webpackJsonp([204390864267482],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _button = _interopRequireDefault(__webpack_require__(125));
	
	var _buttonGroup = _interopRequireDefault(__webpack_require__(124));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_button["default"].Group = _buttonGroup["default"];
	var _default = _button["default"];
	exports["default"] = _default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(50);
	
	var r = (0, _immutable.Record)({
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	}); /**
	     * Copyright (c) Meta Platforms, Inc. and affiliates.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     *
	     * 
	     * @format
	     */
	
	exports.default = r;
	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(227);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @format
	 */
	
	var Yoga = __webpack_require__(309);
	var nbind = __webpack_require__(307);
	
	var ran = false;
	var ret = null;
	
	nbind({}, function (err, result) {
	  if (ran) {
	    return;
	  }
	
	  ran = true;
	
	  if (err) {
	    throw err;
	  }
	
	  ret = result;
	});
	
	if (!ran) {
	  throw new Error("Failed to load the yoga module - it needed to be loaded synchronously, but didn't");
	}
	
	// $FlowFixMe ret will not be null here
	module.exports = Yoga(ret.bind, ret.lib);

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function omit(obj, fields) {
	  var shallowCopy = (0, _extends3["default"])({}, obj);
	  for (var i = 0; i < fields.length; i++) {
	    var key = fields[i];
	    delete shallowCopy[key];
	  }
	  return shallowCopy;
	}
	
	exports["default"] = omit;
	module.exports = exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.toArray = toArray;
	exports.getActiveIndex = getActiveIndex;
	exports.getActiveKey = getActiveKey;
	exports.setTransform = setTransform;
	exports.isTransform3dSupported = isTransform3dSupported;
	exports.setTransition = setTransition;
	exports.getTransformPropValue = getTransformPropValue;
	exports.isVertical = isVertical;
	exports.getTransformByIndex = getTransformByIndex;
	exports.getMarginStyle = getMarginStyle;
	exports.getStyle = getStyle;
	exports.setPxStyle = setPxStyle;
	exports.getDataAttr = getDataAttr;
	exports.getLeft = getLeft;
	exports.getTop = getTop;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArray(children) {
	  // allow [c,[a,b]]
	  var c = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    if (child) {
	      c.push(child);
	    }
	  });
	  return c;
	}
	
	function getActiveIndex(children, activeKey) {
	  var c = toArray(children);
	  for (var i = 0; i < c.length; i++) {
	    if (c[i].key === activeKey) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function getActiveKey(children, index) {
	  var c = toArray(children);
	  return c[index].key;
	}
	
	function setTransform(style, v) {
	  style.transform = v;
	  style.webkitTransform = v;
	  style.mozTransform = v;
	}
	
	function isTransform3dSupported(style) {
	  return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
	}
	
	function setTransition(style, v) {
	  style.transition = v;
	  style.webkitTransition = v;
	  style.MozTransition = v;
	}
	
	function getTransformPropValue(v) {
	  return {
	    transform: v,
	    WebkitTransform: v,
	    MozTransform: v
	  };
	}
	
	function isVertical(tabBarPosition) {
	  return tabBarPosition === 'left' || tabBarPosition === 'right';
	}
	
	function getTransformByIndex(index, tabBarPosition) {
	  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ltr';
	
	  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
	
	  if (!isVertical(tabBarPosition) && direction === 'rtl') {
	    return translate + '(' + index * 100 + '%) translateZ(0)';
	  }
	  return translate + '(' + -index * 100 + '%) translateZ(0)';
	}
	
	function getMarginStyle(index, tabBarPosition) {
	  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
	  return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
	}
	
	function getStyle(el, property) {
	  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
	}
	
	function setPxStyle(el, value, vertical) {
	  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
	  setTransform(el.style, 'translate3d(' + value + ')');
	}
	
	function getDataAttr(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
	      prev[key] = props[key];
	    }
	    return prev;
	  }, {});
	}
	
	function toNum(style, property) {
	  return +style.getPropertyValue(property).replace('px', '');
	}
	
	function getTypeValue(start, current, end, tabNode, wrapperNode) {
	  var total = getStyle(wrapperNode, 'padding-' + start);
	  if (!tabNode || !tabNode.parentNode) {
	    return total;
	  }
	
	  var childNodes = tabNode.parentNode.childNodes;
	
	  Array.prototype.some.call(childNodes, function (node) {
	    var style = window.getComputedStyle(node);
	
	    if (node !== tabNode) {
	      total += toNum(style, 'margin-' + start);
	      total += node[current];
	      total += toNum(style, 'margin-' + end);
	
	      if (style.boxSizing === 'content-box') {
	        total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
	      }
	      return false;
	    }
	
	    // We need count current node margin
	    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
	    total += toNum(style, 'margin-' + start);
	
	    return true;
	  });
	
	  return total;
	}
	
	function getLeft(tabNode, wrapperNode) {
	  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
	}
	
	function getTop(tabNode, wrapperNode) {
	  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Record; /**
	              * Copyright (c) Meta Platforms, Inc. and affiliates.
	              *
	              * This source code is licensed under the MIT license found in the
	              * LICENSE file in the root directory of this source tree.
	              *
	              * 
	              * @format
	              */
	
	var _immutable = __webpack_require__(50);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	var _entryBrowser = __webpack_require__(20);
	
	var _entryBrowser2 = _interopRequireDefault(_entryBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var r = (0, _immutable.Record)((_Record = {
	  width: 'auto',
	  height: 'auto',
	  minWidth: 0,
	  minHeight: 0,
	  maxWidth: 'none',
	  maxHeight: 'none',
	  justifyContent: _entryBrowser2.default.JUSTIFY_FLEX_START,
	  alignItems: _entryBrowser2.default.ALIGN_STRETCH,
	  alignSelf: _entryBrowser2.default.ALIGN_AUTO,
	  alignContent: _entryBrowser2.default.ALIGN_STRETCH,
	  flexDirection: _entryBrowser2.default.FLEX_DIRECTION_ROW,
	  padding: (0, _PositionRecord2.default)(),
	  margin: (0, _PositionRecord2.default)(),
	  border: (0, _PositionRecord2.default)(),
	  position: (0, _PositionRecord2.default)({
	    left: NaN,
	    top: NaN,
	    right: NaN,
	    bottom: NaN
	  }),
	  positionType: _entryBrowser2.default.POSITION_TYPE_RELATIVE,
	  flexWrap: _entryBrowser2.default.WRAP_NO_WRAP,
	  flexBasis: 'auto',
	  flexGrow: 0,
	  flexShrink: 1,
	  children: (0, _immutable.List)(),
	  aspectRatio: 'auto'
	}, _Record['minWidth'] = NaN, _Record['maxWidth'] = NaN, _Record['minHeight'] = NaN, _Record['maxHeight'] = NaN, _Record));
	
	exports.default = r;
	module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noop = noop;
	exports.getKeyFromChildrenIndex = getKeyFromChildrenIndex;
	exports.getMenuIdFromSubMenuEventKey = getMenuIdFromSubMenuEventKey;
	exports.loopMenuItem = loopMenuItem;
	exports.loopMenuItemRecursively = loopMenuItemRecursively;
	exports.isMobileDevice = exports.setStyle = exports.getWidth = exports.menuAllProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _isMobile = _interopRequireDefault(__webpack_require__(260));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function noop() {}
	
	function getKeyFromChildrenIndex(child, menuEventKey, index) {
	  var prefix = menuEventKey || '';
	  return child.key || "".concat(prefix, "item_").concat(index);
	}
	
	function getMenuIdFromSubMenuEventKey(eventKey) {
	  return "".concat(eventKey, "-menu-");
	}
	
	function loopMenuItem(children, cb) {
	  var index = -1;
	  React.Children.forEach(children, function (c) {
	    index += 1;
	
	    if (c && c.type && c.type.isMenuItemGroup) {
	      React.Children.forEach(c.props.children, function (c2) {
	        index += 1;
	        cb(c2, index);
	      });
	    } else {
	      cb(c, index);
	    }
	  });
	}
	
	function loopMenuItemRecursively(children, keys, ret) {
	  /* istanbul ignore if */
	  if (!children || ret.find) {
	    return;
	  }
	
	  React.Children.forEach(children, function (c) {
	    if (c) {
	      var construct = c.type;
	
	      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
	        return;
	      }
	
	      if (keys.indexOf(c.key) !== -1) {
	        ret.find = true;
	      } else if (c.props.children) {
	        loopMenuItemRecursively(c.props.children, keys, ret);
	      }
	    }
	  });
	}
	
	var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator', 'motion', // the following keys found need to be removed from test regression
	'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon']; // ref: https://github.com/ant-design/ant-design/issues/14007
	// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
	// getBoundingClientRect return the full precision value, which is
	// not the same behavior as on chrome. Set the precision to 6 to
	// unify their behavior
	
	exports.menuAllProps = menuAllProps;
	
	var getWidth = function getWidth(elem) {
	  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;
	
	  if (width) {
	    width = +width.toFixed(6);
	  }
	
	  return width || 0;
	};
	
	exports.getWidth = getWidth;
	
	var setStyle = function setStyle(elem, styleProperty, value) {
	  if (elem && _typeof(elem.style) === 'object') {
	    elem.style[styleProperty] = value;
	  }
	};
	
	exports.setStyle = setStyle;
	
	var isMobileDevice = function isMobileDevice() {
	  return _isMobile.default.any;
	};
	
	exports.isMobileDevice = isMobileDevice;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fixControlledValue = fixControlledValue;
	exports.resolveOnChange = resolveOnChange;
	exports.getInputClassName = getInputClassName;
	exports["default"] = exports.InputSizes = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _omit = _interopRequireDefault(__webpack_require__(22));
	
	var _type = __webpack_require__(31);
	
	var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(64));
	
	var _configProvider = __webpack_require__(7);
	
	var _warning = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InputSizes = (0, _type.tuple)('small', 'default', 'large');
	exports.InputSizes = InputSizes;
	
	function fixControlledValue(value) {
	  if (typeof value === 'undefined' || value === null) {
	    return '';
	  }
	
	  return value;
	}
	
	function resolveOnChange(target, e, onChange) {
	  if (onChange) {
	    var event = e;
	
	    if (e.type === 'click') {
	      // click clear icon
	      event = Object.create(e);
	      event.target = target;
	      event.currentTarget = target;
	      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input
	
	      target.value = '';
	      onChange(event); // reset target ref value
	
	      target.value = originalInputValue;
	      return;
	    }
	
	    onChange(event);
	  }
	}
	
	function getInputClassName(prefixCls, size, disabled) {
	  var _classNames;
	
	  return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
	}
	
	var Input = /*#__PURE__*/function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  var _super = _createSuper(Input);
	
	  function Input(props) {
	    var _this;
	
	    _classCallCheck(this, Input);
	
	    _this = _super.call(this, props);
	
	    _this.saveClearableInput = function (input) {
	      _this.clearableInput = input;
	    };
	
	    _this.saveInput = function (input) {
	      _this.input = input;
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.focus();
	      });
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.renderInput = function (prefixCls) {
	      var _this$props = _this.props,
	          className = _this$props.className,
	          addonBefore = _this$props.addonBefore,
	          addonAfter = _this$props.addonAfter,
	          size = _this$props.size,
	          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop
	
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
	      // specify either the value prop, or the defaultValue prop, but not both.
	      'defaultValue', 'size', 'inputType']);
	      return /*#__PURE__*/React.createElement("input", _extends({}, otherProps, {
	        onChange: _this.handleChange,
	        onKeyDown: _this.handleKeyDown,
	        className: (0, _classnames["default"])(getInputClassName(prefixCls, size, disabled), _defineProperty({}, className, className && !addonBefore && !addonAfter)),
	        ref: _this.saveInput
	      }));
	    };
	
	    _this.clearPasswordValueAttribute = function () {
	      // https://github.com/ant-design/ant-design/issues/20541
	      _this.removePasswordTimeout = setTimeout(function () {
	        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
	          _this.input.removeAttribute('value');
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props2 = _this.props,
	          onPressEnter = _this$props2.onPressEnter,
	          onKeyDown = _this$props2.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        inputType: "input",
	        value: fixControlledValue(value),
	        element: _this.renderInput(prefixCls),
	        handleReset: _this.handleReset,
	        ref: _this.saveClearableInput
	      }));
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.clearPasswordValueAttribute();
	    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
	    // We keep an empty function here.
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
	        (0, _warning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
	      }
	
	      return null;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.removePasswordTimeout) {
	        clearTimeout(this.removePasswordTimeout);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Input;
	}(React.Component);
	
	Input.defaultProps = {
	  type: 'text'
	};
	Input.propTypes = {
	  type: PropTypes.string,
	  id: PropTypes.string,
	  size: PropTypes.oneOf(InputSizes),
	  maxLength: PropTypes.number,
	  disabled: PropTypes.bool,
	  value: PropTypes.any,
	  defaultValue: PropTypes.any,
	  className: PropTypes.string,
	  addonBefore: PropTypes.node,
	  addonAfter: PropTypes.node,
	  prefixCls: PropTypes.string,
	  onPressEnter: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onKeyUp: PropTypes.func,
	  onFocus: PropTypes.func,
	  onBlur: PropTypes.func,
	  prefix: PropTypes.node,
	  suffix: PropTypes.node,
	  allowClear: PropTypes.bool
	};
	(0, _reactLifecyclesCompat.polyfill)(Input);
	var _default = Input;
	exports["default"] = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(49)
	var Schema = __webpack_require__(77)
	var DefinedInfo = __webpack_require__(75)
	
	module.exports = create
	
	function create(definition) {
	  var space = definition.space
	  var mustUseProperty = definition.mustUseProperty || []
	  var attributes = definition.attributes || {}
	  var props = definition.properties
	  var transform = definition.transform
	  var property = {}
	  var normal = {}
	  var prop
	  var info
	
	  for (prop in props) {
	    info = new DefinedInfo(
	      prop,
	      transform(attributes, prop),
	      props[prop],
	      space
	    )
	
	    if (mustUseProperty.indexOf(prop) !== -1) {
	      info.mustUseProperty = true
	    }
	
	    property[prop] = info
	
	    normal[normalize(prop)] = prop
	    normal[normalize(info.attribute)] = prop
	  }
	
	  return new Schema(property, normal, space)
	}


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * @ignore
	 * some key-codes definition and utils from closure-library
	 * @author yiminghe@gmail.com
	 */
	var KeyCode = {
	  /**
	   * MAC_ENTER
	   */
	  MAC_ENTER: 3,
	
	  /**
	   * BACKSPACE
	   */
	  BACKSPACE: 8,
	
	  /**
	   * TAB
	   */
	  TAB: 9,
	
	  /**
	   * NUMLOCK on FF/Safari Mac
	   */
	  NUM_CENTER: 12,
	
	  /**
	   * ENTER
	   */
	  ENTER: 13,
	
	  /**
	   * SHIFT
	   */
	  SHIFT: 16,
	
	  /**
	   * CTRL
	   */
	  CTRL: 17,
	
	  /**
	   * ALT
	   */
	  ALT: 18,
	
	  /**
	   * PAUSE
	   */
	  PAUSE: 19,
	
	  /**
	   * CAPS_LOCK
	   */
	  CAPS_LOCK: 20,
	
	  /**
	   * ESC
	   */
	  ESC: 27,
	
	  /**
	   * SPACE
	   */
	  SPACE: 32,
	
	  /**
	   * PAGE_UP
	   */
	  PAGE_UP: 33,
	
	  /**
	   * PAGE_DOWN
	   */
	  PAGE_DOWN: 34,
	
	  /**
	   * END
	   */
	  END: 35,
	
	  /**
	   * HOME
	   */
	  HOME: 36,
	
	  /**
	   * LEFT
	   */
	  LEFT: 37,
	
	  /**
	   * UP
	   */
	  UP: 38,
	
	  /**
	   * RIGHT
	   */
	  RIGHT: 39,
	
	  /**
	   * DOWN
	   */
	  DOWN: 40,
	
	  /**
	   * PRINT_SCREEN
	   */
	  PRINT_SCREEN: 44,
	
	  /**
	   * INSERT
	   */
	  INSERT: 45,
	
	  /**
	   * DELETE
	   */
	  DELETE: 46,
	
	  /**
	   * ZERO
	   */
	  ZERO: 48,
	
	  /**
	   * ONE
	   */
	  ONE: 49,
	
	  /**
	   * TWO
	   */
	  TWO: 50,
	
	  /**
	   * THREE
	   */
	  THREE: 51,
	
	  /**
	   * FOUR
	   */
	  FOUR: 52,
	
	  /**
	   * FIVE
	   */
	  FIVE: 53,
	
	  /**
	   * SIX
	   */
	  SIX: 54,
	
	  /**
	   * SEVEN
	   */
	  SEVEN: 55,
	
	  /**
	   * EIGHT
	   */
	  EIGHT: 56,
	
	  /**
	   * NINE
	   */
	  NINE: 57,
	
	  /**
	   * QUESTION_MARK
	   */
	  QUESTION_MARK: 63,
	
	  /**
	   * A
	   */
	  A: 65,
	
	  /**
	   * B
	   */
	  B: 66,
	
	  /**
	   * C
	   */
	  C: 67,
	
	  /**
	   * D
	   */
	  D: 68,
	
	  /**
	   * E
	   */
	  E: 69,
	
	  /**
	   * F
	   */
	  F: 70,
	
	  /**
	   * G
	   */
	  G: 71,
	
	  /**
	   * H
	   */
	  H: 72,
	
	  /**
	   * I
	   */
	  I: 73,
	
	  /**
	   * J
	   */
	  J: 74,
	
	  /**
	   * K
	   */
	  K: 75,
	
	  /**
	   * L
	   */
	  L: 76,
	
	  /**
	   * M
	   */
	  M: 77,
	
	  /**
	   * N
	   */
	  N: 78,
	
	  /**
	   * O
	   */
	  O: 79,
	
	  /**
	   * P
	   */
	  P: 80,
	
	  /**
	   * Q
	   */
	  Q: 81,
	
	  /**
	   * R
	   */
	  R: 82,
	
	  /**
	   * S
	   */
	  S: 83,
	
	  /**
	   * T
	   */
	  T: 84,
	
	  /**
	   * U
	   */
	  U: 85,
	
	  /**
	   * V
	   */
	  V: 86,
	
	  /**
	   * W
	   */
	  W: 87,
	
	  /**
	   * X
	   */
	  X: 88,
	
	  /**
	   * Y
	   */
	  Y: 89,
	
	  /**
	   * Z
	   */
	  Z: 90,
	
	  /**
	   * META
	   */
	  META: 91,
	
	  /**
	   * WIN_KEY_RIGHT
	   */
	  WIN_KEY_RIGHT: 92,
	
	  /**
	   * CONTEXT_MENU
	   */
	  CONTEXT_MENU: 93,
	
	  /**
	   * NUM_ZERO
	   */
	  NUM_ZERO: 96,
	
	  /**
	   * NUM_ONE
	   */
	  NUM_ONE: 97,
	
	  /**
	   * NUM_TWO
	   */
	  NUM_TWO: 98,
	
	  /**
	   * NUM_THREE
	   */
	  NUM_THREE: 99,
	
	  /**
	   * NUM_FOUR
	   */
	  NUM_FOUR: 100,
	
	  /**
	   * NUM_FIVE
	   */
	  NUM_FIVE: 101,
	
	  /**
	   * NUM_SIX
	   */
	  NUM_SIX: 102,
	
	  /**
	   * NUM_SEVEN
	   */
	  NUM_SEVEN: 103,
	
	  /**
	   * NUM_EIGHT
	   */
	  NUM_EIGHT: 104,
	
	  /**
	   * NUM_NINE
	   */
	  NUM_NINE: 105,
	
	  /**
	   * NUM_MULTIPLY
	   */
	  NUM_MULTIPLY: 106,
	
	  /**
	   * NUM_PLUS
	   */
	  NUM_PLUS: 107,
	
	  /**
	   * NUM_MINUS
	   */
	  NUM_MINUS: 109,
	
	  /**
	   * NUM_PERIOD
	   */
	  NUM_PERIOD: 110,
	
	  /**
	   * NUM_DIVISION
	   */
	  NUM_DIVISION: 111,
	
	  /**
	   * F1
	   */
	  F1: 112,
	
	  /**
	   * F2
	   */
	  F2: 113,
	
	  /**
	   * F3
	   */
	  F3: 114,
	
	  /**
	   * F4
	   */
	  F4: 115,
	
	  /**
	   * F5
	   */
	  F5: 116,
	
	  /**
	   * F6
	   */
	  F6: 117,
	
	  /**
	   * F7
	   */
	  F7: 118,
	
	  /**
	   * F8
	   */
	  F8: 119,
	
	  /**
	   * F9
	   */
	  F9: 120,
	
	  /**
	   * F10
	   */
	  F10: 121,
	
	  /**
	   * F11
	   */
	  F11: 122,
	
	  /**
	   * F12
	   */
	  F12: 123,
	
	  /**
	   * NUMLOCK
	   */
	  NUMLOCK: 144,
	
	  /**
	   * SEMICOLON
	   */
	  SEMICOLON: 186,
	
	  /**
	   * DASH
	   */
	  DASH: 189,
	
	  /**
	   * EQUALS
	   */
	  EQUALS: 187,
	
	  /**
	   * COMMA
	   */
	  COMMA: 188,
	
	  /**
	   * PERIOD
	   */
	  PERIOD: 190,
	
	  /**
	   * SLASH
	   */
	  SLASH: 191,
	
	  /**
	   * APOSTROPHE
	   */
	  APOSTROPHE: 192,
	
	  /**
	   * SINGLE_QUOTE
	   */
	  SINGLE_QUOTE: 222,
	
	  /**
	   * OPEN_SQUARE_BRACKET
	   */
	  OPEN_SQUARE_BRACKET: 219,
	
	  /**
	   * BACKSLASH
	   */
	  BACKSLASH: 220,
	
	  /**
	   * CLOSE_SQUARE_BRACKET
	   */
	  CLOSE_SQUARE_BRACKET: 221,
	
	  /**
	   * WIN_KEY
	   */
	  WIN_KEY: 224,
	
	  /**
	   * MAC_FF_META
	   */
	  MAC_FF_META: 224,
	
	  /**
	   * WIN_IME
	   */
	  WIN_IME: 229,
	  // ======================== Function ========================
	
	  /**
	   * whether text and modified key is entered at the same time.
	   */
	  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
	    var keyCode = e.keyCode;
	
	    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
	    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
	      return false;
	    } // The following keys are quite harmless, even in combination with
	    // CTRL, ALT or SHIFT.
	
	
	    switch (keyCode) {
	      case KeyCode.ALT:
	      case KeyCode.CAPS_LOCK:
	      case KeyCode.CONTEXT_MENU:
	      case KeyCode.CTRL:
	      case KeyCode.DOWN:
	      case KeyCode.END:
	      case KeyCode.ESC:
	      case KeyCode.HOME:
	      case KeyCode.INSERT:
	      case KeyCode.LEFT:
	      case KeyCode.MAC_FF_META:
	      case KeyCode.META:
	      case KeyCode.NUMLOCK:
	      case KeyCode.NUM_CENTER:
	      case KeyCode.PAGE_DOWN:
	      case KeyCode.PAGE_UP:
	      case KeyCode.PAUSE:
	      case KeyCode.PRINT_SCREEN:
	      case KeyCode.RIGHT:
	      case KeyCode.SHIFT:
	      case KeyCode.UP:
	      case KeyCode.WIN_KEY:
	      case KeyCode.WIN_KEY_RIGHT:
	        return false;
	
	      default:
	        return true;
	    }
	  },
	
	  /**
	   * whether character is entered.
	   */
	  isCharacterKey: function isCharacterKey(keyCode) {
	    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
	      return true;
	    }
	
	    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
	      return true;
	    }
	
	    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
	      return true;
	    } // Safari sends zero key code for non-latin characters.
	
	
	    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
	      return true;
	    }
	
	    switch (keyCode) {
	      case KeyCode.SPACE:
	      case KeyCode.QUESTION_MARK:
	      case KeyCode.NUM_PLUS:
	      case KeyCode.NUM_MINUS:
	      case KeyCode.NUM_PERIOD:
	      case KeyCode.NUM_DIVISION:
	      case KeyCode.SEMICOLON:
	      case KeyCode.DASH:
	      case KeyCode.EQUALS:
	      case KeyCode.COMMA:
	      case KeyCode.PERIOD:
	      case KeyCode.SLASH:
	      case KeyCode.APOSTROPHE:
	      case KeyCode.SINGLE_QUOTE:
	      case KeyCode.OPEN_SQUARE_BRACKET:
	      case KeyCode.BACKSLASH:
	      case KeyCode.CLOSE_SQUARE_BRACKET:
	        return true;
	
	      default:
	        return false;
	    }
	  }
	};
	var _default = KeyCode;
	exports.default = _default;

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.connect = exports.Provider = undefined;
	
	var _Provider2 = __webpack_require__(223);
	
	var _Provider3 = _interopRequireDefault(_Provider2);
	
	var _connect2 = __webpack_require__(224);
	
	var _connect3 = _interopRequireDefault(_connect2);
	
	var _create2 = __webpack_require__(225);
	
	var _create3 = _interopRequireDefault(_create2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider3.default;
	exports.connect = _connect3.default;
	exports.create = _create3.default;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapperRaf;
	
	var _raf = _interopRequireDefault(__webpack_require__(51));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var id = 0;
	var ids = {}; // Support call raf with delay specified frame
	
	function wrapperRaf(callback) {
	  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var myId = id++;
	  var restFrames = delayFrames;
	
	  function internalCallback() {
	    restFrames -= 1;
	
	    if (restFrames <= 0) {
	      callback();
	      delete ids[myId];
	    } else {
	      ids[myId] = (0, _raf["default"])(internalCallback);
	    }
	  }
	
	  ids[myId] = (0, _raf["default"])(internalCallback);
	  return myId;
	}
	
	wrapperRaf.cancel = function cancel(pid) {
	  if (pid === undefined) return;
	
	  _raf["default"].cancel(ids[pid]);
	
	  delete ids[pid];
	};
	
	wrapperRaf.ids = ids; // export this for test usage

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Input = _interopRequireDefault(__webpack_require__(26));
	
	var _Group = _interopRequireDefault(__webpack_require__(127));
	
	var _Search = _interopRequireDefault(__webpack_require__(130));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(131));
	
	var _Password = _interopRequireDefault(__webpack_require__(128));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Input["default"].Group = _Group["default"];
	_Input["default"].Search = _Search["default"];
	_Input["default"].TextArea = _TextArea["default"];
	_Input["default"].Password = _Password["default"];
	var _default = _Input["default"];
	exports["default"] = _default;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(229);
	
	__webpack_require__(17);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(29));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var MenuContext = (0, _createReactContext["default"])({
	  inlineCollapsed: false
	});
	var _default = MenuContext;
	exports["default"] = _default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(247));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(34));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Radio = /*#__PURE__*/function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  var _super = _createSuper(Radio);
	
	  function Radio() {
	    var _this;
	
	    _classCallCheck(this, Radio);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.onChange = function (e) {
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	
	      if (_this.context.radioGroup && _this.context.radioGroup.onChange) {
	        _this.context.radioGroup.onChange(e);
	      }
	    };
	
	    _this.renderRadio = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          style = props.style,
	          restProps = __rest(props, ["prefixCls", "className", "children", "style"]);
	
	      var radioGroup = context.radioGroup;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	
	      var radioProps = _extends({}, restProps);
	
	      if (radioGroup) {
	        radioProps.name = radioGroup.name;
	        radioProps.onChange = _this.onChange;
	        radioProps.checked = props.value === radioGroup.value;
	        radioProps.disabled = props.disabled || radioGroup.disabled;
	      }
	
	      var wrapperClassString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _classNames));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: wrapperClassString,
	          style: style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, radioProps, {
	          prefixCls: prefixCls,
	          ref: _this.saveCheckbox
	        })), children !== undefined ? /*#__PURE__*/React.createElement("span", null, children) : null)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Radio, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.radioGroup, nextContext.radioGroup);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadio);
	    }
	  }]);
	
	  return Radio;
	}(React.Component);
	
	exports["default"] = Radio;
	Radio.defaultProps = {
	  type: 'radio'
	};
	Radio.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _rcTooltip = _interopRequireDefault(__webpack_require__(275));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _placements = _interopRequireDefault(__webpack_require__(149));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var splitObject = function splitObject(obj, keys) {
	  var picked = {};
	
	  var omitted = _extends({}, obj);
	
	  keys.forEach(function (key) {
	    if (obj && key in obj) {
	      picked[key] = obj[key];
	      delete omitted[key];
	    }
	  });
	  return {
	    picked: picked,
	    omitted: omitted
	  };
	}; // Fix Tooltip won't hide at disabled button
	// mouse events don't trigger at disabled button in Chrome
	// https://github.com/react-component/tooltip/issues/18
	
	
	function getDisabledCompatibleChildren(element) {
	  var elementType = element.type;
	
	  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === 'button') && element.props.disabled) {
	    // Pick some layout related style properties up to span
	    // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
	    var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
	        picked = _splitObject.picked,
	        omitted = _splitObject.omitted;
	
	    var spanStyle = _extends(_extends({
	      display: 'inline-block'
	    }, picked), {
	      cursor: 'not-allowed',
	      width: element.props.block ? '100%' : null
	    });
	
	    var buttonStyle = _extends(_extends({}, omitted), {
	      pointerEvents: 'none'
	    });
	
	    var child = /*#__PURE__*/React.cloneElement(element, {
	      style: buttonStyle,
	      className: null
	    });
	    return /*#__PURE__*/React.createElement("span", {
	      style: spanStyle,
	      className: element.props.className
	    }, child);
	  }
	
	  return element;
	}
	
	var Tooltip = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tooltip, _React$Component);
	
	  var _super = _createSuper(Tooltip);
	
	  function Tooltip(props) {
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    _this = _super.call(this, props);
	
	    _this.onVisibleChange = function (visible) {
	      var onVisibleChange = _this.props.onVisibleChange;
	
	      if (!('visible' in _this.props)) {
	        _this.setState({
	          visible: _this.isNoTitle() ? false : visible
	        });
	      }
	
	      if (onVisibleChange && !_this.isNoTitle()) {
	        onVisibleChange(visible);
	      }
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    }; // 动态设置动画点
	
	
	    _this.onPopupAlign = function (domNode, align) {
	      var placements = _this.getPlacements(); // 当前返回的位置
	
	
	      var placement = Object.keys(placements).filter(function (key) {
	        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
	      })[0];
	
	      if (!placement) {
	        return;
	      } // 根据当前坐标设置动画点
	
	
	      var rect = domNode.getBoundingClientRect();
	      var transformOrigin = {
	        top: '50%',
	        left: '50%'
	      };
	
	      if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
	        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
	      } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
	        transformOrigin.top = "".concat(-align.offset[1], "px");
	      }
	
	      if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
	        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
	      } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
	        transformOrigin.left = "".concat(-align.offset[0], "px");
	      }
	
	      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
	    };
	
	    _this.renderTooltip = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          openClassName = props.openClassName,
	          getPopupContainer = props.getPopupContainer,
	          getTooltipContainer = props.getTooltipContainer;
	      var children = props.children;
	      var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
	      var visible = state.visible; // Hide tooltip when there is no title
	
	      if (!('visible' in props) && _this.isNoTitle()) {
	        visible = false;
	      }
	
	      var child = getDisabledCompatibleChildren( /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement("span", null, children));
	      var childProps = child.props;
	      var childCls = (0, _classnames["default"])(childProps.className, _defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true));
	      return /*#__PURE__*/React.createElement(_rcTooltip["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
	        ref: _this.saveTooltip,
	        builtinPlacements: _this.getPlacements(),
	        overlay: _this.getOverlay(),
	        visible: visible,
	        onVisibleChange: _this.onVisibleChange,
	        onPopupAlign: _this.onPopupAlign
	      }), visible ? /*#__PURE__*/React.cloneElement(child, {
	        className: childCls
	      }) : child);
	    };
	
	    _this.state = {
	      visible: !!props.visible || !!props.defaultVisible
	    };
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getPlacements",
	    value: function getPlacements() {
	      var _this$props = this.props,
	          builtinPlacements = _this$props.builtinPlacements,
	          arrowPointAtCenter = _this$props.arrowPointAtCenter,
	          autoAdjustOverflow = _this$props.autoAdjustOverflow;
	      return builtinPlacements || (0, _placements["default"])({
	        arrowPointAtCenter: arrowPointAtCenter,
	        verticalArrowShift: 8,
	        autoAdjustOverflow: autoAdjustOverflow
	      });
	    }
	  }, {
	    key: "isNoTitle",
	    value: function isNoTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          overlay = _this$props2.overlay;
	      return !title && !overlay && title !== 0; // overlay for old version compatibility
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          overlay = _this$props3.overlay;
	
	      if (title === 0) {
	        return title;
	      }
	
	      return overlay || title || '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTooltip);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tooltip;
	}(React.Component);
	
	Tooltip.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big-fast',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  arrowPointAtCenter: false,
	  autoAdjustOverflow: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Tooltip);
	var _default = Tooltip;
	exports["default"] = _default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.JSEnumLookup = undefined;
	exports.default = generateCode;
	
	var _entryBrowser = __webpack_require__(20);
	
	var _entryBrowser2 = _interopRequireDefault(_entryBrowser);
	
	var _LayoutRecord = __webpack_require__(24);
	
	var _LayoutRecord2 = _interopRequireDefault(_LayoutRecord);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JSEnumLookup = exports.JSEnumLookup = {
	  justifyContent: 'JUSTIFY_',
	  alignItems: 'ALIGN_',
	  alignContent: 'ALIGN_',
	  alignSelf: 'ALIGN_',
	  position: 'POSITION_',
	  flexDirection: 'DIRECTION_',
	  flexWrap: 'WRAP_',
	  positionType: 'POSITION_TYPE_',
	  direction: 'DIRECTION_'
	}; /**
	    * Copyright (c) Meta Platforms, Inc. and affiliates.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    * @format
	    */
	
	function getEnum(yogaEnum, value) {
	  return 'yoga.' + (Object.keys(_entryBrowser2.default).filter(function (key) {
	    return key.toLowerCase().startsWith(yogaEnum.toLowerCase());
	  }).find(function (key) {
	    return _entryBrowser2.default[key] === value;
	  }) || value);
	}
	
	function setProperty(name, key, value, enumValue) {
	  return [name, '.set', key[0].toUpperCase() + key.substr(1), '(', enumValue ? enumValue + ', ' : '', JSEnumLookup[key] ? getEnum(JSEnumLookup[key], value) : value, ');'].join('');
	}
	
	function getLayoutCode(node, name, index) {
	  var lines = [];
	  var childName = function childName(i) {
	    return (name === 'root' ? 'node' : name) + '_' + i;
	  };
	
	  lines.push.apply(lines, node.children.map(function (node, i) {
	    return getLayoutCode(node, childName(i), i);
	  }));
	
	  lines.push('', '// create node ' + name, 'const ' + name + ' = Node.create();');
	  var untouchedNode = (0, _LayoutRecord2.default)({ width: '', height: '' });
	  Object.keys(untouchedNode.toJS()).forEach(function (key) {
	    if (key !== 'children' && untouchedNode[key] !== node[key]) {
	      if (node[key] instanceof _PositionRecord2.default) {
	        // iterate through position record
	        var _node$key$toJS = node[key].toJS(),
	            top = _node$key$toJS.top,
	            left = _node$key$toJS.left,
	            right = _node$key$toJS.right,
	            bottom = _node$key$toJS.bottom;
	
	        if (top !== untouchedNode[key].top && top === left && top === right && top === bottom) {
	          // all edges
	          lines.push(setProperty(name, key, node[key].top, getEnum('edge', 8)));
	          return;
	        }
	        var alreadySet = [];
	        if (top !== untouchedNode[key].top && top === bottom) {
	          lines.push(setProperty(name, key, node[key].top, getEnum('edge', 7)));
	          alreadySet.push('top', 'bottom');
	        }
	        if (left !== untouchedNode[key].left && left === right) {
	          lines.push(setProperty(name, key, node[key].left, getEnum('edge', 6)));
	          alreadySet.push('left', 'right');
	        }
	        ['left', 'top', 'right', 'bottom'].forEach(function (pKey, i) {
	          if (node[key][pKey] !== untouchedNode[key][pKey] && alreadySet.indexOf(pKey) === -1) {
	            lines.push(setProperty(name, key, node[key][pKey], getEnum('edge', i)));
	          }
	        });
	      } else {
	        lines.push(setProperty(name, key, node[key]));
	      }
	    }
	  });
	
	  if (node.children && node.children.size > 0) {
	    lines.push.apply(lines, ['', '// insert children'].concat(node.children.map(function (_, i) {
	      return name + '.insertChild(' + childName(i) + ', ' + i + ');';
	    })));
	  }
	
	  return lines.join('\n');
	}
	
	function generateCode(root, direction) {
	  var rootNodeName = 'root';
	  return ['import yoga, {Node} from \'yoga-layout\';', getLayoutCode(root, rootNodeName, 0), '', rootNodeName + '.calculateLayout(' + root.width + ', ' + root.height + ', ' + getEnum('direction', direction) + ');', rootNodeName + '.getComputedLayout();'].join('\n');
	}

/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports) {

	'use strict'
	
	var powers = 0
	
	exports.boolean = increment()
	exports.booleanish = increment()
	exports.overloadedBoolean = increment()
	exports.number = increment()
	exports.spaceSeparated = increment()
	exports.commaSeparated = increment()
	exports.commaOrSpaceSeparated = increment()
	
	function increment() {
	  return Math.pow(2, ++powers)
	}


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = normalize
	
	function normalize(value) {
	  return value.toLowerCase()
	}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * MIT License
	 * 
	 * Copyright (c) 2014-present, Lee Byron and other contributors.
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Immutable = {}));
	}(this, (function (exports) { 'use strict';
	
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  function MakeRef() {
	    return { value: false };
	  }
	
	  function SetRef(ref) {
	    if (ref) {
	      ref.value = true;
	    }
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (
	      ((begin === 0 && !isNeg(begin)) ||
	        (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size))
	    );
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    // Sanitize indices using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    return index === undefined
	      ? defaultIndex
	      : isNeg(index)
	      ? size === Infinity
	        ? size
	        : Math.max(0, size + index) | 0
	      : size === undefined || size === index
	      ? index
	      : Math.min(size, index) | 0;
	  }
	
	  function isNeg(value) {
	    // Account for -0 which is negative, but not less than 0.
	    return value < 0 || (value === 0 && 1 / value === -Infinity);
	  }
	
	  var IS_COLLECTION_SYMBOL = '@@__IMMUTABLE_ITERABLE__@@';
	
	  function isCollection(maybeCollection) {
	    return Boolean(maybeCollection && maybeCollection[IS_COLLECTION_SYMBOL]);
	  }
	
	  var IS_KEYED_SYMBOL = '@@__IMMUTABLE_KEYED__@@';
	
	  function isKeyed(maybeKeyed) {
	    return Boolean(maybeKeyed && maybeKeyed[IS_KEYED_SYMBOL]);
	  }
	
	  var IS_INDEXED_SYMBOL = '@@__IMMUTABLE_INDEXED__@@';
	
	  function isIndexed(maybeIndexed) {
	    return Boolean(maybeIndexed && maybeIndexed[IS_INDEXED_SYMBOL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  var Collection = function Collection(value) {
	    return isCollection(value) ? value : Seq(value);
	  };
	
	  var KeyedCollection = /*@__PURE__*/(function (Collection) {
	    function KeyedCollection(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	    if ( Collection ) KeyedCollection.__proto__ = Collection;
	    KeyedCollection.prototype = Object.create( Collection && Collection.prototype );
	    KeyedCollection.prototype.constructor = KeyedCollection;
	
	    return KeyedCollection;
	  }(Collection));
	
	  var IndexedCollection = /*@__PURE__*/(function (Collection) {
	    function IndexedCollection(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	    if ( Collection ) IndexedCollection.__proto__ = Collection;
	    IndexedCollection.prototype = Object.create( Collection && Collection.prototype );
	    IndexedCollection.prototype.constructor = IndexedCollection;
	
	    return IndexedCollection;
	  }(Collection));
	
	  var SetCollection = /*@__PURE__*/(function (Collection) {
	    function SetCollection(value) {
	      return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	    if ( Collection ) SetCollection.__proto__ = Collection;
	    SetCollection.prototype = Object.create( Collection && Collection.prototype );
	    SetCollection.prototype.constructor = SetCollection;
	
	    return SetCollection;
	  }(Collection));
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var IS_SEQ_SYMBOL = '@@__IMMUTABLE_SEQ__@@';
	
	  function isSeq(maybeSeq) {
	    return Boolean(maybeSeq && maybeSeq[IS_SEQ_SYMBOL]);
	  }
	
	  var IS_RECORD_SYMBOL = '@@__IMMUTABLE_RECORD__@@';
	
	  function isRecord(maybeRecord) {
	    return Boolean(maybeRecord && maybeRecord[IS_RECORD_SYMBOL]);
	  }
	
	  function isImmutable(maybeImmutable) {
	    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
	  }
	
	  var IS_ORDERED_SYMBOL = '@@__IMMUTABLE_ORDERED__@@';
	
	  function isOrdered(maybeOrdered) {
	    return Boolean(maybeOrdered && maybeOrdered[IS_ORDERED_SYMBOL]);
	  }
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	  var Iterator = function Iterator(next) {
	    this.next = next;
	  };
	
	  Iterator.prototype.toString = function toString () {
	    return '[Iterator]';
	  };
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
	    return this.toString();
	  };
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult
	      ? (iteratorResult.value = value)
	      : (iteratorResult = {
	          value: value,
	          done: false,
	        });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    if (Array.isArray(maybeIterable)) {
	      // IE11 trick as it does not support `Symbol.iterator`
	      return true;
	    }
	
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn =
	      iterable &&
	      ((REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	        iterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isEntriesIterable(maybeIterable) {
	    var iteratorFn = getIteratorFn(maybeIterable);
	    return iteratorFn && iteratorFn === maybeIterable.entries;
	  }
	
	  function isKeysIterable(maybeIterable) {
	    var iteratorFn = getIteratorFn(maybeIterable);
	    return iteratorFn && iteratorFn === maybeIterable.keys;
	  }
	
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  function isArrayLike(value) {
	    if (Array.isArray(value) || typeof value === 'string') {
	      return true;
	    }
	
	    return (
	      value &&
	      typeof value === 'object' &&
	      Number.isInteger(value.length) &&
	      value.length >= 0 &&
	      (value.length === 0
	        ? // Only {length: 0} is considered Array-like.
	          Object.keys(value).length === 1
	        : // An object is only Array-like if it has a property where the last value
	          // in the array-like may be found (which could be undefined).
	          value.hasOwnProperty(value.length - 1))
	    );
	  }
	
	  var Seq = /*@__PURE__*/(function (Collection) {
	    function Seq(value) {
	      return value === undefined || value === null
	        ? emptySequence()
	        : isImmutable(value)
	        ? value.toSeq()
	        : seqFromValue(value);
	    }
	
	    if ( Collection ) Seq.__proto__ = Collection;
	    Seq.prototype = Object.create( Collection && Collection.prototype );
	    Seq.prototype.constructor = Seq;
	
	    Seq.prototype.toSeq = function toSeq () {
	      return this;
	    };
	
	    Seq.prototype.toString = function toString () {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function cacheResult () {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function __iterate (fn, reverse) {
	      var cache = this._cache;
	      if (cache) {
	        var size = cache.length;
	        var i = 0;
	        while (i !== size) {
	          var entry = cache[reverse ? size - ++i : i++];
	          if (fn(entry[1], entry[0], this) === false) {
	            break;
	          }
	        }
	        return i;
	      }
	      return this.__iterateUncached(fn, reverse);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function __iterator (type, reverse) {
	      var cache = this._cache;
	      if (cache) {
	        var size = cache.length;
	        var i = 0;
	        return new Iterator(function () {
	          if (i === size) {
	            return iteratorDone();
	          }
	          var entry = cache[reverse ? size - ++i : i++];
	          return iteratorValue(type, entry[0], entry[1]);
	        });
	      }
	      return this.__iteratorUncached(type, reverse);
	    };
	
	    return Seq;
	  }(Collection));
	
	  var KeyedSeq = /*@__PURE__*/(function (Seq) {
	    function KeyedSeq(value) {
	      return value === undefined || value === null
	        ? emptySequence().toKeyedSeq()
	        : isCollection(value)
	        ? isKeyed(value)
	          ? value.toSeq()
	          : value.fromEntrySeq()
	        : isRecord(value)
	        ? value.toSeq()
	        : keyedSeqFromValue(value);
	    }
	
	    if ( Seq ) KeyedSeq.__proto__ = Seq;
	    KeyedSeq.prototype = Object.create( Seq && Seq.prototype );
	    KeyedSeq.prototype.constructor = KeyedSeq;
	
	    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq () {
	      return this;
	    };
	
	    return KeyedSeq;
	  }(Seq));
	
	  var IndexedSeq = /*@__PURE__*/(function (Seq) {
	    function IndexedSeq(value) {
	      return value === undefined || value === null
	        ? emptySequence()
	        : isCollection(value)
	        ? isKeyed(value)
	          ? value.entrySeq()
	          : value.toIndexedSeq()
	        : isRecord(value)
	        ? value.toSeq().entrySeq()
	        : indexedSeqFromValue(value);
	    }
	
	    if ( Seq ) IndexedSeq.__proto__ = Seq;
	    IndexedSeq.prototype = Object.create( Seq && Seq.prototype );
	    IndexedSeq.prototype.constructor = IndexedSeq;
	
	    IndexedSeq.of = function of (/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq () {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function toString () {
	      return this.__toString('Seq [', ']');
	    };
	
	    return IndexedSeq;
	  }(Seq));
	
	  var SetSeq = /*@__PURE__*/(function (Seq) {
	    function SetSeq(value) {
	      return (
	        isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)
	      ).toSetSeq();
	    }
	
	    if ( Seq ) SetSeq.__proto__ = Seq;
	    SetSeq.prototype = Object.create( Seq && Seq.prototype );
	    SetSeq.prototype.constructor = SetSeq;
	
	    SetSeq.of = function of (/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function toSetSeq () {
	      return this;
	    };
	
	    return SetSeq;
	  }(Seq));
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  Seq.prototype[IS_SEQ_SYMBOL] = true;
	
	  // #pragma Root Sequences
	
	  var ArraySeq = /*@__PURE__*/(function (IndexedSeq) {
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    if ( IndexedSeq ) ArraySeq.__proto__ = IndexedSeq;
	    ArraySeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
	    ArraySeq.prototype.constructor = ArraySeq;
	
	    ArraySeq.prototype.get = function get (index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function __iterate (fn, reverse) {
	      var array = this._array;
	      var size = array.length;
	      var i = 0;
	      while (i !== size) {
	        var ii = reverse ? size - ++i : i++;
	        if (fn(array[ii], ii, this) === false) {
	          break;
	        }
	      }
	      return i;
	    };
	
	    ArraySeq.prototype.__iterator = function __iterator (type, reverse) {
	      var array = this._array;
	      var size = array.length;
	      var i = 0;
	      return new Iterator(function () {
	        if (i === size) {
	          return iteratorDone();
	        }
	        var ii = reverse ? size - ++i : i++;
	        return iteratorValue(type, ii, array[ii]);
	      });
	    };
	
	    return ArraySeq;
	  }(IndexedSeq));
	
	  var ObjectSeq = /*@__PURE__*/(function (KeyedSeq) {
	    function ObjectSeq(object) {
	      var keys = Object.keys(object).concat(
	        Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []
	      );
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    if ( KeyedSeq ) ObjectSeq.__proto__ = KeyedSeq;
	    ObjectSeq.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
	    ObjectSeq.prototype.constructor = ObjectSeq;
	
	    ObjectSeq.prototype.get = function get (key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function has (key) {
	      return hasOwnProperty.call(this._object, key);
	    };
	
	    ObjectSeq.prototype.__iterate = function __iterate (fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var size = keys.length;
	      var i = 0;
	      while (i !== size) {
	        var key = keys[reverse ? size - ++i : i++];
	        if (fn(object[key], key, this) === false) {
	          break;
	        }
	      }
	      return i;
	    };
	
	    ObjectSeq.prototype.__iterator = function __iterator (type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var size = keys.length;
	      var i = 0;
	      return new Iterator(function () {
	        if (i === size) {
	          return iteratorDone();
	        }
	        var key = keys[reverse ? size - ++i : i++];
	        return iteratorValue(type, key, object[key]);
	      });
	    };
	
	    return ObjectSeq;
	  }(KeyedSeq));
	  ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;
	
	  var CollectionSeq = /*@__PURE__*/(function (IndexedSeq) {
	    function CollectionSeq(collection) {
	      this._collection = collection;
	      this.size = collection.length || collection.size;
	    }
	
	    if ( IndexedSeq ) CollectionSeq.__proto__ = IndexedSeq;
	    CollectionSeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
	    CollectionSeq.prototype.constructor = CollectionSeq;
	
	    CollectionSeq.prototype.__iterateUncached = function __iterateUncached (fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var collection = this._collection;
	      var iterator = getIterator(collection);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached (type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var collection = this._collection;
	      var iterator = getIterator(collection);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function () {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	    return CollectionSeq;
	  }(IndexedSeq));
	
	  // # pragma Helper functions
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (seq) {
	      return seq.fromEntrySeq();
	    }
	    if (typeof value === 'object') {
	      return new ObjectSeq(value);
	    }
	    throw new TypeError(
	      'Expected Array or collection object of [k, v] entries, or keyed object: ' +
	        value
	    );
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (seq) {
	      return seq;
	    }
	    throw new TypeError(
	      'Expected Array or collection object of values: ' + value
	    );
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (seq) {
	      return isEntriesIterable(value)
	        ? seq.fromEntrySeq()
	        : isKeysIterable(value)
	        ? seq.toSetSeq()
	        : seq;
	    }
	    if (typeof value === 'object') {
	      return new ObjectSeq(value);
	    }
	    throw new TypeError(
	      'Expected Array or collection object of values, or keyed object: ' + value
	    );
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return isArrayLike(value)
	      ? new ArraySeq(value)
	      : hasIterator(value)
	      ? new CollectionSeq(value)
	      : undefined;
	  }
	
	  var IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@';
	
	  function isMap(maybeMap) {
	    return Boolean(maybeMap && maybeMap[IS_MAP_SYMBOL]);
	  }
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  function isValueObject(maybeValue) {
	    return Boolean(
	      maybeValue &&
	        typeof maybeValue.equals === 'function' &&
	        typeof maybeValue.hashCode === 'function'
	    );
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections are Value Objects: they implement `equals()`
	   * and `hashCode()`.
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (
	      typeof valueA.valueOf === 'function' &&
	      typeof valueB.valueOf === 'function'
	    ) {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    return !!(
	      isValueObject(valueA) &&
	      isValueObject(valueB) &&
	      valueA.equals(valueB)
	    );
	  }
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2
	      ? Math.imul
	      : function imul(a, b) {
	          a |= 0; // int
	          b |= 0; // int
	          var c = a & 0xffff;
	          var d = b & 0xffff;
	          // Shift by 0 fixes the sign on the high part.
	          return (c * d + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0)) | 0; // int
	        };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xbfffffff);
	  }
	
	  var defaultValueOf = Object.prototype.valueOf;
	
	  function hash(o) {
	    if (o == null) {
	      return hashNullish(o);
	    }
	
	    if (typeof o.hashCode === 'function') {
	      // Drop any high bits from accidentally long hash codes.
	      return smi(o.hashCode(o));
	    }
	
	    var v = valueOf(o);
	
	    if (v == null) {
	      return hashNullish(v);
	    }
	
	    switch (typeof v) {
	      case 'boolean':
	        // The hash values for built-in constants are a 1 value for each 5-byte
	        // shift region expect for the first, which encodes the value. This
	        // reduces the odds of a hash collision for these common values.
	        return v ? 0x42108421 : 0x42108420;
	      case 'number':
	        return hashNumber(v);
	      case 'string':
	        return v.length > STRING_HASH_CACHE_MIN_STRLEN
	          ? cachedHashString(v)
	          : hashString(v);
	      case 'object':
	      case 'function':
	        return hashJSObj(v);
	      case 'symbol':
	        return hashSymbol(v);
	      default:
	        if (typeof v.toString === 'function') {
	          return hashString(v.toString());
	        }
	        throw new Error('Value type ' + typeof v + ' cannot be hashed.');
	    }
	  }
	
	  function hashNullish(nullish) {
	    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
	  }
	
	  // Compress arbitrarily large numbers into smi hashes.
	  function hashNumber(n) {
	    if (n !== n || n === Infinity) {
	      return 0;
	    }
	    var hash = n | 0;
	    if (hash !== n) {
	      hash ^= n * 0xffffffff;
	    }
	    while (n > 0xffffffff) {
	      n /= 0xffffffff;
	      hash ^= n;
	    }
	    return smi(hash);
	  }
	
	  function cachedHashString(string) {
	    var hashed = stringHashCache[string];
	    if (hashed === undefined) {
	      hashed = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hashed;
	    }
	    return hashed;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hashed = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hashed = (31 * hashed + string.charCodeAt(ii)) | 0;
	    }
	    return smi(hashed);
	  }
	
	  function hashSymbol(sym) {
	    var hashed = symbolMap[sym];
	    if (hashed !== undefined) {
	      return hashed;
	    }
	
	    hashed = nextHash();
	
	    symbolMap[sym] = hashed;
	
	    return hashed;
	  }
	
	  function hashJSObj(obj) {
	    var hashed;
	    if (usingWeakMap) {
	      hashed = weakMap.get(obj);
	      if (hashed !== undefined) {
	        return hashed;
	      }
	    }
	
	    hashed = obj[UID_HASH_KEY];
	    if (hashed !== undefined) {
	      return hashed;
	    }
	
	    if (!canDefineProperty) {
	      hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hashed !== undefined) {
	        return hashed;
	      }
	
	      hashed = getIENodeHash(obj);
	      if (hashed !== undefined) {
	        return hashed;
	      }
	    }
	
	    hashed = nextHash();
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hashed);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        enumerable: false,
	        configurable: false,
	        writable: false,
	        value: hashed,
	      });
	    } else if (
	      obj.propertyIsEnumerable !== undefined &&
	      obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable
	    ) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function () {
	        return this.constructor.prototype.propertyIsEnumerable.apply(
	          this,
	          arguments
	        );
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hashed;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hashed;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function () {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  })();
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  function valueOf(obj) {
	    return obj.valueOf !== defaultValueOf && typeof obj.valueOf === 'function'
	      ? obj.valueOf(obj)
	      : obj;
	  }
	
	  function nextHash() {
	    var nextHash = ++_objHashUID;
	    if (_objHashUID & 0x40000000) {
	      _objHashUID = 0;
	    }
	    return nextHash;
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var symbolMap = Object.create(null);
	
	  var _objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  var ToKeyedSequence = /*@__PURE__*/(function (KeyedSeq) {
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    if ( KeyedSeq ) ToKeyedSequence.__proto__ = KeyedSeq;
	    ToKeyedSequence.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
	    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
	
	    ToKeyedSequence.prototype.get = function get (key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function has (key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function valueSeq () {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function reverse () {
	      var this$1$1 = this;
	
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function () { return this$1$1._iter.toSeq().reverse(); };
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function map (mapper, context) {
	      var this$1$1 = this;
	
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function () { return this$1$1._iter.toSeq().map(mapper, context); };
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function __iterate (fn, reverse) {
	      var this$1$1 = this;
	
	      return this._iter.__iterate(function (v, k) { return fn(v, k, this$1$1); }, reverse);
	    };
	
	    ToKeyedSequence.prototype.__iterator = function __iterator (type, reverse) {
	      return this._iter.__iterator(type, reverse);
	    };
	
	    return ToKeyedSequence;
	  }(KeyedSeq));
	  ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;
	
	  var ToIndexedSequence = /*@__PURE__*/(function (IndexedSeq) {
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    if ( IndexedSeq ) ToIndexedSequence.__proto__ = IndexedSeq;
	    ToIndexedSequence.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
	    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
	
	    ToIndexedSequence.prototype.includes = function includes (value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function __iterate (fn, reverse) {
	      var this$1$1 = this;
	
	      var i = 0;
	      reverse && ensureSize(this);
	      return this._iter.__iterate(
	        function (v) { return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1); },
	        reverse
	      );
	    };
	
	    ToIndexedSequence.prototype.__iterator = function __iterator (type, reverse) {
	      var this$1$1 = this;
	
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var i = 0;
	      reverse && ensureSize(this);
	      return new Iterator(function () {
	        var step = iterator.next();
	        return step.done
	          ? step
	          : iteratorValue(
	              type,
	              reverse ? this$1$1.size - ++i : i++,
	              step.value,
	              step
	            );
	      });
	    };
	
	    return ToIndexedSequence;
	  }(IndexedSeq));
	
	  var ToSetSequence = /*@__PURE__*/(function (SetSeq) {
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    if ( SetSeq ) ToSetSequence.__proto__ = SetSeq;
	    ToSetSequence.prototype = Object.create( SetSeq && SetSeq.prototype );
	    ToSetSequence.prototype.constructor = ToSetSequence;
	
	    ToSetSequence.prototype.has = function has (key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function __iterate (fn, reverse) {
	      var this$1$1 = this;
	
	      return this._iter.__iterate(function (v) { return fn(v, v, this$1$1); }, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function __iterator (type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function () {
	        var step = iterator.next();
	        return step.done
	          ? step
	          : iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	    return ToSetSequence;
	  }(SetSeq));
	
	  var FromEntriesSequence = /*@__PURE__*/(function (KeyedSeq) {
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    if ( KeyedSeq ) FromEntriesSequence.__proto__ = KeyedSeq;
	    FromEntriesSequence.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
	    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
	
	    FromEntriesSequence.prototype.entrySeq = function entrySeq () {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function __iterate (fn, reverse) {
	      var this$1$1 = this;
	
	      return this._iter.__iterate(function (entry) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedCollection = isCollection(entry);
	          return fn(
	            indexedCollection ? entry.get(1) : entry[1],
	            indexedCollection ? entry.get(0) : entry[0],
	            this$1$1
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function __iterator (type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function () {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedCollection = isCollection(entry);
	            return iteratorValue(
	              type,
	              indexedCollection ? entry.get(0) : entry[0],
	              indexedCollection ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	    return FromEntriesSequence;
	  }(KeyedSeq));
	
	  ToIndexedSequence.prototype.cacheResult =
	    ToKeyedSequence.prototype.cacheResult =
	    ToSetSequence.prototype.cacheResult =
	    FromEntriesSequence.prototype.cacheResult =
	      cacheResultThrough;
	
	  function flipFactory(collection) {
	    var flipSequence = makeSequence(collection);
	    flipSequence._iter = collection;
	    flipSequence.size = collection.size;
	    flipSequence.flip = function () { return collection; };
	    flipSequence.reverse = function () {
	      var reversedSequence = collection.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function () { return collection.reverse(); };
	      return reversedSequence;
	    };
	    flipSequence.has = function (key) { return collection.includes(key); };
	    flipSequence.includes = function (key) { return collection.has(key); };
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {
	      var this$1$1 = this;
	
	      return collection.__iterate(function (v, k) { return fn(k, v, this$1$1) !== false; }, reverse);
	    };
	    flipSequence.__iteratorUncached = function (type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = collection.__iterator(type, reverse);
	        return new Iterator(function () {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return collection.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    };
	    return flipSequence;
	  }
	
	  function mapFactory(collection, mapper, context) {
	    var mappedSequence = makeSequence(collection);
	    mappedSequence.size = collection.size;
	    mappedSequence.has = function (key) { return collection.has(key); };
	    mappedSequence.get = function (key, notSetValue) {
	      var v = collection.get(key, NOT_SET);
	      return v === NOT_SET
	        ? notSetValue
	        : mapper.call(context, v, key, collection);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {
	      var this$1$1 = this;
	
	      return collection.__iterate(
	        function (v, k, c) { return fn(mapper.call(context, v, k, c), k, this$1$1) !== false; },
	        reverse
	      );
	    };
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function () {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, collection),
	          step
	        );
	      });
	    };
	    return mappedSequence;
	  }
	
	  function reverseFactory(collection, useKeys) {
	    var this$1$1 = this;
	
	    var reversedSequence = makeSequence(collection);
	    reversedSequence._iter = collection;
	    reversedSequence.size = collection.size;
	    reversedSequence.reverse = function () { return collection; };
	    if (collection.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(collection);
	        flipSequence.reverse = function () { return collection.flip(); };
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function (key, notSetValue) { return collection.get(useKeys ? key : -1 - key, notSetValue); };
	    reversedSequence.has = function (key) { return collection.has(useKeys ? key : -1 - key); };
	    reversedSequence.includes = function (value) { return collection.includes(value); };
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {
	      var this$1$1 = this;
	
	      var i = 0;
	      reverse && ensureSize(collection);
	      return collection.__iterate(
	        function (v, k) { return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1); },
	        !reverse
	      );
	    };
	    reversedSequence.__iterator = function (type, reverse) {
	      var i = 0;
	      reverse && ensureSize(collection);
	      var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
	      return new Iterator(function () {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        return iteratorValue(
	          type,
	          useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++,
	          entry[1],
	          step
	        );
	      });
	    };
	    return reversedSequence;
	  }
	
	  function filterFactory(collection, predicate, context, useKeys) {
	    var filterSequence = makeSequence(collection);
	    if (useKeys) {
	      filterSequence.has = function (key) {
	        var v = collection.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, collection);
	      };
	      filterSequence.get = function (key, notSetValue) {
	        var v = collection.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, collection)
	          ? v
	          : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {
	      var this$1$1 = this;
	
	      var iterations = 0;
	      collection.__iterate(function (v, k, c) {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$1$1);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function () {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, collection)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    };
	    return filterSequence;
	  }
	
	  function countByFactory(collection, grouper, context) {
	    var groups = Map().asMutable();
	    collection.__iterate(function (v, k) {
	      groups.update(grouper.call(context, v, k, collection), 0, function (a) { return a + 1; });
	    });
	    return groups.asImmutable();
	  }
	
	  function groupByFactory(collection, grouper, context) {
	    var isKeyedIter = isKeyed(collection);
	    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
	    collection.__iterate(function (v, k) {
	      groups.update(
	        grouper.call(context, v, k, collection),
	        function (a) { return ((a = a || []), a.push(isKeyedIter ? [k, v] : v), a); }
	      );
	    });
	    var coerce = collectionClass(collection);
	    return groups.map(function (arr) { return reify(collection, coerce(arr)); }).asImmutable();
	  }
	
	  function sliceFactory(collection, begin, end, useKeys) {
	    var originalSize = collection.size;
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return collection;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this collection's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(collection);
	
	    // If collection.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size =
	      sliceSize === 0 ? sliceSize : (collection.size && sliceSize) || undefined;
	
	    if (!useKeys && isSeq(collection) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize
	          ? collection.get(index + resolvedBegin, notSetValue)
	          : notSetValue;
	      };
	    }
	
	    sliceSeq.__iterateUncached = function (fn, reverse) {
	      var this$1$1 = this;
	
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      collection.__iterate(function (v, k) {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return (
	            fn(v, useKeys ? k : iterations - 1, this$1$1) !== false &&
	            iterations !== sliceSize
	          );
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function (type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      if (sliceSize === 0) {
	        return new Iterator(iteratorDone);
	      }
	      var iterator = collection.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function () {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES || step.done) {
	          return step;
	        }
	        if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        }
	        return iteratorValue(type, iterations - 1, step.value[1], step);
	      });
	    };
	
	    return sliceSeq;
	  }
	
	  function takeWhileFactory(collection, predicate, context) {
	    var takeSequence = makeSequence(collection);
	    takeSequence.__iterateUncached = function (fn, reverse) {
	      var this$1$1 = this;
	
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      collection.__iterate(
	        function (v, k, c) { return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1); }
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function (type, reverse) {
	      var this$1$1 = this;
	
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function () {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$1$1)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	  function skipWhileFactory(collection, predicate, context, useKeys) {
	    var skipSequence = makeSequence(collection);
	    skipSequence.__iterateUncached = function (fn, reverse) {
	      var this$1$1 = this;
	
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      collection.__iterate(function (v, k, c) {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$1$1);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function (type, reverse) {
	      var this$1$1 = this;
	
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function () {
	        var step;
	        var k;
	        var v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            }
	            if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            }
	            return iteratorValue(type, iterations++, step.value[1], step);
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$1$1));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	  function concatFactory(collection, values) {
	    var isKeyedCollection = isKeyed(collection);
	    var iters = [collection]
	      .concat(values)
	      .map(function (v) {
	        if (!isCollection(v)) {
	          v = isKeyedCollection
	            ? keyedSeqFromValue(v)
	            : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	        } else if (isKeyedCollection) {
	          v = KeyedCollection(v);
	        }
	        return v;
	      })
	      .filter(function (v) { return v.size !== 0; });
	
	    if (iters.length === 0) {
	      return collection;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (
	        singleton === collection ||
	        (isKeyedCollection && isKeyed(singleton)) ||
	        (isIndexed(collection) && isIndexed(singleton))
	      ) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedCollection) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(collection)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(function (sum, seq) {
	      if (sum !== undefined) {
	        var size = seq.size;
	        if (size !== undefined) {
	          return sum + size;
	        }
	      }
	    }, 0);
	    return concatSeq;
	  }
	
	  function flattenFactory(collection, depth, useKeys) {
	    var flatSequence = makeSequence(collection);
	    flatSequence.__iterateUncached = function (fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {
	        iter.__iterate(function (v, k) {
	          if ((!depth || currentDepth < depth) && isCollection(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else {
	            iterations++;
	            if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) {
	              stopped = true;
	            }
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(collection, 0);
	      return iterations;
	    };
	    flatSequence.__iteratorUncached = function (type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = collection.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function () {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isCollection(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    };
	    return flatSequence;
	  }
	
	  function flatMapFactory(collection, mapper, context) {
	    var coerce = collectionClass(collection);
	    return collection
	      .toSeq()
	      .map(function (v, k) { return coerce(mapper.call(context, v, k, collection)); })
	      .flatten(true);
	  }
	
	  function interposeFactory(collection, separator) {
	    var interposedSequence = makeSequence(collection);
	    interposedSequence.size = collection.size && collection.size * 2 - 1;
	    interposedSequence.__iterateUncached = function (fn, reverse) {
	      var this$1$1 = this;
	
	      var iterations = 0;
	      collection.__iterate(
	        function (v) { return (!iterations || fn(separator, iterations++, this$1$1) !== false) &&
	          fn(v, iterations++, this$1$1) !== false; },
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = collection.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function () {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2
	          ? iteratorValue(type, iterations++, separator)
	          : iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	  function sortFactory(collection, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedCollection = isKeyed(collection);
	    var index = 0;
	    var entries = collection
	      .toSeq()
	      .map(function (v, k) { return [k, v, index++, mapper ? mapper(v, k, collection) : v]; })
	      .valueSeq()
	      .toArray();
	    entries
	      .sort(function (a, b) { return comparator(a[3], b[3]) || a[2] - b[2]; })
	      .forEach(
	        isKeyedCollection
	          ? function (v, i) {
	              entries[i].length = 2;
	            }
	          : function (v, i) {
	              entries[i] = v[1];
	            }
	      );
	    return isKeyedCollection
	      ? KeyedSeq(entries)
	      : isIndexed(collection)
	      ? IndexedSeq(entries)
	      : SetSeq(entries);
	  }
	
	  function maxFactory(collection, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = collection
	        .toSeq()
	        .map(function (v, k) { return [v, mapper(v, k, collection)]; })
	        .reduce(function (a, b) { return (maxCompare(comparator, a[1], b[1]) ? b : a); });
	      return entry && entry[0];
	    }
	    return collection.reduce(function (a, b) { return (maxCompare(comparator, a, b) ? b : a); });
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (
	      (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) ||
	      comp > 0
	    );
	  }
	
	  function zipWithFactory(keyIter, zipper, iters, zipAll) {
	    var zipSequence = makeSequence(keyIter);
	    var sizes = new ArraySeq(iters).map(function (i) { return i.size; });
	    zipSequence.size = zipAll ? sizes.max() : sizes.min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function (fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function (type, reverse) {
	      var iterators = iters.map(
	        function (i) { return ((i = Collection(i)), getIterator(reverse ? i.reverse() : i)); }
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function () {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function (i) { return i.next(); });
	          isDone = zipAll ? steps.every(function (s) { return s.done; }) : steps.some(function (s) { return s.done; });
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(
	            null,
	            steps.map(function (s) { return s.value; })
	          )
	        );
	      });
	    };
	    return zipSequence;
	  }
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function collectionClass(collection) {
	    return isKeyed(collection)
	      ? KeyedCollection
	      : isIndexed(collection)
	      ? IndexedCollection
	      : SetCollection;
	  }
	
	  function makeSequence(collection) {
	    return Object.create(
	      (isKeyed(collection)
	        ? KeyedSeq
	        : isIndexed(collection)
	        ? IndexedSeq
	        : SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    }
	    return Seq.prototype.cacheResult.call(this);
	  }
	
	  function defaultComparator(a, b) {
	    if (a === undefined && b === undefined) {
	      return 0;
	    }
	
	    if (a === undefined) {
	      return 1;
	    }
	
	    if (b === undefined) {
	      return -1;
	    }
	
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function invariant(condition, error) {
	    if (!condition) { throw new Error(error); }
	  }
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  function coerceKeyPath(keyPath) {
	    if (isArrayLike(keyPath) && typeof keyPath !== 'string') {
	      return keyPath;
	    }
	    if (isOrdered(keyPath)) {
	      return keyPath.toArray();
	    }
	    throw new TypeError(
	      'Invalid keyPath: expected Ordered Collection or Array: ' + keyPath
	    );
	  }
	
	  var toString = Object.prototype.toString;
	
	  function isPlainObject(value) {
	    // The base prototype's toString deals with Argument objects and native namespaces like Math
	    if (
	      !value ||
	      typeof value !== 'object' ||
	      toString.call(value) !== '[object Object]'
	    ) {
	      return false;
	    }
	
	    var proto = Object.getPrototypeOf(value);
	    if (proto === null) {
	      return true;
	    }
	
	    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
	    var parentProto = proto;
	    var nextProto = Object.getPrototypeOf(proto);
	    while (nextProto !== null) {
	      parentProto = nextProto;
	      nextProto = Object.getPrototypeOf(parentProto);
	    }
	    return parentProto === proto;
	  }
	
	  /**
	   * Returns true if the value is a potentially-persistent data structure, either
	   * provided by Immutable.js or a plain Array or Object.
	   */
	  function isDataStructure(value) {
	    return (
	      typeof value === 'object' &&
	      (isImmutable(value) || Array.isArray(value) || isPlainObject(value))
	    );
	  }
	
	  function quoteString(value) {
	    try {
	      return typeof value === 'string' ? JSON.stringify(value) : String(value);
	    } catch (_ignoreError) {
	      return JSON.stringify(value);
	    }
	  }
	
	  function has(collection, key) {
	    return isImmutable(collection)
	      ? collection.has(key)
	      : isDataStructure(collection) && hasOwnProperty.call(collection, key);
	  }
	
	  function get(collection, key, notSetValue) {
	    return isImmutable(collection)
	      ? collection.get(key, notSetValue)
	      : !has(collection, key)
	      ? notSetValue
	      : typeof collection.get === 'function'
	      ? collection.get(key)
	      : collection[key];
	  }
	
	  function shallowCopy(from) {
	    if (Array.isArray(from)) {
	      return arrCopy(from);
	    }
	    var to = {};
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	    return to;
	  }
	
	  function remove(collection, key) {
	    if (!isDataStructure(collection)) {
	      throw new TypeError(
	        'Cannot update non-data-structure value: ' + collection
	      );
	    }
	    if (isImmutable(collection)) {
	      if (!collection.remove) {
	        throw new TypeError(
	          'Cannot update immutable value without .remove() method: ' + collection
	        );
	      }
	      return collection.remove(key);
	    }
	    if (!hasOwnProperty.call(collection, key)) {
	      return collection;
	    }
	    var collectionCopy = shallowCopy(collection);
	    if (Array.isArray(collectionCopy)) {
	      collectionCopy.splice(key, 1);
	    } else {
	      delete collectionCopy[key];
	    }
	    return collectionCopy;
	  }
	
	  function set(collection, key, value) {
	    if (!isDataStructure(collection)) {
	      throw new TypeError(
	        'Cannot update non-data-structure value: ' + collection
	      );
	    }
	    if (isImmutable(collection)) {
	      if (!collection.set) {
	        throw new TypeError(
	          'Cannot update immutable value without .set() method: ' + collection
	        );
	      }
	      return collection.set(key, value);
	    }
	    if (hasOwnProperty.call(collection, key) && value === collection[key]) {
	      return collection;
	    }
	    var collectionCopy = shallowCopy(collection);
	    collectionCopy[key] = value;
	    return collectionCopy;
	  }
	
	  function updateIn$1(collection, keyPath, notSetValue, updater) {
	    if (!updater) {
	      updater = notSetValue;
	      notSetValue = undefined;
	    }
	    var updatedValue = updateInDeeply(
	      isImmutable(collection),
	      collection,
	      coerceKeyPath(keyPath),
	      0,
	      notSetValue,
	      updater
	    );
	    return updatedValue === NOT_SET ? notSetValue : updatedValue;
	  }
	
	  function updateInDeeply(
	    inImmutable,
	    existing,
	    keyPath,
	    i,
	    notSetValue,
	    updater
	  ) {
	    var wasNotSet = existing === NOT_SET;
	    if (i === keyPath.length) {
	      var existingValue = wasNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    if (!wasNotSet && !isDataStructure(existing)) {
	      throw new TypeError(
	        'Cannot update within non-data-structure value in path [' +
	          keyPath.slice(0, i).map(quoteString) +
	          ']: ' +
	          existing
	      );
	    }
	    var key = keyPath[i];
	    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
	    var nextUpdated = updateInDeeply(
	      nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting),
	      nextExisting,
	      keyPath,
	      i + 1,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting
	      ? existing
	      : nextUpdated === NOT_SET
	      ? remove(existing, key)
	      : set(
	          wasNotSet ? (inImmutable ? emptyMap() : {}) : existing,
	          key,
	          nextUpdated
	        );
	  }
	
	  function setIn$1(collection, keyPath, value) {
	    return updateIn$1(collection, keyPath, NOT_SET, function () { return value; });
	  }
	
	  function setIn(keyPath, v) {
	    return setIn$1(this, keyPath, v);
	  }
	
	  function removeIn(collection, keyPath) {
	    return updateIn$1(collection, keyPath, function () { return NOT_SET; });
	  }
	
	  function deleteIn(keyPath) {
	    return removeIn(this, keyPath);
	  }
	
	  function update$1(collection, key, notSetValue, updater) {
	    return updateIn$1(collection, [key], notSetValue, updater);
	  }
	
	  function update(key, notSetValue, updater) {
	    return arguments.length === 1
	      ? key(this)
	      : update$1(this, key, notSetValue, updater);
	  }
	
	  function updateIn(keyPath, notSetValue, updater) {
	    return updateIn$1(this, keyPath, notSetValue, updater);
	  }
	
	  function merge$1() {
	    var iters = [], len = arguments.length;
	    while ( len-- ) iters[ len ] = arguments[ len ];
	
	    return mergeIntoKeyedWith(this, iters);
	  }
	
	  function mergeWith$1(merger) {
	    var iters = [], len = arguments.length - 1;
	    while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];
	
	    if (typeof merger !== 'function') {
	      throw new TypeError('Invalid merger function: ' + merger);
	    }
	    return mergeIntoKeyedWith(this, iters, merger);
	  }
	
	  function mergeIntoKeyedWith(collection, collections, merger) {
	    var iters = [];
	    for (var ii = 0; ii < collections.length; ii++) {
	      var collection$1 = KeyedCollection(collections[ii]);
	      if (collection$1.size !== 0) {
	        iters.push(collection$1);
	      }
	    }
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (
	      collection.toSeq().size === 0 &&
	      !collection.__ownerID &&
	      iters.length === 1
	    ) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function (collection) {
	      var mergeIntoCollection = merger
	        ? function (value, key) {
	            update$1(collection, key, NOT_SET, function (oldVal) { return oldVal === NOT_SET ? value : merger(oldVal, value, key); }
	            );
	          }
	        : function (value, key) {
	            collection.set(key, value);
	          };
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoCollection);
	      }
	    });
	  }
	
	  function merge(collection) {
	    var sources = [], len = arguments.length - 1;
	    while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
	
	    return mergeWithSources(collection, sources);
	  }
	
	  function mergeWith(merger, collection) {
	    var sources = [], len = arguments.length - 2;
	    while ( len-- > 0 ) sources[ len ] = arguments[ len + 2 ];
	
	    return mergeWithSources(collection, sources, merger);
	  }
	
	  function mergeDeep$1(collection) {
	    var sources = [], len = arguments.length - 1;
	    while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
	
	    return mergeDeepWithSources(collection, sources);
	  }
	
	  function mergeDeepWith$1(merger, collection) {
	    var sources = [], len = arguments.length - 2;
	    while ( len-- > 0 ) sources[ len ] = arguments[ len + 2 ];
	
	    return mergeDeepWithSources(collection, sources, merger);
	  }
	
	  function mergeDeepWithSources(collection, sources, merger) {
	    return mergeWithSources(collection, sources, deepMergerWith(merger));
	  }
	
	  function mergeWithSources(collection, sources, merger) {
	    if (!isDataStructure(collection)) {
	      throw new TypeError(
	        'Cannot merge into non-data-structure value: ' + collection
	      );
	    }
	    if (isImmutable(collection)) {
	      return typeof merger === 'function' && collection.mergeWith
	        ? collection.mergeWith.apply(collection, [ merger ].concat( sources ))
	        : collection.merge
	        ? collection.merge.apply(collection, sources)
	        : collection.concat.apply(collection, sources);
	    }
	    var isArray = Array.isArray(collection);
	    var merged = collection;
	    var Collection = isArray ? IndexedCollection : KeyedCollection;
	    var mergeItem = isArray
	      ? function (value) {
	          // Copy on write
	          if (merged === collection) {
	            merged = shallowCopy(merged);
	          }
	          merged.push(value);
	        }
	      : function (value, key) {
	          var hasVal = hasOwnProperty.call(merged, key);
	          var nextVal =
	            hasVal && merger ? merger(merged[key], value, key) : value;
	          if (!hasVal || nextVal !== merged[key]) {
	            // Copy on write
	            if (merged === collection) {
	              merged = shallowCopy(merged);
	            }
	            merged[key] = nextVal;
	          }
	        };
	    for (var i = 0; i < sources.length; i++) {
	      Collection(sources[i]).forEach(mergeItem);
	    }
	    return merged;
	  }
	
	  function deepMergerWith(merger) {
	    function deepMerger(oldValue, newValue, key) {
	      return isDataStructure(oldValue) &&
	        isDataStructure(newValue) &&
	        areMergeable(oldValue, newValue)
	        ? mergeWithSources(oldValue, [newValue], deepMerger)
	        : merger
	        ? merger(oldValue, newValue, key)
	        : newValue;
	    }
	    return deepMerger;
	  }
	
	  /**
	   * It's unclear what the desired behavior is for merging two collections that
	   * fall into separate categories between keyed, indexed, or set-like, so we only
	   * consider them mergeable if they fall into the same category.
	   */
	  function areMergeable(oldDataStructure, newDataStructure) {
	    var oldSeq = Seq(oldDataStructure);
	    var newSeq = Seq(newDataStructure);
	    // This logic assumes that a sequence can only fall into one of the three
	    // categories mentioned above (since there's no `isSetLike()` method).
	    return (
	      isIndexed(oldSeq) === isIndexed(newSeq) &&
	      isKeyed(oldSeq) === isKeyed(newSeq)
	    );
	  }
	
	  function mergeDeep() {
	    var iters = [], len = arguments.length;
	    while ( len-- ) iters[ len ] = arguments[ len ];
	
	    return mergeDeepWithSources(this, iters);
	  }
	
	  function mergeDeepWith(merger) {
	    var iters = [], len = arguments.length - 1;
	    while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];
	
	    return mergeDeepWithSources(this, iters, merger);
	  }
	
	  function mergeIn(keyPath) {
	    var iters = [], len = arguments.length - 1;
	    while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];
	
	    return updateIn$1(this, keyPath, emptyMap(), function (m) { return mergeWithSources(m, iters); });
	  }
	
	  function mergeDeepIn(keyPath) {
	    var iters = [], len = arguments.length - 1;
	    while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];
	
	    return updateIn$1(this, keyPath, emptyMap(), function (m) { return mergeDeepWithSources(m, iters); }
	    );
	  }
	
	  function withMutations(fn) {
	    var mutable = this.asMutable();
	    fn(mutable);
	    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	  }
	
	  function asMutable() {
	    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	  }
	
	  function asImmutable() {
	    return this.__ensureOwner();
	  }
	
	  function wasAltered() {
	    return this.__altered;
	  }
	
	  var Map = /*@__PURE__*/(function (KeyedCollection) {
	    function Map(value) {
	      return value === undefined || value === null
	        ? emptyMap()
	        : isMap(value) && !isOrdered(value)
	        ? value
	        : emptyMap().withMutations(function (map) {
	            var iter = KeyedCollection(value);
	            assertNotInfinite(iter.size);
	            iter.forEach(function (v, k) { return map.set(k, v); });
	          });
	    }
	
	    if ( KeyedCollection ) Map.__proto__ = KeyedCollection;
	    Map.prototype = Object.create( KeyedCollection && KeyedCollection.prototype );
	    Map.prototype.constructor = Map;
	
	    Map.of = function of () {
	      var keyValues = [], len = arguments.length;
	      while ( len-- ) keyValues[ len ] = arguments[ len ];
	
	      return emptyMap().withMutations(function (map) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function toString () {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function get (k, notSetValue) {
	      return this._root
	        ? this._root.get(0, undefined, k, notSetValue)
	        : notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function set (k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.remove = function remove (k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteAll = function deleteAll (keys) {
	      var collection = Collection(keys);
	
	      if (collection.size === 0) {
	        return this;
	      }
	
	      return this.withMutations(function (map) {
	        collection.forEach(function (key) { return map.remove(key); });
	      });
	    };
	
	    Map.prototype.clear = function clear () {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.sort = function sort (comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function sortBy (mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    Map.prototype.map = function map (mapper, context) {
	      var this$1$1 = this;
	
	      return this.withMutations(function (map) {
	        map.forEach(function (value, key) {
	          map.set(key, mapper.call(context, value, key, this$1$1));
	        });
	      });
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.__iterator = function __iterator (type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function __iterate (fn, reverse) {
	      var this$1$1 = this;
	
	      var iterations = 0;
	      this._root &&
	        this._root.iterate(function (entry) {
	          iterations++;
	          return fn(entry[1], entry[0], this$1$1);
	        }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function __ensureOwner (ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        if (this.size === 0) {
	          return emptyMap();
	        }
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	    return Map;
	  }(KeyedCollection));
	
	  Map.isMap = isMap;
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SYMBOL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeAll = MapPrototype.deleteAll;
	  MapPrototype.setIn = setIn;
	  MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
	  MapPrototype.update = update;
	  MapPrototype.updateIn = updateIn;
	  MapPrototype.merge = MapPrototype.concat = merge$1;
	  MapPrototype.mergeWith = mergeWith$1;
	  MapPrototype.mergeDeep = mergeDeep;
	  MapPrototype.mergeDeepWith = mergeDeepWith;
	  MapPrototype.mergeIn = mergeIn;
	  MapPrototype.mergeDeepIn = mergeDeepIn;
	  MapPrototype.withMutations = withMutations;
	  MapPrototype.wasAltered = wasAltered;
	  MapPrototype.asImmutable = asImmutable;
	  MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
	  MapPrototype['@@transducer/step'] = function (result, arr) {
	    return result.set(arr[0], arr[1]);
	  };
	  MapPrototype['@@transducer/result'] = function (obj) {
	    return obj.asImmutable();
	  };
	
	  // #pragma Trie Nodes
	
	  var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
	    this.ownerID = ownerID;
	    this.entries = entries;
	  };
	
	  ArrayMapNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
	    var entries = this.entries;
	    for (var ii = 0, len = entries.length; ii < len; ii++) {
	      if (is(key, entries[ii][0])) {
	        return entries[ii][1];
	      }
	    }
	    return notSetValue;
	  };
	
	  ArrayMapNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    var removed = value === NOT_SET;
	
	    var entries = this.entries;
	    var idx = 0;
	    var len = entries.length;
	    for (; idx < len; idx++) {
	      if (is(key, entries[idx][0])) {
	        break;
	      }
	    }
	    var exists = idx < len;
	
	    if (exists ? entries[idx][1] === value : removed) {
	      return this;
	    }
	
	    SetRef(didAlter);
	    (removed || !exists) && SetRef(didChangeSize);
	
	    if (removed && entries.length === 1) {
	      return; // undefined
	    }
	
	    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	      return createNodes(ownerID, entries, key, value);
	    }
	
	    var isEditable = ownerID && ownerID === this.ownerID;
	    var newEntries = isEditable ? entries : arrCopy(entries);
	
	    if (exists) {
	      if (removed) {
	        idx === len - 1
	          ? newEntries.pop()
	          : (newEntries[idx] = newEntries.pop());
	      } else {
	        newEntries[idx] = [key, value];
	      }
	    } else {
	      newEntries.push([key, value]);
	    }
	
	    if (isEditable) {
	      this.entries = newEntries;
	      return this;
	    }
	
	    return new ArrayMapNode(ownerID, newEntries);
	  };
	
	  var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
	    this.ownerID = ownerID;
	    this.bitmap = bitmap;
	    this.nodes = nodes;
	  };
	
	  BitmapIndexedNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
	    if (keyHash === undefined) {
	      keyHash = hash(key);
	    }
	    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
	    var bitmap = this.bitmap;
	    return (bitmap & bit) === 0
	      ? notSetValue
	      : this.nodes[popCount(bitmap & (bit - 1))].get(
	          shift + SHIFT,
	          keyHash,
	          key,
	          notSetValue
	        );
	  };
	
	  BitmapIndexedNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (keyHash === undefined) {
	      keyHash = hash(key);
	    }
	    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	    var bit = 1 << keyHashFrag;
	    var bitmap = this.bitmap;
	    var exists = (bitmap & bit) !== 0;
	
	    if (!exists && value === NOT_SET) {
	      return this;
	    }
	
	    var idx = popCount(bitmap & (bit - 1));
	    var nodes = this.nodes;
	    var node = exists ? nodes[idx] : undefined;
	    var newNode = updateNode(
	      node,
	      ownerID,
	      shift + SHIFT,
	      keyHash,
	      key,
	      value,
	      didChangeSize,
	      didAlter
	    );
	
	    if (newNode === node) {
	      return this;
	    }
	
	    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	      return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	    }
	
	    if (
	      exists &&
	      !newNode &&
	      nodes.length === 2 &&
	      isLeafNode(nodes[idx ^ 1])
	    ) {
	      return nodes[idx ^ 1];
	    }
	
	    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	      return newNode;
	    }
	
	    var isEditable = ownerID && ownerID === this.ownerID;
	    var newBitmap = exists ? (newNode ? bitmap : bitmap ^ bit) : bitmap | bit;
	    var newNodes = exists
	      ? newNode
	        ? setAt(nodes, idx, newNode, isEditable)
	        : spliceOut(nodes, idx, isEditable)
	      : spliceIn(nodes, idx, newNode, isEditable);
	
	    if (isEditable) {
	      this.bitmap = newBitmap;
	      this.nodes = newNodes;
	      return this;
	    }
	
	    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	  };
	
	  var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
	    this.ownerID = ownerID;
	    this.count = count;
	    this.nodes = nodes;
	  };
	
	  HashArrayMapNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
	    if (keyHash === undefined) {
	      keyHash = hash(key);
	    }
	    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	    var node = this.nodes[idx];
	    return node
	      ? node.get(shift + SHIFT, keyHash, key, notSetValue)
	      : notSetValue;
	  };
	
	  HashArrayMapNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (keyHash === undefined) {
	      keyHash = hash(key);
	    }
	    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	    var removed = value === NOT_SET;
	    var nodes = this.nodes;
	    var node = nodes[idx];
	
	    if (removed && !node) {
	      return this;
	    }
	
	    var newNode = updateNode(
	      node,
	      ownerID,
	      shift + SHIFT,
	      keyHash,
	      key,
	      value,
	      didChangeSize,
	      didAlter
	    );
	    if (newNode === node) {
	      return this;
	    }
	
	    var newCount = this.count;
	    if (!node) {
	      newCount++;
	    } else if (!newNode) {
	      newCount--;
	      if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	        return packNodes(ownerID, nodes, newCount, idx);
	      }
	    }
	
	    var isEditable = ownerID && ownerID === this.ownerID;
	    var newNodes = setAt(nodes, idx, newNode, isEditable);
	
	    if (isEditable) {
	      this.count = newCount;
	      this.nodes = newNodes;
	      return this;
	    }
	
	    return new HashArrayMapNode(ownerID, newCount, newNodes);
	  };
	
	  var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
	    this.ownerID = ownerID;
	    this.keyHash = keyHash;
	    this.entries = entries;
	  };
	
	  HashCollisionNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
	    var entries = this.entries;
	    for (var ii = 0, len = entries.length; ii < len; ii++) {
	      if (is(key, entries[ii][0])) {
	        return entries[ii][1];
	      }
	    }
	    return notSetValue;
	  };
	
	  HashCollisionNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (keyHash === undefined) {
	      keyHash = hash(key);
	    }
	
	    var removed = value === NOT_SET;
	
	    if (keyHash !== this.keyHash) {
	      if (removed) {
	        return this;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	    }
	
	    var entries = this.entries;
	    var idx = 0;
	    var len = entries.length;
	    for (; idx < len; idx++) {
	      if (is(key, entries[idx][0])) {
	        break;
	      }
	    }
	    var exists = idx < len;
	
	    if (exists ? entries[idx][1] === value : removed) {
	      return this;
	    }
	
	    SetRef(didAlter);
	    (removed || !exists) && SetRef(didChangeSize);
	
	    if (removed && len === 2) {
	      return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	    }
	
	    var isEditable = ownerID && ownerID === this.ownerID;
	    var newEntries = isEditable ? entries : arrCopy(entries);
	
	    if (exists) {
	      if (removed) {
	        idx === len - 1
	          ? newEntries.pop()
	          : (newEntries[idx] = newEntries.pop());
	      } else {
	        newEntries[idx] = [key, value];
	      }
	    } else {
	      newEntries.push([key, value]);
	    }
	
	    if (isEditable) {
	      this.entries = newEntries;
	      return this;
	    }
	
	    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	  };
	
	  var ValueNode = function ValueNode(ownerID, keyHash, entry) {
	    this.ownerID = ownerID;
	    this.keyHash = keyHash;
	    this.entry = entry;
	  };
	
	  ValueNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
	    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	  };
	
	  ValueNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    var removed = value === NOT_SET;
	    var keyMatch = is(key, this.entry[0]);
	    if (keyMatch ? value === this.entry[1] : removed) {
	      return this;
	    }
	
	    SetRef(didAlter);
	
	    if (removed) {
	      SetRef(didChangeSize);
	      return; // undefined
	    }
	
	    if (keyMatch) {
	      if (ownerID && ownerID === this.ownerID) {
	        this.entry[1] = value;
	        return this;
	      }
	      return new ValueNode(ownerID, this.keyHash, [key, value]);
	    }
	
	    SetRef(didChangeSize);
	    return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	  };
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate =
	    function (fn, reverse) {
	      var entries = this.entries;
	      for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	          return false;
	        }
	      }
	    };
	
	  BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate =
	    function (fn, reverse) {
	      var nodes = this.nodes;
	      for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	        var node = nodes[reverse ? maxIndex - ii : ii];
	        if (node && node.iterate(fn, reverse) === false) {
	          return false;
	        }
	      }
	    };
	
	  // eslint-disable-next-line no-unused-vars
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  };
	
	  var MapIterator = /*@__PURE__*/(function (Iterator) {
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    if ( Iterator ) MapIterator.__proto__ = Iterator;
	    MapIterator.prototype = Object.create( Iterator && Iterator.prototype );
	    MapIterator.prototype.constructor = MapIterator;
	
	    MapIterator.prototype.next = function next () {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex = (void 0);
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(
	              type,
	              node.entries[this._reverse ? maxIndex - index : index]
	            );
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	    return MapIterator;
	  }(Iterator));
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev,
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef();
	      var didAlter = MakeRef();
	      newRoot = updateNode(
	        map._root,
	        map.__ownerID,
	        0,
	        undefined,
	        k,
	        v,
	        didChangeSize,
	        didAlter
	      );
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? (v === NOT_SET ? -1 : 1) : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(
	    node,
	    ownerID,
	    shift,
	    keyHash,
	    key,
	    value,
	    didChangeSize,
	    didAlter
	  ) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(
	      ownerID,
	      shift,
	      keyHash,
	      key,
	      value,
	      didChangeSize,
	      didAlter
	    );
	  }
	
	  function isLeafNode(node) {
	    return (
	      node.constructor === ValueNode || node.constructor === HashCollisionNode
	    );
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes =
	      idx1 === idx2
	        ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)]
	        : ((newNode = new ValueNode(ownerID, keyHash, entry)),
	          idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function popCount(x) {
	    x -= (x >> 1) & 0x55555555;
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x += x >> 8;
	    x += x >> 16;
	    return x & 0x7f;
	  }
	
	  function setAt(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  var IS_LIST_SYMBOL = '@@__IMMUTABLE_LIST__@@';
	
	  function isList(maybeList) {
	    return Boolean(maybeList && maybeList[IS_LIST_SYMBOL]);
	  }
	
	  var List = /*@__PURE__*/(function (IndexedCollection) {
	    function List(value) {
	      var empty = emptyList();
	      if (value === undefined || value === null) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedCollection(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function (list) {
	        list.setSize(size);
	        iter.forEach(function (v, i) { return list.set(i, v); });
	      });
	    }
	
	    if ( IndexedCollection ) List.__proto__ = IndexedCollection;
	    List.prototype = Object.create( IndexedCollection && IndexedCollection.prototype );
	    List.prototype.constructor = List;
	
	    List.of = function of (/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function toString () {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function get (index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function set (index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function remove (index) {
	      return !this.has(index)
	        ? this
	        : index === 0
	        ? this.shift()
	        : index === this.size - 1
	        ? this.pop()
	        : this.splice(index, 1);
	    };
	
	    List.prototype.insert = function insert (index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function clear () {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function push (/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function (list) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function pop () {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function unshift (/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function (list) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function shift () {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.concat = function concat (/*...collections*/) {
	      var arguments$1 = arguments;
	
	      var seqs = [];
	      for (var i = 0; i < arguments.length; i++) {
	        var argument = arguments$1[i];
	        var seq = IndexedCollection(
	          typeof argument !== 'string' && hasIterator(argument)
	            ? argument
	            : [argument]
	        );
	        if (seq.size !== 0) {
	          seqs.push(seq);
	        }
	      }
	      if (seqs.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && seqs.length === 1) {
	        return this.constructor(seqs[0]);
	      }
	      return this.withMutations(function (list) {
	        seqs.forEach(function (seq) { return seq.forEach(function (value) { return list.push(value); }); });
	      });
	    };
	
	    List.prototype.setSize = function setSize (size) {
	      return setListBounds(this, 0, size);
	    };
	
	    List.prototype.map = function map (mapper, context) {
	      var this$1$1 = this;
	
	      return this.withMutations(function (list) {
	        for (var i = 0; i < this$1$1.size; i++) {
	          list.set(i, mapper.call(context, list.get(i), i, this$1$1));
	        }
	      });
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function slice (begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function __iterator (type, reverse) {
	      var index = reverse ? this.size : 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function () {
	        var value = values();
	        return value === DONE
	          ? iteratorDone()
	          : iteratorValue(type, reverse ? --index : index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function __iterate (fn, reverse) {
	      var index = reverse ? this.size : 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, reverse ? --index : index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function __ensureOwner (ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        if (this.size === 0) {
	          return emptyList();
	        }
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeList(
	        this._origin,
	        this._capacity,
	        this._level,
	        this._root,
	        this._tail,
	        ownerID,
	        this.__hash
	      );
	    };
	
	    return List;
	  }(IndexedCollection));
	
	  List.isList = isList;
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SYMBOL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.merge = ListPrototype.concat;
	  ListPrototype.setIn = setIn;
	  ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
	  ListPrototype.update = update;
	  ListPrototype.updateIn = updateIn;
	  ListPrototype.mergeIn = mergeIn;
	  ListPrototype.mergeDeepIn = mergeDeepIn;
	  ListPrototype.withMutations = withMutations;
	  ListPrototype.wasAltered = wasAltered;
	  ListPrototype.asImmutable = asImmutable;
	  ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
	  ListPrototype['@@transducer/step'] = function (result, arr) {
	    return result.push(arr);
	  };
	  ListPrototype['@@transducer/result'] = function (obj) {
	    return obj.asImmutable();
	  };
	
	  var VNode = function VNode(array, ownerID) {
	    this.array = array;
	    this.ownerID = ownerID;
	  };
	
	  // TODO: seems like these methods are very similar
	
	  VNode.prototype.removeBefore = function removeBefore (ownerID, level, index) {
	    if (index === level ? 1 << level : this.array.length === 0) {
	      return this;
	    }
	    var originIndex = (index >>> level) & MASK;
	    if (originIndex >= this.array.length) {
	      return new VNode([], ownerID);
	    }
	    var removingFirst = originIndex === 0;
	    var newChild;
	    if (level > 0) {
	      var oldChild = this.array[originIndex];
	      newChild =
	        oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	      if (newChild === oldChild && removingFirst) {
	        return this;
	      }
	    }
	    if (removingFirst && !newChild) {
	      return this;
	    }
	    var editable = editableVNode(this, ownerID);
	    if (!removingFirst) {
	      for (var ii = 0; ii < originIndex; ii++) {
	        editable.array[ii] = undefined;
	      }
	    }
	    if (newChild) {
	      editable.array[originIndex] = newChild;
	    }
	    return editable;
	  };
	
	  VNode.prototype.removeAfter = function removeAfter (ownerID, level, index) {
	    if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	      return this;
	    }
	    var sizeIndex = ((index - 1) >>> level) & MASK;
	    if (sizeIndex >= this.array.length) {
	      return this;
	    }
	
	    var newChild;
	    if (level > 0) {
	      var oldChild = this.array[sizeIndex];
	      newChild =
	        oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	      if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	        return this;
	      }
	    }
	
	    var editable = editableVNode(this, ownerID);
	    editable.array.splice(sizeIndex + 1);
	    if (newChild) {
	      editable.array[sizeIndex] = newChild;
	    }
	    return editable;
	  };
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0
	        ? iterateLeaf(node, offset)
	        : iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function () {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function () {
	        while (true) {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx],
	            level - SHIFT,
	            offset + (idx << level)
	          );
	        }
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function (list) {
	        index < 0
	          ? setListBounds(list, index).set(0, value)
	          : setListBounds(list, 0, index + 1).set(index, value);
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef();
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(
	        newRoot,
	        list.__ownerID,
	        list._level,
	        index,
	        value,
	        didAlter
	      );
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(
	        lowerNode,
	        ownerID,
	        level - SHIFT,
	        index,
	        value,
	        didAlter
	      );
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    if (didAlter) {
	      SetRef(didAlter);
	    }
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin |= 0;
	    }
	    if (end !== undefined) {
	      end |= 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity =
	      end === undefined
	        ? oldCapacity
	        : end < 0
	        ? oldCapacity + end
	        : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(
	        newRoot && newRoot.array.length ? [undefined, newRoot] : [],
	        owner
	      );
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(
	        newRoot && newRoot.array.length ? [newRoot] : [],
	        owner
	      );
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail =
	      newTailOffset < oldTailOffset
	        ? listNodeFor(list, newCapacity - 1)
	        : newTailOffset > oldTailOffset
	        ? new VNode([], owner)
	        : oldTail;
	
	    // Merge Tail into tree.
	    if (
	      oldTail &&
	      newTailOffset > oldTailOffset &&
	      newOrigin < oldCapacity &&
	      oldTail.array.length
	    ) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	      // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if ((beginIndex !== newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(
	          owner,
	          newLevel,
	          newTailOffset - offsetShift
	        );
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : ((size - 1) >>> SHIFT) << SHIFT;
	  }
	
	  var OrderedMap = /*@__PURE__*/(function (Map) {
	    function OrderedMap(value) {
	      return value === undefined || value === null
	        ? emptyOrderedMap()
	        : isOrderedMap(value)
	        ? value
	        : emptyOrderedMap().withMutations(function (map) {
	            var iter = KeyedCollection(value);
	            assertNotInfinite(iter.size);
	            iter.forEach(function (v, k) { return map.set(k, v); });
	          });
	    }
	
	    if ( Map ) OrderedMap.__proto__ = Map;
	    OrderedMap.prototype = Object.create( Map && Map.prototype );
	    OrderedMap.prototype.constructor = OrderedMap;
	
	    OrderedMap.of = function of (/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function toString () {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function get (k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function clear () {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        this.__altered = true;
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function set (k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function remove (k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.__iterate = function __iterate (fn, reverse) {
	      var this$1$1 = this;
	
	      return this._list.__iterate(
	        function (entry) { return entry && fn(entry[1], entry[0], this$1$1); },
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function __iterator (type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function __ensureOwner (ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        if (this.size === 0) {
	          return emptyOrderedMap();
	        }
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	    return OrderedMap;
	  }(Map));
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    omap.__altered = false;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return (
	      EMPTY_ORDERED_MAP ||
	      (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()))
	    );
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) {
	      // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function (entry, idx) { return entry !== undefined && i !== idx; });
	        newMap = newList
	          .toKeyedSeq()
	          .map(function (entry) { return entry[0]; })
	          .flip()
	          .toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else if (has) {
	      if (v === list.get(i)[1]) {
	        return omap;
	      }
	      newMap = map;
	      newList = list.set(i, [k, v]);
	    } else {
	      newMap = map.set(k, list.size);
	      newList = list.set(list.size, [k, v]);
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      omap.__altered = true;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  var IS_STACK_SYMBOL = '@@__IMMUTABLE_STACK__@@';
	
	  function isStack(maybeStack) {
	    return Boolean(maybeStack && maybeStack[IS_STACK_SYMBOL]);
	  }
	
	  var Stack = /*@__PURE__*/(function (IndexedCollection) {
	    function Stack(value) {
	      return value === undefined || value === null
	        ? emptyStack()
	        : isStack(value)
	        ? value
	        : emptyStack().pushAll(value);
	    }
	
	    if ( IndexedCollection ) Stack.__proto__ = IndexedCollection;
	    Stack.prototype = Object.create( IndexedCollection && IndexedCollection.prototype );
	    Stack.prototype.constructor = Stack;
	
	    Stack.of = function of (/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function toString () {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function get (index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function peek () {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function push (/*...values*/) {
	      var arguments$1 = arguments;
	
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments$1[ii],
	          next: head,
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function pushAll (iter) {
	      iter = IndexedCollection(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      if (this.size === 0 && isStack(iter)) {
	        return iter;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.__iterate(function (value) {
	        newSize++;
	        head = {
	          value: value,
	          next: head,
	        };
	      }, /* reverse */ true);
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function pop () {
	      return this.slice(1);
	    };
	
	    Stack.prototype.clear = function clear () {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function slice (begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function __ensureOwner (ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        if (this.size === 0) {
	          return emptyStack();
	        }
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function __iterate (fn, reverse) {
	      var this$1$1 = this;
	
	      if (reverse) {
	        return new ArraySeq(this.toArray()).__iterate(
	          function (v, k) { return fn(v, k, this$1$1); },
	          reverse
	        );
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function __iterator (type, reverse) {
	      if (reverse) {
	        return new ArraySeq(this.toArray()).__iterator(type, reverse);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function () {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	    return Stack;
	  }(IndexedCollection));
	
	  Stack.isStack = isStack;
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SYMBOL] = true;
	  StackPrototype.shift = StackPrototype.pop;
	  StackPrototype.unshift = StackPrototype.push;
	  StackPrototype.unshiftAll = StackPrototype.pushAll;
	  StackPrototype.withMutations = withMutations;
	  StackPrototype.wasAltered = wasAltered;
	  StackPrototype.asImmutable = asImmutable;
	  StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
	  StackPrototype['@@transducer/step'] = function (result, arr) {
	    return result.unshift(arr);
	  };
	  StackPrototype['@@transducer/result'] = function (obj) {
	    return obj.asImmutable();
	  };
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  var IS_SET_SYMBOL = '@@__IMMUTABLE_SET__@@';
	
	  function isSet(maybeSet) {
	    return Boolean(maybeSet && maybeSet[IS_SET_SYMBOL]);
	  }
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isCollection(b) ||
	      (a.size !== undefined && b.size !== undefined && a.size !== b.size) ||
	      (a.__hash !== undefined &&
	        b.__hash !== undefined &&
	        a.__hash !== b.__hash) ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return (
	        b.every(function (v, k) {
	          var entry = entries.next().value;
	          return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	        }) && entries.next().done
	      );
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function (v, k) {
	      if (
	        notAssociative
	          ? !a.has(v)
	          : flipped
	          ? !is(v, a.get(k, NOT_SET))
	          : !is(a.get(k, NOT_SET), v)
	      ) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  function mixin(ctor, methods) {
	    var keyCopier = function (key) {
	      ctor.prototype[key] = methods[key];
	    };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  function toJS(value) {
	    if (!value || typeof value !== 'object') {
	      return value;
	    }
	    if (!isCollection(value)) {
	      if (!isDataStructure(value)) {
	        return value;
	      }
	      value = Seq(value);
	    }
	    if (isKeyed(value)) {
	      var result$1 = {};
	      value.__iterate(function (v, k) {
	        result$1[k] = toJS(v);
	      });
	      return result$1;
	    }
	    var result = [];
	    value.__iterate(function (v) {
	      result.push(toJS(v));
	    });
	    return result;
	  }
	
	  var Set = /*@__PURE__*/(function (SetCollection) {
	    function Set(value) {
	      return value === undefined || value === null
	        ? emptySet()
	        : isSet(value) && !isOrdered(value)
	        ? value
	        : emptySet().withMutations(function (set) {
	            var iter = SetCollection(value);
	            assertNotInfinite(iter.size);
	            iter.forEach(function (v) { return set.add(v); });
	          });
	    }
	
	    if ( SetCollection ) Set.__proto__ = SetCollection;
	    Set.prototype = Object.create( SetCollection && SetCollection.prototype );
	    Set.prototype.constructor = Set;
	
	    Set.of = function of (/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function fromKeys (value) {
	      return this(KeyedCollection(value).keySeq());
	    };
	
	    Set.intersect = function intersect (sets) {
	      sets = Collection(sets).toArray();
	      return sets.length
	        ? SetPrototype.intersect.apply(Set(sets.pop()), sets)
	        : emptySet();
	    };
	
	    Set.union = function union (sets) {
	      sets = Collection(sets).toArray();
	      return sets.length
	        ? SetPrototype.union.apply(Set(sets.pop()), sets)
	        : emptySet();
	    };
	
	    Set.prototype.toString = function toString () {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function has (value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function add (value) {
	      return updateSet(this, this._map.set(value, value));
	    };
	
	    Set.prototype.remove = function remove (value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function clear () {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.map = function map (mapper, context) {
	      var this$1$1 = this;
	
	      // keep track if the set is altered by the map function
	      var didChanges = false;
	
	      var newMap = updateSet(
	        this,
	        this._map.mapEntries(function (ref) {
	          var v = ref[1];
	
	          var mapped = mapper.call(context, v, v, this$1$1);
	
	          if (mapped !== v) {
	            didChanges = true;
	          }
	
	          return [mapped, mapped];
	        }, context)
	      );
	
	      return didChanges ? newMap : this;
	    };
	
	    Set.prototype.union = function union () {
	      var iters = [], len = arguments.length;
	      while ( len-- ) iters[ len ] = arguments[ len ];
	
	      iters = iters.filter(function (x) { return x.size !== 0; });
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function (set) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetCollection(iters[ii]).forEach(function (value) { return set.add(value); });
	        }
	      });
	    };
	
	    Set.prototype.intersect = function intersect () {
	      var iters = [], len = arguments.length;
	      while ( len-- ) iters[ len ] = arguments[ len ];
	
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function (iter) { return SetCollection(iter); });
	      var toRemove = [];
	      this.forEach(function (value) {
	        if (!iters.every(function (iter) { return iter.includes(value); })) {
	          toRemove.push(value);
	        }
	      });
	      return this.withMutations(function (set) {
	        toRemove.forEach(function (value) {
	          set.remove(value);
	        });
	      });
	    };
	
	    Set.prototype.subtract = function subtract () {
	      var iters = [], len = arguments.length;
	      while ( len-- ) iters[ len ] = arguments[ len ];
	
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function (iter) { return SetCollection(iter); });
	      var toRemove = [];
	      this.forEach(function (value) {
	        if (iters.some(function (iter) { return iter.includes(value); })) {
	          toRemove.push(value);
	        }
	      });
	      return this.withMutations(function (set) {
	        toRemove.forEach(function (value) {
	          set.remove(value);
	        });
	      });
	    };
	
	    Set.prototype.sort = function sort (comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function sortBy (mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function wasAltered () {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function __iterate (fn, reverse) {
	      var this$1$1 = this;
	
	      return this._map.__iterate(function (k) { return fn(k, k, this$1$1); }, reverse);
	    };
	
	    Set.prototype.__iterator = function __iterator (type, reverse) {
	      return this._map.__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function __ensureOwner (ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        if (this.size === 0) {
	          return this.__empty();
	        }
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	    return Set;
	  }(SetCollection));
	
	  Set.isSet = isSet;
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SYMBOL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
	  SetPrototype.withMutations = withMutations;
	  SetPrototype.asImmutable = asImmutable;
	  SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
	  SetPrototype['@@transducer/step'] = function (result, arr) {
	    return result.add(arr);
	  };
	  SetPrototype['@@transducer/result'] = function (obj) {
	    return obj.asImmutable();
	  };
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map
	      ? set
	      : newMap.size === 0
	      ? set.__empty()
	      : set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  /**
	   * Returns a lazy seq of nums from start (inclusive) to end
	   * (exclusive), by step, where start defaults to 0, step to 1, and end to
	   * infinity. When start is equal to end, returns empty list.
	   */
	  var Range = /*@__PURE__*/(function (IndexedSeq) {
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    if ( IndexedSeq ) Range.__proto__ = IndexedSeq;
	    Range.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
	    Range.prototype.constructor = Range;
	
	    Range.prototype.toString = function toString () {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return (
	        'Range [ ' +
	        this._start +
	        '...' +
	        this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	        ' ]'
	      );
	    };
	
	    Range.prototype.get = function get (index, notSetValue) {
	      return this.has(index)
	        ? this._start + wrapIndex(this, index) * this._step
	        : notSetValue;
	    };
	
	    Range.prototype.includes = function includes (searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return (
	        possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex)
	      );
	    };
	
	    Range.prototype.slice = function slice (begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(
	        this.get(begin, this._end),
	        this.get(end, this._end),
	        this._step
	      );
	    };
	
	    Range.prototype.indexOf = function indexOf (searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index;
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function lastIndexOf (searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function __iterate (fn, reverse) {
	      var size = this.size;
	      var step = this._step;
	      var value = reverse ? this._start + (size - 1) * step : this._start;
	      var i = 0;
	      while (i !== size) {
	        if (fn(value, reverse ? size - ++i : i++, this) === false) {
	          break;
	        }
	        value += reverse ? -step : step;
	      }
	      return i;
	    };
	
	    Range.prototype.__iterator = function __iterator (type, reverse) {
	      var size = this.size;
	      var step = this._step;
	      var value = reverse ? this._start + (size - 1) * step : this._start;
	      var i = 0;
	      return new Iterator(function () {
	        if (i === size) {
	          return iteratorDone();
	        }
	        var v = value;
	        value += reverse ? -step : step;
	        return iteratorValue(type, reverse ? size - ++i : i++, v);
	      });
	    };
	
	    Range.prototype.equals = function equals (other) {
	      return other instanceof Range
	        ? this._start === other._start &&
	            this._end === other._end &&
	            this._step === other._step
	        : deepEqual(this, other);
	    };
	
	    return Range;
	  }(IndexedSeq));
	
	  var EMPTY_RANGE;
	
	  function getIn$1(collection, searchKeyPath, notSetValue) {
	    var keyPath = coerceKeyPath(searchKeyPath);
	    var i = 0;
	    while (i !== keyPath.length) {
	      collection = get(collection, keyPath[i++], NOT_SET);
	      if (collection === NOT_SET) {
	        return notSetValue;
	      }
	    }
	    return collection;
	  }
	
	  function getIn(searchKeyPath, notSetValue) {
	    return getIn$1(this, searchKeyPath, notSetValue);
	  }
	
	  function hasIn$1(collection, keyPath) {
	    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
	  }
	
	  function hasIn(searchKeyPath) {
	    return hasIn$1(this, searchKeyPath);
	  }
	
	  function toObject() {
	    assertNotInfinite(this.size);
	    var object = {};
	    this.__iterate(function (v, k) {
	      object[k] = v;
	    });
	    return object;
	  }
	
	  // Note: all of these methods are deprecated.
	  Collection.isIterable = isCollection;
	  Collection.isKeyed = isKeyed;
	  Collection.isIndexed = isIndexed;
	  Collection.isAssociative = isAssociative;
	  Collection.isOrdered = isOrdered;
	
	  Collection.Iterator = Iterator;
	
	  mixin(Collection, {
	    // ### Conversion to other types
	
	    toArray: function toArray() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      var useTuples = isKeyed(this);
	      var i = 0;
	      this.__iterate(function (v, k) {
	        // Keyed collections produce an array of tuples.
	        array[i++] = useTuples ? [k, v] : v;
	      });
	      return array;
	    },
	
	    toIndexedSeq: function toIndexedSeq() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function toJS$1() {
	      return toJS(this);
	    },
	
	    toKeyedSeq: function toKeyedSeq() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function toMap() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: toObject,
	
	    toOrderedMap: function toOrderedMap() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function toOrderedSet() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function toSet() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function toSetSeq() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function toSeq() {
	      return isIndexed(this)
	        ? this.toIndexedSeq()
	        : isKeyed(this)
	        ? this.toKeyedSeq()
	        : this.toSetSeq();
	    },
	
	    toStack: function toStack() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function toList() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    // ### Common JavaScript methods and properties
	
	    toString: function toString() {
	      return '[Collection]';
	    },
	
	    __toString: function __toString(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return (
	        head +
	        ' ' +
	        this.toSeq().map(this.__toStringMapper).join(', ') +
	        ' ' +
	        tail
	      );
	    },
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function concat() {
	      var values = [], len = arguments.length;
	      while ( len-- ) values[ len ] = arguments[ len ];
	
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function includes(searchValue) {
	      return this.some(function (value) { return is(value, searchValue); });
	    },
	
	    entries: function entries() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function every(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function (v, k, c) {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function filter(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function find(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function forEach(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function join(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function (v) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function keys() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function map(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function reduce$1(reducer, initialReduction, context) {
	      return reduce(
	        this,
	        reducer,
	        initialReduction,
	        context,
	        arguments.length < 2,
	        false
	      );
	    },
	
	    reduceRight: function reduceRight(reducer, initialReduction, context) {
	      return reduce(
	        this,
	        reducer,
	        initialReduction,
	        context,
	        arguments.length < 2,
	        true
	      );
	    },
	
	    reverse: function reverse() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function slice(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function some(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function sort(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function values() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	    // ### More sequential methods
	
	    butLast: function butLast() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function isEmpty() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function () { return true; });
	    },
	
	    count: function count(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function countBy(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function equals(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function entrySeq() {
	      var collection = this;
	      if (collection._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(collection._cache);
	      }
	      var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function () { return collection.toSeq(); };
	      return entriesSequence;
	    },
	
	    filterNot: function filterNot(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function findEntry(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function (v, k, c) {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function findKey(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function findLast(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
	      return this.toKeyedSeq()
	        .reverse()
	        .findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function findLastKey(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function first(notSetValue) {
	      return this.find(returnTrue, null, notSetValue);
	    },
	
	    flatMap: function flatMap(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function flatten(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function fromEntrySeq() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function get(searchKey, notSetValue) {
	      return this.find(function (_, key) { return is(key, searchKey); }, undefined, notSetValue);
	    },
	
	    getIn: getIn,
	
	    groupBy: function groupBy(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function has(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: hasIn,
	
	    isSubset: function isSubset(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Collection(iter);
	      return this.every(function (value) { return iter.includes(value); });
	    },
	
	    isSuperset: function isSuperset(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function keyOf(searchValue) {
	      return this.findKey(function (value) { return is(value, searchValue); });
	    },
	
	    keySeq: function keySeq() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function last(notSetValue) {
	      return this.toSeq().reverse().first(notSetValue);
	    },
	
	    lastKeyOf: function lastKeyOf(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function max(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function maxBy(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function min(comparator) {
	      return maxFactory(
	        this,
	        comparator ? neg(comparator) : defaultNegComparator
	      );
	    },
	
	    minBy: function minBy(mapper, comparator) {
	      return maxFactory(
	        this,
	        comparator ? neg(comparator) : defaultNegComparator,
	        mapper
	      );
	    },
	
	    rest: function rest() {
	      return this.slice(1);
	    },
	
	    skip: function skip(amount) {
	      return amount === 0 ? this : this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function skipLast(amount) {
	      return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
	    },
	
	    skipWhile: function skipWhile(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function skipUntil(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function sortBy(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function take(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function takeLast(amount) {
	      return this.slice(-Math.max(0, amount));
	    },
	
	    takeWhile: function takeWhile(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function takeUntil(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    update: function update(fn) {
	      return fn(this);
	    },
	
	    valueSeq: function valueSeq() {
	      return this.toIndexedSeq();
	    },
	
	    // ### Hashable Object
	
	    hashCode: function hashCode() {
	      return this.__hash || (this.__hash = hashCollection(this));
	    },
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  var CollectionPrototype = Collection.prototype;
	  CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
	  CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
	  CollectionPrototype.toJSON = CollectionPrototype.toArray;
	  CollectionPrototype.__toStringMapper = quoteString;
	  CollectionPrototype.inspect = CollectionPrototype.toSource = function () {
	    return this.toString();
	  };
	  CollectionPrototype.chain = CollectionPrototype.flatMap;
	  CollectionPrototype.contains = CollectionPrototype.includes;
	
	  mixin(KeyedCollection, {
	    // ### More sequential methods
	
	    flip: function flip() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function mapEntries(mapper, context) {
	      var this$1$1 = this;
	
	      var iterations = 0;
	      return reify(
	        this,
	        this.toSeq()
	          .map(function (v, k) { return mapper.call(context, [k, v], iterations++, this$1$1); })
	          .fromEntrySeq()
	      );
	    },
	
	    mapKeys: function mapKeys(mapper, context) {
	      var this$1$1 = this;
	
	      return reify(
	        this,
	        this.toSeq()
	          .flip()
	          .map(function (k, v) { return mapper.call(context, k, v, this$1$1); })
	          .flip()
	      );
	    },
	  });
	
	  var KeyedCollectionPrototype = KeyedCollection.prototype;
	  KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
	  KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
	  KeyedCollectionPrototype.toJSON = toObject;
	  KeyedCollectionPrototype.__toStringMapper = function (v, k) { return quoteString(k) + ': ' + quoteString(v); };
	
	  mixin(IndexedCollection, {
	    // ### Conversion to other types
	
	    toKeyedSeq: function toKeyedSeq() {
	      return new ToKeyedSequence(this, false);
	    },
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function filter(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function findIndex(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function indexOf(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function lastIndexOf(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function reverse() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function slice(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function splice(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum || 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1
	          ? spliced
	          : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	    // ### More collection methods
	
	    findLastIndex: function findLastIndex(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function first(notSetValue) {
	      return this.get(0, notSetValue);
	    },
	
	    flatten: function flatten(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function get(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return index < 0 ||
	        this.size === Infinity ||
	        (this.size !== undefined && index > this.size)
	        ? notSetValue
	        : this.find(function (_, key) { return key === index; }, undefined, notSetValue);
	    },
	
	    has: function has(index) {
	      index = wrapIndex(this, index);
	      return (
	        index >= 0 &&
	        (this.size !== undefined
	          ? this.size === Infinity || index < this.size
	          : this.indexOf(index) !== -1)
	      );
	    },
	
	    interpose: function interpose(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function interleave(/*...collections*/) {
	      var collections = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * collections.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function keySeq() {
	      return Range(0, this.size);
	    },
	
	    last: function last(notSetValue) {
	      return this.get(-1, notSetValue);
	    },
	
	    skipWhile: function skipWhile(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function zip(/*, ...collections */) {
	      var collections = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, collections));
	    },
	
	    zipAll: function zipAll(/*, ...collections */) {
	      var collections = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, collections, true));
	    },
	
	    zipWith: function zipWith(zipper /*, ...collections */) {
	      var collections = arrCopy(arguments);
	      collections[0] = this;
	      return reify(this, zipWithFactory(this, zipper, collections));
	    },
	  });
	
	  var IndexedCollectionPrototype = IndexedCollection.prototype;
	  IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
	  IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;
	
	  mixin(SetCollection, {
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function get(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function includes(value) {
	      return this.has(value);
	    },
	
	    // ### More sequential methods
	
	    keySeq: function keySeq() {
	      return this.valueSeq();
	    },
	  });
	
	  var SetCollectionPrototype = SetCollection.prototype;
	  SetCollectionPrototype.has = CollectionPrototype.includes;
	  SetCollectionPrototype.contains = SetCollectionPrototype.includes;
	  SetCollectionPrototype.keys = SetCollectionPrototype.values;
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedCollectionPrototype);
	  mixin(IndexedSeq, IndexedCollectionPrototype);
	  mixin(SetSeq, SetCollectionPrototype);
	
	  // #pragma Helper functions
	
	  function reduce(collection, reducer, reduction, context, useFirst, reverse) {
	    assertNotInfinite(collection.size);
	    collection.__iterate(function (v, k, c) {
	      if (useFirst) {
	        useFirst = false;
	        reduction = v;
	      } else {
	        reduction = reducer.call(context, reduction, v, k, c);
	      }
	    }, reverse);
	    return reduction;
	  }
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function () {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  function neg(predicate) {
	    return function () {
	      return -predicate.apply(this, arguments);
	    };
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashCollection(collection) {
	    if (collection.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(collection);
	    var keyed = isKeyed(collection);
	    var h = ordered ? 1 : 0;
	    var size = collection.__iterate(
	      keyed
	        ? ordered
	          ? function (v, k) {
	              h = (31 * h + hashMerge(hash(v), hash(k))) | 0;
	            }
	          : function (v, k) {
	              h = (h + hashMerge(hash(v), hash(k))) | 0;
	            }
	        : ordered
	        ? function (v) {
	            h = (31 * h + hash(v)) | 0;
	          }
	        : function (v) {
	            h = (h + hash(v)) | 0;
	          }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xcc9e2d51);
	    h = imul((h << 15) | (h >>> -15), 0x1b873593);
	    h = imul((h << 13) | (h >>> -13), 5);
	    h = ((h + 0xe6546b64) | 0) ^ size;
	    h = imul(h ^ (h >>> 16), 0x85ebca6b);
	    h = imul(h ^ (h >>> 13), 0xc2b2ae35);
	    h = smi(h ^ (h >>> 16));
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return (a ^ (b + 0x9e3779b9 + (a << 6) + (a >> 2))) | 0; // int
	  }
	
	  var OrderedSet = /*@__PURE__*/(function (Set) {
	    function OrderedSet(value) {
	      return value === undefined || value === null
	        ? emptyOrderedSet()
	        : isOrderedSet(value)
	        ? value
	        : emptyOrderedSet().withMutations(function (set) {
	            var iter = SetCollection(value);
	            assertNotInfinite(iter.size);
	            iter.forEach(function (v) { return set.add(v); });
	          });
	    }
	
	    if ( Set ) OrderedSet.__proto__ = Set;
	    OrderedSet.prototype = Object.create( Set && Set.prototype );
	    OrderedSet.prototype.constructor = OrderedSet;
	
	    OrderedSet.of = function of (/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function fromKeys (value) {
	      return this(KeyedCollection(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function toString () {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	    return OrderedSet;
	  }(Set));
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
	  OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
	  OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
	  OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return (
	      EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()))
	    );
	  }
	
	  function throwOnInvalidDefaultValues(defaultValues) {
	    if (isRecord(defaultValues)) {
	      throw new Error(
	        'Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.'
	      );
	    }
	
	    if (isImmutable(defaultValues)) {
	      throw new Error(
	        'Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.'
	      );
	    }
	
	    if (defaultValues === null || typeof defaultValues !== 'object') {
	      throw new Error(
	        'Can not call `Record` with a non-object as default values. Use a plain javascript object instead.'
	      );
	    }
	  }
	
	  var Record = function Record(defaultValues, name) {
	    var hasInitialized;
	
	    throwOnInvalidDefaultValues(defaultValues);
	
	    var RecordType = function Record(values) {
	      var this$1$1 = this;
	
	      if (values instanceof RecordType) {
	        return values;
	      }
	      if (!(this instanceof RecordType)) {
	        return new RecordType(values);
	      }
	      if (!hasInitialized) {
	        hasInitialized = true;
	        var keys = Object.keys(defaultValues);
	        var indices = (RecordTypePrototype._indices = {});
	        // Deprecated: left to attempt not to break any external code which
	        // relies on a ._name property existing on record instances.
	        // Use Record.getDescriptiveName() instead
	        RecordTypePrototype._name = name;
	        RecordTypePrototype._keys = keys;
	        RecordTypePrototype._defaultValues = defaultValues;
	        for (var i = 0; i < keys.length; i++) {
	          var propName = keys[i];
	          indices[propName] = i;
	          if (RecordTypePrototype[propName]) {
	            /* eslint-disable no-console */
	            typeof console === 'object' &&
	              console.warn &&
	              console.warn(
	                'Cannot define ' +
	                  recordName(this) +
	                  ' with property "' +
	                  propName +
	                  '" since that property name is part of the Record API.'
	              );
	            /* eslint-enable no-console */
	          } else {
	            setProp(RecordTypePrototype, propName);
	          }
	        }
	      }
	      this.__ownerID = undefined;
	      this._values = List().withMutations(function (l) {
	        l.setSize(this$1$1._keys.length);
	        KeyedCollection(values).forEach(function (v, k) {
	          l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
	        });
	      });
	      return this;
	    };
	
	    var RecordTypePrototype = (RecordType.prototype =
	      Object.create(RecordPrototype));
	    RecordTypePrototype.constructor = RecordType;
	
	    if (name) {
	      RecordType.displayName = name;
	    }
	
	    return RecordType;
	  };
	
	  Record.prototype.toString = function toString () {
	    var str = recordName(this) + ' { ';
	    var keys = this._keys;
	    var k;
	    for (var i = 0, l = keys.length; i !== l; i++) {
	      k = keys[i];
	      str += (i ? ', ' : '') + k + ': ' + quoteString(this.get(k));
	    }
	    return str + ' }';
	  };
	
	  Record.prototype.equals = function equals (other) {
	    return (
	      this === other ||
	      (isRecord(other) && recordSeq(this).equals(recordSeq(other)))
	    );
	  };
	
	  Record.prototype.hashCode = function hashCode () {
	    return recordSeq(this).hashCode();
	  };
	
	  // @pragma Access
	
	  Record.prototype.has = function has (k) {
	    return this._indices.hasOwnProperty(k);
	  };
	
	  Record.prototype.get = function get (k, notSetValue) {
	    if (!this.has(k)) {
	      return notSetValue;
	    }
	    var index = this._indices[k];
	    var value = this._values.get(index);
	    return value === undefined ? this._defaultValues[k] : value;
	  };
	
	  // @pragma Modification
	
	  Record.prototype.set = function set (k, v) {
	    if (this.has(k)) {
	      var newValues = this._values.set(
	        this._indices[k],
	        v === this._defaultValues[k] ? undefined : v
	      );
	      if (newValues !== this._values && !this.__ownerID) {
	        return makeRecord(this, newValues);
	      }
	    }
	    return this;
	  };
	
	  Record.prototype.remove = function remove (k) {
	    return this.set(k);
	  };
	
	  Record.prototype.clear = function clear () {
	    var newValues = this._values.clear().setSize(this._keys.length);
	
	    return this.__ownerID ? this : makeRecord(this, newValues);
	  };
	
	  Record.prototype.wasAltered = function wasAltered () {
	    return this._values.wasAltered();
	  };
	
	  Record.prototype.toSeq = function toSeq () {
	    return recordSeq(this);
	  };
	
	  Record.prototype.toJS = function toJS$1 () {
	    return toJS(this);
	  };
	
	  Record.prototype.entries = function entries () {
	    return this.__iterator(ITERATE_ENTRIES);
	  };
	
	  Record.prototype.__iterator = function __iterator (type, reverse) {
	    return recordSeq(this).__iterator(type, reverse);
	  };
	
	  Record.prototype.__iterate = function __iterate (fn, reverse) {
	    return recordSeq(this).__iterate(fn, reverse);
	  };
	
	  Record.prototype.__ensureOwner = function __ensureOwner (ownerID) {
	    if (ownerID === this.__ownerID) {
	      return this;
	    }
	    var newValues = this._values.__ensureOwner(ownerID);
	    if (!ownerID) {
	      this.__ownerID = ownerID;
	      this._values = newValues;
	      return this;
	    }
	    return makeRecord(this, newValues, ownerID);
	  };
	
	  Record.isRecord = isRecord;
	  Record.getDescriptiveName = recordName;
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[IS_RECORD_SYMBOL] = true;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
	  RecordPrototype.getIn = getIn;
	  RecordPrototype.hasIn = CollectionPrototype.hasIn;
	  RecordPrototype.merge = merge$1;
	  RecordPrototype.mergeWith = mergeWith$1;
	  RecordPrototype.mergeIn = mergeIn;
	  RecordPrototype.mergeDeep = mergeDeep;
	  RecordPrototype.mergeDeepWith = mergeDeepWith;
	  RecordPrototype.mergeDeepIn = mergeDeepIn;
	  RecordPrototype.setIn = setIn;
	  RecordPrototype.update = update;
	  RecordPrototype.updateIn = updateIn;
	  RecordPrototype.withMutations = withMutations;
	  RecordPrototype.asMutable = asMutable;
	  RecordPrototype.asImmutable = asImmutable;
	  RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
	  RecordPrototype.toJSON = RecordPrototype.toObject =
	    CollectionPrototype.toObject;
	  RecordPrototype.inspect = RecordPrototype.toSource = function () {
	    return this.toString();
	  };
	
	  function makeRecord(likeRecord, values, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._values = values;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record.constructor.displayName || record.constructor.name || 'Record';
	  }
	
	  function recordSeq(record) {
	    return keyedSeqFromValue(record._keys.map(function (k) { return [k, record.get(k)]; }));
	  }
	
	  function setProp(prototype, name) {
	    try {
	      Object.defineProperty(prototype, name, {
	        get: function () {
	          return this.get(name);
	        },
	        set: function (value) {
	          invariant(this.__ownerID, 'Cannot set on an immutable record.');
	          this.set(name, value);
	        },
	      });
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  /**
	   * Returns a lazy Seq of `value` repeated `times` times. When `times` is
	   * undefined, returns an infinite sequence of `value`.
	   */
	  var Repeat = /*@__PURE__*/(function (IndexedSeq) {
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    if ( IndexedSeq ) Repeat.__proto__ = IndexedSeq;
	    Repeat.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
	    Repeat.prototype.constructor = Repeat;
	
	    Repeat.prototype.toString = function toString () {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function get (index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function includes (searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function slice (begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size)
	        ? this
	        : new Repeat(
	            this._value,
	            resolveEnd(end, size) - resolveBegin(begin, size)
	          );
	    };
	
	    Repeat.prototype.reverse = function reverse () {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function indexOf (searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function lastIndexOf (searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function __iterate (fn, reverse) {
	      var size = this.size;
	      var i = 0;
	      while (i !== size) {
	        if (fn(this._value, reverse ? size - ++i : i++, this) === false) {
	          break;
	        }
	      }
	      return i;
	    };
	
	    Repeat.prototype.__iterator = function __iterator (type, reverse) {
	      var this$1$1 = this;
	
	      var size = this.size;
	      var i = 0;
	      return new Iterator(function () { return i === size
	          ? iteratorDone()
	          : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value); }
	      );
	    };
	
	    Repeat.prototype.equals = function equals (other) {
	      return other instanceof Repeat
	        ? is(this._value, other._value)
	        : deepEqual(other);
	    };
	
	    return Repeat;
	  }(IndexedSeq));
	
	  var EMPTY_REPEAT;
	
	  function fromJS(value, converter) {
	    return fromJSWith(
	      [],
	      converter || defaultConverter,
	      value,
	      '',
	      converter && converter.length > 2 ? [] : undefined,
	      { '': value }
	    );
	  }
	
	  function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
	    if (
	      typeof value !== 'string' &&
	      !isImmutable(value) &&
	      (isArrayLike(value) || hasIterator(value) || isPlainObject(value))
	    ) {
	      if (~stack.indexOf(value)) {
	        throw new TypeError('Cannot convert circular structure to Immutable');
	      }
	      stack.push(value);
	      keyPath && key !== '' && keyPath.push(key);
	      var converted = converter.call(
	        parentValue,
	        key,
	        Seq(value).map(function (v, k) { return fromJSWith(stack, converter, v, k, keyPath, value); }
	        ),
	        keyPath && keyPath.slice()
	      );
	      stack.pop();
	      keyPath && keyPath.pop();
	      return converted;
	    }
	    return value;
	  }
	
	  function defaultConverter(k, v) {
	    // Effectively the opposite of "Collection.toSeq()"
	    return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
	  }
	
	  var version = "4.1.0";
	
	  var Immutable = {
	    version: version,
	
	    Collection: Collection,
	    // Note: Iterable is deprecated
	    Iterable: Collection,
	
	    Seq: Seq,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS,
	    hash: hash,
	
	    isImmutable: isImmutable,
	    isCollection: isCollection,
	    isKeyed: isKeyed,
	    isIndexed: isIndexed,
	    isAssociative: isAssociative,
	    isOrdered: isOrdered,
	    isValueObject: isValueObject,
	    isPlainObject: isPlainObject,
	    isSeq: isSeq,
	    isList: isList,
	    isMap: isMap,
	    isOrderedMap: isOrderedMap,
	    isStack: isStack,
	    isSet: isSet,
	    isOrderedSet: isOrderedSet,
	    isRecord: isRecord,
	
	    get: get,
	    getIn: getIn$1,
	    has: has,
	    hasIn: hasIn$1,
	    merge: merge,
	    mergeDeep: mergeDeep$1,
	    mergeWith: mergeWith,
	    mergeDeepWith: mergeDeepWith$1,
	    remove: remove,
	    removeIn: removeIn,
	    set: set,
	    setIn: setIn$1,
	    update: update$1,
	    updateIn: updateIn$1,
	  };
	
	  // Note: Iterable is deprecated
	  var Iterable = Collection;
	
	  exports.Collection = Collection;
	  exports.Iterable = Iterable;
	  exports.List = List;
	  exports.Map = Map;
	  exports.OrderedMap = OrderedMap;
	  exports.OrderedSet = OrderedSet;
	  exports.Range = Range;
	  exports.Record = Record;
	  exports.Repeat = Repeat;
	  exports.Seq = Seq;
	  exports.Set = Set;
	  exports.Stack = Stack;
	  exports.default = Immutable;
	  exports.fromJS = fromJS;
	  exports.get = get;
	  exports.getIn = getIn$1;
	  exports.has = has;
	  exports.hasIn = hasIn$1;
	  exports.hash = hash;
	  exports.is = is;
	  exports.isAssociative = isAssociative;
	  exports.isCollection = isCollection;
	  exports.isImmutable = isImmutable;
	  exports.isIndexed = isIndexed;
	  exports.isKeyed = isKeyed;
	  exports.isList = isList;
	  exports.isMap = isMap;
	  exports.isOrdered = isOrdered;
	  exports.isOrderedMap = isOrderedMap;
	  exports.isOrderedSet = isOrderedSet;
	  exports.isPlainObject = isPlainObject;
	  exports.isRecord = isRecord;
	  exports.isSeq = isSeq;
	  exports.isSet = isSet;
	  exports.isStack = isStack;
	  exports.isValueObject = isValueObject;
	  exports.merge = merge;
	  exports.mergeDeep = mergeDeep$1;
	  exports.mergeDeepWith = mergeDeepWith$1;
	  exports.mergeWith = mergeWith;
	  exports.remove = remove;
	  exports.removeIn = removeIn;
	  exports.set = set;
	  exports.setIn = setIn$1;
	  exports.update = update$1;
	  exports.updateIn = updateIn$1;
	  exports.version = version;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(238)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "SubMenu", {
	  enumerable: true,
	  get: function get() {
	    return _SubMenu.default;
	  }
	});
	Object.defineProperty(exports, "Item", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuItemGroup", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItemGroup.default;
	  }
	});
	Object.defineProperty(exports, "ItemGroup", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItemGroup.default;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	exports.default = void 0;
	
	var _Menu = _interopRequireDefault(__webpack_require__(256));
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(87));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(257));
	
	var _MenuItemGroup = _interopRequireDefault(__webpack_require__(258));
	
	var _Divider = _interopRequireDefault(__webpack_require__(255));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Menu.default;
	exports.default = _default;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _contains = __webpack_require__(55);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(54);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ContainerRender = __webpack_require__(95);
	
	var _ContainerRender2 = _interopRequireDefault(_ContainerRender);
	
	var _Portal = __webpack_require__(97);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(94);
	
	var _Popup = __webpack_require__(276);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var contextTypes = {
	  rcTrigger: _propTypes2['default'].shape({
	    onPopupMouseDown: _propTypes2['default'].func
	  })
	};
	
	var Trigger = function (_React$Component) {
	  (0, _inherits3['default'])(Trigger, _React$Component);
	
	  function Trigger(props) {
	    (0, _classCallCheck3['default'])(this, Trigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    _this.state = {
	      prevPopupVisible: popupVisible,
	      popupVisible: popupVisible
	    };
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	    return _this;
	  }
	
	  Trigger.prototype.getChildContext = function getChildContext() {
	    return {
	      rcTrigger: {
	        onPopupMouseDown: this.onPopupMouseDown
	      }
	    };
	  };
	
	  Trigger.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  };
	
	  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	    clearTimeout(this.mouseDownTimeout);
	  };
	
	  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var popupVisible = _ref.popupVisible;
	
	    var newState = {};
	
	    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
	      newState.popupVisible = popupVisible;
	      newState.prevPopupVisible = prevState.popupVisible;
	    }
	
	    return newState;
	  };
	
	  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  };
	
	  Trigger.prototype.getPopupAlign = function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  };
	
	  /**
	   * @param popupVisible    Show or not the popup element
	   * @param event           SyntheticEvent, used for `pointAlign`
	   */
	  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
	    var alignPoint = this.props.alignPoint;
	    var prevPopupVisible = this.state.popupVisible;
	
	
	    this.clearDelayTimer();
	
	    if (prevPopupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	
	    // Always record the point position since mouseEnterDelay will delay the show
	    if (alignPoint && event) {
	      this.setPoint(event);
	    }
	  };
	
	  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible, point);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible, event);
	    }
	  };
	
	  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  };
	
	  Trigger.prototype.createTwoChains = function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  };
	
	  Trigger.prototype.isClickToShow = function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  };
	
	  Trigger.prototype.isClickToHide = function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  };
	
	  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  };
	
	  Trigger.prototype.isFocusToShow = function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  };
	
	  Trigger.prototype.isBlurToHide = function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  };
	
	  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  };
	
	  Trigger.prototype.fireEvents = function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  };
	
	  Trigger.prototype.close = function close() {
	    this.setPopupVisible(false);
	  };
	
	  Trigger.prototype.render = function render() {
	    var _this3 = this;
	
	    var popupVisible = this.state.popupVisible;
	    var _props8 = this.props,
	        children = _props8.children,
	        forceRender = _props8.forceRender,
	        alignPoint = _props8.alignPoint,
	        className = _props8.className;
	
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	      if (alignPoint) {
	        newChildProps.onMouseMove = this.onMouseMove;
	      }
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var childrenClassName = (0, _classnames2['default'])(child && child.props && child.props.className, className);
	    if (childrenClassName) {
	      newChildProps.className = childrenClassName;
	    }
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return _react2['default'].createElement(
	        _ContainerRender2['default'],
	        {
	          parent: this,
	          visible: popupVisible,
	          autoMount: false,
	          forceRender: forceRender,
	          getComponent: this.getComponent,
	          getContainer: this.getContainer
	        },
	        function (_ref2) {
	          var renderComponent = _ref2.renderComponent;
	
	          _this3.renderComponent = renderComponent;
	          return trigger;
	        }
	      );
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  };
	
	  return Trigger;
	}(_react2['default'].Component);
	
	Trigger.propTypes = {
	  children: _propTypes2['default'].any,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  showAction: _propTypes2['default'].any,
	  hideAction: _propTypes2['default'].any,
	  getPopupClassNameFromAlign: _propTypes2['default'].any,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  afterPopupVisibleChange: _propTypes2['default'].func,
	  popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  popupStyle: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  builtinPlacements: _propTypes2['default'].object,
	  popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  popupAnimation: _propTypes2['default'].any,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  zIndex: _propTypes2['default'].number,
	  focusDelay: _propTypes2['default'].number,
	  blurDelay: _propTypes2['default'].number,
	  getPopupContainer: _propTypes2['default'].func,
	  getDocument: _propTypes2['default'].func,
	  forceRender: _propTypes2['default'].bool,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  mask: _propTypes2['default'].bool,
	  maskClosable: _propTypes2['default'].bool,
	  onPopupAlign: _propTypes2['default'].func,
	  popupAlign: _propTypes2['default'].object,
	  popupVisible: _propTypes2['default'].bool,
	  defaultPopupVisible: _propTypes2['default'].bool,
	  maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  maskAnimation: _propTypes2['default'].string,
	  stretch: _propTypes2['default'].string,
	  alignPoint: _propTypes2['default'].bool // Maybe we can support user pass position in the future
	};
	Trigger.contextTypes = contextTypes;
	Trigger.childContextTypes = contextTypes;
	Trigger.defaultProps = {
	  prefixCls: 'rc-trigger-popup',
	  getPopupClassNameFromAlign: returnEmptyString,
	  getDocument: returnDocument,
	  onPopupVisibleChange: noop,
	  afterPopupVisibleChange: noop,
	  onPopupAlign: noop,
	  popupClassName: '',
	  mouseEnterDelay: 0,
	  mouseLeaveDelay: 0.1,
	  focusDelay: 0,
	  blurDelay: 0.15,
	  popupStyle: {},
	  destroyPopupOnHide: false,
	  popupAlign: {},
	  defaultPopupVisible: false,
	  mask: false,
	  maskClosable: true,
	  action: [],
	  showAction: [],
	  hideAction: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onMouseEnter = function (e) {
	    var mouseEnterDelay = _this4.props.mouseEnterDelay;
	
	    _this4.fireEvents('onMouseEnter', e);
	    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	  };
	
	  this.onMouseMove = function (e) {
	    _this4.fireEvents('onMouseMove', e);
	    _this4.setPoint(e);
	  };
	
	  this.onMouseLeave = function (e) {
	    _this4.fireEvents('onMouseLeave', e);
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onPopupMouseEnter = function () {
	    _this4.clearDelayTimer();
	  };
	
	  this.onPopupMouseLeave = function (e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && (0, _contains2['default'])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onFocus = function (e) {
	    _this4.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    _this4.clearDelayTimer();
	    if (_this4.isFocusToShow()) {
	      _this4.focusTime = Date.now();
	      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
	    }
	  };
	
	  this.onMouseDown = function (e) {
	    _this4.fireEvents('onMouseDown', e);
	    _this4.preClickTime = Date.now();
	  };
	
	  this.onTouchStart = function (e) {
	    _this4.fireEvents('onTouchStart', e);
	    _this4.preTouchTime = Date.now();
	  };
	
	  this.onBlur = function (e) {
	    _this4.fireEvents('onBlur', e);
	    _this4.clearDelayTimer();
	    if (_this4.isBlurToHide()) {
	      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
	    }
	  };
	
	  this.onContextMenu = function (e) {
	    e.preventDefault();
	    _this4.fireEvents('onContextMenu', e);
	    _this4.setPopupVisible(true, e);
	  };
	
	  this.onContextMenuClose = function () {
	    if (_this4.isContextMenuToShow()) {
	      _this4.close();
	    }
	  };
	
	  this.onClick = function (event) {
	    _this4.fireEvents('onClick', event);
	    // focus will trigger click
	    if (_this4.focusTime) {
	      var preTime = void 0;
	      if (_this4.preClickTime && _this4.preTouchTime) {
	        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
	      } else if (_this4.preClickTime) {
	        preTime = _this4.preClickTime;
	      } else if (_this4.preTouchTime) {
	        preTime = _this4.preTouchTime;
	      }
	      if (Math.abs(preTime - _this4.focusTime) < 20) {
	        return;
	      }
	      _this4.focusTime = 0;
	    }
	    _this4.preClickTime = 0;
	    _this4.preTouchTime = 0;
	
	    // Only prevent default when all the action is click.
	    // https://github.com/ant-design/ant-design/issues/17043
	    // https://github.com/ant-design/ant-design/issues/17291
	    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var nextVisible = !_this4.state.popupVisible;
	    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
	      _this4.setPopupVisible(!_this4.state.popupVisible, event);
	    }
	  };
	
	  this.onPopupMouseDown = function () {
	    var _context$rcTrigger = _this4.context.rcTrigger,
	        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
	
	    _this4.hasPopupMouseDown = true;
	
	    clearTimeout(_this4.mouseDownTimeout);
	    _this4.mouseDownTimeout = setTimeout(function () {
	      _this4.hasPopupMouseDown = false;
	    }, 0);
	
	    if (rcTrigger.onPopupMouseDown) {
	      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
	    }
	  };
	
	  this.onDocumentClick = function (event) {
	    if (_this4.props.mask && !_this4.props.maskClosable) {
	      return;
	    }
	
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(_this4);
	    if (!(0, _contains2['default'])(root, target) && !_this4.hasPopupMouseDown) {
	      _this4.close();
	    }
	  };
	
	  this.getRootDomNode = function () {
	    return (0, _reactDom.findDOMNode)(_this4);
	  };
	
	  this.getPopupClassNameFromAlign = function (align) {
	    var className = [];
	    var _props9 = _this4.props,
	        popupPlacement = _props9.popupPlacement,
	        builtinPlacements = _props9.builtinPlacements,
	        prefixCls = _props9.prefixCls,
	        alignPoint = _props9.alignPoint,
	        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	    }
	    if (getPopupClassNameFromAlign) {
	      className.push(getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  };
	
	  this.getComponent = function () {
	    var _props10 = _this4.props,
	        prefixCls = _props10.prefixCls,
	        destroyPopupOnHide = _props10.destroyPopupOnHide,
	        popupClassName = _props10.popupClassName,
	        action = _props10.action,
	        onPopupAlign = _props10.onPopupAlign,
	        popupAnimation = _props10.popupAnimation,
	        popupTransitionName = _props10.popupTransitionName,
	        popupStyle = _props10.popupStyle,
	        mask = _props10.mask,
	        maskAnimation = _props10.maskAnimation,
	        maskTransitionName = _props10.maskTransitionName,
	        zIndex = _props10.zIndex,
	        popup = _props10.popup,
	        stretch = _props10.stretch,
	        alignPoint = _props10.alignPoint;
	    var _state = _this4.state,
	        popupVisible = _state.popupVisible,
	        point = _state.point;
	
	
	    var align = _this4.getPopupAlign();
	
	    var mouseProps = {};
	    if (_this4.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
	    }
	    if (_this4.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
	    }
	
	    mouseProps.onMouseDown = _this4.onPopupMouseDown;
	    mouseProps.onTouchStart = _this4.onPopupMouseDown;
	
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: prefixCls,
	        destroyPopupOnHide: destroyPopupOnHide,
	        visible: popupVisible,
	        point: alignPoint && point,
	        className: popupClassName,
	        action: action,
	        align: align,
	        onAlign: onPopupAlign,
	        animation: popupAnimation,
	        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
	      }, mouseProps, {
	        stretch: stretch,
	        getRootDomNode: _this4.getRootDomNode,
	        style: popupStyle,
	        mask: mask,
	        zIndex: zIndex,
	        transitionName: popupTransitionName,
	        maskAnimation: maskAnimation,
	        maskTransitionName: maskTransitionName,
	        ref: _this4.savePopup
	      }),
	      typeof popup === 'function' ? popup() : popup
	    );
	  };
	
	  this.getContainer = function () {
	    var props = _this4.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this4)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  };
	
	  this.setPoint = function (point) {
	    var alignPoint = _this4.props.alignPoint;
	
	    if (!alignPoint || !point) return;
	
	    _this4.setState({
	      point: {
	        pageX: point.pageX,
	        pageY: point.pageY
	      }
	    });
	  };
	
	  this.handlePortalUpdate = function () {
	    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
	      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
	    }
	  };
	
	  this.savePopup = function (node) {
	    _this4._component = node;
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Trigger);
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addEventListenerWrap;
	
	var _addDomEventListener = _interopRequireDefault(__webpack_require__(119));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
	    _reactDom.default.unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener.default)(target, eventType, callback, option);
	}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	function contains(root, n) {
	  var node = n;
	
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	
	    node = node.parentNode;
	  }
	
	  return false;
	}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(166)
	var ieee754 = __webpack_require__(205)
	var isArray = __webpack_require__(323)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcDropdown = _interopRequireDefault(__webpack_require__(252));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _configProvider = __webpack_require__(7);
	
	var _warning = _interopRequireDefault(__webpack_require__(21));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	var _type = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');
	
	var Dropdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  var _super = _createSuper(Dropdown);
	
	  function Dropdown() {
	    var _this;
	
	    _classCallCheck(this, Dropdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderOverlay = function (prefixCls) {
	      // rc-dropdown already can process the function of overlay, but we have check logic here.
	      // So we need render the element to check and pass back to rc-dropdown.
	      var overlay = _this.props.overlay;
	      var overlayNode;
	
	      if (typeof overlay === 'function') {
	        overlayNode = overlay();
	      } else {
	        overlayNode = overlay;
	      }
	
	      overlayNode = React.Children.only(overlayNode);
	      var overlayProps = overlayNode.props; // Warning if use other mode
	
	      (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', 'Dropdown', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
	      // menu should be focusable in dropdown defaultly
	
	      var _overlayProps$selecta = overlayProps.selectable,
	          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
	          _overlayProps$focusab = overlayProps.focusable,
	          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
	      var expandIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-submenu-arrow")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
	      }));
	      var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlay : /*#__PURE__*/React.cloneElement(overlayNode, {
	        mode: 'vertical',
	        selectable: selectable,
	        focusable: focusable,
	        expandIcon: expandIcon
	      });
	      return fixedModeOverlay;
	    };
	
	    _this.renderDropDown = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          children = _this$props.children,
	          trigger = _this$props.trigger,
	          disabled = _this$props.disabled,
	          getPopupContainer = _this$props.getPopupContainer;
	      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
	      var child = React.Children.only(children);
	      var dropdownTrigger = /*#__PURE__*/React.cloneElement(child, {
	        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
	        disabled: disabled
	      });
	      var triggerActions = disabled ? [] : trigger;
	      var alignPoint;
	
	      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
	        alignPoint = true;
	      }
	
	      return /*#__PURE__*/React.createElement(_rcDropdown["default"], _extends({
	        alignPoint: alignPoint
	      }, _this.props, {
	        prefixCls: prefixCls,
	        getPopupContainer: getPopupContainer || getContextPopupContainer,
	        transitionName: _this.getTransitionName(),
	        trigger: triggerActions,
	        overlay: function overlay() {
	          return _this.renderOverlay(prefixCls);
	        }
	      }), dropdownTrigger);
	    };
	
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: "getTransitionName",
	    value: function getTransitionName() {
	      var _this$props2 = this.props,
	          _this$props2$placemen = _this$props2.placement,
	          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen,
	          transitionName = _this$props2.transitionName;
	
	      if (transitionName !== undefined) {
	        return transitionName;
	      }
	
	      if (placement.indexOf('top') >= 0) {
	        return 'slide-down';
	      }
	
	      return 'slide-up';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDropDown);
	    }
	  }]);
	
	  return Dropdown;
	}(React.Component);
	
	exports["default"] = Dropdown;
	Dropdown.defaultProps = {
	  mouseEnterDelay: 0.15,
	  mouseLeaveDelay: 0.1,
	  placement: 'bottomLeft'
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _dropdown = _interopRequireDefault(__webpack_require__(61));
	
	var _dropdownButton = _interopRequireDefault(__webpack_require__(126));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_dropdown["default"].Button = _dropdownButton["default"];
	var _default = _dropdown["default"];
	exports["default"] = _default;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(228);
	
	__webpack_require__(17);

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasPrefixSuffix = hasPrefixSuffix;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	var _type = __webpack_require__(31);
	
	var _Input = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ClearableInputType = (0, _type.tuple)('text', 'input');
	
	function hasPrefixSuffix(props) {
	  return !!(props.prefix || props.suffix || props.allowClear);
	}
	
	var ClearableLabeledInput = /*#__PURE__*/function (_React$Component) {
	  _inherits(ClearableLabeledInput, _React$Component);
	
	  var _super = _createSuper(ClearableLabeledInput);
	
	  function ClearableLabeledInput() {
	    _classCallCheck(this, ClearableLabeledInput);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ClearableLabeledInput, [{
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var _this$props = this.props,
	          allowClear = _this$props.allowClear,
	          value = _this$props.value,
	          disabled = _this$props.disabled,
	          readOnly = _this$props.readOnly,
	          inputType = _this$props.inputType,
	          handleReset = _this$props.handleReset;
	
	      if (!allowClear || disabled || readOnly || value === undefined || value === null || value === '') {
	        return null;
	      }
	
	      var className = inputType === ClearableInputType[0] ? "".concat(prefixCls, "-textarea-clear-icon") : "".concat(prefixCls, "-clear-icon");
	      return /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        onClick: handleReset,
	        className: className,
	        role: "button"
	      });
	    }
	  }, {
	    key: "renderSuffix",
	    value: function renderSuffix(prefixCls) {
	      var _this$props2 = this.props,
	          suffix = _this$props2.suffix,
	          allowClear = _this$props2.allowClear;
	
	      if (suffix || allowClear) {
	        return /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-suffix")
	        }, this.renderClearIcon(prefixCls), suffix);
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderLabeledIcon",
	    value: function renderLabeledIcon(prefixCls, element) {
	      var _classNames;
	
	      var props = this.props;
	      var suffix = this.renderSuffix(prefixCls);
	
	      if (!hasPrefixSuffix(props)) {
	        return /*#__PURE__*/React.cloneElement(element, {
	          value: props.value
	        });
	      }
	
	      var prefix = props.prefix ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-prefix")
	      }, props.prefix) : null;
	      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), props.suffix && props.allowClear && this.props.value), _classNames));
	      return /*#__PURE__*/React.createElement("span", {
	        className: affixWrapperCls,
	        style: props.style
	      }, prefix, /*#__PURE__*/React.cloneElement(element, {
	        style: null,
	        value: props.value,
	        className: (0, _Input.getInputClassName)(prefixCls, props.size, props.disabled)
	      }), suffix);
	    }
	  }, {
	    key: "renderInputWithLabel",
	    value: function renderInputWithLabel(prefixCls, labeledElement) {
	      var _classNames3;
	
	      var _this$props3 = this.props,
	          addonBefore = _this$props3.addonBefore,
	          addonAfter = _this$props3.addonAfter,
	          style = _this$props3.style,
	          size = _this$props3.size,
	          className = _this$props3.className; // Not wrap when there is not addons
	
	      if (!addonBefore && !addonAfter) {
	        return labeledElement;
	      }
	
	      var wrapperClassName = "".concat(prefixCls, "-group");
	      var addonClassName = "".concat(wrapperClassName, "-addon");
	      var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonBefore) : null;
	      var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonAfter) : null;
	      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
	      var mergedGroupClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
	      // and put style prop in wrapper
	
	      return /*#__PURE__*/React.createElement("span", {
	        className: mergedGroupClassName,
	        style: style
	      }, /*#__PURE__*/React.createElement("span", {
	        className: mergedWrapperClassName
	      }, addonBeforeNode, /*#__PURE__*/React.cloneElement(labeledElement, {
	        style: null
	      }), addonAfterNode));
	    }
	  }, {
	    key: "renderTextAreaWithClearIcon",
	    value: function renderTextAreaWithClearIcon(prefixCls, element) {
	      var _this$props4 = this.props,
	          value = _this$props4.value,
	          allowClear = _this$props4.allowClear,
	          className = _this$props4.className,
	          style = _this$props4.style;
	
	      if (!allowClear) {
	        return /*#__PURE__*/React.cloneElement(element, {
	          value: value
	        });
	      }
	
	      var affixWrapperCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"));
	      return /*#__PURE__*/React.createElement("span", {
	        className: affixWrapperCls,
	        style: style
	      }, /*#__PURE__*/React.cloneElement(element, {
	        style: null,
	        value: value
	      }), this.renderClearIcon(prefixCls));
	    }
	  }, {
	    key: "renderClearableLabeledInput",
	    value: function renderClearableLabeledInput() {
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          inputType = _this$props5.inputType,
	          element = _this$props5.element;
	
	      if (inputType === ClearableInputType[0]) {
	        return this.renderTextAreaWithClearIcon(prefixCls, element);
	      }
	
	      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderClearableLabeledInput();
	    }
	  }]);
	
	  return ClearableLabeledInput;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ClearableLabeledInput);
	var _default = ClearableLabeledInput;
	exports["default"] = _default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SiderContext = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(29));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _omit = _interopRequireDefault(__webpack_require__(22));
	
	var _layout = __webpack_require__(133);
	
	var _configProvider = __webpack_require__(7);
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	var _isNumeric = _interopRequireDefault(__webpack_require__(120));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	}
	
	var dimensionMaxMap = {
	  xs: '479.98px',
	  sm: '575.98px',
	  md: '767.98px',
	  lg: '991.98px',
	  xl: '1199.98px',
	  xxl: '1599.98px'
	};
	var SiderContext = (0, _createReactContext["default"])({});
	exports.SiderContext = SiderContext;
	
	var generateId = function () {
	  var i = 0;
	  return function () {
	    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    i += 1;
	    return "".concat(prefix).concat(i);
	  };
	}();
	
	var InternalSider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalSider, _React$Component);
	
	  var _super = _createSuper(InternalSider);
	
	  function InternalSider(props) {
	    var _this;
	
	    _classCallCheck(this, InternalSider);
	
	    _this = _super.call(this, props);
	
	    _this.responsiveHandler = function (mql) {
	      _this.setState({
	        below: mql.matches
	      });
	
	      var onBreakpoint = _this.props.onBreakpoint;
	
	      if (onBreakpoint) {
	        onBreakpoint(mql.matches);
	      }
	
	      if (_this.state.collapsed !== mql.matches) {
	        _this.setCollapsed(mql.matches, 'responsive');
	      }
	    };
	
	    _this.setCollapsed = function (collapsed, type) {
	      if (!('collapsed' in _this.props)) {
	        _this.setState({
	          collapsed: collapsed
	        });
	      }
	
	      var onCollapse = _this.props.onCollapse;
	
	      if (onCollapse) {
	        onCollapse(collapsed, type);
	      }
	    };
	
	    _this.toggle = function () {
	      var collapsed = !_this.state.collapsed;
	
	      _this.setCollapsed(collapsed, 'clickTrigger');
	    };
	
	    _this.belowShowChange = function () {
	      _this.setState(function (_ref) {
	        var belowShow = _ref.belowShow;
	        return {
	          belowShow: !belowShow
	        };
	      });
	    };
	
	    _this.renderSider = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          theme = _a.theme,
	          collapsible = _a.collapsible,
	          reverseArrow = _a.reverseArrow,
	          trigger = _a.trigger,
	          style = _a.style,
	          width = _a.width,
	          collapsedWidth = _a.collapsedWidth,
	          zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle,
	          others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth", "zeroWidthTriggerStyle"]);
	
	      var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
	      var divProps = (0, _omit["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint', 'siderHook', 'zeroWidthTriggerStyle']);
	      var rawWidth = _this.state.collapsed ? collapsedWidth : width; // use "px" as fallback unit for width
	
	      var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0
	
	      var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/React.createElement("span", {
	        onClick: _this.toggle,
	        className: "".concat(prefixCls, "-zero-width-trigger ").concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left'),
	        style: zeroWidthTriggerStyle
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "bars"
	      })) : null;
	      var iconObj = {
	        expanded: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }),
	        collapsed: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        })
	      };
	      var status = _this.state.collapsed ? 'collapsed' : 'expanded';
	      var defaultTrigger = iconObj[status];
	      var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-trigger"),
	        onClick: _this.toggle,
	        style: {
	          width: siderWidth
	        }
	      }, trigger || defaultTrigger) : null;
	
	      var divStyle = _extends(_extends({}, style), {
	        flex: "0 0 ".concat(siderWidth),
	        maxWidth: siderWidth,
	        minWidth: siderWidth,
	        width: siderWidth
	      });
	
	      var siderCls = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), !!_this.state.collapsed), _defineProperty(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty(_classNames, "".concat(prefixCls, "-below"), !!_this.state.below), _defineProperty(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames));
	      return /*#__PURE__*/React.createElement("aside", _extends({
	        className: siderCls
	      }, divProps, {
	        style: divStyle
	      }), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-children")
	      }, _this.props.children), collapsible || _this.state.below && zeroWidthTrigger ? triggerDom : null);
	    };
	
	    _this.uniqueId = generateId('ant-sider-');
	    var matchMedia;
	
	    if (typeof window !== 'undefined') {
	      matchMedia = window.matchMedia;
	    }
	
	    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMaxMap) {
	      _this.mql = matchMedia("(max-width: ".concat(dimensionMaxMap[props.breakpoint], ")"));
	    }
	
	    var collapsed;
	
	    if ('collapsed' in props) {
	      collapsed = props.collapsed;
	    } else {
	      collapsed = props.defaultCollapsed;
	    }
	
	    _this.state = {
	      collapsed: collapsed,
	      below: false
	    };
	    return _this;
	  }
	
	  _createClass(InternalSider, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.mql) {
	        this.mql.addListener(this.responsiveHandler);
	        this.responsiveHandler(this.mql);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.addSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.mql) {
	        this.mql.removeListener(this.responsiveHandler);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.removeSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var collapsed = this.state.collapsed;
	      var collapsedWidth = this.props.collapsedWidth;
	      return /*#__PURE__*/React.createElement(SiderContext.Provider, {
	        value: {
	          siderCollapsed: collapsed,
	          collapsedWidth: collapsedWidth
	        }
	      }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSider));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('collapsed' in nextProps) {
	        return {
	          collapsed: nextProps.collapsed
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return InternalSider;
	}(React.Component);
	
	InternalSider.defaultProps = {
	  collapsible: false,
	  defaultCollapsed: false,
	  reverseArrow: false,
	  width: 200,
	  collapsedWidth: 80,
	  style: {},
	  theme: 'dark'
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalSider); // eslint-disable-next-line react/prefer-stateless-function
	
	var Sider = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Sider, _React$Component2);
	
	  var _super2 = _createSuper(Sider);
	
	  function Sider() {
	    _classCallCheck(this, Sider);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Sider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return /*#__PURE__*/React.createElement(_layout.LayoutContext.Consumer, null, function (context) {
	        return /*#__PURE__*/React.createElement(InternalSider, _extends({}, context, _this2.props));
	      });
	    }
	  }]);
	
	  return Sider;
	}(React.Component);
	
	exports["default"] = Sider;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(52));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _omit = _interopRequireDefault(__webpack_require__(22));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(135));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(134));
	
	var _configProvider = __webpack_require__(7);
	
	var _warning = _interopRequireDefault(__webpack_require__(21));
	
	var _Sider = __webpack_require__(65);
	
	var _raf = _interopRequireDefault(__webpack_require__(36));
	
	var _motion = _interopRequireDefault(__webpack_require__(121));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(41));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var InternalMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalMenu, _React$Component);
	
	  var _super = _createSuper(InternalMenu);
	
	  function InternalMenu(props) {
	    var _this;
	
	    _classCallCheck(this, InternalMenu);
	
	    _this = _super.call(this, props); // Restore vertical mode when menu is collapsed responsively when mounted
	    // https://github.com/ant-design/ant-design/issues/13104
	    // TODO: not a perfect solution, looking a new way to avoid setting switchingModeFromInline in this situation
	
	    _this.handleMouseEnter = function (e) {
	      _this.restoreModeVerticalFromInline();
	
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(e);
	      }
	    };
	
	    _this.handleTransitionEnd = function (e) {
	      // when inlineCollapsed menu width animation finished
	      // https://github.com/ant-design/ant-design/issues/12864
	      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function
	      // https://github.com/ant-design/ant-design/issues/15699
	
	      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during an animation.
	
	      var classNameValue = Object.prototype.toString.call(className) === '[object SVGAnimatedString]' ? className.animVal : className; // Fix for <Menu style={{ width: '100%' }} />, the width transition won't trigger when menu is collapsed
	      // https://github.com/ant-design/ant-design-pro/issues/2783
	
	      var iconScaled = e.propertyName === 'font-size' && classNameValue.indexOf('anticon') >= 0;
	
	      if (widthCollapsed || iconScaled) {
	        _this.restoreModeVerticalFromInline();
	      }
	    };
	
	    _this.handleClick = function (e) {
	      _this.handleOpenChange([]);
	
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.handleOpenChange = function (openKeys) {
	      _this.setOpenKeys(openKeys);
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(openKeys);
	      }
	    };
	
	    _this.renderMenu = function (_ref) {
	      var getPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          theme = _this$props.theme,
	          collapsedWidth = _this$props.collapsedWidth;
	      var passProps = (0, _omit["default"])(_this.props, ['collapsedWidth', 'siderCollapsed']);
	
	      var menuMode = _this.getRealMenuMode();
	
	      var menuOpenMotion = _this.getOpenMotionProps(menuMode);
	
	      var prefixCls = getPrefixCls('menu', customizePrefixCls);
	      var menuClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()));
	
	      var menuProps = _extends({
	        openKeys: _this.state.openKeys,
	        onOpenChange: _this.handleOpenChange,
	        className: menuClassName,
	        mode: menuMode
	      }, menuOpenMotion);
	
	      if (menuMode !== 'inline') {
	        // closing vertical popup submenu after click it
	        menuProps.onClick = _this.handleClick;
	      } // https://github.com/ant-design/ant-design/issues/8587
	
	
	      var hideMenu = _this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px');
	
	      if (hideMenu) {
	        menuProps.openKeys = [];
	      }
	
	      return /*#__PURE__*/React.createElement(_rcMenu["default"], _extends({
	        getPopupContainer: getPopupContainer
	      }, passProps, menuProps, {
	        prefixCls: prefixCls,
	        onTransitionEnd: _this.handleTransitionEnd,
	        onMouseEnter: _this.handleMouseEnter
	      }));
	    };
	
	    (0, _warning["default"])(!('onOpen' in props || 'onClose' in props), 'Menu', '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
	    (0, _warning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
	    (0, _warning["default"])(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
	    var openKeys;
	
	    if ('openKeys' in props) {
	      openKeys = props.openKeys;
	    } else if ('defaultOpenKeys' in props) {
	      openKeys = props.defaultOpenKeys;
	    }
	
	    _this.state = {
	      openKeys: openKeys || [],
	      switchingModeFromInline: false,
	      inlineOpenKeys: [],
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(InternalMenu, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountRafId);
	    }
	  }, {
	    key: "setOpenKeys",
	    value: function setOpenKeys(openKeys) {
	      if (!('openKeys' in this.props)) {
	        this.setState({
	          openKeys: openKeys
	        });
	      }
	    }
	  }, {
	    key: "getRealMenuMode",
	    value: function getRealMenuMode() {
	      var inlineCollapsed = this.getInlineCollapsed();
	
	      if (this.state.switchingModeFromInline && inlineCollapsed) {
	        return 'inline';
	      }
	
	      var mode = this.props.mode;
	      return inlineCollapsed ? 'vertical' : mode;
	    }
	  }, {
	    key: "getInlineCollapsed",
	    value: function getInlineCollapsed() {
	      var inlineCollapsed = this.props.inlineCollapsed;
	
	      if (this.props.siderCollapsed !== undefined) {
	        return this.props.siderCollapsed;
	      }
	
	      return inlineCollapsed;
	    }
	  }, {
	    key: "getOpenMotionProps",
	    value: function getOpenMotionProps(menuMode) {
	      var _this$props2 = this.props,
	          openTransitionName = _this$props2.openTransitionName,
	          openAnimation = _this$props2.openAnimation,
	          motion = _this$props2.motion; // Provides by user
	
	      if (motion) {
	        return {
	          motion: motion
	        };
	      }
	
	      if (openAnimation) {
	        (0, _warning["default"])(typeof openAnimation === 'string', 'Menu', '`openAnimation` do not support object. Please use `motion` instead.');
	        return {
	          openAnimation: openAnimation
	        };
	      }
	
	      if (openTransitionName) {
	        return {
	          openTransitionName: openTransitionName
	        };
	      } // Default logic
	
	
	      if (menuMode === 'horizontal') {
	        return {
	          motion: {
	            motionName: 'slide-up'
	          }
	        };
	      }
	
	      if (menuMode === 'inline') {
	        return {
	          motion: _motion["default"]
	        };
	      } // When mode switch from inline
	      // submenu should hide without animation
	
	
	      return {
	        motion: {
	          motionName: this.state.switchingModeFromInline ? '' : 'zoom-big'
	        }
	      };
	    }
	  }, {
	    key: "restoreModeVerticalFromInline",
	    value: function restoreModeVerticalFromInline() {
	      var switchingModeFromInline = this.state.switchingModeFromInline;
	
	      if (switchingModeFromInline) {
	        this.setState({
	          switchingModeFromInline: false
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_MenuContext["default"].Provider, {
	        value: {
	          inlineCollapsed: this.getInlineCollapsed() || false,
	          antdMenuTheme: this.props.theme
	        }
	      }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if (prevProps.mode === 'inline' && nextProps.mode !== 'inline') {
	        newState.switchingModeFromInline = true;
	      }
	
	      if ('openKeys' in nextProps) {
	        newState.openKeys = nextProps.openKeys;
	      } else {
	        // [Legacy] Old code will return after `openKeys` changed.
	        // Not sure the reason, we should keep this logic still.
	        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
	          newState.switchingModeFromInline = true;
	          newState.inlineOpenKeys = prevState.openKeys;
	          newState.openKeys = [];
	        }
	
	        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
	          newState.openKeys = prevState.inlineOpenKeys;
	          newState.inlineOpenKeys = [];
	        }
	      }
	
	      return newState;
	    }
	  }]);
	
	  return InternalMenu;
	}(React.Component);
	
	InternalMenu.defaultProps = {
	  className: '',
	  theme: 'light',
	  focusable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalMenu); // We should keep this as ref-able
	
	var Menu = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Menu, _React$Component2);
	
	  var _super2 = _createSuper(Menu);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Menu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return /*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, function (context) {
	        return /*#__PURE__*/React.createElement(InternalMenu, _extends({}, _this2.props, context));
	      });
	    }
	  }]);
	
	  return Menu;
	}(React.Component);
	
	exports["default"] = Menu;
	Menu.Divider = _rcMenu.Divider;
	Menu.Item = _MenuItem["default"];
	Menu.SubMenu = _SubMenu["default"];
	Menu.ItemGroup = _rcMenu.ItemGroup;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(230);
	
	__webpack_require__(69);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.destroyFns = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcDialog = _interopRequireDefault(__webpack_require__(249));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(54));
	
	var _locale = __webpack_require__(99);
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	var _button = _interopRequireDefault(__webpack_require__(15));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(108));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var mousePosition;
	var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795
	
	exports.destroyFns = destroyFns;
	
	var getClickPosition = function getClickPosition(e) {
	  mousePosition = {
	    x: e.pageX,
	    y: e.pageY
	  }; // 100ms 内发生过点击事件，则从点击位置动画展示
	  // 否则直接 zoom 展示
	  // 这样可以兼容非点击方式展开
	
	  setTimeout(function () {
	    return mousePosition = null;
	  }, 100);
	}; // 只有点击事件支持从鼠标位置动画展开
	
	
	if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	  (0, _addEventListener["default"])(document.documentElement, 'click', getClickPosition);
	}
	
	var Modal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  var _super = _createSuper(Modal);
	
	  function Modal() {
	    var _this;
	
	    _classCallCheck(this, Modal);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleCancel = function (e) {
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel(e);
	      }
	    };
	
	    _this.handleOk = function (e) {
	      var onOk = _this.props.onOk;
	
	      if (onOk) {
	        onOk(e);
	      }
	    };
	
	    _this.renderFooter = function (locale) {
	      var _this$props = _this.props,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          cancelText = _this$props.cancelText,
	          confirmLoading = _this$props.confirmLoading;
	      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_button["default"], _extends({
	        onClick: _this.handleCancel
	      }, _this.props.cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	        type: okType,
	        loading: confirmLoading,
	        onClick: _this.handleOk
	      }, _this.props.okButtonProps), okText || locale.okText));
	    };
	
	    _this.renderModal = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          footer = _a.footer,
	          visible = _a.visible,
	          wrapClassName = _a.wrapClassName,
	          centered = _a.centered,
	          getContainer = _a.getContainer,
	          closeIcon = _a.closeIcon,
	          restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon"]);
	
	      var prefixCls = getPrefixCls('modal', customizePrefixCls);
	      var defaultFooter = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Modal",
	        defaultLocale: (0, _locale.getConfirmLocale)()
	      }, _this.renderFooter);
	      var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-x")
	      }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-close-icon"),
	        type: "close"
	      }));
	      return /*#__PURE__*/React.createElement(_rcDialog["default"], _extends({}, restProps, {
	        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
	        prefixCls: prefixCls,
	        wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
	        footer: footer === undefined ? defaultFooter : footer,
	        visible: visible,
	        mousePosition: mousePosition,
	        onClose: _this.handleCancel,
	        closeIcon: closeIconToRender
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderModal);
	    }
	  }]);
	
	  return Modal;
	}(React.Component);
	
	exports["default"] = Modal;
	Modal.defaultProps = {
	  width: 520,
	  transitionName: 'zoom',
	  maskTransitionName: 'fade',
	  confirmLoading: false,
	  visible: false,
	  okType: 'primary'
	};
	Modal.propTypes = {
	  prefixCls: PropTypes.string,
	  onOk: PropTypes.func,
	  onCancel: PropTypes.func,
	  okText: PropTypes.node,
	  cancelText: PropTypes.node,
	  centered: PropTypes.bool,
	  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  confirmLoading: PropTypes.bool,
	  visible: PropTypes.bool,
	  footer: PropTypes.node,
	  title: PropTypes.node,
	  closable: PropTypes.bool,
	  closeIcon: PropTypes.node
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(235);

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START_EVENT_NAME_MAP = {
	  transitionstart: {
	    transition: 'transitionstart',
	    WebkitTransition: 'webkitTransitionStart',
	    MozTransition: 'mozTransitionStart',
	    OTransition: 'oTransitionStart',
	    msTransition: 'MSTransitionStart'
	  },
	
	  animationstart: {
	    animation: 'animationstart',
	    WebkitAnimation: 'webkitAnimationStart',
	    MozAnimation: 'mozAnimationStart',
	    OAnimation: 'oAnimationStart',
	    msAnimation: 'MSAnimationStart'
	  }
	};
	
	var END_EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var startEvents = [];
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete START_EVENT_NAME_MAP.animationstart.animation;
	    delete END_EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete START_EVENT_NAME_MAP.transitionstart.transition;
	    delete END_EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  function process(EVENT_NAME_MAP, events) {
	    for (var baseEventName in EVENT_NAME_MAP) {
	      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	        var baseEvents = EVENT_NAME_MAP[baseEventName];
	        for (var styleName in baseEvents) {
	          if (styleName in style) {
	            events.push(baseEvents[styleName]);
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  process(START_EVENT_NAME_MAP, startEvents);
	  process(END_EVENT_NAME_MAP, endEvents);
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  // Start events
	  startEvents: startEvents,
	
	  addStartEventListener: function addStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      addEventListener(node, startEvent, eventListener);
	    });
	  },
	  removeStartEventListener: function removeStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      removeEventListener(node, startEvent, eventListener);
	    });
	  },
	
	
	  // End events
	  endEvents: endEvents,
	
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var caseSensitiveTransform = __webpack_require__(200)
	
	module.exports = caseInsensitiveTransform
	
	function caseInsensitiveTransform(attributes, property) {
	  return caseSensitiveTransform(attributes, property.toLowerCase())
	}


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var Info = __webpack_require__(76)
	var types = __webpack_require__(48)
	
	module.exports = DefinedInfo
	
	DefinedInfo.prototype = new Info()
	DefinedInfo.prototype.defined = true
	
	var checks = [
	  'boolean',
	  'booleanish',
	  'overloadedBoolean',
	  'number',
	  'commaSeparated',
	  'spaceSeparated',
	  'commaOrSpaceSeparated'
	]
	var checksLength = checks.length
	
	function DefinedInfo(property, attribute, mask, space) {
	  var index = -1
	  var check
	
	  mark(this, 'space', space)
	
	  Info.call(this, property, attribute)
	
	  while (++index < checksLength) {
	    check = checks[index]
	    mark(this, check, (mask & types[check]) === types[check])
	  }
	}
	
	function mark(values, key, value) {
	  if (value) {
	    values[key] = value
	  }
	}


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = Info
	
	var proto = Info.prototype
	
	proto.space = null
	proto.attribute = null
	proto.property = null
	proto.boolean = false
	proto.booleanish = false
	proto.overloadedBoolean = false
	proto.number = false
	proto.commaSeparated = false
	proto.spaceSeparated = false
	proto.commaOrSpaceSeparated = false
	proto.mustUseProperty = false
	proto.defined = false
	
	function Info(property, attribute) {
	  this.property = property
	  this.attribute = attribute
	}


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = Schema
	
	var proto = Schema.prototype
	
	proto.space = null
	proto.normal = {}
	proto.property = {}
	
	function Schema(property, normal, space) {
	  this.property = property
	  this.normal = normal
	
	  if (space) {
	    this.space = space
	  }
	}


/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = decimal
	
	// Check if the given character code, or the character code at the first
	// character, is decimal.
	function decimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return code >= 48 && code <= 57 /* 0-9 */
	}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(81);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(214);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.storeShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  setState: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(284);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	var _ChildrenUtils = __webpack_require__(244);
	
	var _AnimateChild = __webpack_require__(242);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(86);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = (0, _unsafeLifecyclesPolyfill2['default'])(Animate);
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.SubMenu = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(9));
	
	var _rcTrigger = _interopRequireDefault(__webpack_require__(53));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(28));
	
	var _CSSMotion = _interopRequireDefault(__webpack_require__(243));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _miniStore = __webpack_require__(30);
	
	var _SubPopupMenu = _interopRequireDefault(__webpack_require__(88));
	
	var _placements = _interopRequireDefault(__webpack_require__(259));
	
	var _util = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var guid = 0;
	var popupPlacementMap = {
	  horizontal: 'bottomLeft',
	  vertical: 'rightTop',
	  'vertical-left': 'rightTop',
	  'vertical-right': 'leftTop'
	};
	
	var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
	  var menuId = (0, _util.getMenuIdFromSubMenuEventKey)(eventKey);
	  var state = store.getState();
	  store.setState({
	    defaultActiveFirst: _objectSpread({}, state.defaultActiveFirst, _defineProperty({}, menuId, defaultActiveFirst))
	  });
	};
	
	var SubMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SubMenu, _React$Component);
	
	  function SubMenu(props) {
	    var _this;
	
	    _classCallCheck(this, SubMenu);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubMenu).call(this, props));
	
	    _this.onDestroy = function (key) {
	      _this.props.onDestroy(key);
	    };
	    /**
	     * note:
	     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
	     *  which need return code to check if this event is handled
	     */
	
	
	    _this.onKeyDown = function (e) {
	      var keyCode = e.keyCode;
	      var menu = _this.menuInstance;
	      var _this$props = _this.props,
	          isOpen = _this$props.isOpen,
	          store = _this$props.store;
	
	      if (keyCode === _KeyCode.default.ENTER) {
	        _this.onTitleClick(e);
	
	        updateDefaultActiveFirst(store, _this.props.eventKey, true);
	        return true;
	      }
	
	      if (keyCode === _KeyCode.default.RIGHT) {
	        if (isOpen) {
	          menu.onKeyDown(e);
	        } else {
	          _this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value
	
	
	          updateDefaultActiveFirst(store, _this.props.eventKey, true);
	        }
	
	        return true;
	      }
	
	      if (keyCode === _KeyCode.default.LEFT) {
	        var handled;
	
	        if (isOpen) {
	          handled = menu.onKeyDown(e);
	        } else {
	          return undefined;
	        }
	
	        if (!handled) {
	          _this.triggerOpenChange(false);
	
	          handled = true;
	        }
	
	        return handled;
	      }
	
	      if (isOpen && (keyCode === _KeyCode.default.UP || keyCode === _KeyCode.default.DOWN)) {
	        return menu.onKeyDown(e);
	      }
	
	      return undefined;
	    };
	
	    _this.onOpenChange = function (e) {
	      _this.props.onOpenChange(e);
	    };
	
	    _this.onPopupVisibleChange = function (visible) {
	      _this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
	    };
	
	    _this.onMouseEnter = function (e) {
	      var _this$props2 = _this.props,
	          key = _this$props2.eventKey,
	          onMouseEnter = _this$props2.onMouseEnter,
	          store = _this$props2.store;
	      updateDefaultActiveFirst(store, _this.props.eventKey, false);
	      onMouseEnter({
	        key: key,
	        domEvent: e
	      });
	    };
	
	    _this.onMouseLeave = function (e) {
	      var _this$props3 = _this.props,
	          parentMenu = _this$props3.parentMenu,
	          eventKey = _this$props3.eventKey,
	          onMouseLeave = _this$props3.onMouseLeave;
	      parentMenu.subMenuInstance = _assertThisInitialized(_this);
	      onMouseLeave({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	
	    _this.onTitleMouseEnter = function (domEvent) {
	      var _this$props4 = _this.props,
	          key = _this$props4.eventKey,
	          onItemHover = _this$props4.onItemHover,
	          onTitleMouseEnter = _this$props4.onTitleMouseEnter;
	      onItemHover({
	        key: key,
	        hover: true
	      });
	      onTitleMouseEnter({
	        key: key,
	        domEvent: domEvent
	      });
	    };
	
	    _this.onTitleMouseLeave = function (e) {
	      var _this$props5 = _this.props,
	          parentMenu = _this$props5.parentMenu,
	          eventKey = _this$props5.eventKey,
	          onItemHover = _this$props5.onItemHover,
	          onTitleMouseLeave = _this$props5.onTitleMouseLeave;
	      parentMenu.subMenuInstance = _assertThisInitialized(_this);
	      onItemHover({
	        key: eventKey,
	        hover: false
	      });
	      onTitleMouseLeave({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	
	    _this.onTitleClick = function (e) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      props.onTitleClick({
	        key: props.eventKey,
	        domEvent: e
	      });
	
	      if (props.triggerSubMenuAction === 'hover') {
	        return;
	      }
	
	      _this.triggerOpenChange(!props.isOpen, 'click');
	
	      updateDefaultActiveFirst(props.store, _this.props.eventKey, false);
	    };
	
	    _this.onSubMenuClick = function (info) {
	      // in the case of overflowed submenu
	      // onClick is not copied over
	      if (typeof _this.props.onClick === 'function') {
	        _this.props.onClick(_this.addKeyPath(info));
	      }
	    };
	
	    _this.onSelect = function (info) {
	      _this.props.onSelect(info);
	    };
	
	    _this.onDeselect = function (info) {
	      _this.props.onDeselect(info);
	    };
	
	    _this.getPrefixCls = function () {
	      return "".concat(_this.props.rootPrefixCls, "-submenu");
	    };
	
	    _this.getActiveClassName = function () {
	      return "".concat(_this.getPrefixCls(), "-active");
	    };
	
	    _this.getDisabledClassName = function () {
	      return "".concat(_this.getPrefixCls(), "-disabled");
	    };
	
	    _this.getSelectedClassName = function () {
	      return "".concat(_this.getPrefixCls(), "-selected");
	    };
	
	    _this.getOpenClassName = function () {
	      return "".concat(_this.props.rootPrefixCls, "-submenu-open");
	    };
	
	    _this.saveMenuInstance = function (c) {
	      // children menu instance
	      _this.menuInstance = c;
	    };
	
	    _this.addKeyPath = function (info) {
	      return _objectSpread({}, info, {
	        keyPath: (info.keyPath || []).concat(_this.props.eventKey)
	      });
	    };
	
	    _this.triggerOpenChange = function (open, type) {
	      var key = _this.props.eventKey;
	
	      var openChange = function openChange() {
	        _this.onOpenChange({
	          key: key,
	          item: _assertThisInitialized(_this),
	          trigger: type,
	          open: open
	        });
	      };
	
	      if (type === 'mouseenter') {
	        // make sure mouseenter happen after other menu item's mouseleave
	        _this.mouseenterTimeout = setTimeout(function () {
	          openChange();
	        }, 0);
	      } else {
	        openChange();
	      }
	    };
	
	    _this.isChildrenSelected = function () {
	      var ret = {
	        find: false
	      };
	      (0, _util.loopMenuItemRecursively)(_this.props.children, _this.props.selectedKeys, ret);
	      return ret.find;
	    };
	
	    _this.isOpen = function () {
	      return _this.props.openKeys.indexOf(_this.props.eventKey) !== -1;
	    };
	
	    _this.adjustWidth = function () {
	      /* istanbul ignore if */
	      if (!_this.subMenuTitle || !_this.menuInstance) {
	        return;
	      }
	
	      var popupMenu = ReactDOM.findDOMNode(_this.menuInstance);
	
	      if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
	        return;
	      }
	      /* istanbul ignore next */
	
	
	      popupMenu.style.minWidth = "".concat(_this.subMenuTitle.offsetWidth, "px");
	    };
	
	    _this.saveSubMenuTitle = function (subMenuTitle) {
	      _this.subMenuTitle = subMenuTitle;
	    };
	
	    var store = props.store,
	        eventKey = props.eventKey;
	
	    var _store$getState = store.getState(),
	        defaultActiveFirst = _store$getState.defaultActiveFirst;
	
	    _this.isRootMenu = false;
	    var value = false;
	
	    if (defaultActiveFirst) {
	      value = defaultActiveFirst[eventKey];
	    }
	
	    updateDefaultActiveFirst(store, eventKey, value);
	    return _this;
	  }
	
	  _createClass(SubMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentDidUpdate();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _this$props6 = this.props,
	          mode = _this$props6.mode,
	          parentMenu = _this$props6.parentMenu,
	          manualRef = _this$props6.manualRef; // invoke customized ref to expose component to mixin
	
	      if (manualRef) {
	        manualRef(this);
	      }
	
	      if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
	        return;
	      }
	
	      this.minWidthTimeout = setTimeout(function () {
	        return _this2.adjustWidth();
	      }, 0);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this$props7 = this.props,
	          onDestroy = _this$props7.onDestroy,
	          eventKey = _this$props7.eventKey;
	
	      if (onDestroy) {
	        onDestroy(eventKey);
	      }
	      /* istanbul ignore if */
	
	
	      if (this.minWidthTimeout) {
	        clearTimeout(this.minWidthTimeout);
	      }
	      /* istanbul ignore if */
	
	
	      if (this.mouseenterTimeout) {
	        clearTimeout(this.mouseenterTimeout);
	      }
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(children) {
	      var _this3 = this;
	
	      var props = this.props;
	      var baseProps = {
	        mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
	        visible: this.props.isOpen,
	        level: props.level + 1,
	        inlineIndent: props.inlineIndent,
	        focusable: false,
	        onClick: this.onSubMenuClick,
	        onSelect: this.onSelect,
	        onDeselect: this.onDeselect,
	        onDestroy: this.onDestroy,
	        selectedKeys: props.selectedKeys,
	        eventKey: "".concat(props.eventKey, "-menu-"),
	        openKeys: props.openKeys,
	        motion: props.motion,
	        onOpenChange: this.onOpenChange,
	        subMenuOpenDelay: props.subMenuOpenDelay,
	        parentMenu: this,
	        subMenuCloseDelay: props.subMenuCloseDelay,
	        forceSubMenuRender: props.forceSubMenuRender,
	        triggerSubMenuAction: props.triggerSubMenuAction,
	        builtinPlacements: props.builtinPlacements,
	        defaultActiveFirst: props.store.getState().defaultActiveFirst[(0, _util.getMenuIdFromSubMenuEventKey)(props.eventKey)],
	        multiple: props.multiple,
	        prefixCls: props.rootPrefixCls,
	        id: this.internalMenuId,
	        manualRef: this.saveMenuInstance,
	        itemIcon: props.itemIcon,
	        expandIcon: props.expandIcon
	      };
	      var haveRendered = this.haveRendered;
	      this.haveRendered = true;
	      this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender; // never rendered not planning to, don't render
	
	      if (!this.haveOpened) {
	        return React.createElement("div", null);
	      } // ================== Motion ==================
	      // don't show transition on first rendering (no animation for opened menu)
	      // show appear transition if it's not visible (not sure why)
	      // show appear transition if it's not inline mode
	
	
	      var mergedMotion = _objectSpread({}, props.motion, {
	        leavedClassName: "".concat(props.rootPrefixCls, "-hidden"),
	        removeOnLeave: false,
	        motionAppear: haveRendered || !baseProps.visible || baseProps.mode !== 'inline'
	      });
	
	      return React.createElement(_CSSMotion.default, Object.assign({
	        visible: baseProps.visible
	      }, mergedMotion), function (_ref) {
	        var className = _ref.className,
	            style = _ref.style;
	        var mergedClassName = (0, _classnames.default)("".concat(baseProps.prefixCls, "-sub"), className);
	        return React.createElement(_SubPopupMenu.default, Object.assign({}, baseProps, {
	          id: _this3.internalMenuId,
	          className: mergedClassName,
	          style: style
	        }), children);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var props = _objectSpread({}, this.props);
	
	      var isOpen = props.isOpen;
	      var prefixCls = this.getPrefixCls();
	      var isInlineMode = props.mode === 'inline';
	      var className = (0, _classnames.default)(prefixCls, "".concat(prefixCls, "-").concat(props.mode), (_classNames = {}, _defineProperty(_classNames, props.className, !!props.className), _defineProperty(_classNames, this.getOpenClassName(), isOpen), _defineProperty(_classNames, this.getActiveClassName(), props.active || isOpen && !isInlineMode), _defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _defineProperty(_classNames, this.getSelectedClassName(), this.isChildrenSelected()), _classNames));
	
	      if (!this.internalMenuId) {
	        if (props.eventKey) {
	          this.internalMenuId = "".concat(props.eventKey, "$Menu");
	        } else {
	          guid += 1;
	          this.internalMenuId = "$__$".concat(guid, "$Menu");
	        }
	      }
	
	      var mouseEvents = {};
	      var titleClickEvents = {};
	      var titleMouseEvents = {};
	
	      if (!props.disabled) {
	        mouseEvents = {
	          onMouseLeave: this.onMouseLeave,
	          onMouseEnter: this.onMouseEnter
	        }; // only works in title, not outer li
	
	        titleClickEvents = {
	          onClick: this.onTitleClick
	        };
	        titleMouseEvents = {
	          onMouseEnter: this.onTitleMouseEnter,
	          onMouseLeave: this.onTitleMouseLeave
	        };
	      }
	
	      var style = {};
	
	      if (isInlineMode) {
	        style.paddingLeft = props.inlineIndent * props.level;
	      }
	
	      var ariaOwns = {}; // only set aria-owns when menu is open
	      // otherwise it would be an invalid aria-owns value
	      // since corresponding node cannot be found
	
	      if (this.props.isOpen) {
	        ariaOwns = {
	          'aria-owns': this.internalMenuId
	        };
	      } // expand custom icon should NOT be displayed in menu with horizontal mode.
	
	
	      var icon = null;
	
	      if (props.mode !== 'horizontal') {
	        icon = this.props.expandIcon; // ReactNode
	
	        if (typeof this.props.expandIcon === 'function') {
	          icon = React.createElement(this.props.expandIcon, _objectSpread({}, this.props));
	        }
	      }
	
	      var title = React.createElement("div", Object.assign({
	        ref: this.saveSubMenuTitle,
	        style: style,
	        className: "".concat(prefixCls, "-title")
	      }, titleMouseEvents, titleClickEvents, {
	        "aria-expanded": isOpen
	      }, ariaOwns, {
	        "aria-haspopup": "true",
	        title: typeof props.title === 'string' ? props.title : undefined
	      }), props.title, icon || React.createElement("i", {
	        className: "".concat(prefixCls, "-arrow")
	      }));
	      var children = this.renderChildren(props.children);
	      var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
	        return triggerNode.parentNode;
	      };
	      var popupPlacement = popupPlacementMap[props.mode];
	      var popupAlign = props.popupOffset ? {
	        offset: props.popupOffset
	      } : {};
	      var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
	      var disabled = props.disabled,
	          triggerSubMenuAction = props.triggerSubMenuAction,
	          subMenuOpenDelay = props.subMenuOpenDelay,
	          forceSubMenuRender = props.forceSubMenuRender,
	          subMenuCloseDelay = props.subMenuCloseDelay,
	          builtinPlacements = props.builtinPlacements;
	
	      _util.menuAllProps.forEach(function (key) {
	        return delete props[key];
	      }); // Set onClick to null, to ignore propagated onClick event
	
	
	      delete props.onClick;
	      return React.createElement("li", Object.assign({}, props, mouseEvents, {
	        className: className,
	        role: "menuitem"
	      }), isInlineMode && title, isInlineMode && children, !isInlineMode && React.createElement(_rcTrigger.default, {
	        prefixCls: prefixCls,
	        popupClassName: "".concat(prefixCls, "-popup ").concat(popupClassName),
	        getPopupContainer: getPopupContainer,
	        builtinPlacements: Object.assign({}, _placements.default, builtinPlacements),
	        popupPlacement: popupPlacement,
	        popupVisible: isOpen,
	        popupAlign: popupAlign,
	        popup: children,
	        action: disabled ? [] : [triggerSubMenuAction],
	        mouseEnterDelay: subMenuOpenDelay,
	        mouseLeaveDelay: subMenuCloseDelay,
	        onPopupVisibleChange: this.onPopupVisibleChange,
	        forceRender: forceSubMenuRender
	      }, title));
	    }
	  }]);
	
	  return SubMenu;
	}(React.Component);
	
	exports.SubMenu = SubMenu;
	SubMenu.defaultProps = {
	  onMouseEnter: _util.noop,
	  onMouseLeave: _util.noop,
	  onTitleMouseEnter: _util.noop,
	  onTitleMouseLeave: _util.noop,
	  onTitleClick: _util.noop,
	  manualRef: _util.noop,
	  mode: 'vertical',
	  title: ''
	};
	var connected = (0, _miniStore.connect)(function (_ref2, _ref3) {
	  var openKeys = _ref2.openKeys,
	      activeKey = _ref2.activeKey,
	      selectedKeys = _ref2.selectedKeys;
	  var eventKey = _ref3.eventKey,
	      subMenuKey = _ref3.subMenuKey;
	  return {
	    isOpen: openKeys.indexOf(eventKey) > -1,
	    active: activeKey[subMenuKey] === eventKey,
	    selectedKeys: selectedKeys
	  };
	})(SubMenu);
	connected.isSubMenu = true;
	var _default = connected;
	exports.default = _default;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getActiveKey = getActiveKey;
	exports.saveRef = saveRef;
	exports.default = exports.SubPopupMenu = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _miniStore = __webpack_require__(30);
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(28));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(280));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _util = __webpack_require__(25);
	
	var _DOMWrap = _interopRequireDefault(__webpack_require__(254));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function allDisabled(arr) {
	  if (!arr.length) {
	    return true;
	  }
	
	  return arr.every(function (c) {
	    return !!c.props.disabled;
	  });
	}
	
	function updateActiveKey(store, menuId, activeKey) {
	  var state = store.getState();
	  store.setState({
	    activeKey: _objectSpread({}, state.activeKey, _defineProperty({}, menuId, activeKey))
	  });
	}
	
	function getEventKey(props) {
	  // when eventKey not available ,it's menu and return menu id '0-menu-'
	  return props.eventKey || '0-menu-';
	}
	
	function getActiveKey(props, originalActiveKey) {
	  var activeKey = originalActiveKey;
	  var children = props.children,
	      eventKey = props.eventKey;
	
	  if (activeKey) {
	    var found;
	    (0, _util.loopMenuItem)(children, function (c, i) {
	      if (c && c.props && !c.props.disabled && activeKey === (0, _util.getKeyFromChildrenIndex)(c, eventKey, i)) {
	        found = true;
	      }
	    });
	
	    if (found) {
	      return activeKey;
	    }
	  }
	
	  activeKey = null;
	
	  if (props.defaultActiveFirst) {
	    (0, _util.loopMenuItem)(children, function (c, i) {
	      if (!activeKey && c && !c.props.disabled) {
	        activeKey = (0, _util.getKeyFromChildrenIndex)(c, eventKey, i);
	      }
	    });
	    return activeKey;
	  }
	
	  return activeKey;
	}
	
	function saveRef(c) {
	  if (c) {
	    var index = this.instanceArray.indexOf(c);
	
	    if (index !== -1) {
	      // update component if it's already inside instanceArray
	      this.instanceArray[index] = c;
	    } else {
	      // add component if it's not in instanceArray yet;
	      this.instanceArray.push(c);
	    }
	  }
	}
	
	var SubPopupMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SubPopupMenu, _React$Component);
	
	  function SubPopupMenu(props) {
	    var _this;
	
	    _classCallCheck(this, SubPopupMenu);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubPopupMenu).call(this, props));
	    /**
	     * all keyboard events callbacks run from here at first
	     *
	     * note:
	     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
	     *  which need return code to check if this event is handled
	     */
	
	    _this.onKeyDown = function (e, callback) {
	      var keyCode = e.keyCode;
	      var handled;
	
	      _this.getFlatInstanceArray().forEach(function (obj) {
	        if (obj && obj.props.active && obj.onKeyDown) {
	          handled = obj.onKeyDown(e);
	        }
	      });
	
	      if (handled) {
	        return 1;
	      }
	
	      var activeItem = null;
	
	      if (keyCode === _KeyCode.default.UP || keyCode === _KeyCode.default.DOWN) {
	        activeItem = _this.step(keyCode === _KeyCode.default.UP ? -1 : 1);
	      }
	
	      if (activeItem) {
	        e.preventDefault();
	        updateActiveKey(_this.props.store, getEventKey(_this.props), activeItem.props.eventKey);
	
	        if (typeof callback === 'function') {
	          callback(activeItem);
	        }
	
	        return 1;
	      }
	
	      return undefined;
	    };
	
	    _this.onItemHover = function (e) {
	      var key = e.key,
	          hover = e.hover;
	      updateActiveKey(_this.props.store, getEventKey(_this.props), hover ? key : null);
	    };
	
	    _this.onDeselect = function (selectInfo) {
	      _this.props.onDeselect(selectInfo);
	    };
	
	    _this.onSelect = function (selectInfo) {
	      _this.props.onSelect(selectInfo);
	    };
	
	    _this.onClick = function (e) {
	      _this.props.onClick(e);
	    };
	
	    _this.onOpenChange = function (e) {
	      _this.props.onOpenChange(e);
	    };
	
	    _this.onDestroy = function (key) {
	      /* istanbul ignore next */
	      _this.props.onDestroy(key);
	    };
	
	    _this.getFlatInstanceArray = function () {
	      return _this.instanceArray;
	    };
	
	    _this.step = function (direction) {
	      var children = _this.getFlatInstanceArray();
	
	      var activeKey = _this.props.store.getState().activeKey[getEventKey(_this.props)];
	
	      var len = children.length;
	
	      if (!len) {
	        return null;
	      }
	
	      if (direction < 0) {
	        children = children.concat().reverse();
	      } // find current activeIndex
	
	
	      var activeIndex = -1;
	      children.every(function (c, ci) {
	        if (c && c.props.eventKey === activeKey) {
	          activeIndex = ci;
	          return false;
	        }
	
	        return true;
	      });
	
	      if (!_this.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
	        return undefined;
	      }
	
	      var start = (activeIndex + 1) % len;
	      var i = start;
	
	      do {
	        var child = children[i];
	
	        if (!child || child.props.disabled) {
	          i = (i + 1) % len;
	        } else {
	          return child;
	        }
	      } while (i !== start);
	
	      return null;
	    };
	
	    _this.renderCommonMenuItem = function (child, i, extraProps) {
	      var state = _this.props.store.getState();
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var key = (0, _util.getKeyFromChildrenIndex)(child, props.eventKey, i);
	      var childProps = child.props; // https://github.com/ant-design/ant-design/issues/11517#issuecomment-477403055
	
	      if (!childProps || typeof child.type === 'string') {
	        return child;
	      }
	
	      var isActive = key === state.activeKey;
	
	      var newChildProps = _objectSpread({
	        mode: childProps.mode || props.mode,
	        level: props.level,
	        inlineIndent: props.inlineIndent,
	        renderMenuItem: _this.renderMenuItem,
	        rootPrefixCls: props.prefixCls,
	        index: i,
	        parentMenu: props.parentMenu,
	        // customized ref function, need to be invoked manually in child's componentDidMount
	        manualRef: childProps.disabled ? undefined : (0, _createChainedFunction.default)(child.ref, saveRef.bind(_assertThisInitialized(_this))),
	        eventKey: key,
	        active: !childProps.disabled && isActive,
	        multiple: props.multiple,
	        onClick: function onClick(e) {
	          (childProps.onClick || _util.noop)(e);
	
	          _this.onClick(e);
	        },
	        onItemHover: _this.onItemHover,
	        motion: props.motion,
	        subMenuOpenDelay: props.subMenuOpenDelay,
	        subMenuCloseDelay: props.subMenuCloseDelay,
	        forceSubMenuRender: props.forceSubMenuRender,
	        onOpenChange: _this.onOpenChange,
	        onDeselect: _this.onDeselect,
	        onSelect: _this.onSelect,
	        builtinPlacements: props.builtinPlacements,
	        itemIcon: childProps.itemIcon || _this.props.itemIcon,
	        expandIcon: childProps.expandIcon || _this.props.expandIcon
	      }, extraProps); // ref: https://github.com/ant-design/ant-design/issues/13943
	
	
	      if (props.mode === 'inline' || (0, _util.isMobileDevice)()) {
	        newChildProps.triggerSubMenuAction = 'click';
	      }
	
	      return React.cloneElement(child, newChildProps);
	    };
	
	    _this.renderMenuItem = function (c, i, subMenuKey) {
	      /* istanbul ignore if */
	      if (!c) {
	        return null;
	      }
	
	      var state = _this.props.store.getState();
	
	      var extraProps = {
	        openKeys: state.openKeys,
	        selectedKeys: state.selectedKeys,
	        triggerSubMenuAction: _this.props.triggerSubMenuAction,
	        subMenuKey: subMenuKey
	      };
	      return _this.renderCommonMenuItem(c, i, extraProps);
	    };
	
	    props.store.setState({
	      activeKey: _objectSpread({}, props.store.getState().activeKey, _defineProperty({}, props.eventKey, getActiveKey(props, props.activeKey)))
	    });
	    _this.instanceArray = [];
	    return _this;
	  }
	
	  _createClass(SubPopupMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // invoke customized ref to expose component to mixin
	      if (this.props.manualRef) {
	        this.props.manualRef(this);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.visible || nextProps.visible || this.props.className !== nextProps.className || !(0, _shallowequal.default)(this.props.style, nextProps.style);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var props = this.props;
	      var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
	      var activeKey = getActiveKey(props, originalActiveKey);
	
	      if (activeKey !== originalActiveKey) {
	        updateActiveKey(props.store, getEventKey(props), activeKey);
	      } else if ('activeKey' in prevProps) {
	        // If prev activeKey is not same as current activeKey,
	        // we should set it.
	        var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);
	
	        if (activeKey !== prevActiveKey) {
	          updateActiveKey(props.store, getEventKey(props), activeKey);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var props = _extends({}, this.props);
	
	      this.instanceArray = [];
	      var className = (0, _classnames.default)(props.prefixCls, props.className, "".concat(props.prefixCls, "-").concat(props.mode));
	      var domProps = {
	        className: className,
	        // role could be 'select' and by default set to menu
	        role: props.role || 'menu'
	      };
	
	      if (props.id) {
	        domProps.id = props.id;
	      }
	
	      if (props.focusable) {
	        domProps.tabIndex = 0;
	        domProps.onKeyDown = this.onKeyDown;
	      }
	
	      var prefixCls = props.prefixCls,
	          eventKey = props.eventKey,
	          visible = props.visible,
	          level = props.level,
	          mode = props.mode,
	          overflowedIndicator = props.overflowedIndicator,
	          theme = props.theme;
	
	      _util.menuAllProps.forEach(function (key) {
	        return delete props[key];
	      }); // Otherwise, the propagated click event will trigger another onClick
	
	
	      delete props.onClick;
	      return React.createElement(_DOMWrap.default, Object.assign({}, props, {
	        prefixCls: prefixCls,
	        mode: mode,
	        tag: "ul",
	        level: level,
	        theme: theme,
	        visible: visible,
	        overflowedIndicator: overflowedIndicator
	      }, domProps), React.Children.map(props.children, function (c, i) {
	        return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
	      }));
	    }
	  }]);
	
	  return SubPopupMenu;
	}(React.Component);
	
	exports.SubPopupMenu = SubPopupMenu;
	SubPopupMenu.defaultProps = {
	  prefixCls: 'rc-menu',
	  className: '',
	  mode: 'vertical',
	  level: 1,
	  inlineIndent: 24,
	  visible: true,
	  focusable: true,
	  style: {},
	  manualRef: _util.noop
	};
	var connected = (0, _miniStore.connect)()(SubPopupMenu);
	var _default = connected;
	exports.default = _default;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SentinelConsumer = exports.SentinelProvider = undefined;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(28);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _createReactContext = __webpack_require__(29);
	
	var _createReactContext2 = _interopRequireDefault(_createReactContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
	var SentinelContext = (0, _createReactContext2['default'])({});
	var SentinelProvider = exports.SentinelProvider = SentinelContext.Provider;
	var SentinelConsumer = exports.SentinelConsumer = SentinelContext.Consumer;
	
	var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', position: 'absolute' };
	
	var Sentinel = function (_React$Component) {
	  (0, _inherits3['default'])(Sentinel, _React$Component);
	
	  function Sentinel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Sentinel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Sentinel.__proto__ || Object.getPrototypeOf(Sentinel)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (_ref2) {
	      var target = _ref2.target,
	          which = _ref2.which,
	          shiftKey = _ref2.shiftKey;
	      var _this$props = _this.props,
	          nextElement = _this$props.nextElement,
	          prevElement = _this$props.prevElement;
	
	      if (which !== _KeyCode2['default'].TAB || document.activeElement !== target) return;
	
	      // Tab next
	      if (!shiftKey && nextElement) {
	        nextElement.focus();
	      }
	
	      // Tab prev
	      if (shiftKey && prevElement) {
	        prevElement.focus();
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Sentinel, [{
	    key: 'render',
	    value: function render() {
	      var setRef = this.props.setRef;
	
	
	      return _react2['default'].createElement('div', {
	        tabIndex: 0,
	        ref: setRef,
	        style: sentinelStyle,
	        onKeyDown: this.onKeyDown,
	        role: 'presentation'
	      });
	    }
	  }]);
	  return Sentinel;
	}(_react2['default'].Component);
	
	Sentinel.propTypes = {
	  setRef: _propTypes2['default'].func,
	  prevElement: _propTypes2['default'].object,
	  nextElement: _propTypes2['default'].object
	};
	exports['default'] = Sentinel;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent() {
	    (0, _classCallCheck3['default'])(this, TabContent);
	    return (0, _possibleConstructorReturn3['default'])(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(TabContent, [{
	    key: 'getTabPanes',
	    value: function getTabPanes() {
	      var props = this.props;
	      var activeKey = props.activeKey;
	      var children = props.children;
	      var newChildren = [];
	
	      _react2['default'].Children.forEach(children, function (child) {
	        if (!child) {
	          return;
	        }
	        var key = child.key;
	        var active = activeKey === key;
	        newChildren.push(_react2['default'].cloneElement(child, {
	          active: active,
	          destroyInactiveTabPane: props.destroyInactiveTabPane,
	          rootPrefixCls: props.prefixCls
	        }));
	      });
	
	      return newChildren;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var props = this.props;
	      var prefixCls = props.prefixCls,
	          children = props.children,
	          activeKey = props.activeKey,
	          className = props.className,
	          tabBarPosition = props.tabBarPosition,
	          animated = props.animated,
	          animatedWithMargin = props.animatedWithMargin,
	          direction = props.direction;
	      var style = props.style;
	
	      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
	      if (animated) {
	        var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
	        if (activeIndex !== -1) {
	          var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition, direction));
	          style = (0, _extends3['default'])({}, style, animatedStyle);
	        } else {
	          style = (0, _extends3['default'])({}, style, {
	            display: 'none'
	          });
	        }
	      }
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: classes,
	          style: style
	        },
	        this.getTabPanes()
	      );
	    }
	  }]);
	  return TabContent;
	}(_react2['default'].Component);
	
	exports['default'] = TabContent;
	
	
	TabContent.propTypes = {
	  animated: _propTypes2['default'].bool,
	  animatedWithMargin: _propTypes2['default'].bool,
	  prefixCls: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  activeKey: _propTypes2['default'].string,
	  style: _propTypes2['default'].any,
	  tabBarPosition: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  destroyInactiveTabPane: _propTypes2['default'].bool,
	  direction: _propTypes2['default'].string
	};
	
	TabContent.defaultProps = {
	  animated: true
	};
	module.exports = exports['default'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(23);
	
	var _Sentinel = __webpack_require__(89);
	
	var _Sentinel2 = _interopRequireDefault(_Sentinel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane() {
	    (0, _classCallCheck3['default'])(this, TabPane);
	    return (0, _possibleConstructorReturn3['default'])(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(TabPane, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          id = _props.id,
	          className = _props.className,
	          destroyInactiveTabPane = _props.destroyInactiveTabPane,
	          active = _props.active,
	          forceRender = _props.forceRender,
	          rootPrefixCls = _props.rootPrefixCls,
	          style = _props.style,
	          children = _props.children,
	          placeholder = _props.placeholder,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['id', 'className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);
	
	      this._isActived = this._isActived || active;
	      var prefixCls = rootPrefixCls + '-tabpane';
	      var cls = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls, 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-inactive', !active), (0, _defineProperty3['default'])(_classnames, prefixCls + '-active', active), (0, _defineProperty3['default'])(_classnames, className, className), _classnames));
	      var isRender = destroyInactiveTabPane ? active : this._isActived;
	      var shouldRender = isRender || forceRender;
	
	      return _react2['default'].createElement(
	        _Sentinel.SentinelConsumer,
	        null,
	        function (_ref) {
	          var sentinelStart = _ref.sentinelStart,
	              sentinelEnd = _ref.sentinelEnd,
	              setPanelSentinelStart = _ref.setPanelSentinelStart,
	              setPanelSentinelEnd = _ref.setPanelSentinelEnd;
	
	          // Create sentinel
	          var panelSentinelStart = void 0;
	          var panelSentinelEnd = void 0;
	          if (active && shouldRender) {
	            panelSentinelStart = _react2['default'].createElement(_Sentinel2['default'], {
	              setRef: setPanelSentinelStart,
	              prevElement: sentinelStart
	            });
	            panelSentinelEnd = _react2['default'].createElement(_Sentinel2['default'], {
	              setRef: setPanelSentinelEnd,
	              nextElement: sentinelEnd
	            });
	          }
	
	          return _react2['default'].createElement(
	            'div',
	            (0, _extends3['default'])({
	              style: style,
	              role: 'tabpanel',
	              'aria-hidden': active ? 'false' : 'true',
	              className: cls,
	              id: id
	            }, (0, _utils.getDataAttr)(restProps)),
	            panelSentinelStart,
	            shouldRender ? children : placeholder,
	            panelSentinelEnd
	          );
	        }
	      );
	    }
	  }]);
	  return TabPane;
	}(_react2['default'].Component);
	
	exports['default'] = TabPane;
	
	
	TabPane.propTypes = {
	  className: _propTypes2['default'].string,
	  active: _propTypes2['default'].bool,
	  style: _propTypes2['default'].any,
	  destroyInactiveTabPane: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  placeholder: _propTypes2['default'].node,
	  rootPrefixCls: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  id: _propTypes2['default'].string
	};
	
	TabPane.defaultProps = {
	  placeholder: null
	};
	module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  };
	
	  LazyRenderBox.prototype.render = function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2['default'].createElement('div', props);
	    }
	
	    return _react2['default'].Children.only(props.children);
	  };
	
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getAlignPopupClassName = getAlignPopupClassName;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(9));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ContainerRender = /*#__PURE__*/function (_React$Component) {
	  _inherits(ContainerRender, _React$Component);
	
	  var _super = _createSuper(ContainerRender);
	
	  function ContainerRender() {
	    var _this;
	
	    _classCallCheck(this, ContainerRender);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _this.removeContainer = function () {
	      if (_this.container) {
	        _reactDom.default.unmountComponentAtNode(_this.container);
	
	        _this.container.parentNode.removeChild(_this.container);
	
	        _this.container = null;
	      }
	    };
	
	    _this.renderComponent = function (props, ready) {
	      var _this$props = _this.props,
	          visible = _this$props.visible,
	          getComponent = _this$props.getComponent,
	          forceRender = _this$props.forceRender,
	          getContainer = _this$props.getContainer,
	          parent = _this$props.parent;
	
	      if (visible || parent._component || forceRender) {
	        if (!_this.container) {
	          _this.container = getContainer();
	        }
	
	        _reactDom.default.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
	          if (ready) {
	            ready.call(this);
	          }
	        });
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(ContainerRender, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.props.autoDestroy) {
	        this.removeContainer();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children({
	        renderComponent: this.renderComponent,
	        removeContainer: this.removeContainer
	      });
	    }
	  }]);
	
	  return ContainerRender;
	}(_react.default.Component);
	
	exports.default = ContainerRender;
	ContainerRender.propTypes = {
	  autoMount: _propTypes.default.bool,
	  autoDestroy: _propTypes.default.bool,
	  visible: _propTypes.default.bool,
	  forceRender: _propTypes.default.bool,
	  parent: _propTypes.default.any,
	  getComponent: _propTypes.default.func.isRequired,
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.func.isRequired
	};
	ContainerRender.defaultProps = {
	  autoMount: true,
	  autoDestroy: true,
	  forceRender: false
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findDOMNode;
	
	var _reactDom = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Return if a node is a DOM node. Else will return by `findDOMNode`
	 */
	function findDOMNode(node) {
	  if (node instanceof HTMLElement) {
	    return node;
	  }
	
	  return _reactDom.default.findDOMNode(node);
	}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(9));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Portal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  var _super = _createSuper(Portal);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Portal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.createContainer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var didUpdate = this.props.didUpdate;
	
	      if (didUpdate) {
	        didUpdate(prevProps);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeContainer();
	    }
	  }, {
	    key: "createContainer",
	    value: function createContainer() {
	      this._container = this.props.getContainer();
	      this.forceUpdate();
	    }
	  }, {
	    key: "removeContainer",
	    value: function removeContainer() {
	      if (this._container) {
	        this._container.parentNode.removeChild(this._container);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this._container) {
	        return _reactDom.default.createPortal(this.props.children, this._container);
	      }
	
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.default.Component);
	
	exports.default = Portal;
	Portal.propTypes = {
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.node.isRequired,
	  didUpdate: _propTypes.default.func
	};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Easy to set element style, return previous style
	 * IE browser compatible(IE browser doesn't merge overflow style, need to set it separately)
	 * https://github.com/ant-design/ant-design/issues/19393
	 *
	 */
	function setStyle(style) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$element = options.element,
	      element = _options$element === void 0 ? document.body : _options$element;
	  var oldStyle = {};
	  var styleKeys = Object.keys(style); // IE browser compatible
	
	  styleKeys.forEach(function (key) {
	    oldStyle[key] = element.style[key];
	  });
	  styleKeys.forEach(function (key) {
	    element.style[key] = style[key];
	  });
	  return oldStyle;
	}
	
	var _default = setStyle;
	exports.default = _default;

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _input = __webpack_require__(39);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * 
	                                                                                                                                                                                                                                                                   * @format
	                                                                                                                                                                                                                                                                   */
	
	__webpack_require__(40);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _YogaEnumSelect = __webpack_require__(161);
	
	var _YogaEnumSelect2 = _interopRequireDefault(_YogaEnumSelect);
	
	var _YogaPositionEditor = __webpack_require__(163);
	
	var _YogaPositionEditor2 = _interopRequireDefault(_YogaPositionEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  if (_YogaEnumSelect2.default.availableProperties.indexOf(props.property) > -1) {
	    return _react2.default.createElement(_YogaEnumSelect2.default, props);
	  } else if (_YogaPositionEditor2.default.availableProperties.indexOf(props.property) > -1) {
	    return _react2.default.createElement(_YogaPositionEditor2.default, props);
	  } else {
	    return _react2.default.createElement(_input2.default, _extends({
	      type: 'text'
	    }, props, {
	      onChange: function onChange(e) {
	        return props.onChange(props.property, e.target.value);
	      },
	      placeholder: props.placeholder || 'undefined',
	      onFocus: function onFocus(e) {
	        return e.target.select();
	      },
	      value: Number.isNaN(props.value) ? '' : props.value
	    }));
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(117);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(115);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(118);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback, option) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    var _ret = (function () {
	      var useCapture = false;
	      if (typeof option === 'object') {
	        useCapture = option.capture || false;
	      } else if (typeof option === 'boolean') {
	        useCapture = option;
	      }
	
	      target.addEventListener(eventType, wrapCallback, option || false);
	
	      return {
	        v: {
	          remove: function remove() {
	            target.removeEventListener(eventType, wrapCallback, useCapture);
	          }
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var isNumeric = function isNumeric(value) {
	  return !isNaN(parseFloat(value)) && isFinite(value);
	};
	
	var _default = isNumeric;
	exports["default"] = _default;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	// ================== Collapse Motion ==================
	var getCollapsedHeight = function getCollapsedHeight() {
	  return {
	    height: 0,
	    opacity: 0
	  };
	};
	
	var getRealHeight = function getRealHeight(node) {
	  return {
	    height: node.scrollHeight,
	    opacity: 1
	  };
	};
	
	var getCurrentHeight = function getCurrentHeight(node) {
	  return {
	    height: node.offsetHeight
	  };
	};
	
	var collapseMotion = {
	  motionName: 'ant-motion-collapse',
	  onAppearStart: getCollapsedHeight,
	  onEnterStart: getCollapsedHeight,
	  onAppearActive: getRealHeight,
	  onEnterActive: getRealHeight,
	  onLeaveStart: getCurrentHeight,
	  onLeaveActive: getCollapsedHeight
	};
	var _default = collapseMotion;
	exports["default"] = _default;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.isFlexSupported = void 0;
	
	var isStyleSupport = function isStyleSupport(styleName) {
	  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
	    var documentElement = window.document.documentElement;
	    return styleNameList.some(function (name) {
	      return name in documentElement.style;
	    });
	  }
	
	  return false;
	};
	
	var isFlexSupported = isStyleSupport(['flex', 'webkitFlex', 'Flex', 'msFlex']);
	exports.isFlexSupported = isFlexSupported;
	var _default = isStyleSupport;
	exports["default"] = _default;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(9);
	
	var _Event = _interopRequireDefault(__webpack_require__(73));
	
	var _raf = _interopRequireDefault(__webpack_require__(36));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var styleForPesudo; // Where el is the DOM element you'd like to test for visibility
	
	function isHidden(element) {
	  if (false) {
	    return false;
	  }
	
	  return !element || element.offsetParent === null;
	}
	
	function isNotGrey(color) {
	  // eslint-disable-next-line no-useless-escape
	  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
	
	  if (match && match[1] && match[2] && match[3]) {
	    return !(match[1] === match[2] && match[2] === match[3]);
	  }
	
	  return true;
	}
	
	var Wave = /*#__PURE__*/function (_React$Component) {
	  _inherits(Wave, _React$Component);
	
	  var _super = _createSuper(Wave);
	
	  function Wave() {
	    var _this;
	
	    _classCallCheck(this, Wave);
	
	    _this = _super.apply(this, arguments);
	    _this.animationStart = false;
	    _this.destroy = false;
	
	    _this.onClick = function (node, waveColor) {
	      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
	        return;
	      }
	
	      var insertExtraNode = _this.props.insertExtraNode;
	      _this.extraNode = document.createElement('div');
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          extraNode = _assertThisInitialize.extraNode;
	
	      extraNode.className = 'ant-click-animating-node';
	
	      var attributeName = _this.getAttributeName();
	
	      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey
	
	      styleForPesudo = styleForPesudo || document.createElement('style');
	
	      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
	      waveColor !== 'transparent') {
	        // Add nonce if CSP exist
	        if (_this.csp && _this.csp.nonce) {
	          styleForPesudo.nonce = _this.csp.nonce;
	        }
	
	        extraNode.style.borderColor = waveColor;
	        styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");
	
	        if (!document.body.contains(styleForPesudo)) {
	          document.body.appendChild(styleForPesudo);
	        }
	      }
	
	      if (insertExtraNode) {
	        node.appendChild(extraNode);
	      }
	
	      _Event["default"].addStartEventListener(node, _this.onTransitionStart);
	
	      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
	    };
	
	    _this.onTransitionStart = function (e) {
	      if (_this.destroy) return;
	      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));
	
	      if (!e || e.target !== node) {
	        return;
	      }
	
	      if (!_this.animationStart) {
	        _this.resetEffect(node);
	      }
	    };
	
	    _this.onTransitionEnd = function (e) {
	      if (!e || e.animationName !== 'fadeEffect') {
	        return;
	      }
	
	      _this.resetEffect(e.target);
	    };
	
	    _this.bindAnimationEvent = function (node) {
	      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
	        return;
	      }
	
	      var onClick = function onClick(e) {
	        // Fix radio button click twice
	        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
	          return;
	        }
	
	        _this.resetEffect(node); // Get wave color from target
	
	
	        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
	        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
	        _this.clickWaveTimeoutId = window.setTimeout(function () {
	          return _this.onClick(node, waveColor);
	        }, 0);
	
	        _raf["default"].cancel(_this.animationStartId);
	
	        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
	
	        _this.animationStartId = (0, _raf["default"])(function () {
	          _this.animationStart = false;
	        }, 10);
	      };
	
	      node.addEventListener('click', onClick, true);
	      return {
	        cancel: function cancel() {
	          node.removeEventListener('click', onClick, true);
	        }
	      };
	    };
	
	    _this.renderWave = function (_ref) {
	      var csp = _ref.csp;
	      var children = _this.props.children;
	      _this.csp = csp;
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Wave, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var node = (0, _reactDom.findDOMNode)(this);
	
	      if (!node || node.nodeType !== 1) {
	        return;
	      }
	
	      this.instance = this.bindAnimationEvent(node);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.instance) {
	        this.instance.cancel();
	      }
	
	      if (this.clickWaveTimeoutId) {
	        clearTimeout(this.clickWaveTimeoutId);
	      }
	
	      this.destroy = true;
	    }
	  }, {
	    key: "getAttributeName",
	    value: function getAttributeName() {
	      var insertExtraNode = this.props.insertExtraNode;
	      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
	    }
	  }, {
	    key: "resetEffect",
	    value: function resetEffect(node) {
	      if (!node || node === this.extraNode || !(node instanceof Element)) {
	        return;
	      }
	
	      var insertExtraNode = this.props.insertExtraNode;
	      var attributeName = this.getAttributeName();
	      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466
	
	      if (styleForPesudo) {
	        styleForPesudo.innerHTML = '';
	      }
	
	      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
	        node.removeChild(this.extraNode);
	      }
	
	      _Event["default"].removeStartEventListener(node, this.onTransitionStart);
	
	      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWave);
	    }
	  }]);
	
	  return Wave;
	}(React.Component);
	
	exports["default"] = Wave;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var getPrefixCls = _ref.getPrefixCls;
	
	    var customizePrefixCls = props.prefixCls,
	        size = props.size,
	        className = props.className,
	        others = __rest(props, ["prefixCls", "size", "className"]);
	
	    var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
	    // small => sm
	
	    var sizeCls = '';
	
	    switch (size) {
	      case 'large':
	        sizeCls = 'lg';
	        break;
	
	      case 'small':
	        sizeCls = 'sm';
	        break;
	
	      default:
	        break;
	    }
	
	    var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
	    return /*#__PURE__*/React.createElement("div", _extends({}, others, {
	      className: classes
	    }));
	  });
	};
	
	var _default = ButtonGroup;
	exports["default"] = _default;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _omit = _interopRequireDefault(__webpack_require__(22));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(7);
	
	var _wave = _interopRequireDefault(__webpack_require__(123));
	
	var _type = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable react/button-has-type */
	
	
	var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
	var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
	
	function isString(str) {
	  return typeof str === 'string';
	} // Insert one space between two chinese characters automatically.
	
	
	function insertSpace(child, needInserted) {
	  // Check the child if is undefined or null.
	  if (child == null) {
	    return;
	  }
	
	  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.
	
	  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
	    return /*#__PURE__*/React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
	  }
	
	  if (typeof child === 'string') {
	    if (isTwoCNChar(child)) {
	      child = child.split('').join(SPACE);
	    }
	
	    return /*#__PURE__*/React.createElement("span", null, child);
	  }
	
	  return child;
	}
	
	function spaceChildren(children, needInserted) {
	  var isPrevChildPure = false;
	  var childList = [];
	  React.Children.forEach(children, function (child) {
	    var type = _typeof(child);
	
	    var isCurrentChildPure = type === 'string' || type === 'number';
	
	    if (isPrevChildPure && isCurrentChildPure) {
	      var lastIndex = childList.length - 1;
	      var lastChild = childList[lastIndex];
	      childList[lastIndex] = "".concat(lastChild).concat(child);
	    } else {
	      childList.push(child);
	    }
	
	    isPrevChildPure = isCurrentChildPure;
	  }); // Pass to React.Children.map to auto fill key
	
	  return React.Children.map(childList, function (child) {
	    return insertSpace(child, needInserted);
	  });
	}
	
	var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
	var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline', 'round');
	var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
	var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');
	
	var Button = /*#__PURE__*/function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  var _super = _createSuper(Button);
	
	  function Button(props) {
	    var _this;
	
	    _classCallCheck(this, Button);
	
	    _this = _super.call(this, props);
	
	    _this.saveButtonRef = function (node) {
	      _this.buttonNode = node;
	    };
	
	    _this.handleClick = function (e) {
	      var loading = _this.state.loading;
	      var onClick = _this.props.onClick;
	
	      if (loading) {
	        return;
	      }
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.renderButton = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          shape = _a.shape,
	          size = _a.size,
	          className = _a.className,
	          children = _a.children,
	          icon = _a.icon,
	          ghost = _a.ghost,
	          block = _a.block,
	          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "block"]);
	
	      var _this$state = _this.state,
	          loading = _this$state.loading,
	          hasTwoCNChar = _this$state.hasTwoCNChar;
	      var prefixCls = getPrefixCls('btn', customizePrefixCls);
	      var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var iconType = loading ? 'loading' : icon;
	      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), !!loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
	      var iconNode = iconType ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType
	      }) : null;
	      var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
	      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType', 'loading']);
	
	      if (linkButtonRestProps.href !== undefined) {
	        return /*#__PURE__*/React.createElement("a", _extends({}, linkButtonRestProps, {
	          className: classes,
	          onClick: _this.handleClick,
	          ref: _this.saveButtonRef
	        }), iconNode, kids);
	      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
	
	
	      var _b = rest,
	          htmlType = _b.htmlType,
	          otherProps = __rest(_b, ["htmlType"]);
	
	      var buttonNode = /*#__PURE__*/React.createElement("button", _extends({}, (0, _omit["default"])(otherProps, ['loading']), {
	        type: htmlType,
	        className: classes,
	        onClick: _this.handleClick,
	        ref: _this.saveButtonRef
	      }), iconNode, kids);
	
	      if (type === 'link') {
	        return buttonNode;
	      }
	
	      return /*#__PURE__*/React.createElement(_wave["default"], null, buttonNode);
	    };
	
	    _this.state = {
	      loading: props.loading,
	      hasTwoCNChar: false
	    };
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fixTwoCNChar();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      this.fixTwoCNChar();
	
	      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
	        clearTimeout(this.delayTimeout);
	      }
	
	      var loading = this.props.loading;
	
	      if (loading && typeof loading !== 'boolean' && loading.delay) {
	        this.delayTimeout = window.setTimeout(function () {
	          _this2.setState({
	            loading: loading
	          });
	        }, loading.delay);
	      } else if (prevProps.loading !== loading) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          loading: loading
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.delayTimeout) {
	        clearTimeout(this.delayTimeout);
	      }
	    }
	  }, {
	    key: "fixTwoCNChar",
	    value: function fixTwoCNChar() {
	      // Fix for HOC usage like <FormatMessage />
	      if (!this.buttonNode) {
	        return;
	      }
	
	      var buttonText = this.buttonNode.textContent;
	
	      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
	        if (!this.state.hasTwoCNChar) {
	          this.setState({
	            hasTwoCNChar: true
	          });
	        }
	      } else if (this.state.hasTwoCNChar) {
	        this.setState({
	          hasTwoCNChar: false
	        });
	      }
	    }
	  }, {
	    key: "isNeedInserted",
	    value: function isNeedInserted() {
	      var _this$props = this.props,
	          icon = _this$props.icon,
	          children = _this$props.children,
	          type = _this$props.type;
	      return React.Children.count(children) === 1 && !icon && type !== 'link';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
	    }
	  }]);
	
	  return Button;
	}(React.Component);
	
	Button.__ANT_BUTTON = true;
	Button.defaultProps = {
	  loading: false,
	  ghost: false,
	  block: false,
	  htmlType: 'button'
	};
	Button.propTypes = {
	  type: PropTypes.string,
	  shape: PropTypes.oneOf(ButtonShapes),
	  size: PropTypes.oneOf(ButtonSizes),
	  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
	  onClick: PropTypes.func,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  className: PropTypes.string,
	  icon: PropTypes.string,
	  block: PropTypes.bool,
	  title: PropTypes.string
	};
	(0, _reactLifecyclesCompat.polyfill)(Button);
	var _default = Button;
	exports["default"] = _default;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _button = _interopRequireDefault(__webpack_require__(15));
	
	var _configProvider = __webpack_require__(7);
	
	var _dropdown = _interopRequireDefault(__webpack_require__(61));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = _button["default"].Group;
	
	var DropdownButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(DropdownButton, _React$Component);
	
	  var _super = _createSuper(DropdownButton);
	
	  function DropdownButton() {
	    var _this;
	
	    _classCallCheck(this, DropdownButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderButton = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          onClick = _a.onClick,
	          htmlType = _a.htmlType,
	          children = _a.children,
	          className = _a.className,
	          overlay = _a.overlay,
	          trigger = _a.trigger,
	          align = _a.align,
	          visible = _a.visible,
	          onVisibleChange = _a.onVisibleChange,
	          placement = _a.placement,
	          getPopupContainer = _a.getPopupContainer,
	          href = _a.href,
	          _a$icon = _a.icon,
	          icon = _a$icon === void 0 ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "ellipsis"
	      }) : _a$icon,
	          title = _a.title,
	          restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title"]);
	
	      var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
	      var dropdownProps = {
	        align: align,
	        overlay: overlay,
	        disabled: disabled,
	        trigger: disabled ? [] : trigger,
	        onVisibleChange: onVisibleChange,
	        placement: placement,
	        getPopupContainer: getPopupContainer || getContextPopupContainer
	      };
	
	      if ('visible' in _this.props) {
	        dropdownProps.visible = visible;
	      }
	
	      return /*#__PURE__*/React.createElement(ButtonGroup, _extends({}, restProps, {
	        className: (0, _classnames["default"])(prefixCls, className)
	      }), /*#__PURE__*/React.createElement(_button["default"], {
	        type: type,
	        disabled: disabled,
	        onClick: onClick,
	        htmlType: htmlType,
	        href: href,
	        title: title
	      }, children), /*#__PURE__*/React.createElement(_dropdown["default"], dropdownProps, /*#__PURE__*/React.createElement(_button["default"], {
	        type: type
	      }, icon)));
	    };
	
	    return _this;
	  }
	
	  _createClass(DropdownButton, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
	    }
	  }]);
	
	  return DropdownButton;
	}(React.Component);
	
	exports["default"] = DropdownButton;
	DropdownButton.defaultProps = {
	  placement: 'bottomRight',
	  type: 'default'
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Group = function Group(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var _classNames;
	
	    var getPrefixCls = _ref.getPrefixCls;
	    var customizePrefixCls = props.prefixCls,
	        _props$className = props.className,
	        className = _props$className === void 0 ? '' : _props$className;
	    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
	    var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
	    return /*#__PURE__*/React.createElement("span", {
	      className: cls,
	      style: props.style,
	      onMouseEnter: props.onMouseEnter,
	      onMouseLeave: props.onMouseLeave,
	      onFocus: props.onFocus,
	      onBlur: props.onBlur
	    }, props.children);
	  });
	};
	
	var _default = Group;
	exports["default"] = _default;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _omit = _interopRequireDefault(__webpack_require__(22));
	
	var _Input = _interopRequireDefault(__webpack_require__(26));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ActionMap = {
	  click: 'onClick',
	  hover: 'onMouseOver'
	};
	
	var Password = /*#__PURE__*/function (_React$Component) {
	  _inherits(Password, _React$Component);
	
	  var _super = _createSuper(Password);
	
	  function Password() {
	    var _this;
	
	    _classCallCheck(this, Password);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      visible: false
	    };
	
	    _this.onVisibleChange = function () {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setState(function (_ref) {
	        var visible = _ref.visible;
	        return {
	          visible: !visible
	        };
	      });
	    };
	
	    _this.saveInput = function (instance) {
	      if (instance && instance.input) {
	        _this.input = instance.input;
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Password, [{
	    key: "getIcon",
	    value: function getIcon() {
	      var _iconProps;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          action = _this$props.action;
	      var iconTrigger = ActionMap[action] || '';
	      var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, this.onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "type", this.state.visible ? 'eye' : 'eye-invisible'), _defineProperty(_iconProps, "key", 'passwordIcon'), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
	        // Prevent focused state lost
	        // https://github.com/ant-design/ant-design/issues/15173
	        e.preventDefault();
	      }), _iconProps);
	      return /*#__PURE__*/React.createElement(_icon["default"], iconProps);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          inputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          visibilityToggle = _a.visibilityToggle,
	          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);
	
	      var suffixIcon = visibilityToggle && this.getIcon();
	      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	      return /*#__PURE__*/React.createElement(_Input["default"], _extends({}, (0, _omit["default"])(restProps, ['suffix']), {
	        type: this.state.visible ? 'text' : 'password',
	        size: size,
	        className: inputClassName,
	        prefixCls: inputPrefixCls,
	        suffix: suffixIcon,
	        ref: this.saveInput
	      }));
	    }
	  }]);
	
	  return Password;
	}(React.Component);
	
	exports["default"] = Password;
	Password.defaultProps = {
	  inputPrefixCls: 'ant-input',
	  prefixCls: 'ant-input-password',
	  action: 'click',
	  visibilityToggle: true
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(262));
	
	var _omit = _interopRequireDefault(__webpack_require__(22));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(132));
	
	var _raf = _interopRequireDefault(__webpack_require__(36));
	
	var _warning = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ResizableTextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(ResizableTextArea, _React$Component);
	
	  var _super = _createSuper(ResizableTextArea);
	
	  function ResizableTextArea(props) {
	    var _this;
	
	    _classCallCheck(this, ResizableTextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (textArea) {
	      _this.textArea = textArea;
	    };
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.nextFrameActionId);
	
	      _this.nextFrameActionId = (0, _raf["default"])(_this.resizeTextarea);
	    };
	
	    _this.resizeTextarea = function () {
	      var autoSize = _this.props.autoSize || _this.props.autosize;
	
	      if (!autoSize || !_this.textArea) {
	        return;
	      }
	
	      var minRows = autoSize.minRows,
	          maxRows = autoSize.maxRows;
	      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textArea, false, minRows, maxRows);
	
	      _this.setState({
	        textareaStyles: textareaStyles,
	        resizing: true
	      }, function () {
	        _raf["default"].cancel(_this.resizeFrameId);
	
	        _this.resizeFrameId = (0, _raf["default"])(function () {
	          _this.setState({
	            resizing: false
	          });
	
	          _this.fixFirefoxAutoScroll();
	        });
	      });
	    };
	
	    _this.renderTextArea = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          autoSize = _this$props.autoSize,
	          autosize = _this$props.autosize,
	          className = _this$props.className,
	          disabled = _this$props.disabled;
	      var _this$state = _this.state,
	          textareaStyles = _this$state.textareaStyles,
	          resizing = _this$state.resizing;
	      (0, _warning["default"])(autosize === undefined, 'Input.TextArea', 'autosize is deprecated, please use autoSize instead.');
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'autosize', 'defaultValue', 'allowClear']);
	      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
	      // Make sure it could be reset when using form.getFieldDecorator
	
	      if ('value' in otherProps) {
	        otherProps.value = otherProps.value || '';
	      }
	
	      var style = _extends(_extends(_extends({}, _this.props.style), textareaStyles), resizing ? {
	        overflowX: 'hidden',
	        overflowY: 'hidden'
	      } : null);
	
	      return /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	        onResize: _this.resizeOnNextFrame,
	        disabled: !(autoSize || autosize)
	      }, /*#__PURE__*/React.createElement("textarea", _extends({}, otherProps, {
	        className: cls,
	        style: style,
	        ref: _this.saveTextArea
	      })));
	    };
	
	    _this.state = {
	      textareaStyles: {},
	      resizing: false
	    };
	    return _this;
	  }
	
	  _createClass(ResizableTextArea, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resizeTextarea();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // Re-render with the new content then recalculate the height as required.
	      if (prevProps.value !== this.props.value) {
	        this.resizeTextarea();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.nextFrameActionId);
	
	      _raf["default"].cancel(this.resizeFrameId);
	    } // https://github.com/ant-design/ant-design/issues/21870
	
	  }, {
	    key: "fixFirefoxAutoScroll",
	    value: function fixFirefoxAutoScroll() {
	      try {
	        if (document.activeElement === this.textArea) {
	          var currentStart = this.textArea.selectionStart;
	          var currentEnd = this.textArea.selectionEnd;
	          this.textArea.setSelectionRange(currentStart, currentEnd);
	        }
	      } catch (e) {// Fix error in Chrome:
	        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
	        // http://stackoverflow.com/q/21177489/3040605
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderTextArea();
	    }
	  }]);
	
	  return ResizableTextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ResizableTextArea);
	var _default = ResizableTextArea;
	exports["default"] = _default;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _isMobile = __webpack_require__(209);
	
	var _Input = _interopRequireDefault(__webpack_require__(26));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	var _button = _interopRequireDefault(__webpack_require__(15));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.onChange = function (e) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onSearch = _this$props.onSearch;
	
	      if (e && e.target && e.type === 'click' && onSearch) {
	        onSearch(e.target.value, e);
	      }
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.onSearch = function (e) {
	      var _this$props2 = _this.props,
	          onSearch = _this$props2.onSearch,
	          loading = _this$props2.loading,
	          disabled = _this$props2.disabled;
	
	      if (loading || disabled) {
	        return;
	      }
	
	      if (onSearch) {
	        onSearch(_this.input.input.value, e);
	      }
	
	      if (!(0, _isMobile.isMobile)({
	        tablet: true
	      })) {
	        _this.input.focus();
	      }
	    };
	
	    _this.renderLoading = function (prefixCls) {
	      var _this$props3 = _this.props,
	          enterButton = _this$props3.enterButton,
	          size = _this$props3.size;
	
	      if (enterButton) {
	        return /*#__PURE__*/React.createElement(_button["default"], {
	          className: "".concat(prefixCls, "-button"),
	          type: "primary",
	          size: size,
	          key: "enterButton"
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading"
	        }));
	      }
	
	      return /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: "loading",
	        key: "loadingIcon"
	      });
	    };
	
	    _this.renderSuffix = function (prefixCls) {
	      var _this$props4 = _this.props,
	          suffix = _this$props4.suffix,
	          enterButton = _this$props4.enterButton,
	          loading = _this$props4.loading;
	
	      if (loading && !enterButton) {
	        return [suffix, _this.renderLoading(prefixCls)];
	      }
	
	      if (enterButton) return suffix;
	      var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: "search",
	        key: "searchIcon",
	        onClick: _this.onSearch
	      });
	
	      if (suffix) {
	        return [/*#__PURE__*/React.isValidElement(suffix) ? /*#__PURE__*/React.cloneElement(suffix, {
	          key: 'suffix'
	        }) : null, icon];
	      }
	
	      return icon;
	    };
	
	    _this.renderAddonAfter = function (prefixCls) {
	      var _this$props5 = _this.props,
	          enterButton = _this$props5.enterButton,
	          size = _this$props5.size,
	          disabled = _this$props5.disabled,
	          addonAfter = _this$props5.addonAfter,
	          loading = _this$props5.loading;
	      var btnClassName = "".concat(prefixCls, "-button");
	
	      if (loading && enterButton) {
	        return [_this.renderLoading(prefixCls), addonAfter];
	      }
	
	      if (!enterButton) return addonAfter;
	      var button;
	      var enterButtonAsElement = enterButton;
	      var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
	
	      if (isAntdButton || enterButtonAsElement.type === 'button') {
	        button = /*#__PURE__*/React.cloneElement(enterButtonAsElement, _extends({
	          onClick: _this.onSearch,
	          key: 'enterButton'
	        }, isAntdButton ? {
	          className: btnClassName,
	          size: size
	        } : {}));
	      } else {
	        button = /*#__PURE__*/React.createElement(_button["default"], {
	          className: btnClassName,
	          type: "primary",
	          size: size,
	          disabled: disabled,
	          key: "enterButton",
	          onClick: _this.onSearch
	        }, enterButton === true ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "search"
	        }) : enterButton);
	      }
	
	      if (addonAfter) {
	        return [button, /*#__PURE__*/React.isValidElement(addonAfter) ? /*#__PURE__*/React.cloneElement(addonAfter, {
	          key: 'addonAfter'
	        }) : null];
	      }
	
	      return button;
	    };
	
	    _this.renderSearch = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeInputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          enterButton = _a.enterButton,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "inputPrefixCls", "size", "enterButton", "className"]);
	
	      delete restProps.onSearch;
	      delete restProps.loading;
	      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var inputClassName;
	
	      if (enterButton) {
	        var _classNames;
	
	        inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
	      } else {
	        inputClassName = (0, _classnames["default"])(prefixCls, className);
	      }
	
	      return /*#__PURE__*/React.createElement(_Input["default"], _extends({
	        onPressEnter: _this.onSearch
	      }, restProps, {
	        size: size,
	        prefixCls: inputPrefixCls,
	        addonAfter: _this.renderAddonAfter(prefixCls),
	        suffix: _this.renderSuffix(prefixCls),
	        onChange: _this.onChange,
	        ref: _this.saveInput,
	        className: inputClassName
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch);
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  enterButton: false
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(64));
	
	var _ResizableTextArea = _interopRequireDefault(__webpack_require__(129));
	
	var _configProvider = __webpack_require__(7);
	
	var _Input = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var TextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(TextArea, _React$Component);
	
	  var _super = _createSuper(TextArea);
	
	  function TextArea(props) {
	    var _this;
	
	    _classCallCheck(this, TextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (resizableTextArea) {
	      _this.resizableTextArea = resizableTextArea;
	    };
	
	    _this.saveClearableInput = function (clearableInput) {
	      _this.clearableInput = clearableInput;
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, function () {
	        _this.resizableTextArea.resizeTextarea();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          onPressEnter = _this$props.onPressEnter,
	          onKeyDown = _this$props.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.resizableTextArea.renderTextArea();
	
	        _this.focus();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.renderTextArea = function (prefixCls) {
	      return /*#__PURE__*/React.createElement(_ResizableTextArea["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        onKeyDown: _this.handleKeyDown,
	        onChange: _this.handleChange,
	        ref: _this.saveTextArea
	      }));
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        inputType: "text",
	        value: (0, _Input.fixControlledValue)(value),
	        element: _this.renderTextArea(prefixCls),
	        handleReset: _this.handleReset,
	        ref: _this.saveClearableInput
	      }));
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(TextArea, [{
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.resizableTextArea.textArea.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.resizableTextArea.textArea.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(TextArea);
	var _default = TextArea;
	exports["default"] = _default;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateNodeStyling = calculateNodeStyling;
	exports["default"] = calculateNodeHeight;
	// Thanks to https://github.com/andreypopp/react-textarea-autosize/
	
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	var computedStyleCache = {};
	var hiddenTextarea;
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	  var sizingStyle = SIZING_STYLE.map(function (name) {
	    return "".concat(name, ":").concat(style.getPropertyValue(name));
	  }).join(';');
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  } // Fix wrap="off" issue
	  // https://github.com/ant-design/ant-design/issues/6577
	
	
	  if (uiTextNode.getAttribute('wrap')) {
	    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
	  } else {
	    hiddenTextarea.removeAttribute('wrap');
	  } // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	
	  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
	  var minHeight = Number.MIN_SAFE_INTEGER;
	  var maxHeight = Number.MAX_SAFE_INTEGER;
	  var height = hiddenTextarea.scrollHeight;
	  var overflowY;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height += borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height -= paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = ' ';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	
	      height = Math.max(minHeight, height);
	    }
	
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	
	      overflowY = height > maxHeight ? '' : 'hidden';
	      height = Math.min(maxHeight, height);
	    }
	  }
	
	  return {
	    height: height,
	    minHeight: minHeight,
	    maxHeight: maxHeight,
	    overflowY: overflowY
	  };
	}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.LayoutContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(29));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var LayoutContext = (0, _createReactContext["default"])({
	  siderHook: {
	    addSider: function addSider() {
	      return null;
	    },
	    removeSider: function removeSider() {
	      return null;
	    }
	  }
	});
	exports.LayoutContext = LayoutContext;
	
	function generator(_ref) {
	  var suffixCls = _ref.suffixCls,
	      tagName = _ref.tagName,
	      displayName = _ref.displayName;
	  return function (BasicComponent) {
	    var _a;
	
	    return _a = /*#__PURE__*/function (_React$Component) {
	      _inherits(Adapter, _React$Component);
	
	      var _super = _createSuper(Adapter);
	
	      function Adapter() {
	        var _this;
	
	        _classCallCheck(this, Adapter);
	
	        _this = _super.apply(this, arguments);
	
	        _this.renderComponent = function (_ref2) {
	          var getPrefixCls = _ref2.getPrefixCls;
	          var customizePrefixCls = _this.props.prefixCls;
	          var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
	          return /*#__PURE__*/React.createElement(BasicComponent, _extends({
	            prefixCls: prefixCls,
	            tagName: tagName
	          }, _this.props));
	        };
	
	        return _this;
	      }
	
	      _createClass(Adapter, [{
	        key: "render",
	        value: function render() {
	          return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
	        }
	      }]);
	
	      return Adapter;
	    }(React.Component), _a.displayName = displayName, _a;
	  };
	}
	
	var Basic = function Basic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      children = props.children,
	      tagName = props.tagName,
	      others = __rest(props, ["prefixCls", "className", "children", "tagName"]);
	
	  var classString = (0, _classnames["default"])(className, prefixCls);
	  return /*#__PURE__*/React.createElement(tagName, _extends({
	    className: classString
	  }, others), children);
	};
	
	var BasicLayout = /*#__PURE__*/function (_React$Component2) {
	  _inherits(BasicLayout, _React$Component2);
	
	  var _super2 = _createSuper(BasicLayout);
	
	  function BasicLayout() {
	    var _this2;
	
	    _classCallCheck(this, BasicLayout);
	
	    _this2 = _super2.apply(this, arguments);
	    _this2.state = {
	      siders: []
	    };
	    return _this2;
	  }
	
	  _createClass(BasicLayout, [{
	    key: "getSiderHook",
	    value: function getSiderHook() {
	      var _this3 = this;
	
	      return {
	        addSider: function addSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: [].concat(_toConsumableArray(state.siders), [id])
	            };
	          });
	        },
	        removeSider: function removeSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: state.siders.filter(function (currentId) {
	                return currentId !== id;
	              })
	            };
	          });
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          prefixCls = _a.prefixCls,
	          className = _a.className,
	          children = _a.children,
	          hasSider = _a.hasSider,
	          Tag = _a.tagName,
	          others = __rest(_a, ["prefixCls", "className", "children", "hasSider", "tagName"]);
	
	      var classString = (0, _classnames["default"])(className, prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : this.state.siders.length > 0));
	      return /*#__PURE__*/React.createElement(LayoutContext.Provider, {
	        value: {
	          siderHook: this.getSiderHook()
	        }
	      }, /*#__PURE__*/React.createElement(Tag, _extends({
	        className: classString
	      }, others), children));
	    }
	  }]);
	
	  return BasicLayout;
	}(React.Component);
	
	var Layout = generator({
	  suffixCls: 'layout',
	  tagName: 'section',
	  displayName: 'Layout'
	})(BasicLayout);
	var Header = generator({
	  suffixCls: 'layout-header',
	  tagName: 'header',
	  displayName: 'Header'
	})(Basic);
	var Footer = generator({
	  suffixCls: 'layout-footer',
	  tagName: 'footer',
	  displayName: 'Footer'
	})(Basic);
	var Content = generator({
	  suffixCls: 'layout-content',
	  tagName: 'main',
	  displayName: 'Content'
	})(Basic);
	Layout.Header = Header;
	Layout.Footer = Footer;
	Layout.Content = Content;
	var _default = Layout;
	exports["default"] = _default;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcMenu = __webpack_require__(52);
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(41));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(45));
	
	var _Sider = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var MenuItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  var _super = _createSuper(MenuItem);
	
	  function MenuItem() {
	    var _this;
	
	    _classCallCheck(this, MenuItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.menuItem.onKeyDown(e);
	    };
	
	    _this.saveMenuItem = function (menuItem) {
	      _this.menuItem = menuItem;
	    };
	
	    _this.renderItem = function (_ref) {
	      var siderCollapsed = _ref.siderCollapsed;
	      var _this$props = _this.props,
	          level = _this$props.level,
	          children = _this$props.children,
	          rootPrefixCls = _this$props.rootPrefixCls;
	
	      var _a = _this.props,
	          title = _a.title,
	          rest = __rest(_a, ["title"]);
	
	      return /*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref2) {
	        var inlineCollapsed = _ref2.inlineCollapsed;
	        var tooltipProps = {
	          title: title || (level === 1 ? children : '')
	        };
	
	        if (!siderCollapsed && !inlineCollapsed) {
	          tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct
	          // ref: https://github.com/ant-design/ant-design/issues/16742
	
	          tooltipProps.visible = false;
	        }
	
	        return /*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, tooltipProps, {
	          placement: "right",
	          overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
	        }), /*#__PURE__*/React.createElement(_rcMenu.Item, _extends({}, rest, {
	          title: title,
	          ref: _this.saveMenuItem
	        })));
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, this.renderItem);
	    }
	  }]);
	
	  return MenuItem;
	}(React.Component);
	
	exports["default"] = MenuItem;
	MenuItem.isMenuItem = true;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _rcMenu = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(41));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var SubMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(SubMenu, _React$Component);
	
	  var _super = _createSuper(SubMenu);
	
	  function SubMenu() {
	    var _this;
	
	    _classCallCheck(this, SubMenu);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.subMenu.onKeyDown(e);
	    };
	
	    _this.saveSubMenu = function (subMenu) {
	      _this.subMenu = subMenu;
	    };
	
	    return _this;
	  }
	
	  _createClass(SubMenu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          rootPrefixCls = _this$props.rootPrefixCls,
	          popupClassName = _this$props.popupClassName;
	      return /*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref) {
	        var antdMenuTheme = _ref.antdMenuTheme;
	        return /*#__PURE__*/React.createElement(_rcMenu.SubMenu, _extends({}, _this2.props, {
	          ref: _this2.saveSubMenu,
	          popupClassName: (0, _classnames["default"])("".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
	        }));
	      });
	    }
	  }]);
	
	  return SubMenu;
	}(React.Component);
	
	SubMenu.contextTypes = {
	  antdMenuTheme: PropTypes.string
	}; // fix issue:https://github.com/ant-design/ant-design/issues/8666
	
	SubMenu.isSubMenu = 1;
	var _default = SubMenu;
	exports["default"] = _default;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(9));
	
	var _button = _interopRequireDefault(__webpack_require__(15));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ActionButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(ActionButton, _React$Component);
	
	  var _super = _createSuper(ActionButton);
	
	  function ActionButton(props) {
	    var _this;
	
	    _classCallCheck(this, ActionButton);
	
	    _this = _super.call(this, props);
	
	    _this.onClick = function () {
	      var _this$props = _this.props,
	          actionFn = _this$props.actionFn,
	          closeModal = _this$props.closeModal;
	
	      if (actionFn) {
	        var ret;
	
	        if (actionFn.length) {
	          ret = actionFn(closeModal);
	        } else {
	          ret = actionFn();
	
	          if (!ret) {
	            closeModal();
	          }
	        }
	
	        if (ret && ret.then) {
	          _this.setState({
	            loading: true
	          });
	
	          ret.then(function () {
	            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
	            // this.setState({ loading: false });
	            closeModal.apply(void 0, arguments);
	          }, function (e) {
	            // Emit error when catch promise reject
	            // eslint-disable-next-line no-console
	            console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183
	
	            _this.setState({
	              loading: false
	            });
	          });
	        }
	      } else {
	        closeModal();
	      }
	    };
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(ActionButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoFocus) {
	        var $this = ReactDOM.findDOMNode(this);
	        this.timeoutId = setTimeout(function () {
	          return $this.focus();
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          type = _this$props2.type,
	          children = _this$props2.children,
	          buttonProps = _this$props2.buttonProps;
	      var loading = this.state.loading;
	      return /*#__PURE__*/React.createElement(_button["default"], _extends({
	        type: type,
	        onClick: this.onClick,
	        loading: loading
	      }, buttonProps), children);
	    }
	  }]);
	
	  return ActionButton;
	}(React.Component);
	
	exports["default"] = ActionButton;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = confirm;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(9));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(68));
	
	var _ActionButton = _interopRequireDefault(__webpack_require__(136));
	
	var _locale = __webpack_require__(99);
	
	var _warning = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IS_REACT_16 = !!ReactDOM.createPortal;
	
	var ConfirmDialog = function ConfirmDialog(props) {
	  var onCancel = props.onCancel,
	      onOk = props.onOk,
	      close = props.close,
	      zIndex = props.zIndex,
	      afterClose = props.afterClose,
	      visible = props.visible,
	      keyboard = props.keyboard,
	      centered = props.centered,
	      getContainer = props.getContainer,
	      maskStyle = props.maskStyle,
	      okButtonProps = props.okButtonProps,
	      cancelButtonProps = props.cancelButtonProps,
	      _props$iconType = props.iconType,
	      iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
	  (0, _warning["default"])(!('iconType' in props), 'Modal', "The property 'iconType' is deprecated. Use the property 'icon' instead."); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
	
	  var icon = props.icon === undefined ? iconType : props.icon;
	  var okType = props.okType || 'primary';
	  var prefixCls = props.prefixCls || 'ant-modal';
	  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容
	
	  var okCancel = 'okCancel' in props ? props.okCancel : true;
	  var width = props.width || 416;
	  var style = props.style || {};
	  var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为
	
	  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
	  var runtimeLocale = (0, _locale.getConfirmLocale)();
	  var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
	  var cancelText = props.cancelText || runtimeLocale.cancelText;
	  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
	  var transitionName = props.transitionName || 'zoom';
	  var maskTransitionName = props.maskTransitionName || 'fade';
	  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
	  var cancelButton = okCancel && /*#__PURE__*/React.createElement(_ActionButton["default"], {
	    actionFn: onCancel,
	    closeModal: close,
	    autoFocus: autoFocusButton === 'cancel',
	    buttonProps: cancelButtonProps
	  }, cancelText);
	  var iconNode = typeof icon === 'string' ? /*#__PURE__*/React.createElement(_icon["default"], {
	    type: icon
	  }) : icon;
	  return /*#__PURE__*/React.createElement(_Modal["default"], {
	    prefixCls: prefixCls,
	    className: classString,
	    wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
	    onCancel: function onCancel() {
	      return close({
	        triggerCancel: true
	      });
	    },
	    visible: visible,
	    title: "",
	    transitionName: transitionName,
	    footer: "",
	    maskTransitionName: maskTransitionName,
	    mask: mask,
	    maskClosable: maskClosable,
	    maskStyle: maskStyle,
	    style: style,
	    width: width,
	    zIndex: zIndex,
	    afterClose: afterClose,
	    keyboard: keyboard,
	    centered: centered,
	    getContainer: getContainer
	  }, /*#__PURE__*/React.createElement("div", {
	    className: "".concat(contentPrefixCls, "-body-wrapper")
	  }, /*#__PURE__*/React.createElement("div", {
	    className: "".concat(contentPrefixCls, "-body")
	  }, iconNode, props.title === undefined ? null : /*#__PURE__*/React.createElement("span", {
	    className: "".concat(contentPrefixCls, "-title")
	  }, props.title), /*#__PURE__*/React.createElement("div", {
	    className: "".concat(contentPrefixCls, "-content")
	  }, props.content)), /*#__PURE__*/React.createElement("div", {
	    className: "".concat(contentPrefixCls, "-btns")
	  }, cancelButton, /*#__PURE__*/React.createElement(_ActionButton["default"], {
	    type: okType,
	    actionFn: onOk,
	    closeModal: close,
	    autoFocus: autoFocusButton === 'ok',
	    buttonProps: okButtonProps
	  }, okText))));
	};
	
	function confirm(config) {
	  var div = document.createElement('div');
	  document.body.appendChild(div); // eslint-disable-next-line no-use-before-define
	
	  var currentConfig = _extends(_extends({}, config), {
	    close: close,
	    visible: true
	  });
	
	  function destroy() {
	    var unmountResult = ReactDOM.unmountComponentAtNode(div);
	
	    if (unmountResult && div.parentNode) {
	      div.parentNode.removeChild(div);
	    }
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var triggerCancel = args.some(function (param) {
	      return param && param.triggerCancel;
	    });
	
	    if (config.onCancel && triggerCancel) {
	      config.onCancel.apply(config, args);
	    }
	
	    for (var i = 0; i < _Modal.destroyFns.length; i++) {
	      var fn = _Modal.destroyFns[i]; // eslint-disable-next-line no-use-before-define
	
	      if (fn === close) {
	        _Modal.destroyFns.splice(i, 1);
	
	        break;
	      }
	    }
	  }
	
	  function render(props) {
	    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmDialog, props), div);
	  }
	
	  function close() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    currentConfig = _extends(_extends({}, currentConfig), {
	      visible: false,
	      afterClose: destroy.bind.apply(destroy, [this].concat(args))
	    });
	
	    if (IS_REACT_16) {
	      render(currentConfig);
	    } else {
	      destroy.apply(void 0, args);
	    }
	  }
	
	  function update(newConfig) {
	    currentConfig = _extends(_extends({}, currentConfig), newConfig);
	    render(currentConfig);
	  }
	
	  render(currentConfig);
	
	  _Modal.destroyFns.push(close);
	
	  return {
	    destroy: close,
	    update: update
	  };
	}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(68));
	
	var _confirm = _interopRequireDefault(__webpack_require__(137));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function modalWarn(props) {
	  var config = _extends({
	    type: 'warning',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "exclamation-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	}
	
	_Modal["default"].info = function infoFn(props) {
	  var config = _extends({
	    type: 'info',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "info-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].success = function successFn(props) {
	  var config = _extends({
	    type: 'success',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "check-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].error = function errorFn(props) {
	  var config = _extends({
	    type: 'error',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "close-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].warning = modalWarn;
	_Modal["default"].warn = modalWarn;
	
	_Modal["default"].confirm = function confirmFn(props) {
	  var config = _extends({
	    type: 'confirm',
	    okCancel: true
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].destroyAll = function destroyAllFn() {
	  while (_Modal.destroyFns.length) {
	    var close = _Modal.destroyFns.pop();
	
	    if (close) {
	      close();
	    }
	  }
	};
	
	var _default = _Modal["default"];
	exports["default"] = _default;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(231);
	
	__webpack_require__(17);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(45));
	
	var _configProvider = __webpack_require__(7);
	
	var _warning = _interopRequireDefault(__webpack_require__(21));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popover = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popover, _React$Component);
	
	  var _super = _createSuper(Popover);
	
	  function Popover() {
	    var _this;
	
	    _classCallCheck(this, Popover);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderPopover = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          props = __rest(_a, ["prefixCls"]);
	
	      delete props.title;
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      return /*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, props, {
	        prefixCls: prefixCls,
	        ref: _this.saveTooltip,
	        overlay: _this.getOverlay(prefixCls)
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Popover, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay(prefixCls) {
	      var _this$props = this.props,
	          title = _this$props.title,
	          content = _this$props.content;
	      (0, _warning["default"])(!('overlay' in this.props), 'Popover', '`overlay` is removed, please use `content` instead, ' + 'see: https://u.ant.design/popover-content');
	      return /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-title")
	      }, title), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-inner-content")
	      }, content));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPopover);
	    }
	  }]);
	
	  return Popover;
	}(React.Component);
	
	exports["default"] = Popover;
	Popover.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big',
	  trigger: 'hover',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  overlayStyle: {}
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(232);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(34));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _radio = _interopRequireDefault(__webpack_require__(42));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function getCheckedValue(children) {
	  var value = null;
	  var matched = false;
	  React.Children.forEach(children, function (radio) {
	    if (radio && radio.props && radio.props.checked) {
	      value = radio.props.value;
	      matched = true;
	    }
	  });
	  return matched ? {
	    value: value
	  } : undefined;
	}
	
	var RadioGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioGroup, _React$Component);
	
	  var _super = _createSuper(RadioGroup);
	
	  function RadioGroup(props) {
	    var _this;
	
	    _classCallCheck(this, RadioGroup);
	
	    _this = _super.call(this, props);
	
	    _this.onRadioChange = function (ev) {
	      var lastValue = _this.state.value;
	      var value = ev.target.value;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange && value !== lastValue) {
	        onChange(ev);
	      }
	    };
	
	    _this.renderGroup = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className,
	          options = props.options,
	          buttonStyle = props.buttonStyle;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), _defineProperty({}, "".concat(groupPrefixCls, "-").concat(props.size), props.size), className);
	      var children = props.children; // 如果存在 options, 优先使用
	
	      if (options && options.length > 0) {
	        children = options.map(function (option) {
	          if (typeof option === 'string') {
	            // 此处类型自动推导为 string
	            return /*#__PURE__*/React.createElement(_radio["default"], {
	              key: option,
	              prefixCls: prefixCls,
	              disabled: _this.props.disabled,
	              value: option,
	              checked: _this.state.value === option
	            }, option);
	          } // 此处类型自动推导为 { label: string value: string }
	
	
	          return /*#__PURE__*/React.createElement(_radio["default"], {
	            key: "radio-group-value-options-".concat(option.value),
	            prefixCls: prefixCls,
	            disabled: option.disabled || _this.props.disabled,
	            value: option.value,
	            checked: _this.state.value === option.value
	          }, option.label);
	        });
	      }
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: classString,
	        style: props.style,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        id: props.id
	      }, children);
	    };
	
	    var value;
	
	    if ('value' in props) {
	      value = props.value;
	    } else if ('defaultValue' in props) {
	      value = props.defaultValue;
	    } else {
	      var checkedValue = getCheckedValue(props.children);
	      value = checkedValue && checkedValue.value;
	    }
	
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(RadioGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        radioGroup: {
	          onChange: this.onRadioChange,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      var checkedValue = getCheckedValue(nextProps.children);
	
	      if (checkedValue) {
	        return {
	          value: checkedValue.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return RadioGroup;
	}(React.Component);
	
	RadioGroup.defaultProps = {
	  buttonStyle: 'outline'
	};
	RadioGroup.childContextTypes = {
	  radioGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(RadioGroup);
	var _default = RadioGroup;
	exports["default"] = _default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Group", {
	  enumerable: true,
	  get: function get() {
	    return _group["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _radioButton["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _radio = _interopRequireDefault(__webpack_require__(42));
	
	var _group = _interopRequireDefault(__webpack_require__(142));
	
	var _radioButton = _interopRequireDefault(__webpack_require__(144));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_radio["default"].Button = _radioButton["default"];
	_radio["default"].Group = _group["default"];
	var _default = _radio["default"];
	exports["default"] = _default;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _radio = _interopRequireDefault(__webpack_require__(42));
	
	var _configProvider = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RadioButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioButton, _React$Component);
	
	  var _super = _createSuper(RadioButton);
	
	  function RadioButton() {
	    var _this;
	
	    _classCallCheck(this, RadioButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderRadioButton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          radioProps = __rest(_a, ["prefixCls"]);
	
	      var prefixCls = getPrefixCls('radio-button', customizePrefixCls);
	
	      if (_this.context.radioGroup) {
	        radioProps.checked = _this.props.value === _this.context.radioGroup.value;
	        radioProps.disabled = _this.props.disabled || _this.context.radioGroup.disabled;
	      }
	
	      return /*#__PURE__*/React.createElement(_radio["default"], _extends({
	        prefixCls: prefixCls
	      }, radioProps));
	    };
	
	    return _this;
	  }
	
	  _createClass(RadioButton, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadioButton);
	    }
	  }]);
	
	  return RadioButton;
	}(React.Component);
	
	exports["default"] = RadioButton;
	RadioButton.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(233);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _ScrollableInkTabBar = _interopRequireDefault(__webpack_require__(267));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var TabBar = /*#__PURE__*/function (_React$Component) {
	  _inherits(TabBar, _React$Component);
	
	  var _super = _createSuper(TabBar);
	
	  function TabBar() {
	    _classCallCheck(this, TabBar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(TabBar, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          tabBarStyle = _this$props.tabBarStyle,
	          animated = _this$props.animated,
	          renderTabBar = _this$props.renderTabBar,
	          tabBarExtraContent = _this$props.tabBarExtraContent,
	          tabPosition = _this$props.tabPosition,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          size = _this$props.size,
	          type = _this$props.type;
	      var inkBarAnimated = _typeof(animated) === 'object' ? animated.inkBar : animated;
	      var isVertical = tabPosition === 'left' || tabPosition === 'right';
	      var prevIconType = isVertical ? 'up' : 'left';
	      var nextIconType = isVertical ? 'down' : 'right';
	      var prevIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-prev-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: prevIconType,
	        className: "".concat(prefixCls, "-tab-prev-icon-target")
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-next-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: nextIconType,
	        className: "".concat(prefixCls, "-tab-next-icon-target")
	      })); // Additional className for style usage
	
	      var cls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-bar"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size, "-bar"), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card-bar"), type && type.indexOf('card') >= 0), _classNames), className);
	
	      var renderProps = _extends(_extends({}, this.props), {
	        children: null,
	        inkBarAnimated: inkBarAnimated,
	        extraContent: tabBarExtraContent,
	        style: tabBarStyle,
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        className: cls
	      });
	
	      var RenderTabBar;
	
	      if (renderTabBar) {
	        RenderTabBar = renderTabBar(renderProps, _ScrollableInkTabBar["default"]);
	      } else {
	        RenderTabBar = /*#__PURE__*/React.createElement(_ScrollableInkTabBar["default"], renderProps);
	      }
	
	      return /*#__PURE__*/React.cloneElement(RenderTabBar);
	    }
	  }]);
	
	  return TabBar;
	}(React.Component);
	
	exports["default"] = TabBar;
	TabBar.defaultProps = {
	  animated: true,
	  type: 'line'
	};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(9));
	
	var _rcTabs = _interopRequireWildcard(__webpack_require__(272));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(90));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _omit = _interopRequireDefault(__webpack_require__(22));
	
	var _TabBar = _interopRequireDefault(__webpack_require__(146));
	
	var _icon = _interopRequireDefault(__webpack_require__(11));
	
	var _configProvider = __webpack_require__(7);
	
	var _warning = _interopRequireDefault(__webpack_require__(21));
	
	var _styleChecker = __webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Tabs = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  var _super = _createSuper(Tabs);
	
	  function Tabs() {
	    var _this;
	
	    _classCallCheck(this, Tabs);
	
	    _this = _super.apply(this, arguments);
	
	    _this.removeTab = function (targetKey, e) {
	      e.stopPropagation();
	
	      if (!targetKey) {
	        return;
	      }
	
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'remove');
	      }
	    };
	
	    _this.handleChange = function (activeKey) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(activeKey);
	      }
	    };
	
	    _this.createNewTab = function (targetKey) {
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'add');
	      }
	    };
	
	    _this.renderTabs = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          size = _this$props.size,
	          _this$props$type = _this$props.type,
	          type = _this$props$type === void 0 ? 'line' : _this$props$type,
	          tabPosition = _this$props.tabPosition,
	          children = _this$props.children,
	          _this$props$animated = _this$props.animated,
	          animated = _this$props$animated === void 0 ? true : _this$props$animated,
	          hideAdd = _this$props.hideAdd;
	      var tabBarExtraContent = _this.props.tabBarExtraContent;
	      var tabPaneAnimated = _typeof(animated) === 'object' ? animated.tabPane : animated; // card tabs should not have animation
	
	      if (type !== 'line') {
	        tabPaneAnimated = 'animated' in _this.props ? tabPaneAnimated : false;
	      }
	
	      (0, _warning["default"])(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), 'Tabs', "`type=card|editable-card` doesn't have small or large size, it's by design.");
	      var prefixCls = getPrefixCls('tabs', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), tabPosition === 'left' || tabPosition === 'right'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card"), type.indexOf('card') >= 0), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), true), _defineProperty(_classNames, "".concat(prefixCls, "-no-animation"), !tabPaneAnimated), _classNames)); // only card type tabs can be added and closed
	
	      var childrenWithClose = [];
	
	      if (type === 'editable-card') {
	        childrenWithClose = [];
	        React.Children.forEach(children, function (child, index) {
	          if (! /*#__PURE__*/React.isValidElement(child)) return child;
	          var closable = child.props.closable;
	          closable = typeof closable === 'undefined' ? true : closable;
	          var closeIcon = closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "close",
	            className: "".concat(prefixCls, "-close-x"),
	            onClick: function onClick(e) {
	              return _this.removeTab(child.key, e);
	            }
	          }) : null;
	          childrenWithClose.push( /*#__PURE__*/React.cloneElement(child, {
	            tab: /*#__PURE__*/React.createElement("div", {
	              className: closable ? undefined : "".concat(prefixCls, "-tab-unclosable")
	            }, child.props.tab, closeIcon),
	            key: child.key || index
	          }));
	        }); // Add new tab handler
	
	        if (!hideAdd) {
	          tabBarExtraContent = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "plus",
	            className: "".concat(prefixCls, "-new-tab"),
	            onClick: _this.createNewTab
	          }), tabBarExtraContent);
	        }
	      }
	
	      tabBarExtraContent = tabBarExtraContent ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra-content")
	      }, tabBarExtraContent) : null;
	
	      var tabBarProps = __rest(_this.props, []);
	
	      var contentCls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-content"), type.indexOf('card') >= 0 && "".concat(prefixCls, "-card-content"));
	      return /*#__PURE__*/React.createElement(_rcTabs["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        className: cls,
	        tabBarPosition: tabPosition,
	        renderTabBar: function renderTabBar() {
	          return /*#__PURE__*/React.createElement(_TabBar["default"], _extends({}, (0, _omit["default"])(tabBarProps, ['className']), {
	            tabBarExtraContent: tabBarExtraContent
	          }));
	        },
	        renderTabContent: function renderTabContent() {
	          return /*#__PURE__*/React.createElement(_TabContent["default"], {
	            className: contentCls,
	            animated: tabPaneAnimated,
	            animatedWithMargin: true
	          });
	        },
	        onChange: _this.handleChange
	      }), childrenWithClose.length > 0 ? childrenWithClose : children);
	    };
	
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var NO_FLEX = ' no-flex';
	      var tabNode = ReactDOM.findDOMNode(this);
	
	      if (tabNode && !_styleChecker.isFlexSupported && tabNode.className.indexOf(NO_FLEX) === -1) {
	        tabNode.className += NO_FLEX;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTabs);
	    }
	  }]);
	
	  return Tabs;
	}(React.Component);
	
	exports["default"] = Tabs;
	Tabs.TabPane = _rcTabs.TabPane;
	Tabs.defaultProps = {
	  hideAdd: false,
	  tabPosition: 'top'
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(14);
	
	__webpack_require__(234);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOverflowOptions = getOverflowOptions;
	exports["default"] = getPlacements;
	
	var _placements = __webpack_require__(92);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var autoAdjustOverflowEnabled = {
	  adjustX: 1,
	  adjustY: 1
	};
	var autoAdjustOverflowDisabled = {
	  adjustX: 0,
	  adjustY: 0
	};
	var targetOffset = [0, 0];
	
	function getOverflowOptions(autoAdjustOverflow) {
	  if (typeof autoAdjustOverflow === 'boolean') {
	    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
	  }
	
	  return _extends(_extends({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
	}
	
	function getPlacements() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$arrowWidth = config.arrowWidth,
	      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
	      _config$horizontalArr = config.horizontalArrowShift,
	      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
	      _config$verticalArrow = config.verticalArrowShift,
	      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
	      _config$autoAdjustOve = config.autoAdjustOverflow,
	      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
	  var placementMap = {
	    left: {
	      points: ['cr', 'cl'],
	      offset: [-4, 0]
	    },
	    right: {
	      points: ['cl', 'cr'],
	      offset: [4, 0]
	    },
	    top: {
	      points: ['bc', 'tc'],
	      offset: [0, -4]
	    },
	    bottom: {
	      points: ['tc', 'bc'],
	      offset: [0, 4]
	    },
	    topLeft: {
	      points: ['bl', 'tc'],
	      offset: [-(horizontalArrowShift + arrowWidth), -4]
	    },
	    leftTop: {
	      points: ['tr', 'cl'],
	      offset: [-4, -(verticalArrowShift + arrowWidth)]
	    },
	    topRight: {
	      points: ['br', 'tc'],
	      offset: [horizontalArrowShift + arrowWidth, -4]
	    },
	    rightTop: {
	      points: ['tl', 'cr'],
	      offset: [4, -(verticalArrowShift + arrowWidth)]
	    },
	    bottomRight: {
	      points: ['tr', 'bc'],
	      offset: [horizontalArrowShift + arrowWidth, 4]
	    },
	    rightBottom: {
	      points: ['bl', 'cr'],
	      offset: [4, verticalArrowShift + arrowWidth]
	    },
	    bottomLeft: {
	      points: ['tl', 'bc'],
	      offset: [-(horizontalArrowShift + arrowWidth), 4]
	    },
	    leftBottom: {
	      points: ['br', 'cl'],
	      offset: [-4, verticalArrowShift + arrowWidth]
	    }
	  };
	  Object.keys(placementMap).forEach(function (key) {
	    placementMap[key] = config.arrowPointAtCenter ? _extends(_extends({}, placementMap[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow),
	      targetOffset: targetOffset
	    }) : _extends(_extends({}, _placements.placements[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow)
	    });
	    placementMap[key].ignoreShake = true;
	  });
	  return placementMap;
	}

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _flexDirection, _alignItems, _alignSelf, _alignContent, _justifyContent, _flexWrap, _positionType; /**
	                                                                                                        * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                        *
	                                                                                                        * This source code is licensed under the MIT license found in the
	                                                                                                        * LICENSE file in the root directory of this source tree.
	                                                                                                        */
	
	exports.default = generateCode;
	
	var _entryBrowser = __webpack_require__(20);
	
	var _entryBrowser2 = _interopRequireDefault(_entryBrowser);
	
	var _LayoutRecord = __webpack_require__(24);
	
	var _LayoutRecord2 = _interopRequireDefault(_LayoutRecord);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enumLookup = {
	  flexDirection: (_flexDirection = {}, _flexDirection[_entryBrowser2.default.FLEX_DIRECTION_COLUMN] = 'CKFlexboxDirectionVertical', _flexDirection[_entryBrowser2.default.FLEX_DIRECTION_ROW] = 'CKFlexboxDirectionHorizontal', _flexDirection[_entryBrowser2.default.FLEX_DIRECTION_COLUMN_REVERSE] = 'CKFlexboxDirectionVerticalReverse', _flexDirection[_entryBrowser2.default.FLEX_DIRECTION_ROW_REVERSE] = 'CKFlexboxDirectionHorizontalReverse', _flexDirection),
	  alignItems: (_alignItems = {}, _alignItems[_entryBrowser2.default.ALIGN_FLEX_START] = 'CKFlexboxAlignItemsStart', _alignItems[_entryBrowser2.default.ALIGN_FLEX_END] = 'CKFlexboxAlignItemsEnd', _alignItems[_entryBrowser2.default.ALIGN_CENTER] = 'CKFlexboxAlignItemsCenter', _alignItems[_entryBrowser2.default.ALIGN_BASELINE] = 'CKFlexboxAlignItemsBaseline', _alignItems[_entryBrowser2.default.ALIGN_STRETCH] = 'CKFlexboxAlignItemsStretch', _alignItems),
	  alignSelf: (_alignSelf = {}, _alignSelf[_entryBrowser2.default.ALIGN_AUTO] = 'CKFlexboxAlignSelfAuto', _alignSelf[_entryBrowser2.default.ALIGN_FLEX_START] = 'CKFlexboxAlignSelfStart', _alignSelf[_entryBrowser2.default.ALIGN_FLEX_END] = 'CKFlexboxAlignSelfEnd', _alignSelf[_entryBrowser2.default.ALIGN_CENTER] = 'CKFlexboxAlignSelfCenter', _alignSelf[_entryBrowser2.default.ALIGN_BASELINE] = 'CKFlexboxAlignSelfBaseline', _alignSelf[_entryBrowser2.default.ALIGN_STRETCH] = 'CKFlexboxAlignSelfStretch', _alignSelf),
	  alignContent: (_alignContent = {}, _alignContent[_entryBrowser2.default.ALIGN_FLEX_START] = 'CKFlexboxAlignContentStart', _alignContent[_entryBrowser2.default.ALIGN_FLEX_END] = 'CKFlexboxAlignContentEnd', _alignContent[_entryBrowser2.default.ALIGN_CENTER] = 'CKFlexboxAlignContentCenter', _alignContent[_entryBrowser2.default.ALIGN_SPACE_BETWEEN] = 'CKFlexboxAlignContentSpaceBetween', _alignContent[_entryBrowser2.default.ALIGN_SPACE_AROUND] = 'CKFlexboxAlignContentSpaceAround', _alignContent[_entryBrowser2.default.ALIGN_STRETCH] = 'CKFlexboxAlignContentStretch', _alignContent),
	  justifyContent: (_justifyContent = {}, _justifyContent[_entryBrowser2.default.JUSTIFY_FLEX_START] = 'CKFlexboxJustifyContentStart', _justifyContent[_entryBrowser2.default.JUSTIFY_CENTER] = 'CKFlexboxJustifyContentCenter', _justifyContent[_entryBrowser2.default.JUSTIFY_FLEX_END] = 'CKFlexboxJustifyContentEnd', _justifyContent[_entryBrowser2.default.JUSTIFY_SPACE_BETWEEN] = 'CKFlexboxJustifyContentSpaceBetween', _justifyContent[_entryBrowser2.default.JUSTIFY_SPACE_AROUND] = 'CKFlexboxJustifyContentSpaceAround', _justifyContent),
	  flexWrap: (_flexWrap = {}, _flexWrap[_entryBrowser2.default.WRAP_NO_WRAP] = 'CKFlexboxWrapNoWrap', _flexWrap[_entryBrowser2.default.WRAP_WRAP] = 'CKFlexboxWrapWrap', _flexWrap[_entryBrowser2.default.WRAP_WRAP_REVERSE] = 'CKFlexboxWrapWrapReverse', _flexWrap),
	  positionType: (_positionType = {}, _positionType[_entryBrowser2.default.POSITION_TYPE_RELATIVE] = 'CKFlexboxPositionTypeRelative', _positionType[_entryBrowser2.default.POSITION_TYPE_ABSOLUTE] = 'CKFlexboxPositionTypeAbsolute', _positionType)
	};
	
	var untouchedLayout = (0, _LayoutRecord2.default)({});
	var untouchedPosition = (0, _PositionRecord2.default)({});
	
	function keyLookup(key) {
	  var keyLookup = {
	    flexWrap: 'wrap',
	    flexDirection: 'direction'
	  };
	  return keyLookup[key] || key;
	}
	
	function getValue(value) {
	  if (typeof value === 'string' && /%$/.test(value)) {
	    return 'RCRelativeDimension::Percent(' + parseFloat(value) + ')';
	  } else if (value === 'auto') {
	    return 'RCRelativeDimension::Auto()';
	  } else {
	    return String(parseFloat(value));
	  }
	}
	
	function getLayoutCode(node) {
	  var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var isRoot = arguments[2];
	
	  var lines = [];
	  var isFlexbox = node.children.size > 0;
	
	  lines.push(indent + ((isRoot ? '' : '.component = \n' + indent) + '[' + (isFlexbox ? 'CKFlexboxComponent' : 'CKComponent')));
	  lines.push(indent + ' newWithView:{}');
	  lines.push(indent + (' size:{' + getValue(node.width) + ',' + getValue(node.height) + '}'));
	
	  var CKFlexboxComponentStyle = ['direction', 'margin', 'justifyContent', 'alignItems', 'alignContent', 'wrap', 'padding', 'border'];
	  var CKFlexboxComponentChild = ['margin', 'padding', 'flexGrow', 'flexShrink', 'flexBasis', 'alignSelf', 'position'];
	
	  if (isFlexbox) {
	    // render styles
	    lines.push(indent + ' style:{');
	    indent += '\t';
	    CKFlexboxComponentStyle.forEach(function (key) {
	      var line = renderKey(node, key, indent);
	      if (line) {
	        lines.push(line);
	      }
	    });
	    indent = indent.substr(-1);
	    lines.push(indent + ' }');
	
	    // render children
	    lines.push(indent + ' children:{');
	    lines.push.apply(lines, node.children.toJSON().map(function (child) {
	      return indent + '\t{\n' + getLayoutCode(child, indent + '\t\t') + '\n' + indent + '\t},';
	    }));
	    lines.push(indent + ('}]' + (isRoot ? ';' : ',')));
	  } else {
	    lines[lines.length - 1] += '],';
	    CKFlexboxComponentChild.forEach(function (key) {
	      var line = renderKey(node, key, indent);
	      if (line) {
	        lines.push(line);
	      }
	    });
	  }
	
	  return lines.join('\n');
	}
	
	function renderKey(node, key, indent) {
	  if (node[key] instanceof _PositionRecord2.default && !node[key].equals(untouchedPosition)) {
	    var lines = [];
	    lines.push(indent + ('.' + key + ' = {'));
	
	    if (key === 'position') {
	      lines.push(indent + ('\t.type = ' + enumLookup.positionType[node.positionType] + ','));
	    }
	
	    ['top', 'start', 'end', 'bottom'].forEach(function (pKey) {
	      if (node[key][pKey]) {
	        lines.push(indent + ('\t.' + pKey + ' = ' + getValue(node[key][pKey]) + ','));
	      }
	    });
	
	    lines.push(indent + '},');
	    return lines.join('\n');
	  } else if (node[key] !== untouchedLayout[key]) {
	    if (enumLookup[key]) {
	      return indent + ('.' + keyLookup(key) + ' = ' + enumLookup[key][node[key]] + ',');
	    } else {
	      console.error('Unknown property ' + key);
	    }
	  }
	}
	
	function generateCode(root, direction) {
	  return ['CKFlexboxComponent *c =', getLayoutCode(root, '\t', true)].join('\n');
	}
	module.exports = exports['default'];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dropdown = __webpack_require__(62);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _button = __webpack_require__(15);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _modal = __webpack_require__(138);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _tooltip = __webpack_require__(45);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _menu = __webpack_require__(66);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	__webpack_require__(63);
	
	__webpack_require__(17);
	
	__webpack_require__(57);
	
	__webpack_require__(139);
	
	__webpack_require__(69);
	
	__webpack_require__(67);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prismLight = __webpack_require__(292);
	
	var _prismLight2 = _interopRequireDefault(_prismLight);
	
	var _prism = __webpack_require__(293);
	
	var _prism2 = _interopRequireDefault(_prism);
	
	var _CodeJavaScript = __webpack_require__(46);
	
	var _CodeJavaScript2 = _interopRequireDefault(_CodeJavaScript);
	
	var _CodeLitho = __webpack_require__(154);
	
	var _CodeLitho2 = _interopRequireDefault(_CodeLitho);
	
	var _CodeReactNative = __webpack_require__(155);
	
	var _CodeReactNative2 = _interopRequireDefault(_CodeReactNative);
	
	var _CodeComponentKit = __webpack_require__(152);
	
	var _CodeComponentKit2 = _interopRequireDefault(_CodeComponentKit);
	
	var _jsx = __webpack_require__(290);
	
	var _jsx2 = _interopRequireDefault(_jsx);
	
	var _java = __webpack_require__(289);
	
	var _java2 = _interopRequireDefault(_java);
	
	var _objectivec = __webpack_require__(291);
	
	var _objectivec2 = _interopRequireDefault(_objectivec);
	
	__webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//import javascript from 'react-syntax-highlighter/languages/prism/javascript';
	
	
	(0, _prismLight.registerLanguage)('jsx', _jsx2.default);
	//registerLanguage('javascript', javascript);
	(0, _prismLight.registerLanguage)('java', _java2.default);
	(0, _prismLight.registerLanguage)('objectivec', _objectivec2.default);
	
	var LANGUAGES = {
	  litho: {
	    title: 'Litho',
	    generator: _CodeLitho2.default,
	    syntax: 'java'
	  },
	  componentKit: {
	    title: 'ComponentKit',
	    generator: _CodeComponentKit2.default,
	    syntax: 'objectivec'
	  },
	  reactNative: {
	    title: 'React Native',
	    generator: _CodeReactNative2.default,
	    syntax: 'jsx'
	  }
	};
	['Litho', 'ComponentKit', 'React Native'];
	
	var CodeGenerators = function (_Component) {
	  _inherits(CodeGenerators, _Component);
	
	  function CodeGenerators() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CodeGenerators);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      showModal: null,
	      copied: false
	    }, _this.onClick = function (_ref) {
	      var key = _ref.key;
	
	      _this.setState({ showModal: key });
	      if (window.ga) {
	        window.ga('send', {
	          hitType: 'event',
	          eventCategory: 'CodeGenerators',
	          eventAction: 'show',
	          eventLabel: key
	        });
	      }
	    }, _this.onCopy = function () {
	      if (_this._ref) {
	        _this._ref.select();
	        document.execCommand('Copy');
	        _this.setState({ copied: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CodeGenerators.prototype.render = function render() {
	    var _this2 = this;
	
	    var showModal = this.state.showModal;
	
	
	    var menu = _react2.default.createElement(
	      _menu2.default,
	      { onClick: this.onClick },
	      Object.keys(LANGUAGES).map(function (key) {
	        return _react2.default.createElement(
	          _menu2.default.Item,
	          { key: key },
	          LANGUAGES[key].title
	        );
	      })
	    );
	
	    var code = showModal ? LANGUAGES[showModal].generator(this.props.layoutDefinition, this.props.direction) : '';
	
	    return [_react2.default.createElement(
	      _modal2.default,
	      {
	        key: 'modal',
	        title: showModal ? _react2.default.createElement(
	          'div',
	          { className: 'CodeGeneratorsTitle' },
	          LANGUAGES[showModal].title,
	          _react2.default.createElement(
	            _tooltip2.default,
	            {
	              title: this.state.copied ? 'Copied!' : 'Click to copy',
	              onVisibleChange: function onVisibleChange() {
	                return _this2.setState({ copied: false });
	              } },
	            _react2.default.createElement(
	              'a',
	              { onClick: this.onCopy },
	              'copy to clipboard'
	            )
	          )
	        ) : '',
	        visible: Boolean(showModal),
	        footer: null,
	        bodyStyle: { padding: 0 },
	        onCancel: function onCancel() {
	          return _this2.setState({ showModal: null });
	        } },
	      showModal && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('textarea', {
	          className: 'CodeGeneratorsCopyText',
	          value: code,
	          ref: function ref(_ref2) {
	            _this2._ref = _ref2;
	          }
	        }),
	        _react2.default.createElement(
	          _prismLight2.default,
	          {
	            language: LANGUAGES[showModal].syntax,
	            style: _prism2.default,
	            customStyle: { fontSize: '13px', backgroundColor: 'white' },
	            lineNumberStyle: { userSelect: 'none', opacity: 0.5 },
	            codeTagProps: { style: { tabSize: 4 } },
	            showLineNumbers: true },
	          code
	        )
	      )
	    ), _react2.default.createElement(
	      _dropdown2.default,
	      { overlay: menu, key: 'dropdown', trigger: ['click'] },
	      _react2.default.createElement(
	        _button2.default,
	        null,
	        'Get Code ',
	        _react2.default.createElement(_icon2.default, { type: 'down' })
	      )
	    )];
	  };
	
	  return CodeGenerators;
	}(_react.Component);
	
	exports.default = CodeGenerators;
	module.exports = exports['default'];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = generateCode;
	
	var _entryBrowser = __webpack_require__(20);
	
	var _entryBrowser2 = _interopRequireDefault(_entryBrowser);
	
	var _LayoutRecord = __webpack_require__(24);
	
	var _LayoutRecord2 = _interopRequireDefault(_LayoutRecord);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	var _CodeJavaScript = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	
	function getEnum(yogaEnum, value) {
	  var enumLookup = {
	    justifyContent: 'Justify',
	    alignItems: 'Align',
	    alignContent: 'Align',
	    alignSelf: 'Align',
	    position: 'Position',
	    flexWrap: 'Wrap',
	    positionType: 'PositionType',
	    direction: 'Direction'
	  };
	
	  if (!enumLookup[yogaEnum]) {
	    return String(value);
	  } else {
	    var enumValue = Object.keys(_entryBrowser2.default).filter(function (key) {
	      return key.toLowerCase().startsWith(_CodeJavaScript.JSEnumLookup[yogaEnum].toLowerCase());
	    }).find(function (key) {
	      return _entryBrowser2.default[key] === value;
	    });
	
	    return 'Yoga' + enumLookup[yogaEnum] + '.' + (enumValue ? enumValue.replace(/^([A-Z]+)_/, '') : value);
	  }
	}
	
	function dipOrPercent(value) {
	  console.log(value);
	  return value === 'auto' ? 'Auto' : typeof value === 'string' && /%$/.test(value) ? 'Percent' : 'Dip';
	}
	
	function getValue(value) {
	  return value === 'auto' ? '' : ', ' + parseFloat(value);
	}
	
	function getLayoutCode(node) {
	  var _flexDirection;
	
	  var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var isReturning = arguments[2];
	
	  var lines = [];
	  var flexDirection = (_flexDirection = {}, _flexDirection[_entryBrowser2.default.FLEX_DIRECTION_ROW] = 'Row', _flexDirection[_entryBrowser2.default.FLEX_DIRECTION_ROW_REVERSE] = 'RowReverse', _flexDirection[_entryBrowser2.default.FLEX_DIRECTION_COLUMN] = 'Column', _flexDirection[_entryBrowser2.default.FLEX_DIRECTION_COLUMN_REVERSE] = 'ColumnReverse', _flexDirection);
	
	  lines.push(indent + ('' + (isReturning ? 'return ' : '') + flexDirection[node.flexDirection] + '.create(c)'));
	  if (node.children.size > 0) {
	    lines.push.apply(lines, node.children.toJSON().map(function (child) {
	      return indent + '\t.child(\n' + getLayoutCode(child, indent + '\t\t') + ')';
	    }));
	  }
	  var untouchedLayout = (0, _LayoutRecord2.default)();
	  var untouchedPosition = (0, _PositionRecord2.default)({});
	  Object.keys(node.toJSON()).forEach(function (key) {
	    if (node[key] instanceof _PositionRecord2.default && !node[key].equals(untouchedPosition)) {
	      if (key === 'border') {
	        lines.push(indent + '\t.border(', indent + '\t\tBorder.create(c)');
	      }
	
	      var _node$key$toJS = node[key].toJS(),
	          top = _node$key$toJS.top,
	          left = _node$key$toJS.left,
	          right = _node$key$toJS.right,
	          bottom = _node$key$toJS.bottom;
	
	      if (top !== untouchedPosition.top && top === left && top === right && top === bottom) {
	        // all edges
	        lines.push(indent + (key === 'border' ? '\t\t\t.width' + dipOrPercent(node[key].top) + '(YogaEdge.ALL' + getValue(node[key].top) + ')' : '\t.' + key + dipOrPercent(node[key].top) + '(YogaEdge.ALL' + getValue(node[key].top) + ')'));
	        return;
	      }
	      var alreadySet = [];
	      if (top !== untouchedPosition.top && top === bottom) {
	        lines.push(indent + (key === 'border' ? '\t\t\t.width' + dipOrPercent(node[key].top) + '(YogaEdge.VERTICAL' + getValue(node[key].top) + ')' : '\t.' + key + dipOrPercent(node[key].top) + '(YogaEdge.VERTICAL' + getValue(node[key].top) + ')'));
	        alreadySet.push('top', 'bottom');
	      }
	      if (left !== untouchedPosition.left && left === right) {
	        lines.push(indent + (key === 'border' ? '\t\t\t.width' + dipOrPercent(node[key].left) + '(YogaEdge.HORIZONTAL' + getValue(node[key].left) + ')' : '\t.' + key + dipOrPercent(node[key].left) + '(YogaEdge.HORIZONTAL' + getValue(node[key].left) + ')'));
	        alreadySet.push('left', 'right');
	      }
	      ['left', 'top', 'right', 'bottom'].forEach(function (pKey, i) {
	        if (node[key][pKey] !== untouchedPosition[pKey] && alreadySet.indexOf(pKey) === -1 && node[key][pKey]) {
	          lines.push(indent + (key === 'border' ? '\t\t\t.width' + dipOrPercent(node.border[pKey]) + '(YogaEdge.' + pKey.toUpperCase() + getValue(node.border[pKey]) + ')' : '\t.' + key + dipOrPercent(node[key][pKey]) + '(YogaEdge.' + pKey.toUpperCase() + getValue(node[key][pKey]) + ')'));
	        }
	      });
	
	      if (key === 'border') {
	        lines.push(indent + '\t\t\t.color(YogaEdge.ALL, 0xfff36b7f)', indent + '\t\t\t.build())');
	      }
	    } else if (key !== 'children' && key !== 'flexDirection' && node[key] !== untouchedLayout[key] && node[key]) {
	      if (node[key] === 'auto') {
	        lines.push(indent + ('\t.' + key + 'Auto(' + getEnum(key, node[key]) + ')'));
	      } else if (typeof node[key] === 'string' && /%$/.test(node[key])) {
	        lines.push(indent + ('\t.' + key + 'Percent(' + parseFloat(node[key]) + ')'));
	      } else if (['width', 'height', 'minHeight', 'maxHeight', 'minWidth', 'maxWidth', 'flexBasis'].indexOf(key) > -1) {
	        lines.push(indent + ('\t.' + key + 'Dip(' + getEnum(key, node[key]) + ')'));
	      } else {
	        lines.push(indent + ('\t.' + key + '(' + getEnum(key, node[key]) + ')'));
	      }
	    }
	  });
	
	  return lines.join('\n');
	}
	
	function generateCode(root, direction) {
	  return ['@LayoutSpec', 'public class PlaygroundComponentSpec {', '\t@OnCreateLayout', '\tstatic Component onCreateLayout(ComponentContext c) {', getLayoutCode(root, '\t\t', true), '\t\t\t.build();', '\t}', '}'].join('\n');
	}
	module.exports = exports['default'];

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = generateCode;
	
	var _entryBrowser = __webpack_require__(20);
	
	var _entryBrowser2 = _interopRequireDefault(_entryBrowser);
	
	var _LayoutRecord = __webpack_require__(24);
	
	var _LayoutRecord2 = _interopRequireDefault(_LayoutRecord);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	var _CodeJavaScript = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	
	function getValue(value) {
	  return typeof value === 'number' || /^\d+$/.test(value) ? String(value) : '\'' + value + '\'';
	}
	
	function getEnum(yogaEnum, value) {
	  console.log(yogaEnum);
	  var enumValue = Object.keys(_entryBrowser2.default).filter(function (key) {
	    return _CodeJavaScript.JSEnumLookup[yogaEnum] && key.toLowerCase().startsWith(_CodeJavaScript.JSEnumLookup[yogaEnum].toLowerCase());
	  }).find(function (key) {
	    return _entryBrowser2.default[key] === value;
	  });
	
	  return enumValue ? "'" + enumValue.replace(/^([A-Z]+)_/, '').replace('_', '-').toLowerCase() + "'" : getValue(value);
	}
	
	function getLayoutCode(node) {
	  var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var lines = [];
	  var untouchedLayout = (0, _LayoutRecord2.default)();
	  lines.push(indent + '<View style={{');
	  lines.push(indent + '  flex: 1,');
	  Object.keys(node.toJSON()).forEach(function (key) {
	    if (key === 'border' && !node.border.equals(untouchedLayout[key])) {
	      ['Top', 'Left', 'Right', 'Bottom'].forEach(function (pKey) {
	        if (untouchedLayout[key][pKey.toLowerCase()] !== node.border[pKey.toLowerCase()]) {
	          lines.push(indent + ('  border' + pKey + 'Width: ' + getValue(node.border[pKey.toLowerCase()]) + ','));
	        }
	      });
	    } else if (node[key] instanceof _PositionRecord2.default && !node[key].equals(untouchedLayout[key])) {
	      var _node$key$toJS = node[key].toJS(),
	          top = _node$key$toJS.top,
	          left = _node$key$toJS.left,
	          right = _node$key$toJS.right,
	          bottom = _node$key$toJS.bottom;
	
	      if (top && top !== untouchedLayout[key].top && top === left && top === right && top === bottom) {
	        // all edges
	        lines.push(indent + ('  ' + key + ': ' + node[key].top + ','));
	        return;
	      }
	      var alreadySet = [];
	      if (top && top !== untouchedLayout[key].top && top === bottom) {
	        lines.push(indent + ('  ' + key + 'Vertical: ' + getValue(node[key].top) + ','));
	        alreadySet.push('top', 'bottom');
	      }
	      if (left && left !== untouchedLayout[key].left && left === right) {
	        lines.push(indent + ('  ' + key + 'Horizontal: ' + getValue(node[key].left) + ','));
	        alreadySet.push('left', 'right');
	      }
	      ['left', 'top', 'right', 'bottom'].forEach(function (pKey, i) {
	        if (node[key][pKey] !== untouchedLayout[key][pKey] && alreadySet.indexOf(pKey) === -1 && node[key][pKey] && !Number.isNaN(node[key][pKey])) {
	          lines.push(indent + ('  ' + key + pKey[0].toUpperCase() + pKey.substr(1) + ': ' + getValue(node[key][pKey]) + ','));
	        }
	      });
	    } else if (key === 'positionType' && node[key] === _entryBrowser2.default.POSITION_TYPE_ABSOLUTE) {
	      lines.push(indent + '  position: \'absolute\',');
	    } else if (key !== 'children' && node[key] !== untouchedLayout[key] && node[key]) {
	      lines.push(indent + ('  ' + key + ': ' + getEnum(key, node[key]) + ','));
	    }
	  });
	  if (node.children.size > 0) {
	    lines.push(indent + '}}>');
	  } else {
	    lines.push(indent + '}} />');
	  }
	  if (node.children.size > 0) {
	    lines.push.apply(lines, node.children.toJSON().map(function (child) {
	      return getLayoutCode(child, indent + '  ');
	    }));
	  }
	  if (node.children.size > 0) {
	    lines.push(indent + '</View>');
	  }
	  return lines.join('\n');
	}
	
	function generateCode(root, direction) {
	  return ['import React, {Component} from \'react\';', 'import {View} from \'react-native\';', '', 'export default class MyLayout extends Component {', '  render() {', '    return (', getLayoutCode(root, '      '), '    );', '  }', '};'].join('\n');
	}
	module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _button = __webpack_require__(15);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _row = __webpack_require__(43);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(37);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _tabs = __webpack_require__(147);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	__webpack_require__(17);
	
	__webpack_require__(44);
	
	__webpack_require__(38);
	
	__webpack_require__(148);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EditValue = __webpack_require__(100);
	
	var _EditValue2 = _interopRequireDefault(_EditValue);
	
	var _InfoText = __webpack_require__(157);
	
	var _InfoText2 = _interopRequireDefault(_InfoText);
	
	__webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var TabPane = _tabs2.default.TabPane;
	
	var Editor = function (_Component) {
	  _inherits(Editor, _Component);
	
	  function Editor() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Editor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onKeyDown = function (e) {
	      if ((e.key === 'Delete' || e.key === 'Backspace') && _this.props.onRemove && !(e.target instanceof HTMLInputElement)) {
	        _this.props.onRemove();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Editor.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('keydown', this.onKeyDown);
	  };
	
	  Editor.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('keydown', this.onKeyDown);
	  };
	
	  Editor.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        node = _props.node,
	        selectedNodeIsRoot = _props.selectedNodeIsRoot;
	
	    var disabled = !Boolean(node);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'Editor' },
	      _react2.default.createElement(
	        _tabs2.default,
	        { defaultActiveKey: '1', className: 'EditorTabs' },
	        _react2.default.createElement(
	          TabPane,
	          { tab: 'Flex', key: '1' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Direction',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/layout-direction' },
	              'Defines the direction of which text and items are laid out'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            property: 'direction',
	            value: this.props.direction,
	            onChange: this.props.onChangeSetting
	          }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Flex Direction',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/flex-direction' },
	              'Defines the direction of the main-axis'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            disabled: disabled,
	            property: 'flexDirection',
	            value: node ? node.flexDirection : undefined,
	            onChange: this.props.onChangeLayout
	          }),
	          _react2.default.createElement(
	            _row2.default,
	            { gutter: 15, style: { marginTop: 30 } },
	            _react2.default.createElement(
	              _col2.default,
	              { span: 8 },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Basis',
	                _react2.default.createElement(
	                  _InfoText2.default,
	                  { doclink: '/docs/flex' },
	                  'Default size of a node along the main axis'
	                )
	              ),
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                property: 'flexBasis',
	                placeholder: 'auto',
	                disabled: disabled || selectedNodeIsRoot,
	                value: node ? node.flexBasis : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              { span: 8 },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Grow',
	                _react2.default.createElement(
	                  _InfoText2.default,
	                  { doclink: '/docs/flex' },
	                  'The factor of remaining space should be given to this node'
	                )
	              ),
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                property: 'flexGrow',
	                placeholder: '0',
	                disabled: disabled || selectedNodeIsRoot,
	                value: node ? node.flexGrow : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              { span: 8 },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Shrink',
	                _react2.default.createElement(
	                  _InfoText2.default,
	                  { doclink: '/docs/flex' },
	                  'The shrink factor of this element if parent has no space left'
	                )
	              ),
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                property: 'flexShrink',
	                placeholder: '1',
	                disabled: disabled || selectedNodeIsRoot,
	                value: node ? node.flexShrink : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Flex Wrap',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/flex-wrap' },
	              'Wrapping behaviour when child nodes don\'t fit into a single line'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            disabled: disabled,
	            property: 'flexWrap',
	            value: node ? node.flexWrap : undefined,
	            onChange: this.props.onChangeLayout
	          })
	        ),
	        _react2.default.createElement(
	          TabPane,
	          { tab: 'Alignment', key: '2' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Justify Content',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/justify-content' },
	              'Aligns child nodes along the main-axis'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            disabled: disabled,
	            property: 'justifyContent',
	            value: node ? node.justifyContent : undefined,
	            onChange: this.props.onChangeLayout
	          }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Align Items',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/align-items' },
	              'Aligns child nodes along the cross-axis'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            disabled: disabled,
	            property: 'alignItems',
	            value: node ? node.alignItems : undefined,
	            onChange: this.props.onChangeLayout
	          }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Align Self',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/align-items' },
	              'Override align items of parent'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            disabled: disabled || selectedNodeIsRoot,
	            property: 'alignSelf',
	            value: node ? node.alignSelf : undefined,
	            onChange: this.props.onChangeLayout
	          }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Align Content',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/align-content' },
	              'Alignment of lines along the cross-axis when wrapping'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            disabled: disabled,
	            property: 'alignContent',
	            value: node ? node.alignContent : undefined,
	            onChange: this.props.onChangeLayout
	          })
	        ),
	        _react2.default.createElement(
	          TabPane,
	          { tab: 'Layout', key: '3', className: 'ant-tabs-tabpane' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Width \xD7 Height',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/width-height' },
	              'Dimensions of the node'
	            )
	          ),
	          _react2.default.createElement(
	            _row2.default,
	            { gutter: 15 },
	            _react2.default.createElement(
	              _col2.default,
	              { span: 12 },
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                placeholder: 'auto',
	                property: 'width',
	                disabled: disabled,
	                value: node ? node.width : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              { span: 12 },
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                placeholder: 'auto',
	                property: 'height',
	                disabled: disabled,
	                value: node ? node.height : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Max-Width \xD7 Max-Height',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/min-max' },
	              'Maximum dimensions of the node'
	            )
	          ),
	          _react2.default.createElement(
	            _row2.default,
	            { gutter: 15 },
	            _react2.default.createElement(
	              _col2.default,
	              { span: 12 },
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                placeholder: 'none',
	                property: 'maxWidth',
	                disabled: disabled,
	                value: node ? node.maxWidth : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              { span: 12 },
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                placeholder: 'none',
	                property: 'maxHeight',
	                disabled: disabled,
	                value: node ? node.maxHeight : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Min-Width \xD7 Min-Height',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/min-max' },
	              'Minimum dimensions of the node'
	            )
	          ),
	          _react2.default.createElement(
	            _row2.default,
	            { gutter: 15 },
	            _react2.default.createElement(
	              _col2.default,
	              { span: 12 },
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                placeholder: '0',
	                property: 'minWidth',
	                disabled: disabled,
	                value: node ? node.minWidth : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              { span: 12 },
	              _react2.default.createElement(_EditValue2.default, {
	                type: 'text',
	                placeholder: '0',
	                property: 'minHeight',
	                disabled: disabled,
	                value: node ? node.minHeight : undefined,
	                onChange: this.props.onChangeLayout
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Aspect Ratio',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/aspect-ratio' },
	              'Width/Height aspect ratio of node'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            type: 'text',
	            placeholder: 'auto',
	            property: 'aspectRatio',
	            disabled: disabled,
	            value: node ? node.aspectRatio : undefined,
	            onChange: this.props.onChangeLayout
	          }),
	          ['padding', 'border', 'margin'].map(function (property) {
	            return _react2.default.createElement(_EditValue2.default, {
	              property: property,
	              key: property,
	              value: node ? node[property] : undefined,
	              onChange: _this2.props.onChangeLayout,
	              disabled: property === 'margin' && selectedNodeIsRoot
	            });
	          }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Position Type',
	            _react2.default.createElement(
	              _InfoText2.default,
	              { doclink: '/docs/absolute-relative-layout' },
	              'Relative position offsets the node from it\'s calculated position. Absolute position removes the node from the flexbox flow and positions it at the given position.'
	            )
	          ),
	          _react2.default.createElement(_EditValue2.default, {
	            disabled: disabled || selectedNodeIsRoot,
	            property: 'positionType',
	            value: node ? node.positionType : undefined,
	            onChange: this.props.onChangeLayout
	          }),
	          _react2.default.createElement(_EditValue2.default, {
	            disabled: selectedNodeIsRoot,
	            property: 'position',
	            value: node ? node.position : undefined,
	            onChange: this.props.onChangeLayout
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _row2.default,
	        { gutter: 15, className: 'EditorButtons' },
	        _react2.default.createElement(
	          _col2.default,
	          { span: 12 },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              icon: 'plus-circle-o',
	              disabled: !Boolean(this.props.onAdd),
	              onClick: this.props.onAdd,
	              type: 'primary' },
	            'add child node'
	          )
	        ),
	        _react2.default.createElement(
	          _col2.default,
	          { span: 12 },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              icon: 'close-circle-o',
	              disabled: !Boolean(this.props.onRemove),
	              onClick: this.props.onRemove,
	              type: 'danger' },
	            'remove node'
	          )
	        )
	      )
	    );
	  };
	
	  return Editor;
	}(_react.Component);
	
	exports.default = Editor;
	module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _popover = __webpack_require__(140);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(141);
	
	__webpack_require__(57);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var InfoText = function (_Component) {
	  _inherits(InfoText, _Component);
	
	  function InfoText() {
	    _classCallCheck(this, InfoText);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InfoText.prototype.render = function render() {
	    return _react2.default.createElement(
	      _popover2.default,
	      {
	        content: _react2.default.createElement(
	          'div',
	          { className: 'InfoText' },
	          _react2.default.createElement(
	            'p',
	            null,
	            this.props.children
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'docs-link', to: this.props.doclink },
	            'DOCUMENTATION'
	          )
	        ),
	        trigger: 'hover' },
	      _react2.default.createElement(_icon2.default, { className: 'InfoTextIcon', type: 'info-circle-o' })
	    );
	  };
	
	  return InfoText;
	}(_react.Component);
	
	exports.default = InfoText;
	module.exports = exports['default'];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	__webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var PositionGuide = function (_Component) {
	  _inherits(PositionGuide, _Component);
	
	  function PositionGuide() {
	    _classCallCheck(this, PositionGuide);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PositionGuide.prototype.render = function render() {
	    var _props = this.props,
	        position = _props.position,
	        offset = _props.offset,
	        inset = _props.inset,
	        color = _props.color,
	        reverse = _props.reverse;
	    var top = position.top,
	        left = position.left,
	        right = position.right,
	        bottom = position.bottom;
	    var oTop = offset.top,
	        oLeft = offset.left,
	        oRight = offset.right,
	        oBottom = offset.bottom;
	
	
	    if (reverse) {
	      var temp1 = left;
	      left = right;
	      right = temp1;
	      temp1 = oLeft;
	      oLeft = oRight;
	      oRight = temp1;
	    }
	
	    if (!top) {
	      top = 0;
	    }
	    if (!left) {
	      left = 0;
	    }
	    if (!right) {
	      right = 0;
	    }
	    if (!bottom) {
	      bottom = 0;
	    }
	    if (!oTop) {
	      oTop = 0;
	    }
	    if (!oLeft) {
	      oLeft = 0;
	    }
	    if (!oRight) {
	      oRight = 0;
	    }
	    if (!oBottom) {
	      oBottom = 0;
	    }
	
	    if (!inset) {
	      if (top < 0) {
	        bottom -= top;
	        top = 0;
	      }
	      if (bottom < 0) {
	        top -= bottom;
	        bottom = 0;
	      }
	      if (left < 0) {
	        right -= left;
	        left = 0;
	      }
	      if (right < 0) {
	        left -= right;
	        right = 0;
	      }
	    }
	
	    return [top !== 0 ? _react2.default.createElement(
	      'div',
	      {
	        key: 'top',
	        className: 'PositionGuide',
	        style: {
	          backgroundColor: color,
	          height: top,
	          top: inset ? oTop : -top - oTop,
	          left: inset ? left + oLeft : -left - oLeft,
	          right: inset ? right + oRight : -right - oRight
	        } },
	      top
	    ) : null, left !== 0 ? _react2.default.createElement(
	      'div',
	      {
	        key: 'left',
	        className: 'PositionGuide',
	        style: {
	          backgroundColor: color,
	          width: left,
	          top: inset ? oTop : -oTop,
	          bottom: inset ? oBottom : -oBottom,
	          left: inset ? oLeft : -left - oLeft
	        } },
	      left
	    ) : null, right !== 0 ? _react2.default.createElement(
	      'div',
	      {
	        key: 'right',
	        className: 'PositionGuide',
	        style: {
	          backgroundColor: color,
	          width: right,
	          top: inset ? oTop : -oTop,
	          bottom: inset ? oBottom : -oBottom,
	          right: inset ? oRight : -right - oRight
	        } },
	      right
	    ) : null, bottom !== 0 ? _react2.default.createElement(
	      'div',
	      {
	        key: 'bottom',
	        className: 'PositionGuide',
	        style: {
	          backgroundColor: color,
	          height: bottom,
	          bottom: inset ? oBottom : -bottom - oBottom,
	          left: inset ? left + oLeft : -left - oLeft,
	          right: inset ? right + oRight : -right - oRight
	        } },
	      bottom
	    ) : null];
	  };
	
	  return PositionGuide;
	}(_react.Component);
	
	PositionGuide.defaultProps = {
	  offset: (0, _PositionRecord2.default)({})
	};
	exports.default = PositionGuide;
	module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Sidebar = function (_Component) {
	  _inherits(Sidebar, _Component);
	
	  function Sidebar() {
	    _classCallCheck(this, Sidebar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Sidebar.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Sidebar', style: { width: this.props.width } },
	      this.props.children
	    );
	  };
	
	  return Sidebar;
	}(_react.Component);
	
	exports.default = Sidebar;
	module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _button = __webpack_require__(15);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _input = __webpack_require__(39);
	
	var _input2 = _interopRequireDefault(_input);
	
	__webpack_require__(17);
	
	__webpack_require__(40);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var URLShortener = function (_Component) {
	  _inherits(URLShortener, _Component);
	
	  function URLShortener() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, URLShortener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._ref = null, _this.state = {
	      loading: false,
	      shortURL: null
	    }, _this.onHashChange = function () {
	      _this.setState({ shortURL: null });
	    }, _this.onClick = function () {
	      _this.setState({
	        loading: true
	      }, function () {
	        if (window.ga) {
	          window.ga('send', {
	            hitType: 'event',
	            eventCategory: 'URLShortener',
	            eventAction: 'created'
	          });
	        }
	
	        fetch('https://cors-anywhere.herokuapp.com/tinyurl.com/api-create.php?url=' + window.location.href).then(function (res) {
	          return res.text();
	        }).then(function (shortURL) {
	          return _this.setState({ shortURL: shortURL, loading: false });
	        }).catch(function () {
	          return _this.setState({ shortURL: null, loading: false });
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  URLShortener.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('popstate', this.onHashChange);
	  };
	
	  URLShortener.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('popstate', this.onHashChange);
	  };
	
	  URLShortener.prototype.render = function render() {
	    return this.state.shortURL ? _react2.default.createElement(_input2.default, {
	      value: this.state.shortURL,
	      autoFocus: true,
	      ref: function ref(_ref) {
	        if (_ref) {
	          _ref.input.select();
	        }
	      }
	    }) : _react2.default.createElement(
	      _button2.default,
	      {
	        className: 'URLShortener',
	        onClick: this.onClick,
	        icon: 'share-alt',
	        disabled: this.state.loading,
	        type: 'primary' },
	      'Share URL'
	    );
	  };
	
	  return URLShortener;
	}(_react.Component);
	
	exports.default = URLShortener;
	module.exports = exports['default'];

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dropdown = __webpack_require__(62);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _button = __webpack_require__(15);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(11);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _menu = __webpack_require__(66);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _radio = __webpack_require__(143);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(63);
	
	__webpack_require__(17);
	
	__webpack_require__(57);
	
	__webpack_require__(67);
	
	__webpack_require__(145);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _entryBrowser = __webpack_require__(20);
	
	var _entryBrowser2 = _interopRequireDefault(_entryBrowser);
	
	__webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var RadioButton = _radio2.default.Button;
	var RadioGroup = _radio2.default.Group;
	
	var PROPERTY_LOOKUP = {
	  flexDirection: 'FLEX_DIRECTION',
	  direction: 'DIRECTION',
	  justifyContent: 'JUSTIFY',
	  alignSelf: 'ALIGN',
	  alignContent: 'ALIGN',
	  alignItems: 'ALIGN',
	  positionType: 'POSITION_TYPE',
	  flexWrap: 'WRAP'
	};
	
	var YogaEnumSelect = function (_Component) {
	  _inherits(YogaEnumSelect, _Component);
	
	  function YogaEnumSelect(_ref) {
	    var property = _ref.property;
	
	    _classCallCheck(this, YogaEnumSelect);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _initialiseProps.call(_this);
	
	    property = PROPERTY_LOOKUP[property];
	    // $FlowFixMe
	    _this.values = Object.keys(_entryBrowser2.default).map(function (key) {
	      return { key: key, value: _entryBrowser2.default[key] };
	    }).filter(function (_ref2) {
	      var key = _ref2.key;
	      return key.startsWith(property) && key !== property + '_COUNT';
	    });
	    return _this;
	  }
	
	  YogaEnumSelect.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        property = _props.property,
	        props = _objectWithoutProperties(_props, ['property']);
	
	    property = PROPERTY_LOOKUP[property];
	    var selected = this.values.find(function (_ref3) {
	      var key = _ref3.key,
	          value = _ref3.value;
	      return value === _this2.props.value;
	    });
	
	    return this.values.length > 3 ? _react2.default.createElement(
	      'div',
	      { className: 'YogaEnumSelect' },
	      _react2.default.createElement(
	        _dropdown2.default,
	        {
	          trigger: ['click'],
	          disabled: props.disabled,
	          overlay: _react2.default.createElement(
	            _menu2.default,
	            { onClick: this.handleMenuClick },
	            this.values.map(function (_ref4) {
	              var key = _ref4.key,
	                  value = _ref4.value;
	              return _react2.default.createElement(
	                _menu2.default.Item,
	                { key: key, value: value },
	                _this2.getTitle(property, key)
	              );
	            })
	          ) },
	        _react2.default.createElement(
	          _button2.default,
	          null,
	          selected ? this.getTitle(property, selected.key) : '',
	          _react2.default.createElement(_icon2.default, { type: 'down' })
	        )
	      )
	    ) : _react2.default.createElement(
	      RadioGroup,
	      _extends({}, props, {
	        onChange: function onChange(e) {
	          return _this2.props.onChange(_this2.props.property, e.target.value);
	        },
	        defaultValue: 'a',
	        className: 'YogaEnumSelect' }),
	      this.values.map(function (_ref5) {
	        var key = _ref5.key,
	            value = _ref5.value;
	        return _react2.default.createElement(
	          RadioButton,
	          { key: key, value: value },
	          _this2.getTitle(property, key)
	        );
	      })
	    );
	  };
	
	  return YogaEnumSelect;
	}(_react.Component);
	
	YogaEnumSelect.availableProperties = Object.keys(PROPERTY_LOOKUP);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleMenuClick = function (_ref6) {
	    var key = _ref6.key;
	
	    _this3.props.onChange(_this3.props.property, _entryBrowser2.default[key]);
	  };
	
	  this.getTitle = function (property, key) {
	    var replacer = new RegExp('^' + property + '_');
	    return key.replace(replacer, '').replace('_', ' ').toLowerCase();
	  };
	};
	
	exports.default = YogaEnumSelect;
	module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _entryBrowser = __webpack_require__(20);
	
	var _entryBrowser2 = _interopRequireDefault(_entryBrowser);
	
	var _PositionGuide = __webpack_require__(158);
	
	var _PositionGuide2 = _interopRequireDefault(_PositionGuide);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	var _LayoutRecord = __webpack_require__(24);
	
	var _LayoutRecord2 = _interopRequireDefault(_LayoutRecord);
	
	__webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var YogaNode = function (_Component) {
	  _inherits(YogaNode, _Component);
	
	  function YogaNode(props) {
	    _classCallCheck(this, YogaNode);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      hovered: false
	    };
	
	    _this.onMouseMove = function (e) {
	      _this.setState({ hovered: e.target === _this._ref });
	    };
	
	    _this.createYogaNodes = function (layoutDefinition) {
	      var root = _entryBrowser.Node.create();
	
	      var defaultLayout = (0, _LayoutRecord2.default)({});
	      ['width', 'height', 'minWidth', 'maxWidth', 'minHeight', 'maxHeight', 'justifyContent', 'alignItems', 'alignSelf', 'alignContent', 'flexGrow', 'flexShrink', 'positionType', 'aspectRatio', 'flexWrap', 'flexDirection'].forEach(function (key) {
	        try {
	          var value = layoutDefinition[key] === '' ? defaultLayout[key] : layoutDefinition[key];
	          root['set' + key[0].toUpperCase() + key.substr(1)](value);
	        } catch (e) {}
	      });
	
	      ['padding', 'margin', 'position', 'border'].forEach(function (key) {
	        ['top', 'right', 'bottom', 'left'].forEach(function (direction) {
	          try {
	            root['set' + key[0].toUpperCase() + key.substr(1)](_entryBrowser2.default['EDGE_' + direction.toUpperCase()], layoutDefinition[key][direction]);
	          } catch (e) {}
	        });
	      });
	
	      root.setDisplay(_entryBrowser2.default.DISPLAY_FLEX);
	
	      (layoutDefinition.children || []).map(_this.createYogaNodes).forEach(function (node, i) {
	        root.insertChild(node, i);
	      });
	      return root;
	    };
	
	    _this.getComputedLayout = function (node) {
	      return _extends({}, node.getComputedLayout(), {
	        node: node,
	        children: Array.apply(null, Array(node.getChildCount())).map(function (_, i) {
	          return _this.getComputedLayout(node.getChild(i));
	        })
	      });
	    };
	
	    _this.onClick = function (e) {
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        e.stopPropagation();
	        onClick(_this.props.path);
	      }
	    };
	
	    _this.onDoubleClick = function (e) {
	      var onDoubleClick = _this.props.onDoubleClick;
	
	      if (onDoubleClick) {
	        e.stopPropagation();
	        onDoubleClick(_this.props.path);
	      }
	    };
	
	    _this.onMouseLeave = function (e) {
	      return _this.setState({ hovered: false });
	    };
	
	    if (!props.computedLayout) {
	      // is root node
	      _this.calculateLayout(props);
	      _this.state = {
	        visible: !Boolean(props.computedLayout)
	      };
	    }
	    return _this;
	  }
	
	  YogaNode.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ visible: true });
	    }, 200);
	  };
	
	  YogaNode.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.computedLayout && (!this.props.layoutDefinition.equals(nextProps.layoutDefinition) || this.props.direction !== nextProps.direction)) {
	      // is root node and the layout definition or settings changed
	      this.calculateLayout(nextProps);
	    }
	  };
	
	  YogaNode.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.rootNode) {
	      this.rootNode.freeRecursive();
	    }
	  };
	
	  YogaNode.prototype.calculateLayout = function calculateLayout(props) {
	    var root = this.createYogaNodes(props.layoutDefinition);
	    root.calculateLayout(props.layoutDefinition.width, props.layoutDefinition.height, props.direction);
	    this.computedLayout = this.getComputedLayout(root);
	    this.rootNode = root;
	  };
	
	  YogaNode.prototype.showPositionGuides = function showPositionGuides(_ref) {
	    var node = _ref.node;
	
	    var padding = (0, _PositionRecord2.default)({
	      top: node.getComputedPadding(_entryBrowser2.default.EDGE_TOP),
	      left: node.getComputedPadding(_entryBrowser2.default.EDGE_LEFT),
	      right: node.getComputedPadding(_entryBrowser2.default.EDGE_RIGHT),
	      bottom: node.getComputedPadding(_entryBrowser2.default.EDGE_BOTTOM)
	    });
	    var border = (0, _PositionRecord2.default)({
	      top: node.getComputedBorder(_entryBrowser2.default.EDGE_TOP),
	      left: node.getComputedBorder(_entryBrowser2.default.EDGE_LEFT),
	      right: node.getComputedBorder(_entryBrowser2.default.EDGE_RIGHT),
	      bottom: node.getComputedBorder(_entryBrowser2.default.EDGE_BOTTOM)
	    });
	    var margin = (0, _PositionRecord2.default)({
	      top: node.getComputedMargin(_entryBrowser2.default.EDGE_TOP),
	      left: node.getComputedMargin(_entryBrowser2.default.EDGE_LEFT),
	      right: node.getComputedMargin(_entryBrowser2.default.EDGE_RIGHT),
	      bottom: node.getComputedMargin(_entryBrowser2.default.EDGE_BOTTOM)
	    });
	    var position = (0, _PositionRecord2.default)({
	      top: node.getPosition(_entryBrowser2.default.EDGE_TOP).value,
	      left: node.getPosition(_entryBrowser2.default.EDGE_LEFT).value,
	      right: node.getPosition(_entryBrowser2.default.EDGE_RIGHT).value,
	      bottom: node.getPosition(_entryBrowser2.default.EDGE_BOTTOM).value
	    });
	
	    return [_react2.default.createElement(_PositionGuide2.default, {
	      key: 'border',
	      inset: true,
	      position: border,
	      color: 'rgba(251, 170, 51, 0.15)',
	      reverse: node.getFlexWrap() === _entryBrowser2.default.WRAP_WRAP_REVERSE
	    }), _react2.default.createElement(_PositionGuide2.default, {
	      key: 'padding',
	      inset: true,
	      offset: border,
	      position: padding,
	      color: 'rgba(123, 179, 41, 0.1)',
	      reverse: node.getFlexWrap() === _entryBrowser2.default.WRAP_WRAP_REVERSE
	    }), _react2.default.createElement(_PositionGuide2.default, {
	      key: 'margin',
	      position: margin,
	      color: 'rgba(214, 43, 28, 0.1)'
	    }), _react2.default.createElement(_PositionGuide2.default, {
	      key: 'position',
	      offset: margin,
	      position: position,
	      color: 'rgba(115, 51, 205, 0.1)'
	    })];
	  };
	
	  YogaNode.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        layoutDefinition = _props.layoutDefinition,
	        className = _props.className,
	        path = _props.path,
	        selectedNodePath = _props.selectedNodePath,
	        label = _props.label;
	
	    // $FlowFixMe
	
	    var computedLayout = this.props.computedLayout || this.computedLayout;
	    var left = computedLayout.left,
	        top = computedLayout.top,
	        width = computedLayout.width,
	        height = computedLayout.height,
	        children = computedLayout.children;
	
	
	    var isFocused = selectedNodePath && selectedNodePath.length === 0;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'YogaNode ' + (isFocused ? 'focused' : '') + ' ' + (className || '') + ' ' + (this.state.visible ? '' : 'invisible') + ' ' + (this.state.hovered ? 'hover' : ''),
	        style: path.length == 0 ? { width: width, height: height } : { left: left, top: top, width: width, height: height },
	        onDoubleClick: this.onDoubleClick,
	        onMouseMove: this.onMouseMove,
	        onMouseLeave: this.onMouseLeave,
	        ref: function ref(_ref2) {
	          _this3._ref = _ref2;
	        },
	        onClick: this.onClick },
	      label && _react2.default.createElement(
	        'div',
	        { className: 'label' },
	        label
	      ),
	      isFocused && this.props.showGuides && this.showPositionGuides(computedLayout),
	      (children || []).map(function (child, i) {
	        return _react2.default.createElement(YogaNode, {
	          key: i,
	          computedLayout: child,
	          label: String(i + 1),
	          layoutDefinition: layoutDefinition.children.get(i),
	          selectedNodePath: selectedNodePath && selectedNodePath.length > 0 && selectedNodePath[0] === i ? selectedNodePath.slice(1) : null,
	          path: path.concat(i),
	          onClick: _this3.props.onClick,
	          onDoubleClick: _this3.props.onDoubleClick,
	          showGuides: _this3.props.showGuides
	        });
	      })
	    );
	  };
	
	  return YogaNode;
	}(_react.Component);
	
	YogaNode.defaultProps = {
	  path: [],
	  label: 'root',
	  showGuides: true
	};
	exports.default = YogaNode;
	module.exports = exports['default'];

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _input = __webpack_require__(39);
	
	var _input2 = _interopRequireDefault(_input);
	
	__webpack_require__(40);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var YogaPositionEditor = function (_Component) {
	  _inherits(YogaPositionEditor, _Component);
	
	  function YogaPositionEditor() {
	    _classCallCheck(this, YogaPositionEditor);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  YogaPositionEditor.prototype.render = function render() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        value = _props.value,
	        property = _props.property,
	        disabled = _props.disabled;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'YogaPositionEditor' },
	      _react2.default.createElement(_input2.default, {
	        type: 'text',
	        value: Number.isNaN(value.top) ? '' : value.top,
	        disabled: disabled,
	        onChange: function (_onChange) {
	          function onChange(_x) {
	            return _onChange.apply(this, arguments);
	          }
	
	          onChange.toString = function () {
	            return _onChange.toString();
	          };
	
	          return onChange;
	        }(function (e) {
	          return onChange(property, value.set('top', e.target.value));
	        })
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'YogaPositionEditorRow' },
	        _react2.default.createElement(_input2.default, {
	          type: 'text',
	          value: Number.isNaN(value.left) ? '' : value.left,
	          disabled: disabled,
	          onChange: function (_onChange2) {
	            function onChange(_x2) {
	              return _onChange2.apply(this, arguments);
	            }
	
	            onChange.toString = function () {
	              return _onChange2.toString();
	            };
	
	            return onChange;
	          }(function (e) {
	            return onChange(property, value.set('left', e.target.value));
	          })
	        }),
	        property.toUpperCase(),
	        _react2.default.createElement(_input2.default, {
	          type: 'text',
	          value: Number.isNaN(value.right) ? '' : value.right,
	          disabled: disabled,
	          onChange: function (_onChange3) {
	            function onChange(_x3) {
	              return _onChange3.apply(this, arguments);
	            }
	
	            onChange.toString = function () {
	              return _onChange3.toString();
	            };
	
	            return onChange;
	          }(function (e) {
	            return onChange(property, value.set('right', e.target.value));
	          })
	        })
	      ),
	      _react2.default.createElement(_input2.default, {
	        type: 'text',
	        value: Number.isNaN(value.bottom) ? '' : value.bottom,
	        disabled: disabled,
	        onChange: function (_onChange4) {
	          function onChange(_x4) {
	            return _onChange4.apply(this, arguments);
	          }
	
	          onChange.toString = function () {
	            return _onChange4.toString();
	          };
	
	          return onChange;
	        }(function (e) {
	          return onChange(property, value.set('bottom', e.target.value));
	        })
	      })
	    );
	  };
	
	  return YogaPositionEditor;
	}(_react.Component);
	
	YogaPositionEditor.availableProperties = ['position', 'margin', 'padding', 'border'];
	YogaPositionEditor.defaultProps = {
	  value: (0, _PositionRecord2.default)()
	};
	exports.default = YogaPositionEditor;
	module.exports = exports['default'];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _row = __webpack_require__(43);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _button = __webpack_require__(15);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _col = __webpack_require__(37);
	
	var _col2 = _interopRequireDefault(_col);
	
	__webpack_require__(44);
	
	__webpack_require__(17);
	
	__webpack_require__(38);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _entryBrowser = __webpack_require__(20);
	
	var _entryBrowser2 = _interopRequireDefault(_entryBrowser);
	
	var _YogaNode = __webpack_require__(162);
	
	var _YogaNode2 = _interopRequireDefault(_YogaNode);
	
	var _CodeGenerators = __webpack_require__(153);
	
	var _CodeGenerators2 = _interopRequireDefault(_CodeGenerators);
	
	var _URLShortener = __webpack_require__(160);
	
	var _URLShortener2 = _interopRequireDefault(_URLShortener);
	
	var _Editor = __webpack_require__(156);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _immutable = __webpack_require__(50);
	
	var _PositionRecord = __webpack_require__(16);
	
	var _PositionRecord2 = _interopRequireDefault(_PositionRecord);
	
	var _LayoutRecord = __webpack_require__(24);
	
	var _LayoutRecord2 = _interopRequireDefault(_LayoutRecord);
	
	var _Sidebar = __webpack_require__(159);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _btoa = __webpack_require__(167);
	
	var _btoa2 = _interopRequireDefault(_btoa);
	
	__webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	function getPath(path) {
	  return path.reduce(function (acc, cv) {
	    return acc.concat('children', cv);
	  }, []);
	}
	
	var Playground = function (_Component) {
	  _inherits(Playground, _Component);
	
	  function Playground() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Playground);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.rehydrate = function (node) {
	      var record = (0, _LayoutRecord2.default)(node);
	      record = record.set('padding', (0, _PositionRecord2.default)(record.padding));
	      record = record.set('border', (0, _PositionRecord2.default)(record.border));
	      record = record.set('margin', (0, _PositionRecord2.default)(record.margin));
	      record = record.set('position', (0, _PositionRecord2.default)(record.position));
	      record = record.set('children', (0, _immutable.List)(record.children.map(_this.rehydrate)));
	      return record;
	    }, _this.state = {
	      selectedNodePath: _this.props.selectedNodePath,
	      layoutDefinition: _this.rehydrate(_this.props.layoutDefinition),
	      direction: _this.props.direction
	    }, _this.onKeyDown = function (e) {
	      if (e.key === 'Escape') {
	        _this.hideSidePanes();
	      }
	    }, _this.onMouseDown = function (e) {
	      if (e.target === _this._containerRef) {
	        _this.hideSidePanes();
	      }
	    }, _this.onChangeLayout = function (key, value) {
	      var selectedNodePath = _this.state.selectedNodePath;
	
	      if (selectedNodePath) {
	        _this.modifyAtPath([].concat(getPath(selectedNodePath), [key]), value);
	      }
	    }, _this.onRemove = function () {
	      var _this$state = _this.state,
	          selectedNodePath = _this$state.selectedNodePath,
	          layoutDefinition = _this$state.layoutDefinition;
	
	      if (selectedNodePath) {
	        var index = selectedNodePath.pop();
	        var path = getPath(selectedNodePath).concat('children');
	        var updatedChildren = layoutDefinition.getIn(path).delete(index);
	        _this.modifyAtPath(path, updatedChildren);
	        _this.setState({ selectedNodePath: null });
	      }
	    }, _this.onAdd = function () {
	      var _this$state2 = _this.state,
	          selectedNodePath = _this$state2.selectedNodePath,
	          layoutDefinition = _this$state2.layoutDefinition;
	
	      if (selectedNodePath) {
	        var path = getPath(selectedNodePath).concat('children');
	        var updatedChildren = layoutDefinition.getIn(path).push((0, _LayoutRecord2.default)({ width: 100, height: 100 }));
	        _this.modifyAtPath(path, updatedChildren);
	      }
	    }, _this.getHash = function () {
	      var layoutDefinition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.layoutDefinition;
	      return (0, _btoa2.default)(JSON.stringify(_this.removeUnchangedProperties(layoutDefinition)));
	    }, _this.removeUnchangedProperties = function (node) {
	      var untouchedLayout = (0, _LayoutRecord2.default)({});
	      var untouchedPosition = (0, _PositionRecord2.default)({});
	      var result = {};
	      if (!node.equals(untouchedLayout)) {
	        Object.keys(node.toJS()).forEach(function (key) {
	          if (key === 'children' && node.children.size > 0) {
	            result.children = node.children.toJSON().map(_this.removeUnchangedProperties);
	          } else if (node[key] instanceof _PositionRecord2.default && !node[key].equals(untouchedPosition)) {
	            result[key] = {};
	            Object.keys(untouchedPosition.toJS()).forEach(function (position) {
	              if (node[key][position] !== untouchedPosition[position]) {
	                result[key][position] = node[key][position];
	              }
	            });
	          } else if (node[key] !== untouchedLayout[key]) {
	            result[key] = node[key];
	          }
	        });
	      }
	      return result;
	    }, _this.getChildrenCountForSelectedPath = function () {
	      var selectedNode = (_this.state.selectedNodePath || []).reduce(function (node, cv) {
	        return node.children.get(cv);
	      }, _this.state.layoutDefinition);
	      return selectedNode ? selectedNode.children.size : 0;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Playground.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('keydown', this.onKeyDown);
	
	    // rehydrate
	    if (window.location.search && window.location.search.length > 1) {
	      try {
	        var restoredState = JSON.parse(atob(window.location.search.substr(1)));
	        this.setState({ layoutDefinition: this.rehydrate(restoredState) });
	      } catch (e) {
	        window.history.replaceState({}, null, window.location.origin + window.location.pathname);
	      }
	    }
	  };
	
	  Playground.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('keydown', this.onKeyDown);
	  };
	
	  Playground.prototype.hideSidePanes = function hideSidePanes() {
	    if (!Boolean(this.props.renderSidebar)) {
	      // only unselect if we don't have an external sidebar, otherwise the
	      // sidebar may rely on a certain node to be selected
	      this.setState({
	        selectedNodePath: null
	      });
	    }
	  };
	
	  Playground.prototype.modifyAtPath = function modifyAtPath(path, value) {
	    var selectedNodePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.selectedNodePath;
	
	    // $FlowFixMe
	    var layoutDefinition = (0, _immutable.setIn)(this.state.layoutDefinition, path, value);
	    this.setState({
	      layoutDefinition: layoutDefinition,
	      selectedNodePath: selectedNodePath
	    });
	
	    if (this.props.persist) {
	      window.history.replaceState({}, null, window.location.origin + window.location.pathname + '?' + this.getHash(layoutDefinition));
	    }
	  };
	
	  Playground.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        layoutDefinition = _state.layoutDefinition,
	        selectedNodePath = _state.selectedNodePath,
	        direction = _state.direction;
	    var height = this.props.height;
	
	
	    var selectedNode = selectedNodePath ? layoutDefinition.getIn(getPath(selectedNodePath)) : null;
	
	    var playground = _react2.default.createElement(
	      'div',
	      {
	        className: 'Playground ' + (this.props.renderSidebar ? '' : 'standalone'),
	        onMouseDown: this.onMouseDown,
	        style: { height: height, maxHeight: height },
	        ref: function ref(_ref) {
	          _this2._containerRef = _ref;
	        } },
	      _react2.default.createElement(_YogaNode2.default, {
	        layoutDefinition: layoutDefinition,
	        selectedNodePath: selectedNodePath,
	        onClick: function onClick(selectedNodePath) {
	          return _this2.setState({ selectedNodePath: selectedNodePath });
	        },
	        onDoubleClick: this.onAdd,
	        direction: direction,
	        showGuides: this.props.showGuides
	      }),
	      !this.props.renderSidebar && _react2.default.createElement(
	        _Sidebar2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'Actions' },
	          _react2.default.createElement(
	            _row2.default,
	            { gutter: 15 },
	            _react2.default.createElement(
	              _col2.default,
	              { span: 12 },
	              _react2.default.createElement(_CodeGenerators2.default, {
	                layoutDefinition: layoutDefinition,
	                direction: direction
	              })
	            ),
	            _react2.default.createElement(
	              _col2.default,
	              { span: 12 },
	              this.props.persist ? _react2.default.createElement(_URLShortener2.default, null) : _react2.default.createElement(
	                _button2.default,
	                {
	                  href: '/playground?' + this.getHash(),
	                  type: 'primary' },
	                'Open Playground'
	              )
	            )
	          )
	        ),
	        this.state.selectedNodePath ? _react2.default.createElement(_Editor2.default, {
	          node: selectedNode,
	          selectedNodeIsRoot: selectedNodePath ? selectedNodePath.length === 0 : false,
	          onChangeLayout: this.onChangeLayout,
	          onChangeSetting: function onChangeSetting(key, value) {
	            var _this2$setState;
	
	            return _this2.setState((_this2$setState = {}, _this2$setState[key] = value, _this2$setState));
	          },
	          direction: direction,
	          onRemove: selectedNodePath && selectedNodePath.length > 0 ? this.onRemove : undefined,
	          onAdd: selectedNodePath && selectedNodePath.length < this.props.maxDepth ? this.onAdd : undefined
	        }) : _react2.default.createElement(
	          'div',
	          { className: 'NoContent' },
	          'Select a node to edit its properties'
	        )
	      )
	    );
	
	    if (this.props.renderSidebar) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'PlaygroundContainer ' + (this.props.className || '') },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.renderSidebar(layoutDefinition.getIn(getPath(selectedNodePath)), this.onChangeLayout)
	        ),
	        playground
	      );
	    } else {
	      return playground;
	    }
	  };
	
	  return Playground;
	}(_react.Component);
	
	Playground.defaultProps = {
	  layoutDefinition: {
	    width: 500,
	    height: 500,
	    children: [{ width: 100, height: 100 }, { width: 100, height: 100 }, { width: 100, height: 100 }]
	  },
	  direction: _entryBrowser2.default.DIRECTION_LTR,
	  maxDepth: 3,
	  showGuides: true,
	  persist: false
	};
	exports.default = Playground;
	module.exports = exports['default'];

/***/ }),
/* 165 */,
/* 166 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {(function () {
	  "use strict";
	
	  function btoa(str) {
	    var buffer;
	
	    if (str instanceof Buffer) {
	      buffer = str;
	    } else {
	      buffer = Buffer.from(str.toString(), 'binary');
	    }
	
	    return buffer.toString('base64');
	  }
	
	  module.exports = btoa;
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59).Buffer))

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	// Parse comma-separated tokens to an array.
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = input.slice(lastIndex, index).trim()
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	// Compile an array to comma-separated tokens.
	// `options.padLeft` (default: `true`) pads a space left of each token, and
	// `options.padRight` (default: `false`) pads a space to the right of each token.
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  // Ensure the last empty entry is seen.
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return values.join(right + comma + left).trim()
	}


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(70);
	} catch (err) {
	  var index = __webpack_require__(70);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(165);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(73);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(169);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendorPrefix;
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
	}
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	
	  if (name) {
	    node.style[name] = value;
	
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	
	  if (name) {
	    node.style[name] = value;
	
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return {
	      x: parseFloat(matrix[12] || matrix[4], 0),
	      y: parseFloat(matrix[13] || matrix[5], 0)
	    };
	  }
	
	  return {
	    x: 0,
	    y: 0
	  };
	}
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	
	  if (transform && transform !== 'none') {
	    var arr;
	    var match2d = transform.match(matrix2d);
	
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, "matrix(".concat(arr.join(','), ")"));
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
	    }
	  } else {
	    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
	  }
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605
	
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	
	  elem.style.display = originalStyle;
	}
	
	function css(el, name, v) {
	  var value = v;
	
	  if (_typeof(name) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	
	    return undefined;
	  }
	
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = "".concat(value, "px");
	    }
	
	    el.style[name] = value;
	    return undefined;
	  }
	
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box;
	  var x;
	  var y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	
	  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = Math.floor(box.left);
	  y = Math.floor(box.top); // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
	  var method = "scroll".concat(top ? 'Top' : 'Left');
	
	  if (typeof ret !== 'number') {
	    var d = w.document; // ie6,7,8 standard mode
	
	    ret = d.documentElement[method];
	
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	
	
	function isWindow(obj) {
	  // must use == for ie8
	
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	
	  if (node.nodeType === 9) {
	    return node;
	  }
	
	  return node.ownerDocument;
	}
	
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61
	
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
	
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content
	
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out
	
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX; // Revert the changed values
	
	    style[LEFT] = left;
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	} // 设置 elem 相对 elem.ownerDocument 的坐标
	
	
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = getTransitionProperty(elem) || '';
	    setTransitionProperty(elem, 'none');
	  }
	
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = "".concat(presetH, "px");
	  }
	
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = "".concat(presetV, "px");
	  } // force relayout
	
	
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	
	  css(elem, originalStyle); // force relayout
	
	  forceRelayout(elem);
	
	  if ('left' in offset || 'top' in offset) {
	    setTransitionProperty(elem, originalTransition);
	  }
	
	  var ret = {};
	
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	
	      var _off = offset[_key] - originalOffset[_key];
	
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	
	  css(elem, ret);
	}
	
	function setTransform$1(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = getTransformXY(elem);
	  var resultXY = {
	    x: originalXY.x,
	    y: originalXY.y
	  };
	
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	
	  setTransformXY(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && getTransformName() in document.body.style) {
	    setTransform$1(elem, offset);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name; // Remember the old values, and insert the new ones
	
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem); // Revert the old values
	
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop;
	  var j;
	  var i;
	
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	
	        if (prop === 'border') {
	          cssProp = "".concat(prop).concat(which[i], "Width");
	        } else {
	          cssProp = prop + which[i];
	        }
	
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	
	  return value;
	}
	
	var domUtils = {
	  getParent: function getParent(element) {
	    var parent = element;
	
	    do {
	      if (parent.nodeType === 11 && parent.host) {
	        parent = parent.host;
	      } else {
	        parent = parent.parentNode;
	      }
	    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
	
	    return parent;
	  }
	};
	each(['Width', 'Height'], function (name) {
	  domUtils["doc".concat(name)] = function (refWin) {
	    var d = refWin.document;
	    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
	  };
	
	  domUtils["viewport".concat(name)] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = "client".concat(name);
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
	    // backcompat 取 body
	
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	
	function getWH(elem, name, ex) {
	  var extra = ex;
	
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
	  var isBorderBox = isBorderBoxFn(elem);
	  var cssBoxValue = 0;
	
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary
	
	    cssBoxValue = getComputedStyleX(elem, name);
	
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    } // Normalize '', auto, and prepare for extra
	
	
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which);
	    }
	
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
	  }
	
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	}; // fix #119 : https://github.com/kissyteam/kissy/issues/119
	
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val;
	  var elem = args[0]; // in case elem is window
	  // elem.offsetWidth === undefined
	
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	
	  domUtils["outer".concat(first)] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	
	    if (val !== undefined) {
	      if (elem) {
	        var isBorderBox = isBorderBoxFn(elem);
	
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which);
	        }
	
	        return css(elem, name, val);
	      }
	
	      return undefined;
	    }
	
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i;
	    var ret = {};
	
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	
	    var overflow = obj.overflow;
	
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	
	    return ret;
	  },
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
	    }
	
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	mix(utils, domUtils);
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	var getParent = utils.getParent;
	
	function getOffsetParent(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return null;
	  } // ie 这个也不是完全可行
	
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	
	
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent;
	  var positionStyle = utils.css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
	  }
	
	  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
	    positionStyle = utils.css(parent, 'position');
	
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	
	  return null;
	}
	
	var getParent$1 = utils.getParent;
	function isAncestorFixed(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent = null;
	
	  for (parent = getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
	  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
	    var positionStyle = utils.css(parent, 'position');
	
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * 获得元素的显示部分的区域
	 */
	
	function getVisibleRectForElement(element, alwaysByViewport) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = getOffsetParent(element);
	  var doc = utils.getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
	      var pos = utils.offset(el); // add border
	
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	
	    el = getOffsetParent(el);
	  } // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	
	
	  var originalPosition = null;
	
	  if (!utils.isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = utils.css(element, 'position');
	
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
	  // We should cut this ourself.
	
	  var bodyStyle = window.getComputedStyle(body);
	
	  if (bodyStyle.overflowX === 'hidden') {
	    documentWidth = win.innerWidth;
	  }
	
	  if (bodyStyle.overflowY === 'hidden') {
	    documentHeight = win.innerHeight;
	  } // Reset element position after calculate the visible area
	
	
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	
	  if (alwaysByViewport || isAncestorFixed(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = utils.clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  } // Left edge inside and right edge outside viewport, try to resize it.
	
	
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  } // Right edge outside viewport, try to move it.
	
	
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  } // Top edge outside viewport, try to move it.
	
	
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  } // Top edge inside and bottom edge outside viewport, try to resize it.
	
	
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  } // Bottom edge outside viewport, try to move it.
	
	
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return utils.mix(pos, size);
	}
	
	function getRegion(node) {
	  var offset;
	  var w;
	  var h;
	
	  if (!utils.isWindow(node) && node.nodeType !== 9) {
	    offset = utils.offset(node);
	    w = utils.outerWidth(node);
	    h = utils.outerHeight(node);
	  } else {
	    var win = utils.getWindow(node);
	    offset = {
	      left: utils.getWindowScrollLeft(win),
	      top: utils.getWindowScrollTop(win)
	    };
	    w = utils.viewportWidth(win);
	    h = utils.viewportHeight(win);
	  }
	
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = region.left;
	  var y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = getAlignOffset(refNodeRegion, points[1]);
	  var p2 = getAlignOffset(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	  return {
	    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
	    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
	  };
	}
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  utils.each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n;
	
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	
	
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域
	
	  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height
	
	  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比
	
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置
	
	  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域
	
	  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整
	
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        }); // 偏移量也反下
	
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        }); // 偏移量也反下
	
	
	        var _newOffset = flipOffset(offset, 1);
	
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	
	        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    } // 如果失败，重新计算当前节点将要被放置的位置
	
	
	    if (fail) {
	      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	      utils.mix(newElRegion, elFuturePos);
	    }
	
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	
	    if (isStillFailX || isStillFailY) {
	      var _newPoints2 = points; // 重置对应部分的翻转逻辑
	
	      if (isStillFailX) {
	        _newPoints2 = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	      }
	
	      if (isStillFailY) {
	        _newPoints2 = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	      }
	
	      points = _newPoints2;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    } // 2. 只有指定了可以调整当前方向才调整
	
	
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度
	
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  } // need judge to in case set fixed with in css on height auto element
	
	
	  if (newElRegion.width !== elRegion.width) {
	    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
	  } // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	
	
	  utils.offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	function isOutOfVisibleRect(target, alwaysByViewport) {
	  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
	  var targetRegion = getRegion(target);
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = getRegion(target);
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
	  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	
	alignElement.__getOffsetParent = getOffsetParent;
	alignElement.__getVisibleRectForElement = getVisibleRectForElement;
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX;
	  var pageY;
	  var doc = utils.getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point
	
	  var points = [align.points[0], 'cc'];
	  return doAlign(el, tgtRegion, _objectSpread(_objectSpread({}, align), {}, {
	    points: points
	  }), pointInView);
	}
	
	exports.alignElement = alignElement;
	exports.alignPoint = alignPoint;
	exports.default = alignElement;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(180);
	
	function scrollIntoView(elem, container, config) {
	  config = config || {};
	  // document 归一化到 window
	  if (container.nodeType === 9) {
	    container = util.getWindow(container);
	  }
	
	  var allowHorizontalScroll = config.allowHorizontalScroll;
	  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
	  var alignWithTop = config.alignWithTop;
	  var alignWithLeft = config.alignWithLeft;
	  var offsetTop = config.offsetTop || 0;
	  var offsetLeft = config.offsetLeft || 0;
	  var offsetBottom = config.offsetBottom || 0;
	  var offsetRight = config.offsetRight || 0;
	
	  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
	
	  var isWin = util.isWindow(container);
	  var elemOffset = util.offset(elem);
	  var eh = util.outerHeight(elem);
	  var ew = util.outerWidth(elem);
	  var containerOffset = undefined;
	  var ch = undefined;
	  var cw = undefined;
	  var containerScroll = undefined;
	  var diffTop = undefined;
	  var diffBottom = undefined;
	  var win = undefined;
	  var winScroll = undefined;
	  var ww = undefined;
	  var wh = undefined;
	
	  if (isWin) {
	    win = container;
	    wh = util.height(win);
	    ww = util.width(win);
	    winScroll = {
	      left: util.scrollLeft(win),
	      top: util.scrollTop(win)
	    };
	    // elem 相对 container 可视视窗的距离
	    diffTop = {
	      left: elemOffset.left - winScroll.left - offsetLeft,
	      top: elemOffset.top - winScroll.top - offsetTop
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
	      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
	    };
	    containerScroll = winScroll;
	  } else {
	    containerOffset = util.offset(container);
	    ch = container.clientHeight;
	    cw = container.clientWidth;
	    containerScroll = {
	      left: container.scrollLeft,
	      top: container.scrollTop
	    };
	    // elem 相对 container 可视视窗的距离
	    // 注意边框, offset 是边框到根节点
	    diffTop = {
	      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
	      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
	      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
	    };
	  }
	
	  if (diffTop.top < 0 || diffBottom.top > 0) {
	    // 强制向上
	    if (alignWithTop === true) {
	      util.scrollTop(container, containerScroll.top + diffTop.top);
	    } else if (alignWithTop === false) {
	      util.scrollTop(container, containerScroll.top + diffBottom.top);
	    } else {
	      // 自动调整
	      if (diffTop.top < 0) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  } else {
	    if (!onlyScrollIfNeeded) {
	      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
	      if (alignWithTop) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  }
	
	  if (allowHorizontalScroll) {
	    if (diffTop.left < 0 || diffBottom.left > 0) {
	      // 强制向上
	      if (alignWithLeft === true) {
	        util.scrollLeft(container, containerScroll.left + diffTop.left);
	      } else if (alignWithLeft === false) {
	        util.scrollLeft(container, containerScroll.left + diffBottom.left);
	      } else {
	        // 自动调整
	        if (diffTop.left < 0) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    } else {
	      if (!onlyScrollIfNeeded) {
	        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
	        if (alignWithLeft) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    }
	  }
	}
	
	module.exports = scrollIntoView;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(178);

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	function getClientPosition(elem) {
	  var box = undefined;
	  var x = undefined;
	  var y = undefined;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, computedStyle_) {
	  var val = '';
	  var d = elem.ownerDocument;
	  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	var getComputedStyleX = undefined;
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = undefined;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = undefined;
	  var j = undefined;
	  var i = undefined;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = undefined;
	        if (prop === 'border') {
	          cssProp = prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj != null && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, extra) {
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue == null || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  }
	  if (borderBoxValueOrIsBorderBox) {
	    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
	    return val + (extra === BORDER_INDEX ? 0 : padding);
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay(elem) {
	  var val = undefined;
	  var args = arguments;
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value += 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, val) {
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setOffset(elem, offset) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var old = getOffset(elem);
	  var ret = {};
	  var current = undefined;
	  var key = undefined;
	
	  for (key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      current = parseFloat(css(elem, key)) || 0;
	      ret[key] = current + offset[key] - old[key];
	    }
	  }
	  css(elem, ret);
	}
	
	module.exports = _extends({
	  getWindow: function getWindow(node) {
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function offset(el, value) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value);
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var ret = {};
	    for (var i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (var i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	  scrollLeft: function scrollLeft(w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollLeft(w);
	      }
	      window.scrollTo(v, getScrollTop(w));
	    } else {
	      if (v === undefined) {
	        return w.scrollLeft;
	      }
	      w.scrollLeft = v;
	    }
	  },
	  scrollTop: function scrollTop(w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollTop(w);
	      }
	      window.scrollTo(getScrollLeft(w), v);
	    } else {
	      if (v === undefined) {
	        return w.scrollTop;
	      }
	      w.scrollTop = v;
	    }
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	}, domUtils);

/***/ }),
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = parse
	
	var search = /[#.]/g
	
	// Create a hast element from a simple CSS selector.
	function parse(selector, defaultTagName) {
	  var value = selector || ''
	  var name = defaultTagName || 'div'
	  var props = {}
	  var start = 0
	  var subvalue
	  var previous
	  var match
	
	  while (start < value.length) {
	    search.lastIndex = start
	    match = search.exec(value)
	    subvalue = value.slice(start, match ? match.index : value.length)
	
	    if (subvalue) {
	      if (!previous) {
	        name = subvalue
	      } else if (previous === '#') {
	        props.id = subvalue
	      } else if (props.className) {
	        props.className.push(subvalue)
	      } else {
	        props.className = [subvalue]
	      }
	
	      start += subvalue.length
	    }
	
	    if (match) {
	      previous = match[0]
	      start++
	    }
	  }
	
	  return {type: 'element', tagName: name, properties: props, children: []}
	}


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var find = __webpack_require__(196)
	var normalize = __webpack_require__(49)
	var parseSelector = __webpack_require__(192)
	var spaces = __webpack_require__(304).parse
	var commas = __webpack_require__(168).parse
	
	module.exports = factory
	
	var own = {}.hasOwnProperty
	
	function factory(schema, defaultTagName, caseSensitive) {
	  var adjust = caseSensitive ? createAdjustMap(caseSensitive) : null
	
	  return h
	
	  // Hyperscript compatible DSL for creating virtual hast trees.
	  function h(selector, properties) {
	    var node = parseSelector(selector, defaultTagName)
	    var children = Array.prototype.slice.call(arguments, 2)
	    var name = node.tagName.toLowerCase()
	    var property
	
	    node.tagName = adjust && own.call(adjust, name) ? adjust[name] : name
	
	    if (properties && isChildren(properties, node)) {
	      children.unshift(properties)
	      properties = null
	    }
	
	    if (properties) {
	      for (property in properties) {
	        addProperty(node.properties, property, properties[property])
	      }
	    }
	
	    addChild(node.children, children)
	
	    if (node.tagName === 'template') {
	      node.content = {type: 'root', children: node.children}
	      node.children = []
	    }
	
	    return node
	  }
	
	  function addProperty(properties, key, value) {
	    var info
	    var property
	    var result
	
	    // Ignore nully and NaN values.
	    if (value === null || value === undefined || value !== value) {
	      return
	    }
	
	    info = find(schema, key)
	    property = info.property
	    result = value
	
	    // Handle list values.
	    if (typeof result === 'string') {
	      if (info.spaceSeparated) {
	        result = spaces(result)
	      } else if (info.commaSeparated) {
	        result = commas(result)
	      } else if (info.commaOrSpaceSeparated) {
	        result = spaces(commas(result).join(' '))
	      }
	    }
	
	    // Accept `object` on style.
	    if (property === 'style' && typeof value !== 'string') {
	      result = style(result)
	    }
	
	    // Class-names (which can be added both on the `selector` and here).
	    if (property === 'className' && properties.className) {
	      result = properties.className.concat(result)
	    }
	
	    properties[property] = parsePrimitives(info, property, result)
	  }
	}
	
	function isChildren(value, node) {
	  return (
	    typeof value === 'string' ||
	    'length' in value ||
	    isNode(node.tagName, value)
	  )
	}
	
	function isNode(tagName, value) {
	  var type = value.type
	
	  if (tagName === 'input' || !type || typeof type !== 'string') {
	    return false
	  }
	
	  if (typeof value.children === 'object' && 'length' in value.children) {
	    return true
	  }
	
	  type = type.toLowerCase()
	
	  if (tagName === 'button') {
	    return (
	      type !== 'menu' &&
	      type !== 'submit' &&
	      type !== 'reset' &&
	      type !== 'button'
	    )
	  }
	
	  return 'value' in value
	}
	
	function addChild(nodes, value) {
	  var index
	  var length
	
	  if (typeof value === 'string' || typeof value === 'number') {
	    nodes.push({type: 'text', value: String(value)})
	    return
	  }
	
	  if (typeof value === 'object' && 'length' in value) {
	    index = -1
	    length = value.length
	
	    while (++index < length) {
	      addChild(nodes, value[index])
	    }
	
	    return
	  }
	
	  if (typeof value !== 'object' || !('type' in value)) {
	    throw new Error('Expected node, nodes, or string, got `' + value + '`')
	  }
	
	  nodes.push(value)
	}
	
	// Parse a (list of) primitives.
	function parsePrimitives(info, name, value) {
	  var index
	  var length
	  var result
	
	  if (typeof value !== 'object' || !('length' in value)) {
	    return parsePrimitive(info, name, value)
	  }
	
	  length = value.length
	  index = -1
	  result = []
	
	  while (++index < length) {
	    result[index] = parsePrimitive(info, name, value[index])
	  }
	
	  return result
	}
	
	// Parse a single primitives.
	function parsePrimitive(info, name, value) {
	  var result = value
	
	  if (info.number || info.positiveNumber) {
	    if (!isNaN(result) && result !== '') {
	      result = Number(result)
	    }
	  } else if (info.boolean || info.overloadedBoolean) {
	    // Accept `boolean` and `string`.
	    if (
	      typeof result === 'string' &&
	      (result === '' || normalize(value) === normalize(name))
	    ) {
	      result = true
	    }
	  }
	
	  return result
	}
	
	function style(value) {
	  var result = []
	  var key
	
	  for (key in value) {
	    result.push([key, value[key]].join(': '))
	  }
	
	  return result.join('; ')
	}
	
	function createAdjustMap(values) {
	  var length = values.length
	  var index = -1
	  var result = {}
	  var value
	
	  while (++index < length) {
	    value = values[index]
	    result[value.toLowerCase()] = value
	  }
	
	  return result
	}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var schema = __webpack_require__(197)
	var factory = __webpack_require__(193)
	
	var html = factory(schema, 'div')
	html.displayName = 'html'
	
	module.exports = html


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = __webpack_require__(194)


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(49)
	var DefinedInfo = __webpack_require__(75)
	var Info = __webpack_require__(76)
	
	var data = 'data'
	
	module.exports = find
	
	var valid = /^data[-\w.:]+$/i
	var dash = /-[a-z]/g
	var cap = /[A-Z]/g
	
	function find(schema, value) {
	  var normal = normalize(value)
	  var prop = value
	  var Type = Info
	
	  if (normal in schema.normal) {
	    return schema.property[schema.normal[normal]]
	  }
	
	  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
	    // Attribute or property.
	    if (value.charAt(4) === '-') {
	      prop = datasetToProperty(value)
	    } else {
	      value = datasetToAttribute(value)
	    }
	
	    Type = DefinedInfo
	  }
	
	  return new Type(prop, value)
	}
	
	function datasetToProperty(attribute) {
	  var value = attribute.slice(5).replace(dash, camelcase)
	  return data + value.charAt(0).toUpperCase() + value.slice(1)
	}
	
	function datasetToAttribute(property) {
	  var value = property.slice(4)
	
	  if (dash.test(value)) {
	    return property
	  }
	
	  value = value.replace(cap, kebab)
	
	  if (value.charAt(0) !== '-') {
	    value = '-' + value
	  }
	
	  return data + value
	}
	
	function kebab($0) {
	  return '-' + $0.toLowerCase()
	}
	
	function camelcase($0) {
	  return $0.charAt(1).toUpperCase()
	}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var merge = __webpack_require__(201)
	var xlink = __webpack_require__(202)
	var xml = __webpack_require__(203)
	var xmlns = __webpack_require__(204)
	var aria = __webpack_require__(198)
	var html = __webpack_require__(199)
	
	module.exports = merge([xml, xlink, xmlns, aria, html])


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(48)
	var create = __webpack_require__(27)
	
	var booleanish = types.booleanish
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	
	module.exports = create({
	  transform: ariaTransform,
	  properties: {
	    ariaActiveDescendant: null,
	    ariaAtomic: booleanish,
	    ariaAutoComplete: null,
	    ariaBusy: booleanish,
	    ariaChecked: booleanish,
	    ariaColCount: number,
	    ariaColIndex: number,
	    ariaColSpan: number,
	    ariaControls: spaceSeparated,
	    ariaCurrent: null,
	    ariaDescribedBy: spaceSeparated,
	    ariaDetails: null,
	    ariaDisabled: booleanish,
	    ariaDropEffect: spaceSeparated,
	    ariaErrorMessage: null,
	    ariaExpanded: booleanish,
	    ariaFlowTo: spaceSeparated,
	    ariaGrabbed: booleanish,
	    ariaHasPopup: null,
	    ariaHidden: booleanish,
	    ariaInvalid: null,
	    ariaKeyShortcuts: null,
	    ariaLabel: null,
	    ariaLabelledBy: spaceSeparated,
	    ariaLevel: number,
	    ariaLive: null,
	    ariaModal: booleanish,
	    ariaMultiLine: booleanish,
	    ariaMultiSelectable: booleanish,
	    ariaOrientation: null,
	    ariaOwns: spaceSeparated,
	    ariaPlaceholder: null,
	    ariaPosInSet: number,
	    ariaPressed: booleanish,
	    ariaReadOnly: booleanish,
	    ariaRelevant: null,
	    ariaRequired: booleanish,
	    ariaRoleDescription: spaceSeparated,
	    ariaRowCount: number,
	    ariaRowIndex: number,
	    ariaRowSpan: number,
	    ariaSelected: booleanish,
	    ariaSetSize: number,
	    ariaSort: null,
	    ariaValueMax: number,
	    ariaValueMin: number,
	    ariaValueNow: number,
	    ariaValueText: null,
	    role: null
	  }
	})
	
	function ariaTransform(_, prop) {
	  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
	}


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(48)
	var create = __webpack_require__(27)
	var caseInsensitiveTransform = __webpack_require__(74)
	
	var boolean = types.boolean
	var overloadedBoolean = types.overloadedBoolean
	var booleanish = types.booleanish
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	var commaSeparated = types.commaSeparated
	
	module.exports = create({
	  space: 'html',
	  attributes: {
	    acceptcharset: 'accept-charset',
	    classname: 'class',
	    htmlfor: 'for',
	    httpequiv: 'http-equiv'
	  },
	  transform: caseInsensitiveTransform,
	  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
	  properties: {
	    // Standard Properties.
	    abbr: null,
	    accept: commaSeparated,
	    acceptCharset: spaceSeparated,
	    accessKey: spaceSeparated,
	    action: null,
	    allow: null,
	    allowFullScreen: boolean,
	    allowPaymentRequest: boolean,
	    allowUserMedia: boolean,
	    alt: null,
	    as: null,
	    async: boolean,
	    autoCapitalize: null,
	    autoComplete: spaceSeparated,
	    autoFocus: boolean,
	    autoPlay: boolean,
	    capture: boolean,
	    charSet: null,
	    checked: boolean,
	    cite: null,
	    className: spaceSeparated,
	    cols: number,
	    colSpan: null,
	    content: null,
	    contentEditable: booleanish,
	    controls: boolean,
	    controlsList: spaceSeparated,
	    coords: number | commaSeparated,
	    crossOrigin: null,
	    data: null,
	    dateTime: null,
	    decoding: null,
	    default: boolean,
	    defer: boolean,
	    dir: null,
	    dirName: null,
	    disabled: boolean,
	    download: overloadedBoolean,
	    draggable: booleanish,
	    encType: null,
	    enterKeyHint: null,
	    form: null,
	    formAction: null,
	    formEncType: null,
	    formMethod: null,
	    formNoValidate: boolean,
	    formTarget: null,
	    headers: spaceSeparated,
	    height: number,
	    hidden: boolean,
	    high: number,
	    href: null,
	    hrefLang: null,
	    htmlFor: spaceSeparated,
	    httpEquiv: spaceSeparated,
	    id: null,
	    imageSizes: null,
	    imageSrcSet: commaSeparated,
	    inputMode: null,
	    integrity: null,
	    is: null,
	    isMap: boolean,
	    itemId: null,
	    itemProp: spaceSeparated,
	    itemRef: spaceSeparated,
	    itemScope: boolean,
	    itemType: spaceSeparated,
	    kind: null,
	    label: null,
	    lang: null,
	    language: null,
	    list: null,
	    loading: null,
	    loop: boolean,
	    low: number,
	    manifest: null,
	    max: null,
	    maxLength: number,
	    media: null,
	    method: null,
	    min: null,
	    minLength: number,
	    multiple: boolean,
	    muted: boolean,
	    name: null,
	    nonce: null,
	    noModule: boolean,
	    noValidate: boolean,
	    onAbort: null,
	    onAfterPrint: null,
	    onAuxClick: null,
	    onBeforePrint: null,
	    onBeforeUnload: null,
	    onBlur: null,
	    onCancel: null,
	    onCanPlay: null,
	    onCanPlayThrough: null,
	    onChange: null,
	    onClick: null,
	    onClose: null,
	    onContextMenu: null,
	    onCopy: null,
	    onCueChange: null,
	    onCut: null,
	    onDblClick: null,
	    onDrag: null,
	    onDragEnd: null,
	    onDragEnter: null,
	    onDragExit: null,
	    onDragLeave: null,
	    onDragOver: null,
	    onDragStart: null,
	    onDrop: null,
	    onDurationChange: null,
	    onEmptied: null,
	    onEnded: null,
	    onError: null,
	    onFocus: null,
	    onFormData: null,
	    onHashChange: null,
	    onInput: null,
	    onInvalid: null,
	    onKeyDown: null,
	    onKeyPress: null,
	    onKeyUp: null,
	    onLanguageChange: null,
	    onLoad: null,
	    onLoadedData: null,
	    onLoadedMetadata: null,
	    onLoadEnd: null,
	    onLoadStart: null,
	    onMessage: null,
	    onMessageError: null,
	    onMouseDown: null,
	    onMouseEnter: null,
	    onMouseLeave: null,
	    onMouseMove: null,
	    onMouseOut: null,
	    onMouseOver: null,
	    onMouseUp: null,
	    onOffline: null,
	    onOnline: null,
	    onPageHide: null,
	    onPageShow: null,
	    onPaste: null,
	    onPause: null,
	    onPlay: null,
	    onPlaying: null,
	    onPopState: null,
	    onProgress: null,
	    onRateChange: null,
	    onRejectionHandled: null,
	    onReset: null,
	    onResize: null,
	    onScroll: null,
	    onSecurityPolicyViolation: null,
	    onSeeked: null,
	    onSeeking: null,
	    onSelect: null,
	    onSlotChange: null,
	    onStalled: null,
	    onStorage: null,
	    onSubmit: null,
	    onSuspend: null,
	    onTimeUpdate: null,
	    onToggle: null,
	    onUnhandledRejection: null,
	    onUnload: null,
	    onVolumeChange: null,
	    onWaiting: null,
	    onWheel: null,
	    open: boolean,
	    optimum: number,
	    pattern: null,
	    ping: spaceSeparated,
	    placeholder: null,
	    playsInline: boolean,
	    poster: null,
	    preload: null,
	    readOnly: boolean,
	    referrerPolicy: null,
	    rel: spaceSeparated,
	    required: boolean,
	    reversed: boolean,
	    rows: number,
	    rowSpan: number,
	    sandbox: spaceSeparated,
	    scope: null,
	    scoped: boolean,
	    seamless: boolean,
	    selected: boolean,
	    shape: null,
	    size: number,
	    sizes: null,
	    slot: null,
	    span: number,
	    spellCheck: booleanish,
	    src: null,
	    srcDoc: null,
	    srcLang: null,
	    srcSet: commaSeparated,
	    start: number,
	    step: null,
	    style: null,
	    tabIndex: number,
	    target: null,
	    title: null,
	    translate: null,
	    type: null,
	    typeMustMatch: boolean,
	    useMap: null,
	    value: booleanish,
	    width: number,
	    wrap: null,
	
	    // Legacy.
	    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
	    align: null, // Several. Use CSS `text-align` instead,
	    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
	    archive: spaceSeparated, // `<object>`. List of URIs to archives
	    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
	    background: null, // `<body>`. Use CSS `background-image` instead
	    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
	    border: number, // `<table>`. Use CSS `border-width` instead,
	    borderColor: null, // `<table>`. Use CSS `border-color` instead,
	    bottomMargin: number, // `<body>`
	    cellPadding: null, // `<table>`
	    cellSpacing: null, // `<table>`
	    char: null, // Several table elements. When `align=char`, sets the character to align on
	    charOff: null, // Several table elements. When `char`, offsets the alignment
	    classId: null, // `<object>`
	    clear: null, // `<br>`. Use CSS `clear` instead
	    code: null, // `<object>`
	    codeBase: null, // `<object>`
	    codeType: null, // `<object>`
	    color: null, // `<font>` and `<hr>`. Use CSS instead
	    compact: boolean, // Lists. Use CSS to reduce space between items instead
	    declare: boolean, // `<object>`
	    event: null, // `<script>`
	    face: null, // `<font>`. Use CSS instead
	    frame: null, // `<table>`
	    frameBorder: null, // `<iframe>`. Use CSS `border` instead
	    hSpace: number, // `<img>` and `<object>`
	    leftMargin: number, // `<body>`
	    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
	    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
	    lowSrc: null, // `<img>`. Use a `<picture>`
	    marginHeight: number, // `<body>`
	    marginWidth: number, // `<body>`
	    noResize: boolean, // `<frame>`
	    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
	    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
	    noWrap: boolean, // `<td>` and `<th>`
	    object: null, // `<applet>`
	    profile: null, // `<head>`
	    prompt: null, // `<isindex>`
	    rev: null, // `<link>`
	    rightMargin: number, // `<body>`
	    rules: null, // `<table>`
	    scheme: null, // `<meta>`
	    scrolling: booleanish, // `<frame>`. Use overflow in the child context
	    standby: null, // `<object>`
	    summary: null, // `<table>`
	    text: null, // `<body>`. Use CSS `color` instead
	    topMargin: number, // `<body>`
	    valueType: null, // `<param>`
	    version: null, // `<html>`. Use a doctype.
	    vAlign: null, // Several. Use CSS `vertical-align` instead
	    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
	    vSpace: number, // `<img>` and `<object>`
	
	    // Non-standard Properties.
	    allowTransparency: null,
	    autoCorrect: null,
	    autoSave: null,
	    disablePictureInPicture: boolean,
	    disableRemotePlayback: boolean,
	    prefix: null,
	    property: null,
	    results: number,
	    security: null,
	    unselectable: null
	  }
	})


/***/ }),
/* 200 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = caseSensitiveTransform
	
	function caseSensitiveTransform(attributes, attribute) {
	  return attribute in attributes ? attributes[attribute] : attribute
	}


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(306)
	var Schema = __webpack_require__(77)
	
	module.exports = merge
	
	function merge(definitions) {
	  var length = definitions.length
	  var property = []
	  var normal = []
	  var index = -1
	  var info
	  var space
	
	  while (++index < length) {
	    info = definitions[index]
	    property.push(info.property)
	    normal.push(info.normal)
	    space = info.space
	  }
	
	  return new Schema(
	    xtend.apply(null, property),
	    xtend.apply(null, normal),
	    space
	  )
	}


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(27)
	
	module.exports = create({
	  space: 'xlink',
	  transform: xlinkTransform,
	  properties: {
	    xLinkActuate: null,
	    xLinkArcRole: null,
	    xLinkHref: null,
	    xLinkRole: null,
	    xLinkShow: null,
	    xLinkTitle: null,
	    xLinkType: null
	  }
	})
	
	function xlinkTransform(_, prop) {
	  return 'xlink:' + prop.slice(5).toLowerCase()
	}


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(27)
	
	module.exports = create({
	  space: 'xml',
	  transform: xmlTransform,
	  properties: {
	    xmlLang: null,
	    xmlBase: null,
	    xmlSpace: null
	  }
	})
	
	function xmlTransform(_, prop) {
	  return 'xml:' + prop.slice(3).toLowerCase()
	}


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(27)
	var caseInsensitiveTransform = __webpack_require__(74)
	
	module.exports = create({
	  space: 'xmlns',
	  attributes: {
	    xmlnsxlink: 'xmlns:xlink'
	  },
	  transform: caseInsensitiveTransform,
	  properties: {
	    xmlns: null,
	    xmlnsXLink: null
	  }
	})


/***/ }),
/* 205 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = alphabetical
	
	// Check if the given character code, or the character code at the first
	// character, is alphabetical.
	function alphabetical(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 && code <= 122) /* a-z */ ||
	    (code >= 65 && code <= 90) /* A-Z */
	  )
	}


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var alphabetical = __webpack_require__(206)
	var decimal = __webpack_require__(79)
	
	module.exports = alphanumerical
	
	// Check if the given character code, or the character code at the first
	// character, is alphanumerical.
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character)
	}


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = hexadecimal
	
	// Check if the given character code, or the character code at the first
	// character, is hexadecimal.
	function hexadecimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 /* a */ && code <= 102) /* z */ ||
	    (code >= 65 /* A */ && code <= 70) /* Z */ ||
	    (code >= 48 /* A */ && code <= 57) /* Z */
	  )
	}


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = isMobile
	module.exports.isMobile = isMobile
	module.exports.default = isMobile
	
	var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
	
	var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i
	
	function isMobile (opts) {
	  if (!opts) opts = {}
	  var ua = opts.ua
	  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
	  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
	    ua = ua.headers['user-agent']
	  }
	  if (typeof ua !== 'string') return false
	
	  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)
	
	  if (
	    !result &&
	    opts.tablet &&
	    opts.featureDetect &&
	    navigator &&
	    navigator.maxTouchPoints > 1 &&
	    ua.indexOf('Macintosh') !== -1 &&
	    ua.indexOf('Safari') !== -1
	  ) {
	    result = true
	  }
	
	  return result
	}


/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(80),
	    getRawTag = __webpack_require__(215),
	    objectToString = __webpack_require__(216);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(217);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(80);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(82),
	    now = __webpack_require__(221),
	    toNumber = __webpack_require__(222);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(212),
	    isObjectLike = __webpack_require__(219);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(81);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(213),
	    isObject = __webpack_require__(82),
	    isSymbol = __webpack_require__(220);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropTypes = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  function Provider() {
	    _classCallCheck(this, Provider);
	
	    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
	  }
	
	  _createClass(Provider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        miniStore: this.props.store
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return Provider;
	}(_react.Component);
	
	Provider.propTypes = {
	  store: _PropTypes.storeShape.isRequired
	};
	Provider.childContextTypes = {
	  miniStore: _PropTypes.storeShape.isRequired
	};
	exports.default = Provider;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = connect;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowequal = __webpack_require__(34);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _hoistNonReactStatics = __webpack_require__(322);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _PropTypes = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function isStateless(Component) {
	  return !Component.prototype.render;
	}
	
	var defaultMapStateToProps = function defaultMapStateToProps() {
	  return {};
	};
	
	function connect(mapStateToProps) {
	  var shouldSubscribe = !!mapStateToProps;
	  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      _createClass(Connect, null, [{
	        key: 'getDerivedStateFromProps',
	        value: function getDerivedStateFromProps(props, prevState) {
	          // using ownProps
	          if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
	            return {
	              subscribed: finnalMapStateToProps(prevState.store.getState(), props),
	              props: props
	            };
	          }
	          return { props: props };
	        }
	      }]);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));
	
	        _this.handleChange = function () {
	          if (!_this.unsubscribe) {
	            return;
	          }
	          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
	          _this.setState({ subscribed: nextState });
	        };
	
	        _this.store = context.miniStore;
	        _this.state = {
	          subscribed: finnalMapStateToProps(_this.store.getState(), props),
	          store: _this.store,
	          props: props
	        };
	        return _this;
	      }
	
	      _createClass(Connect, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.trySubscribe();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.tryUnsubscribe();
	        }
	      }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	          return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state.subscribed, nextState.subscribed);
	        }
	      }, {
	        key: 'trySubscribe',
	        value: function trySubscribe() {
	          if (shouldSubscribe) {
	            this.unsubscribe = this.store.subscribe(this.handleChange);
	            this.handleChange();
	          }
	        }
	      }, {
	        key: 'tryUnsubscribe',
	        value: function tryUnsubscribe() {
	          if (this.unsubscribe) {
	            this.unsubscribe();
	            this.unsubscribe = null;
	          }
	        }
	      }, {
	        key: 'getWrappedInstance',
	        value: function getWrappedInstance() {
	          return this.wrappedInstance;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this2 = this;
	
	          var props = _extends({}, this.props, this.state.subscribed, {
	            store: this.store
	          });
	
	          if (!isStateless(WrappedComponent)) {
	            props = _extends({}, props, {
	              ref: function ref(c) {
	                return _this2.wrappedInstance = c;
	              }
	            });
	          }
	
	          return _react2.default.createElement(WrappedComponent, props);
	        }
	      }]);
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	    Connect.contextTypes = {
	      miniStore: _PropTypes.storeShape.isRequired
	    };
	
	
	    (0, _reactLifecyclesCompat.polyfill)(Connect);
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = create;
	function create(initialState) {
	  var state = initialState;
	  var listeners = [];
	
	  function setState(partial) {
	    state = _extends({}, state, partial);
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	  }
	
	  function getState() {
	    return state;
	  }
	
	  function subscribe(listener) {
	    listeners.push(listener);
	
	    return function unsubscribe() {
	      var index = listeners.indexOf(listener);
	      listeners.splice(index, 1);
	    };
	  }
	
	  return {
	    setState: setState,
	    getState: getState,
	    subscribe: subscribe
	  };
	}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// mutationobserver-shim v0.3.3 (github.com/megawac/MutationObserver.js)
	// Authors: Graeme Yeates (github.com/megawac) 
	/*
	 Shim for MutationObserver interface
	 Author: Graeme Yeates (github.com/megawac)
	 Repository: https://github.com/megawac/MutationObserver.js
	 License: WTFPL V2, 2004 (wtfpl.net).
	 Though credit and staring the repo will make me feel pretty, you can modify and redistribute as you please.
	 Attempts to follow spec (https://www.w3.org/TR/dom/#mutation-observers) as closely as possible for native javascript
	 See https://github.com/WebKit/webkit/blob/master/Source/WebCore/dom/MutationObserver.cpp for current webkit source c++ implementation
	*/
	window.MutationObserver||(window.MutationObserver=function(y){function z(a){this.i=[];this.m=a}function K(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,z._period)})()}function r(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==y&&a[c]!==y&&(b[c]=a[c]);return b}function L(a,b){var c=E(a,b);return function(d){var f=d.length;b.a&&3===a.nodeType&&
	a.nodeValue!==c.a&&d.push(new r({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&C(d,a,c.b,b.f);if(b.c||b.g)var m=M(d,a,c,b);if(m||d.length!==f)c=E(a,b)}}function N(a,b){return b.value}function O(a,b){return"style"!==b.name?b.value:a.style.cssText}function C(a,b,c,d){for(var f={},m=b.attributes,k,g,p=m.length;p--;)k=m[p],g=k.name,d&&d[g]===y||(F(b,k)!==c[g]&&a.push(r({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(r({target:b,
	type:"attributes",attributeName:g,oldValue:c[g]}))}function M(a,b,c,d){function f(g,p,t,q,x){var A=g.length-1;x=-~((A-x)/2);for(var h,l,e;e=g.pop();)h=t[e.j],l=q[e.l],d.c&&x&&Math.abs(e.j-e.l)>=A&&(a.push(r({type:"childList",target:p,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),x--),d.b&&l.b&&C(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(r({type:"characterData",target:h,oldValue:l.a})),d.g&&m(h,l)}function m(g,p){for(var t=g.childNodes,
	q=p.c,x=t.length,A=q?q.length:0,h,l,e,n,v,B=0,w=0,u=0;w<x||u<A;)n=t[w],v=(e=q[u])&&e.node,n===v?(d.b&&e.b&&C(a,n,e.b,d.f),d.a&&e.a!==y&&n.nodeValue!==e.a&&a.push(r({type:"characterData",target:n,oldValue:e.a})),l&&f(l,g,t,q,B),d.g&&(n.childNodes.length||e.c&&e.c.length)&&m(n,e),w++,u++):(k=!0,h||(h={},l=[]),n&&(h[e=G(n)]||(h[e]=!0,-1===(e=H(q,n,u,"node"))?d.c&&(a.push(r({type:"childList",target:g,addedNodes:[n],nextSibling:n.nextSibling,previousSibling:n.previousSibling})),B++):l.push({j:w,l:e})),
	w++),v&&v!==t[w]&&(h[e=G(v)]||(h[e]=!0,-1===(e=H(t,v,w))?d.c&&(a.push(r({type:"childList",target:p.node,removedNodes:[v],nextSibling:q[u+1],previousSibling:q[u-1]})),B--):l.push({j:e,l:u})),u++));l&&f(l,g,t,q,B)}var k;m(b,c);return k}function E(a,b){var c=!0;return function m(f){var k={node:f};!b.a||3!==f.nodeType&&8!==f.nodeType?(b.b&&c&&1===f.nodeType&&(k.b=I(f.attributes,function(g,p){if(!b.f||b.f[p.name])g[p.name]=F(f,p);return g},{})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=P(f.childNodes,m)),c=b.g):k.a=
	f.nodeValue;return k}(a)}function G(a){try{return a.id||(a.mo_id=a.mo_id||J++)}catch(b){try{return a.nodeValue}catch(c){return J++}}}function P(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function I(a,b,c){for(var d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function H(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}z._period=30;z.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,
	a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=I(b.attributeFilter,function(m,k){m[k]=!0;return m},{}));d.push({s:a,o:L(a,c)});this.h||K(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var D=document.createElement("i");D.style.top=0;var F=(D="null"!=D.attributes.style.value)?N:O,J=1;return z}(void 0));
	//# sourceMappingURL=mutationobserver.map


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict'
	
	/* eslint-env browser */
	
	var el
	
	var semicolon = 59 //  ';'
	
	module.exports = decodeEntity
	
	function decodeEntity(characters) {
	  var entity = '&' + characters + ';'
	  var char
	
	  el = el || document.createElement('i')
	  el.innerHTML = entity
	  char = el.textContent
	
	  // Some entities do not require the closing semicolon (`&not` - for instance),
	  // which leads to situations where parsing the assumed entity of &notit; will
	  // result in the string `¬it;`.  When we encounter a trailing semicolon after
	  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
	  // assume that the matching was incomplete
	  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
	    return false
	  }
	
	  // If the decoded string is equal to the input, the entity was not valid
	  return char === entity ? false : char
	}


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var legacy = __webpack_require__(210)
	var invalid = __webpack_require__(211)
	var decimal = __webpack_require__(79)
	var hexadecimal = __webpack_require__(208)
	var alphanumerical = __webpack_require__(207)
	var decodeEntity = __webpack_require__(236)
	
	module.exports = parseEntities
	
	var own = {}.hasOwnProperty
	var fromCharCode = String.fromCharCode
	var noop = Function.prototype
	
	// Default settings.
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	}
	
	// Characters.
	var tab = 9 // '\t'
	var lineFeed = 10 // '\n'
	var formFeed = 12 //  '\f'
	var space = 32 // ' '
	var ampersand = 38 //  '&'
	var semicolon = 59 //  ';'
	var lessThan = 60 //  '<'
	var equalsTo = 61 //  '='
	var numberSign = 35 //  '#'
	var uppercaseX = 88 //  'X'
	var lowercaseX = 120 //  'x'
	var replacementCharacter = 65533 // '�'
	
	// Reference types.
	var name = 'named'
	var hexa = 'hexadecimal'
	var deci = 'decimal'
	
	// Map of bases.
	var bases = {}
	
	bases[hexa] = 16
	bases[deci] = 10
	
	// Map of types to tests.
	// Each type of character reference accepts different characters.
	// This test is used to detect whether a reference has ended (as the semicolon
	// is not strictly needed).
	var tests = {}
	
	tests[name] = alphanumerical
	tests[deci] = decimal
	tests[hexa] = hexadecimal
	
	// Warning types.
	var namedNotTerminated = 1
	var numericNotTerminated = 2
	var namedEmpty = 3
	var numericEmpty = 4
	var namedUnknown = 5
	var numericDisallowed = 6
	var numericProhibited = 7
	
	// Warning messages.
	var messages = {}
	
	messages[namedNotTerminated] =
	  'Named character references must be terminated by a semicolon'
	messages[numericNotTerminated] =
	  'Numeric character references must be terminated by a semicolon'
	messages[namedEmpty] = 'Named character references cannot be empty'
	messages[numericEmpty] = 'Numeric character references cannot be empty'
	messages[namedUnknown] = 'Named character references must be known'
	messages[numericDisallowed] =
	  'Numeric character references cannot be disallowed'
	messages[numericProhibited] =
	  'Numeric character references cannot be outside the permissible Unicode range'
	
	// Wrap to ensure clean parameters are given to `parse`.
	function parseEntities(value, options) {
	  var settings = {}
	  var option
	  var key
	
	  if (!options) {
	    options = {}
	  }
	
	  for (key in defaults) {
	    option = options[key]
	    settings[key] =
	      option === null || option === undefined ? defaults[key] : option
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || []
	    settings.position = settings.position.start
	  }
	
	  return parse(value, settings)
	}
	
	// Parse entities.
	// eslint-disable-next-line complexity
	function parse(value, settings) {
	  var additional = settings.additional
	  var nonTerminated = settings.nonTerminated
	  var handleText = settings.text
	  var handleReference = settings.reference
	  var handleWarning = settings.warning
	  var textContext = settings.textContext
	  var referenceContext = settings.referenceContext
	  var warningContext = settings.warningContext
	  var pos = settings.position
	  var indent = settings.indent || []
	  var length = value.length
	  var index = 0
	  var lines = -1
	  var column = pos.column || 1
	  var line = pos.line || 1
	  var queue = ''
	  var result = []
	  var entityCharacters
	  var namedEntity
	  var terminated
	  var characters
	  var character
	  var reference
	  var following
	  var warning
	  var reason
	  var output
	  var entity
	  var begin
	  var start
	  var type
	  var test
	  var prev
	  var next
	  var diff
	  var end
	
	  if (typeof additional === 'string') {
	    additional = additional.charCodeAt(0)
	  }
	
	  // Cache the current point.
	  prev = now()
	
	  // Wrap `handleWarning`.
	  warning = handleWarning ? parseError : noop
	
	  // Ensure the algorithm walks over the first character and the end (inclusive).
	  index--
	  length++
	
	  while (++index < length) {
	    // If the previous character was a newline.
	    if (character === lineFeed) {
	      column = indent[lines] || 1
	    }
	
	    character = value.charCodeAt(index)
	
	    if (character === ampersand) {
	      following = value.charCodeAt(index + 1)
	
	      // The behaviour depends on the identity of the next character.
	      if (
	        following === tab ||
	        following === lineFeed ||
	        following === formFeed ||
	        following === space ||
	        following === ampersand ||
	        following === lessThan ||
	        following !== following ||
	        (additional && following === additional)
	      ) {
	        // Not a character reference.
	        // No characters are consumed, and nothing is returned.
	        // This is not an error, either.
	        queue += fromCharCode(character)
	        column++
	
	        continue
	      }
	
	      start = index + 1
	      begin = start
	      end = start
	
	      if (following === numberSign) {
	        // Numerical entity.
	        end = ++begin
	
	        // The behaviour further depends on the next character.
	        following = value.charCodeAt(end)
	
	        if (following === uppercaseX || following === lowercaseX) {
	          // ASCII hex digits.
	          type = hexa
	          end = ++begin
	        } else {
	          // ASCII digits.
	          type = deci
	        }
	      } else {
	        // Named entity.
	        type = name
	      }
	
	      entityCharacters = ''
	      entity = ''
	      characters = ''
	      test = tests[type]
	      end--
	
	      while (++end < length) {
	        following = value.charCodeAt(end)
	
	        if (!test(following)) {
	          break
	        }
	
	        characters += fromCharCode(following)
	
	        // Check if we can match a legacy named reference.
	        // If so, we cache that as the last viable named reference.
	        // This ensures we do not need to walk backwards later.
	        if (type === name && own.call(legacy, characters)) {
	          entityCharacters = characters
	          entity = legacy[characters]
	        }
	      }
	
	      terminated = value.charCodeAt(end) === semicolon
	
	      if (terminated) {
	        end++
	
	        namedEntity = type === name ? decodeEntity(characters) : false
	
	        if (namedEntity) {
	          entityCharacters = characters
	          entity = namedEntity
	        }
	      }
	
	      diff = 1 + end - start
	
	      if (!terminated && !nonTerminated) {
	        // Empty.
	      } else if (!characters) {
	        // An empty (possible) entity is valid, unless it’s numeric (thus an
	        // ampersand followed by an octothorp).
	        if (type !== name) {
	          warning(numericEmpty, diff)
	        }
	      } else if (type === name) {
	        // An ampersand followed by anything unknown, and not terminated, is
	        // invalid.
	        if (terminated && !entity) {
	          warning(namedUnknown, 1)
	        } else {
	          // If theres something after an entity name which is not known, cap
	          // the reference.
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length
	            diff = 1 + end - begin
	            terminated = false
	          }
	
	          // If the reference is not terminated, warn.
	          if (!terminated) {
	            reason = entityCharacters ? namedNotTerminated : namedEmpty
	
	            if (settings.attribute) {
	              following = value.charCodeAt(end)
	
	              if (following === equalsTo) {
	                warning(reason, diff)
	                entity = null
	              } else if (alphanumerical(following)) {
	                entity = null
	              } else {
	                warning(reason, diff)
	              }
	            } else {
	              warning(reason, diff)
	            }
	          }
	        }
	
	        reference = entity
	      } else {
	        if (!terminated) {
	          // All non-terminated numeric entities are not rendered, and trigger a
	          // warning.
	          warning(numericNotTerminated, diff)
	        }
	
	        // When terminated and number, parse as either hexadecimal or decimal.
	        reference = parseInt(characters, bases[type])
	
	        // Trigger a warning when the parsed number is prohibited, and replace
	        // with replacement character.
	        if (prohibited(reference)) {
	          warning(numericProhibited, diff)
	          reference = fromCharCode(replacementCharacter)
	        } else if (reference in invalid) {
	          // Trigger a warning when the parsed number is disallowed, and replace
	          // by an alternative.
	          warning(numericDisallowed, diff)
	          reference = invalid[reference]
	        } else {
	          // Parse the number.
	          output = ''
	
	          // Trigger a warning when the parsed number should not be used.
	          if (disallowed(reference)) {
	            warning(numericDisallowed, diff)
	          }
	
	          // Stringify the number.
	          if (reference > 0xffff) {
	            reference -= 0x10000
	            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
	            reference = 0xdc00 | (reference & 0x3ff)
	          }
	
	          reference = output + fromCharCode(reference)
	        }
	      }
	
	      // Found it!
	      // First eat the queued characters as normal text, then eat an entity.
	      if (reference) {
	        flush()
	
	        prev = now()
	        index = end - 1
	        column += end - start + 1
	        result.push(reference)
	        next = now()
	        next.offset++
	
	        if (handleReference) {
	          handleReference.call(
	            referenceContext,
	            reference,
	            {start: prev, end: next},
	            value.slice(start - 1, end)
	          )
	        }
	
	        prev = next
	      } else {
	        // If we could not find a reference, queue the checked characters (as
	        // normal characters), and move the pointer to their end.
	        // This is possible because we can be certain neither newlines nor
	        // ampersands are included.
	        characters = value.slice(start - 1, end)
	        queue += characters
	        column += characters.length
	        index = end - 1
	      }
	    } else {
	      // Handle anything other than an ampersand, including newlines and EOF.
	      if (
	        character === 10 // Line feed
	      ) {
	        line++
	        lines++
	        column = 0
	      }
	
	      if (character === character) {
	        queue += fromCharCode(character)
	        column++
	      } else {
	        flush()
	      }
	    }
	  }
	
	  // Return the reduced nodes, and any possible warnings.
	  return result.join('')
	
	  // Get current position.
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    }
	  }
	
	  // “Throw” a parse-error: a warning.
	  function parseError(code, offset) {
	    var position = now()
	
	    position.column += offset
	    position.offset += offset
	
	    handleWarning.call(warningContext, messages[code], position, code)
	  }
	
	  // Flush `queue` (normal text).
	  // Macro invoked before each entity and at the end of `value`.
	  // Does nothing when `queue` is empty.
	  function flush() {
	    if (queue) {
	      result.push(queue)
	
	      if (handleText) {
	        handleText.call(textContext, queue, {start: prev, end: now()})
	      }
	
	      queue = ''
	    }
	  }
	}
	
	// Check if `character` is outside the permissible unicode range.
	function prohibited(code) {
	  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
	}
	
	// Check if `character` is disallowed.
	function disallowed(code) {
	  return (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000b ||
	    (code >= 0x000d && code <= 0x001f) ||
	    (code >= 0x007f && code <= 0x009f) ||
	    (code >= 0xfdd0 && code <= 0xfdef) ||
	    (code & 0xffff) === 0xffff ||
	    (code & 0xffff) === 0xfffe
	  )
	}


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)))

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(177);
	
	var _addEventListener = __webpack_require__(54);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _util = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElement(func) {
	  if (typeof func !== 'function' || !func) return null;
	  return func();
	}
	
	function getPoint(point) {
	  if (typeof point !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          target = _this$props.target,
	          align = _this$props.align,
	          onAlign = _this$props.onAlign;
	
	      if (!disabled && target) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	
	        var result = void 0;
	        var element = getElement(target);
	        var point = getPoint(target);
	
	        // IE lose focus after element realign
	        // We should record activeElement and restore later
	        var activeElement = document.activeElement;
	
	        if (element) {
	          result = (0, _domAlign.alignElement)(source, element, align);
	        } else if (point) {
	          result = (0, _domAlign.alignPoint)(source, point, align);
	        }
	
	        (0, _util.restoreFocus)(activeElement, source);
	
	        if (onAlign) {
	          onAlign(source, result);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Align, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var props = this.props;
	      // if parent ref not attached .... use document.getElementById
	      this.forceAlign();
	      if (!props.disabled && props.monitorWindowResize) {
	        this.startMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var reAlign = false;
	      var props = this.props;
	
	      if (!props.disabled) {
	        var source = _reactDom2['default'].findDOMNode(this);
	        var sourceRect = source ? source.getBoundingClientRect() : null;
	
	        if (prevProps.disabled) {
	          reAlign = true;
	        } else {
	          var lastElement = getElement(prevProps.target);
	          var currentElement = getElement(props.target);
	          var lastPoint = getPoint(prevProps.target);
	          var currentPoint = getPoint(props.target);
	
	          if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) {
	            // Skip if is window
	            reAlign = false;
	          } else if (lastElement !== currentElement || // Element change
	          lastElement && !currentElement && currentPoint || // Change from element to point
	          lastPoint && currentPoint && currentElement || // Change from point to element
	          currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) {
	            reAlign = true;
	          }
	
	          // If source element size changed
	          var preRect = this.sourceRect || {};
	          if (!reAlign && source && (!(0, _util.isSimilarValue)(preRect.width, sourceRect.width) || !(0, _util.isSimilarValue)(preRect.height, sourceRect.height))) {
	            reAlign = true;
	          }
	        }
	
	        this.sourceRect = sourceRect;
	      }
	
	      if (reAlign) {
	        this.forceAlign();
	      }
	
	      if (props.monitorWindowResize && !props.disabled) {
	        this.startMonitorWindowResize();
	      } else {
	        this.stopMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopMonitorWindowResize();
	    }
	  }, {
	    key: 'startMonitorWindowResize',
	    value: function startMonitorWindowResize() {
	      if (!this.resizeHandler) {
	        this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
	        this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	      }
	    }
	  }, {
	    key: 'stopMonitorWindowResize',
	    value: function stopMonitorWindowResize() {
	      if (this.resizeHandler) {
	        this.bufferMonitor.clear();
	        this.resizeHandler.remove();
	        this.resizeHandler = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          childrenProps = _props.childrenProps,
	          children = _props.children;
	
	      var child = _react2['default'].Children.only(children);
	      if (childrenProps) {
	        var newProps = {};
	        var propList = Object.keys(childrenProps);
	        propList.forEach(function (prop) {
	          newProps[prop] = _this2.props[childrenProps[prop]];
	        });
	
	        return _react2['default'].cloneElement(child, newProps);
	      }
	      return child;
	    }
	  }]);
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].shape({
	    clientX: _propTypes2['default'].number,
	    clientY: _propTypes2['default'].number,
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })]),
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(239);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffer = buffer;
	exports.isSamePoint = isSamePoint;
	exports.isWindow = isWindow;
	exports.isSimilarValue = isSimilarValue;
	exports.restoreFocus = restoreFocus;
	
	var _contains = __webpack_require__(55);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function isWindow(obj) {
	  return obj && typeof obj === 'object' && obj.window === obj;
	}
	
	function isSimilarValue(val1, val2) {
	  var int1 = Math.floor(val1);
	  var int2 = Math.floor(val2);
	  return Math.abs(int1 - int2) <= 1;
	}
	
	function restoreFocus(activeElement, container) {
	  // Focus back if is in the container
	  if (activeElement !== document.activeElement && (0, _contains2['default'])(container, activeElement)) {
	    activeElement.focus();
	  }
	}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(176);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(86);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any,
	  animation: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MotionPropTypes = undefined;
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.genCSSMotion = genCSSMotion;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _findDOMNode = __webpack_require__(96);
	
	var _findDOMNode2 = _interopRequireDefault(_findDOMNode);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _raf = __webpack_require__(51);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _motion = __webpack_require__(245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var STATUS_NONE = 'none'; /* eslint-disable react/default-props-match-prop-types, react/no-multi-comp */
	
	var STATUS_APPEAR = 'appear';
	var STATUS_ENTER = 'enter';
	var STATUS_LEAVE = 'leave';
	
	var MotionPropTypes = exports.MotionPropTypes = {
	  eventProps: _propTypes2['default'].object, // Internal usage. Only pass by CSSMotionList
	  visible: _propTypes2['default'].bool,
	  children: _propTypes2['default'].func,
	  motionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  motionAppear: _propTypes2['default'].bool,
	  motionEnter: _propTypes2['default'].bool,
	  motionLeave: _propTypes2['default'].bool,
	  motionLeaveImmediately: _propTypes2['default'].bool, // Trigger leave motion immediately
	  motionDeadline: _propTypes2['default'].number,
	  removeOnLeave: _propTypes2['default'].bool,
	  leavedClassName: _propTypes2['default'].string,
	  onAppearStart: _propTypes2['default'].func,
	  onAppearActive: _propTypes2['default'].func,
	  onAppearEnd: _propTypes2['default'].func,
	  onEnterStart: _propTypes2['default'].func,
	  onEnterActive: _propTypes2['default'].func,
	  onEnterEnd: _propTypes2['default'].func,
	  onLeaveStart: _propTypes2['default'].func,
	  onLeaveActive: _propTypes2['default'].func,
	  onLeaveEnd: _propTypes2['default'].func
	};
	
	/**
	 * `transitionSupport` is used for none transition test case.
	 * Default we use browser transition event support check.
	 */
	function genCSSMotion(config) {
	  var transitionSupport = config;
	  var forwardRef = !!_react2['default'].forwardRef;
	
	  if (typeof config === 'object') {
	    transitionSupport = config.transitionSupport;
	    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
	  }
	
	  function isSupportTransition(props) {
	    return !!(props.motionName && transitionSupport);
	  }
	
	  var CSSMotion = function (_React$Component) {
	    (0, _inherits3['default'])(CSSMotion, _React$Component);
	
	    function CSSMotion() {
	      (0, _classCallCheck3['default'])(this, CSSMotion);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));
	
	      _this.onDomUpdate = function () {
	        var _this$state = _this.state,
	            status = _this$state.status,
	            newStatus = _this$state.newStatus;
	        var _this$props = _this.props,
	            onAppearStart = _this$props.onAppearStart,
	            onEnterStart = _this$props.onEnterStart,
	            onLeaveStart = _this$props.onLeaveStart,
	            onAppearActive = _this$props.onAppearActive,
	            onEnterActive = _this$props.onEnterActive,
	            onLeaveActive = _this$props.onLeaveActive,
	            motionAppear = _this$props.motionAppear,
	            motionEnter = _this$props.motionEnter,
	            motionLeave = _this$props.motionLeave;
	
	
	        if (!isSupportTransition(_this.props)) {
	          return;
	        }
	
	        // Event injection
	        var $ele = _this.getElement();
	        if (_this.$cacheEle !== $ele) {
	          _this.removeEventListener(_this.$cacheEle);
	          _this.addEventListener($ele);
	          _this.$cacheEle = $ele;
	        }
	
	        // Init status
	        if (newStatus && status === STATUS_APPEAR && motionAppear) {
	          _this.updateStatus(onAppearStart, null, null, function () {
	            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
	          });
	        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
	          _this.updateStatus(onEnterStart, null, null, function () {
	            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
	          });
	        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
	          _this.updateStatus(onLeaveStart, null, null, function () {
	            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
	          });
	        }
	      };
	
	      _this.onMotionEnd = function (event) {
	        var _this$state2 = _this.state,
	            status = _this$state2.status,
	            statusActive = _this$state2.statusActive;
	        var _this$props2 = _this.props,
	            onAppearEnd = _this$props2.onAppearEnd,
	            onEnterEnd = _this$props2.onEnterEnd,
	            onLeaveEnd = _this$props2.onLeaveEnd;
	
	        if (status === STATUS_APPEAR && statusActive) {
	          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_ENTER && statusActive) {
	          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_LEAVE && statusActive) {
	          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
	        }
	      };
	
	      _this.setNodeRef = function (node) {
	        var internalRef = _this.props.internalRef;
	
	        _this.node = node;
	
	        if (typeof internalRef === 'function') {
	          internalRef(node);
	        } else if (internalRef && 'current' in internalRef) {
	          internalRef.current = node;
	        }
	      };
	
	      _this.getElement = function () {
	        try {
	          return (0, _findDOMNode2['default'])(_this.node || _this);
	        } catch (e) {
	          /**
	           * Fallback to cache element.
	           * This is only happen when `motionDeadline` trigger but element removed.
	           */
	          return _this.$cacheEle;
	        }
	      };
	
	      _this.addEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.addEventListener(_motion.transitionEndName, _this.onMotionEnd);
	        $ele.addEventListener(_motion.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.removeEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.removeEventListener(_motion.transitionEndName, _this.onMotionEnd);
	        $ele.removeEventListener(_motion.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
	        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;
	
	        if (statusStyle === false || _this._destroyed) return;
	
	        var nextStep = void 0;
	        if (callback) {
	          nextStep = function nextStep() {
	            _this.nextFrame(callback);
	          };
	        }
	
	        _this.setState((0, _extends3['default'])({
	          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
	          newStatus: false
	        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
	      };
	
	      _this.updateActiveStatus = function (styleFunc, currentStatus) {
	        // `setState` use `postMessage` to trigger at the end of frame.
	        // Let's use requestAnimationFrame to update new state in next frame.
	        _this.nextFrame(function () {
	          var status = _this.state.status;
	
	          if (status !== currentStatus) return;
	
	          var motionDeadline = _this.props.motionDeadline;
	
	
	          _this.updateStatus(styleFunc, { statusActive: true });
	
	          if (motionDeadline > 0) {
	            setTimeout(function () {
	              _this.onMotionEnd({
	                deadline: true
	              });
	            }, motionDeadline);
	          }
	        });
	      };
	
	      _this.nextFrame = function (func) {
	        _this.cancelNextFrame();
	        _this.raf = (0, _raf2['default'])(func);
	      };
	
	      _this.cancelNextFrame = function () {
	        if (_this.raf) {
	          _raf2['default'].cancel(_this.raf);
	          _this.raf = null;
	        }
	      };
	
	      _this.state = {
	        status: STATUS_NONE,
	        statusActive: false,
	        newStatus: false,
	        statusStyle: null
	      };
	      _this.$cacheEle = null;
	      _this.node = null;
	      _this.raf = null;
	      return _this;
	    }
	
	    (0, _createClass3['default'])(CSSMotion, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._destroyed = true;
	        this.removeEventListener(this.$cacheEle);
	        this.cancelNextFrame();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classNames;
	
	        var _state = this.state,
	            status = _state.status,
	            statusActive = _state.statusActive,
	            statusStyle = _state.statusStyle;
	        var _props = this.props,
	            children = _props.children,
	            motionName = _props.motionName,
	            visible = _props.visible,
	            removeOnLeave = _props.removeOnLeave,
	            leavedClassName = _props.leavedClassName,
	            eventProps = _props.eventProps;
	
	
	        if (!children) return null;
	
	        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
	          if (visible) {
	            return children((0, _extends3['default'])({}, eventProps), this.setNodeRef);
	          } else if (!removeOnLeave) {
	            return children((0, _extends3['default'])({}, eventProps, { className: leavedClassName }), this.setNodeRef);
	          }
	
	          return null;
	        }
	
	        return children((0, _extends3['default'])({}, eventProps, {
	          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status), status !== STATUS_NONE), (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status + '-active'), status !== STATUS_NONE && statusActive), (0, _defineProperty3['default'])(_classNames, motionName, typeof motionName === 'string'), _classNames)),
	          style: statusStyle
	        }), this.setNodeRef);
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(props, _ref) {
	        var prevProps = _ref.prevProps,
	            prevStatus = _ref.status;
	
	        if (!isSupportTransition(props)) return {};
	
	        var visible = props.visible,
	            motionAppear = props.motionAppear,
	            motionEnter = props.motionEnter,
	            motionLeave = props.motionLeave,
	            motionLeaveImmediately = props.motionLeaveImmediately;
	
	        var newState = {
	          prevProps: props
	        };
	
	        // Clean up status if prop set to false
	        if (prevStatus === STATUS_APPEAR && !motionAppear || prevStatus === STATUS_ENTER && !motionEnter || prevStatus === STATUS_LEAVE && !motionLeave) {
	          newState.status = STATUS_NONE;
	          newState.statusActive = false;
	          newState.newStatus = false;
	        }
	
	        // Appear
	        if (!prevProps && visible && motionAppear) {
	          newState.status = STATUS_APPEAR;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Enter
	        if (prevProps && !prevProps.visible && visible && motionEnter) {
	          newState.status = STATUS_ENTER;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Leave
	        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
	          newState.status = STATUS_LEAVE;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        return newState;
	      }
	    }]);
	    return CSSMotion;
	  }(_react2['default'].Component);
	
	  CSSMotion.propTypes = (0, _extends3['default'])({}, MotionPropTypes, {
	
	    internalRef: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func])
	  });
	  CSSMotion.defaultProps = {
	    visible: true,
	    motionEnter: true,
	    motionAppear: true,
	    motionLeave: true,
	    removeOnLeave: true
	  };
	
	
	  (0, _reactLifecyclesCompat.polyfill)(CSSMotion);
	
	  if (!forwardRef) {
	    return CSSMotion;
	  }
	
	  return _react2['default'].forwardRef(function (props, ref) {
	    return _react2['default'].createElement(CSSMotion, (0, _extends3['default'])({ internalRef: ref }, props));
	  });
	}
	
	exports['default'] = genCSSMotion(_motion.supportTransition);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVendorPrefixes = getVendorPrefixes;
	exports.getVendorPrefixedEventName = getVendorPrefixedEventName;
	exports.getTransitionName = getTransitionName;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// ================= Transition =================
	// Event wrapper. Copy from react source code
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	function getVendorPrefixes(domSupport, win) {
	  var prefixes = {
	    animationend: makePrefixMap('Animation', 'AnimationEnd'),
	    transitionend: makePrefixMap('Transition', 'TransitionEnd')
	  };
	
	  if (domSupport) {
	    if (!('AnimationEvent' in win)) {
	      delete prefixes.animationend.animation;
	    }
	
	    if (!('TransitionEvent' in win)) {
	      delete prefixes.transitionend.transition;
	    }
	  }
	
	  return prefixes;
	}
	
	var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});
	
	var style = {};
	
	if (canUseDOM) {
	  style = document.createElement('div').style;
	}
	
	var prefixedEventNames = {};
	
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  if (prefixMap) {
	    var stylePropList = Object.keys(prefixMap);
	    var len = stylePropList.length;
	    for (var i = 0; i < len; i += 1) {
	      var styleProp = stylePropList[i];
	      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
	        prefixedEventNames[eventName] = prefixMap[styleProp];
	        return prefixedEventNames[eventName];
	      }
	    }
	  }
	
	  return '';
	}
	
	var animationEndName = exports.animationEndName = getVendorPrefixedEventName('animationend');
	var transitionEndName = exports.transitionEndName = getVendorPrefixedEventName('transitionend');
	var supportTransition = exports.supportTransition = !!(animationEndName && transitionEndName);
	
	function getTransitionName(transitionName, transitionType) {
	  if (!transitionName) return null;
	
	  if (typeof transitionName === 'object') {
	    var type = transitionType.replace(/-\w/g, function (match) {
	      return match[1].toUpperCase();
	    });
	    return transitionName[type];
	  }
	
	  return transitionName + '-' + transitionType;
	}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Checkbox = function (_Component) {
	  (0, _inherits3['default'])(Checkbox, _Component);
	
	  function Checkbox(props) {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onChange = _this$props.onChange;
	
	      if (disabled) {
	        return;
	      }
	      if (!('checked' in _this.props)) {
	        _this.setState({
	          checked: e.target.checked
	        });
	      }
	      if (onChange) {
	        onChange({
	          target: (0, _extends3['default'])({}, _this.props, {
	            checked: e.target.checked
	          }),
	          stopPropagation: function stopPropagation() {
	            e.stopPropagation();
	          },
	          preventDefault: function preventDefault() {
	            e.preventDefault();
	          },
	
	          nativeEvent: e.nativeEvent
	        });
	      }
	    };
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    var checked = 'checked' in props ? props.checked : props.defaultChecked;
	
	    _this.state = {
	      checked: checked
	    };
	    return _this;
	  }
	
	  Checkbox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if ('checked' in props) {
	      return (0, _extends3['default'])({}, state, {
	        checked: props.checked
	      });
	    }
	    return null;
	  };
	
	  Checkbox.prototype.focus = function focus() {
	    this.input.focus();
	  };
	
	  Checkbox.prototype.blur = function blur() {
	    this.input.blur();
	  };
	
	  Checkbox.prototype.render = function render() {
	    var _classNames;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        className = _props.className,
	        style = _props.style,
	        name = _props.name,
	        id = _props.id,
	        type = _props.type,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        tabIndex = _props.tabIndex,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onBlur = _props.onBlur,
	        autoFocus = _props.autoFocus,
	        value = _props.value,
	        others = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'className', 'style', 'name', 'id', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);
	
	
	    var globalProps = Object.keys(others).reduce(function (prev, key) {
	      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
	        prev[key] = others[key];
	      }
	      return prev;
	    }, {});
	
	    var checked = this.state.checked;
	
	    var classString = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));
	
	    return _react2['default'].createElement(
	      'span',
	      { className: classString, style: style },
	      _react2['default'].createElement('input', (0, _extends3['default'])({
	        name: name,
	        id: id,
	        type: type,
	        readOnly: readOnly,
	        disabled: disabled,
	        tabIndex: tabIndex,
	        className: prefixCls + '-input',
	        checked: !!checked,
	        onClick: onClick,
	        onFocus: onFocus,
	        onBlur: onBlur,
	        onChange: this.handleChange,
	        autoFocus: autoFocus,
	        ref: this.saveInput,
	        value: value
	      }, globalProps)),
	      _react2['default'].createElement('span', { className: prefixCls + '-inner' })
	    );
	  };
	
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  name: _propTypes2['default'].string,
	  id: _propTypes2['default'].string,
	  type: _propTypes2['default'].string,
	  defaultChecked: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].bool]),
	  checked: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].bool]),
	  disabled: _propTypes2['default'].bool,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  onClick: _propTypes2['default'].func,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  readOnly: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  value: _propTypes2['default'].any
	};
	Checkbox.defaultProps = {
	  prefixCls: 'rc-checkbox',
	  className: '',
	  style: {},
	  type: 'checkbox',
	  defaultChecked: false,
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {},
	  onChange: function onChange() {}
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Checkbox);
	
	exports['default'] = Checkbox;
	module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Checkbox = __webpack_require__(246);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Checkbox2['default'];
	module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _KeyCode = __webpack_require__(28);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _contains = __webpack_require__(55);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _rcAnimate = __webpack_require__(85);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _LazyRenderBox = __webpack_require__(250);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var uuid = 0;
	/* eslint react/no-is-mounted:0 */
	function getScroll(w, top) {
	    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	    var method = 'scroll' + (top ? 'Top' : 'Left');
	    if (typeof ret !== 'number') {
	        var d = w.document;
	        ret = d.documentElement[method];
	        if (typeof ret !== 'number') {
	            ret = d.body[method];
	        }
	    }
	    return ret;
	}
	function setTransformOrigin(node, value) {
	    var style = node.style;
	    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
	        style[prefix + 'TransformOrigin'] = value;
	    });
	    style['transformOrigin'] = value;
	}
	function offset(el) {
	    var rect = el.getBoundingClientRect();
	    var pos = {
	        left: rect.left,
	        top: rect.top
	    };
	    var doc = el.ownerDocument;
	    var w = doc.defaultView || doc.parentWindow;
	    pos.left += getScroll(w);
	    pos.top += getScroll(w, true);
	    return pos;
	}
	
	var Dialog = function (_React$Component) {
	    (0, _inherits3['default'])(Dialog, _React$Component);
	
	    function Dialog(props) {
	        (0, _classCallCheck3['default'])(this, Dialog);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	        _this.inTransition = false;
	        _this.onAnimateLeave = function () {
	            var afterClose = _this.props.afterClose;
	            // need demo?
	            // https://github.com/react-component/dialog/pull/28
	
	            if (_this.wrap) {
	                _this.wrap.style.display = 'none';
	            }
	            _this.inTransition = false;
	            _this.switchScrollingEffect();
	            if (afterClose) {
	                afterClose();
	            }
	        };
	        _this.onDialogMouseDown = function () {
	            _this.dialogMouseDown = true;
	        };
	        _this.onMaskMouseUp = function () {
	            if (_this.dialogMouseDown) {
	                _this.timeoutId = setTimeout(function () {
	                    _this.dialogMouseDown = false;
	                }, 0);
	            }
	        };
	        _this.onMaskClick = function (e) {
	            // android trigger click on open (fastclick??)
	            if (Date.now() - _this.openTime < 300) {
	                return;
	            }
	            if (e.target === e.currentTarget && !_this.dialogMouseDown) {
	                _this.close(e);
	            }
	        };
	        _this.onKeyDown = function (e) {
	            var props = _this.props;
	            if (props.keyboard && e.keyCode === _KeyCode2['default'].ESC) {
	                e.stopPropagation();
	                _this.close(e);
	                return;
	            }
	            // keep focus inside dialog
	            if (props.visible) {
	                if (e.keyCode === _KeyCode2['default'].TAB) {
	                    var activeElement = document.activeElement;
	                    var sentinelStart = _this.sentinelStart;
	                    if (e.shiftKey) {
	                        if (activeElement === sentinelStart) {
	                            _this.sentinelEnd.focus();
	                        }
	                    } else if (activeElement === _this.sentinelEnd) {
	                        sentinelStart.focus();
	                    }
	                }
	            }
	        };
	        _this.getDialogElement = function () {
	            var props = _this.props;
	            var closable = props.closable;
	            var prefixCls = props.prefixCls;
	            var dest = {};
	            if (props.width !== undefined) {
	                dest.width = props.width;
	            }
	            if (props.height !== undefined) {
	                dest.height = props.height;
	            }
	            var footer = void 0;
	            if (props.footer) {
	                footer = React.createElement("div", { className: prefixCls + '-footer', ref: _this.saveRef('footer') }, props.footer);
	            }
	            var header = void 0;
	            if (props.title) {
	                header = React.createElement("div", { className: prefixCls + '-header', ref: _this.saveRef('header') }, React.createElement("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
	            }
	            var closer = void 0;
	            if (closable) {
	                closer = React.createElement("button", { type: "button", onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, props.closeIcon || React.createElement("span", { className: prefixCls + '-close-x' }));
	            }
	            var style = (0, _extends3['default'])({}, props.style, dest);
	            var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', outline: 'none' };
	            var transitionName = _this.getTransitionName();
	            var dialogElement = React.createElement(_LazyRenderBox2['default'], { key: "dialog-element", role: "document", ref: _this.saveRef('dialog'), style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible, forceRender: props.forceRender, onMouseDown: _this.onDialogMouseDown }, React.createElement("div", { tabIndex: 0, ref: _this.saveRef('sentinelStart'), style: sentinelStyle, "aria-hidden": "true" }), React.createElement("div", { className: prefixCls + '-content' }, closer, header, React.createElement("div", (0, _extends3['default'])({ className: prefixCls + '-body', style: props.bodyStyle, ref: _this.saveRef('body') }, props.bodyProps), props.children), footer), React.createElement("div", { tabIndex: 0, ref: _this.saveRef('sentinelEnd'), style: sentinelStyle, "aria-hidden": "true" }));
	            return React.createElement(_rcAnimate2['default'], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, props.visible || !props.destroyOnClose ? dialogElement : null);
	        };
	        _this.getZIndexStyle = function () {
	            var style = {};
	            var props = _this.props;
	            if (props.zIndex !== undefined) {
	                style.zIndex = props.zIndex;
	            }
	            return style;
	        };
	        _this.getWrapStyle = function () {
	            return (0, _extends3['default'])({}, _this.getZIndexStyle(), _this.props.wrapStyle);
	        };
	        _this.getMaskStyle = function () {
	            return (0, _extends3['default'])({}, _this.getZIndexStyle(), _this.props.maskStyle);
	        };
	        _this.getMaskElement = function () {
	            var props = _this.props;
	            var maskElement = void 0;
	            if (props.mask) {
	                var maskTransition = _this.getMaskTransitionName();
	                maskElement = React.createElement(_LazyRenderBox2['default'], (0, _extends3['default'])({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
	                if (maskTransition) {
	                    maskElement = React.createElement(_rcAnimate2['default'], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
	                }
	            }
	            return maskElement;
	        };
	        _this.getMaskTransitionName = function () {
	            var props = _this.props;
	            var transitionName = props.maskTransitionName;
	            var animation = props.maskAnimation;
	            if (!transitionName && animation) {
	                transitionName = props.prefixCls + '-' + animation;
	            }
	            return transitionName;
	        };
	        _this.getTransitionName = function () {
	            var props = _this.props;
	            var transitionName = props.transitionName;
	            var animation = props.animation;
	            if (!transitionName && animation) {
	                transitionName = props.prefixCls + '-' + animation;
	            }
	            return transitionName;
	        };
	        _this.close = function (e) {
	            var onClose = _this.props.onClose;
	
	            if (onClose) {
	                onClose(e);
	            }
	        };
	        _this.saveRef = function (name) {
	            return function (node) {
	                _this[name] = node;
	            };
	        };
	        _this.titleId = 'rcDialogTitle' + uuid++;
	        _this.switchScrollingEffect = props.switchScrollingEffect || function () {};
	        return _this;
	    }
	
	    Dialog.prototype.componentDidMount = function componentDidMount() {
	        this.componentDidUpdate({});
	        // if forceRender is true, set element style display to be none;
	        if ((this.props.forceRender || this.props.getContainer === false && !this.props.visible) && this.wrap) {
	            this.wrap.style.display = 'none';
	        }
	    };
	
	    Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            visible = _props.visible,
	            mask = _props.mask,
	            focusTriggerAfterClose = _props.focusTriggerAfterClose;
	
	        var mousePosition = this.props.mousePosition;
	        if (visible) {
	            // first show
	            if (!prevProps.visible) {
	                this.openTime = Date.now();
	                this.switchScrollingEffect();
	                this.tryFocus();
	                var dialogNode = ReactDOM.findDOMNode(this.dialog);
	                if (mousePosition) {
	                    var elOffset = offset(dialogNode);
	                    setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
	                } else {
	                    setTransformOrigin(dialogNode, '');
	                }
	            }
	        } else if (prevProps.visible) {
	            this.inTransition = true;
	            if (mask && this.lastOutSideFocusNode && focusTriggerAfterClose) {
	                try {
	                    this.lastOutSideFocusNode.focus();
	                } catch (e) {
	                    this.lastOutSideFocusNode = null;
	                }
	                this.lastOutSideFocusNode = null;
	            }
	        }
	    };
	
	    Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
	        var _props2 = this.props,
	            visible = _props2.visible,
	            getOpenCount = _props2.getOpenCount;
	
	        if ((visible || this.inTransition) && !getOpenCount()) {
	            this.switchScrollingEffect();
	        }
	        clearTimeout(this.timeoutId);
	    };
	
	    Dialog.prototype.tryFocus = function tryFocus() {
	        if (!(0, _contains2['default'])(this.wrap, document.activeElement)) {
	            this.lastOutSideFocusNode = document.activeElement;
	            this.sentinelStart.focus();
	        }
	    };
	
	    Dialog.prototype.render = function render() {
	        var props = this.props;
	        var prefixCls = props.prefixCls,
	            maskClosable = props.maskClosable;
	
	        var style = this.getWrapStyle();
	        // clear hide display
	        // and only set display after async anim, not here for hide
	        if (props.visible) {
	            style.display = null;
	        }
	        return React.createElement("div", { className: prefixCls + '-root' }, this.getMaskElement(), React.createElement("div", (0, _extends3['default'])({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: this.saveRef('wrap'), onClick: maskClosable ? this.onMaskClick : null, onMouseUp: maskClosable ? this.onMaskMouseUp : null, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
	    };
	
	    return Dialog;
	}(React.Component);
	
	exports['default'] = Dialog;
	
	Dialog.defaultProps = {
	    className: '',
	    mask: true,
	    visible: false,
	    keyboard: true,
	    closable: true,
	    maskClosable: true,
	    destroyOnClose: false,
	    prefixCls: 'rc-dialog',
	    focusTriggerAfterClose: true
	};
	module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Dialog = __webpack_require__(248);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _PortalWrapper = __webpack_require__(279);
	
	var _PortalWrapper2 = _interopRequireDefault(_PortalWrapper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// fix issue #10656
	/*
	* getContainer remarks
	* Custom container should not be return, because in the Portal component, it will remove the
	* return container element here, if the custom container is the only child of it's component,
	* like issue #10656, It will has a conflict with removeChild method in react-dom.
	* So here should add a child (div element) to custom container.
	* */
	exports['default'] = function (props) {
	    var visible = props.visible,
	        getContainer = props.getContainer,
	        forceRender = props.forceRender;
	    // 渲染在当前 dom 里；
	
	    if (getContainer === false) {
	        return React.createElement(_Dialog2['default'], (0, _extends3['default'])({}, props, { getOpenCount: function getOpenCount() {
	                return 2;
	            } }));
	    }
	    return React.createElement(_PortalWrapper2['default'], { visible: visible, forceRender: forceRender, getContainer: getContainer }, function (childProps) {
	        return React.createElement(_Dialog2['default'], (0, _extends3['default'])({}, props, childProps));
	    });
	};
	
	module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var LazyRenderBox = function (_React$Component) {
	    (0, _inherits3["default"])(LazyRenderBox, _React$Component);
	
	    function LazyRenderBox() {
	        (0, _classCallCheck3["default"])(this, LazyRenderBox);
	        return (0, _possibleConstructorReturn3["default"])(this, _React$Component.apply(this, arguments));
	    }
	
	    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        if (nextProps.forceRender) {
	            return true;
	        }
	        return !!nextProps.hiddenClassName || !!nextProps.visible;
	    };
	
	    LazyRenderBox.prototype.render = function render() {
	        var _a = this.props,
	            className = _a.className,
	            hiddenClassName = _a.hiddenClassName,
	            visible = _a.visible,
	            forceRender = _a.forceRender,
	            restProps = __rest(_a, ["className", "hiddenClassName", "visible", "forceRender"]);
	        var useClassName = className;
	        if (!!hiddenClassName && !visible) {
	            useClassName += " " + hiddenClassName;
	        }
	        return React.createElement("div", (0, _extends3["default"])({}, restProps, { className: useClassName }));
	    };
	
	    return LazyRenderBox;
	}(React.Component);
	
	exports["default"] = LazyRenderBox;
	module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcTrigger = __webpack_require__(53);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _placements = __webpack_require__(253);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    if ('visible' in props) {
	      _this.state = {
	        visible: props.visible
	      };
	    } else {
	      _this.state = {
	        visible: props.defaultVisible
	      };
	    }
	    return _this;
	  }
	
	  Dropdown.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
	    if ('visible' in nextProps) {
	      return {
	        visible: nextProps.visible
	      };
	    }
	    return null;
	  };
	
	  Dropdown.prototype.getOverlayElement = function getOverlayElement() {
	    var overlay = this.props.overlay;
	
	    var overlayElement = void 0;
	    if (typeof overlay === 'function') {
	      overlayElement = overlay();
	    } else {
	      overlayElement = overlay;
	    }
	    return overlayElement;
	  };
	
	  Dropdown.prototype.getMenuElementOrLambda = function getMenuElementOrLambda() {
	    var overlay = this.props.overlay;
	
	    if (typeof overlay === 'function') {
	      return this.getMenuElement;
	    }
	    return this.getMenuElement();
	  };
	
	  Dropdown.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Dropdown.prototype.getOpenClassName = function getOpenClassName() {
	    var _props = this.props,
	        openClassName = _props.openClassName,
	        prefixCls = _props.prefixCls;
	
	    if (openClassName !== undefined) {
	      return openClassName;
	    }
	    return prefixCls + '-open';
	  };
	
	  Dropdown.prototype.renderChildren = function renderChildren() {
	    var children = this.props.children;
	    var visible = this.state.visible;
	
	    var childrenProps = children.props ? children.props : {};
	    var childClassName = (0, _classnames2['default'])(childrenProps.className, this.getOpenClassName());
	    return visible && children ? (0, _react.cloneElement)(children, { className: childClassName }) : children;
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        transitionName = _props2.transitionName,
	        animation = _props2.animation,
	        align = _props2.align,
	        placement = _props2.placement,
	        getPopupContainer = _props2.getPopupContainer,
	        showAction = _props2.showAction,
	        hideAction = _props2.hideAction,
	        overlayClassName = _props2.overlayClassName,
	        overlayStyle = _props2.overlayStyle,
	        trigger = _props2.trigger,
	        otherProps = _objectWithoutProperties(_props2, ['prefixCls', 'transitionName', 'animation', 'align', 'placement', 'getPopupContainer', 'showAction', 'hideAction', 'overlayClassName', 'overlayStyle', 'trigger']);
	
	    var triggerHideAction = hideAction;
	    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
	      triggerHideAction = ['click'];
	    }
	
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      _extends({}, otherProps, {
	        prefixCls: prefixCls,
	        ref: this.saveTrigger,
	        popupClassName: overlayClassName,
	        popupStyle: overlayStyle,
	        builtinPlacements: _placements2['default'],
	        action: trigger,
	        showAction: showAction,
	        hideAction: triggerHideAction || [],
	        popupPlacement: placement,
	        popupAlign: align,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        popupVisible: this.state.visible,
	        afterPopupVisibleChange: this.afterVisibleChange,
	        popup: this.getMenuElementOrLambda(),
	        onPopupVisibleChange: this.onVisibleChange,
	        getPopupContainer: getPopupContainer
	      }),
	      this.renderChildren()
	    );
	  };
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
	  minOverlayWidthMatchTrigger: _propTypes2['default'].bool,
	  onVisibleChange: _propTypes2['default'].func,
	  onOverlayClick: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].string,
	  overlayClassName: _propTypes2['default'].string,
	  openClassName: _propTypes2['default'].string,
	  animation: _propTypes2['default'].any,
	  align: _propTypes2['default'].object,
	  overlayStyle: _propTypes2['default'].object,
	  placement: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
	  trigger: _propTypes2['default'].array,
	  alignPoint: _propTypes2['default'].bool,
	  showAction: _propTypes2['default'].array,
	  hideAction: _propTypes2['default'].array,
	  getPopupContainer: _propTypes2['default'].func,
	  visible: _propTypes2['default'].bool,
	  defaultVisible: _propTypes2['default'].bool
	};
	Dropdown.defaultProps = {
	  prefixCls: 'rc-dropdown',
	  trigger: ['hover'],
	  showAction: [],
	  overlayClassName: '',
	  overlayStyle: {},
	  defaultVisible: false,
	  onVisibleChange: function onVisibleChange() {},
	
	  placement: 'bottomLeft'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onClick = function (e) {
	    var props = _this2.props;
	    var overlayProps = _this2.getOverlayElement().props;
	    // do no call onVisibleChange, if you need click to hide, use onClick and control visible
	    if (!('visible' in props)) {
	      _this2.setState({
	        visible: false
	      });
	    }
	    if (props.onOverlayClick) {
	      props.onOverlayClick(e);
	    }
	    if (overlayProps.onClick) {
	      overlayProps.onClick(e);
	    }
	  };
	
	  this.onVisibleChange = function (visible) {
	    var props = _this2.props;
	    if (!('visible' in props)) {
	      _this2.setState({
	        visible: visible
	      });
	    }
	    props.onVisibleChange(visible);
	  };
	
	  this.getMinOverlayWidthMatchTrigger = function () {
	    var _props3 = _this2.props,
	        minOverlayWidthMatchTrigger = _props3.minOverlayWidthMatchTrigger,
	        alignPoint = _props3.alignPoint;
	
	    if ('minOverlayWidthMatchTrigger' in _this2.props) {
	      return minOverlayWidthMatchTrigger;
	    }
	
	    return !alignPoint;
	  };
	
	  this.getMenuElement = function () {
	    var prefixCls = _this2.props.prefixCls;
	
	    var overlayElement = _this2.getOverlayElement();
	    var extraOverlayProps = {
	      prefixCls: prefixCls + '-menu',
	      onClick: _this2.onClick
	    };
	    if (typeof overlayElement.type === 'string') {
	      delete extraOverlayProps.prefixCls;
	    }
	    return _react2['default'].cloneElement(overlayElement, extraOverlayProps);
	  };
	
	  this.afterVisibleChange = function (visible) {
	    if (visible && _this2.getMinOverlayWidthMatchTrigger()) {
	      var overlayNode = _this2.getPopupDomNode();
	      var rootNode = _reactDom2['default'].findDOMNode(_this2);
	      if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
	        overlayNode.style.minWidth = rootNode.offsetWidth + 'px';
	        if (_this2.trigger && _this2.trigger._component && _this2.trigger._component.alignInstance) {
	          _this2.trigger._component.alignInstance.forceAlign();
	        }
	      }
	    }
	  };
	
	  this.saveTrigger = function (node) {
	    _this2.trigger = node;
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Dropdown);
	
	exports['default'] = Dropdown;
	module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Dropdown = __webpack_require__(251);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Dropdown2['default'];
	module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  topCenter: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  bottomCenter: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(9));
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(56));
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(87));
	
	var _util = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
	var FLOAT_PRECISION_ADJUST = 0.5; // Fix ssr
	
	if (canUseDOM) {
	  // eslint-disable-next-line global-require
	  __webpack_require__(226);
	}
	
	var DOMWrap =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(DOMWrap, _React$Component);
	
	  function DOMWrap() {
	    var _this;
	
	    _classCallCheck(this, DOMWrap);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DOMWrap).apply(this, arguments));
	    _this.resizeObserver = null;
	    _this.mutationObserver = null; // original scroll size of the list
	
	    _this.originalTotalWidth = 0; // copy of overflowed items
	
	    _this.overflowedItems = []; // cache item of the original items (so we can track the size and order)
	
	    _this.menuItemSizes = [];
	    _this.state = {
	      lastVisibleIndex: undefined
	    }; // get all valid menuItem nodes
	
	    _this.getMenuItemNodes = function () {
	      var prefixCls = _this.props.prefixCls;
	      var ul = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	
	      if (!ul) {
	        return [];
	      } // filter out all overflowed indicator placeholder
	
	
	      return [].slice.call(ul.children).filter(function (node) {
	        return node.className.split(' ').indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
	      });
	    };
	
	    _this.getOverflowedSubMenuItem = function (keyPrefix, overflowedItems, renderPlaceholder) {
	      var _this$props = _this.props,
	          overflowedIndicator = _this$props.overflowedIndicator,
	          level = _this$props.level,
	          mode = _this$props.mode,
	          prefixCls = _this$props.prefixCls,
	          theme = _this$props.theme;
	
	      if (level !== 1 || mode !== 'horizontal') {
	        return null;
	      } // put all the overflowed item inside a submenu
	      // with a title of overflow indicator ('...')
	
	
	      var copy = _this.props.children[0];
	
	      var _copy$props = copy.props,
	          throwAway = _copy$props.children,
	          title = _copy$props.title,
	          propStyle = _copy$props.style,
	          rest = _objectWithoutProperties(_copy$props, ["children", "title", "style"]);
	
	      var style = _objectSpread({}, propStyle);
	
	      var key = "".concat(keyPrefix, "-overflowed-indicator");
	      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");
	
	      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
	        style = _objectSpread({}, style, {
	          display: 'none'
	        });
	      } else if (renderPlaceholder) {
	        style = _objectSpread({}, style, {
	          visibility: 'hidden',
	          // prevent from taking normal dom space
	          position: 'absolute'
	        });
	        key = "".concat(key, "-placeholder");
	        eventKey = "".concat(eventKey, "-placeholder");
	      }
	
	      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : '';
	      var props = {};
	
	      _util.menuAllProps.forEach(function (k) {
	        if (rest[k] !== undefined) {
	          props[k] = rest[k];
	        }
	      });
	
	      return React.createElement(_SubMenu.default, Object.assign({
	        title: overflowedIndicator,
	        className: "".concat(prefixCls, "-overflowed-submenu"),
	        popupClassName: popupClassName
	      }, props, {
	        key: key,
	        eventKey: eventKey,
	        disabled: false,
	        style: style
	      }), overflowedItems);
	    }; // memorize rendered menuSize
	
	
	    _this.setChildrenWidthAndResize = function () {
	      if (_this.props.mode !== 'horizontal') {
	        return;
	      }
	
	      var ul = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	
	      if (!ul) {
	        return;
	      }
	
	      var ulChildrenNodes = ul.children;
	
	      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
	        return;
	      }
	
	      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1]; // need last overflowed indicator for calculating length;
	
	      (0, _util.setStyle)(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');
	
	      var menuItemNodes = _this.getMenuItemNodes(); // reset display attribute for all hidden elements caused by overflow to calculate updated width
	      // and then reset to original state after width calculation
	
	
	      var overflowedItems = menuItemNodes.filter(function (c) {
	        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
	      });
	      overflowedItems.forEach(function (c) {
	        (0, _util.setStyle)(c, 'display', 'inline-block');
	      });
	      _this.menuItemSizes = menuItemNodes.map(function (c) {
	        return (0, _util.getWidth)(c);
	      });
	      overflowedItems.forEach(function (c) {
	        (0, _util.setStyle)(c, 'display', 'none');
	      });
	      _this.overflowedIndicatorWidth = (0, _util.getWidth)(ul.children[ul.children.length - 1]);
	      _this.originalTotalWidth = _this.menuItemSizes.reduce(function (acc, cur) {
	        return acc + cur;
	      }, 0);
	
	      _this.handleResize(); // prevent the overflowed indicator from taking space;
	
	
	      (0, _util.setStyle)(lastOverflowedIndicatorPlaceholder, 'display', 'none');
	    };
	
	    _this.handleResize = function () {
	      if (_this.props.mode !== 'horizontal') {
	        return;
	      }
	
	      var ul = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	
	      if (!ul) {
	        return;
	      }
	
	      var width = (0, _util.getWidth)(ul);
	      _this.overflowedItems = [];
	      var currentSumWidth = 0; // index for last visible child in horizontal mode
	
	      var lastVisibleIndex; // float number comparison could be problematic
	      // e.g. 0.1 + 0.2 > 0.3 =====> true
	      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation
	
	      if (_this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
	        lastVisibleIndex = -1;
	
	        _this.menuItemSizes.forEach(function (liWidth) {
	          currentSumWidth += liWidth;
	
	          if (currentSumWidth + _this.overflowedIndicatorWidth <= width) {
	            lastVisibleIndex += 1;
	          }
	        });
	      }
	
	      _this.setState({
	        lastVisibleIndex: lastVisibleIndex
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(DOMWrap, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setChildrenWidthAndResize();
	
	      if (this.props.level === 1 && this.props.mode === 'horizontal') {
	        var menuUl = ReactDOM.findDOMNode(this);
	
	        if (!menuUl) {
	          return;
	        }
	
	        this.resizeObserver = new _resizeObserverPolyfill.default(function (entries) {
	          entries.forEach(_this2.setChildrenWidthAndResize);
	        });
	        [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
	          _this2.resizeObserver.observe(el);
	        });
	
	        if (typeof MutationObserver !== 'undefined') {
	          this.mutationObserver = new MutationObserver(function () {
	            _this2.resizeObserver.disconnect();
	
	            [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
	              _this2.resizeObserver.observe(el);
	            });
	
	            _this2.setChildrenWidthAndResize();
	          });
	          this.mutationObserver.observe(menuUl, {
	            attributes: false,
	            childList: true,
	            subTree: false
	          });
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.resizeObserver) {
	        this.resizeObserver.disconnect();
	      }
	
	      if (this.mutationObserver) {
	        this.mutationObserver.disconnect();
	      }
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(children) {
	      var _this3 = this;
	
	      // need to take care of overflowed items in horizontal mode
	      var lastVisibleIndex = this.state.lastVisibleIndex;
	      return (children || []).reduce(function (acc, childNode, index) {
	        var item = childNode;
	
	        if (_this3.props.mode === 'horizontal') {
	          var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);
	
	          if (lastVisibleIndex !== undefined && _this3.props.className.indexOf("".concat(_this3.props.prefixCls, "-root")) !== -1) {
	            if (index > lastVisibleIndex) {
	              item = React.cloneElement(childNode, // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
	              {
	                style: {
	                  display: 'none'
	                },
	                eventKey: "".concat(childNode.props.eventKey, "-hidden"),
	
	                /**
	                 * Legacy code. Here `className` never used:
	                 * https://github.com/react-component/menu/commit/4cd6b49fce9d116726f4ea00dda85325d6f26500#diff-e2fa48f75c2dd2318295cde428556a76R240
	                 */
	                className: "".concat(MENUITEM_OVERFLOWED_CLASSNAME)
	              });
	            }
	
	            if (index === lastVisibleIndex + 1) {
	              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
	                return React.cloneElement(c, // children[index].key will become '.$key' in clone by default,
	                // we have to overwrite with the correct key explicitly
	                {
	                  key: c.props.eventKey,
	                  mode: 'vertical-left'
	                });
	              });
	              overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
	            }
	          }
	
	          var ret = [].concat(_toConsumableArray(acc), [overflowed, item]);
	
	          if (index === children.length - 1) {
	            // need a placeholder for calculating overflowed indicator width
	            ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
	          }
	
	          return ret;
	        }
	
	        return [].concat(_toConsumableArray(acc), [item]);
	      }, []);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          visible = _this$props2.visible,
	          prefixCls = _this$props2.prefixCls,
	          overflowedIndicator = _this$props2.overflowedIndicator,
	          mode = _this$props2.mode,
	          level = _this$props2.level,
	          tag = _this$props2.tag,
	          children = _this$props2.children,
	          theme = _this$props2.theme,
	          rest = _objectWithoutProperties(_this$props2, ["visible", "prefixCls", "overflowedIndicator", "mode", "level", "tag", "children", "theme"]);
	
	      var Tag = tag;
	      return React.createElement(Tag, Object.assign({}, rest), this.renderChildren(children));
	    }
	  }]);
	
	  return DOMWrap;
	}(React.Component);
	
	DOMWrap.defaultProps = {
	  tag: 'div',
	  className: ''
	};
	var _default = DOMWrap;
	exports.default = _default;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Divider = function Divider(_ref) {
	  var className = _ref.className,
	      rootPrefixCls = _ref.rootPrefixCls,
	      style = _ref.style;
	  return React.createElement("li", {
	    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
	    style: style
	  });
	};
	
	Divider.defaultProps = {
	  // To fix keyboard UX.
	  disabled: true,
	  className: '',
	  style: {}
	};
	var _default = Divider;
	exports.default = _default;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _miniStore = __webpack_require__(30);
	
	var _SubPopupMenu = _interopRequireWildcard(__webpack_require__(88));
	
	var _util = __webpack_require__(25);
	
	var _legacyUtil = __webpack_require__(261);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Menu =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Menu, _React$Component);
	
	  function Menu(props) {
	    var _this;
	
	    _classCallCheck(this, Menu);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this, props));
	
	    _this.onSelect = function (selectInfo) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      if (props.selectable) {
	        // root menu
	        var _this$store$getState = _this.store.getState(),
	            _selectedKeys = _this$store$getState.selectedKeys;
	
	        var selectedKey = selectInfo.key;
	
	        if (props.multiple) {
	          _selectedKeys = _selectedKeys.concat([selectedKey]);
	        } else {
	          _selectedKeys = [selectedKey];
	        }
	
	        if (!('selectedKeys' in props)) {
	          _this.store.setState({
	            selectedKeys: _selectedKeys
	          });
	        }
	
	        props.onSelect(_objectSpread({}, selectInfo, {
	          selectedKeys: _selectedKeys
	        }));
	      }
	    };
	
	    _this.onClick = function (e) {
	      _this.props.onClick(e);
	    }; // onKeyDown needs to be exposed as a instance method
	    // e.g., in rc-select, we need to navigate menu item while
	    // current active item is rc-select input box rather than the menu itself
	
	
	    _this.onKeyDown = function (e, callback) {
	      _this.innerMenu.getWrappedInstance().onKeyDown(e, callback);
	    };
	
	    _this.onOpenChange = function (event) {
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          props = _assertThisInitialize2.props;
	
	      var openKeys = _this.store.getState().openKeys.concat();
	
	      var changed = false;
	
	      var processSingle = function processSingle(e) {
	        var oneChanged = false;
	
	        if (e.open) {
	          oneChanged = openKeys.indexOf(e.key) === -1;
	
	          if (oneChanged) {
	            openKeys.push(e.key);
	          }
	        } else {
	          var index = openKeys.indexOf(e.key);
	          oneChanged = index !== -1;
	
	          if (oneChanged) {
	            openKeys.splice(index, 1);
	          }
	        }
	
	        changed = changed || oneChanged;
	      };
	
	      if (Array.isArray(event)) {
	        // batch change call
	        event.forEach(processSingle);
	      } else {
	        processSingle(event);
	      }
	
	      if (changed) {
	        if (!('openKeys' in _this.props)) {
	          _this.store.setState({
	            openKeys: openKeys
	          });
	        }
	
	        props.onOpenChange(openKeys);
	      }
	    };
	
	    _this.onDeselect = function (selectInfo) {
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          props = _assertThisInitialize3.props;
	
	      if (props.selectable) {
	        var _selectedKeys2 = _this.store.getState().selectedKeys.concat();
	
	        var selectedKey = selectInfo.key;
	
	        var index = _selectedKeys2.indexOf(selectedKey);
	
	        if (index !== -1) {
	          _selectedKeys2.splice(index, 1);
	        }
	
	        if (!('selectedKeys' in props)) {
	          _this.store.setState({
	            selectedKeys: _selectedKeys2
	          });
	        }
	
	        props.onDeselect(_objectSpread({}, selectInfo, {
	          selectedKeys: _selectedKeys2
	        }));
	      }
	    };
	
	    _this.getOpenTransitionName = function () {
	      var _assertThisInitialize4 = _assertThisInitialized(_this),
	          props = _assertThisInitialize4.props;
	
	      var transitionName = props.openTransitionName;
	      var animationName = props.openAnimation;
	
	      if (!transitionName && typeof animationName === 'string') {
	        transitionName = "".concat(props.prefixCls, "-open-").concat(animationName);
	      }
	
	      return transitionName;
	    };
	
	    _this.setInnerMenu = function (node) {
	      _this.innerMenu = node;
	    };
	
	    _this.isRootMenu = true;
	    var selectedKeys = props.defaultSelectedKeys;
	    var openKeys = props.defaultOpenKeys;
	
	    if ('selectedKeys' in props) {
	      selectedKeys = props.selectedKeys || [];
	    }
	
	    if ('openKeys' in props) {
	      openKeys = props.openKeys || [];
	    }
	
	    _this.store = (0, _miniStore.create)({
	      selectedKeys: selectedKeys,
	      openKeys: openKeys,
	      activeKey: {
	        '0-menu-': (0, _SubPopupMenu.getActiveKey)(props, props.activeKey)
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateMiniStore();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateMiniStore();
	    }
	  }, {
	    key: "updateMiniStore",
	    value: function updateMiniStore() {
	      if ('selectedKeys' in this.props) {
	        this.store.setState({
	          selectedKeys: this.props.selectedKeys || []
	        });
	      }
	
	      if ('openKeys' in this.props) {
	        this.store.setState({
	          openKeys: this.props.openKeys || []
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = _objectSpread({}, this.props);
	
	      props.className += " ".concat(props.prefixCls, "-root");
	      props = _objectSpread({}, props, {
	        onClick: this.onClick,
	        onOpenChange: this.onOpenChange,
	        onDeselect: this.onDeselect,
	        onSelect: this.onSelect,
	        parentMenu: this,
	        motion: (0, _legacyUtil.getMotion)(this.props)
	      });
	      delete props.openAnimation;
	      delete props.openTransitionName;
	      return React.createElement(_miniStore.Provider, {
	        store: this.store
	      }, React.createElement(_SubPopupMenu.default, Object.assign({}, props, {
	        ref: this.setInnerMenu
	      }), this.props.children));
	    }
	  }]);
	
	  return Menu;
	}(React.Component);
	
	Menu.defaultProps = {
	  selectable: true,
	  onClick: _util.noop,
	  onSelect: _util.noop,
	  onOpenChange: _util.noop,
	  onDeselect: _util.noop,
	  defaultSelectedKeys: [],
	  defaultOpenKeys: [],
	  subMenuOpenDelay: 0.1,
	  subMenuCloseDelay: 0.1,
	  triggerSubMenuAction: 'hover',
	  prefixCls: 'rc-menu',
	  className: '',
	  mode: 'vertical',
	  style: {},
	  builtinPlacements: {},
	  overflowedIndicator: React.createElement("span", null, "\xB7\xB7\xB7")
	};
	var _default = Menu;
	exports.default = _default;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(9));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(28));
	
	var _classnames = _interopRequireDefault(__webpack_require__(3));
	
	var _domScrollIntoView = _interopRequireDefault(__webpack_require__(179));
	
	var _miniStore = __webpack_require__(30);
	
	var _util = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MenuItem =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem() {
	    var _this;
	
	    _classCallCheck(this, MenuItem);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).apply(this, arguments));
	
	    _this.onKeyDown = function (e) {
	      var keyCode = e.keyCode;
	
	      if (keyCode === _KeyCode.default.ENTER) {
	        _this.onClick(e);
	
	        return true;
	      }
	
	      return undefined;
	    };
	
	    _this.onMouseLeave = function (e) {
	      var _this$props = _this.props,
	          eventKey = _this$props.eventKey,
	          onItemHover = _this$props.onItemHover,
	          onMouseLeave = _this$props.onMouseLeave;
	      onItemHover({
	        key: eventKey,
	        hover: false
	      });
	      onMouseLeave({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	
	    _this.onMouseEnter = function (e) {
	      var _this$props2 = _this.props,
	          eventKey = _this$props2.eventKey,
	          onItemHover = _this$props2.onItemHover,
	          onMouseEnter = _this$props2.onMouseEnter;
	      onItemHover({
	        key: eventKey,
	        hover: true
	      });
	      onMouseEnter({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	
	    _this.onClick = function (e) {
	      var _this$props3 = _this.props,
	          eventKey = _this$props3.eventKey,
	          multiple = _this$props3.multiple,
	          onClick = _this$props3.onClick,
	          onSelect = _this$props3.onSelect,
	          onDeselect = _this$props3.onDeselect,
	          isSelected = _this$props3.isSelected;
	      var info = {
	        key: eventKey,
	        keyPath: [eventKey],
	        item: _assertThisInitialized(_this),
	        domEvent: e
	      };
	      onClick(info);
	
	      if (multiple) {
	        if (isSelected) {
	          onDeselect(info);
	        } else {
	          onSelect(info);
	        }
	      } else if (!isSelected) {
	        onSelect(info);
	      }
	    };
	
	    _this.saveNode = function (node) {
	      _this.node = node;
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // invoke customized ref to expose component to mixin
	      this.callRef();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props4 = this.props,
	          active = _this$props4.active,
	          parentMenu = _this$props4.parentMenu,
	          eventKey = _this$props4.eventKey; // 在 parentMenu 上层保存滚动状态，避免重复的 MenuItem key 导致滚动跳动
	      // https://github.com/ant-design/ant-design/issues/16181
	
	      if (!prevProps.active && active && (!parentMenu || !parentMenu["scrolled-".concat(eventKey)])) {
	        if (this.node) {
	          (0, _domScrollIntoView.default)(this.node, ReactDOM.findDOMNode(parentMenu), {
	            onlyScrollIfNeeded: true
	          });
	          parentMenu["scrolled-".concat(eventKey)] = true;
	        }
	      } else if (parentMenu && parentMenu["scrolled-".concat(eventKey)]) {
	        delete parentMenu["scrolled-".concat(eventKey)];
	      }
	
	      this.callRef();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var props = this.props;
	
	      if (props.onDestroy) {
	        props.onDestroy(props.eventKey);
	      }
	    }
	  }, {
	    key: "getPrefixCls",
	    value: function getPrefixCls() {
	      return "".concat(this.props.rootPrefixCls, "-item");
	    }
	  }, {
	    key: "getActiveClassName",
	    value: function getActiveClassName() {
	      return "".concat(this.getPrefixCls(), "-active");
	    }
	  }, {
	    key: "getSelectedClassName",
	    value: function getSelectedClassName() {
	      return "".concat(this.getPrefixCls(), "-selected");
	    }
	  }, {
	    key: "getDisabledClassName",
	    value: function getDisabledClassName() {
	      return "".concat(this.getPrefixCls(), "-disabled");
	    }
	  }, {
	    key: "callRef",
	    value: function callRef() {
	      if (this.props.manualRef) {
	        this.props.manualRef(this);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var props = _objectSpread({}, this.props);
	
	      var className = (0, _classnames.default)(this.getPrefixCls(), props.className, (_classNames = {}, _defineProperty(_classNames, this.getActiveClassName(), !props.disabled && props.active), _defineProperty(_classNames, this.getSelectedClassName(), props.isSelected), _defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _classNames));
	
	      var attrs = _objectSpread({}, props.attribute, {
	        title: props.title,
	        className: className,
	        // set to menuitem by default
	        role: props.role || 'menuitem',
	        'aria-disabled': props.disabled
	      });
	
	      if (props.role === 'option') {
	        // overwrite to option
	        attrs = _objectSpread({}, attrs, {
	          role: 'option',
	          'aria-selected': props.isSelected
	        });
	      } else if (props.role === null || props.role === 'none') {
	        // sometimes we want to specify role inside <li/> element
	        // <li><a role='menuitem'>Link</a></li> would be a good example
	        // in this case the role on <li/> should be "none" to
	        // remove the implied listitem role.
	        // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
	        attrs.role = 'none';
	      } // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner
	
	
	      var mouseEvent = {
	        onClick: props.disabled ? null : this.onClick,
	        onMouseLeave: props.disabled ? null : this.onMouseLeave,
	        onMouseEnter: props.disabled ? null : this.onMouseEnter
	      };
	
	      var style = _objectSpread({}, props.style);
	
	      if (props.mode === 'inline') {
	        style.paddingLeft = props.inlineIndent * props.level;
	      }
	
	      _util.menuAllProps.forEach(function (key) {
	        return delete props[key];
	      });
	
	      var icon = this.props.itemIcon;
	
	      if (typeof this.props.itemIcon === 'function') {
	        // TODO: This is a bug which should fixed after TS refactor
	        icon = React.createElement(this.props.itemIcon, this.props);
	      }
	
	      return React.createElement("li", Object.assign({}, props, attrs, mouseEvent, {
	        style: style,
	        ref: this.saveNode
	      }), props.children, icon);
	    }
	  }]);
	
	  return MenuItem;
	}(React.Component);
	
	exports.MenuItem = MenuItem;
	MenuItem.isMenuItem = true;
	MenuItem.defaultProps = {
	  onSelect: _util.noop,
	  onMouseEnter: _util.noop,
	  onMouseLeave: _util.noop,
	  manualRef: _util.noop
	};
	var connected = (0, _miniStore.connect)(function (_ref, _ref2) {
	  var activeKey = _ref.activeKey,
	      selectedKeys = _ref.selectedKeys;
	  var eventKey = _ref2.eventKey,
	      subMenuKey = _ref2.subMenuKey;
	  return {
	    active: activeKey[subMenuKey] === eventKey,
	    isSelected: selectedKeys.indexOf(eventKey) !== -1
	  };
	})(MenuItem);
	var _default = connected;
	exports.default = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _util = __webpack_require__(25);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MenuItemGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(MenuItemGroup, _React$Component);
	
	  function MenuItemGroup() {
	    var _this;
	
	    _classCallCheck(this, MenuItemGroup);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItemGroup).apply(this, arguments));
	
	    _this.renderInnerMenuItem = function (item) {
	      var _this$props = _this.props,
	          renderMenuItem = _this$props.renderMenuItem,
	          index = _this$props.index;
	      return renderMenuItem(item, index, _this.props.subMenuKey);
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItemGroup, [{
	    key: "render",
	    value: function render() {
	      var props = _extends({}, this.props);
	
	      var _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className,
	          rootPrefixCls = props.rootPrefixCls;
	      var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
	      var listClassName = "".concat(rootPrefixCls, "-item-group-list");
	      var title = props.title,
	          children = props.children;
	
	      _util.menuAllProps.forEach(function (key) {
	        return delete props[key];
	      }); // Set onClick to null, to ignore propagated onClick event
	
	
	      delete props.onClick;
	      return React.createElement("li", Object.assign({}, props, {
	        className: "".concat(className, " ").concat(rootPrefixCls, "-item-group")
	      }), React.createElement("div", {
	        className: titleClassName,
	        title: typeof title === 'string' ? title : undefined
	      }, title), React.createElement("ul", {
	        className: listClassName
	      }, React.Children.map(children, this.renderInnerMenuItem)));
	    }
	  }]);
	
	  return MenuItemGroup;
	}(React.Component);
	
	MenuItemGroup.isMenuItemGroup = true;
	MenuItemGroup.defaultProps = {
	  disabled: true
	};
	var _default = MenuItemGroup;
	exports.default = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.placements = void 0;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	var placements = {
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -7]
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 7]
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0]
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0]
	  }
	};
	exports.placements = placements;
	var _default = placements;
	exports.default = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	// MIT License from https://github.com/kaimallea/isMobile
	var applePhone = /iPhone/i;
	var appleIpod = /iPod/i;
	var appleTablet = /iPad/i;
	var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'
	
	var androidTablet = /Android/i;
	var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
	var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
	var windowsPhone = /Windows Phone/i;
	var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'
	
	var otherBlackberry = /BlackBerry/i;
	var otherBlackberry10 = /BB10/i;
	var otherOpera = /Opera Mini/i;
	var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
	var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'
	
	function match(regex, userAgent) {
	  return regex.test(userAgent);
	}
	
	function isMobile(userAgent) {
	  var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''); // Facebook mobile app's integrated browser adds a bunch of strings that
	  // match everything. Strip it out if it exists.
	
	  var tmp = ua.split('[FBAN');
	
	  if (typeof tmp[1] !== 'undefined') {
	    var _tmp = tmp;
	
	    var _tmp2 = _slicedToArray(_tmp, 1);
	
	    ua = _tmp2[0];
	  } // Twitter mobile app's integrated browser on iPad adds a "Twitter for
	  // iPhone" string. Same probably happens on other tablet platforms.
	  // This will confuse detection so strip it out if it exists.
	
	
	  tmp = ua.split('Twitter');
	
	  if (typeof tmp[1] !== 'undefined') {
	    var _tmp3 = tmp;
	
	    var _tmp4 = _slicedToArray(_tmp3, 1);
	
	    ua = _tmp4[0];
	  }
	
	  var result = {
	    apple: {
	      phone: match(applePhone, ua) && !match(windowsPhone, ua),
	      ipod: match(appleIpod, ua),
	      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
	      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
	    },
	    amazon: {
	      phone: match(amazonPhone, ua),
	      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
	      device: match(amazonPhone, ua) || match(amazonTablet, ua)
	    },
	    android: {
	      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
	      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
	      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
	    },
	    windows: {
	      phone: match(windowsPhone, ua),
	      tablet: match(windowsTablet, ua),
	      device: match(windowsPhone, ua) || match(windowsTablet, ua)
	    },
	    other: {
	      blackberry: match(otherBlackberry, ua),
	      blackberry10: match(otherBlackberry10, ua),
	      opera: match(otherOpera, ua),
	      firefox: match(otherFirefox, ua),
	      chrome: match(otherChrome, ua),
	      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
	    },
	    // Additional
	    any: null,
	    phone: null,
	    tablet: null
	  };
	  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device; // excludes 'other' devices and ipods, targeting touchscreen phones
	
	  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
	  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
	  return result;
	}
	
	var defaultResult = _objectSpread({}, isMobile(), {
	  isMobile: isMobile
	});
	
	var _default = defaultResult;
	exports.default = _default;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMotion = getMotion;
	
	var _warning = _interopRequireDefault(__webpack_require__(107));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function getMotion(_ref) {
	  var prefixCls = _ref.prefixCls,
	      motion = _ref.motion,
	      openAnimation = _ref.openAnimation,
	      openTransitionName = _ref.openTransitionName;
	
	  if (motion) {
	    return motion;
	  }
	
	  if (_typeof(openAnimation) === 'object' && openAnimation) {
	    (0, _warning.default)(false, 'Object type of `openAnimation` is removed. Please use `motion` instead.');
	  } else if (typeof openAnimation === 'string') {
	    return {
	      motionName: "".concat(prefixCls, "-open-").concat(openAnimation)
	    };
	  }
	
	  if (openTransitionName) {
	    return {
	      motionName: openTransitionName
	    };
	  }
	
	  return null;
	}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var findDOMNode_1 = __importDefault(__webpack_require__(96));
	
	var toArray_1 = __importDefault(__webpack_require__(278));
	
	var warning_1 = __importDefault(__webpack_require__(107));
	
	var ref_1 = __webpack_require__(282);
	
	var resize_observer_polyfill_1 = __importDefault(__webpack_require__(56));
	
	var util_1 = __webpack_require__(263);
	
	var INTERNAL_PREFIX_KEY = 'rc-observer-key'; // Still need to be compatible with React 15, we use class component here
	
	var ReactResizeObserver =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ReactResizeObserver, _React$Component);
	
	  function ReactResizeObserver() {
	    var _this;
	
	    _classCallCheck(this, ReactResizeObserver);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactResizeObserver).apply(this, arguments));
	    _this.resizeObserver = null;
	    _this.childNode = null;
	    _this.currentElement = null;
	    _this.state = {
	      width: 0,
	      height: 0
	    };
	
	    _this.onResize = function (entries) {
	      var onResize = _this.props.onResize;
	      var target = entries[0].target;
	
	      var _target$getBoundingCl = target.getBoundingClientRect(),
	          width = _target$getBoundingCl.width,
	          height = _target$getBoundingCl.height;
	      /**
	       * Resize observer trigger when content size changed.
	       * In most case we just care about element size,
	       * let's use `boundary` instead of `contentRect` here to avoid shaking.
	       */
	
	
	      var fixedWidth = Math.floor(width);
	      var fixedHeight = Math.floor(height);
	
	      if (_this.state.width !== fixedWidth || _this.state.height !== fixedHeight) {
	        var size = {
	          width: fixedWidth,
	          height: fixedHeight
	        };
	
	        _this.setState(size);
	
	        if (onResize) {
	          onResize(size);
	        }
	      }
	    };
	
	    _this.setChildNode = function (node) {
	      _this.childNode = node;
	    };
	
	    return _this;
	  }
	
	  _createClass(ReactResizeObserver, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.onComponentUpdated();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.onComponentUpdated();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyObserver();
	    }
	  }, {
	    key: "onComponentUpdated",
	    value: function onComponentUpdated() {
	      var disabled = this.props.disabled; // Unregister if disabled
	
	      if (disabled) {
	        this.destroyObserver();
	        return;
	      } // Unregister if element changed
	
	
	      var element = findDOMNode_1.default(this.childNode || this);
	      var elementChanged = element !== this.currentElement;
	
	      if (elementChanged) {
	        this.destroyObserver();
	        this.currentElement = element;
	      }
	
	      if (!this.resizeObserver && element) {
	        this.resizeObserver = new resize_observer_polyfill_1.default(this.onResize);
	        this.resizeObserver.observe(element);
	      }
	    }
	  }, {
	    key: "destroyObserver",
	    value: function destroyObserver() {
	      if (this.resizeObserver) {
	        this.resizeObserver.disconnect();
	        this.resizeObserver = null;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      var childNodes = toArray_1.default(children);
	
	      if (childNodes.length > 1) {
	        warning_1.default(false, 'Find more than one child node with `children` in ResizeObserver. Will only observe first one.');
	      } else if (childNodes.length === 0) {
	        warning_1.default(false, '`children` of ResizeObserver is empty. Nothing is in observe.');
	        return null;
	      }
	
	      var childNode = childNodes[0];
	
	      if (React.isValidElement(childNode) && util_1.supportRef(childNode)) {
	        var ref = childNode.ref;
	        childNodes[0] = React.cloneElement(childNode, {
	          ref: ref_1.composeRef(ref, this.setChildNode)
	        });
	      }
	
	      return childNodes.length === 1 ? childNodes[0] : childNodes.map(function (node, index) {
	        if (!React.isValidElement(node) || 'key' in node && node.key !== null) {
	          return node;
	        }
	
	        return React.cloneElement(node, {
	          key: "".concat(INTERNAL_PREFIX_KEY, "-").concat(index)
	        });
	      });
	    }
	  }]);
	
	  return ReactResizeObserver;
	}(React.Component);
	
	ReactResizeObserver.displayName = 'ResizeObserver';
	exports.default = ReactResizeObserver;

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function supportRef(node) {
	  // Function component
	  if (node.type && node.type.prototype && !node.type.prototype.render) {
	    return false;
	  }
	
	  return true;
	}
	
	exports.supportRef = supportRef;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _componentDidUpdate(component, init) {
	  var _component$props = component.props,
	      styles = _component$props.styles,
	      panels = _component$props.panels,
	      activeKey = _component$props.activeKey,
	      direction = _component$props.direction;
	
	  var rootNode = component.props.getRef('root');
	  var wrapNode = component.props.getRef('nav') || rootNode;
	  var inkBarNode = component.props.getRef('inkBar');
	  var activeTab = component.props.getRef('activeTab');
	  var inkBarNodeStyle = inkBarNode.style;
	  var tabBarPosition = component.props.tabBarPosition;
	  var activeIndex = (0, _utils.getActiveIndex)(panels, activeKey);
	  if (init) {
	    // prevent mount animation
	    inkBarNodeStyle.display = 'none';
	  }
	  if (activeTab) {
	    var tabNode = activeTab;
	    var transformSupported = (0, _utils.isTransform3dSupported)(inkBarNodeStyle);
	
	    // Reset current style
	    (0, _utils.setTransform)(inkBarNodeStyle, '');
	    inkBarNodeStyle.width = '';
	    inkBarNodeStyle.height = '';
	    inkBarNodeStyle.left = '';
	    inkBarNodeStyle.top = '';
	    inkBarNodeStyle.bottom = '';
	    inkBarNodeStyle.right = '';
	
	    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
	      var left = (0, _utils.getLeft)(tabNode, wrapNode);
	      var width = tabNode.offsetWidth;
	
	      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
	      // It means no css working, then ink bar should not have width until css is loaded
	      // Fix https://github.com/ant-design/ant-design/issues/7564
	      if (width === rootNode.offsetWidth) {
	        width = 0;
	      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
	        width = parseFloat(styles.inkBar.width, 10);
	        if (width) {
	          left += (tabNode.offsetWidth - width) / 2;
	        }
	      }
	      if (direction === 'rtl') {
	        left = (0, _utils.getStyle)(tabNode, 'margin-left') - left;
	      }
	      // use 3d gpu to optimize render
	      if (transformSupported) {
	        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
	      } else {
	        inkBarNodeStyle.left = left + 'px';
	      }
	      inkBarNodeStyle.width = width + 'px';
	    } else {
	      var top = (0, _utils.getTop)(tabNode, wrapNode, true);
	      var height = tabNode.offsetHeight;
	      if (styles.inkBar && styles.inkBar.height !== undefined) {
	        height = parseFloat(styles.inkBar.height, 10);
	        if (height) {
	          top += (tabNode.offsetHeight - height) / 2;
	        }
	      }
	      if (transformSupported) {
	        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
	        inkBarNodeStyle.top = '0';
	      } else {
	        inkBarNodeStyle.top = top + 'px';
	      }
	      inkBarNodeStyle.height = height + 'px';
	    }
	  }
	  inkBarNodeStyle.display = activeIndex !== -1 ? 'block' : 'none';
	}
	
	var InkTabBarNode = function (_React$Component) {
	  (0, _inherits3['default'])(InkTabBarNode, _React$Component);
	
	  function InkTabBarNode() {
	    (0, _classCallCheck3['default'])(this, InkTabBarNode);
	    return (0, _possibleConstructorReturn3['default'])(this, (InkTabBarNode.__proto__ || Object.getPrototypeOf(InkTabBarNode)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(InkTabBarNode, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // ref https://github.com/ant-design/ant-design/issues/8678
	      // ref https://github.com/react-component/tabs/issues/135
	      // InkTabBarNode need parent/root ref for calculating position
	      // since parent componentDidMount triggered after child componentDidMount
	      // we're doing a quick fix here to use setTimeout to calculate position
	      // after parent/root component mounted
	      this.timeout = setTimeout(function () {
	        _componentDidUpdate(_this2, true);
	      }, 0);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _componentDidUpdate(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          styles = _props.styles,
	          inkBarAnimated = _props.inkBarAnimated;
	
	      var className = prefixCls + '-ink-bar';
	      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
	      return _react2['default'].createElement('div', {
	        style: styles.inkBar,
	        className: classes,
	        key: 'inkBar',
	        ref: this.props.saveRef('inkBar')
	      });
	    }
	  }]);
	  return InkTabBarNode;
	}(_react2['default'].Component);
	
	exports['default'] = InkTabBarNode;
	
	
	InkTabBarNode.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  styles: _propTypes2['default'].object,
	  inkBarAnimated: _propTypes2['default'].bool,
	  saveRef: _propTypes2['default'].func,
	  direction: _propTypes2['default'].string
	};
	
	InkTabBarNode.defaultProps = {
	  prefixCls: '',
	  inkBarAnimated: true,
	  styles: {},
	  saveRef: function saveRef() {}
	};
	module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  /**
	   * LEFT
	   */
	  LEFT: 37, // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38, // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39, // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40 // also NUM_SOUTH
	};
	module.exports = exports['default'];

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SaveRef = function (_React$Component) {
	  (0, _inherits3['default'])(SaveRef, _React$Component);
	
	  function SaveRef() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, SaveRef);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = SaveRef.__proto__ || Object.getPrototypeOf(SaveRef)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (name) {
	      return _this[name];
	    }, _this.saveRef = function (name) {
	      return function (node) {
	        if (node) {
	          _this[name] = node;
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(SaveRef, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children(this.saveRef, this.getRef);
	    }
	  }]);
	  return SaveRef;
	}(_react2['default'].Component);
	
	exports['default'] = SaveRef;
	
	
	SaveRef.propTypes = {
	  children: _propTypes2['default'].func
	};
	
	SaveRef.defaultProps = {
	  children: function children() {
	    return null;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InkTabBarNode = __webpack_require__(264);
	
	var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);
	
	var _TabBarTabsNode = __webpack_require__(270);
	
	var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);
	
	var _TabBarRootNode = __webpack_require__(269);
	
	var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);
	
	var _ScrollableTabBarNode = __webpack_require__(268);
	
	var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);
	
	var _SaveRef = __webpack_require__(266);
	
	var _SaveRef2 = _interopRequireDefault(_SaveRef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ScrollableInkTabBar = function (_React$Component) {
	  (0, _inherits3['default'])(ScrollableInkTabBar, _React$Component);
	
	  function ScrollableInkTabBar() {
	    (0, _classCallCheck3['default'])(this, ScrollableInkTabBar);
	    return (0, _possibleConstructorReturn3['default'])(this, (ScrollableInkTabBar.__proto__ || Object.getPrototypeOf(ScrollableInkTabBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(ScrollableInkTabBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          renderTabBarNode = _props.children,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	
	      return _react2['default'].createElement(
	        _SaveRef2['default'],
	        null,
	        function (saveRef, getRef) {
	          return _react2['default'].createElement(
	            _TabBarRootNode2['default'],
	            (0, _extends3['default'])({ saveRef: saveRef }, restProps),
	            _react2['default'].createElement(
	              _ScrollableTabBarNode2['default'],
	              (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps),
	              _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, renderTabBarNode: renderTabBarNode }, restProps)),
	              _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps))
	            )
	          );
	        }
	      );
	    }
	  }]);
	  return ScrollableInkTabBar;
	}(_react2['default'].Component); /* eslint-disable react/prefer-stateless-function */
	
	
	exports['default'] = ScrollableInkTabBar;
	
	
	ScrollableInkTabBar.propTypes = {
	  children: _propTypes2['default'].func
	};
	module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames5 = __webpack_require__(3);
	
	var _classnames6 = _interopRequireDefault(_classnames5);
	
	var _debounce = __webpack_require__(218);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _resizeObserverPolyfill = __webpack_require__(56);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _utils = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ScrollableTabBarNode = function (_React$Component) {
	  (0, _inherits3['default'])(ScrollableTabBarNode, _React$Component);
	
	  function ScrollableTabBarNode(props) {
	    (0, _classCallCheck3['default'])(this, ScrollableTabBarNode);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (ScrollableTabBarNode.__proto__ || Object.getPrototypeOf(ScrollableTabBarNode)).call(this, props));
	
	    _this.prevTransitionEnd = function (e) {
	      if (e.propertyName !== 'opacity') {
	        return;
	      }
	      var container = _this.props.getRef('container');
	      _this.scrollToActiveTab({
	        target: container,
	        currentTarget: container
	      });
	    };
	
	    _this.scrollToActiveTab = function (e) {
	      var activeTab = _this.props.getRef('activeTab');
	      var navWrap = _this.props.getRef('navWrap');
	      if (e && e.target !== e.currentTarget || !activeTab) {
	        return;
	      }
	
	      // when not scrollable or enter scrollable first time, don't emit scrolling
	      var needToSroll = _this.isNextPrevShown() && _this.lastNextPrevShown;
	      _this.lastNextPrevShown = _this.isNextPrevShown();
	      if (!needToSroll) {
	        return;
	      }
	
	      var activeTabWH = _this.getScrollWH(activeTab);
	      var navWrapNodeWH = _this.getOffsetWH(navWrap);
	      var offset = _this.offset;
	
	      var wrapOffset = _this.getOffsetLT(navWrap);
	      var activeTabOffset = _this.getOffsetLT(activeTab);
	      if (wrapOffset > activeTabOffset) {
	        offset += wrapOffset - activeTabOffset;
	        _this.setOffset(offset);
	      } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
	        offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
	        _this.setOffset(offset);
	      }
	    };
	
	    _this.prev = function (e) {
	      _this.props.onPrevClick(e);
	      var navWrapNode = _this.props.getRef('navWrap');
	      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
	      var offset = _this.offset;
	
	      _this.setOffset(offset + navWrapNodeWH);
	    };
	
	    _this.next = function (e) {
	      _this.props.onNextClick(e);
	      var navWrapNode = _this.props.getRef('navWrap');
	      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
	      var offset = _this.offset;
	
	      _this.setOffset(offset - navWrapNodeWH);
	    };
	
	    _this.offset = 0;
	
	    _this.state = {
	      next: false,
	      prev: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(ScrollableTabBarNode, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.componentDidUpdate();
	      this.debouncedResize = (0, _debounce2['default'])(function () {
	        _this2.setNextPrev();
	        _this2.scrollToActiveTab();
	      }, 200);
	      this.resizeObserver = new _resizeObserverPolyfill2['default'](this.debouncedResize);
	      this.resizeObserver.observe(this.props.getRef('container'));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var props = this.props;
	      if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
	        this.setOffset(0);
	        return;
	      }
	      var nextPrev = this.setNextPrev();
	      // wait next, prev show hide
	      /* eslint react/no-did-update-set-state:0 */
	      if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
	        this.setState({}, this.scrollToActiveTab);
	      } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
	        // can not use props.activeKey
	        this.scrollToActiveTab();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.resizeObserver) {
	        this.resizeObserver.disconnect();
	      }
	      if (this.debouncedResize && this.debouncedResize.cancel) {
	        this.debouncedResize.cancel();
	      }
	    }
	  }, {
	    key: 'setNextPrev',
	    value: function setNextPrev() {
	      var navNode = this.props.getRef('nav');
	      var navTabsContainer = this.props.getRef('navTabsContainer');
	      var navNodeWH = this.getScrollWH(navTabsContainer || navNode);
	      // Add 1px to fix `offsetWidth` with decimal in Chrome not correct handle
	      // https://github.com/ant-design/ant-design/issues/13423
	      var containerWH = this.getOffsetWH(this.props.getRef('container')) + 1;
	      var navWrapNodeWH = this.getOffsetWH(this.props.getRef('navWrap'));
	      var offset = this.offset;
	
	      var minOffset = containerWH - navNodeWH;
	      var _state = this.state,
	          next = _state.next,
	          prev = _state.prev;
	
	      if (minOffset >= 0) {
	        next = false;
	        this.setOffset(0, false);
	        offset = 0;
	      } else if (minOffset < offset) {
	        next = true;
	      } else {
	        next = false;
	        // Fix https://github.com/ant-design/ant-design/issues/8861
	        // Test with container offset which is stable
	        // and set the offset of the nav wrap node
	        var realOffset = navWrapNodeWH - navNodeWH;
	        this.setOffset(realOffset, false);
	        offset = realOffset;
	      }
	
	      if (offset < 0) {
	        prev = true;
	      } else {
	        prev = false;
	      }
	
	      this.setNext(next);
	      this.setPrev(prev);
	      return {
	        next: next,
	        prev: prev
	      };
	    }
	  }, {
	    key: 'getOffsetWH',
	    value: function getOffsetWH(node) {
	      var tabBarPosition = this.props.tabBarPosition;
	      var prop = 'offsetWidth';
	      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	        prop = 'offsetHeight';
	      }
	      return node[prop];
	    }
	  }, {
	    key: 'getScrollWH',
	    value: function getScrollWH(node) {
	      var tabBarPosition = this.props.tabBarPosition;
	      var prop = 'scrollWidth';
	      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	        prop = 'scrollHeight';
	      }
	      return node[prop];
	    }
	  }, {
	    key: 'getOffsetLT',
	    value: function getOffsetLT(node) {
	      var tabBarPosition = this.props.tabBarPosition;
	      var prop = 'left';
	      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	        prop = 'top';
	      }
	      return node.getBoundingClientRect()[prop];
	    }
	  }, {
	    key: 'setOffset',
	    value: function setOffset(offset) {
	      var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var target = Math.min(0, offset);
	      if (this.offset !== target) {
	        this.offset = target;
	        var navOffset = {};
	        var tabBarPosition = this.props.tabBarPosition;
	        var navStyle = this.props.getRef('nav').style;
	        var transformSupported = (0, _utils.isTransform3dSupported)(navStyle);
	        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	          if (transformSupported) {
	            navOffset = {
	              value: 'translate3d(0,' + target + 'px,0)'
	            };
	          } else {
	            navOffset = {
	              name: 'top',
	              value: target + 'px'
	            };
	          }
	        } else if (transformSupported) {
	          if (this.props.direction === 'rtl') {
	            target = -target;
	          }
	          navOffset = {
	            value: 'translate3d(' + target + 'px,0,0)'
	          };
	        } else {
	          navOffset = {
	            name: 'left',
	            value: target + 'px'
	          };
	        }
	        if (transformSupported) {
	          (0, _utils.setTransform)(navStyle, navOffset.value);
	        } else {
	          navStyle[navOffset.name] = navOffset.value;
	        }
	        if (checkNextPrev) {
	          this.setNextPrev();
	        }
	      }
	    }
	  }, {
	    key: 'setPrev',
	    value: function setPrev(v) {
	      if (this.state.prev !== v) {
	        this.setState({
	          prev: v
	        });
	      }
	    }
	  }, {
	    key: 'setNext',
	    value: function setNext(v) {
	      if (this.state.next !== v) {
	        this.setState({
	          next: v
	        });
	      }
	    }
	  }, {
	    key: 'isNextPrevShown',
	    value: function isNextPrevShown(state) {
	      if (state) {
	        return state.next || state.prev;
	      }
	      return this.state.next || this.state.prev;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames, _classnames2, _classnames3, _classnames4;
	
	      var _state2 = this.state,
	          next = _state2.next,
	          prev = _state2.prev;
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          scrollAnimated = _props.scrollAnimated,
	          navWrapper = _props.navWrapper,
	          prevIcon = _props.prevIcon,
	          nextIcon = _props.nextIcon;
	
	      var showNextPrev = prev || next;
	
	      var prevButton = _react2['default'].createElement(
	        'span',
	        {
	          onClick: prev ? this.prev : null,
	          unselectable: 'unselectable',
	          className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
	          onTransitionEnd: this.prevTransitionEnd
	        },
	        prevIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' })
	      );
	
	      var nextButton = _react2['default'].createElement(
	        'span',
	        {
	          onClick: next ? this.next : null,
	          unselectable: 'unselectable',
	          className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
	        },
	        nextIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' })
	      );
	
	      var navClassName = prefixCls + '-nav';
	      var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
	          key: 'container',
	          ref: this.props.saveRef('container')
	        },
	        prevButton,
	        nextButton,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-nav-wrap', ref: this.props.saveRef('navWrap') },
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-nav-scroll' },
	            _react2['default'].createElement(
	              'div',
	              { className: navClasses, ref: this.props.saveRef('nav') },
	              navWrapper(this.props.children)
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ScrollableTabBarNode;
	}(_react2['default'].Component);
	
	exports['default'] = ScrollableTabBarNode;
	
	
	ScrollableTabBarNode.propTypes = {
	  activeKey: _propTypes2['default'].string,
	  getRef: _propTypes2['default'].func.isRequired,
	  saveRef: _propTypes2['default'].func.isRequired,
	  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
	  prefixCls: _propTypes2['default'].string,
	  scrollAnimated: _propTypes2['default'].bool,
	  onPrevClick: _propTypes2['default'].func,
	  onNextClick: _propTypes2['default'].func,
	  navWrapper: _propTypes2['default'].func,
	  children: _propTypes2['default'].node,
	  prevIcon: _propTypes2['default'].node,
	  nextIcon: _propTypes2['default'].node,
	  direction: _propTypes2['default'].node
	};
	
	ScrollableTabBarNode.defaultProps = {
	  tabBarPosition: 'left',
	  prefixCls: '',
	  scrollAnimated: true,
	  onPrevClick: function onPrevClick() {},
	  onNextClick: function onNextClick() {},
	  navWrapper: function navWrapper(ele) {
	    return ele;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabBarRootNode = function (_React$Component) {
	  (0, _inherits3['default'])(TabBarRootNode, _React$Component);
	
	  function TabBarRootNode() {
	    (0, _classCallCheck3['default'])(this, TabBarRootNode);
	    return (0, _possibleConstructorReturn3['default'])(this, (TabBarRootNode.__proto__ || Object.getPrototypeOf(TabBarRootNode)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(TabBarRootNode, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          onKeyDown = _props.onKeyDown,
	          className = _props.className,
	          extraContent = _props.extraContent,
	          style = _props.style,
	          tabBarPosition = _props.tabBarPosition,
	          children = _props.children,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition', 'children']);
	
	      var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
	      var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
	      var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
	      var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
	      var newChildren = children;
	      if (extraContent) {
	        newChildren = [(0, _react.cloneElement)(extraContent, {
	          key: 'extra',
	          style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
	        }), (0, _react.cloneElement)(children, { key: 'content' })];
	        newChildren = topOrBottom ? newChildren : newChildren.reverse();
	      }
	      return _react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          role: 'tablist',
	          className: cls,
	          tabIndex: '0',
	          ref: this.props.saveRef('root'),
	          onKeyDown: onKeyDown,
	          style: style
	        }, (0, _utils.getDataAttr)(restProps)),
	        newChildren
	      );
	    }
	  }]);
	  return TabBarRootNode;
	}(_react2['default'].Component);
	
	exports['default'] = TabBarRootNode;
	
	
	TabBarRootNode.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
	  children: _propTypes2['default'].node,
	  extraContent: _propTypes2['default'].node,
	  onKeyDown: _propTypes2['default'].func,
	  saveRef: _propTypes2['default'].func
	};
	
	TabBarRootNode.defaultProps = {
	  prefixCls: '',
	  className: '',
	  style: {},
	  tabBarPosition: 'top',
	  extraContent: null,
	  children: null,
	  onKeyDown: function onKeyDown() {},
	  saveRef: function saveRef() {}
	};
	module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(35);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabBarTabsNode = function (_React$Component) {
	  (0, _inherits3['default'])(TabBarTabsNode, _React$Component);
	
	  function TabBarTabsNode() {
	    (0, _classCallCheck3['default'])(this, TabBarTabsNode);
	    return (0, _possibleConstructorReturn3['default'])(this, (TabBarTabsNode.__proto__ || Object.getPrototypeOf(TabBarTabsNode)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(TabBarTabsNode, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.panels,
	          activeKey = _props.activeKey,
	          prefixCls = _props.prefixCls,
	          tabBarGutter = _props.tabBarGutter,
	          saveRef = _props.saveRef,
	          tabBarPosition = _props.tabBarPosition,
	          renderTabBarNode = _props.renderTabBarNode,
	          direction = _props.direction;
	
	      var rst = [];
	
	      _react2['default'].Children.forEach(children, function (child, index) {
	        if (!child) {
	          return;
	        }
	        var key = child.key;
	        var cls = activeKey === key ? prefixCls + '-tab-active' : '';
	        cls += ' ' + prefixCls + '-tab';
	        var events = {};
	        if (child.props.disabled) {
	          cls += ' ' + prefixCls + '-tab-disabled';
	        } else {
	          events = {
	            onClick: _this2.props.onTabClick.bind(_this2, key)
	          };
	        }
	        var ref = {};
	        if (activeKey === key) {
	          ref.ref = saveRef('activeTab');
	        }
	
	        var gutter = tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter;
	
	        var marginProperty = direction === 'rtl' ? 'marginLeft' : 'marginRight';
	        var style = (0, _defineProperty3['default'])({}, (0, _utils.isVertical)(tabBarPosition) ? 'marginBottom' : marginProperty, gutter);
	        (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');
	
	        var node = _react2['default'].createElement(
	          'div',
	          (0, _extends3['default'])({
	            role: 'tab',
	            'aria-disabled': child.props.disabled ? 'true' : 'false',
	            'aria-selected': activeKey === key ? 'true' : 'false'
	          }, events, {
	            className: cls,
	            key: key,
	            style: style
	          }, ref),
	          child.props.tab
	        );
	
	        if (renderTabBarNode) {
	          node = renderTabBarNode(node);
	        }
	
	        rst.push(node);
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { ref: saveRef('navTabsContainer') },
	        rst
	      );
	    }
	  }]);
	  return TabBarTabsNode;
	}(_react2['default'].Component);
	
	exports['default'] = TabBarTabsNode;
	
	
	TabBarTabsNode.propTypes = {
	  activeKey: _propTypes2['default'].string,
	  panels: _propTypes2['default'].node,
	  prefixCls: _propTypes2['default'].string,
	  tabBarGutter: _propTypes2['default'].number,
	  onTabClick: _propTypes2['default'].func,
	  saveRef: _propTypes2['default'].func,
	  renderTabBarNode: _propTypes2['default'].func,
	  tabBarPosition: _propTypes2['default'].string,
	  direction: _propTypes2['default'].string
	};
	
	TabBarTabsNode.defaultProps = {
	  panels: [],
	  prefixCls: [],
	  tabBarGutter: null,
	  onTabClick: function onTabClick() {},
	  saveRef: function saveRef() {}
	};
	module.exports = exports['default'];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _raf = __webpack_require__(51);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _KeyCode = __webpack_require__(265);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _TabPane = __webpack_require__(91);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _utils = __webpack_require__(23);
	
	var _Sentinel = __webpack_require__(89);
	
	var _Sentinel2 = _interopRequireDefault(_Sentinel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function getDefaultActiveKey(props) {
	  var activeKey = void 0;
	  _react2['default'].Children.forEach(props.children, function (child) {
	    if (child && !activeKey && !child.props.disabled) {
	      activeKey = child.key;
	    }
	  });
	  return activeKey;
	}
	
	function activeKeyIsValid(props, key) {
	  var keys = _react2['default'].Children.map(props.children, function (child) {
	    return child && child.key;
	  });
	  return keys.indexOf(key) >= 0;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs(props) {
	    (0, _classCallCheck3['default'])(this, Tabs);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var activeKey = void 0;
	    if ('activeKey' in props) {
	      activeKey = props.activeKey;
	    } else if ('defaultActiveKey' in props) {
	      activeKey = props.defaultActiveKey;
	    } else {
	      activeKey = getDefaultActiveKey(props);
	    }
	
	    _this.state = {
	      activeKey: activeKey
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Tabs, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.destroy = true;
	      _raf2['default'].cancel(this.sentinelId);
	    }
	
	    // Sentinel for tab index
	
	  }, {
	    key: 'updateSentinelContext',
	    value: function updateSentinelContext() {
	      var _this2 = this;
	
	      if (this.destroy) return;
	
	      _raf2['default'].cancel(this.sentinelId);
	      this.sentinelId = (0, _raf2['default'])(function () {
	        if (_this2.destroy) return;
	        _this2.forceUpdate();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var props = this.props;
	      var prefixCls = props.prefixCls,
	          navWrapper = props.navWrapper,
	          tabBarPosition = props.tabBarPosition,
	          className = props.className,
	          renderTabContent = props.renderTabContent,
	          renderTabBar = props.renderTabBar,
	          destroyInactiveTabPane = props.destroyInactiveTabPane,
	          direction = props.direction,
	          restProps = (0, _objectWithoutProperties3['default'])(props, ['prefixCls', 'navWrapper', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane', 'direction']);
	
	      var cls = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls, 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-' + tabBarPosition, 1), (0, _defineProperty3['default'])(_classnames, className, !!className), (0, _defineProperty3['default'])(_classnames, prefixCls + '-rtl', direction === 'rtl'), _classnames));
	
	      this.tabBar = renderTabBar();
	
	      var tabBar = _react2['default'].cloneElement(this.tabBar, {
	        prefixCls: prefixCls,
	        navWrapper: navWrapper,
	        key: 'tabBar',
	        onKeyDown: this.onNavKeyDown,
	        tabBarPosition: tabBarPosition,
	        onTabClick: this.onTabClick,
	        panels: props.children,
	        activeKey: this.state.activeKey,
	        direction: this.props.direction
	      });
	
	      var tabContent = _react2['default'].cloneElement(renderTabContent(), {
	        prefixCls: prefixCls,
	        tabBarPosition: tabBarPosition,
	        activeKey: this.state.activeKey,
	        destroyInactiveTabPane: destroyInactiveTabPane,
	        children: props.children,
	        onChange: this.setActiveKey,
	        key: 'tabContent',
	        direction: this.props.direction
	      });
	
	      var sentinelStart = _react2['default'].createElement(_Sentinel2['default'], {
	        key: 'sentinelStart',
	        setRef: this.setSentinelStart,
	        nextElement: this.panelSentinelStart
	      });
	      var sentinelEnd = _react2['default'].createElement(_Sentinel2['default'], {
	        key: 'sentinelEnd',
	        setRef: this.setSentinelEnd,
	        prevElement: this.panelSentinelEnd
	      });
	
	      var contents = [];
	      if (tabBarPosition === 'bottom') {
	        contents.push(sentinelStart, tabContent, sentinelEnd, tabBar);
	      } else {
	        contents.push(tabBar, sentinelStart, tabContent, sentinelEnd);
	      }
	
	      return _react2['default'].createElement(
	        _Sentinel.SentinelProvider,
	        {
	          value: {
	            sentinelStart: this.sentinelStart,
	            sentinelEnd: this.sentinelEnd,
	            setPanelSentinelStart: this.setPanelSentinelStart,
	            setPanelSentinelEnd: this.setPanelSentinelEnd
	          }
	        },
	        _react2['default'].createElement(
	          'div',
	          (0, _extends3['default'])({
	            className: cls,
	            style: props.style
	          }, (0, _utils.getDataAttr)(restProps), {
	            onScroll: this.onScroll
	          }),
	          contents
	        )
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(props, state) {
	      var newState = {};
	      if ('activeKey' in props) {
	        newState.activeKey = props.activeKey;
	      } else if (!activeKeyIsValid(props, state.activeKey)) {
	        newState.activeKey = getDefaultActiveKey(props);
	      }
	      if (Object.keys(newState).length > 0) {
	        return newState;
	      }
	      return null;
	    }
	  }]);
	  return Tabs;
	}(_react2['default'].Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onTabClick = function (activeKey, e) {
	    if (_this3.tabBar.props.onTabClick) {
	      _this3.tabBar.props.onTabClick(activeKey, e);
	    }
	    _this3.setActiveKey(activeKey);
	  };
	
	  this.onNavKeyDown = function (e) {
	    var eventKeyCode = e.keyCode;
	    if (eventKeyCode === _KeyCode2['default'].RIGHT || eventKeyCode === _KeyCode2['default'].DOWN) {
	      e.preventDefault();
	      var nextKey = _this3.getNextActiveKey(true);
	      _this3.onTabClick(nextKey);
	    } else if (eventKeyCode === _KeyCode2['default'].LEFT || eventKeyCode === _KeyCode2['default'].UP) {
	      e.preventDefault();
	      var previousKey = _this3.getNextActiveKey(false);
	      _this3.onTabClick(previousKey);
	    }
	  };
	
	  this.onScroll = function (_ref) {
	    var target = _ref.target,
	        currentTarget = _ref.currentTarget;
	
	    if (target === currentTarget && target.scrollLeft > 0) {
	      target.scrollLeft = 0;
	    }
	  };
	
	  this.setSentinelStart = function (node) {
	    _this3.sentinelStart = node;
	  };
	
	  this.setSentinelEnd = function (node) {
	    _this3.sentinelEnd = node;
	  };
	
	  this.setPanelSentinelStart = function (node) {
	    if (node !== _this3.panelSentinelStart) {
	      _this3.updateSentinelContext();
	    }
	    _this3.panelSentinelStart = node;
	  };
	
	  this.setPanelSentinelEnd = function (node) {
	    if (node !== _this3.panelSentinelEnd) {
	      _this3.updateSentinelContext();
	    }
	    _this3.panelSentinelEnd = node;
	  };
	
	  this.setActiveKey = function (activeKey) {
	    if (_this3.state.activeKey !== activeKey) {
	      if (!('activeKey' in _this3.props)) {
	        _this3.setState({
	          activeKey: activeKey
	        });
	      }
	      _this3.props.onChange(activeKey);
	    }
	  };
	
	  this.getNextActiveKey = function (next) {
	    var activeKey = _this3.state.activeKey;
	    var children = [];
	    _react2['default'].Children.forEach(_this3.props.children, function (c) {
	      if (c && !c.props.disabled) {
	        if (next) {
	          children.push(c);
	        } else {
	          children.unshift(c);
	        }
	      }
	    });
	    var length = children.length;
	    var ret = length && children[0].key;
	    children.forEach(function (child, i) {
	      if (child.key === activeKey) {
	        if (i === length - 1) {
	          ret = children[0].key;
	        } else {
	          ret = children[i + 1].key;
	        }
	      }
	    });
	    return ret;
	  };
	};
	
	Tabs.propTypes = {
	  destroyInactiveTabPane: _propTypes2['default'].bool,
	  renderTabBar: _propTypes2['default'].func.isRequired,
	  renderTabContent: _propTypes2['default'].func.isRequired,
	  navWrapper: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  children: _propTypes2['default'].node,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  tabBarPosition: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  activeKey: _propTypes2['default'].string,
	  defaultActiveKey: _propTypes2['default'].string,
	  direction: _propTypes2['default'].string
	};
	
	Tabs.defaultProps = {
	  prefixCls: 'rc-tabs',
	  destroyInactiveTabPane: false,
	  onChange: noop,
	  navWrapper: function navWrapper(arg) {
	    return arg;
	  },
	  tabBarPosition: 'top',
	  children: null,
	  style: {},
	  direction: 'ltr'
	};
	
	Tabs.TabPane = _TabPane2['default'];
	
	(0, _reactLifecyclesCompat.polyfill)(Tabs);
	
	exports['default'] = Tabs;
	module.exports = exports['default'];

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabContent = exports.TabPane = undefined;
	
	var _Tabs = __webpack_require__(271);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabPane = __webpack_require__(91);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _TabContent = __webpack_require__(90);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tabs2['default'];
	exports.TabPane = _TabPane2['default'];
	exports.TabContent = _TabContent2['default'];

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Content = function (_React$Component) {
	  (0, _inherits3['default'])(Content, _React$Component);
	
	  function Content() {
	    (0, _classCallCheck3['default'])(this, Content);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Content.prototype.componentDidUpdate = function componentDidUpdate() {
	    var trigger = this.props.trigger;
	
	    if (trigger) {
	      trigger.forcePopupAlign();
	    }
	  };
	
	  Content.prototype.render = function render() {
	    var _props = this.props,
	        overlay = _props.overlay,
	        prefixCls = _props.prefixCls,
	        id = _props.id;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
	      typeof overlay === 'function' ? overlay() : overlay
	    );
	  };
	
	  return Content;
	}(_react2['default'].Component);
	
	Content.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  id: _propTypes2['default'].string,
	  trigger: _propTypes2['default'].any
	};
	exports['default'] = Content;
	module.exports = exports['default'];

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(53);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _placements = __webpack_require__(92);
	
	var _Content = __webpack_require__(273);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tooltip = function (_Component) {
	  (0, _inherits3['default'])(Tooltip, _Component);
	
	  function Tooltip() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
	      var _this$props = _this.props,
	          arrowContent = _this$props.arrowContent,
	          overlay = _this$props.overlay,
	          prefixCls = _this$props.prefixCls,
	          id = _this$props.id;
	
	      return [_react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-arrow', key: 'arrow' },
	        arrowContent
	      ), _react2['default'].createElement(_Content2['default'], {
	        key: 'content',
	        trigger: _this.trigger,
	        prefixCls: prefixCls,
	        id: id,
	        overlay: overlay
	      })];
	    }, _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Tooltip.prototype.render = function render() {
	    var _props = this.props,
	        overlayClassName = _props.overlayClassName,
	        trigger = _props.trigger,
	        mouseEnterDelay = _props.mouseEnterDelay,
	        mouseLeaveDelay = _props.mouseLeaveDelay,
	        overlayStyle = _props.overlayStyle,
	        prefixCls = _props.prefixCls,
	        children = _props.children,
	        onVisibleChange = _props.onVisibleChange,
	        afterVisibleChange = _props.afterVisibleChange,
	        transitionName = _props.transitionName,
	        animation = _props.animation,
	        placement = _props.placement,
	        align = _props.align,
	        destroyTooltipOnHide = _props.destroyTooltipOnHide,
	        defaultVisible = _props.defaultVisible,
	        getTooltipContainer = _props.getTooltipContainer,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = (0, _extends3['default'])({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      (0, _extends3['default'])({
	        popupClassName: overlayClassName,
	        ref: this.saveTrigger,
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        afterPopupVisibleChange: afterVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  };
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  trigger: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  defaultVisible: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  animation: _propTypes2['default'].any,
	  onVisibleChange: _propTypes2['default'].func,
	  afterVisibleChange: _propTypes2['default'].func,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  overlayStyle: _propTypes2['default'].object,
	  overlayClassName: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  getTooltipContainer: _propTypes2['default'].func,
	  destroyTooltipOnHide: _propTypes2['default'].bool,
	  align: _propTypes2['default'].object,
	  arrowContent: _propTypes2['default'].any,
	  id: _propTypes2['default'].string
	};
	Tooltip.defaultProps = {
	  prefixCls: 'rc-tooltip',
	  mouseEnterDelay: 0,
	  destroyTooltipOnHide: false,
	  mouseLeaveDelay: 0.1,
	  align: {},
	  placement: 'right',
	  trigger: ['hover'],
	  arrowContent: null
	};
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Tooltip = __webpack_require__(274);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tooltip2['default'];
	module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(240);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(85);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(277);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(93);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Used for stretch
	      stretchChecked: false,
	      targetWidth: undefined,
	      targetHeight: undefined
	    };
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	    this.setStretchSize();
	  };
	
	  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setStretchSize();
	  };
	
	  // Record size if stretch needed
	
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var _this2 = this;
	
	    var savePopupRef = this.savePopupRef;
	    var _state = this.state,
	        stretchChecked = _state.stretchChecked,
	        targetHeight = _state.targetHeight,
	        targetWidth = _state.targetWidth;
	    var _props = this.props,
	        align = _props.align,
	        visible = _props.visible,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        getClassNameFromAlign = _props.getClassNameFromAlign,
	        destroyPopupOnHide = _props.destroyPopupOnHide,
	        stretch = _props.stretch,
	        children = _props.children,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseLeave = _props.onMouseLeave,
	        onMouseDown = _props.onMouseDown,
	        onTouchStart = _props.onTouchStart;
	
	    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	
	    var sizeStyle = {};
	    if (stretch) {
	      // Stretch with target
	      if (stretch.indexOf('height') !== -1) {
	        sizeStyle.height = targetHeight;
	      } else if (stretch.indexOf('minHeight') !== -1) {
	        sizeStyle.minHeight = targetHeight;
	      }
	      if (stretch.indexOf('width') !== -1) {
	        sizeStyle.width = targetWidth;
	      } else if (stretch.indexOf('minWidth') !== -1) {
	        sizeStyle.minWidth = targetWidth;
	      }
	
	      // Delay force align to makes ui smooth
	      if (!stretchChecked) {
	        sizeStyle.visibility = 'hidden';
	        setTimeout(function () {
	          if (_this2.alignInstance) {
	            _this2.alignInstance.forceAlign();
	          }
	        }, 0);
	      }
	    }
	
	    var newStyle = (0, _extends3['default'])({}, sizeStyle, style, this.getZIndexStyle());
	
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDown: onMouseDown,
	      onTouchStart: onTouchStart,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getAlignTarget(),
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            children
	          )
	        ) : null
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getAlignTarget(),
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  stretch: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  point: _propTypes2['default'].shape({
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this3.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this3.currentAlignClassName !== currentAlignClassName) {
	      _this3.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this3.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.setStretchSize = function () {
	    var _props2 = _this3.props,
	        stretch = _props2.stretch,
	        getRootDomNode = _props2.getRootDomNode,
	        visible = _props2.visible;
	    var _state2 = _this3.state,
	        stretchChecked = _state2.stretchChecked,
	        targetHeight = _state2.targetHeight,
	        targetWidth = _state2.targetWidth;
	
	
	    if (!stretch || !visible) {
	      if (stretchChecked) {
	        _this3.setState({ stretchChecked: false });
	      }
	      return;
	    }
	
	    var $ele = getRootDomNode();
	    if (!$ele) return;
	
	    var height = $ele.offsetHeight;
	    var width = $ele.offsetWidth;
	
	    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
	      _this3.setState({
	        stretchChecked: true,
	        targetHeight: height,
	        targetWidth: width
	      });
	    }
	  };
	
	  this.getTargetElement = function () {
	    return _this3.props.getRootDomNode();
	  };
	
	  this.getAlignTarget = function () {
	    var point = _this3.props.point;
	
	    if (point) {
	      return point;
	    }
	    return _this3.getTargetElement;
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(93);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseDown: props.onMouseDown,
	        onTouchStart: props.onTouchStart,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toArray;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toArray(children) {
	  var ret = [];
	
	  _react.default.Children.forEach(children, function (child) {
	    if (child === undefined || child === null) {
	      return;
	    }
	
	    if (Array.isArray(child)) {
	      ret = ret.concat(toArray(child));
	    } else if ((0, _reactIs.isFragment)(child) && child.props) {
	      ret = ret.concat(toArray(child.props.children));
	    } else {
	      ret.push(child);
	    }
	  });
	
	  return ret;
	}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(9));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactLifecyclesCompat = __webpack_require__(10);
	
	var _ContainerRender = _interopRequireDefault(__webpack_require__(95));
	
	var _Portal = _interopRequireDefault(__webpack_require__(97));
	
	var _switchScrollingEffect = _interopRequireDefault(__webpack_require__(283));
	
	var _setStyle = _interopRequireDefault(__webpack_require__(98));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var openCount = 0;
	var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);
	var IS_REACT_16 = ('createPortal' in _reactDom.default); // https://github.com/ant-design/ant-design/issues/19340
	// https://github.com/ant-design/ant-design/issues/19332
	
	var cacheOverflow = {};
	
	var PortalWrapper = /*#__PURE__*/function (_React$Component) {
	  _inherits(PortalWrapper, _React$Component);
	
	  var _super = _createSuper(PortalWrapper);
	
	  function PortalWrapper(props) {
	    var _this;
	
	    _classCallCheck(this, PortalWrapper);
	
	    _this = _super.call(this, props);
	
	    _this.getParent = function () {
	      var getContainer = _this.props.getContainer;
	
	      if (getContainer) {
	        if (typeof getContainer === 'string') {
	          return document.querySelectorAll(getContainer)[0];
	        }
	
	        if (typeof getContainer === 'function') {
	          return getContainer();
	        }
	
	        if (_typeof(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
	          return getContainer;
	        }
	      }
	
	      return document.body;
	    };
	
	    _this.getContainer = function () {
	      if (windowIsUndefined) {
	        return null;
	      }
	
	      if (!_this.container) {
	        _this.container = document.createElement('div');
	
	        var parent = _this.getParent();
	
	        if (parent) {
	          parent.appendChild(_this.container);
	        }
	      }
	
	      _this.setWrapperClassName();
	
	      return _this.container;
	    };
	
	    _this.setWrapperClassName = function () {
	      var wrapperClassName = _this.props.wrapperClassName;
	
	      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
	        _this.container.className = wrapperClassName;
	      }
	    };
	
	    _this.savePortal = function (c) {
	      // Warning: don't rename _component
	      // https://github.com/react-component/util/pull/65#discussion_r352407916
	      _this._component = c;
	    };
	
	    _this.removeCurrentContainer = function (visible) {
	      _this.container = null;
	      _this._component = null;
	
	      if (!IS_REACT_16) {
	        if (visible) {
	          _this.renderComponent({
	            afterClose: _this.removeContainer,
	            onClose: function onClose() {},
	            visible: false
	          });
	        } else {
	          _this.removeContainer();
	        }
	      }
	    };
	
	    _this.switchScrollingEffect = function () {
	      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
	        (0, _switchScrollingEffect.default)(); // Must be set after switchScrollingEffect
	
	        cacheOverflow = (0, _setStyle.default)({
	          overflow: 'hidden',
	          overflowX: 'hidden',
	          overflowY: 'hidden'
	        });
	      } else if (!openCount) {
	        (0, _setStyle.default)(cacheOverflow);
	        cacheOverflow = {};
	        (0, _switchScrollingEffect.default)(true);
	      }
	    };
	
	    var _visible = props.visible;
	    openCount = _visible ? openCount + 1 : openCount;
	    _this.state = {
	      _self: _assertThisInitialized(_this)
	    };
	    return _this;
	  }
	
	  _createClass(PortalWrapper, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.setWrapperClassName();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var visible = this.props.visible; // 离开时不会 render， 导到离开时数值不变，改用 func 。。
	
	      openCount = visible && openCount ? openCount - 1 : openCount;
	      this.removeCurrentContainer(visible);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          forceRender = _this$props.forceRender,
	          visible = _this$props.visible;
	      var portal = null;
	      var childProps = {
	        getOpenCount: function getOpenCount() {
	          return openCount;
	        },
	        getContainer: this.getContainer,
	        switchScrollingEffect: this.switchScrollingEffect
	      }; // suppport react15
	
	      if (!IS_REACT_16) {
	        return /*#__PURE__*/_react.default.createElement(_ContainerRender.default, {
	          parent: this,
	          visible: visible,
	          autoDestroy: false,
	          getComponent: function getComponent() {
	            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            return children(_objectSpread(_objectSpread(_objectSpread({}, extra), childProps), {}, {
	              ref: _this2.savePortal
	            }));
	          },
	          getContainer: this.getContainer,
	          forceRender: forceRender
	        }, function (_ref) {
	          var renderComponent = _ref.renderComponent,
	              removeContainer = _ref.removeContainer;
	          _this2.renderComponent = renderComponent;
	          _this2.removeContainer = removeContainer;
	          return null;
	        });
	      }
	
	      if (forceRender || visible || this._component) {
	        portal = /*#__PURE__*/_react.default.createElement(_Portal.default, {
	          getContainer: this.getContainer,
	          ref: this.savePortal
	        }, children(childProps));
	      }
	
	      return portal;
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, _ref2) {
	      var prevProps = _ref2.prevProps,
	          _self = _ref2._self;
	      var visible = props.visible,
	          getContainer = props.getContainer;
	
	      if (prevProps) {
	        var prevVisible = prevProps.visible,
	            prevGetContainer = prevProps.getContainer;
	
	        if (visible !== prevVisible) {
	          openCount = visible && !prevVisible ? openCount + 1 : openCount - 1;
	        }
	
	        var getContainerIsFunc = typeof getContainer === 'function' && typeof prevGetContainer === 'function';
	
	        if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
	          _self.removeCurrentContainer(false);
	        }
	      }
	
	      return {
	        prevProps: props
	      };
	    }
	  }]);
	
	  return PortalWrapper;
	}(_react.default.Component);
	
	PortalWrapper.propTypes = {
	  wrapperClassName: _propTypes.default.string,
	  forceRender: _propTypes.default.bool,
	  getContainer: _propTypes.default.any,
	  children: _propTypes.default.func,
	  visible: _propTypes.default.bool
	};
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(PortalWrapper);
	
	exports.default = _default;

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainedFunction;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  var args = [].slice.call(arguments, 0);
	
	  if (args.length === 1) {
	    return args[0];
	  }
	
	  return function chainedFunction() {
	    for (var i = 0; i < args.length; i++) {
	      if (args[i] && args[i].apply) {
	        args[i].apply(this, arguments);
	      }
	    }
	  };
	}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScrollBarSize;
	var cached;
	
	function getScrollBarSize(fresh) {
	  if (typeof document === 'undefined') {
	    return 0;
	  }
	
	  if (fresh || cached === undefined) {
	    var inner = document.createElement('div');
	    inner.style.width = '100%';
	    inner.style.height = '200px';
	    var outer = document.createElement('div');
	    var outerStyle = outer.style;
	    outerStyle.position = 'absolute';
	    outerStyle.top = 0;
	    outerStyle.left = 0;
	    outerStyle.pointerEvents = 'none';
	    outerStyle.visibility = 'hidden';
	    outerStyle.width = '200px';
	    outerStyle.height = '150px';
	    outerStyle.overflow = 'hidden';
	    outer.appendChild(inner);
	    document.body.appendChild(outer);
	    var widthContained = inner.offsetWidth;
	    outer.style.overflow = 'scroll';
	    var widthScroll = inner.offsetWidth;
	
	    if (widthContained === widthScroll) {
	      widthScroll = outer.clientWidth;
	    }
	
	    document.body.removeChild(outer);
	    cached = widthContained - widthScroll;
	  }
	
	  return cached;
	}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fillRef = fillRef;
	exports.composeRef = composeRef;
	exports.supportRef = supportRef;
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function fillRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
	    ref.current = node;
	  }
	}
	/**
	 * Merge refs into one ref function to support ref passing.
	 */
	
	
	function composeRef() {
	  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
	    refs[_key] = arguments[_key];
	  }
	
	  return function (node) {
	    refs.forEach(function (ref) {
	      fillRef(ref, node);
	    });
	  };
	}
	
	function supportRef(nodeOrComponent) {
	  // Function component node
	  if (nodeOrComponent.type && nodeOrComponent.type.prototype && !nodeOrComponent.type.prototype.render) {
	    return false;
	  } // Class component
	
	
	  if (typeof nodeOrComponent === 'function' && nodeOrComponent.prototype && !nodeOrComponent.prototype.render) {
	    return false;
	  }
	
	  return true;
	}
	/* eslint-enable */

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _getScrollBarSize = _interopRequireDefault(__webpack_require__(281));
	
	var _setStyle = _interopRequireDefault(__webpack_require__(98));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBodyOverflowing() {
	  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
	}
	
	var cacheStyle = {};
	
	var _default = function _default(close) {
	  if (!isBodyOverflowing() && !close) {
	    return;
	  } // https://github.com/ant-design/ant-design/issues/19729
	
	
	  var scrollingEffectClassName = 'ant-scrolling-effect';
	  var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');
	  var bodyClassName = document.body.className;
	
	  if (close) {
	    if (!scrollingEffectClassNameReg.test(bodyClassName)) return;
	    (0, _setStyle.default)(cacheStyle);
	    cacheStyle = {};
	    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg, '').trim();
	    return;
	  }
	
	  var scrollBarSize = (0, _getScrollBarSize.default)();
	
	  if (scrollBarSize) {
	    cacheStyle = (0, _setStyle.default)({
	      position: 'relative',
	      width: "calc(100% - ".concat(scrollBarSize, "px)")
	    });
	
	    if (!scrollingEffectClassNameReg.test(bodyClassName)) {
	      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName);
	      document.body.className = addClassName.trim();
	    }
	  }
	};
	
	exports.default = _default;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  } // only handle componentWillReceiveProps
	
	
	  if (typeof prototype.componentWillReceiveProps !== 'function') {
	    return Component;
	  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
	  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler
	
	
	  if (!_react.default.Profiler) {
	    return Component;
	  } // Here polyfill get started
	
	
	  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
	  delete prototype.componentWillReceiveProps;
	  return Component;
	};
	
	var _default = unsafeLifecyclesPolyfill;
	exports.default = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(285);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(101);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.createStyleObject = createStyleObject;
	exports.createClassNameString = createClassNameString;
	exports.createChildren = createChildren;
	exports.default = createElement;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createStyleObject(classNames) {
	  var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var stylesheet = arguments[2];
	
	  return classNames.reduce(function (styleObject, className) {
	    return (0, _extends3.default)({}, styleObject, stylesheet[className]);
	  }, elementStyle);
	}
	
	function createClassNameString(classNames) {
	  return classNames.join(' ');
	}
	
	function createChildren(stylesheet, useInlineStyles) {
	  var childrenCount = 0;
	  return function (children) {
	    childrenCount += 1;
	    return children.map(function (child, i) {
	      return createElement({
	        node: child,
	        stylesheet: stylesheet,
	        useInlineStyles: useInlineStyles,
	        key: 'code-segment-' + childrenCount + '-' + i
	      });
	    });
	  };
	}
	
	function createElement(_ref) {
	  var node = _ref.node,
	      stylesheet = _ref.stylesheet,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      useInlineStyles = _ref.useInlineStyles,
	      key = _ref.key;
	  var properties = node.properties,
	      type = node.type,
	      TagName = node.tagName,
	      value = node.value;
	
	  if (type === 'text') {
	    return value;
	  } else if (TagName) {
	    var childrenCreator = createChildren(stylesheet, useInlineStyles);
	    var nonStylesheetClassNames = useInlineStyles && properties.className && properties.className.filter(function (className) {
	      return !stylesheet[className];
	    });
	    var className = nonStylesheetClassNames && nonStylesheetClassNames.length ? nonStylesheetClassNames : undefined;
	    var props = useInlineStyles ? (0, _extends3.default)({}, properties, { className: className }, {
	      style: createStyleObject(properties.className, (0, _assign2.default)({}, properties.style, style), stylesheet)
	    }) : (0, _extends3.default)({}, properties, { className: createClassNameString(properties.className) });
	    var children = childrenCreator(node.children);
	    return _react2.default.createElement(
	      TagName,
	      (0, _extends3.default)({ key: key }, props),
	      children
	    );
	  }
	}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(19);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(101);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = function (defaultAstGenerator, defaultStyle) {
	  return function SyntaxHighlighter(_ref6) {
	    var language = _ref6.language,
	        children = _ref6.children,
	        _ref6$style = _ref6.style,
	        style = _ref6$style === undefined ? defaultStyle : _ref6$style,
	        _ref6$customStyle = _ref6.customStyle,
	        customStyle = _ref6$customStyle === undefined ? {} : _ref6$customStyle,
	        _ref6$codeTagProps = _ref6.codeTagProps,
	        codeTagProps = _ref6$codeTagProps === undefined ? { style: style['code[class*=\"language-\"]'] } : _ref6$codeTagProps,
	        _ref6$useInlineStyles = _ref6.useInlineStyles,
	        useInlineStyles = _ref6$useInlineStyles === undefined ? true : _ref6$useInlineStyles,
	        _ref6$showLineNumbers = _ref6.showLineNumbers,
	        showLineNumbers = _ref6$showLineNumbers === undefined ? false : _ref6$showLineNumbers,
	        _ref6$startingLineNum = _ref6.startingLineNumber,
	        startingLineNumber = _ref6$startingLineNum === undefined ? 1 : _ref6$startingLineNum,
	        lineNumberContainerStyle = _ref6.lineNumberContainerStyle,
	        lineNumberStyle = _ref6.lineNumberStyle,
	        wrapLines = _ref6.wrapLines,
	        _ref6$lineProps = _ref6.lineProps,
	        lineProps = _ref6$lineProps === undefined ? {} : _ref6$lineProps,
	        renderer = _ref6.renderer,
	        _ref6$PreTag = _ref6.PreTag,
	        PreTag = _ref6$PreTag === undefined ? 'pre' : _ref6$PreTag,
	        _ref6$CodeTag = _ref6.CodeTag,
	        CodeTag = _ref6$CodeTag === undefined ? 'code' : _ref6$CodeTag,
	        _ref6$code = _ref6.code,
	        code = _ref6$code === undefined ? Array.isArray(children) ? children[0] : children : _ref6$code,
	        astGenerator = _ref6.astGenerator,
	        rest = (0, _objectWithoutProperties3.default)(_ref6, ['language', 'children', 'style', 'customStyle', 'codeTagProps', 'useInlineStyles', 'showLineNumbers', 'startingLineNumber', 'lineNumberContainerStyle', 'lineNumberStyle', 'wrapLines', 'lineProps', 'renderer', 'PreTag', 'CodeTag', 'code', 'astGenerator']);
	
	    astGenerator = astGenerator || defaultAstGenerator;
	
	    var lineNumbers = showLineNumbers ? _react2.default.createElement(LineNumbers, {
	      containerStyle: lineNumberContainerStyle,
	      codeStyle: codeTagProps.style || {},
	      numberStyle: lineNumberStyle,
	      startingLineNumber: startingLineNumber,
	      codeString: code
	    }) : null;
	
	    var defaultPreStyle = style.hljs || style['pre[class*=\"language-\"]'] || { backgroundColor: '#fff' };
	    var preProps = useInlineStyles ? (0, _assign2.default)({}, rest, { style: (0, _assign2.default)({}, defaultPreStyle, customStyle) }) : (0, _assign2.default)({}, rest, { className: 'hljs' });
	
	    if (!astGenerator) {
	      return _react2.default.createElement(
	        PreTag,
	        preProps,
	        lineNumbers,
	        _react2.default.createElement(
	          CodeTag,
	          codeTagProps,
	          code
	        )
	      );
	    }
	
	    /* 
	     * some custom renderers rely on individual row elements so we need to turn wrapLines on 
	     * if renderer is provided and wrapLines is undefined
	    */
	    wrapLines = renderer && wrapLines === undefined ? true : wrapLines;
	    renderer = renderer || defaultRenderer;
	    var defaultCodeValue = [{ type: 'text', value: code }];
	    var codeTree = getCodeTree({ astGenerator: astGenerator, language: language, code: code, defaultCodeValue: defaultCodeValue });
	    if (codeTree.language === null) {
	      codeTree.value = defaultCodeValue;
	    }
	
	    var tree = wrapLines ? wrapLinesInSpan(codeTree, lineProps) : codeTree.value;
	
	    return _react2.default.createElement(
	      PreTag,
	      preProps,
	      lineNumbers,
	      _react2.default.createElement(
	        CodeTag,
	        codeTagProps,
	        renderer({ rows: tree, stylesheet: style, useInlineStyles: useInlineStyles })
	      )
	    );
	  };
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createElement = __webpack_require__(287);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newLineRegex = /\n/g;
	function getNewLines(str) {
	  return str.match(newLineRegex);
	}
	
	function getLineNumbers(_ref) {
	  var lines = _ref.lines,
	      startingLineNumber = _ref.startingLineNumber,
	      style = _ref.style;
	
	  return lines.map(function (_, i) {
	    var number = i + startingLineNumber;
	    return _react2.default.createElement(
	      'span',
	      {
	        key: 'line-' + i,
	        className: 'react-syntax-highlighter-line-number',
	        style: typeof style === 'function' ? style(number) : style
	      },
	      number + '\n'
	    );
	  });
	}
	
	function LineNumbers(_ref2) {
	  var codeString = _ref2.codeString,
	      codeStyle = _ref2.codeStyle,
	      _ref2$containerStyle = _ref2.containerStyle,
	      containerStyle = _ref2$containerStyle === undefined ? { float: 'left', paddingRight: '10px' } : _ref2$containerStyle,
	      _ref2$numberStyle = _ref2.numberStyle,
	      numberStyle = _ref2$numberStyle === undefined ? {} : _ref2$numberStyle,
	      startingLineNumber = _ref2.startingLineNumber;
	
	  return _react2.default.createElement(
	    'code',
	    { style: (0, _assign2.default)({}, codeStyle, containerStyle) },
	    getLineNumbers({
	      lines: codeString.replace(/\n$/, '').split('\n'),
	      style: numberStyle,
	      startingLineNumber: startingLineNumber
	    })
	  );
	}
	
	function createLineElement(_ref3) {
	  var children = _ref3.children,
	      lineNumber = _ref3.lineNumber,
	      lineProps = _ref3.lineProps,
	      _ref3$className = _ref3.className,
	      className = _ref3$className === undefined ? [] : _ref3$className;
	
	  var properties = (typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps) || {};
	  properties.className = properties.className ? className.concat(properties.className) : className;
	  return {
	    type: 'element',
	    tagName: 'span',
	    properties: properties,
	    children: children
	  };
	}
	
	function flattenCodeTree(tree) {
	  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  for (var i = 0; i < tree.length; i++) {
	    var node = tree[i];
	    if (node.type === 'text') {
	      newTree.push(createLineElement({
	        children: [node],
	        className: className
	      }));
	    } else if (node.children) {
	      var classNames = className.concat(node.properties.className);
	      newTree = newTree.concat(flattenCodeTree(node.children, classNames));
	    }
	  }
	  return newTree;
	}
	
	function wrapLinesInSpan(codeTree, lineProps) {
	  var tree = flattenCodeTree(codeTree.value);
	  var newTree = [];
	  var lastLineBreakIndex = -1;
	  var index = 0;
	
	  var _loop = function _loop() {
	    var node = tree[index];
	    var value = node.children[0].value;
	    var newLines = getNewLines(value);
	    if (newLines) {
	      var splitValue = value.split('\n');
	      splitValue.forEach(function (text, i) {
	        var lineNumber = newTree.length + 1;
	        var newChild = { type: 'text', value: text + '\n' };
	        if (i === 0) {
	          var _children = tree.slice(lastLineBreakIndex + 1, index).concat(createLineElement({ children: [newChild], className: node.properties.className }));
	          newTree.push(createLineElement({ children: _children, lineNumber: lineNumber, lineProps: lineProps }));
	        } else if (i === splitValue.length - 1) {
	          var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
	          if (stringChild) {
	            var lastLineInPreviousSpan = { type: 'text', value: '' + text };
	            var newElem = createLineElement({ children: [lastLineInPreviousSpan], className: node.properties.className });
	            tree.splice(index + 1, 0, newElem);
	          } else {
	            newTree.push(createLineElement({ children: [newChild], lineNumber: lineNumber, lineProps: lineProps, className: node.properties.className }));
	          }
	        } else {
	          newTree.push(createLineElement({ children: [newChild], lineNumber: lineNumber, lineProps: lineProps, className: node.properties.className }));
	        }
	      });
	      lastLineBreakIndex = index;
	    }
	    index++;
	  };
	
	  while (index < tree.length) {
	    _loop();
	  }
	  if (lastLineBreakIndex !== tree.length - 1) {
	    var children = tree.slice(lastLineBreakIndex + 1, tree.length);
	    if (children && children.length) {
	      newTree.push(createLineElement({ children: children, lineNumber: newTree.length + 1, lineProps: lineProps }));
	    }
	  }
	  return newTree;
	}
	
	function defaultRenderer(_ref4) {
	  var rows = _ref4.rows,
	      stylesheet = _ref4.stylesheet,
	      useInlineStyles = _ref4.useInlineStyles;
	
	  return rows.map(function (node, i) {
	    return (0, _createElement2.default)({
	      node: node,
	      stylesheet: stylesheet,
	      useInlineStyles: useInlineStyles,
	      key: 'code-segement' + i
	    });
	  });
	}
	
	function getCodeTree(_ref5) {
	  var astGenerator = _ref5.astGenerator,
	      language = _ref5.language,
	      code = _ref5.code,
	      defaultCodeValue = _ref5.defaultCodeValue;
	
	  if (astGenerator.getLanguage) {
	    var hasLanguage = language && astGenerator.getLanguage(language);
	    if (language === 'text') {
	      return { value: defaultCodeValue, language: 'text' };
	    } else if (hasLanguage) {
	      return astGenerator.highlight(language, code);
	    } else {
	      return astGenerator.highlightAuto(code);
	    }
	  }
	  try {
	    return language && language !== 'text' ? { value: astGenerator.highlight(code, language) } : { value: defaultCodeValue };
	  } catch (e) {
	    return { value: defaultCodeValue };
	  }
	}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _java = __webpack_require__(298);
	
	var _java2 = _interopRequireDefault(_java);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	exports.default = _java2.default;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = __webpack_require__(300);
	
	var _jsx2 = _interopRequireDefault(_jsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	exports.default = _jsx2.default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectivec = __webpack_require__(302);
	
	var _objectivec2 = _interopRequireDefault(_objectivec);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	exports.default = _objectivec2.default;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerLanguage = undefined;
	
	var _highlight = __webpack_require__(288);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _core = __webpack_require__(294);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var registerLanguage = exports.registerLanguage = function registerLanguage(_, language) {
	  return _core2.default.register(language);
	};
	exports.default = (0, _highlight2.default)(_core2.default, {});

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    "code[class*=\"language-\"]": {
	        "color": "black",
	        "background": "none",
	        "textShadow": "0 1px white",
	        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
	        "textAlign": "left",
	        "whiteSpace": "pre",
	        "wordSpacing": "normal",
	        "wordBreak": "normal",
	        "wordWrap": "normal",
	        "lineHeight": "1.5",
	        "MozTabSize": "4",
	        "OTabSize": "4",
	        "tabSize": "4",
	        "WebkitHyphens": "none",
	        "MozHyphens": "none",
	        "msHyphens": "none",
	        "hyphens": "none"
	    },
	    "pre[class*=\"language-\"]": {
	        "color": "black",
	        "background": "#f5f2f0",
	        "textShadow": "0 1px white",
	        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
	        "textAlign": "left",
	        "whiteSpace": "pre",
	        "wordSpacing": "normal",
	        "wordBreak": "normal",
	        "wordWrap": "normal",
	        "lineHeight": "1.5",
	        "MozTabSize": "4",
	        "OTabSize": "4",
	        "tabSize": "4",
	        "WebkitHyphens": "none",
	        "MozHyphens": "none",
	        "msHyphens": "none",
	        "hyphens": "none",
	        "padding": "1em",
	        "margin": ".5em 0",
	        "overflow": "auto"
	    },
	    "pre[class*=\"language-\"]::-moz-selection": {
	        "textShadow": "none",
	        "background": "#b3d4fc"
	    },
	    "pre[class*=\"language-\"] ::-moz-selection": {
	        "textShadow": "none",
	        "background": "#b3d4fc"
	    },
	    "code[class*=\"language-\"]::-moz-selection": {
	        "textShadow": "none",
	        "background": "#b3d4fc"
	    },
	    "code[class*=\"language-\"] ::-moz-selection": {
	        "textShadow": "none",
	        "background": "#b3d4fc"
	    },
	    "pre[class*=\"language-\"]::selection": {
	        "textShadow": "none",
	        "background": "#b3d4fc"
	    },
	    "pre[class*=\"language-\"] ::selection": {
	        "textShadow": "none",
	        "background": "#b3d4fc"
	    },
	    "code[class*=\"language-\"]::selection": {
	        "textShadow": "none",
	        "background": "#b3d4fc"
	    },
	    "code[class*=\"language-\"] ::selection": {
	        "textShadow": "none",
	        "background": "#b3d4fc"
	    },
	    ":not(pre) > code[class*=\"language-\"]": {
	        "background": "#f5f2f0",
	        "padding": ".1em",
	        "borderRadius": ".3em",
	        "whiteSpace": "normal"
	    },
	    "comment": {
	        "color": "slategray"
	    },
	    "prolog": {
	        "color": "slategray"
	    },
	    "doctype": {
	        "color": "slategray"
	    },
	    "cdata": {
	        "color": "slategray"
	    },
	    "punctuation": {
	        "color": "#999"
	    },
	    ".namespace": {
	        "Opacity": ".7"
	    },
	    "property": {
	        "color": "#905"
	    },
	    "tag": {
	        "color": "#905"
	    },
	    "boolean": {
	        "color": "#905"
	    },
	    "number": {
	        "color": "#905"
	    },
	    "constant": {
	        "color": "#905"
	    },
	    "symbol": {
	        "color": "#905"
	    },
	    "deleted": {
	        "color": "#905"
	    },
	    "selector": {
	        "color": "#690"
	    },
	    "attr-name": {
	        "color": "#690"
	    },
	    "string": {
	        "color": "#690"
	    },
	    "char": {
	        "color": "#690"
	    },
	    "builtin": {
	        "color": "#690"
	    },
	    "inserted": {
	        "color": "#690"
	    },
	    "operator": {
	        "color": "#9a6e3a",
	        "background": "hsla(0, 0%, 100%, .5)"
	    },
	    "entity": {
	        "color": "#9a6e3a",
	        "background": "hsla(0, 0%, 100%, .5)",
	        "cursor": "help"
	    },
	    "url": {
	        "color": "#9a6e3a",
	        "background": "hsla(0, 0%, 100%, .5)"
	    },
	    ".language-css .token.string": {
	        "color": "#9a6e3a",
	        "background": "hsla(0, 0%, 100%, .5)"
	    },
	    ".style .token.string": {
	        "color": "#9a6e3a",
	        "background": "hsla(0, 0%, 100%, .5)"
	    },
	    "atrule": {
	        "color": "#07a"
	    },
	    "attr-value": {
	        "color": "#07a"
	    },
	    "keyword": {
	        "color": "#07a"
	    },
	    "function": {
	        "color": "#DD4A68"
	    },
	    "class-name": {
	        "color": "#DD4A68"
	    },
	    "regex": {
	        "color": "#e90"
	    },
	    "important": {
	        "color": "#e90",
	        "fontWeight": "bold"
	    },
	    "variable": {
	        "color": "#e90"
	    },
	    "bold": {
	        "fontWeight": "bold"
	    },
	    "italic": {
	        "fontStyle": "italic"
	    }
	};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict'
	
	/* global window, self */
	
	var restore = capture()
	
	// istanbul ignore next - Don't allow Prism to run on page load in browser or
	// to start messaging from workers.
	var ctx =
	  typeof window === 'undefined'
	    ? typeof self === 'undefined'
	      ? {}
	      : self
	    : window
	
	ctx.Prism = {manual: true, disableWorkerMessageHandler: true}
	
	// Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
	// The wrapped non-leaky grammars are loaded instead of Prism’s originals.
	var h = __webpack_require__(195)
	var decode = __webpack_require__(237)
	var Prism = __webpack_require__(303)
	var markup = __webpack_require__(301)
	var css = __webpack_require__(297)
	var clike = __webpack_require__(296)
	var js = __webpack_require__(299)
	
	restore()
	
	var own = {}.hasOwnProperty
	
	// Inherit.
	function Refractor() {}
	
	Refractor.prototype = Prism
	
	// Construct.
	var refract = new Refractor()
	
	// Expose.
	module.exports = refract
	
	// Create.
	refract.highlight = highlight
	refract.register = register
	refract.alias = alias
	refract.registered = registered
	refract.listLanguages = listLanguages
	
	// Register bundled grammars.
	register(markup)
	register(css)
	register(clike)
	register(js)
	
	refract.util.encode = encode
	refract.Token.stringify = stringify
	
	function register(grammar) {
	  if (typeof grammar !== 'function' || !grammar.displayName) {
	    throw new Error('Expected `function` for `grammar`, got `' + grammar + '`')
	  }
	
	  // Do not duplicate registrations.
	  if (refract.languages[grammar.displayName] === undefined) {
	    grammar(refract)
	  }
	}
	
	function alias(name, alias) {
	  var languages = refract.languages
	  var map = name
	  var key
	  var list
	  var length
	  var index
	
	  if (alias) {
	    map = {}
	    map[name] = alias
	  }
	
	  for (key in map) {
	    list = map[key]
	    list = typeof list === 'string' ? [list] : list
	    length = list.length
	    index = -1
	
	    while (++index < length) {
	      languages[list[index]] = languages[key]
	    }
	  }
	}
	
	function highlight(value, name) {
	  var sup = Prism.highlight
	  var grammar
	
	  if (typeof value !== 'string') {
	    throw new Error('Expected `string` for `value`, got `' + value + '`')
	  }
	
	  // `name` is a grammar object.
	  if (refract.util.type(name) === 'Object') {
	    grammar = name
	    name = null
	  } else {
	    if (typeof name !== 'string') {
	      throw new Error('Expected `string` for `name`, got `' + name + '`')
	    }
	
	    if (own.call(refract.languages, name)) {
	      grammar = refract.languages[name]
	    } else {
	      throw new Error('Unknown language: `' + name + '` is not registered')
	    }
	  }
	
	  return sup.call(this, value, grammar, name)
	}
	
	function registered(language) {
	  if (typeof language !== 'string') {
	    throw new Error('Expected `string` for `language`, got `' + language + '`')
	  }
	
	  return own.call(refract.languages, language)
	}
	
	function listLanguages() {
	  var languages = refract.languages
	  var list = []
	  var language
	
	  for (language in languages) {
	    if (
	      own.call(languages, language) &&
	      typeof languages[language] === 'object'
	    ) {
	      list.push(language)
	    }
	  }
	
	  return list
	}
	
	function stringify(value, language, parent) {
	  var env
	
	  if (typeof value === 'string') {
	    return {type: 'text', value: value}
	  }
	
	  if (refract.util.type(value) === 'Array') {
	    return stringifyAll(value, language)
	  }
	
	  env = {
	    type: value.type,
	    content: refract.Token.stringify(value.content, language, parent),
	    tag: 'span',
	    classes: ['token', value.type],
	    attributes: {},
	    language: language,
	    parent: parent
	  }
	
	  if (value.alias) {
	    env.classes = env.classes.concat(value.alias)
	  }
	
	  refract.hooks.run('wrap', env)
	
	  return h(
	    env.tag + '.' + env.classes.join('.'),
	    attributes(env.attributes),
	    env.content
	  )
	}
	
	function stringifyAll(values, language) {
	  var result = []
	  var length = values.length
	  var index = -1
	  var value
	
	  while (++index < length) {
	    value = values[index]
	
	    if (value !== '' && value !== null && value !== undefined) {
	      result.push(value)
	    }
	  }
	
	  index = -1
	  length = result.length
	
	  while (++index < length) {
	    value = result[index]
	    result[index] = refract.Token.stringify(value, language, result)
	  }
	
	  return result
	}
	
	function encode(tokens) {
	  return tokens
	}
	
	function attributes(attrs) {
	  var key
	
	  for (key in attrs) {
	    attrs[key] = decode(attrs[key])
	  }
	
	  return attrs
	}
	
	function capture() {
	  var defined = 'Prism' in global
	  /* istanbul ignore next */
	  var current = defined ? global.Prism : undefined
	
	  return restore
	
	  function restore() {
	    /* istanbul ignore else - Clean leaks after Prism. */
	    if (defined) {
	      global.Prism = current
	    } else {
	      delete global.Prism
	    }
	
	    defined = undefined
	    current = undefined
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = c
	c.displayName = 'c'
	c.aliases = []
	function c(Prism) {
	  Prism.languages.c = Prism.languages.extend('clike', {
	    'class-name': {
	      pattern: /(\b(?:enum|struct)\s+)\w+/,
	      lookbehind: true
	    },
	    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,
	    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/,
	    number: /(?:\b0x(?:[\da-f]+\.?[\da-f]*|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?)[ful]*/i
	  })
	  Prism.languages.insertBefore('c', 'string', {
	    macro: {
	      // allow for multiline macro definitions
	      // spaces after the # character compile fine with gcc
	      pattern: /(^\s*)#\s*[a-z]+(?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
	      lookbehind: true,
	      alias: 'property',
	      inside: {
	        // highlight the path of the include statement as a string
	        string: {
	          pattern: /(#\s*include\s*)(?:<.+?>|("|')(?:\\?.)+?\2)/,
	          lookbehind: true
	        },
	        // highlight macro directives as keywords
	        directive: {
	          pattern: /(#\s*)\b(?:define|defined|elif|else|endif|error|ifdef|ifndef|if|import|include|line|pragma|undef|using)\b/,
	          lookbehind: true,
	          alias: 'keyword'
	        }
	      }
	    },
	    // highlight predefined macros as constants
	    constant: /\b(?:__FILE__|__LINE__|__DATE__|__TIME__|__TIMESTAMP__|__func__|EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|stdin|stdout|stderr)\b/
	  })
	  delete Prism.languages.c['boolean']
	}


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = clike
	clike.displayName = 'clike'
	clike.aliases = []
	function clike(Prism) {
	  Prism.languages.clike = {
	    comment: [
	      {
	        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
	        lookbehind: true
	      },
	      {
	        pattern: /(^|[^\\:])\/\/.*/,
	        lookbehind: true,
	        greedy: true
	      }
	    ],
	    string: {
	      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
	      greedy: true
	    },
	    'class-name': {
	      pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
	      lookbehind: true,
	      inside: {
	        punctuation: /[.\\]/
	      }
	    },
	    keyword: /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
	    boolean: /\b(?:true|false)\b/,
	    function: /\w+(?=\()/,
	    number: /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
	    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
	    punctuation: /[{}[\];(),.:]/
	  }
	}


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = css
	css.displayName = 'css'
	css.aliases = []
	function css(Prism) {
	  ;(function(Prism) {
	    var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/
	    Prism.languages.css = {
	      comment: /\/\*[\s\S]*?\*\//,
	      atrule: {
	        pattern: /@[\w-]+[\s\S]*?(?:;|(?=\s*\{))/,
	        inside: {
	          rule: /@[\w-]+/ // See rest below
	        }
	      },
	      url: {
	        pattern: RegExp('url\\((?:' + string.source + '|[^\n\r()]*)\\)', 'i'),
	        inside: {
	          function: /^url/i,
	          punctuation: /^\(|\)$/
	        }
	      },
	      selector: RegExp(
	        '[^{}\\s](?:[^{};"\']|' + string.source + ')*?(?=\\s*\\{)'
	      ),
	      string: {
	        pattern: string,
	        greedy: true
	      },
	      property: /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
	      important: /!important\b/i,
	      function: /[-a-z0-9]+(?=\()/i,
	      punctuation: /[(){};:,]/
	    }
	    Prism.languages.css['atrule'].inside.rest = Prism.languages.css
	    var markup = Prism.languages.markup
	    if (markup) {
	      markup.tag.addInlined('style', 'css')
	      Prism.languages.insertBefore(
	        'inside',
	        'attr-value',
	        {
	          'style-attr': {
	            pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
	            inside: {
	              'attr-name': {
	                pattern: /^\s*style/i,
	                inside: markup.tag.inside
	              },
	              punctuation: /^\s*=\s*['"]|['"]\s*$/,
	              'attr-value': {
	                pattern: /.+/i,
	                inside: Prism.languages.css
	              }
	            },
	            alias: 'language-css'
	          }
	        },
	        markup.tag
	      )
	    }
	  })(Prism)
	}


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = java
	java.displayName = 'java'
	java.aliases = []
	function java(Prism) {
	  ;(function(Prism) {
	    var keywords = /\b(?:abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while|var|null|exports|module|open|opens|provides|requires|to|transitive|uses|with)\b/ // based on the java naming conventions
	    var className = /\b[A-Z](?:\w*[a-z]\w*)?\b/
	    Prism.languages.java = Prism.languages.extend('clike', {
	      'class-name': [
	        className, // variables and parameters
	        // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
	        /\b[A-Z]\w*(?=\s+\w+\s*[;,=())])/
	      ],
	      keyword: keywords,
	      function: [
	        Prism.languages.clike.function,
	        {
	          pattern: /(\:\:)[a-z_]\w*/,
	          lookbehind: true
	        }
	      ],
	      number: /\b0b[01][01_]*L?\b|\b0x[\da-f_]*\.?[\da-f_p+-]+\b|(?:\b\d[\d_]*\.?[\d_]*|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
	      operator: {
	        pattern: /(^|[^.])(?:<<=?|>>>?=?|->|([-+&|])\2|[?:~]|[-+*/%&|^!=<>]=?)/m,
	        lookbehind: true
	      }
	    })
	    Prism.languages.insertBefore('java', 'class-name', {
	      annotation: {
	        alias: 'punctuation',
	        pattern: /(^|[^.])@\w+/,
	        lookbehind: true
	      },
	      namespace: {
	        pattern: /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)[a-z]\w*(\.[a-z]\w*)+/,
	        lookbehind: true,
	        inside: {
	          punctuation: /\./
	        }
	      },
	      generics: {
	        pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
	        inside: {
	          'class-name': className,
	          keyword: keywords,
	          punctuation: /[<>(),.:]/,
	          operator: /[?&|]/
	        }
	      }
	    })
	  })(Prism)
	}


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = javascript
	javascript.displayName = 'javascript'
	javascript.aliases = ['js']
	function javascript(Prism) {
	  Prism.languages.javascript = Prism.languages.extend('clike', {
	    'class-name': [
	      Prism.languages.clike['class-name'],
	      {
	        pattern: /(^|[^$\w\xA0-\uFFFF])[_$A-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\.(?:prototype|constructor))/,
	        lookbehind: true
	      }
	    ],
	    keyword: [
	      {
	        pattern: /((?:^|})\s*)(?:catch|finally)\b/,
	        lookbehind: true
	      },
	      {
	        pattern: /(^|[^.])\b(?:as|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
	        lookbehind: true
	      }
	    ],
	    number: /\b(?:(?:0[xX](?:[\dA-Fa-f](?:_[\dA-Fa-f])?)+|0[bB](?:[01](?:_[01])?)+|0[oO](?:[0-7](?:_[0-7])?)+)n?|(?:\d(?:_\d)?)+n|NaN|Infinity)\b|(?:\b(?:\d(?:_\d)?)+\.?(?:\d(?:_\d)?)*|\B\.(?:\d(?:_\d)?)+)(?:[Ee][+-]?(?:\d(?:_\d)?)+)?/,
	    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	    function: /#?[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	    operator: /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
	  })
	  Prism.languages.javascript[
	    'class-name'
	  ][0].pattern = /(\b(?:class|interface|extends|implements|instanceof|new)\s+)[\w.\\]+/
	  Prism.languages.insertBefore('javascript', 'keyword', {
	    regex: {
	      pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[(?:[^\]\\\r\n]|\\.)*]|\\.|[^/\\\[\r\n])+\/[gimyus]{0,6}(?=\s*($|[\r\n,.;})\]]))/,
	      lookbehind: true,
	      greedy: true
	    },
	    // This must be declared before keyword because we use "function" inside the look-forward
	    'function-variable': {
	      pattern: /#?[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/,
	      alias: 'function'
	    },
	    parameter: [
	      {
	        pattern: /(function(?:\s+[_$A-Za-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)?\s*\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\))/,
	        lookbehind: true,
	        inside: Prism.languages.javascript
	      },
	      {
	        pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=>)/i,
	        inside: Prism.languages.javascript
	      },
	      {
	        pattern: /(\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\)\s*=>)/,
	        lookbehind: true,
	        inside: Prism.languages.javascript
	      },
	      {
	        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:[_$A-Za-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\s*)\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\)\s*\{)/,
	        lookbehind: true,
	        inside: Prism.languages.javascript
	      }
	    ],
	    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
	  })
	  Prism.languages.insertBefore('javascript', 'string', {
	    'template-string': {
	      pattern: /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})+}|(?!\${)[^\\`])*`/,
	      greedy: true,
	      inside: {
	        'template-punctuation': {
	          pattern: /^`|`$/,
	          alias: 'string'
	        },
	        interpolation: {
	          pattern: /((?:^|[^\\])(?:\\{2})*)\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})+}/,
	          lookbehind: true,
	          inside: {
	            'interpolation-punctuation': {
	              pattern: /^\${|}$/,
	              alias: 'punctuation'
	            },
	            rest: Prism.languages.javascript
	          }
	        },
	        string: /[\s\S]+/
	      }
	    }
	  })
	  if (Prism.languages.markup) {
	    Prism.languages.markup.tag.addInlined('script', 'javascript')
	  }
	  Prism.languages.js = Prism.languages.javascript
	}


/***/ }),
/* 300 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = jsx
	jsx.displayName = 'jsx'
	jsx.aliases = []
	function jsx(Prism) {
	  ;(function(Prism) {
	    var javascript = Prism.util.clone(Prism.languages.javascript)
	    Prism.languages.jsx = Prism.languages.extend('markup', javascript)
	    Prism.languages.jsx.tag.pattern = /<\/?(?:[\w.:-]+\s*(?:\s+(?:[\w.:-]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s{'">=]+|\{(?:\{(?:\{[^}]*\}|[^{}])*\}|[^{}])+\}))?|\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}))*\s*\/?)?>/i
	    Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/i
	    Prism.languages.jsx.tag.inside[
	      'attr-value'
	    ].pattern = /=(?!\{)(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">]+)/i
	    Prism.languages.jsx.tag.inside['tag'].inside[
	      'class-name'
	    ] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/
	    Prism.languages.insertBefore(
	      'inside',
	      'attr-name',
	      {
	        spread: {
	          pattern: /\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}/,
	          inside: {
	            punctuation: /\.{3}|[{}.]/,
	            'attr-value': /\w+/
	          }
	        }
	      },
	      Prism.languages.jsx.tag
	    )
	    Prism.languages.insertBefore(
	      'inside',
	      'attr-value',
	      {
	        script: {
	          // Allow for two levels of nesting
	          pattern: /=(\{(?:\{(?:\{[^}]*\}|[^}])*\}|[^}])+\})/i,
	          inside: {
	            'script-punctuation': {
	              pattern: /^=(?={)/,
	              alias: 'punctuation'
	            },
	            rest: Prism.languages.jsx
	          },
	          alias: 'language-javascript'
	        }
	      },
	      Prism.languages.jsx.tag
	    ) // The following will handle plain text inside tags
	    var stringifyToken = function(token) {
	      if (!token) {
	        return ''
	      }
	      if (typeof token === 'string') {
	        return token
	      }
	      if (typeof token.content === 'string') {
	        return token.content
	      }
	      return token.content.map(stringifyToken).join('')
	    }
	    var walkTokens = function(tokens) {
	      var openedTags = []
	      for (var i = 0; i < tokens.length; i++) {
	        var token = tokens[i]
	        var notTagNorBrace = false
	        if (typeof token !== 'string') {
	          if (
	            token.type === 'tag' &&
	            token.content[0] &&
	            token.content[0].type === 'tag'
	          ) {
	            // We found a tag, now find its kind
	            if (token.content[0].content[0].content === '</') {
	              // Closing tag
	              if (
	                openedTags.length > 0 &&
	                openedTags[openedTags.length - 1].tagName ===
	                  stringifyToken(token.content[0].content[1])
	              ) {
	                // Pop matching opening tag
	                openedTags.pop()
	              }
	            } else {
	              if (token.content[token.content.length - 1].content === '/>') {
	                // Autoclosed tag, ignore
	              } else {
	                // Opening tag
	                openedTags.push({
	                  tagName: stringifyToken(token.content[0].content[1]),
	                  openedBraces: 0
	                })
	              }
	            }
	          } else if (
	            openedTags.length > 0 &&
	            token.type === 'punctuation' &&
	            token.content === '{'
	          ) {
	            // Here we might have entered a JSX context inside a tag
	            openedTags[openedTags.length - 1].openedBraces++
	          } else if (
	            openedTags.length > 0 &&
	            openedTags[openedTags.length - 1].openedBraces > 0 &&
	            token.type === 'punctuation' &&
	            token.content === '}'
	          ) {
	            // Here we might have left a JSX context inside a tag
	            openedTags[openedTags.length - 1].openedBraces--
	          } else {
	            notTagNorBrace = true
	          }
	        }
	        if (notTagNorBrace || typeof token === 'string') {
	          if (
	            openedTags.length > 0 &&
	            openedTags[openedTags.length - 1].openedBraces === 0
	          ) {
	            // Here we are inside a tag, and not inside a JSX context.
	            // That's plain text: drop any tokens matched.
	            var plainText = stringifyToken(token) // And merge text with adjacent text
	            if (
	              i < tokens.length - 1 &&
	              (typeof tokens[i + 1] === 'string' ||
	                tokens[i + 1].type === 'plain-text')
	            ) {
	              plainText += stringifyToken(tokens[i + 1])
	              tokens.splice(i + 1, 1)
	            }
	            if (
	              i > 0 &&
	              (typeof tokens[i - 1] === 'string' ||
	                tokens[i - 1].type === 'plain-text')
	            ) {
	              plainText = stringifyToken(tokens[i - 1]) + plainText
	              tokens.splice(i - 1, 1)
	              i--
	            }
	            tokens[i] = new Prism.Token(
	              'plain-text',
	              plainText,
	              null,
	              plainText
	            )
	          }
	        }
	        if (token.content && typeof token.content !== 'string') {
	          walkTokens(token.content)
	        }
	      }
	    }
	    Prism.hooks.add('after-tokenize', function(env) {
	      if (env.language !== 'jsx' && env.language !== 'tsx') {
	        return
	      }
	      walkTokens(env.tokens)
	    })
	  })(Prism)
	}


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = markup
	markup.displayName = 'markup'
	markup.aliases = ['xml', 'html', 'mathml', 'svg']
	function markup(Prism) {
	  Prism.languages.markup = {
	    comment: /<!--[\s\S]*?-->/,
	    prolog: /<\?[\s\S]+?\?>/,
	    doctype: /<!DOCTYPE[\s\S]+?>/i,
	    cdata: /<!\[CDATA\[[\s\S]*?]]>/i,
	    tag: {
	      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/i,
	      greedy: true,
	      inside: {
	        tag: {
	          pattern: /^<\/?[^\s>\/]+/i,
	          inside: {
	            punctuation: /^<\/?/,
	            namespace: /^[^\s>\/:]+:/
	          }
	        },
	        'attr-value': {
	          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/i,
	          inside: {
	            punctuation: [
	              /^=/,
	              {
	                pattern: /^(\s*)["']|["']$/,
	                lookbehind: true
	              }
	            ]
	          }
	        },
	        punctuation: /\/?>/,
	        'attr-name': {
	          pattern: /[^\s>\/]+/,
	          inside: {
	            namespace: /^[^\s>\/:]+:/
	          }
	        }
	      }
	    },
	    entity: /&#?[\da-z]{1,8};/i
	  }
	  Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	    Prism.languages.markup['entity'] // Plugin to make entity title show the real entity, idea by Roman Komarov
	  Prism.hooks.add('wrap', function(env) {
	    if (env.type === 'entity') {
	      env.attributes['title'] = env.content.value.replace(/&amp;/, '&')
	    }
	  })
	  Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	    /**
	     * Adds an inlined language to markup.
	     *
	     * An example of an inlined language is CSS with `<style>` tags.
	     *
	     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	     * case insensitive.
	     * @param {string} lang The language key.
	     * @example
	     * addInlined('style', 'css');
	     */
	    value: function addInlined(tagName, lang) {
	      var includedCdataInside = {}
	      includedCdataInside['language-' + lang] = {
	        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
	        lookbehind: true,
	        inside: Prism.languages[lang]
	      }
	      includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i
	      var inside = {
	        'included-cdata': {
	          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
	          inside: includedCdataInside
	        }
	      }
	      inside['language-' + lang] = {
	        pattern: /[\s\S]+/,
	        inside: Prism.languages[lang]
	      }
	      var def = {}
	      def[tagName] = {
	        pattern: RegExp(
	          /(<__[\s\S]*?>)(?:<!\[CDATA\[[\s\S]*?\]\]>\s*|[\s\S])*?(?=<\/__>)/.source.replace(
	            /__/g,
	            tagName
	          ),
	          'i'
	        ),
	        lookbehind: true,
	        greedy: true,
	        inside: inside
	      }
	      Prism.languages.insertBefore('markup', 'cdata', def)
	    }
	  })
	  Prism.languages.xml = Prism.languages.extend('markup', {})
	  Prism.languages.html = Prism.languages.markup
	  Prism.languages.mathml = Prism.languages.markup
	  Prism.languages.svg = Prism.languages.markup
	}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	var refractorC = __webpack_require__(295)
	module.exports = objectivec
	objectivec.displayName = 'objectivec'
	objectivec.aliases = []
	function objectivec(Prism) {
	  Prism.register(refractorC)
	  Prism.languages.objectivec = Prism.languages.extend('c', {
	    keyword: /\b(?:asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while|in|self|super)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
	    string: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|@"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
	    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
	  })
	  delete Prism.languages.objectivec['class-name']
	}


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var _self = (typeof window !== 'undefined')
		? window   // if in browser
		: (
			(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
		);
	
	/**
	 * Prism: Lightweight, robust, elegant syntax highlighting
	 * MIT license http://www.opensource.org/licenses/mit-license.php/
	 * @author Lea Verou http://lea.verou.me
	 */
	
	var Prism = (function (_self){
	
	// Private helper vars
	var lang = /\blang(?:uage)?-([\w-]+)\b/i;
	var uniqueId = 0;
	
	var _ = {
		manual: _self.Prism && _self.Prism.manual,
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
		util: {
			encode: function (tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(_.util.encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},
	
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},
	
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},
	
			// Deep clone a language definition (e.g. to extend it)
			clone: function deepClone(o, visited) {
				var clone, id, type = _.util.type(o);
				visited = visited || {};
	
				switch (type) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = {};
						visited[id] = clone;
	
						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}
	
						return clone;
	
					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;
	
						o.forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});
	
						return clone;
	
					default:
						return o;
				}
			}
		},
	
		languages: {
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);
	
				for (var key in redef) {
					lang[key] = redef[key];
				}
	
				return lang;
			},
	
			/**
			 * Insert a token before another token in a language literal
			 * As this needs to recreate the object (we cannot actually insert before keys in object literals),
			 * we cannot just provide an object, we need an object and a key.
			 * @param inside The key (or language id) of the parent
			 * @param before The key to insert before.
			 * @param insert Object with the key/value pairs to insert
			 * @param root The object that contains `inside`. If equal to Prism.languages, it can be omitted.
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || _.languages;
				var grammar = root[inside];
				var ret = {};
	
				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {
	
						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}
	
						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}
	
				var old = root[inside];
				root[inside] = ret;
	
				// Update references in other language definitions
				_.languages.DFS(_.languages, function(key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});
	
				return ret;
			},
	
			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};
	
				var objId = _.util.objId;
	
				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);
	
						var property = o[i],
						    propertyType = _.util.type(property);
	
						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						}
						else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},
		plugins: {},
	
		highlightAll: function(async, callback) {
			_.highlightAllUnder(document, async, callback);
		},
	
		highlightAllUnder: function(container, async, callback) {
			var env = {
				callback: callback,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};
	
			_.hooks.run('before-highlightall', env);
	
			var elements = container.querySelectorAll(env.selector);
	
			for (var i=0, element; element = elements[i++];) {
				_.highlightElement(element, async === true, env.callback);
			}
		},
	
		highlightElement: function(element, async, callback) {
			// Find language
			var language = 'none', grammar, parent = element;
	
			while (parent && !lang.test(parent.className)) {
				parent = parent.parentNode;
			}
	
			if (parent) {
				language = (parent.className.match(lang) || [,'none'])[1].toLowerCase();
				grammar = _.languages[language];
			}
	
			// Set language on the element, if not present
			element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
	
			if (element.parentNode) {
				// Set language on the parent, for styling
				parent = element.parentNode;
	
				if (/pre/i.test(parent.nodeName)) {
					parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
				}
			}
	
			var code = element.textContent;
	
			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};
	
			var insertHighlightedCode = function (highlightedCode) {
				env.highlightedCode = highlightedCode;
	
				_.hooks.run('before-insert', env);
	
				env.element.innerHTML = env.highlightedCode;
	
				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}
	
			_.hooks.run('before-sanity-check', env);
	
			if (!env.code) {
				_.hooks.run('complete', env);
				return;
			}
	
			_.hooks.run('before-highlight', env);
	
			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}
	
			if (async && _self.Worker) {
				var worker = new Worker(_.filename);
	
				worker.onmessage = function(evt) {
					insertHighlightedCode(evt.data);
				};
	
				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			}
			else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},
	
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},
	
		matchGrammar: function (text, strarr, grammar, index, startPos, oneshot, target) {
			for (var token in grammar) {
				if(!grammar.hasOwnProperty(token) || !grammar[token]) {
					continue;
				}
	
				if (token == target) {
					return;
				}
	
				var patterns = grammar[token];
				patterns = (_.util.type(patterns) === "Array") ? patterns : [patterns];
	
				for (var j = 0; j < patterns.length; ++j) {
					var pattern = patterns[j],
						inside = pattern.inside,
						lookbehind = !!pattern.lookbehind,
						greedy = !!pattern.greedy,
						lookbehindLength = 0,
						alias = pattern.alias;
	
					if (greedy && !pattern.pattern.global) {
						// Without the global flag, lastIndex won't work
						var flags = pattern.pattern.toString().match(/[imuy]*$/)[0];
						pattern.pattern = RegExp(pattern.pattern.source, flags + "g");
					}
	
					pattern = pattern.pattern || pattern;
	
					// Don’t cache length as it changes during the loop
					for (var i = index, pos = startPos; i < strarr.length; pos += strarr[i].length, ++i) {
	
						var str = strarr[i];
	
						if (strarr.length > text.length) {
							// Something went terribly wrong, ABORT, ABORT!
							return;
						}
	
						if (str instanceof Token) {
							continue;
						}
	
						if (greedy && i != strarr.length - 1) {
							pattern.lastIndex = pos;
							var match = pattern.exec(text);
							if (!match) {
								break;
							}
	
							var from = match.index + (lookbehind ? match[1].length : 0),
							    to = match.index + match[0].length,
							    k = i,
							    p = pos;
	
							for (var len = strarr.length; k < len && (p < to || (!strarr[k].type && !strarr[k - 1].greedy)); ++k) {
								p += strarr[k].length;
								// Move the index i to the element in strarr that is closest to from
								if (from >= p) {
									++i;
									pos = p;
								}
							}
	
							// If strarr[i] is a Token, then the match starts inside another Token, which is invalid
							if (strarr[i] instanceof Token) {
								continue;
							}
	
							// Number of tokens to delete and replace with the new match
							delNum = k - i;
							str = text.slice(pos, p);
							match.index -= pos;
						} else {
							pattern.lastIndex = 0;
	
							var match = pattern.exec(str),
								delNum = 1;
						}
	
						if (!match) {
							if (oneshot) {
								break;
							}
	
							continue;
						}
	
						if(lookbehind) {
							lookbehindLength = match[1] ? match[1].length : 0;
						}
	
						var from = match.index + lookbehindLength,
						    match = match[0].slice(lookbehindLength),
						    to = from + match.length,
						    before = str.slice(0, from),
						    after = str.slice(to);
	
						var args = [i, delNum];
	
						if (before) {
							++i;
							pos += before.length;
							args.push(before);
						}
	
						var wrapped = new Token(token, inside? _.tokenize(match, inside) : match, alias, match, greedy);
	
						args.push(wrapped);
	
						if (after) {
							args.push(after);
						}
	
						Array.prototype.splice.apply(strarr, args);
	
						if (delNum != 1)
							_.matchGrammar(text, strarr, grammar, i, pos, true, token);
	
						if (oneshot)
							break;
					}
				}
			}
		},
	
		tokenize: function(text, grammar) {
			var strarr = [text];
	
			var rest = grammar.rest;
	
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}
	
				delete grammar.rest;
			}
	
			_.matchGrammar(text, strarr, grammar, 0, 0, false);
	
			return strarr;
		},
	
		hooks: {
			all: {},
	
			add: function (name, callback) {
				var hooks = _.hooks.all;
	
				hooks[name] = hooks[name] || [];
	
				hooks[name].push(callback);
			},
	
			run: function (name, env) {
				var callbacks = _.hooks.all[name];
	
				if (!callbacks || !callbacks.length) {
					return;
				}
	
				for (var i=0, callback; callback = callbacks[i++];) {
					callback(env);
				}
			}
		},
	
		Token: Token
	};
	
	_self.Prism = _;
	
	function Token(type, content, alias, matchedStr, greedy) {
		this.type = type;
		this.content = content;
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || "").length|0;
		this.greedy = !!greedy;
	}
	
	Token.stringify = function(o, language) {
		if (typeof o == 'string') {
			return o;
		}
	
		if (Array.isArray(o)) {
			return o.map(function(element) {
				return Token.stringify(element, language);
			}).join('');
		}
	
		var env = {
			type: o.type,
			content: Token.stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};
	
		if (o.alias) {
			var aliases = Array.isArray(o.alias) ? o.alias : [o.alias];
			Array.prototype.push.apply(env.classes, aliases);
		}
	
		_.hooks.run('wrap', env);
	
		var attributes = Object.keys(env.attributes).map(function(name) {
			return name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}).join(' ');
	
		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + (attributes ? ' ' + attributes : '') + '>' + env.content + '</' + env.tag + '>';
	};
	
	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}
	
		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data),
					lang = message.language,
					code = message.code,
					immediateClose = message.immediateClose;
	
				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}
	
		return _;
	}
	
	//Get current script and highlight
	var script = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();
	
	if (script) {
		_.filename = script.src;
	
		if (!_.manual && !script.hasAttribute('data-manual')) {
			if(document.readyState !== "loading") {
				if (window.requestAnimationFrame) {
					window.requestAnimationFrame(_.highlightAll);
				} else {
					window.setTimeout(_.highlightAll, 16);
				}
			}
			else {
				document.addEventListener('DOMContentLoaded', _.highlightAll);
			}
		}
	}
	
	return _;
	
	})(_self);
	
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Prism;
	}
	
	// hack for components to work correctly in node.js
	if (typeof global !== 'undefined') {
		global.Prism = Prism;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var empty = ''
	var space = ' '
	var whiteSpace = /[ \t\n\r\f]+/g
	
	function parse(value) {
	  var input = String(value || empty).trim()
	  return input === empty ? [] : input.split(whiteSpace)
	}
	
	function stringify(values) {
	  return values.join(space).trim()
	}


/***/ }),
/* 305 */,
/* 306 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, module, Buffer) {(function (root, wrapper) {
	  if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return wrapper;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if (typeof module == "object" && module.exports) module.exports = wrapper;else (root.nbind = root.nbind || {}).init = wrapper;
	})(this, function (Module, cb) {
	  if (typeof Module == "function") {
	    cb = Module;Module = {};
	  }Module.onRuntimeInitialized = function (init, cb) {
	    return function () {
	      if (init) init.apply(this, arguments);try {
	        Module.ccall("nbind_init");
	      } catch (err) {
	        cb(err);return;
	      }cb(null, { bind: Module._nbind_value, reflect: Module.NBind.reflect, queryType: Module.NBind.queryType, toggleLightGC: Module.toggleLightGC, lib: Module });
	    };
	  }(Module.onRuntimeInitialized, cb);var Module;if (!Module) Module = (typeof Module !== "undefined" ? Module : null) || {};var moduleOverrides = {};for (var key in Module) {
	    if (Module.hasOwnProperty(key)) {
	      moduleOverrides[key] = Module[key];
	    }
	  }var ENVIRONMENT_IS_WEB = false;var ENVIRONMENT_IS_WORKER = false;var ENVIRONMENT_IS_NODE = false;var ENVIRONMENT_IS_SHELL = false;if (Module["ENVIRONMENT"]) {
	    if (Module["ENVIRONMENT"] === "WEB") {
	      ENVIRONMENT_IS_WEB = true;
	    } else if (Module["ENVIRONMENT"] === "WORKER") {
	      ENVIRONMENT_IS_WORKER = true;
	    } else if (Module["ENVIRONMENT"] === "NODE") {
	      ENVIRONMENT_IS_NODE = true;
	    } else if (Module["ENVIRONMENT"] === "SHELL") {
	      ENVIRONMENT_IS_SHELL = true;
	    } else {
	      throw new Error("The provided Module['ENVIRONMENT'] value is not valid. It must be one of: WEB|WORKER|NODE|SHELL.");
	    }
	  } else {
	    ENVIRONMENT_IS_WEB = typeof window === "object";ENVIRONMENT_IS_WORKER = typeof importScripts === "function";ENVIRONMENT_IS_NODE = typeof process === "object" && "function" === "function" && !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_WORKER;ENVIRONMENT_IS_SHELL = !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_NODE && !ENVIRONMENT_IS_WORKER;
	  }if (ENVIRONMENT_IS_NODE) {
	    if (!Module["print"]) Module["print"] = console.log;if (!Module["printErr"]) Module["printErr"] = console.warn;var nodeFS;var nodePath;Module["read"] = function shell_read(filename, binary) {
	      if (!nodeFS) nodeFS = {}("");if (!nodePath) nodePath = {}("");filename = nodePath["normalize"](filename);var ret = nodeFS["readFileSync"](filename);return binary ? ret : ret.toString();
	    };Module["readBinary"] = function readBinary(filename) {
	      var ret = Module["read"](filename, true);if (!ret.buffer) {
	        ret = new Uint8Array(ret);
	      }assert(ret.buffer);return ret;
	    };Module["load"] = function load(f) {
	      globalEval(read(f));
	    };if (!Module["thisProgram"]) {
	      if (process["argv"].length > 1) {
	        Module["thisProgram"] = process["argv"][1].replace(/\\/g, "/");
	      } else {
	        Module["thisProgram"] = "unknown-program";
	      }
	    }Module["arguments"] = process["argv"].slice(2);if (true) {
	      module["exports"] = Module;
	    }process["on"]("uncaughtException", function (ex) {
	      if (!(ex instanceof ExitStatus)) {
	        throw ex;
	      }
	    });Module["inspect"] = function () {
	      return "[Emscripten Module object]";
	    };
	  } else if (ENVIRONMENT_IS_SHELL) {
	    if (!Module["print"]) Module["print"] = print;if (typeof printErr != "undefined") Module["printErr"] = printErr;if (typeof read != "undefined") {
	      Module["read"] = read;
	    } else {
	      Module["read"] = function shell_read() {
	        throw "no read() available";
	      };
	    }Module["readBinary"] = function readBinary(f) {
	      if (typeof readbuffer === "function") {
	        return new Uint8Array(readbuffer(f));
	      }var data = read(f, "binary");assert(typeof data === "object");return data;
	    };if (typeof scriptArgs != "undefined") {
	      Module["arguments"] = scriptArgs;
	    } else if (typeof arguments != "undefined") {
	      Module["arguments"] = arguments;
	    }if (typeof quit === "function") {
	      Module["quit"] = function (status, toThrow) {
	        quit(status);
	      };
	    }
	  } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
	    Module["read"] = function shell_read(url) {
	      var xhr = new XMLHttpRequest();xhr.open("GET", url, false);xhr.send(null);return xhr.responseText;
	    };if (ENVIRONMENT_IS_WORKER) {
	      Module["readBinary"] = function readBinary(url) {
	        var xhr = new XMLHttpRequest();xhr.open("GET", url, false);xhr.responseType = "arraybuffer";xhr.send(null);return new Uint8Array(xhr.response);
	      };
	    }Module["readAsync"] = function readAsync(url, onload, onerror) {
	      var xhr = new XMLHttpRequest();xhr.open("GET", url, true);xhr.responseType = "arraybuffer";xhr.onload = function xhr_onload() {
	        if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
	          onload(xhr.response);
	        } else {
	          onerror();
	        }
	      };xhr.onerror = onerror;xhr.send(null);
	    };if (typeof arguments != "undefined") {
	      Module["arguments"] = arguments;
	    }if (typeof console !== "undefined") {
	      if (!Module["print"]) Module["print"] = function shell_print(x) {
	        console.log(x);
	      };if (!Module["printErr"]) Module["printErr"] = function shell_printErr(x) {
	        console.warn(x);
	      };
	    } else {
	      var TRY_USE_DUMP = false;if (!Module["print"]) Module["print"] = TRY_USE_DUMP && typeof dump !== "undefined" ? function (x) {
	        dump(x);
	      } : function (x) {};
	    }if (ENVIRONMENT_IS_WORKER) {
	      Module["load"] = importScripts;
	    }if (typeof Module["setWindowTitle"] === "undefined") {
	      Module["setWindowTitle"] = function (title) {
	        document.title = title;
	      };
	    }
	  } else {
	    throw "Unknown runtime environment. Where are we?";
	  }function globalEval(x) {
	    eval.call(null, x);
	  }if (!Module["load"] && Module["read"]) {
	    Module["load"] = function load(f) {
	      globalEval(Module["read"](f));
	    };
	  }if (!Module["print"]) {
	    Module["print"] = function () {};
	  }if (!Module["printErr"]) {
	    Module["printErr"] = Module["print"];
	  }if (!Module["arguments"]) {
	    Module["arguments"] = [];
	  }if (!Module["thisProgram"]) {
	    Module["thisProgram"] = "./this.program";
	  }if (!Module["quit"]) {
	    Module["quit"] = function (status, toThrow) {
	      throw toThrow;
	    };
	  }Module.print = Module["print"];Module.printErr = Module["printErr"];Module["preRun"] = [];Module["postRun"] = [];for (var key in moduleOverrides) {
	    if (moduleOverrides.hasOwnProperty(key)) {
	      Module[key] = moduleOverrides[key];
	    }
	  }moduleOverrides = undefined;var Runtime = { setTempRet0: function (value) {
	      tempRet0 = value;return value;
	    }, getTempRet0: function () {
	      return tempRet0;
	    }, stackSave: function () {
	      return STACKTOP;
	    }, stackRestore: function (stackTop) {
	      STACKTOP = stackTop;
	    }, getNativeTypeSize: function (type) {
	      switch (type) {case "i1":case "i8":
	          return 1;case "i16":
	          return 2;case "i32":
	          return 4;case "i64":
	          return 8;case "float":
	          return 4;case "double":
	          return 8;default:
	          {
	            if (type[type.length - 1] === "*") {
	              return Runtime.QUANTUM_SIZE;
	            } else if (type[0] === "i") {
	              var bits = parseInt(type.substr(1));assert(bits % 8 === 0);return bits / 8;
	            } else {
	              return 0;
	            }
	          }}
	    }, getNativeFieldSize: function (type) {
	      return Math.max(Runtime.getNativeTypeSize(type), Runtime.QUANTUM_SIZE);
	    }, STACK_ALIGN: 16, prepVararg: function (ptr, type) {
	      if (type === "double" || type === "i64") {
	        if (ptr & 7) {
	          assert((ptr & 7) === 4);ptr += 4;
	        }
	      } else {
	        assert((ptr & 3) === 0);
	      }return ptr;
	    }, getAlignSize: function (type, size, vararg) {
	      if (!vararg && (type == "i64" || type == "double")) return 8;if (!type) return Math.min(size, 8);return Math.min(size || (type ? Runtime.getNativeFieldSize(type) : 0), Runtime.QUANTUM_SIZE);
	    }, dynCall: function (sig, ptr, args) {
	      if (args && args.length) {
	        return Module["dynCall_" + sig].apply(null, [ptr].concat(args));
	      } else {
	        return Module["dynCall_" + sig].call(null, ptr);
	      }
	    }, functionPointers: [], addFunction: function (func) {
	      for (var i = 0; i < Runtime.functionPointers.length; i++) {
	        if (!Runtime.functionPointers[i]) {
	          Runtime.functionPointers[i] = func;return 2 * (1 + i);
	        }
	      }throw "Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.";
	    }, removeFunction: function (index) {
	      Runtime.functionPointers[(index - 2) / 2] = null;
	    }, warnOnce: function (text) {
	      if (!Runtime.warnOnce.shown) Runtime.warnOnce.shown = {};if (!Runtime.warnOnce.shown[text]) {
	        Runtime.warnOnce.shown[text] = 1;Module.printErr(text);
	      }
	    }, funcWrappers: {}, getFuncWrapper: function (func, sig) {
	      if (!func) return;assert(sig);if (!Runtime.funcWrappers[sig]) {
	        Runtime.funcWrappers[sig] = {};
	      }var sigCache = Runtime.funcWrappers[sig];if (!sigCache[func]) {
	        if (sig.length === 1) {
	          sigCache[func] = function dynCall_wrapper() {
	            return Runtime.dynCall(sig, func);
	          };
	        } else if (sig.length === 2) {
	          sigCache[func] = function dynCall_wrapper(arg) {
	            return Runtime.dynCall(sig, func, [arg]);
	          };
	        } else {
	          sigCache[func] = function dynCall_wrapper() {
	            return Runtime.dynCall(sig, func, Array.prototype.slice.call(arguments));
	          };
	        }
	      }return sigCache[func];
	    }, getCompilerSetting: function (name) {
	      throw "You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work";
	    }, stackAlloc: function (size) {
	      var ret = STACKTOP;STACKTOP = STACKTOP + size | 0;STACKTOP = STACKTOP + 15 & -16;return ret;
	    }, staticAlloc: function (size) {
	      var ret = STATICTOP;STATICTOP = STATICTOP + size | 0;STATICTOP = STATICTOP + 15 & -16;return ret;
	    }, dynamicAlloc: function (size) {
	      var ret = HEAP32[DYNAMICTOP_PTR >> 2];var end = (ret + size + 15 | 0) & -16;HEAP32[DYNAMICTOP_PTR >> 2] = end;if (end >= TOTAL_MEMORY) {
	        var success = enlargeMemory();if (!success) {
	          HEAP32[DYNAMICTOP_PTR >> 2] = ret;return 0;
	        }
	      }return ret;
	    }, alignMemory: function (size, quantum) {
	      var ret = size = Math.ceil(size / (quantum ? quantum : 16)) * (quantum ? quantum : 16);return ret;
	    }, makeBigInt: function (low, high, unsigned) {
	      var ret = unsigned ? +(low >>> 0) + +(high >>> 0) * +4294967296 : +(low >>> 0) + +(high | 0) * +4294967296;return ret;
	    }, GLOBAL_BASE: 8, QUANTUM_SIZE: 4, __dummy__: 0 };Module["Runtime"] = Runtime;var ABORT = 0;var EXITSTATUS = 0;function assert(condition, text) {
	    if (!condition) {
	      abort("Assertion failed: " + text);
	    }
	  }function getCFunc(ident) {
	    var func = Module["_" + ident];if (!func) {
	      try {
	        func = eval("_" + ident);
	      } catch (e) {}
	    }assert(func, "Cannot call unknown function " + ident + " (perhaps LLVM optimizations or closure removed it?)");return func;
	  }var cwrap, ccall;(function () {
	    var JSfuncs = { "stackSave": function () {
	        Runtime.stackSave();
	      }, "stackRestore": function () {
	        Runtime.stackRestore();
	      }, "arrayToC": function (arr) {
	        var ret = Runtime.stackAlloc(arr.length);writeArrayToMemory(arr, ret);return ret;
	      }, "stringToC": function (str) {
	        var ret = 0;if (str !== null && str !== undefined && str !== 0) {
	          var len = (str.length << 2) + 1;ret = Runtime.stackAlloc(len);stringToUTF8(str, ret, len);
	        }return ret;
	      } };var toC = { "string": JSfuncs["stringToC"], "array": JSfuncs["arrayToC"] };ccall = function ccallFunc(ident, returnType, argTypes, args, opts) {
	      var func = getCFunc(ident);var cArgs = [];var stack = 0;if (args) {
	        for (var i = 0; i < args.length; i++) {
	          var converter = toC[argTypes[i]];if (converter) {
	            if (stack === 0) stack = Runtime.stackSave();cArgs[i] = converter(args[i]);
	          } else {
	            cArgs[i] = args[i];
	          }
	        }
	      }var ret = func.apply(null, cArgs);if (returnType === "string") ret = Pointer_stringify(ret);if (stack !== 0) {
	        if (opts && opts.async) {
	          EmterpreterAsync.asyncFinalizers.push(function () {
	            Runtime.stackRestore(stack);
	          });return;
	        }Runtime.stackRestore(stack);
	      }return ret;
	    };var sourceRegex = /^function\s*[a-zA-Z$_0-9]*\s*\(([^)]*)\)\s*{\s*([^*]*?)[\s;]*(?:return\s*(.*?)[;\s]*)?}$/;function parseJSFunc(jsfunc) {
	      var parsed = jsfunc.toString().match(sourceRegex).slice(1);return { arguments: parsed[0], body: parsed[1], returnValue: parsed[2] };
	    }var JSsource = null;function ensureJSsource() {
	      if (!JSsource) {
	        JSsource = {};for (var fun in JSfuncs) {
	          if (JSfuncs.hasOwnProperty(fun)) {
	            JSsource[fun] = parseJSFunc(JSfuncs[fun]);
	          }
	        }
	      }
	    }cwrap = function cwrap(ident, returnType, argTypes) {
	      argTypes = argTypes || [];var cfunc = getCFunc(ident);var numericArgs = argTypes.every(function (type) {
	        return type === "number";
	      });var numericRet = returnType !== "string";if (numericRet && numericArgs) {
	        return cfunc;
	      }var argNames = argTypes.map(function (x, i) {
	        return "$" + i;
	      });var funcstr = "(function(" + argNames.join(",") + ") {";var nargs = argTypes.length;if (!numericArgs) {
	        ensureJSsource();funcstr += "var stack = " + JSsource["stackSave"].body + ";";for (var i = 0; i < nargs; i++) {
	          var arg = argNames[i],
	              type = argTypes[i];if (type === "number") continue;var convertCode = JSsource[type + "ToC"];funcstr += "var " + convertCode.arguments + " = " + arg + ";";funcstr += convertCode.body + ";";funcstr += arg + "=(" + convertCode.returnValue + ");";
	        }
	      }var cfuncname = parseJSFunc(function () {
	        return cfunc;
	      }).returnValue;funcstr += "var ret = " + cfuncname + "(" + argNames.join(",") + ");";if (!numericRet) {
	        var strgfy = parseJSFunc(function () {
	          return Pointer_stringify;
	        }).returnValue;funcstr += "ret = " + strgfy + "(ret);";
	      }if (!numericArgs) {
	        ensureJSsource();funcstr += JSsource["stackRestore"].body.replace("()", "(stack)") + ";";
	      }funcstr += "return ret})";return eval(funcstr);
	    };
	  })();Module["ccall"] = ccall;Module["cwrap"] = cwrap;function setValue(ptr, value, type, noSafe) {
	    type = type || "i8";if (type.charAt(type.length - 1) === "*") type = "i32";switch (type) {case "i1":
	        HEAP8[ptr >> 0] = value;break;case "i8":
	        HEAP8[ptr >> 0] = value;break;case "i16":
	        HEAP16[ptr >> 1] = value;break;case "i32":
	        HEAP32[ptr >> 2] = value;break;case "i64":
	        tempI64 = [value >>> 0, (tempDouble = value, +Math_abs(tempDouble) >= +1 ? tempDouble > +0 ? (Math_min(+Math_floor(tempDouble / +4294967296), +4294967295) | 0) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / +4294967296) >>> 0 : 0)], HEAP32[ptr >> 2] = tempI64[0], HEAP32[ptr + 4 >> 2] = tempI64[1];break;case "float":
	        HEAPF32[ptr >> 2] = value;break;case "double":
	        HEAPF64[ptr >> 3] = value;break;default:
	        abort("invalid type for setValue: " + type);}
	  }Module["setValue"] = setValue;function getValue(ptr, type, noSafe) {
	    type = type || "i8";if (type.charAt(type.length - 1) === "*") type = "i32";switch (type) {case "i1":
	        return HEAP8[ptr >> 0];case "i8":
	        return HEAP8[ptr >> 0];case "i16":
	        return HEAP16[ptr >> 1];case "i32":
	        return HEAP32[ptr >> 2];case "i64":
	        return HEAP32[ptr >> 2];case "float":
	        return HEAPF32[ptr >> 2];case "double":
	        return HEAPF64[ptr >> 3];default:
	        abort("invalid type for setValue: " + type);}return null;
	  }Module["getValue"] = getValue;var ALLOC_NORMAL = 0;var ALLOC_STACK = 1;var ALLOC_STATIC = 2;var ALLOC_DYNAMIC = 3;var ALLOC_NONE = 4;Module["ALLOC_NORMAL"] = ALLOC_NORMAL;Module["ALLOC_STACK"] = ALLOC_STACK;Module["ALLOC_STATIC"] = ALLOC_STATIC;Module["ALLOC_DYNAMIC"] = ALLOC_DYNAMIC;Module["ALLOC_NONE"] = ALLOC_NONE;function allocate(slab, types, allocator, ptr) {
	    var zeroinit, size;if (typeof slab === "number") {
	      zeroinit = true;size = slab;
	    } else {
	      zeroinit = false;size = slab.length;
	    }var singleType = typeof types === "string" ? types : null;var ret;if (allocator == ALLOC_NONE) {
	      ret = ptr;
	    } else {
	      ret = [typeof _malloc === "function" ? _malloc : Runtime.staticAlloc, Runtime.stackAlloc, Runtime.staticAlloc, Runtime.dynamicAlloc][allocator === undefined ? ALLOC_STATIC : allocator](Math.max(size, singleType ? 1 : types.length));
	    }if (zeroinit) {
	      var ptr = ret,
	          stop;assert((ret & 3) == 0);stop = ret + (size & ~3);for (; ptr < stop; ptr += 4) {
	        HEAP32[ptr >> 2] = 0;
	      }stop = ret + size;while (ptr < stop) {
	        HEAP8[ptr++ >> 0] = 0;
	      }return ret;
	    }if (singleType === "i8") {
	      if (slab.subarray || slab.slice) {
	        HEAPU8.set(slab, ret);
	      } else {
	        HEAPU8.set(new Uint8Array(slab), ret);
	      }return ret;
	    }var i = 0,
	        type,
	        typeSize,
	        previousType;while (i < size) {
	      var curr = slab[i];if (typeof curr === "function") {
	        curr = Runtime.getFunctionIndex(curr);
	      }type = singleType || types[i];if (type === 0) {
	        i++;continue;
	      }if (type == "i64") type = "i32";setValue(ret + i, curr, type);if (previousType !== type) {
	        typeSize = Runtime.getNativeTypeSize(type);previousType = type;
	      }i += typeSize;
	    }return ret;
	  }Module["allocate"] = allocate;function getMemory(size) {
	    if (!staticSealed) return Runtime.staticAlloc(size);if (!runtimeInitialized) return Runtime.dynamicAlloc(size);return _malloc(size);
	  }Module["getMemory"] = getMemory;function Pointer_stringify(ptr, length) {
	    if (length === 0 || !ptr) return "";var hasUtf = 0;var t;var i = 0;while (1) {
	      t = HEAPU8[ptr + i >> 0];hasUtf |= t;if (t == 0 && !length) break;i++;if (length && i == length) break;
	    }if (!length) length = i;var ret = "";if (hasUtf < 128) {
	      var MAX_CHUNK = 1024;var curr;while (length > 0) {
	        curr = String.fromCharCode.apply(String, HEAPU8.subarray(ptr, ptr + Math.min(length, MAX_CHUNK)));ret = ret ? ret + curr : curr;ptr += MAX_CHUNK;length -= MAX_CHUNK;
	      }return ret;
	    }return Module["UTF8ToString"](ptr);
	  }Module["Pointer_stringify"] = Pointer_stringify;function AsciiToString(ptr) {
	    var str = "";while (1) {
	      var ch = HEAP8[ptr++ >> 0];if (!ch) return str;str += String.fromCharCode(ch);
	    }
	  }Module["AsciiToString"] = AsciiToString;function stringToAscii(str, outPtr) {
	    return writeAsciiToMemory(str, outPtr, false);
	  }Module["stringToAscii"] = stringToAscii;var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : undefined;function UTF8ArrayToString(u8Array, idx) {
	    var endPtr = idx;while (u8Array[endPtr]) ++endPtr;if (endPtr - idx > 16 && u8Array.subarray && UTF8Decoder) {
	      return UTF8Decoder.decode(u8Array.subarray(idx, endPtr));
	    } else {
	      var u0, u1, u2, u3, u4, u5;var str = "";while (1) {
	        u0 = u8Array[idx++];if (!u0) return str;if (!(u0 & 128)) {
	          str += String.fromCharCode(u0);continue;
	        }u1 = u8Array[idx++] & 63;if ((u0 & 224) == 192) {
	          str += String.fromCharCode((u0 & 31) << 6 | u1);continue;
	        }u2 = u8Array[idx++] & 63;if ((u0 & 240) == 224) {
	          u0 = (u0 & 15) << 12 | u1 << 6 | u2;
	        } else {
	          u3 = u8Array[idx++] & 63;if ((u0 & 248) == 240) {
	            u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | u3;
	          } else {
	            u4 = u8Array[idx++] & 63;if ((u0 & 252) == 248) {
	              u0 = (u0 & 3) << 24 | u1 << 18 | u2 << 12 | u3 << 6 | u4;
	            } else {
	              u5 = u8Array[idx++] & 63;u0 = (u0 & 1) << 30 | u1 << 24 | u2 << 18 | u3 << 12 | u4 << 6 | u5;
	            }
	          }
	        }if (u0 < 65536) {
	          str += String.fromCharCode(u0);
	        } else {
	          var ch = u0 - 65536;str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
	        }
	      }
	    }
	  }Module["UTF8ArrayToString"] = UTF8ArrayToString;function UTF8ToString(ptr) {
	    return UTF8ArrayToString(HEAPU8, ptr);
	  }Module["UTF8ToString"] = UTF8ToString;function stringToUTF8Array(str, outU8Array, outIdx, maxBytesToWrite) {
	    if (!(maxBytesToWrite > 0)) return 0;var startIdx = outIdx;var endIdx = outIdx + maxBytesToWrite - 1;for (var i = 0; i < str.length; ++i) {
	      var u = str.charCodeAt(i);if (u >= 55296 && u <= 57343) u = 65536 + ((u & 1023) << 10) | str.charCodeAt(++i) & 1023;if (u <= 127) {
	        if (outIdx >= endIdx) break;outU8Array[outIdx++] = u;
	      } else if (u <= 2047) {
	        if (outIdx + 1 >= endIdx) break;outU8Array[outIdx++] = 192 | u >> 6;outU8Array[outIdx++] = 128 | u & 63;
	      } else if (u <= 65535) {
	        if (outIdx + 2 >= endIdx) break;outU8Array[outIdx++] = 224 | u >> 12;outU8Array[outIdx++] = 128 | u >> 6 & 63;outU8Array[outIdx++] = 128 | u & 63;
	      } else if (u <= 2097151) {
	        if (outIdx + 3 >= endIdx) break;outU8Array[outIdx++] = 240 | u >> 18;outU8Array[outIdx++] = 128 | u >> 12 & 63;outU8Array[outIdx++] = 128 | u >> 6 & 63;outU8Array[outIdx++] = 128 | u & 63;
	      } else if (u <= 67108863) {
	        if (outIdx + 4 >= endIdx) break;outU8Array[outIdx++] = 248 | u >> 24;outU8Array[outIdx++] = 128 | u >> 18 & 63;outU8Array[outIdx++] = 128 | u >> 12 & 63;outU8Array[outIdx++] = 128 | u >> 6 & 63;outU8Array[outIdx++] = 128 | u & 63;
	      } else {
	        if (outIdx + 5 >= endIdx) break;outU8Array[outIdx++] = 252 | u >> 30;outU8Array[outIdx++] = 128 | u >> 24 & 63;outU8Array[outIdx++] = 128 | u >> 18 & 63;outU8Array[outIdx++] = 128 | u >> 12 & 63;outU8Array[outIdx++] = 128 | u >> 6 & 63;outU8Array[outIdx++] = 128 | u & 63;
	      }
	    }outU8Array[outIdx] = 0;return outIdx - startIdx;
	  }Module["stringToUTF8Array"] = stringToUTF8Array;function stringToUTF8(str, outPtr, maxBytesToWrite) {
	    return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
	  }Module["stringToUTF8"] = stringToUTF8;function lengthBytesUTF8(str) {
	    var len = 0;for (var i = 0; i < str.length; ++i) {
	      var u = str.charCodeAt(i);if (u >= 55296 && u <= 57343) u = 65536 + ((u & 1023) << 10) | str.charCodeAt(++i) & 1023;if (u <= 127) {
	        ++len;
	      } else if (u <= 2047) {
	        len += 2;
	      } else if (u <= 65535) {
	        len += 3;
	      } else if (u <= 2097151) {
	        len += 4;
	      } else if (u <= 67108863) {
	        len += 5;
	      } else {
	        len += 6;
	      }
	    }return len;
	  }Module["lengthBytesUTF8"] = lengthBytesUTF8;var UTF16Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : undefined;function demangle(func) {
	    var __cxa_demangle_func = Module["___cxa_demangle"] || Module["__cxa_demangle"];if (__cxa_demangle_func) {
	      try {
	        var s = func.substr(1);var len = lengthBytesUTF8(s) + 1;var buf = _malloc(len);stringToUTF8(s, buf, len);var status = _malloc(4);var ret = __cxa_demangle_func(buf, 0, 0, status);if (getValue(status, "i32") === 0 && ret) {
	          return Pointer_stringify(ret);
	        }
	      } catch (e) {} finally {
	        if (buf) _free(buf);if (status) _free(status);if (ret) _free(ret);
	      }return func;
	    }Runtime.warnOnce("warning: build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling");return func;
	  }function demangleAll(text) {
	    var regex = /__Z[\w\d_]+/g;return text.replace(regex, function (x) {
	      var y = demangle(x);return x === y ? x : x + " [" + y + "]";
	    });
	  }function jsStackTrace() {
	    var err = new Error();if (!err.stack) {
	      try {
	        throw new Error(0);
	      } catch (e) {
	        err = e;
	      }if (!err.stack) {
	        return "(no stack trace available)";
	      }
	    }return err.stack.toString();
	  }function stackTrace() {
	    var js = jsStackTrace();if (Module["extraStackTrace"]) js += "\n" + Module["extraStackTrace"]();return demangleAll(js);
	  }Module["stackTrace"] = stackTrace;var HEAP, buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;function updateGlobalBufferViews() {
	    Module["HEAP8"] = HEAP8 = new Int8Array(buffer);Module["HEAP16"] = HEAP16 = new Int16Array(buffer);Module["HEAP32"] = HEAP32 = new Int32Array(buffer);Module["HEAPU8"] = HEAPU8 = new Uint8Array(buffer);Module["HEAPU16"] = HEAPU16 = new Uint16Array(buffer);Module["HEAPU32"] = HEAPU32 = new Uint32Array(buffer);Module["HEAPF32"] = HEAPF32 = new Float32Array(buffer);Module["HEAPF64"] = HEAPF64 = new Float64Array(buffer);
	  }var STATIC_BASE, STATICTOP, staticSealed;var STACK_BASE, STACKTOP, STACK_MAX;var DYNAMIC_BASE, DYNAMICTOP_PTR;STATIC_BASE = STATICTOP = STACK_BASE = STACKTOP = STACK_MAX = DYNAMIC_BASE = DYNAMICTOP_PTR = 0;staticSealed = false;function abortOnCannotGrowMemory() {
	    abort("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value " + TOTAL_MEMORY + ", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime but prevents some optimizations, (3) set Module.TOTAL_MEMORY to a higher value before the program runs, or (4) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ");
	  }function enlargeMemory() {
	    abortOnCannotGrowMemory();
	  }var TOTAL_STACK = Module["TOTAL_STACK"] || 5242880;var TOTAL_MEMORY = Module["TOTAL_MEMORY"] || 134217728;if (TOTAL_MEMORY < TOTAL_STACK) Module.printErr("TOTAL_MEMORY should be larger than TOTAL_STACK, was " + TOTAL_MEMORY + "! (TOTAL_STACK=" + TOTAL_STACK + ")");if (Module["buffer"]) {
	    buffer = Module["buffer"];
	  } else {
	    {
	      buffer = new ArrayBuffer(TOTAL_MEMORY);
	    }
	  }updateGlobalBufferViews();function getTotalMemory() {
	    return TOTAL_MEMORY;
	  }HEAP32[0] = 1668509029;HEAP16[1] = 25459;if (HEAPU8[2] !== 115 || HEAPU8[3] !== 99) throw "Runtime error: expected the system to be little-endian!";Module["HEAP"] = HEAP;Module["buffer"] = buffer;Module["HEAP8"] = HEAP8;Module["HEAP16"] = HEAP16;Module["HEAP32"] = HEAP32;Module["HEAPU8"] = HEAPU8;Module["HEAPU16"] = HEAPU16;Module["HEAPU32"] = HEAPU32;Module["HEAPF32"] = HEAPF32;Module["HEAPF64"] = HEAPF64;function callRuntimeCallbacks(callbacks) {
	    while (callbacks.length > 0) {
	      var callback = callbacks.shift();if (typeof callback == "function") {
	        callback();continue;
	      }var func = callback.func;if (typeof func === "number") {
	        if (callback.arg === undefined) {
	          Module["dynCall_v"](func);
	        } else {
	          Module["dynCall_vi"](func, callback.arg);
	        }
	      } else {
	        func(callback.arg === undefined ? null : callback.arg);
	      }
	    }
	  }var __ATPRERUN__ = [];var __ATINIT__ = [];var __ATMAIN__ = [];var __ATEXIT__ = [];var __ATPOSTRUN__ = [];var runtimeInitialized = false;var runtimeExited = false;function preRun() {
	    if (Module["preRun"]) {
	      if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];while (Module["preRun"].length) {
	        addOnPreRun(Module["preRun"].shift());
	      }
	    }callRuntimeCallbacks(__ATPRERUN__);
	  }function ensureInitRuntime() {
	    if (runtimeInitialized) return;runtimeInitialized = true;callRuntimeCallbacks(__ATINIT__);
	  }function preMain() {
	    callRuntimeCallbacks(__ATMAIN__);
	  }function exitRuntime() {
	    callRuntimeCallbacks(__ATEXIT__);runtimeExited = true;
	  }function postRun() {
	    if (Module["postRun"]) {
	      if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];while (Module["postRun"].length) {
	        addOnPostRun(Module["postRun"].shift());
	      }
	    }callRuntimeCallbacks(__ATPOSTRUN__);
	  }function addOnPreRun(cb) {
	    __ATPRERUN__.unshift(cb);
	  }Module["addOnPreRun"] = addOnPreRun;function addOnInit(cb) {
	    __ATINIT__.unshift(cb);
	  }Module["addOnInit"] = addOnInit;function addOnPreMain(cb) {
	    __ATMAIN__.unshift(cb);
	  }Module["addOnPreMain"] = addOnPreMain;function addOnExit(cb) {
	    __ATEXIT__.unshift(cb);
	  }Module["addOnExit"] = addOnExit;function addOnPostRun(cb) {
	    __ATPOSTRUN__.unshift(cb);
	  }Module["addOnPostRun"] = addOnPostRun;function intArrayFromString(stringy, dontAddNull, length) {
	    var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;var u8array = new Array(len);var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);if (dontAddNull) u8array.length = numBytesWritten;return u8array;
	  }Module["intArrayFromString"] = intArrayFromString;function intArrayToString(array) {
	    var ret = [];for (var i = 0; i < array.length; i++) {
	      var chr = array[i];if (chr > 255) {
	        chr &= 255;
	      }ret.push(String.fromCharCode(chr));
	    }return ret.join("");
	  }Module["intArrayToString"] = intArrayToString;function writeStringToMemory(string, buffer, dontAddNull) {
	    Runtime.warnOnce("writeStringToMemory is deprecated and should not be called! Use stringToUTF8() instead!");var lastChar, end;if (dontAddNull) {
	      end = buffer + lengthBytesUTF8(string);lastChar = HEAP8[end];
	    }stringToUTF8(string, buffer, Infinity);if (dontAddNull) HEAP8[end] = lastChar;
	  }Module["writeStringToMemory"] = writeStringToMemory;function writeArrayToMemory(array, buffer) {
	    HEAP8.set(array, buffer);
	  }Module["writeArrayToMemory"] = writeArrayToMemory;function writeAsciiToMemory(str, buffer, dontAddNull) {
	    for (var i = 0; i < str.length; ++i) {
	      HEAP8[buffer++ >> 0] = str.charCodeAt(i);
	    }if (!dontAddNull) HEAP8[buffer >> 0] = 0;
	  }Module["writeAsciiToMemory"] = writeAsciiToMemory;if (!Math["imul"] || Math["imul"](4294967295, 5) !== -5) Math["imul"] = function imul(a, b) {
	    var ah = a >>> 16;var al = a & 65535;var bh = b >>> 16;var bl = b & 65535;return al * bl + (ah * bl + al * bh << 16) | 0;
	  };Math.imul = Math["imul"];if (!Math["fround"]) {
	    var froundBuffer = new Float32Array(1);Math["fround"] = function (x) {
	      froundBuffer[0] = x;return froundBuffer[0];
	    };
	  }Math.fround = Math["fround"];if (!Math["clz32"]) Math["clz32"] = function (x) {
	    x = x >>> 0;for (var i = 0; i < 32; i++) {
	      if (x & 1 << 31 - i) return i;
	    }return 32;
	  };Math.clz32 = Math["clz32"];if (!Math["trunc"]) Math["trunc"] = function (x) {
	    return x < 0 ? Math.ceil(x) : Math.floor(x);
	  };Math.trunc = Math["trunc"];var Math_abs = Math.abs;var Math_cos = Math.cos;var Math_sin = Math.sin;var Math_tan = Math.tan;var Math_acos = Math.acos;var Math_asin = Math.asin;var Math_atan = Math.atan;var Math_atan2 = Math.atan2;var Math_exp = Math.exp;var Math_log = Math.log;var Math_sqrt = Math.sqrt;var Math_ceil = Math.ceil;var Math_floor = Math.floor;var Math_pow = Math.pow;var Math_imul = Math.imul;var Math_fround = Math.fround;var Math_round = Math.round;var Math_min = Math.min;var Math_clz32 = Math.clz32;var Math_trunc = Math.trunc;var runDependencies = 0;var runDependencyWatcher = null;var dependenciesFulfilled = null;function getUniqueRunDependency(id) {
	    return id;
	  }function addRunDependency(id) {
	    runDependencies++;if (Module["monitorRunDependencies"]) {
	      Module["monitorRunDependencies"](runDependencies);
	    }
	  }Module["addRunDependency"] = addRunDependency;function removeRunDependency(id) {
	    runDependencies--;if (Module["monitorRunDependencies"]) {
	      Module["monitorRunDependencies"](runDependencies);
	    }if (runDependencies == 0) {
	      if (runDependencyWatcher !== null) {
	        clearInterval(runDependencyWatcher);runDependencyWatcher = null;
	      }if (dependenciesFulfilled) {
	        var callback = dependenciesFulfilled;dependenciesFulfilled = null;callback();
	      }
	    }
	  }Module["removeRunDependency"] = removeRunDependency;Module["preloadedImages"] = {};Module["preloadedAudios"] = {};var ASM_CONSTS = [function ($0, $1, $2, $3, $4, $5, $6, $7) {
	    return _nbind.callbackSignatureList[$0].apply(this, arguments);
	  }];function _emscripten_asm_const_iiiiiiii(code, a0, a1, a2, a3, a4, a5, a6) {
	    return ASM_CONSTS[code](a0, a1, a2, a3, a4, a5, a6);
	  }function _emscripten_asm_const_iiiii(code, a0, a1, a2, a3) {
	    return ASM_CONSTS[code](a0, a1, a2, a3);
	  }function _emscripten_asm_const_iiidddddd(code, a0, a1, a2, a3, a4, a5, a6, a7) {
	    return ASM_CONSTS[code](a0, a1, a2, a3, a4, a5, a6, a7);
	  }function _emscripten_asm_const_iiididi(code, a0, a1, a2, a3, a4, a5) {
	    return ASM_CONSTS[code](a0, a1, a2, a3, a4, a5);
	  }function _emscripten_asm_const_iiii(code, a0, a1, a2) {
	    return ASM_CONSTS[code](a0, a1, a2);
	  }function _emscripten_asm_const_iiiid(code, a0, a1, a2, a3) {
	    return ASM_CONSTS[code](a0, a1, a2, a3);
	  }function _emscripten_asm_const_iiiiii(code, a0, a1, a2, a3, a4) {
	    return ASM_CONSTS[code](a0, a1, a2, a3, a4);
	  }STATIC_BASE = Runtime.GLOBAL_BASE;STATICTOP = STATIC_BASE + 12800;__ATINIT__.push({ func: function () {
	      __GLOBAL__sub_I_Yoga_cpp();
	    } }, { func: function () {
	      __GLOBAL__sub_I_nbind_cc();
	    } }, { func: function () {
	      __GLOBAL__sub_I_common_cc();
	    } }, { func: function () {
	      __GLOBAL__sub_I_Binding_cc();
	    } });allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 192, 127, 0, 0, 192, 127, 0, 0, 192, 127, 3, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 3, 0, 0, 0, 0, 0, 192, 127, 3, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 0, 0, 255, 255, 255, 255, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 192, 127, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 0, 0, 255, 255, 255, 255, 255, 255, 255, 255, 0, 0, 128, 191, 0, 0, 128, 191, 0, 0, 192, 127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 63, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 3, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 190, 12, 0, 0, 200, 12, 0, 0, 208, 12, 0, 0, 216, 12, 0, 0, 230, 12, 0, 0, 242, 12, 0, 0, 1, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 192, 127, 3, 0, 0, 0, 180, 45, 0, 0, 181, 45, 0, 0, 182, 45, 0, 0, 181, 45, 0, 0, 182, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 3, 0, 0, 0, 1, 0, 0, 0, 4, 0, 0, 0, 183, 45, 0, 0, 181, 45, 0, 0, 181, 45, 0, 0, 181, 45, 0, 0, 181, 45, 0, 0, 181, 45, 0, 0, 181, 45, 0, 0, 184, 45, 0, 0, 185, 45, 0, 0, 181, 45, 0, 0, 181, 45, 0, 0, 182, 45, 0, 0, 186, 45, 0, 0, 185, 45, 0, 0, 148, 4, 0, 0, 3, 0, 0, 0, 187, 45, 0, 0, 164, 4, 0, 0, 188, 45, 0, 0, 2, 0, 0, 0, 189, 45, 0, 0, 164, 4, 0, 0, 188, 45, 0, 0, 185, 45, 0, 0, 164, 4, 0, 0, 185, 45, 0, 0, 164, 4, 0, 0, 188, 45, 0, 0, 181, 45, 0, 0, 182, 45, 0, 0, 181, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 5, 0, 0, 0, 6, 0, 0, 0, 1, 0, 0, 0, 7, 0, 0, 0, 183, 45, 0, 0, 182, 45, 0, 0, 181, 45, 0, 0, 190, 45, 0, 0, 190, 45, 0, 0, 182, 45, 0, 0, 182, 45, 0, 0, 185, 45, 0, 0, 181, 45, 0, 0, 185, 45, 0, 0, 182, 45, 0, 0, 181, 45, 0, 0, 185, 45, 0, 0, 182, 45, 0, 0, 185, 45, 0, 0, 48, 5, 0, 0, 3, 0, 0, 0, 56, 5, 0, 0, 1, 0, 0, 0, 189, 45, 0, 0, 185, 45, 0, 0, 164, 4, 0, 0, 76, 5, 0, 0, 2, 0, 0, 0, 191, 45, 0, 0, 186, 45, 0, 0, 182, 45, 0, 0, 185, 45, 0, 0, 192, 45, 0, 0, 185, 45, 0, 0, 182, 45, 0, 0, 186, 45, 0, 0, 185, 45, 0, 0, 76, 5, 0, 0, 76, 5, 0, 0, 136, 5, 0, 0, 182, 45, 0, 0, 181, 45, 0, 0, 2, 0, 0, 0, 190, 45, 0, 0, 136, 5, 0, 0, 56, 19, 0, 0, 156, 5, 0, 0, 2, 0, 0, 0, 184, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 8, 0, 0, 0, 9, 0, 0, 0, 1, 0, 0, 0, 10, 0, 0, 0, 204, 5, 0, 0, 181, 45, 0, 0, 181, 45, 0, 0, 2, 0, 0, 0, 180, 45, 0, 0, 204, 5, 0, 0, 2, 0, 0, 0, 195, 45, 0, 0, 236, 5, 0, 0, 97, 19, 0, 0, 198, 45, 0, 0, 211, 45, 0, 0, 212, 45, 0, 0, 213, 45, 0, 0, 214, 45, 0, 0, 215, 45, 0, 0, 188, 45, 0, 0, 182, 45, 0, 0, 216, 45, 0, 0, 217, 45, 0, 0, 218, 45, 0, 0, 219, 45, 0, 0, 192, 45, 0, 0, 181, 45, 0, 0, 0, 0, 0, 0, 185, 45, 0, 0, 110, 19, 0, 0, 186, 45, 0, 0, 115, 19, 0, 0, 221, 45, 0, 0, 120, 19, 0, 0, 148, 4, 0, 0, 132, 19, 0, 0, 96, 6, 0, 0, 145, 19, 0, 0, 222, 45, 0, 0, 164, 19, 0, 0, 223, 45, 0, 0, 173, 19, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 104, 6, 0, 0, 1, 0, 0, 0, 187, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 11, 0, 0, 0, 12, 0, 0, 0, 1, 0, 0, 0, 13, 0, 0, 0, 185, 45, 0, 0, 224, 45, 0, 0, 164, 6, 0, 0, 188, 45, 0, 0, 172, 6, 0, 0, 180, 6, 0, 0, 2, 0, 0, 0, 188, 6, 0, 0, 7, 0, 0, 0, 224, 45, 0, 0, 7, 0, 0, 0, 164, 6, 0, 0, 1, 0, 0, 0, 213, 45, 0, 0, 185, 45, 0, 0, 224, 45, 0, 0, 172, 6, 0, 0, 185, 45, 0, 0, 224, 45, 0, 0, 164, 6, 0, 0, 185, 45, 0, 0, 224, 45, 0, 0, 211, 45, 0, 0, 211, 45, 0, 0, 222, 45, 0, 0, 211, 45, 0, 0, 224, 45, 0, 0, 222, 45, 0, 0, 211, 45, 0, 0, 224, 45, 0, 0, 172, 6, 0, 0, 222, 45, 0, 0, 211, 45, 0, 0, 224, 45, 0, 0, 188, 45, 0, 0, 222, 45, 0, 0, 211, 45, 0, 0, 40, 7, 0, 0, 188, 45, 0, 0, 2, 0, 0, 0, 224, 45, 0, 0, 185, 45, 0, 0, 188, 45, 0, 0, 188, 45, 0, 0, 188, 45, 0, 0, 188, 45, 0, 0, 222, 45, 0, 0, 224, 45, 0, 0, 148, 4, 0, 0, 185, 45, 0, 0, 148, 4, 0, 0, 148, 4, 0, 0, 148, 4, 0, 0, 148, 4, 0, 0, 148, 4, 0, 0, 185, 45, 0, 0, 164, 6, 0, 0, 148, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 14, 0, 0, 0, 15, 0, 0, 0, 1, 0, 0, 0, 16, 0, 0, 0, 148, 7, 0, 0, 2, 0, 0, 0, 225, 45, 0, 0, 183, 45, 0, 0, 188, 45, 0, 0, 168, 7, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 234, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 255, 255, 255, 255, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 148, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 28, 9, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 2, 0, 0, 0, 242, 45, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 255, 255, 255, 255, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 67, 111, 117, 108, 100, 32, 110, 111, 116, 32, 97, 108, 108, 111, 99, 97, 116, 101, 32, 109, 101, 109, 111, 114, 121, 32, 102, 111, 114, 32, 110, 111, 100, 101, 0, 67, 97, 110, 110, 111, 116, 32, 114, 101, 115, 101, 116, 32, 97, 32, 110, 111, 100, 101, 32, 119, 104, 105, 99, 104, 32, 115, 116, 105, 108, 108, 32, 104, 97, 115, 32, 99, 104, 105, 108, 100, 114, 101, 110, 32, 97, 116, 116, 97, 99, 104, 101, 100, 0, 67, 97, 110, 110, 111, 116, 32, 114, 101, 115, 101, 116, 32, 97, 32, 110, 111, 100, 101, 32, 115, 116, 105, 108, 108, 32, 97, 116, 116, 97, 99, 104, 101, 100, 32, 116, 111, 32, 97, 32, 112, 97, 114, 101, 110, 116, 0, 67, 111, 117, 108, 100, 32, 110, 111, 116, 32, 97, 108, 108, 111, 99, 97, 116, 101, 32, 109, 101, 109, 111, 114, 121, 32, 102, 111, 114, 32, 99, 111, 110, 102, 105, 103, 0, 67, 97, 110, 110, 111, 116, 32, 115, 101, 116, 32, 109, 101, 97, 115, 117, 114, 101, 32, 102, 117, 110, 99, 116, 105, 111, 110, 58, 32, 78, 111, 100, 101, 115, 32, 119, 105, 116, 104, 32, 109, 101, 97, 115, 117, 114, 101, 32, 102, 117, 110, 99, 116, 105, 111, 110, 115, 32, 99, 97, 110, 110, 111, 116, 32, 104, 97, 118, 101, 32, 99, 104, 105, 108, 100, 114, 101, 110, 46, 0, 67, 104, 105, 108, 100, 32, 97, 108, 114, 101, 97, 100, 121, 32, 104, 97, 115, 32, 97, 32, 112, 97, 114, 101, 110, 116, 44, 32, 105, 116, 32, 109, 117, 115, 116, 32, 98, 101, 32, 114, 101, 109, 111, 118, 101, 100, 32, 102, 105, 114, 115, 116, 46, 0, 67, 97, 110, 110, 111, 116, 32, 97, 100, 100, 32, 99, 104, 105, 108, 100, 58, 32, 78, 111, 100, 101, 115, 32, 119, 105, 116, 104, 32, 109, 101, 97, 115, 117, 114, 101, 32, 102, 117, 110, 99, 116, 105, 111, 110, 115, 32, 99, 97, 110, 110, 111, 116, 32, 104, 97, 118, 101, 32, 99, 104, 105, 108, 100, 114, 101, 110, 46, 0, 79, 110, 108, 121, 32, 108, 101, 97, 102, 32, 110, 111, 100, 101, 115, 32, 119, 105, 116, 104, 32, 99, 117, 115, 116, 111, 109, 32, 109, 101, 97, 115, 117, 114, 101, 32, 102, 117, 110, 99, 116, 105, 111, 110, 115, 115, 104, 111, 117, 108, 100, 32, 109, 97, 110, 117, 97, 108, 108, 121, 32, 109, 97, 114, 107, 32, 116, 104, 101, 109, 115, 101, 108, 118, 101, 115, 32, 97, 115, 32, 100, 105, 114, 116, 121, 0, 67, 97, 110, 110, 111, 116, 32, 103, 101, 116, 32, 108, 97, 121, 111, 117, 116, 32, 112, 114, 111, 112, 101, 114, 116, 105, 101, 115, 32, 111, 102, 32, 109, 117, 108, 116, 105, 45, 101, 100, 103, 101, 32, 115, 104, 111, 114, 116, 104, 97, 110, 100, 115, 0, 37, 115, 37, 100, 46, 123, 91, 115, 107, 105, 112, 112, 101, 100, 93, 32, 0, 119, 109, 58, 32, 37, 115, 44, 32, 104, 109, 58, 32, 37, 115, 44, 32, 97, 119, 58, 32, 37, 102, 32, 97, 104, 58, 32, 37, 102, 32, 61, 62, 32, 100, 58, 32, 40, 37, 102, 44, 32, 37, 102, 41, 32, 37, 115, 10, 0, 37, 115, 37, 100, 46, 123, 37, 115, 0, 42, 0, 119, 109, 58, 32, 37, 115, 44, 32, 104, 109, 58, 32, 37, 115, 44, 32, 97, 119, 58, 32, 37, 102, 32, 97, 104, 58, 32, 37, 102, 32, 37, 115, 10, 0, 37, 115, 37, 100, 46, 125, 37, 115, 0, 119, 109, 58, 32, 37, 115, 44, 32, 104, 109, 58, 32, 37, 115, 44, 32, 100, 58, 32, 40, 37, 102, 44, 32, 37, 102, 41, 32, 37, 115, 10, 0, 79, 117, 116, 32, 111, 102, 32, 99, 97, 99, 104, 101, 32, 101, 110, 116, 114, 105, 101, 115, 33, 10, 0, 83, 99, 97, 108, 101, 32, 102, 97, 99, 116, 111, 114, 32, 115, 104, 111, 117, 108, 100, 32, 110, 111, 116, 32, 98, 101, 32, 108, 101, 115, 115, 32, 116, 104, 97, 110, 32, 122, 101, 114, 111, 0, 105, 110, 105, 116, 105, 97, 108, 0, 37, 115, 10, 0, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 0, 85, 78, 68, 69, 70, 73, 78, 69, 68, 0, 69, 88, 65, 67, 84, 76, 89, 0, 65, 84, 95, 77, 79, 83, 84, 0, 76, 65, 89, 95, 85, 78, 68, 69, 70, 73, 78, 69, 68, 0, 76, 65, 89, 95, 69, 88, 65, 67, 84, 76, 89, 0, 76, 65, 89, 95, 65, 84, 95, 77, 79, 83, 84, 0, 97, 118, 97, 105, 108, 97, 98, 108, 101, 87, 105, 100, 116, 104, 32, 105, 115, 32, 105, 110, 100, 101, 102, 105, 110, 105, 116, 101, 32, 115, 111, 32, 119, 105, 100, 116, 104, 77, 101, 97, 115, 117, 114, 101, 77, 111, 100, 101, 32, 109, 117, 115, 116, 32, 98, 101, 32, 89, 71, 77, 101, 97, 115, 117, 114, 101, 77, 111, 100, 101, 85, 110, 100, 101, 102, 105, 110, 101, 100, 0, 97, 118, 97, 105, 108, 97, 98, 108, 101, 72, 101, 105, 103, 104, 116, 32, 105, 115, 32, 105, 110, 100, 101, 102, 105, 110, 105, 116, 101, 32, 115, 111, 32, 104, 101, 105, 103, 104, 116, 77, 101, 97, 115, 117, 114, 101, 77, 111, 100, 101, 32, 109, 117, 115, 116, 32, 98, 101, 32, 89, 71, 77, 101, 97, 115, 117, 114, 101, 77, 111, 100, 101, 85, 110, 100, 101, 102, 105, 110, 101, 100, 0, 102, 108, 101, 120, 0, 115, 116, 114, 101, 116, 99, 104, 0, 109, 117, 108, 116, 105, 108, 105, 110, 101, 45, 115, 116, 114, 101, 116, 99, 104, 0, 69, 120, 112, 101, 99, 116, 101, 100, 32, 110, 111, 100, 101, 32, 116, 111, 32, 104, 97, 118, 101, 32, 99, 117, 115, 116, 111, 109, 32, 109, 101, 97, 115, 117, 114, 101, 32, 102, 117, 110, 99, 116, 105, 111, 110, 0, 109, 101, 97, 115, 117, 114, 101, 0, 69, 120, 112, 101, 99, 116, 32, 99, 117, 115, 116, 111, 109, 32, 98, 97, 115, 101, 108, 105, 110, 101, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 116, 111, 32, 110, 111, 116, 32, 114, 101, 116, 117, 114, 110, 32, 78, 97, 78, 0, 97, 98, 115, 45, 109, 101, 97, 115, 117, 114, 101, 0, 97, 98, 115, 45, 108, 97, 121, 111, 117, 116, 0, 78, 111, 100, 101, 0, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 0, 99, 114, 101, 97, 116, 101, 87, 105, 116, 104, 67, 111, 110, 102, 105, 103, 0, 100, 101, 115, 116, 114, 111, 121, 0, 114, 101, 115, 101, 116, 0, 99, 111, 112, 121, 83, 116, 121, 108, 101, 0, 115, 101, 116, 80, 111, 115, 105, 116, 105, 111, 110, 84, 121, 112, 101, 0, 115, 101, 116, 80, 111, 115, 105, 116, 105, 111, 110, 0, 115, 101, 116, 80, 111, 115, 105, 116, 105, 111, 110, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 65, 108, 105, 103, 110, 67, 111, 110, 116, 101, 110, 116, 0, 115, 101, 116, 65, 108, 105, 103, 110, 73, 116, 101, 109, 115, 0, 115, 101, 116, 65, 108, 105, 103, 110, 83, 101, 108, 102, 0, 115, 101, 116, 70, 108, 101, 120, 68, 105, 114, 101, 99, 116, 105, 111, 110, 0, 115, 101, 116, 70, 108, 101, 120, 87, 114, 97, 112, 0, 115, 101, 116, 74, 117, 115, 116, 105, 102, 121, 67, 111, 110, 116, 101, 110, 116, 0, 115, 101, 116, 77, 97, 114, 103, 105, 110, 0, 115, 101, 116, 77, 97, 114, 103, 105, 110, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 77, 97, 114, 103, 105, 110, 65, 117, 116, 111, 0, 115, 101, 116, 79, 118, 101, 114, 102, 108, 111, 119, 0, 115, 101, 116, 68, 105, 115, 112, 108, 97, 121, 0, 115, 101, 116, 70, 108, 101, 120, 0, 115, 101, 116, 70, 108, 101, 120, 66, 97, 115, 105, 115, 0, 115, 101, 116, 70, 108, 101, 120, 66, 97, 115, 105, 115, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 70, 108, 101, 120, 71, 114, 111, 119, 0, 115, 101, 116, 70, 108, 101, 120, 83, 104, 114, 105, 110, 107, 0, 115, 101, 116, 87, 105, 100, 116, 104, 0, 115, 101, 116, 87, 105, 100, 116, 104, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 87, 105, 100, 116, 104, 65, 117, 116, 111, 0, 115, 101, 116, 72, 101, 105, 103, 104, 116, 0, 115, 101, 116, 72, 101, 105, 103, 104, 116, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 72, 101, 105, 103, 104, 116, 65, 117, 116, 111, 0, 115, 101, 116, 77, 105, 110, 87, 105, 100, 116, 104, 0, 115, 101, 116, 77, 105, 110, 87, 105, 100, 116, 104, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 77, 105, 110, 72, 101, 105, 103, 104, 116, 0, 115, 101, 116, 77, 105, 110, 72, 101, 105, 103, 104, 116, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 77, 97, 120, 87, 105, 100, 116, 104, 0, 115, 101, 116, 77, 97, 120, 87, 105, 100, 116, 104, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 77, 97, 120, 72, 101, 105, 103, 104, 116, 0, 115, 101, 116, 77, 97, 120, 72, 101, 105, 103, 104, 116, 80, 101, 114, 99, 101, 110, 116, 0, 115, 101, 116, 65, 115, 112, 101, 99, 116, 82, 97, 116, 105, 111, 0, 115, 101, 116, 66, 111, 114, 100, 101, 114, 0, 115, 101, 116, 80, 97, 100, 100, 105, 110, 103, 0, 115, 101, 116, 80, 97, 100, 100, 105, 110, 103, 80, 101, 114, 99, 101, 110, 116, 0, 103, 101, 116, 80, 111, 115, 105, 116, 105, 111, 110, 84, 121, 112, 101, 0, 103, 101, 116, 80, 111, 115, 105, 116, 105, 111, 110, 0, 103, 101, 116, 65, 108, 105, 103, 110, 67, 111, 110, 116, 101, 110, 116, 0, 103, 101, 116, 65, 108, 105, 103, 110, 73, 116, 101, 109, 115, 0, 103, 101, 116, 65, 108, 105, 103, 110, 83, 101, 108, 102, 0, 103, 101, 116, 70, 108, 101, 120, 68, 105, 114, 101, 99, 116, 105, 111, 110, 0, 103, 101, 116, 70, 108, 101, 120, 87, 114, 97, 112, 0, 103, 101, 116, 74, 117, 115, 116, 105, 102, 121, 67, 111, 110, 116, 101, 110, 116, 0, 103, 101, 116, 77, 97, 114, 103, 105, 110, 0, 103, 101, 116, 70, 108, 101, 120, 66, 97, 115, 105, 115, 0, 103, 101, 116, 70, 108, 101, 120, 71, 114, 111, 119, 0, 103, 101, 116, 70, 108, 101, 120, 83, 104, 114, 105, 110, 107, 0, 103, 101, 116, 87, 105, 100, 116, 104, 0, 103, 101, 116, 72, 101, 105, 103, 104, 116, 0, 103, 101, 116, 77, 105, 110, 87, 105, 100, 116, 104, 0, 103, 101, 116, 77, 105, 110, 72, 101, 105, 103, 104, 116, 0, 103, 101, 116, 77, 97, 120, 87, 105, 100, 116, 104, 0, 103, 101, 116, 77, 97, 120, 72, 101, 105, 103, 104, 116, 0, 103, 101, 116, 65, 115, 112, 101, 99, 116, 82, 97, 116, 105, 111, 0, 103, 101, 116, 66, 111, 114, 100, 101, 114, 0, 103, 101, 116, 79, 118, 101, 114, 102, 108, 111, 119, 0, 103, 101, 116, 68, 105, 115, 112, 108, 97, 121, 0, 103, 101, 116, 80, 97, 100, 100, 105, 110, 103, 0, 105, 110, 115, 101, 114, 116, 67, 104, 105, 108, 100, 0, 114, 101, 109, 111, 118, 101, 67, 104, 105, 108, 100, 0, 103, 101, 116, 67, 104, 105, 108, 100, 67, 111, 117, 110, 116, 0, 103, 101, 116, 80, 97, 114, 101, 110, 116, 0, 103, 101, 116, 67, 104, 105, 108, 100, 0, 115, 101, 116, 77, 101, 97, 115, 117, 114, 101, 70, 117, 110, 99, 0, 117, 110, 115, 101, 116, 77, 101, 97, 115, 117, 114, 101, 70, 117, 110, 99, 0, 109, 97, 114, 107, 68, 105, 114, 116, 121, 0, 105, 115, 68, 105, 114, 116, 121, 0, 99, 97, 108, 99, 117, 108, 97, 116, 101, 76, 97, 121, 111, 117, 116, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 76, 101, 102, 116, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 82, 105, 103, 104, 116, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 84, 111, 112, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 66, 111, 116, 116, 111, 109, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 87, 105, 100, 116, 104, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 72, 101, 105, 103, 104, 116, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 76, 97, 121, 111, 117, 116, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 77, 97, 114, 103, 105, 110, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 66, 111, 114, 100, 101, 114, 0, 103, 101, 116, 67, 111, 109, 112, 117, 116, 101, 100, 80, 97, 100, 100, 105, 110, 103, 0, 67, 111, 110, 102, 105, 103, 0, 99, 114, 101, 97, 116, 101, 0, 115, 101, 116, 69, 120, 112, 101, 114, 105, 109, 101, 110, 116, 97, 108, 70, 101, 97, 116, 117, 114, 101, 69, 110, 97, 98, 108, 101, 100, 0, 115, 101, 116, 80, 111, 105, 110, 116, 83, 99, 97, 108, 101, 70, 97, 99, 116, 111, 114, 0, 105, 115, 69, 120, 112, 101, 114, 105, 109, 101, 110, 116, 97, 108, 70, 101, 97, 116, 117, 114, 101, 69, 110, 97, 98, 108, 101, 100, 0, 86, 97, 108, 117, 101, 0, 76, 97, 121, 111, 117, 116, 0, 83, 105, 122, 101, 0, 103, 101, 116, 73, 110, 115, 116, 97, 110, 99, 101, 67, 111, 117, 110, 116, 0, 73, 110, 116, 54, 52, 0, 1, 1, 1, 2, 2, 4, 4, 4, 4, 8, 8, 4, 8, 118, 111, 105, 100, 0, 98, 111, 111, 108, 0, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 0, 99, 98, 70, 117, 110, 99, 116, 105, 111, 110, 32, 38, 0, 99, 111, 110, 115, 116, 32, 99, 98, 70, 117, 110, 99, 116, 105, 111, 110, 32, 38, 0, 69, 120, 116, 101, 114, 110, 97, 108, 0, 66, 117, 102, 102, 101, 114, 0, 78, 66, 105, 110, 100, 73, 68, 0, 78, 66, 105, 110, 100, 0, 98, 105, 110, 100, 95, 118, 97, 108, 117, 101, 0, 114, 101, 102, 108, 101, 99, 116, 0, 113, 117, 101, 114, 121, 84, 121, 112, 101, 0, 108, 97, 108, 108, 111, 99, 0, 108, 114, 101, 115, 101, 116, 0, 123, 114, 101, 116, 117, 114, 110, 40, 95, 110, 98, 105, 110, 100, 46, 99, 97, 108, 108, 98, 97, 99, 107, 83, 105, 103, 110, 97, 116, 117, 114, 101, 76, 105, 115, 116, 91, 36, 48, 93, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 97, 114, 103, 117, 109, 101, 110, 116, 115, 41, 41, 59, 125, 0, 95, 110, 98, 105, 110, 100, 95, 110, 101, 119, 0, 17, 0, 10, 0, 17, 17, 17, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 0, 17, 0, 15, 10, 17, 17, 17, 3, 10, 7, 0, 1, 19, 9, 11, 11, 0, 0, 9, 6, 11, 0, 0, 11, 0, 6, 17, 0, 0, 0, 17, 17, 17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 0, 17, 0, 10, 10, 17, 17, 17, 0, 10, 0, 0, 2, 0, 9, 11, 0, 0, 0, 9, 0, 11, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 12, 0, 0, 0, 0, 9, 12, 0, 0, 0, 0, 0, 12, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13, 0, 0, 0, 4, 13, 0, 0, 0, 0, 9, 14, 0, 0, 0, 0, 0, 14, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 15, 0, 0, 0, 0, 9, 16, 0, 0, 0, 0, 0, 16, 0, 0, 16, 0, 0, 18, 0, 0, 0, 18, 18, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 18, 0, 0, 0, 18, 18, 18, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 10, 0, 0, 0, 0, 9, 11, 0, 0, 0, 0, 0, 11, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 12, 0, 0, 0, 0, 9, 12, 0, 0, 0, 0, 0, 12, 0, 0, 12, 0, 0, 45, 43, 32, 32, 32, 48, 88, 48, 120, 0, 40, 110, 117, 108, 108, 41, 0, 45, 48, 88, 43, 48, 88, 32, 48, 88, 45, 48, 120, 43, 48, 120, 32, 48, 120, 0, 105, 110, 102, 0, 73, 78, 70, 0, 110, 97, 110, 0, 78, 65, 78, 0, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 65, 66, 67, 68, 69, 70, 46, 0, 84, 33, 34, 25, 13, 1, 2, 3, 17, 75, 28, 12, 16, 4, 11, 29, 18, 30, 39, 104, 110, 111, 112, 113, 98, 32, 5, 6, 15, 19, 20, 21, 26, 8, 22, 7, 40, 36, 23, 24, 9, 10, 14, 27, 31, 37, 35, 131, 130, 125, 38, 42, 43, 60, 61, 62, 63, 67, 71, 74, 77, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 99, 100, 101, 102, 103, 105, 106, 107, 108, 114, 115, 116, 121, 122, 123, 124, 0, 73, 108, 108, 101, 103, 97, 108, 32, 98, 121, 116, 101, 32, 115, 101, 113, 117, 101, 110, 99, 101, 0, 68, 111, 109, 97, 105, 110, 32, 101, 114, 114, 111, 114, 0, 82, 101, 115, 117, 108, 116, 32, 110, 111, 116, 32, 114, 101, 112, 114, 101, 115, 101, 110, 116, 97, 98, 108, 101, 0, 78, 111, 116, 32, 97, 32, 116, 116, 121, 0, 80, 101, 114, 109, 105, 115, 115, 105, 111, 110, 32, 100, 101, 110, 105, 101, 100, 0, 79, 112, 101, 114, 97, 116, 105, 111, 110, 32, 110, 111, 116, 32, 112, 101, 114, 109, 105, 116, 116, 101, 100, 0, 78, 111, 32, 115, 117, 99, 104, 32, 102, 105, 108, 101, 32, 111, 114, 32, 100, 105, 114, 101, 99, 116, 111, 114, 121, 0, 78, 111, 32, 115, 117, 99, 104, 32, 112, 114, 111, 99, 101, 115, 115, 0, 70, 105, 108, 101, 32, 101, 120, 105, 115, 116, 115, 0, 86, 97, 108, 117, 101, 32, 116, 111, 111, 32, 108, 97, 114, 103, 101, 32, 102, 111, 114, 32, 100, 97, 116, 97, 32, 116, 121, 112, 101, 0, 78, 111, 32, 115, 112, 97, 99, 101, 32, 108, 101, 102, 116, 32, 111, 110, 32, 100, 101, 118, 105, 99, 101, 0, 79, 117, 116, 32, 111, 102, 32, 109, 101, 109, 111, 114, 121, 0, 82, 101, 115, 111, 117, 114, 99, 101, 32, 98, 117, 115, 121, 0, 73, 110, 116, 101, 114, 114, 117, 112, 116, 101, 100, 32, 115, 121, 115, 116, 101, 109, 32, 99, 97, 108, 108, 0, 82, 101, 115, 111, 117, 114, 99, 101, 32, 116, 101, 109, 112, 111, 114, 97, 114, 105, 108, 121, 32, 117, 110, 97, 118, 97, 105, 108, 97, 98, 108, 101, 0, 73, 110, 118, 97, 108, 105, 100, 32, 115, 101, 101, 107, 0, 67, 114, 111, 115, 115, 45, 100, 101, 118, 105, 99, 101, 32, 108, 105, 110, 107, 0, 82, 101, 97, 100, 45, 111, 110, 108, 121, 32, 102, 105, 108, 101, 32, 115, 121, 115, 116, 101, 109, 0, 68, 105, 114, 101, 99, 116, 111, 114, 121, 32, 110, 111, 116, 32, 101, 109, 112, 116, 121, 0, 67, 111, 110, 110, 101, 99, 116, 105, 111, 110, 32, 114, 101, 115, 101, 116, 32, 98, 121, 32, 112, 101, 101, 114, 0, 79, 112, 101, 114, 97, 116, 105, 111, 110, 32, 116, 105, 109, 101, 100, 32, 111, 117, 116, 0, 67, 111, 110, 110, 101, 99, 116, 105, 111, 110, 32, 114, 101, 102, 117, 115, 101, 100, 0, 72, 111, 115, 116, 32, 105, 115, 32, 100, 111, 119, 110, 0, 72, 111, 115, 116, 32, 105, 115, 32, 117, 110, 114, 101, 97, 99, 104, 97, 98, 108, 101, 0, 65, 100, 100, 114, 101, 115, 115, 32, 105, 110, 32, 117, 115, 101, 0, 66, 114, 111, 107, 101, 110, 32, 112, 105, 112, 101, 0, 73, 47, 79, 32, 101, 114, 114, 111, 114, 0, 78, 111, 32, 115, 117, 99, 104, 32, 100, 101, 118, 105, 99, 101, 32, 111, 114, 32, 97, 100, 100, 114, 101, 115, 115, 0, 66, 108, 111, 99, 107, 32, 100, 101, 118, 105, 99, 101, 32, 114, 101, 113, 117, 105, 114, 101, 100, 0, 78, 111, 32, 115, 117, 99, 104, 32, 100, 101, 118, 105, 99, 101, 0, 78, 111, 116, 32, 97, 32, 100, 105, 114, 101, 99, 116, 111, 114, 121, 0, 73, 115, 32, 97, 32, 100, 105, 114, 101, 99, 116, 111, 114, 121, 0, 84, 101, 120, 116, 32, 102, 105, 108, 101, 32, 98, 117, 115, 121, 0, 69, 120, 101, 99, 32, 102, 111, 114, 109, 97, 116, 32, 101, 114, 114, 111, 114, 0, 73, 110, 118, 97, 108, 105, 100, 32, 97, 114, 103, 117, 109, 101, 110, 116, 0, 65, 114, 103, 117, 109, 101, 110, 116, 32, 108, 105, 115, 116, 32, 116, 111, 111, 32, 108, 111, 110, 103, 0, 83, 121, 109, 98, 111, 108, 105, 99, 32, 108, 105, 110, 107, 32, 108, 111, 111, 112, 0, 70, 105, 108, 101, 110, 97, 109, 101, 32, 116, 111, 111, 32, 108, 111, 110, 103, 0, 84, 111, 111, 32, 109, 97, 110, 121, 32, 111, 112, 101, 110, 32, 102, 105, 108, 101, 115, 32, 105, 110, 32, 115, 121, 115, 116, 101, 109, 0, 78, 111, 32, 102, 105, 108, 101, 32, 100, 101, 115, 99, 114, 105, 112, 116, 111, 114, 115, 32, 97, 118, 97, 105, 108, 97, 98, 108, 101, 0, 66, 97, 100, 32, 102, 105, 108, 101, 32, 100, 101, 115, 99, 114, 105, 112, 116, 111, 114, 0, 78, 111, 32, 99, 104, 105, 108, 100, 32, 112, 114, 111, 99, 101, 115, 115, 0, 66, 97, 100, 32, 97, 100, 100, 114, 101, 115, 115, 0, 70, 105, 108, 101, 32, 116, 111, 111, 32, 108, 97, 114, 103, 101, 0, 84, 111, 111, 32, 109, 97, 110, 121, 32, 108, 105, 110, 107, 115, 0, 78, 111, 32, 108, 111, 99, 107, 115, 32, 97, 118, 97, 105, 108, 97, 98, 108, 101, 0, 82, 101, 115, 111, 117, 114, 99, 101, 32, 100, 101, 97, 100, 108, 111, 99, 107, 32, 119, 111, 117, 108, 100, 32, 111, 99, 99, 117, 114, 0, 83, 116, 97, 116, 101, 32, 110, 111, 116, 32, 114, 101, 99, 111, 118, 101, 114, 97, 98, 108, 101, 0, 80, 114, 101, 118, 105, 111, 117, 115, 32, 111, 119, 110, 101, 114, 32, 100, 105, 101, 100, 0, 79, 112, 101, 114, 97, 116, 105, 111, 110, 32, 99, 97, 110, 99, 101, 108, 101, 100, 0, 70, 117, 110, 99, 116, 105, 111, 110, 32, 110, 111, 116, 32, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 0, 78, 111, 32, 109, 101, 115, 115, 97, 103, 101, 32, 111, 102, 32, 100, 101, 115, 105, 114, 101, 100, 32, 116, 121, 112, 101, 0, 73, 100, 101, 110, 116, 105, 102, 105, 101, 114, 32, 114, 101, 109, 111, 118, 101, 100, 0, 68, 101, 118, 105, 99, 101, 32, 110, 111, 116, 32, 97, 32, 115, 116, 114, 101, 97, 109, 0, 78, 111, 32, 100, 97, 116, 97, 32, 97, 118, 97, 105, 108, 97, 98, 108, 101, 0, 68, 101, 118, 105, 99, 101, 32, 116, 105, 109, 101, 111, 117, 116, 0, 79, 117, 116, 32, 111, 102, 32, 115, 116, 114, 101, 97, 109, 115, 32, 114, 101, 115, 111, 117, 114, 99, 101, 115, 0, 76, 105, 110, 107, 32, 104, 97, 115, 32, 98, 101, 101, 110, 32, 115, 101, 118, 101, 114, 101, 100, 0, 80, 114, 111, 116, 111, 99, 111, 108, 32, 101, 114, 114, 111, 114, 0, 66, 97, 100, 32, 109, 101, 115, 115, 97, 103, 101, 0, 70, 105, 108, 101, 32, 100, 101, 115, 99, 114, 105, 112, 116, 111, 114, 32, 105, 110, 32, 98, 97, 100, 32, 115, 116, 97, 116, 101, 0, 78, 111, 116, 32, 97, 32, 115, 111, 99, 107, 101, 116, 0, 68, 101, 115, 116, 105, 110, 97, 116, 105, 111, 110, 32, 97, 100, 100, 114, 101, 115, 115, 32, 114, 101, 113, 117, 105, 114, 101, 100, 0, 77, 101, 115, 115, 97, 103, 101, 32, 116, 111, 111, 32, 108, 97, 114, 103, 101, 0, 80, 114, 111, 116, 111, 99, 111, 108, 32, 119, 114, 111, 110, 103, 32, 116, 121, 112, 101, 32, 102, 111, 114, 32, 115, 111, 99, 107, 101, 116, 0, 80, 114, 111, 116, 111, 99, 111, 108, 32, 110, 111, 116, 32, 97, 118, 97, 105, 108, 97, 98, 108, 101, 0, 80, 114, 111, 116, 111, 99, 111, 108, 32, 110, 111, 116, 32, 115, 117, 112, 112, 111, 114, 116, 101, 100, 0, 83, 111, 99, 107, 101, 116, 32, 116, 121, 112, 101, 32, 110, 111, 116, 32, 115, 117, 112, 112, 111, 114, 116, 101, 100, 0, 78, 111, 116, 32, 115, 117, 112, 112, 111, 114, 116, 101, 100, 0, 80, 114, 111, 116, 111, 99, 111, 108, 32, 102, 97, 109, 105, 108, 121, 32, 110, 111, 116, 32, 115, 117, 112, 112, 111, 114, 116, 101, 100, 0, 65, 100, 100, 114, 101, 115, 115, 32, 102, 97, 109, 105, 108, 121, 32, 110, 111, 116, 32, 115, 117, 112, 112, 111, 114, 116, 101, 100, 32, 98, 121, 32, 112, 114, 111, 116, 111, 99, 111, 108, 0, 65, 100, 100, 114, 101, 115, 115, 32, 110, 111, 116, 32, 97, 118, 97, 105, 108, 97, 98, 108, 101, 0, 78, 101, 116, 119, 111, 114, 107, 32, 105, 115, 32, 100, 111, 119, 110, 0, 78, 101, 116, 119, 111, 114, 107, 32, 117, 110, 114, 101, 97, 99, 104, 97, 98, 108, 101, 0, 67, 111, 110, 110, 101, 99, 116, 105, 111, 110, 32, 114, 101, 115, 101, 116, 32, 98, 121, 32, 110, 101, 116, 119, 111, 114, 107, 0, 67, 111, 110, 110, 101, 99, 116, 105, 111, 110, 32, 97, 98, 111, 114, 116, 101, 100, 0, 78, 111, 32, 98, 117, 102, 102, 101, 114, 32, 115, 112, 97, 99, 101, 32, 97, 118, 97, 105, 108, 97, 98, 108, 101, 0, 83, 111, 99, 107, 101, 116, 32, 105, 115, 32, 99, 111, 110, 110, 101, 99, 116, 101, 100, 0, 83, 111, 99, 107, 101, 116, 32, 110, 111, 116, 32, 99, 111, 110, 110, 101, 99, 116, 101, 100, 0, 67, 97, 110, 110, 111, 116, 32, 115, 101, 110, 100, 32, 97, 102, 116, 101, 114, 32, 115, 111, 99, 107, 101, 116, 32, 115, 104, 117, 116, 100, 111, 119, 110, 0, 79, 112, 101, 114, 97, 116, 105, 111, 110, 32, 97, 108, 114, 101, 97, 100, 121, 32, 105, 110, 32, 112, 114, 111, 103, 114, 101, 115, 115, 0, 79, 112, 101, 114, 97, 116, 105, 111, 110, 32, 105, 110, 32, 112, 114, 111, 103, 114, 101, 115, 115, 0, 83, 116, 97, 108, 101, 32, 102, 105, 108, 101, 32, 104, 97, 110, 100, 108, 101, 0, 82, 101, 109, 111, 116, 101, 32, 73, 47, 79, 32, 101, 114, 114, 111, 114, 0, 81, 117, 111, 116, 97, 32, 101, 120, 99, 101, 101, 100, 101, 100, 0, 78, 111, 32, 109, 101, 100, 105, 117, 109, 32, 102, 111, 117, 110, 100, 0, 87, 114, 111, 110, 103, 32, 109, 101, 100, 105, 117, 109, 32, 116, 121, 112, 101, 0, 78, 111, 32, 101, 114, 114, 111, 114, 32, 105, 110, 102, 111, 114, 109, 97, 116, 105, 111, 110, 0, 0], "i8", ALLOC_NONE, Runtime.GLOBAL_BASE);var tempDoublePtr = STATICTOP;STATICTOP += 16;function _atexit(func, arg) {
	    __ATEXIT__.unshift({ func: func, arg: arg });
	  }function ___cxa_atexit() {
	    return _atexit.apply(null, arguments);
	  }function _abort() {
	    Module["abort"]();
	  }function __ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj() {
	    Module["printErr"]("missing function: _ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj");abort(-1);
	  }function __decorate(decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;return c > 3 && r && Object.defineProperty(target, key, r), r;
	  }function _defineHidden(value) {
	    return function (target, key) {
	      Object.defineProperty(target, key, { configurable: false, enumerable: false, value: value, writable: true });
	    };
	  }var _nbind = {};function __nbind_free_external(num) {
	    _nbind.externalList[num].dereference(num);
	  }function __nbind_reference_external(num) {
	    _nbind.externalList[num].reference();
	  }function _llvm_stackrestore(p) {
	    var self = _llvm_stacksave;var ret = self.LLVM_SAVEDSTACKS[p];self.LLVM_SAVEDSTACKS.splice(p, 1);Runtime.stackRestore(ret);
	  }function __nbind_register_pool(pageSize, usedPtr, rootPtr, pagePtr) {
	    _nbind.Pool.pageSize = pageSize;_nbind.Pool.usedPtr = usedPtr / 4;_nbind.Pool.rootPtr = rootPtr;_nbind.Pool.pagePtr = pagePtr / 4;HEAP32[usedPtr / 4] = 16909060;if (HEAP8[usedPtr] == 1) _nbind.bigEndian = true;HEAP32[usedPtr / 4] = 0;_nbind.makeTypeKindTbl = (_a = {}, _a[1024] = _nbind.PrimitiveType, _a[64] = _nbind.Int64Type, _a[2048] = _nbind.BindClass, _a[3072] = _nbind.BindClassPtr, _a[4096] = _nbind.SharedClassPtr, _a[5120] = _nbind.ArrayType, _a[6144] = _nbind.ArrayType, _a[7168] = _nbind.CStringType, _a[9216] = _nbind.CallbackType, _a[10240] = _nbind.BindType, _a);_nbind.makeTypeNameTbl = { "Buffer": _nbind.BufferType, "External": _nbind.ExternalType, "Int64": _nbind.Int64Type, "_nbind_new": _nbind.CreateValueType, "bool": _nbind.BooleanType, "cbFunction &": _nbind.CallbackType, "const cbFunction &": _nbind.CallbackType, "const std::string &": _nbind.StringType, "std::string": _nbind.StringType };Module["toggleLightGC"] = _nbind.toggleLightGC;_nbind.callUpcast = Module["dynCall_ii"];var globalScope = _nbind.makeType(_nbind.constructType, { flags: 2048, id: 0, name: "" });globalScope.proto = Module;_nbind.BindClass.list.push(globalScope);var _a;
	  }function _emscripten_set_main_loop_timing(mode, value) {
	    Browser.mainLoop.timingMode = mode;Browser.mainLoop.timingValue = value;if (!Browser.mainLoop.func) {
	      return 1;
	    }if (mode == 0) {
	      Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_setTimeout() {
	        var timeUntilNextTick = Math.max(0, Browser.mainLoop.tickStartTime + value - _emscripten_get_now()) | 0;setTimeout(Browser.mainLoop.runner, timeUntilNextTick);
	      };Browser.mainLoop.method = "timeout";
	    } else if (mode == 1) {
	      Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_rAF() {
	        Browser.requestAnimationFrame(Browser.mainLoop.runner);
	      };Browser.mainLoop.method = "rAF";
	    } else if (mode == 2) {
	      if (!window["setImmediate"]) {
	        var setImmediates = [];var emscriptenMainLoopMessageId = "setimmediate";function Browser_setImmediate_messageHandler(event) {
	          if (event.source === window && event.data === emscriptenMainLoopMessageId) {
	            event.stopPropagation();setImmediates.shift()();
	          }
	        }window.addEventListener("message", Browser_setImmediate_messageHandler, true);window["setImmediate"] = function Browser_emulated_setImmediate(func) {
	          setImmediates.push(func);if (ENVIRONMENT_IS_WORKER) {
	            if (Module["setImmediates"] === undefined) Module["setImmediates"] = [];Module["setImmediates"].push(func);window.postMessage({ target: emscriptenMainLoopMessageId });
	          } else window.postMessage(emscriptenMainLoopMessageId, "*");
	        };
	      }Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_setImmediate() {
	        window["setImmediate"](Browser.mainLoop.runner);
	      };Browser.mainLoop.method = "immediate";
	    }return 0;
	  }function _emscripten_get_now() {
	    abort();
	  }function _emscripten_set_main_loop(func, fps, simulateInfiniteLoop, arg, noSetTiming) {
	    Module["noExitRuntime"] = true;assert(!Browser.mainLoop.func, "emscripten_set_main_loop: there can only be one main loop function at once: call emscripten_cancel_main_loop to cancel the previous one before setting a new one with different parameters.");Browser.mainLoop.func = func;Browser.mainLoop.arg = arg;var browserIterationFunc;if (typeof arg !== "undefined") {
	      browserIterationFunc = function () {
	        Module["dynCall_vi"](func, arg);
	      };
	    } else {
	      browserIterationFunc = function () {
	        Module["dynCall_v"](func);
	      };
	    }var thisMainLoopId = Browser.mainLoop.currentlyRunningMainloop;Browser.mainLoop.runner = function Browser_mainLoop_runner() {
	      if (ABORT) return;if (Browser.mainLoop.queue.length > 0) {
	        var start = Date.now();var blocker = Browser.mainLoop.queue.shift();blocker.func(blocker.arg);if (Browser.mainLoop.remainingBlockers) {
	          var remaining = Browser.mainLoop.remainingBlockers;var next = remaining % 1 == 0 ? remaining - 1 : Math.floor(remaining);if (blocker.counted) {
	            Browser.mainLoop.remainingBlockers = next;
	          } else {
	            next = next + .5;Browser.mainLoop.remainingBlockers = (8 * remaining + next) / 9;
	          }
	        }console.log('main loop blocker "' + blocker.name + '" took ' + (Date.now() - start) + " ms");Browser.mainLoop.updateStatus();if (thisMainLoopId < Browser.mainLoop.currentlyRunningMainloop) return;setTimeout(Browser.mainLoop.runner, 0);return;
	      }if (thisMainLoopId < Browser.mainLoop.currentlyRunningMainloop) return;Browser.mainLoop.currentFrameNumber = Browser.mainLoop.currentFrameNumber + 1 | 0;if (Browser.mainLoop.timingMode == 1 && Browser.mainLoop.timingValue > 1 && Browser.mainLoop.currentFrameNumber % Browser.mainLoop.timingValue != 0) {
	        Browser.mainLoop.scheduler();return;
	      } else if (Browser.mainLoop.timingMode == 0) {
	        Browser.mainLoop.tickStartTime = _emscripten_get_now();
	      }if (Browser.mainLoop.method === "timeout" && Module.ctx) {
	        Module.printErr("Looks like you are rendering without using requestAnimationFrame for the main loop. You should use 0 for the frame rate in emscripten_set_main_loop in order to use requestAnimationFrame, as that can greatly improve your frame rates!");Browser.mainLoop.method = "";
	      }Browser.mainLoop.runIter(browserIterationFunc);if (thisMainLoopId < Browser.mainLoop.currentlyRunningMainloop) return;if (typeof SDL === "object" && SDL.audio && SDL.audio.queueNewAudioData) SDL.audio.queueNewAudioData();Browser.mainLoop.scheduler();
	    };if (!noSetTiming) {
	      if (fps && fps > 0) _emscripten_set_main_loop_timing(0, 1e3 / fps);else _emscripten_set_main_loop_timing(1, 1);Browser.mainLoop.scheduler();
	    }if (simulateInfiniteLoop) {
	      throw "SimulateInfiniteLoop";
	    }
	  }var Browser = { mainLoop: { scheduler: null, method: "", currentlyRunningMainloop: 0, func: null, arg: 0, timingMode: 0, timingValue: 0, currentFrameNumber: 0, queue: [], pause: function () {
	        Browser.mainLoop.scheduler = null;Browser.mainLoop.currentlyRunningMainloop++;
	      }, resume: function () {
	        Browser.mainLoop.currentlyRunningMainloop++;var timingMode = Browser.mainLoop.timingMode;var timingValue = Browser.mainLoop.timingValue;var func = Browser.mainLoop.func;Browser.mainLoop.func = null;_emscripten_set_main_loop(func, 0, false, Browser.mainLoop.arg, true);_emscripten_set_main_loop_timing(timingMode, timingValue);Browser.mainLoop.scheduler();
	      }, updateStatus: function () {
	        if (Module["setStatus"]) {
	          var message = Module["statusMessage"] || "Please wait...";var remaining = Browser.mainLoop.remainingBlockers;var expected = Browser.mainLoop.expectedBlockers;if (remaining) {
	            if (remaining < expected) {
	              Module["setStatus"](message + " (" + (expected - remaining) + "/" + expected + ")");
	            } else {
	              Module["setStatus"](message);
	            }
	          } else {
	            Module["setStatus"]("");
	          }
	        }
	      }, runIter: function (func) {
	        if (ABORT) return;if (Module["preMainLoop"]) {
	          var preRet = Module["preMainLoop"]();if (preRet === false) {
	            return;
	          }
	        }try {
	          func();
	        } catch (e) {
	          if (e instanceof ExitStatus) {
	            return;
	          } else {
	            if (e && typeof e === "object" && e.stack) Module.printErr("exception thrown: " + [e, e.stack]);throw e;
	          }
	        }if (Module["postMainLoop"]) Module["postMainLoop"]();
	      } }, isFullscreen: false, pointerLock: false, moduleContextCreatedCallbacks: [], workers: [], init: function () {
	      if (!Module["preloadPlugins"]) Module["preloadPlugins"] = [];if (Browser.initted) return;Browser.initted = true;try {
	        new Blob();Browser.hasBlobConstructor = true;
	      } catch (e) {
	        Browser.hasBlobConstructor = false;console.log("warning: no blob constructor, cannot create blobs with mimetypes");
	      }Browser.BlobBuilder = typeof MozBlobBuilder != "undefined" ? MozBlobBuilder : typeof WebKitBlobBuilder != "undefined" ? WebKitBlobBuilder : !Browser.hasBlobConstructor ? console.log("warning: no BlobBuilder") : null;Browser.URLObject = typeof window != "undefined" ? window.URL ? window.URL : window.webkitURL : undefined;if (!Module.noImageDecoding && typeof Browser.URLObject === "undefined") {
	        console.log("warning: Browser does not support creating object URLs. Built-in browser image decoding will not be available.");Module.noImageDecoding = true;
	      }var imagePlugin = {};imagePlugin["canHandle"] = function imagePlugin_canHandle(name) {
	        return !Module.noImageDecoding && /\.(jpg|jpeg|png|bmp)$/i.test(name);
	      };imagePlugin["handle"] = function imagePlugin_handle(byteArray, name, onload, onerror) {
	        var b = null;if (Browser.hasBlobConstructor) {
	          try {
	            b = new Blob([byteArray], { type: Browser.getMimetype(name) });if (b.size !== byteArray.length) {
	              b = new Blob([new Uint8Array(byteArray).buffer], { type: Browser.getMimetype(name) });
	            }
	          } catch (e) {
	            Runtime.warnOnce("Blob constructor present but fails: " + e + "; falling back to blob builder");
	          }
	        }if (!b) {
	          var bb = new Browser.BlobBuilder();bb.append(new Uint8Array(byteArray).buffer);b = bb.getBlob();
	        }var url = Browser.URLObject.createObjectURL(b);var img = new Image();img.onload = function img_onload() {
	          assert(img.complete, "Image " + name + " could not be decoded");var canvas = document.createElement("canvas");canvas.width = img.width;canvas.height = img.height;var ctx = canvas.getContext("2d");ctx.drawImage(img, 0, 0);Module["preloadedImages"][name] = canvas;Browser.URLObject.revokeObjectURL(url);if (onload) onload(byteArray);
	        };img.onerror = function img_onerror(event) {
	          console.log("Image " + url + " could not be decoded");if (onerror) onerror();
	        };img.src = url;
	      };Module["preloadPlugins"].push(imagePlugin);var audioPlugin = {};audioPlugin["canHandle"] = function audioPlugin_canHandle(name) {
	        return !Module.noAudioDecoding && name.substr(-4) in { ".ogg": 1, ".wav": 1, ".mp3": 1 };
	      };audioPlugin["handle"] = function audioPlugin_handle(byteArray, name, onload, onerror) {
	        var done = false;function finish(audio) {
	          if (done) return;done = true;Module["preloadedAudios"][name] = audio;if (onload) onload(byteArray);
	        }function fail() {
	          if (done) return;done = true;Module["preloadedAudios"][name] = new Audio();if (onerror) onerror();
	        }if (Browser.hasBlobConstructor) {
	          try {
	            var b = new Blob([byteArray], { type: Browser.getMimetype(name) });
	          } catch (e) {
	            return fail();
	          }var url = Browser.URLObject.createObjectURL(b);var audio = new Audio();audio.addEventListener("canplaythrough", function () {
	            finish(audio);
	          }, false);audio.onerror = function audio_onerror(event) {
	            if (done) return;console.log("warning: browser could not fully decode audio " + name + ", trying slower base64 approach");function encode64(data) {
	              var BASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var PAD = "=";var ret = "";var leftchar = 0;var leftbits = 0;for (var i = 0; i < data.length; i++) {
	                leftchar = leftchar << 8 | data[i];leftbits += 8;while (leftbits >= 6) {
	                  var curr = leftchar >> leftbits - 6 & 63;leftbits -= 6;ret += BASE[curr];
	                }
	              }if (leftbits == 2) {
	                ret += BASE[(leftchar & 3) << 4];ret += PAD + PAD;
	              } else if (leftbits == 4) {
	                ret += BASE[(leftchar & 15) << 2];ret += PAD;
	              }return ret;
	            }audio.src = "data:audio/x-" + name.substr(-3) + ";base64," + encode64(byteArray);finish(audio);
	          };audio.src = url;Browser.safeSetTimeout(function () {
	            finish(audio);
	          }, 1e4);
	        } else {
	          return fail();
	        }
	      };Module["preloadPlugins"].push(audioPlugin);function pointerLockChange() {
	        Browser.pointerLock = document["pointerLockElement"] === Module["canvas"] || document["mozPointerLockElement"] === Module["canvas"] || document["webkitPointerLockElement"] === Module["canvas"] || document["msPointerLockElement"] === Module["canvas"];
	      }var canvas = Module["canvas"];if (canvas) {
	        canvas.requestPointerLock = canvas["requestPointerLock"] || canvas["mozRequestPointerLock"] || canvas["webkitRequestPointerLock"] || canvas["msRequestPointerLock"] || function () {};canvas.exitPointerLock = document["exitPointerLock"] || document["mozExitPointerLock"] || document["webkitExitPointerLock"] || document["msExitPointerLock"] || function () {};canvas.exitPointerLock = canvas.exitPointerLock.bind(document);document.addEventListener("pointerlockchange", pointerLockChange, false);document.addEventListener("mozpointerlockchange", pointerLockChange, false);document.addEventListener("webkitpointerlockchange", pointerLockChange, false);document.addEventListener("mspointerlockchange", pointerLockChange, false);if (Module["elementPointerLock"]) {
	          canvas.addEventListener("click", function (ev) {
	            if (!Browser.pointerLock && Module["canvas"].requestPointerLock) {
	              Module["canvas"].requestPointerLock();ev.preventDefault();
	            }
	          }, false);
	        }
	      }
	    }, createContext: function (canvas, useWebGL, setInModule, webGLContextAttributes) {
	      if (useWebGL && Module.ctx && canvas == Module.canvas) return Module.ctx;var ctx;var contextHandle;if (useWebGL) {
	        var contextAttributes = { antialias: false, alpha: false };if (webGLContextAttributes) {
	          for (var attribute in webGLContextAttributes) {
	            contextAttributes[attribute] = webGLContextAttributes[attribute];
	          }
	        }contextHandle = GL.createContext(canvas, contextAttributes);if (contextHandle) {
	          ctx = GL.getContext(contextHandle).GLctx;
	        }
	      } else {
	        ctx = canvas.getContext("2d");
	      }if (!ctx) return null;if (setInModule) {
	        if (!useWebGL) assert(typeof GLctx === "undefined", "cannot set in module if GLctx is used, but we are a non-GL context that would replace it");Module.ctx = ctx;if (useWebGL) GL.makeContextCurrent(contextHandle);Module.useWebGL = useWebGL;Browser.moduleContextCreatedCallbacks.forEach(function (callback) {
	          callback();
	        });Browser.init();
	      }return ctx;
	    }, destroyContext: function (canvas, useWebGL, setInModule) {}, fullscreenHandlersInstalled: false, lockPointer: undefined, resizeCanvas: undefined, requestFullscreen: function (lockPointer, resizeCanvas, vrDevice) {
	      Browser.lockPointer = lockPointer;Browser.resizeCanvas = resizeCanvas;Browser.vrDevice = vrDevice;if (typeof Browser.lockPointer === "undefined") Browser.lockPointer = true;if (typeof Browser.resizeCanvas === "undefined") Browser.resizeCanvas = false;if (typeof Browser.vrDevice === "undefined") Browser.vrDevice = null;var canvas = Module["canvas"];function fullscreenChange() {
	        Browser.isFullscreen = false;var canvasContainer = canvas.parentNode;if ((document["fullscreenElement"] || document["mozFullScreenElement"] || document["msFullscreenElement"] || document["webkitFullscreenElement"] || document["webkitCurrentFullScreenElement"]) === canvasContainer) {
	          canvas.exitFullscreen = document["exitFullscreen"] || document["cancelFullScreen"] || document["mozCancelFullScreen"] || document["msExitFullscreen"] || document["webkitCancelFullScreen"] || function () {};canvas.exitFullscreen = canvas.exitFullscreen.bind(document);if (Browser.lockPointer) canvas.requestPointerLock();Browser.isFullscreen = true;if (Browser.resizeCanvas) Browser.setFullscreenCanvasSize();
	        } else {
	          canvasContainer.parentNode.insertBefore(canvas, canvasContainer);canvasContainer.parentNode.removeChild(canvasContainer);if (Browser.resizeCanvas) Browser.setWindowedCanvasSize();
	        }if (Module["onFullScreen"]) Module["onFullScreen"](Browser.isFullscreen);if (Module["onFullscreen"]) Module["onFullscreen"](Browser.isFullscreen);Browser.updateCanvasDimensions(canvas);
	      }if (!Browser.fullscreenHandlersInstalled) {
	        Browser.fullscreenHandlersInstalled = true;document.addEventListener("fullscreenchange", fullscreenChange, false);document.addEventListener("mozfullscreenchange", fullscreenChange, false);document.addEventListener("webkitfullscreenchange", fullscreenChange, false);document.addEventListener("MSFullscreenChange", fullscreenChange, false);
	      }var canvasContainer = document.createElement("div");canvas.parentNode.insertBefore(canvasContainer, canvas);canvasContainer.appendChild(canvas);canvasContainer.requestFullscreen = canvasContainer["requestFullscreen"] || canvasContainer["mozRequestFullScreen"] || canvasContainer["msRequestFullscreen"] || (canvasContainer["webkitRequestFullscreen"] ? function () {
	        canvasContainer["webkitRequestFullscreen"](Element["ALLOW_KEYBOARD_INPUT"]);
	      } : null) || (canvasContainer["webkitRequestFullScreen"] ? function () {
	        canvasContainer["webkitRequestFullScreen"](Element["ALLOW_KEYBOARD_INPUT"]);
	      } : null);if (vrDevice) {
	        canvasContainer.requestFullscreen({ vrDisplay: vrDevice });
	      } else {
	        canvasContainer.requestFullscreen();
	      }
	    }, requestFullScreen: function (lockPointer, resizeCanvas, vrDevice) {
	      Module.printErr("Browser.requestFullScreen() is deprecated. Please call Browser.requestFullscreen instead.");Browser.requestFullScreen = function (lockPointer, resizeCanvas, vrDevice) {
	        return Browser.requestFullscreen(lockPointer, resizeCanvas, vrDevice);
	      };return Browser.requestFullscreen(lockPointer, resizeCanvas, vrDevice);
	    }, nextRAF: 0, fakeRequestAnimationFrame: function (func) {
	      var now = Date.now();if (Browser.nextRAF === 0) {
	        Browser.nextRAF = now + 1e3 / 60;
	      } else {
	        while (now + 2 >= Browser.nextRAF) {
	          Browser.nextRAF += 1e3 / 60;
	        }
	      }var delay = Math.max(Browser.nextRAF - now, 0);setTimeout(func, delay);
	    }, requestAnimationFrame: function requestAnimationFrame(func) {
	      if (typeof window === "undefined") {
	        Browser.fakeRequestAnimationFrame(func);
	      } else {
	        if (!window.requestAnimationFrame) {
	          window.requestAnimationFrame = window["requestAnimationFrame"] || window["mozRequestAnimationFrame"] || window["webkitRequestAnimationFrame"] || window["msRequestAnimationFrame"] || window["oRequestAnimationFrame"] || Browser.fakeRequestAnimationFrame;
	        }window.requestAnimationFrame(func);
	      }
	    }, safeCallback: function (func) {
	      return function () {
	        if (!ABORT) return func.apply(null, arguments);
	      };
	    }, allowAsyncCallbacks: true, queuedAsyncCallbacks: [], pauseAsyncCallbacks: function () {
	      Browser.allowAsyncCallbacks = false;
	    }, resumeAsyncCallbacks: function () {
	      Browser.allowAsyncCallbacks = true;if (Browser.queuedAsyncCallbacks.length > 0) {
	        var callbacks = Browser.queuedAsyncCallbacks;Browser.queuedAsyncCallbacks = [];callbacks.forEach(function (func) {
	          func();
	        });
	      }
	    }, safeRequestAnimationFrame: function (func) {
	      return Browser.requestAnimationFrame(function () {
	        if (ABORT) return;if (Browser.allowAsyncCallbacks) {
	          func();
	        } else {
	          Browser.queuedAsyncCallbacks.push(func);
	        }
	      });
	    }, safeSetTimeout: function (func, timeout) {
	      Module["noExitRuntime"] = true;return setTimeout(function () {
	        if (ABORT) return;if (Browser.allowAsyncCallbacks) {
	          func();
	        } else {
	          Browser.queuedAsyncCallbacks.push(func);
	        }
	      }, timeout);
	    }, safeSetInterval: function (func, timeout) {
	      Module["noExitRuntime"] = true;return setInterval(function () {
	        if (ABORT) return;if (Browser.allowAsyncCallbacks) {
	          func();
	        }
	      }, timeout);
	    }, getMimetype: function (name) {
	      return { "jpg": "image/jpeg", "jpeg": "image/jpeg", "png": "image/png", "bmp": "image/bmp", "ogg": "audio/ogg", "wav": "audio/wav", "mp3": "audio/mpeg" }[name.substr(name.lastIndexOf(".") + 1)];
	    }, getUserMedia: function (func) {
	      if (!window.getUserMedia) {
	        window.getUserMedia = navigator["getUserMedia"] || navigator["mozGetUserMedia"];
	      }window.getUserMedia(func);
	    }, getMovementX: function (event) {
	      return event["movementX"] || event["mozMovementX"] || event["webkitMovementX"] || 0;
	    }, getMovementY: function (event) {
	      return event["movementY"] || event["mozMovementY"] || event["webkitMovementY"] || 0;
	    }, getMouseWheelDelta: function (event) {
	      var delta = 0;switch (event.type) {case "DOMMouseScroll":
	          delta = event.detail;break;case "mousewheel":
	          delta = event.wheelDelta;break;case "wheel":
	          delta = event["deltaY"];break;default:
	          throw "unrecognized mouse wheel event: " + event.type;}return delta;
	    }, mouseX: 0, mouseY: 0, mouseMovementX: 0, mouseMovementY: 0, touches: {}, lastTouches: {}, calculateMouseEvent: function (event) {
	      if (Browser.pointerLock) {
	        if (event.type != "mousemove" && "mozMovementX" in event) {
	          Browser.mouseMovementX = Browser.mouseMovementY = 0;
	        } else {
	          Browser.mouseMovementX = Browser.getMovementX(event);Browser.mouseMovementY = Browser.getMovementY(event);
	        }if (typeof SDL != "undefined") {
	          Browser.mouseX = SDL.mouseX + Browser.mouseMovementX;Browser.mouseY = SDL.mouseY + Browser.mouseMovementY;
	        } else {
	          Browser.mouseX += Browser.mouseMovementX;Browser.mouseY += Browser.mouseMovementY;
	        }
	      } else {
	        var rect = Module["canvas"].getBoundingClientRect();var cw = Module["canvas"].width;var ch = Module["canvas"].height;var scrollX = typeof window.scrollX !== "undefined" ? window.scrollX : window.pageXOffset;var scrollY = typeof window.scrollY !== "undefined" ? window.scrollY : window.pageYOffset;if (event.type === "touchstart" || event.type === "touchend" || event.type === "touchmove") {
	          var touch = event.touch;if (touch === undefined) {
	            return;
	          }var adjustedX = touch.pageX - (scrollX + rect.left);var adjustedY = touch.pageY - (scrollY + rect.top);adjustedX = adjustedX * (cw / rect.width);adjustedY = adjustedY * (ch / rect.height);var coords = { x: adjustedX, y: adjustedY };if (event.type === "touchstart") {
	            Browser.lastTouches[touch.identifier] = coords;Browser.touches[touch.identifier] = coords;
	          } else if (event.type === "touchend" || event.type === "touchmove") {
	            var last = Browser.touches[touch.identifier];if (!last) last = coords;Browser.lastTouches[touch.identifier] = last;Browser.touches[touch.identifier] = coords;
	          }return;
	        }var x = event.pageX - (scrollX + rect.left);var y = event.pageY - (scrollY + rect.top);x = x * (cw / rect.width);y = y * (ch / rect.height);Browser.mouseMovementX = x - Browser.mouseX;Browser.mouseMovementY = y - Browser.mouseY;Browser.mouseX = x;Browser.mouseY = y;
	      }
	    }, asyncLoad: function (url, onload, onerror, noRunDep) {
	      var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";Module["readAsync"](url, function (arrayBuffer) {
	        assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');onload(new Uint8Array(arrayBuffer));if (dep) removeRunDependency(dep);
	      }, function (event) {
	        if (onerror) {
	          onerror();
	        } else {
	          throw 'Loading data file "' + url + '" failed.';
	        }
	      });if (dep) addRunDependency(dep);
	    }, resizeListeners: [], updateResizeListeners: function () {
	      var canvas = Module["canvas"];Browser.resizeListeners.forEach(function (listener) {
	        listener(canvas.width, canvas.height);
	      });
	    }, setCanvasSize: function (width, height, noUpdates) {
	      var canvas = Module["canvas"];Browser.updateCanvasDimensions(canvas, width, height);if (!noUpdates) Browser.updateResizeListeners();
	    }, windowedWidth: 0, windowedHeight: 0, setFullscreenCanvasSize: function () {
	      if (typeof SDL != "undefined") {
	        var flags = HEAPU32[SDL.screen + Runtime.QUANTUM_SIZE * 0 >> 2];flags = flags | 8388608;HEAP32[SDL.screen + Runtime.QUANTUM_SIZE * 0 >> 2] = flags;
	      }Browser.updateResizeListeners();
	    }, setWindowedCanvasSize: function () {
	      if (typeof SDL != "undefined") {
	        var flags = HEAPU32[SDL.screen + Runtime.QUANTUM_SIZE * 0 >> 2];flags = flags & ~8388608;HEAP32[SDL.screen + Runtime.QUANTUM_SIZE * 0 >> 2] = flags;
	      }Browser.updateResizeListeners();
	    }, updateCanvasDimensions: function (canvas, wNative, hNative) {
	      if (wNative && hNative) {
	        canvas.widthNative = wNative;canvas.heightNative = hNative;
	      } else {
	        wNative = canvas.widthNative;hNative = canvas.heightNative;
	      }var w = wNative;var h = hNative;if (Module["forcedAspectRatio"] && Module["forcedAspectRatio"] > 0) {
	        if (w / h < Module["forcedAspectRatio"]) {
	          w = Math.round(h * Module["forcedAspectRatio"]);
	        } else {
	          h = Math.round(w / Module["forcedAspectRatio"]);
	        }
	      }if ((document["fullscreenElement"] || document["mozFullScreenElement"] || document["msFullscreenElement"] || document["webkitFullscreenElement"] || document["webkitCurrentFullScreenElement"]) === canvas.parentNode && typeof screen != "undefined") {
	        var factor = Math.min(screen.width / w, screen.height / h);w = Math.round(w * factor);h = Math.round(h * factor);
	      }if (Browser.resizeCanvas) {
	        if (canvas.width != w) canvas.width = w;if (canvas.height != h) canvas.height = h;if (typeof canvas.style != "undefined") {
	          canvas.style.removeProperty("width");canvas.style.removeProperty("height");
	        }
	      } else {
	        if (canvas.width != wNative) canvas.width = wNative;if (canvas.height != hNative) canvas.height = hNative;if (typeof canvas.style != "undefined") {
	          if (w != wNative || h != hNative) {
	            canvas.style.setProperty("width", w + "px", "important");canvas.style.setProperty("height", h + "px", "important");
	          } else {
	            canvas.style.removeProperty("width");canvas.style.removeProperty("height");
	          }
	        }
	      }
	    }, wgetRequests: {}, nextWgetRequestHandle: 0, getNextWgetRequestHandle: function () {
	      var handle = Browser.nextWgetRequestHandle;Browser.nextWgetRequestHandle++;return handle;
	    } };var SYSCALLS = { varargs: 0, get: function (varargs) {
	      SYSCALLS.varargs += 4;var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];return ret;
	    }, getStr: function () {
	      var ret = Pointer_stringify(SYSCALLS.get());return ret;
	    }, get64: function () {
	      var low = SYSCALLS.get(),
	          high = SYSCALLS.get();if (low >= 0) assert(high === 0);else assert(high === -1);return low;
	    }, getZero: function () {
	      assert(SYSCALLS.get() === 0);
	    } };function ___syscall6(which, varargs) {
	    SYSCALLS.varargs = varargs;try {
	      var stream = SYSCALLS.getStreamFromFD();FS.close(stream);return 0;
	    } catch (e) {
	      if (typeof FS === "undefined" || !(e instanceof FS.ErrnoError)) abort(e);return -e.errno;
	    }
	  }function ___syscall54(which, varargs) {
	    SYSCALLS.varargs = varargs;try {
	      return 0;
	    } catch (e) {
	      if (typeof FS === "undefined" || !(e instanceof FS.ErrnoError)) abort(e);return -e.errno;
	    }
	  }function _typeModule(self) {
	    var structureList = [[0, 1, "X"], [1, 1, "const X"], [128, 1, "X *"], [256, 1, "X &"], [384, 1, "X &&"], [512, 1, "std::shared_ptr<X>"], [640, 1, "std::unique_ptr<X>"], [5120, 1, "std::vector<X>"], [6144, 2, "std::array<X, Y>"], [9216, -1, "std::function<X (Y)>"]];function applyStructure(outerName, outerFlags, innerName, innerFlags, param, flip) {
	      if (outerFlags == 1) {
	        var ref = innerFlags & 896;if (ref == 128 || ref == 256 || ref == 384) outerName = "X const";
	      }var name;if (flip) {
	        name = innerName.replace("X", outerName).replace("Y", param);
	      } else {
	        name = outerName.replace("X", innerName).replace("Y", param);
	      }return name.replace(/([*&]) (?=[*&])/g, "$1");
	    }function reportProblem(problem, id, kind, structureType, place) {
	      throw new Error(problem + " type " + kind.replace("X", id + "?") + (structureType ? " with flag " + structureType : "") + " in " + place);
	    }function getComplexType(id, constructType, getType, queryType, place, kind, prevStructure, depth) {
	      if (kind === void 0) {
	        kind = "X";
	      }if (depth === void 0) {
	        depth = 1;
	      }var result = getType(id);if (result) return result;var query = queryType(id);var structureType = query.placeholderFlag;var structure = structureList[structureType];if (prevStructure && structure) {
	        kind = applyStructure(prevStructure[2], prevStructure[0], kind, structure[0], "?", true);
	      }var problem;if (structureType == 0) problem = "Unbound";if (structureType >= 10) problem = "Corrupt";if (depth > 20) problem = "Deeply nested";if (problem) reportProblem(problem, id, kind, structureType, place || "?");var subId = query.paramList[0];var subType = getComplexType(subId, constructType, getType, queryType, place, kind, structure, depth + 1);var srcSpec;var spec = { flags: structure[0], id: id, name: "", paramList: [subType] };var argList = [];var structureParam = "?";switch (query.placeholderFlag) {case 1:
	          srcSpec = subType.spec;break;case 2:
	          if ((subType.flags & 15360) == 1024 && subType.spec.ptrSize == 1) {
	            spec.flags = 7168;break;
	          };case 3:case 6:case 5:
	          srcSpec = subType.spec;if ((subType.flags & 15360) != 2048) {}break;case 8:
	          structureParam = "" + query.paramList[1];spec.paramList.push(query.paramList[1]);break;case 9:
	          for (var _i = 0, _a = query.paramList[1]; _i < _a.length; _i++) {
	            var paramId = _a[_i];var paramType = getComplexType(paramId, constructType, getType, queryType, place, kind, structure, depth + 1);argList.push(paramType.name);spec.paramList.push(paramType);
	          }structureParam = argList.join(", ");break;default:
	          break;}spec.name = applyStructure(structure[2], structure[0], subType.name, subType.flags, structureParam);if (srcSpec) {
	        for (var _b = 0, _c = Object.keys(srcSpec); _b < _c.length; _b++) {
	          var key = _c[_b];spec[key] = spec[key] || srcSpec[key];
	        }spec.flags |= srcSpec.flags;
	      }return makeType(constructType, spec);
	    }function makeType(constructType, spec) {
	      var flags = spec.flags;var refKind = flags & 896;var kind = flags & 15360;if (!spec.name && kind == 1024) {
	        if (spec.ptrSize == 1) {
	          spec.name = (flags & 16 ? "" : (flags & 8 ? "un" : "") + "signed ") + "char";
	        } else {
	          spec.name = (flags & 8 ? "u" : "") + (flags & 32 ? "float" : "int") + (spec.ptrSize * 8 + "_t");
	        }
	      }if (spec.ptrSize == 8 && !(flags & 32)) kind = 64;if (kind == 2048) {
	        if (refKind == 512 || refKind == 640) {
	          kind = 4096;
	        } else if (refKind) kind = 3072;
	      }return constructType(kind, spec);
	    }var Type = function () {
	      function Type(spec) {
	        this.id = spec.id;this.name = spec.name;this.flags = spec.flags;this.spec = spec;
	      }Type.prototype.toString = function () {
	        return this.name;
	      };return Type;
	    }();var output = { Type: Type, getComplexType: getComplexType, makeType: makeType, structureList: structureList };self.output = output;return self.output || output;
	  }function __nbind_register_type(id, namePtr) {
	    var name = _nbind.readAsciiString(namePtr);var spec = { flags: 10240, id: id, name: name };_nbind.makeType(_nbind.constructType, spec);
	  }function __nbind_register_callback_signature(typeListPtr, typeCount) {
	    var typeList = _nbind.readTypeIdList(typeListPtr, typeCount);var num = _nbind.callbackSignatureList.length;_nbind.callbackSignatureList[num] = _nbind.makeJSCaller(typeList);return num;
	  }function __extends(Class, Parent) {
	    for (var key in Parent) if (Parent.hasOwnProperty(key)) Class[key] = Parent[key];function Base() {
	      this.constructor = Class;
	    }Base.prototype = Parent.prototype;Class.prototype = new Base();
	  }function __nbind_register_class(idListPtr, policyListPtr, superListPtr, upcastListPtr, superCount, destructorPtr, namePtr) {
	    var name = _nbind.readAsciiString(namePtr);var policyTbl = _nbind.readPolicyList(policyListPtr);var idList = HEAPU32.subarray(idListPtr / 4, idListPtr / 4 + 2);var spec = { flags: 2048 | (policyTbl["Value"] ? 2 : 0), id: idList[0], name: name };var bindClass = _nbind.makeType(_nbind.constructType, spec);bindClass.ptrType = _nbind.getComplexType(idList[1], _nbind.constructType, _nbind.getType, _nbind.queryType);bindClass.destroy = _nbind.makeMethodCaller(bindClass.ptrType, { boundID: spec.id, flags: 0, name: "destroy", num: 0, ptr: destructorPtr, title: bindClass.name + ".free", typeList: ["void", "uint32_t", "uint32_t"] });if (superCount) {
	      bindClass.superIdList = Array.prototype.slice.call(HEAPU32.subarray(superListPtr / 4, superListPtr / 4 + superCount));bindClass.upcastList = Array.prototype.slice.call(HEAPU32.subarray(upcastListPtr / 4, upcastListPtr / 4 + superCount));
	    }Module[bindClass.name] = bindClass.makeBound(policyTbl);_nbind.BindClass.list.push(bindClass);
	  }function _removeAccessorPrefix(name) {
	    var prefixMatcher = /^[Gg]et_?([A-Z]?([A-Z]?))/;return name.replace(prefixMatcher, function (match, initial, second) {
	      return second ? initial : initial.toLowerCase();
	    });
	  }function __nbind_register_function(boundID, policyListPtr, typeListPtr, typeCount, ptr, direct, signatureType, namePtr, num, flags) {
	    var bindClass = _nbind.getType(boundID);var policyTbl = _nbind.readPolicyList(policyListPtr);var typeList = _nbind.readTypeIdList(typeListPtr, typeCount);var specList;if (signatureType == 5) {
	      specList = [{ direct: ptr, name: "__nbindConstructor", ptr: 0, title: bindClass.name + " constructor", typeList: ["uint32_t"].concat(typeList.slice(1)) }, { direct: direct, name: "__nbindValueConstructor", ptr: 0, title: bindClass.name + " value constructor", typeList: ["void", "uint32_t"].concat(typeList.slice(1)) }];
	    } else {
	      var name_1 = _nbind.readAsciiString(namePtr);var title = (bindClass.name && bindClass.name + ".") + name_1;if (signatureType == 3 || signatureType == 4) {
	        name_1 = _removeAccessorPrefix(name_1);
	      }specList = [{ boundID: boundID, direct: direct, name: name_1, ptr: ptr, title: title, typeList: typeList }];
	    }for (var _i = 0, specList_1 = specList; _i < specList_1.length; _i++) {
	      var spec = specList_1[_i];spec.signatureType = signatureType;spec.policyTbl = policyTbl;spec.num = num;spec.flags = flags;bindClass.addMethod(spec);
	    }
	  }function _nbind_value(name, proto) {
	    if (!_nbind.typeNameTbl[name]) _nbind.throwError("Unknown value type " + name);Module["NBind"].bind_value(name, proto);_defineHidden(_nbind.typeNameTbl[name].proto.prototype.__nbindValueConstructor)(proto.prototype, "__nbindValueConstructor");
	  }Module["_nbind_value"] = _nbind_value;function __nbind_get_value_object(num, ptr) {
	    var obj = _nbind.popValue(num);if (!obj.fromJS) {
	      throw new Error("Object " + obj + " has no fromJS function");
	    }obj.fromJS(function () {
	      obj.__nbindValueConstructor.apply(this, Array.prototype.concat.apply([ptr], arguments));
	    });
	  }function _emscripten_memcpy_big(dest, src, num) {
	    HEAPU8.set(HEAPU8.subarray(src, src + num), dest);return dest;
	  }function __nbind_register_primitive(id, size, flags) {
	    var spec = { flags: 1024 | flags, id: id, ptrSize: size };_nbind.makeType(_nbind.constructType, spec);
	  }var cttz_i8 = allocate([8, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 6, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 7, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 6, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0], "i8", ALLOC_STATIC);function ___setErrNo(value) {
	    if (Module["___errno_location"]) HEAP32[Module["___errno_location"]() >> 2] = value;return value;
	  }function _llvm_stacksave() {
	    var self = _llvm_stacksave;if (!self.LLVM_SAVEDSTACKS) {
	      self.LLVM_SAVEDSTACKS = [];
	    }self.LLVM_SAVEDSTACKS.push(Runtime.stackSave());return self.LLVM_SAVEDSTACKS.length - 1;
	  }function ___syscall140(which, varargs) {
	    SYSCALLS.varargs = varargs;try {
	      var stream = SYSCALLS.getStreamFromFD(),
	          offset_high = SYSCALLS.get(),
	          offset_low = SYSCALLS.get(),
	          result = SYSCALLS.get(),
	          whence = SYSCALLS.get();var offset = offset_low;FS.llseek(stream, offset, whence);HEAP32[result >> 2] = stream.position;if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;return 0;
	    } catch (e) {
	      if (typeof FS === "undefined" || !(e instanceof FS.ErrnoError)) abort(e);return -e.errno;
	    }
	  }function ___syscall146(which, varargs) {
	    SYSCALLS.varargs = varargs;try {
	      var stream = SYSCALLS.get(),
	          iov = SYSCALLS.get(),
	          iovcnt = SYSCALLS.get();var ret = 0;if (!___syscall146.buffer) {
	        ___syscall146.buffers = [null, [], []];___syscall146.printChar = function (stream, curr) {
	          var buffer = ___syscall146.buffers[stream];assert(buffer);if (curr === 0 || curr === 10) {
	            (stream === 1 ? Module["print"] : Module["printErr"])(UTF8ArrayToString(buffer, 0));buffer.length = 0;
	          } else {
	            buffer.push(curr);
	          }
	        };
	      }for (var i = 0; i < iovcnt; i++) {
	        var ptr = HEAP32[iov + i * 8 >> 2];var len = HEAP32[iov + (i * 8 + 4) >> 2];for (var j = 0; j < len; j++) {
	          ___syscall146.printChar(stream, HEAPU8[ptr + j]);
	        }ret += len;
	      }return ret;
	    } catch (e) {
	      if (typeof FS === "undefined" || !(e instanceof FS.ErrnoError)) abort(e);return -e.errno;
	    }
	  }function __nbind_finish() {
	    for (var _i = 0, _a = _nbind.BindClass.list; _i < _a.length; _i++) {
	      var bindClass = _a[_i];bindClass.finish();
	    }
	  }var ___dso_handle = STATICTOP;STATICTOP += 16;(function (_nbind) {
	    var typeIdTbl = {};_nbind.typeNameTbl = {};var Pool = function () {
	      function Pool() {}Pool.lalloc = function (size) {
	        size = size + 7 & ~7;var used = HEAPU32[Pool.usedPtr];if (size > Pool.pageSize / 2 || size > Pool.pageSize - used) {
	          var NBind = _nbind.typeNameTbl["NBind"].proto;return NBind.lalloc(size);
	        } else {
	          HEAPU32[Pool.usedPtr] = used + size;return Pool.rootPtr + used;
	        }
	      };Pool.lreset = function (used, page) {
	        var topPage = HEAPU32[Pool.pagePtr];if (topPage) {
	          var NBind = _nbind.typeNameTbl["NBind"].proto;NBind.lreset(used, page);
	        } else {
	          HEAPU32[Pool.usedPtr] = used;
	        }
	      };return Pool;
	    }();_nbind.Pool = Pool;function constructType(kind, spec) {
	      var construct = kind == 10240 ? _nbind.makeTypeNameTbl[spec.name] || _nbind.BindType : _nbind.makeTypeKindTbl[kind];var bindType = new construct(spec);typeIdTbl[spec.id] = bindType;_nbind.typeNameTbl[spec.name] = bindType;return bindType;
	    }_nbind.constructType = constructType;function getType(id) {
	      return typeIdTbl[id];
	    }_nbind.getType = getType;function queryType(id) {
	      var placeholderFlag = HEAPU8[id];var paramCount = _nbind.structureList[placeholderFlag][1];id /= 4;if (paramCount < 0) {
	        ++id;paramCount = HEAPU32[id] + 1;
	      }var paramList = Array.prototype.slice.call(HEAPU32.subarray(id + 1, id + 1 + paramCount));if (placeholderFlag == 9) {
	        paramList = [paramList[0], paramList.slice(1)];
	      }return { paramList: paramList, placeholderFlag: placeholderFlag };
	    }_nbind.queryType = queryType;function getTypes(idList, place) {
	      return idList.map(function (id) {
	        return typeof id == "number" ? _nbind.getComplexType(id, constructType, getType, queryType, place) : _nbind.typeNameTbl[id];
	      });
	    }_nbind.getTypes = getTypes;function readTypeIdList(typeListPtr, typeCount) {
	      return Array.prototype.slice.call(HEAPU32, typeListPtr / 4, typeListPtr / 4 + typeCount);
	    }_nbind.readTypeIdList = readTypeIdList;function readAsciiString(ptr) {
	      var endPtr = ptr;while (HEAPU8[endPtr++]);return String.fromCharCode.apply("", HEAPU8.subarray(ptr, endPtr - 1));
	    }_nbind.readAsciiString = readAsciiString;function readPolicyList(policyListPtr) {
	      var policyTbl = {};if (policyListPtr) {
	        while (1) {
	          var namePtr = HEAPU32[policyListPtr / 4];if (!namePtr) break;policyTbl[readAsciiString(namePtr)] = true;policyListPtr += 4;
	        }
	      }return policyTbl;
	    }_nbind.readPolicyList = readPolicyList;function getDynCall(typeList, name) {
	      var mangleMap = { float32_t: "d", float64_t: "d", int64_t: "d", uint64_t: "d", "void": "v" };var signature = typeList.map(function (type) {
	        return mangleMap[type.name] || "i";
	      }).join("");var dynCall = Module["dynCall_" + signature];if (!dynCall) {
	        throw new Error("dynCall_" + signature + " not found for " + name + "(" + typeList.map(function (type) {
	          return type.name;
	        }).join(", ") + ")");
	      }return dynCall;
	    }_nbind.getDynCall = getDynCall;function addMethod(obj, name, func, arity) {
	      var overload = obj[name];if (obj.hasOwnProperty(name) && overload) {
	        if (overload.arity || overload.arity === 0) {
	          overload = _nbind.makeOverloader(overload, overload.arity);obj[name] = overload;
	        }overload.addMethod(func, arity);
	      } else {
	        func.arity = arity;obj[name] = func;
	      }
	    }_nbind.addMethod = addMethod;function throwError(message) {
	      throw new Error(message);
	    }_nbind.throwError = throwError;_nbind.bigEndian = false;_a = _typeModule(_typeModule), _nbind.Type = _a.Type, _nbind.makeType = _a.makeType, _nbind.getComplexType = _a.getComplexType, _nbind.structureList = _a.structureList;var BindType = function (_super) {
	      __extends(BindType, _super);function BindType() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;_this.heap = HEAPU32;_this.ptrSize = 4;return _this;
	      }BindType.prototype.needsWireRead = function (policyTbl) {
	        return !!this.wireRead || !!this.makeWireRead;
	      };BindType.prototype.needsWireWrite = function (policyTbl) {
	        return !!this.wireWrite || !!this.makeWireWrite;
	      };return BindType;
	    }(_nbind.Type);_nbind.BindType = BindType;var PrimitiveType = function (_super) {
	      __extends(PrimitiveType, _super);function PrimitiveType(spec) {
	        var _this = _super.call(this, spec) || this;var heapTbl = spec.flags & 32 ? { 32: HEAPF32, 64: HEAPF64 } : spec.flags & 8 ? { 8: HEAPU8, 16: HEAPU16, 32: HEAPU32 } : { 8: HEAP8, 16: HEAP16, 32: HEAP32 };_this.heap = heapTbl[spec.ptrSize * 8];_this.ptrSize = spec.ptrSize;return _this;
	      }PrimitiveType.prototype.needsWireWrite = function (policyTbl) {
	        return !!policyTbl && !!policyTbl["Strict"];
	      };PrimitiveType.prototype.makeWireWrite = function (expr, policyTbl) {
	        return policyTbl && policyTbl["Strict"] && function (arg) {
	          if (typeof arg == "number") return arg;throw new Error("Type mismatch");
	        };
	      };return PrimitiveType;
	    }(BindType);_nbind.PrimitiveType = PrimitiveType;function pushCString(str, policyTbl) {
	      if (str === null || str === undefined) {
	        if (policyTbl && policyTbl["Nullable"]) {
	          return 0;
	        } else throw new Error("Type mismatch");
	      }if (policyTbl && policyTbl["Strict"]) {
	        if (typeof str != "string") throw new Error("Type mismatch");
	      } else str = str.toString();var length = Module.lengthBytesUTF8(str) + 1;var result = _nbind.Pool.lalloc(length);Module.stringToUTF8Array(str, HEAPU8, result, length);return result;
	    }_nbind.pushCString = pushCString;function popCString(ptr) {
	      if (ptr === 0) return null;return Module.Pointer_stringify(ptr);
	    }_nbind.popCString = popCString;var CStringType = function (_super) {
	      __extends(CStringType, _super);function CStringType() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;_this.wireRead = popCString;_this.wireWrite = pushCString;_this.readResources = [_nbind.resources.pool];_this.writeResources = [_nbind.resources.pool];return _this;
	      }CStringType.prototype.makeWireWrite = function (expr, policyTbl) {
	        return function (arg) {
	          return pushCString(arg, policyTbl);
	        };
	      };return CStringType;
	    }(BindType);_nbind.CStringType = CStringType;var BooleanType = function (_super) {
	      __extends(BooleanType, _super);function BooleanType() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;_this.wireRead = function (arg) {
	          return !!arg;
	        };return _this;
	      }BooleanType.prototype.needsWireWrite = function (policyTbl) {
	        return !!policyTbl && !!policyTbl["Strict"];
	      };BooleanType.prototype.makeWireRead = function (expr) {
	        return "!!(" + expr + ")";
	      };BooleanType.prototype.makeWireWrite = function (expr, policyTbl) {
	        return policyTbl && policyTbl["Strict"] && function (arg) {
	          if (typeof arg == "boolean") return arg;throw new Error("Type mismatch");
	        } || expr;
	      };return BooleanType;
	    }(BindType);_nbind.BooleanType = BooleanType;var Wrapper = function () {
	      function Wrapper() {}Wrapper.prototype.persist = function () {
	        this.__nbindState |= 1;
	      };return Wrapper;
	    }();_nbind.Wrapper = Wrapper;function makeBound(policyTbl, bindClass) {
	      var Bound = function (_super) {
	        __extends(Bound, _super);function Bound(marker, flags, ptr, shared) {
	          var _this = _super.call(this) || this;if (!(_this instanceof Bound)) {
	            return new (Function.prototype.bind.apply(Bound, Array.prototype.concat.apply([null], arguments)))();
	          }var nbindFlags = flags;var nbindPtr = ptr;var nbindShared = shared;if (marker !== _nbind.ptrMarker) {
	            var wirePtr = _this.__nbindConstructor.apply(_this, arguments);nbindFlags = 4096 | 512;nbindShared = HEAPU32[wirePtr / 4];nbindPtr = HEAPU32[wirePtr / 4 + 1];
	          }var spec = { configurable: true, enumerable: false, value: null, writable: false };var propTbl = { "__nbindFlags": nbindFlags, "__nbindPtr": nbindPtr };if (nbindShared) {
	            propTbl["__nbindShared"] = nbindShared;_nbind.mark(_this);
	          }for (var _i = 0, _a = Object.keys(propTbl); _i < _a.length; _i++) {
	            var key = _a[_i];spec.value = propTbl[key];Object.defineProperty(_this, key, spec);
	          }_defineHidden(0)(_this, "__nbindState");return _this;
	        }Bound.prototype.free = function () {
	          bindClass.destroy.call(this, this.__nbindShared, this.__nbindFlags);this.__nbindState |= 2;disableMember(this, "__nbindShared");disableMember(this, "__nbindPtr");
	        };return Bound;
	      }(Wrapper);__decorate([_defineHidden()], Bound.prototype, "__nbindConstructor", void 0);__decorate([_defineHidden()], Bound.prototype, "__nbindValueConstructor", void 0);__decorate([_defineHidden(policyTbl)], Bound.prototype, "__nbindPolicies", void 0);return Bound;
	    }_nbind.makeBound = makeBound;function disableMember(obj, name) {
	      function die() {
	        throw new Error("Accessing deleted object");
	      }Object.defineProperty(obj, name, { configurable: false, enumerable: false, get: die, set: die });
	    }_nbind.ptrMarker = {};var BindClass = function (_super) {
	      __extends(BindClass, _super);function BindClass(spec) {
	        var _this = _super.call(this, spec) || this;_this.wireRead = function (arg) {
	          return _nbind.popValue(arg, _this.ptrType);
	        };_this.wireWrite = function (arg) {
	          return pushPointer(arg, _this.ptrType, true);
	        };_this.pendingSuperCount = 0;_this.ready = false;_this.methodTbl = {};if (spec.paramList) {
	          _this.classType = spec.paramList[0].classType;_this.proto = _this.classType.proto;
	        } else _this.classType = _this;return _this;
	      }BindClass.prototype.makeBound = function (policyTbl) {
	        var Bound = _nbind.makeBound(policyTbl, this);this.proto = Bound;this.ptrType.proto = Bound;return Bound;
	      };BindClass.prototype.addMethod = function (spec) {
	        var overloadList = this.methodTbl[spec.name] || [];overloadList.push(spec);this.methodTbl[spec.name] = overloadList;
	      };BindClass.prototype.registerMethods = function (src, staticOnly) {
	        var setter;for (var _i = 0, _a = Object.keys(src.methodTbl); _i < _a.length; _i++) {
	          var name_1 = _a[_i];var overloadList = src.methodTbl[name_1];for (var _b = 0, overloadList_1 = overloadList; _b < overloadList_1.length; _b++) {
	            var spec = overloadList_1[_b];var target = void 0;var caller = void 0;target = this.proto.prototype;if (staticOnly && spec.signatureType != 1) continue;switch (spec.signatureType) {case 1:
	                target = this.proto;case 5:
	                caller = _nbind.makeCaller(spec);_nbind.addMethod(target, spec.name, caller, spec.typeList.length - 1);break;case 4:
	                setter = _nbind.makeMethodCaller(src.ptrType, spec);break;case 3:
	                Object.defineProperty(target, spec.name, { configurable: true, enumerable: false, get: _nbind.makeMethodCaller(src.ptrType, spec), set: setter });break;case 2:
	                caller = _nbind.makeMethodCaller(src.ptrType, spec);_nbind.addMethod(target, spec.name, caller, spec.typeList.length - 1);break;default:
	                break;}
	          }
	        }
	      };BindClass.prototype.registerSuperMethods = function (src, firstSuper, visitTbl) {
	        if (visitTbl[src.name]) return;visitTbl[src.name] = true;var superNum = 0;var nextFirst;for (var _i = 0, _a = src.superIdList || []; _i < _a.length; _i++) {
	          var superId = _a[_i];var superClass = _nbind.getType(superId);if (superNum++ < firstSuper || firstSuper < 0) {
	            nextFirst = -1;
	          } else {
	            nextFirst = 0;
	          }this.registerSuperMethods(superClass, nextFirst, visitTbl);
	        }this.registerMethods(src, firstSuper < 0);
	      };BindClass.prototype.finish = function () {
	        if (this.ready) return this;this.ready = true;this.superList = (this.superIdList || []).map(function (superId) {
	          return _nbind.getType(superId).finish();
	        });var Bound = this.proto;if (this.superList.length) {
	          var Proto = function () {
	            this.constructor = Bound;
	          };Proto.prototype = this.superList[0].proto.prototype;Bound.prototype = new Proto();
	        }if (Bound != Module) Bound.prototype.__nbindType = this;this.registerSuperMethods(this, 1, {});return this;
	      };BindClass.prototype.upcastStep = function (dst, ptr) {
	        if (dst == this) return ptr;for (var i = 0; i < this.superList.length; ++i) {
	          var superPtr = this.superList[i].upcastStep(dst, _nbind.callUpcast(this.upcastList[i], ptr));if (superPtr) return superPtr;
	        }return 0;
	      };return BindClass;
	    }(_nbind.BindType);BindClass.list = [];_nbind.BindClass = BindClass;function popPointer(ptr, type) {
	      return ptr ? new type.proto(_nbind.ptrMarker, type.flags, ptr) : null;
	    }_nbind.popPointer = popPointer;function pushPointer(obj, type, tryValue) {
	      if (!(obj instanceof _nbind.Wrapper)) {
	        if (tryValue) {
	          return _nbind.pushValue(obj);
	        } else throw new Error("Type mismatch");
	      }var ptr = obj.__nbindPtr;var objType = obj.__nbindType.classType;var classType = type.classType;if (obj instanceof type.proto) {
	        while (objType != classType) {
	          ptr = _nbind.callUpcast(objType.upcastList[0], ptr);objType = objType.superList[0];
	        }
	      } else {
	        ptr = objType.upcastStep(classType, ptr);if (!ptr) throw new Error("Type mismatch");
	      }return ptr;
	    }_nbind.pushPointer = pushPointer;function pushMutablePointer(obj, type) {
	      var ptr = pushPointer(obj, type);if (obj.__nbindFlags & 1) {
	        throw new Error("Passing a const value as a non-const argument");
	      }return ptr;
	    }var BindClassPtr = function (_super) {
	      __extends(BindClassPtr, _super);function BindClassPtr(spec) {
	        var _this = _super.call(this, spec) || this;_this.classType = spec.paramList[0].classType;_this.proto = _this.classType.proto;var isConst = spec.flags & 1;var isValue = (_this.flags & 896) == 256 && spec.flags & 2;var push = isConst ? pushPointer : pushMutablePointer;var pop = isValue ? _nbind.popValue : popPointer;_this.makeWireWrite = function (expr, policyTbl) {
	          return policyTbl["Nullable"] ? function (arg) {
	            return arg ? push(arg, _this) : 0;
	          } : function (arg) {
	            return push(arg, _this);
	          };
	        };_this.wireRead = function (arg) {
	          return pop(arg, _this);
	        };_this.wireWrite = function (arg) {
	          return push(arg, _this);
	        };return _this;
	      }return BindClassPtr;
	    }(_nbind.BindType);_nbind.BindClassPtr = BindClassPtr;function popShared(ptr, type) {
	      var shared = HEAPU32[ptr / 4];var unsafe = HEAPU32[ptr / 4 + 1];return unsafe ? new type.proto(_nbind.ptrMarker, type.flags, unsafe, shared) : null;
	    }_nbind.popShared = popShared;function pushShared(obj, type) {
	      if (!(obj instanceof type.proto)) throw new Error("Type mismatch");return obj.__nbindShared;
	    }function pushMutableShared(obj, type) {
	      if (!(obj instanceof type.proto)) throw new Error("Type mismatch");if (obj.__nbindFlags & 1) {
	        throw new Error("Passing a const value as a non-const argument");
	      }return obj.__nbindShared;
	    }var SharedClassPtr = function (_super) {
	      __extends(SharedClassPtr, _super);function SharedClassPtr(spec) {
	        var _this = _super.call(this, spec) || this;_this.readResources = [_nbind.resources.pool];_this.classType = spec.paramList[0].classType;_this.proto = _this.classType.proto;var isConst = spec.flags & 1;var push = isConst ? pushShared : pushMutableShared;_this.wireRead = function (arg) {
	          return popShared(arg, _this);
	        };_this.wireWrite = function (arg) {
	          return push(arg, _this);
	        };return _this;
	      }return SharedClassPtr;
	    }(_nbind.BindType);_nbind.SharedClassPtr = SharedClassPtr;_nbind.externalList = [0];var firstFreeExternal = 0;var External = function () {
	      function External(data) {
	        this.refCount = 1;this.data = data;
	      }External.prototype.register = function () {
	        var num = firstFreeExternal;if (num) {
	          firstFreeExternal = _nbind.externalList[num];
	        } else num = _nbind.externalList.length;_nbind.externalList[num] = this;return num;
	      };External.prototype.reference = function () {
	        ++this.refCount;
	      };External.prototype.dereference = function (num) {
	        if (--this.refCount == 0) {
	          if (this.free) this.free();_nbind.externalList[num] = firstFreeExternal;firstFreeExternal = num;
	        }
	      };return External;
	    }();_nbind.External = External;function popExternal(num) {
	      var obj = _nbind.externalList[num];obj.dereference(num);return obj.data;
	    }function pushExternal(obj) {
	      var external = new External(obj);external.reference();return external.register();
	    }var ExternalType = function (_super) {
	      __extends(ExternalType, _super);function ExternalType() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;_this.wireRead = popExternal;_this.wireWrite = pushExternal;return _this;
	      }return ExternalType;
	    }(_nbind.BindType);_nbind.ExternalType = ExternalType;_nbind.callbackSignatureList = [];var CallbackType = function (_super) {
	      __extends(CallbackType, _super);function CallbackType() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;_this.wireWrite = function (func) {
	          if (typeof func != "function") _nbind.throwError("Type mismatch");return new _nbind.External(func).register();
	        };return _this;
	      }return CallbackType;
	    }(_nbind.BindType);_nbind.CallbackType = CallbackType;_nbind.valueList = [0];var firstFreeValue = 0;function pushValue(value) {
	      var num = firstFreeValue;if (num) {
	        firstFreeValue = _nbind.valueList[num];
	      } else num = _nbind.valueList.length;_nbind.valueList[num] = value;return num * 2 + 1;
	    }_nbind.pushValue = pushValue;function popValue(num, type) {
	      if (!num) _nbind.throwError("Value type JavaScript class is missing or not registered");if (num & 1) {
	        num >>= 1;var obj = _nbind.valueList[num];_nbind.valueList[num] = firstFreeValue;firstFreeValue = num;return obj;
	      } else if (type) {
	        return _nbind.popShared(num, type);
	      } else throw new Error("Invalid value slot " + num);
	    }_nbind.popValue = popValue;var valueBase = 0x10000000000000000;function push64(num) {
	      if (typeof num == "number") return num;return pushValue(num) * 4096 + valueBase;
	    }function pop64(num) {
	      if (num < valueBase) return num;return popValue((num - valueBase) / 4096);
	    }var CreateValueType = function (_super) {
	      __extends(CreateValueType, _super);function CreateValueType() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }CreateValueType.prototype.makeWireWrite = function (expr) {
	        return "(_nbind.pushValue(new " + expr + "))";
	      };return CreateValueType;
	    }(_nbind.BindType);_nbind.CreateValueType = CreateValueType;var Int64Type = function (_super) {
	      __extends(Int64Type, _super);function Int64Type() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;_this.wireWrite = push64;_this.wireRead = pop64;return _this;
	      }return Int64Type;
	    }(_nbind.BindType);_nbind.Int64Type = Int64Type;function pushArray(arr, type) {
	      if (!arr) return 0;var length = arr.length;if ((type.size || type.size === 0) && length < type.size) {
	        throw new Error("Type mismatch");
	      }var ptrSize = type.memberType.ptrSize;var result = _nbind.Pool.lalloc(4 + length * ptrSize);HEAPU32[result / 4] = length;var heap = type.memberType.heap;var ptr = (result + 4) / ptrSize;var wireWrite = type.memberType.wireWrite;var num = 0;if (wireWrite) {
	        while (num < length) {
	          heap[ptr++] = wireWrite(arr[num++]);
	        }
	      } else {
	        while (num < length) {
	          heap[ptr++] = arr[num++];
	        }
	      }return result;
	    }_nbind.pushArray = pushArray;function popArray(ptr, type) {
	      if (ptr === 0) return null;var length = HEAPU32[ptr / 4];var arr = new Array(length);var heap = type.memberType.heap;ptr = (ptr + 4) / type.memberType.ptrSize;var wireRead = type.memberType.wireRead;var num = 0;if (wireRead) {
	        while (num < length) {
	          arr[num++] = wireRead(heap[ptr++]);
	        }
	      } else {
	        while (num < length) {
	          arr[num++] = heap[ptr++];
	        }
	      }return arr;
	    }_nbind.popArray = popArray;var ArrayType = function (_super) {
	      __extends(ArrayType, _super);function ArrayType(spec) {
	        var _this = _super.call(this, spec) || this;_this.wireRead = function (arg) {
	          return popArray(arg, _this);
	        };_this.wireWrite = function (arg) {
	          return pushArray(arg, _this);
	        };_this.readResources = [_nbind.resources.pool];_this.writeResources = [_nbind.resources.pool];_this.memberType = spec.paramList[0];if (spec.paramList[1]) _this.size = spec.paramList[1];return _this;
	      }return ArrayType;
	    }(_nbind.BindType);_nbind.ArrayType = ArrayType;function pushString(str, policyTbl) {
	      if (str === null || str === undefined) {
	        if (policyTbl && policyTbl["Nullable"]) {
	          str = "";
	        } else throw new Error("Type mismatch");
	      }if (policyTbl && policyTbl["Strict"]) {
	        if (typeof str != "string") throw new Error("Type mismatch");
	      } else str = str.toString();var length = Module.lengthBytesUTF8(str);var result = _nbind.Pool.lalloc(4 + length + 1);HEAPU32[result / 4] = length;Module.stringToUTF8Array(str, HEAPU8, result + 4, length + 1);return result;
	    }_nbind.pushString = pushString;function popString(ptr) {
	      if (ptr === 0) return null;var length = HEAPU32[ptr / 4];return Module.Pointer_stringify(ptr + 4, length);
	    }_nbind.popString = popString;var StringType = function (_super) {
	      __extends(StringType, _super);function StringType() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;_this.wireRead = popString;_this.wireWrite = pushString;_this.readResources = [_nbind.resources.pool];_this.writeResources = [_nbind.resources.pool];return _this;
	      }StringType.prototype.makeWireWrite = function (expr, policyTbl) {
	        return function (arg) {
	          return pushString(arg, policyTbl);
	        };
	      };return StringType;
	    }(_nbind.BindType);_nbind.StringType = StringType;function makeArgList(argCount) {
	      return Array.apply(null, Array(argCount)).map(function (dummy, num) {
	        return "a" + (num + 1);
	      });
	    }function anyNeedsWireWrite(typeList, policyTbl) {
	      return typeList.reduce(function (result, type) {
	        return result || type.needsWireWrite(policyTbl);
	      }, false);
	    }function anyNeedsWireRead(typeList, policyTbl) {
	      return typeList.reduce(function (result, type) {
	        return result || !!type.needsWireRead(policyTbl);
	      }, false);
	    }function makeWireRead(convertParamList, policyTbl, type, expr) {
	      var paramNum = convertParamList.length;if (type.makeWireRead) {
	        return type.makeWireRead(expr, convertParamList, paramNum);
	      } else if (type.wireRead) {
	        convertParamList[paramNum] = type.wireRead;return "(convertParamList[" + paramNum + "](" + expr + "))";
	      } else return expr;
	    }function makeWireWrite(convertParamList, policyTbl, type, expr) {
	      var wireWrite;var paramNum = convertParamList.length;if (type.makeWireWrite) {
	        wireWrite = type.makeWireWrite(expr, policyTbl, convertParamList, paramNum);
	      } else wireWrite = type.wireWrite;if (wireWrite) {
	        if (typeof wireWrite == "string") {
	          return wireWrite;
	        } else {
	          convertParamList[paramNum] = wireWrite;return "(convertParamList[" + paramNum + "](" + expr + "))";
	        }
	      } else return expr;
	    }function buildCallerFunction(dynCall, ptrType, ptr, num, policyTbl, needsWireWrite, prefix, returnType, argTypeList, mask, err) {
	      var argList = makeArgList(argTypeList.length);var convertParamList = [];var callExpression = makeWireRead(convertParamList, policyTbl, returnType, "dynCall(" + [prefix].concat(argList.map(function (name, index) {
	        return makeWireWrite(convertParamList, policyTbl, argTypeList[index], name);
	      })).join(",") + ")");var resourceSet = _nbind.listResources([returnType], argTypeList);var sourceCode = "function(" + argList.join(",") + "){" + (mask ? "this.__nbindFlags&mask&&err();" : "") + resourceSet.makeOpen() + "var r=" + callExpression + ";" + resourceSet.makeClose() + "return r;" + "}";return eval("(" + sourceCode + ")");
	    }function buildJSCallerFunction(returnType, argTypeList) {
	      var argList = makeArgList(argTypeList.length);var convertParamList = [];var callExpression = makeWireWrite(convertParamList, null, returnType, "_nbind.externalList[num].data(" + argList.map(function (name, index) {
	        return makeWireRead(convertParamList, null, argTypeList[index], name);
	      }).join(",") + ")");var resourceSet = _nbind.listResources(argTypeList, [returnType]);resourceSet.remove(_nbind.resources.pool);var sourceCode = "function(" + ["dummy", "num"].concat(argList).join(",") + "){" + resourceSet.makeOpen() + "var r=" + callExpression + ";" + resourceSet.makeClose() + "return r;" + "}";return eval("(" + sourceCode + ")");
	    }_nbind.buildJSCallerFunction = buildJSCallerFunction;function makeJSCaller(idList) {
	      var argCount = idList.length - 1;var typeList = _nbind.getTypes(idList, "callback");var returnType = typeList[0];var argTypeList = typeList.slice(1);var needsWireRead = anyNeedsWireRead(argTypeList, null);var needsWireWrite = returnType.needsWireWrite(null);if (!needsWireWrite && !needsWireRead) {
	        switch (argCount) {case 0:
	            return function (dummy, num) {
	              return _nbind.externalList[num].data();
	            };case 1:
	            return function (dummy, num, a1) {
	              return _nbind.externalList[num].data(a1);
	            };case 2:
	            return function (dummy, num, a1, a2) {
	              return _nbind.externalList[num].data(a1, a2);
	            };case 3:
	            return function (dummy, num, a1, a2, a3) {
	              return _nbind.externalList[num].data(a1, a2, a3);
	            };default:
	            break;}
	      }return buildJSCallerFunction(returnType, argTypeList);
	    }_nbind.makeJSCaller = makeJSCaller;function makeMethodCaller(ptrType, spec) {
	      var argCount = spec.typeList.length - 1;var typeIdList = spec.typeList.slice(0);typeIdList.splice(1, 0, "uint32_t", spec.boundID);var typeList = _nbind.getTypes(typeIdList, spec.title);var returnType = typeList[0];var argTypeList = typeList.slice(3);var needsWireRead = returnType.needsWireRead(spec.policyTbl);var needsWireWrite = anyNeedsWireWrite(argTypeList, spec.policyTbl);var ptr = spec.ptr;var num = spec.num;var dynCall = _nbind.getDynCall(typeList, spec.title);var mask = ~spec.flags & 1;function err() {
	        throw new Error("Calling a non-const method on a const object");
	      }if (!needsWireRead && !needsWireWrite) {
	        switch (argCount) {case 0:
	            return function () {
	              return this.__nbindFlags & mask ? err() : dynCall(ptr, num, _nbind.pushPointer(this, ptrType));
	            };case 1:
	            return function (a1) {
	              return this.__nbindFlags & mask ? err() : dynCall(ptr, num, _nbind.pushPointer(this, ptrType), a1);
	            };case 2:
	            return function (a1, a2) {
	              return this.__nbindFlags & mask ? err() : dynCall(ptr, num, _nbind.pushPointer(this, ptrType), a1, a2);
	            };case 3:
	            return function (a1, a2, a3) {
	              return this.__nbindFlags & mask ? err() : dynCall(ptr, num, _nbind.pushPointer(this, ptrType), a1, a2, a3);
	            };default:
	            break;}
	      }return buildCallerFunction(dynCall, ptrType, ptr, num, spec.policyTbl, needsWireWrite, "ptr,num,pushPointer(this,ptrType)", returnType, argTypeList, mask, err);
	    }_nbind.makeMethodCaller = makeMethodCaller;function makeCaller(spec) {
	      var argCount = spec.typeList.length - 1;var typeList = _nbind.getTypes(spec.typeList, spec.title);var returnType = typeList[0];var argTypeList = typeList.slice(1);var needsWireRead = returnType.needsWireRead(spec.policyTbl);var needsWireWrite = anyNeedsWireWrite(argTypeList, spec.policyTbl);var direct = spec.direct;var ptr = spec.ptr;if (spec.direct && !needsWireRead && !needsWireWrite) {
	        var dynCall_1 = _nbind.getDynCall(typeList, spec.title);switch (argCount) {case 0:
	            return function () {
	              return dynCall_1(direct);
	            };case 1:
	            return function (a1) {
	              return dynCall_1(direct, a1);
	            };case 2:
	            return function (a1, a2) {
	              return dynCall_1(direct, a1, a2);
	            };case 3:
	            return function (a1, a2, a3) {
	              return dynCall_1(direct, a1, a2, a3);
	            };default:
	            break;}ptr = 0;
	      }var prefix;if (ptr) {
	        var typeIdList = spec.typeList.slice(0);typeIdList.splice(1, 0, "uint32_t");typeList = _nbind.getTypes(typeIdList, spec.title);prefix = "ptr,num";
	      } else {
	        ptr = direct;prefix = "ptr";
	      }var dynCall = _nbind.getDynCall(typeList, spec.title);return buildCallerFunction(dynCall, null, ptr, spec.num, spec.policyTbl, needsWireWrite, prefix, returnType, argTypeList);
	    }_nbind.makeCaller = makeCaller;function makeOverloader(func, arity) {
	      var callerList = [];function call() {
	        return callerList[arguments.length].apply(this, arguments);
	      }call.addMethod = function (_func, _arity) {
	        callerList[_arity] = _func;
	      };call.addMethod(func, arity);return call;
	    }_nbind.makeOverloader = makeOverloader;var Resource = function () {
	      function Resource(open, close) {
	        var _this = this;this.makeOpen = function () {
	          return Object.keys(_this.openTbl).join("");
	        };this.makeClose = function () {
	          return Object.keys(_this.closeTbl).join("");
	        };this.openTbl = {};this.closeTbl = {};if (open) this.openTbl[open] = true;if (close) this.closeTbl[close] = true;
	      }Resource.prototype.add = function (other) {
	        for (var _i = 0, _a = Object.keys(other.openTbl); _i < _a.length; _i++) {
	          var key = _a[_i];this.openTbl[key] = true;
	        }for (var _b = 0, _c = Object.keys(other.closeTbl); _b < _c.length; _b++) {
	          var key = _c[_b];this.closeTbl[key] = true;
	        }
	      };Resource.prototype.remove = function (other) {
	        for (var _i = 0, _a = Object.keys(other.openTbl); _i < _a.length; _i++) {
	          var key = _a[_i];delete this.openTbl[key];
	        }for (var _b = 0, _c = Object.keys(other.closeTbl); _b < _c.length; _b++) {
	          var key = _c[_b];delete this.closeTbl[key];
	        }
	      };return Resource;
	    }();_nbind.Resource = Resource;function listResources(readList, writeList) {
	      var result = new Resource();for (var _i = 0, readList_1 = readList; _i < readList_1.length; _i++) {
	        var bindType = readList_1[_i];for (var _a = 0, _b = bindType.readResources || []; _a < _b.length; _a++) {
	          var resource = _b[_a];result.add(resource);
	        }
	      }for (var _c = 0, writeList_1 = writeList; _c < writeList_1.length; _c++) {
	        var bindType = writeList_1[_c];for (var _d = 0, _e = bindType.writeResources || []; _d < _e.length; _d++) {
	          var resource = _e[_d];result.add(resource);
	        }
	      }return result;
	    }_nbind.listResources = listResources;_nbind.resources = { pool: new Resource("var used=HEAPU32[_nbind.Pool.usedPtr],page=HEAPU32[_nbind.Pool.pagePtr];", "_nbind.Pool.lreset(used,page);") };var ExternalBuffer = function (_super) {
	      __extends(ExternalBuffer, _super);function ExternalBuffer(buf, ptr) {
	        var _this = _super.call(this, buf) || this;_this.ptr = ptr;return _this;
	      }ExternalBuffer.prototype.free = function () {
	        _free(this.ptr);
	      };return ExternalBuffer;
	    }(_nbind.External);function getBuffer(buf) {
	      if (buf instanceof ArrayBuffer) {
	        return new Uint8Array(buf);
	      } else if (buf instanceof DataView) {
	        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
	      } else return buf;
	    }function pushBuffer(buf, policyTbl) {
	      if (buf === null || buf === undefined) {
	        if (policyTbl && policyTbl["Nullable"]) buf = [];
	      }if (typeof buf != "object") throw new Error("Type mismatch");var b = buf;var length = b.byteLength || b.length;if (!length && length !== 0 && b.byteLength !== 0) throw new Error("Type mismatch");var result = _nbind.Pool.lalloc(8);var data = _malloc(length);var ptr = result / 4;HEAPU32[ptr++] = length;HEAPU32[ptr++] = data;HEAPU32[ptr++] = new ExternalBuffer(buf, data).register();HEAPU8.set(getBuffer(buf), data);return result;
	    }var BufferType = function (_super) {
	      __extends(BufferType, _super);function BufferType() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;_this.wireWrite = pushBuffer;_this.readResources = [_nbind.resources.pool];_this.writeResources = [_nbind.resources.pool];return _this;
	      }BufferType.prototype.makeWireWrite = function (expr, policyTbl) {
	        return function (arg) {
	          return pushBuffer(arg, policyTbl);
	        };
	      };return BufferType;
	    }(_nbind.BindType);_nbind.BufferType = BufferType;function commitBuffer(num, data, length) {
	      var buf = _nbind.externalList[num].data;var NodeBuffer = Buffer;if (typeof Buffer != "function") NodeBuffer = function () {};if (buf instanceof Array) {} else {
	        var src = HEAPU8.subarray(data, data + length);if (buf instanceof NodeBuffer) {
	          var srcBuf = void 0;if (typeof Buffer.from == "function" && Buffer.from.length >= 3) {
	            srcBuf = Buffer.from(src);
	          } else srcBuf = new Buffer(src);srcBuf.copy(buf);
	        } else getBuffer(buf).set(src);
	      }
	    }_nbind.commitBuffer = commitBuffer;var dirtyList = [];var gcTimer = 0;function sweep() {
	      for (var _i = 0, dirtyList_1 = dirtyList; _i < dirtyList_1.length; _i++) {
	        var obj = dirtyList_1[_i];if (!(obj.__nbindState & (1 | 2))) {
	          obj.free();
	        }
	      }dirtyList = [];gcTimer = 0;
	    }_nbind.mark = function (obj) {};function toggleLightGC(enable) {
	      if (enable) {
	        _nbind.mark = function (obj) {
	          dirtyList.push(obj);if (!gcTimer) gcTimer = setTimeout(sweep, 0);
	        };
	      } else {
	        _nbind.mark = function (obj) {};
	      }
	    }_nbind.toggleLightGC = toggleLightGC;
	  })(_nbind);Module["requestFullScreen"] = function Module_requestFullScreen(lockPointer, resizeCanvas, vrDevice) {
	    Module.printErr("Module.requestFullScreen is deprecated. Please call Module.requestFullscreen instead.");Module["requestFullScreen"] = Module["requestFullscreen"];Browser.requestFullScreen(lockPointer, resizeCanvas, vrDevice);
	  };Module["requestFullscreen"] = function Module_requestFullscreen(lockPointer, resizeCanvas, vrDevice) {
	    Browser.requestFullscreen(lockPointer, resizeCanvas, vrDevice);
	  };Module["requestAnimationFrame"] = function Module_requestAnimationFrame(func) {
	    Browser.requestAnimationFrame(func);
	  };Module["setCanvasSize"] = function Module_setCanvasSize(width, height, noUpdates) {
	    Browser.setCanvasSize(width, height, noUpdates);
	  };Module["pauseMainLoop"] = function Module_pauseMainLoop() {
	    Browser.mainLoop.pause();
	  };Module["resumeMainLoop"] = function Module_resumeMainLoop() {
	    Browser.mainLoop.resume();
	  };Module["getUserMedia"] = function Module_getUserMedia() {
	    Browser.getUserMedia();
	  };Module["createContext"] = function Module_createContext(canvas, useWebGL, setInModule, webGLContextAttributes) {
	    return Browser.createContext(canvas, useWebGL, setInModule, webGLContextAttributes);
	  };if (ENVIRONMENT_IS_NODE) {
	    _emscripten_get_now = function _emscripten_get_now_actual() {
	      var t = process["hrtime"]();return t[0] * 1e3 + t[1] / 1e6;
	    };
	  } else if (typeof dateNow !== "undefined") {
	    _emscripten_get_now = dateNow;
	  } else if (typeof self === "object" && self["performance"] && typeof self["performance"]["now"] === "function") {
	    _emscripten_get_now = function () {
	      return self["performance"]["now"]();
	    };
	  } else if (typeof performance === "object" && typeof performance["now"] === "function") {
	    _emscripten_get_now = function () {
	      return performance["now"]();
	    };
	  } else {
	    _emscripten_get_now = Date.now;
	  }__ATEXIT__.push(function () {
	    var fflush = Module["_fflush"];if (fflush) fflush(0);var printChar = ___syscall146.printChar;if (!printChar) return;var buffers = ___syscall146.buffers;if (buffers[1].length) printChar(1, 10);if (buffers[2].length) printChar(2, 10);
	  });DYNAMICTOP_PTR = allocate(1, "i32", ALLOC_STATIC);STACK_BASE = STACKTOP = Runtime.alignMemory(STATICTOP);STACK_MAX = STACK_BASE + TOTAL_STACK;DYNAMIC_BASE = Runtime.alignMemory(STACK_MAX);HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE;staticSealed = true;function invoke_viiiii(index, a1, a2, a3, a4, a5) {
	    try {
	      Module["dynCall_viiiii"](index, a1, a2, a3, a4, a5);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_vif(index, a1, a2) {
	    try {
	      Module["dynCall_vif"](index, a1, a2);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_vid(index, a1, a2) {
	    try {
	      Module["dynCall_vid"](index, a1, a2);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_fiff(index, a1, a2, a3) {
	    try {
	      return Module["dynCall_fiff"](index, a1, a2, a3);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_vi(index, a1) {
	    try {
	      Module["dynCall_vi"](index, a1);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_vii(index, a1, a2) {
	    try {
	      Module["dynCall_vii"](index, a1, a2);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_ii(index, a1) {
	    try {
	      return Module["dynCall_ii"](index, a1);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_viddi(index, a1, a2, a3, a4) {
	    try {
	      Module["dynCall_viddi"](index, a1, a2, a3, a4);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_vidd(index, a1, a2, a3) {
	    try {
	      Module["dynCall_vidd"](index, a1, a2, a3);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_iiii(index, a1, a2, a3) {
	    try {
	      return Module["dynCall_iiii"](index, a1, a2, a3);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_diii(index, a1, a2, a3) {
	    try {
	      return Module["dynCall_diii"](index, a1, a2, a3);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_di(index, a1) {
	    try {
	      return Module["dynCall_di"](index, a1);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_iid(index, a1, a2) {
	    try {
	      return Module["dynCall_iid"](index, a1, a2);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_iii(index, a1, a2) {
	    try {
	      return Module["dynCall_iii"](index, a1, a2);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_viiddi(index, a1, a2, a3, a4, a5) {
	    try {
	      Module["dynCall_viiddi"](index, a1, a2, a3, a4, a5);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_viiiiii(index, a1, a2, a3, a4, a5, a6) {
	    try {
	      Module["dynCall_viiiiii"](index, a1, a2, a3, a4, a5, a6);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_dii(index, a1, a2) {
	    try {
	      return Module["dynCall_dii"](index, a1, a2);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_i(index) {
	    try {
	      return Module["dynCall_i"](index);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_iiiiii(index, a1, a2, a3, a4, a5) {
	    try {
	      return Module["dynCall_iiiiii"](index, a1, a2, a3, a4, a5);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_viiid(index, a1, a2, a3, a4) {
	    try {
	      Module["dynCall_viiid"](index, a1, a2, a3, a4);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_viififi(index, a1, a2, a3, a4, a5, a6) {
	    try {
	      Module["dynCall_viififi"](index, a1, a2, a3, a4, a5, a6);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_viii(index, a1, a2, a3) {
	    try {
	      Module["dynCall_viii"](index, a1, a2, a3);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_v(index) {
	    try {
	      Module["dynCall_v"](index);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_viid(index, a1, a2, a3) {
	    try {
	      Module["dynCall_viid"](index, a1, a2, a3);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_idd(index, a1, a2) {
	    try {
	      return Module["dynCall_idd"](index, a1, a2);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }function invoke_viiii(index, a1, a2, a3, a4) {
	    try {
	      Module["dynCall_viiii"](index, a1, a2, a3, a4);
	    } catch (e) {
	      if (typeof e !== "number" && e !== "longjmp") throw e;Module["setThrew"](1, 0);
	    }
	  }Module.asmGlobalArg = { "Math": Math, "Int8Array": Int8Array, "Int16Array": Int16Array, "Int32Array": Int32Array, "Uint8Array": Uint8Array, "Uint16Array": Uint16Array, "Uint32Array": Uint32Array, "Float32Array": Float32Array, "Float64Array": Float64Array, "NaN": NaN, "Infinity": Infinity };Module.asmLibraryArg = { "abort": abort, "assert": assert, "enlargeMemory": enlargeMemory, "getTotalMemory": getTotalMemory, "abortOnCannotGrowMemory": abortOnCannotGrowMemory, "invoke_viiiii": invoke_viiiii, "invoke_vif": invoke_vif, "invoke_vid": invoke_vid, "invoke_fiff": invoke_fiff, "invoke_vi": invoke_vi, "invoke_vii": invoke_vii, "invoke_ii": invoke_ii, "invoke_viddi": invoke_viddi, "invoke_vidd": invoke_vidd, "invoke_iiii": invoke_iiii, "invoke_diii": invoke_diii, "invoke_di": invoke_di, "invoke_iid": invoke_iid, "invoke_iii": invoke_iii, "invoke_viiddi": invoke_viiddi, "invoke_viiiiii": invoke_viiiiii, "invoke_dii": invoke_dii, "invoke_i": invoke_i, "invoke_iiiiii": invoke_iiiiii, "invoke_viiid": invoke_viiid, "invoke_viififi": invoke_viififi, "invoke_viii": invoke_viii, "invoke_v": invoke_v, "invoke_viid": invoke_viid, "invoke_idd": invoke_idd, "invoke_viiii": invoke_viiii, "_emscripten_asm_const_iiiii": _emscripten_asm_const_iiiii, "_emscripten_asm_const_iiidddddd": _emscripten_asm_const_iiidddddd, "_emscripten_asm_const_iiiid": _emscripten_asm_const_iiiid, "__nbind_reference_external": __nbind_reference_external, "_emscripten_asm_const_iiiiiiii": _emscripten_asm_const_iiiiiiii, "_removeAccessorPrefix": _removeAccessorPrefix, "_typeModule": _typeModule, "__nbind_register_pool": __nbind_register_pool, "__decorate": __decorate, "_llvm_stackrestore": _llvm_stackrestore, "___cxa_atexit": ___cxa_atexit, "__extends": __extends, "__nbind_get_value_object": __nbind_get_value_object, "__ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj": __ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj, "_emscripten_set_main_loop_timing": _emscripten_set_main_loop_timing, "__nbind_register_primitive": __nbind_register_primitive, "__nbind_register_type": __nbind_register_type, "_emscripten_memcpy_big": _emscripten_memcpy_big, "__nbind_register_function": __nbind_register_function, "___setErrNo": ___setErrNo, "__nbind_register_class": __nbind_register_class, "__nbind_finish": __nbind_finish, "_abort": _abort, "_nbind_value": _nbind_value, "_llvm_stacksave": _llvm_stacksave, "___syscall54": ___syscall54, "_defineHidden": _defineHidden, "_emscripten_set_main_loop": _emscripten_set_main_loop, "_emscripten_get_now": _emscripten_get_now, "__nbind_register_callback_signature": __nbind_register_callback_signature, "_emscripten_asm_const_iiiiii": _emscripten_asm_const_iiiiii, "__nbind_free_external": __nbind_free_external, "_emscripten_asm_const_iiii": _emscripten_asm_const_iiii, "_emscripten_asm_const_iiididi": _emscripten_asm_const_iiididi, "___syscall6": ___syscall6, "_atexit": _atexit, "___syscall140": ___syscall140, "___syscall146": ___syscall146, "DYNAMICTOP_PTR": DYNAMICTOP_PTR, "tempDoublePtr": tempDoublePtr, "ABORT": ABORT, "STACKTOP": STACKTOP, "STACK_MAX": STACK_MAX, "cttz_i8": cttz_i8, "___dso_handle": ___dso_handle }; // EMSCRIPTEN_START_ASM
	  var asm = function (global, env, buffer) {
	    "use asm";
	    var a = new global.Int8Array(buffer);var b = new global.Int16Array(buffer);var c = new global.Int32Array(buffer);var d = new global.Uint8Array(buffer);var e = new global.Uint16Array(buffer);var f = new global.Uint32Array(buffer);var g = new global.Float32Array(buffer);var h = new global.Float64Array(buffer);var i = env.DYNAMICTOP_PTR | 0;var j = env.tempDoublePtr | 0;var k = env.ABORT | 0;var l = env.STACKTOP | 0;var m = env.STACK_MAX | 0;var n = env.cttz_i8 | 0;var o = env.___dso_handle | 0;var p = 0;var q = 0;var r = 0;var s = 0;var t = global.NaN,
	        u = global.Infinity;var v = 0,
	        w = 0,
	        x = 0,
	        y = 0,
	        z = 0.0;var A = 0;var B = global.Math.floor;var C = global.Math.abs;var D = global.Math.sqrt;var E = global.Math.pow;var F = global.Math.cos;var G = global.Math.sin;var H = global.Math.tan;var I = global.Math.acos;var J = global.Math.asin;var K = global.Math.atan;var L = global.Math.atan2;var M = global.Math.exp;var N = global.Math.log;var O = global.Math.ceil;var P = global.Math.imul;var Q = global.Math.min;var R = global.Math.max;var S = global.Math.clz32;var T = global.Math.fround;var U = env.abort;var V = env.assert;var W = env.enlargeMemory;var X = env.getTotalMemory;var Y = env.abortOnCannotGrowMemory;var Z = env.invoke_viiiii;var _ = env.invoke_vif;var $ = env.invoke_vid;var aa = env.invoke_fiff;var ba = env.invoke_vi;var ca = env.invoke_vii;var da = env.invoke_ii;var ea = env.invoke_viddi;var fa = env.invoke_vidd;var ga = env.invoke_iiii;var ha = env.invoke_diii;var ia = env.invoke_di;var ja = env.invoke_iid;var ka = env.invoke_iii;var la = env.invoke_viiddi;var ma = env.invoke_viiiiii;var na = env.invoke_dii;var oa = env.invoke_i;var pa = env.invoke_iiiiii;var qa = env.invoke_viiid;var ra = env.invoke_viififi;var sa = env.invoke_viii;var ta = env.invoke_v;var ua = env.invoke_viid;var va = env.invoke_idd;var wa = env.invoke_viiii;var xa = env._emscripten_asm_const_iiiii;var ya = env._emscripten_asm_const_iiidddddd;var za = env._emscripten_asm_const_iiiid;var Aa = env.__nbind_reference_external;var Ba = env._emscripten_asm_const_iiiiiiii;var Ca = env._removeAccessorPrefix;var Da = env._typeModule;var Ea = env.__nbind_register_pool;var Fa = env.__decorate;var Ga = env._llvm_stackrestore;var Ha = env.___cxa_atexit;var Ia = env.__extends;var Ja = env.__nbind_get_value_object;var Ka = env.__ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj;var La = env._emscripten_set_main_loop_timing;var Ma = env.__nbind_register_primitive;var Na = env.__nbind_register_type;var Oa = env._emscripten_memcpy_big;var Pa = env.__nbind_register_function;var Qa = env.___setErrNo;var Ra = env.__nbind_register_class;var Sa = env.__nbind_finish;var Ta = env._abort;var Ua = env._nbind_value;var Va = env._llvm_stacksave;var Wa = env.___syscall54;var Xa = env._defineHidden;var Ya = env._emscripten_set_main_loop;var Za = env._emscripten_get_now;var _a = env.__nbind_register_callback_signature;var $a = env._emscripten_asm_const_iiiiii;var ab = env.__nbind_free_external;var bb = env._emscripten_asm_const_iiii;var cb = env._emscripten_asm_const_iiididi;var db = env.___syscall6;var eb = env._atexit;var fb = env.___syscall140;var gb = env.___syscall146;var hb = T(0);const ib = T(0);
	    // EMSCRIPTEN_START_FUNCS
	    function Jb(a) {
	      a = a | 0;var b = 0;b = l;l = l + a | 0;l = l + 15 & -16;return b | 0;
	    }function Kb() {
	      return l | 0;
	    }function Lb(a) {
	      a = a | 0;l = a;
	    }function Mb(a, b) {
	      a = a | 0;b = b | 0;l = a;m = b;
	    }function Nb(a, b) {
	      a = a | 0;b = b | 0;if (!p) {
	        p = a;q = b;
	      }
	    }function Ob(a) {
	      a = a | 0;A = a;
	    }function Pb() {
	      return A | 0;
	    }function Qb() {
	      var b = 0,
	          d = 0;BC(8104, 8, 400) | 0;BC(8504, 408, 540) | 0;b = 9044;d = b + 44 | 0;do {
	        c[b >> 2] = 0;b = b + 4 | 0;
	      } while ((b | 0) < (d | 0));a[9088] = 0;a[9089] = 1;c[2273] = 0;c[2274] = 948;c[2275] = 948;Ha(17, 8104, o | 0) | 0;return;
	    }function Rb(a) {
	      a = a | 0;oc(a + 948 | 0);return;
	    }function Sb(a) {
	      a = T(a);return ((af(a) | 0) & 2147483647) >>> 0 > 2139095040 | 0;
	    }function Tb(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;a: do if (!(c[a + (b << 3) + 4 >> 2] | 0)) {
	        if ((b | 2 | 0) == 3 ? c[a + 60 >> 2] | 0 : 0) {
	          a = a + 56 | 0;break;
	        }switch (b | 0) {case 0:case 2:case 4:case 5:
	            {
	              if (c[a + 52 >> 2] | 0) {
	                a = a + 48 | 0;break a;
	              }break;
	            }default:
	            {}}if (!(c[a + 68 >> 2] | 0)) {
	          a = (b | 1 | 0) == 5 ? 948 : d;break;
	        } else {
	          a = a + 64 | 0;break;
	        }
	      } else a = a + (b << 3) | 0; while (0);return a | 0;
	    }function Ub(b) {
	      b = b | 0;var d = 0;d = oB(1e3) | 0;Vb(b, (d | 0) != 0, 2456);c[2276] = (c[2276] | 0) + 1;BC(d | 0, 8104, 1e3) | 0;if (a[b + 2 >> 0] | 0) {
	        c[d + 4 >> 2] = 2;c[d + 12 >> 2] = 4;
	      }c[d + 976 >> 2] = b;return d | 0;
	    }function Vb(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0;f = l;l = l + 16 | 0;e = f;if (!b) {
	        c[e >> 2] = d;fe(a, 5, 3197, e);
	      }l = f;return;
	    }function Wb() {
	      return Ub(956) | 0;
	    }function Xb(a) {
	      a = a | 0;var b = 0;b = qC(1e3) | 0;Yb(b, a);Vb(c[a + 976 >> 2] | 0, 1, 2456);c[2276] = (c[2276] | 0) + 1;c[b + 944 >> 2] = 0;return b | 0;
	    }function Yb(a, b) {
	      a = a | 0;b = b | 0;var d = 0;BC(a | 0, b | 0, 948) | 0;ie(a + 948 | 0, b + 948 | 0);d = a + 960 | 0;a = b + 960 | 0;b = d + 40 | 0;do {
	        c[d >> 2] = c[a >> 2];d = d + 4 | 0;a = a + 4 | 0;
	      } while ((d | 0) < (b | 0));return;
	    }function Zb(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0;b = a + 944 | 0;d = c[b >> 2] | 0;if (d | 0) {
	        _b(d + 948 | 0, a) | 0;c[b >> 2] = 0;
	      }d = $b(a) | 0;if (d | 0) {
	        b = 0;do {
	          c[(ac(a, b) | 0) + 944 >> 2] = 0;b = b + 1 | 0;
	        } while ((b | 0) != (d | 0));
	      }d = a + 948 | 0;e = c[d >> 2] | 0;f = a + 952 | 0;b = c[f >> 2] | 0;if ((b | 0) != (e | 0)) c[f >> 2] = b + (~((b + -4 - e | 0) >>> 2) << 2);bc(d);pB(a);c[2276] = (c[2276] | 0) + -1;return;
	    }function _b(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = c[a >> 2] | 0;i = a + 4 | 0;d = c[i >> 2] | 0;g = d;a: do if ((e | 0) == (d | 0)) {
	        f = e;h = 4;
	      } else {
	        a = e;while (1) {
	          if ((c[a >> 2] | 0) == (b | 0)) {
	            f = a;h = 4;break a;
	          }a = a + 4 | 0;if ((a | 0) == (d | 0)) {
	            a = 0;break;
	          }
	        }
	      } while (0);if ((h | 0) == 4) if ((f | 0) != (d | 0)) {
	        e = f + 4 | 0;a = g - e | 0;b = a >> 2;if (b) {
	          GC(f | 0, e | 0, a | 0) | 0;d = c[i >> 2] | 0;
	        }a = f + (b << 2) | 0;if ((d | 0) == (a | 0)) a = 1;else {
	          c[i >> 2] = d + (~((d + -4 - a | 0) >>> 2) << 2);a = 1;
	        }
	      } else a = 0;return a | 0;
	    }function $b(a) {
	      a = a | 0;return (c[a + 952 >> 2] | 0) - (c[a + 948 >> 2] | 0) >> 2 | 0;
	    }function ac(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = c[a + 948 >> 2] | 0;if ((c[a + 952 >> 2] | 0) - d >> 2 >>> 0 > b >>> 0) a = c[d + (b << 2) >> 2] | 0;else a = 0;return a | 0;
	    }function bc(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0;e = l;l = l + 32 | 0;b = e;f = c[a >> 2] | 0;d = (c[a + 4 >> 2] | 0) - f | 0;if (((c[a + 8 >> 2] | 0) - f | 0) >>> 0 > d >>> 0) {
	        f = d >> 2;bf(b, f, f, a + 8 | 0);cf(a, b);df(b);
	      }l = e;return;
	    }function cc(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0;k = $b(a) | 0;do if (k | 0) {
	        if ((c[(ac(a, 0) | 0) + 944 >> 2] | 0) == (a | 0)) {
	          if (!(_b(a + 948 | 0, b) | 0)) break;BC(b + 400 | 0, 8504, 540) | 0;c[b + 944 >> 2] = 0;nc(a);break;
	        }h = c[(c[a + 976 >> 2] | 0) + 12 >> 2] | 0;i = a + 948 | 0;j = (h | 0) == 0;d = 0;g = 0;do {
	          e = c[(c[i >> 2] | 0) + (g << 2) >> 2] | 0;if ((e | 0) == (b | 0)) nc(a);else {
	            f = Xb(e) | 0;c[(c[i >> 2] | 0) + (d << 2) >> 2] = f;c[f + 944 >> 2] = a;if (!j) Ib[h & 15](e, f, a, d);d = d + 1 | 0;
	          }g = g + 1 | 0;
	        } while ((g | 0) != (k | 0));if (d >>> 0 < k >>> 0) {
	          j = a + 948 | 0;i = a + 952 | 0;h = d;d = c[i >> 2] | 0;do {
	            g = (c[j >> 2] | 0) + (h << 2) | 0;e = g + 4 | 0;f = d - e | 0;b = f >> 2;if (!b) f = d;else {
	              GC(g | 0, e | 0, f | 0) | 0;d = c[i >> 2] | 0;f = d;
	            }e = g + (b << 2) | 0;if ((f | 0) != (e | 0)) {
	              d = f + (~((f + -4 - e | 0) >>> 2) << 2) | 0;c[i >> 2] = d;
	            }h = h + 1 | 0;
	          } while ((h | 0) != (k | 0));
	        }
	      } while (0);return;
	    }function dc(b) {
	      b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0;ec(b, ($b(b) | 0) == 0, 2491);ec(b, (c[b + 944 >> 2] | 0) == 0, 2545);d = b + 948 | 0;e = c[d >> 2] | 0;f = b + 952 | 0;g = c[f >> 2] | 0;if ((g | 0) != (e | 0)) c[f >> 2] = g + (~((g + -4 - e | 0) >>> 2) << 2);bc(d);d = b + 976 | 0;e = c[d >> 2] | 0;BC(b | 0, 8104, 1e3) | 0;if (a[e + 2 >> 0] | 0) {
	        c[b + 4 >> 2] = 2;c[b + 12 >> 2] = 4;
	      }c[d >> 2] = e;return;
	    }function ec(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0;f = l;l = l + 16 | 0;e = f;if (!b) {
	        c[e >> 2] = d;Vd(a, 5, 3197, e);
	      }l = f;return;
	    }function fc() {
	      return c[2276] | 0;
	    }function gc() {
	      var a = 0;a = oB(20) | 0;hc((a | 0) != 0, 2592);c[2277] = (c[2277] | 0) + 1;c[a >> 2] = c[239];c[a + 4 >> 2] = c[240];c[a + 8 >> 2] = c[241];c[a + 12 >> 2] = c[242];c[a + 16 >> 2] = c[243];return a | 0;
	    }function hc(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = l;l = l + 16 | 0;d = e;if (!a) {
	        c[d >> 2] = b;Vd(0, 5, 3197, d);
	      }l = e;return;
	    }function ic(a) {
	      a = a | 0;pB(a);c[2277] = (c[2277] | 0) + -1;return;
	    }function jc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;if (!b) {
	        d = 0;b = 0;
	      } else {
	        ec(a, ($b(a) | 0) == 0, 2629);d = 1;
	      }c[a + 964 >> 2] = b;c[a + 988 >> 2] = d;return;
	    }function kc(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;g = e + 8 | 0;f = e + 4 | 0;h = e;c[f >> 2] = b;ec(a, (c[b + 944 >> 2] | 0) == 0, 2709);ec(a, (c[a + 964 >> 2] | 0) == 0, 2763);lc(a);b = a + 948 | 0;c[h >> 2] = (c[b >> 2] | 0) + (d << 2);c[g >> 2] = c[h >> 2];mc(b, g, f) | 0;c[(c[f >> 2] | 0) + 944 >> 2] = a;nc(a);l = e;return;
	    }function lc(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;d = $b(a) | 0;if (d | 0 ? (c[(ac(a, 0) | 0) + 944 >> 2] | 0) != (a | 0) : 0) {
	        e = c[(c[a + 976 >> 2] | 0) + 12 >> 2] | 0;f = a + 948 | 0;g = (e | 0) == 0;b = 0;do {
	          h = c[(c[f >> 2] | 0) + (b << 2) >> 2] | 0;i = Xb(h) | 0;c[(c[f >> 2] | 0) + (b << 2) >> 2] = i;c[i + 944 >> 2] = a;if (!g) Ib[e & 15](h, i, a, b);b = b + 1 | 0;
	        } while ((b | 0) != (d | 0));
	      }return;
	    }function mc(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0,
	          s = 0,
	          t = 0;s = l;l = l + 64 | 0;n = s + 52 | 0;i = s + 48 | 0;o = s + 28 | 0;p = s + 24 | 0;q = s + 20 | 0;r = s;e = c[a >> 2] | 0;g = e;b = e + ((c[b >> 2] | 0) - g >> 2 << 2) | 0;e = a + 4 | 0;f = c[e >> 2] | 0;h = a + 8 | 0;do if (f >>> 0 < (c[h >> 2] | 0) >>> 0) {
	        if ((b | 0) == (f | 0)) {
	          c[b >> 2] = c[d >> 2];c[e >> 2] = (c[e >> 2] | 0) + 4;break;
	        }ef(a, b, f, b + 4 | 0);if (b >>> 0 <= d >>> 0) d = (c[e >> 2] | 0) >>> 0 > d >>> 0 ? d + 4 | 0 : d;c[b >> 2] = c[d >> 2];
	      } else {
	        e = (f - g >> 2) + 1 | 0;f = le(a) | 0;if (f >>> 0 < e >>> 0) jC(a);m = c[a >> 2] | 0;k = (c[h >> 2] | 0) - m | 0;g = k >> 1;bf(r, k >> 2 >>> 0 < f >>> 1 >>> 0 ? g >>> 0 < e >>> 0 ? e : g : f, b - m >> 2, a + 8 | 0);m = r + 8 | 0;e = c[m >> 2] | 0;g = r + 12 | 0;k = c[g >> 2] | 0;h = k;j = e;do if ((e | 0) == (k | 0)) {
	          k = r + 4 | 0;e = c[k >> 2] | 0;t = c[r >> 2] | 0;f = t;if (e >>> 0 <= t >>> 0) {
	            e = h - f >> 1;e = (e | 0) == 0 ? 1 : e;bf(o, e, e >>> 2, c[r + 16 >> 2] | 0);c[p >> 2] = c[k >> 2];c[q >> 2] = c[m >> 2];c[i >> 2] = c[p >> 2];c[n >> 2] = c[q >> 2];gf(o, i, n);e = c[r >> 2] | 0;c[r >> 2] = c[o >> 2];c[o >> 2] = e;e = o + 4 | 0;t = c[k >> 2] | 0;c[k >> 2] = c[e >> 2];c[e >> 2] = t;e = o + 8 | 0;t = c[m >> 2] | 0;c[m >> 2] = c[e >> 2];c[e >> 2] = t;e = o + 12 | 0;t = c[g >> 2] | 0;c[g >> 2] = c[e >> 2];c[e >> 2] = t;df(o);e = c[m >> 2] | 0;break;
	          }g = e;h = ((g - f >> 2) + 1 | 0) / -2 | 0;i = e + (h << 2) | 0;f = j - g | 0;g = f >> 2;if (g) {
	            GC(i | 0, e | 0, f | 0) | 0;e = c[k >> 2] | 0;
	          }t = i + (g << 2) | 0;c[m >> 2] = t;c[k >> 2] = e + (h << 2);e = t;
	        } while (0);c[e >> 2] = c[d >> 2];c[m >> 2] = (c[m >> 2] | 0) + 4;b = ff(a, r, b) | 0;df(r);
	      } while (0);l = s;return b | 0;
	    }function nc(b) {
	      b = b | 0;var d = 0;do {
	        d = b + 984 | 0;if (a[d >> 0] | 0) break;a[d >> 0] = 1;g[b + 504 >> 2] = T(t);b = c[b + 944 >> 2] | 0;
	      } while ((b | 0) != 0);return;
	    }function oc(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -4 - e | 0) >>> 2) << 2);sC(d);
	      }return;
	    }function pc(a) {
	      a = a | 0;return c[a + 944 >> 2] | 0;
	    }function qc(a) {
	      a = a | 0;ec(a, (c[a + 964 >> 2] | 0) != 0, 2832);nc(a);return;
	    }function rc(b) {
	      b = b | 0;return (a[b + 984 >> 0] | 0) != 0 | 0;
	    }function sc(a, b) {
	      a = a | 0;b = b | 0;if (BB(a, b, 400) | 0) {
	        BC(a | 0, b | 0, 400) | 0;nc(a);
	      }return;
	    }function tc(a) {
	      a = a | 0;var b = ib;b = T(g[a + 44 >> 2]);a = Sb(b) | 0;return T(a ? T(0.0) : b);
	    }function uc(b) {
	      b = b | 0;var d = ib;d = T(g[b + 48 >> 2]);if (Sb(d) | 0) d = a[(c[b + 976 >> 2] | 0) + 2 >> 0] | 0 ? T(1.0) : T(0.0);return T(d);
	    }function vc(a, b) {
	      a = a | 0;b = b | 0;c[a + 980 >> 2] = b;return;
	    }function wc(a) {
	      a = a | 0;return c[a + 980 >> 2] | 0;
	    }function xc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 4 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function yc(a) {
	      a = a | 0;return c[a + 4 >> 2] | 0;
	    }function zc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 8 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function Ac(a) {
	      a = a | 0;return c[a + 8 >> 2] | 0;
	    }function Bc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 12 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function Cc(a) {
	      a = a | 0;return c[a + 12 >> 2] | 0;
	    }function Dc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 16 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function Ec(a) {
	      a = a | 0;return c[a + 16 >> 2] | 0;
	    }function Fc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 20 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function Gc(a) {
	      a = a | 0;return c[a + 20 >> 2] | 0;
	    }function Hc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 24 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function Ic(a) {
	      a = a | 0;return c[a + 24 >> 2] | 0;
	    }function Jc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 28 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function Kc(a) {
	      a = a | 0;return c[a + 28 >> 2] | 0;
	    }function Lc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 32 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function Mc(a) {
	      a = a | 0;return c[a + 32 >> 2] | 0;
	    }function Nc(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 36 | 0;if ((c[d >> 2] | 0) != (b | 0)) {
	        c[d >> 2] = b;nc(a);
	      }return;
	    }function Oc(a) {
	      a = a | 0;return c[a + 36 >> 2] | 0;
	    }function Pc(a, b) {
	      a = a | 0;b = T(b);var c = 0;c = a + 40 | 0;if (T(g[c >> 2]) != b) {
	        g[c >> 2] = b;nc(a);
	      }return;
	    }function Qc(a, b) {
	      a = a | 0;b = T(b);var c = 0;c = a + 44 | 0;if (T(g[c >> 2]) != b) {
	        g[c >> 2] = b;nc(a);
	      }return;
	    }function Rc(a, b) {
	      a = a | 0;b = T(b);var c = 0;c = a + 48 | 0;if (T(g[c >> 2]) != b) {
	        g[c >> 2] = b;nc(a);
	      }return;
	    }function Sc(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = (h ^ 1) & 1;e = a + 52 | 0;f = a + 56 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function Tc(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0;e = a + 52 | 0;d = a + 56 | 0;if (!(!(T(g[e >> 2]) != b) ? (c[d >> 2] | 0) == 2 : 0)) {
	        g[e >> 2] = b;e = Sb(b) | 0;c[d >> 2] = e ? 3 : 2;nc(a);
	      }return;
	    }function Uc(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = b + 52 | 0;d = c[e + 4 >> 2] | 0;b = a;c[b >> 2] = c[e >> 2];c[b + 4 >> 2] = d;return;
	    }function Vc(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0,
	          h = 0;h = Sb(d) | 0;e = (h ^ 1) & 1;f = a + 132 + (b << 3) | 0;b = a + 132 + (b << 3) + 4 | 0;if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
	        g[f >> 2] = d;c[b >> 2] = e;nc(a);
	      }return;
	    }function Wc(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0,
	          h = 0;h = Sb(d) | 0;e = h ? 0 : 2;f = a + 132 + (b << 3) | 0;b = a + 132 + (b << 3) + 4 | 0;if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
	        g[f >> 2] = d;c[b >> 2] = e;nc(a);
	      }return;
	    }function Xc(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = b + 132 + (d << 3) | 0;b = c[e + 4 >> 2] | 0;d = a;c[d >> 2] = c[e >> 2];c[d + 4 >> 2] = b;return;
	    }function Yc(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0,
	          h = 0;h = Sb(d) | 0;e = (h ^ 1) & 1;f = a + 60 + (b << 3) | 0;b = a + 60 + (b << 3) + 4 | 0;if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
	        g[f >> 2] = d;c[b >> 2] = e;nc(a);
	      }return;
	    }function Zc(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0,
	          h = 0;h = Sb(d) | 0;e = h ? 0 : 2;f = a + 60 + (b << 3) | 0;b = a + 60 + (b << 3) + 4 | 0;if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
	        g[f >> 2] = d;c[b >> 2] = e;nc(a);
	      }return;
	    }function _c(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = b + 60 + (d << 3) | 0;b = c[e + 4 >> 2] | 0;d = a;c[d >> 2] = c[e >> 2];c[d + 4 >> 2] = b;return;
	    }function $c(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = a + 60 + (b << 3) + 4 | 0;if ((c[d >> 2] | 0) != 3) {
	        g[a + 60 + (b << 3) >> 2] = T(t);c[d >> 2] = 3;nc(a);
	      }return;
	    }function ad(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0,
	          h = 0;h = Sb(d) | 0;e = (h ^ 1) & 1;f = a + 204 + (b << 3) | 0;b = a + 204 + (b << 3) + 4 | 0;if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
	        g[f >> 2] = d;c[b >> 2] = e;nc(a);
	      }return;
	    }function bd(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0,
	          h = 0;h = Sb(d) | 0;e = h ? 0 : 2;f = a + 204 + (b << 3) | 0;b = a + 204 + (b << 3) + 4 | 0;if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
	        g[f >> 2] = d;c[b >> 2] = e;nc(a);
	      }return;
	    }function cd(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = b + 204 + (d << 3) | 0;b = c[e + 4 >> 2] | 0;d = a;c[d >> 2] = c[e >> 2];c[d + 4 >> 2] = b;return;
	    }function dd(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0,
	          h = 0;h = Sb(d) | 0;e = (h ^ 1) & 1;f = a + 276 + (b << 3) | 0;b = a + 276 + (b << 3) + 4 | 0;if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
	        g[f >> 2] = d;c[b >> 2] = e;nc(a);
	      }return;
	    }function ed(a, b) {
	      a = a | 0;b = b | 0;return T(g[a + 276 + (b << 3) >> 2]);
	    }function fd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = (h ^ 1) & 1;e = a + 348 | 0;f = a + 352 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function gd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0;e = a + 348 | 0;d = a + 352 | 0;if (!(!(T(g[e >> 2]) != b) ? (c[d >> 2] | 0) == 2 : 0)) {
	        g[e >> 2] = b;e = Sb(b) | 0;c[d >> 2] = e ? 3 : 2;nc(a);
	      }return;
	    }function hd(a) {
	      a = a | 0;var b = 0;b = a + 352 | 0;if ((c[b >> 2] | 0) != 3) {
	        g[a + 348 >> 2] = T(t);c[b >> 2] = 3;nc(a);
	      }return;
	    }function id(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = b + 348 | 0;d = c[e + 4 >> 2] | 0;b = a;c[b >> 2] = c[e >> 2];c[b + 4 >> 2] = d;return;
	    }function jd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = (h ^ 1) & 1;e = a + 356 | 0;f = a + 360 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function kd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0;e = a + 356 | 0;d = a + 360 | 0;if (!(!(T(g[e >> 2]) != b) ? (c[d >> 2] | 0) == 2 : 0)) {
	        g[e >> 2] = b;e = Sb(b) | 0;c[d >> 2] = e ? 3 : 2;nc(a);
	      }return;
	    }function ld(a) {
	      a = a | 0;var b = 0;b = a + 360 | 0;if ((c[b >> 2] | 0) != 3) {
	        g[a + 356 >> 2] = T(t);c[b >> 2] = 3;nc(a);
	      }return;
	    }function md(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = b + 356 | 0;d = c[e + 4 >> 2] | 0;b = a;c[b >> 2] = c[e >> 2];c[b + 4 >> 2] = d;return;
	    }function nd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = (h ^ 1) & 1;e = a + 364 | 0;f = a + 368 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function od(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = h ? 0 : 2;e = a + 364 | 0;f = a + 368 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function pd(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = b + 364 | 0;d = c[e + 4 >> 2] | 0;b = a;c[b >> 2] = c[e >> 2];c[b + 4 >> 2] = d;return;
	    }function qd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = (h ^ 1) & 1;e = a + 372 | 0;f = a + 376 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function rd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = h ? 0 : 2;e = a + 372 | 0;f = a + 376 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function sd(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = b + 372 | 0;d = c[e + 4 >> 2] | 0;b = a;c[b >> 2] = c[e >> 2];c[b + 4 >> 2] = d;return;
	    }function td(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = (h ^ 1) & 1;e = a + 380 | 0;f = a + 384 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function ud(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = h ? 0 : 2;e = a + 380 | 0;f = a + 384 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function vd(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = b + 380 | 0;d = c[e + 4 >> 2] | 0;b = a;c[b >> 2] = c[e >> 2];c[b + 4 >> 2] = d;return;
	    }function wd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = (h ^ 1) & 1;e = a + 388 | 0;f = a + 392 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function xd(a, b) {
	      a = a | 0;b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0;h = Sb(b) | 0;d = h ? 0 : 2;e = a + 388 | 0;f = a + 392 | 0;if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
	        g[e >> 2] = b;c[f >> 2] = d;nc(a);
	      }return;
	    }function yd(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = b + 388 | 0;d = c[e + 4 >> 2] | 0;b = a;c[b >> 2] = c[e >> 2];c[b + 4 >> 2] = d;return;
	    }function zd(a, b) {
	      a = a | 0;b = T(b);var c = 0;c = a + 396 | 0;if (T(g[c >> 2]) != b) {
	        g[c >> 2] = b;nc(a);
	      }return;
	    }function Ad(a) {
	      a = a | 0;return T(g[a + 396 >> 2]);
	    }function Bd(a) {
	      a = a | 0;return T(g[a + 400 >> 2]);
	    }function Cd(a) {
	      a = a | 0;return T(g[a + 404 >> 2]);
	    }function Dd(a) {
	      a = a | 0;return T(g[a + 408 >> 2]);
	    }function Ed(a) {
	      a = a | 0;return T(g[a + 412 >> 2]);
	    }function Fd(a) {
	      a = a | 0;return T(g[a + 416 >> 2]);
	    }function Gd(a) {
	      a = a | 0;return T(g[a + 420 >> 2]);
	    }function Hd(a, b) {
	      a = a | 0;b = b | 0;ec(a, (b | 0) < 6, 2918);switch (b | 0) {case 0:
	          {
	            b = (c[a + 496 >> 2] | 0) == 2 ? 5 : 4;break;
	          }case 2:
	          {
	            b = (c[a + 496 >> 2] | 0) == 2 ? 4 : 5;break;
	          }default:
	          {}}return T(g[a + 424 + (b << 2) >> 2]);
	    }function Id(a, b) {
	      a = a | 0;b = b | 0;ec(a, (b | 0) < 6, 2918);switch (b | 0) {case 0:
	          {
	            b = (c[a + 496 >> 2] | 0) == 2 ? 5 : 4;break;
	          }case 2:
	          {
	            b = (c[a + 496 >> 2] | 0) == 2 ? 4 : 5;break;
	          }default:
	          {}}return T(g[a + 448 + (b << 2) >> 2]);
	    }function Jd(a, b) {
	      a = a | 0;b = b | 0;ec(a, (b | 0) < 6, 2918);switch (b | 0) {case 0:
	          {
	            b = (c[a + 496 >> 2] | 0) == 2 ? 5 : 4;break;
	          }case 2:
	          {
	            b = (c[a + 496 >> 2] | 0) == 2 ? 4 : 5;break;
	          }default:
	          {}}return T(g[a + 472 + (b << 2) >> 2]);
	    }function Kd(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = ib;d = c[a + 4 >> 2] | 0;if ((d | 0) == (c[b + 4 >> 2] | 0)) {
	        if (!d) a = 1;else {
	          e = T(g[a >> 2]);a = T(C(T(e - T(g[b >> 2])))) < T(.0000999999974);
	        }
	      } else a = 0;return a | 0;
	    }function Ld(a, b) {
	      a = T(a);b = T(b);var c = 0;if (Sb(a) | 0) c = Sb(b) | 0;else c = T(C(T(a - b))) < T(.0000999999974);return c | 0;
	    }function Md(a, b) {
	      a = a | 0;b = b | 0;Nd(a, b);return;
	    }function Nd(b, d) {
	      b = b | 0;d = d | 0;var e = 0,
	          f = 0;e = l;l = l + 16 | 0;f = e + 4 | 0;c[f >> 2] = 0;c[f + 4 >> 2] = 0;c[f + 8 >> 2] = 0;Ka(f | 0, b | 0, d | 0, 0);Vd(b, 3, (a[f + 11 >> 0] | 0) < 0 ? c[f >> 2] | 0 : f, e);tC(f);l = e;return;
	    }function Od(a, b, c, d) {
	      a = T(a);b = T(b);c = c | 0;d = d | 0;var e = ib;a = T(a * b);e = T(gC(a, T(1.0)));do if (!(Ld(e, T(0.0)) | 0)) {
	        a = T(a - e);if (Ld(e, T(1.0)) | 0) {
	          a = T(a + T(1.0));break;
	        }if (c) {
	          a = T(a + T(1.0));break;
	        }if (!d) {
	          if (e > T(.5)) e = T(1.0);else {
	            d = Ld(e, T(.5)) | 0;e = d ? T(1.0) : T(0.0);
	          }a = T(a + e);
	        }
	      } else a = T(a - e); while (0);return T(a / b);
	    }function Pd(a, b, c, d, e, f, h, i, j, k, l, m, n) {
	      a = a | 0;b = T(b);c = c | 0;d = T(d);e = e | 0;f = T(f);h = h | 0;i = T(i);j = T(j);k = T(k);l = T(l);m = T(m);n = n | 0;var o = 0,
	          p = ib,
	          q = ib,
	          r = ib,
	          s = ib,
	          t = ib,
	          u = ib;if (j < T(0.0) | k < T(0.0)) n = 0;else {
	        if ((n | 0) != 0 ? (p = T(g[n + 4 >> 2]), p != T(0.0)) : 0) {
	          r = T(Od(b, p, 0, 0));s = T(Od(d, p, 0, 0));q = T(Od(f, p, 0, 0));p = T(Od(i, p, 0, 0));
	        } else {
	          q = f;r = b;p = i;s = d;
	        }if ((e | 0) == (a | 0)) o = Ld(q, r) | 0;else o = 0;if ((h | 0) == (c | 0)) n = Ld(p, s) | 0;else n = 0;if ((!o ? (t = T(b - l), !(Qd(a, t, j) | 0)) : 0) ? !(Rd(a, t, e, j) | 0) : 0) o = Sd(a, t, e, f, j) | 0;else o = 1;if ((!n ? (u = T(d - m), !(Qd(c, u, k) | 0)) : 0) ? !(Rd(c, u, h, k) | 0) : 0) n = Sd(c, u, h, i, k) | 0;else n = 1;n = o & n;
	      }return n | 0;
	    }function Qd(a, b, c) {
	      a = a | 0;b = T(b);c = T(c);if ((a | 0) == 1) a = Ld(b, c) | 0;else a = 0;return a | 0;
	    }function Rd(a, b, c, d) {
	      a = a | 0;b = T(b);c = c | 0;d = T(d);if ((a | 0) == 2 & (c | 0) == 0) {
	        if (!(b >= d)) a = Ld(b, d) | 0;else a = 1;
	      } else a = 0;return a | 0;
	    }function Sd(a, b, c, d, e) {
	      a = a | 0;b = T(b);c = c | 0;d = T(d);e = T(e);if ((a | 0) == 2 & (c | 0) == 2 & d > b) {
	        if (!(e <= b)) a = Ld(b, e) | 0;else a = 1;
	      } else a = 0;return a | 0;
	    }function Td(b, d, e, f, i, j, k, m, n, o, p) {
	      b = b | 0;d = T(d);e = T(e);f = f | 0;i = i | 0;j = j | 0;k = T(k);m = T(m);n = n | 0;o = o | 0;p = p | 0;var q = 0,
	          r = 0,
	          s = 0,
	          t = 0,
	          u = ib,
	          v = ib,
	          w = 0,
	          x = 0,
	          y = 0,
	          z = 0,
	          A = 0,
	          B = 0,
	          C = 0,
	          D = 0,
	          E = 0,
	          F = 0,
	          G = 0,
	          H = ib,
	          I = ib,
	          J = ib,
	          K = 0.0,
	          L = 0.0;G = l;l = l + 160 | 0;D = G + 152 | 0;C = G + 120 | 0;B = G + 104 | 0;y = G + 72 | 0;t = G + 56 | 0;A = G + 8 | 0;x = G;z = (c[2279] | 0) + 1 | 0;c[2279] = z;E = b + 984 | 0;if ((a[E >> 0] | 0) != 0 ? (c[b + 512 >> 2] | 0) != (c[2278] | 0) : 0) w = 4;else if ((c[b + 516 >> 2] | 0) == (f | 0)) F = 0;else w = 4;if ((w | 0) == 4) {
	        c[b + 520 >> 2] = 0;c[b + 924 >> 2] = -1;c[b + 928 >> 2] = -1;g[b + 932 >> 2] = T(-1.0);g[b + 936 >> 2] = T(-1.0);F = 1;
	      }a: do if (!(c[b + 964 >> 2] | 0)) {
	        if (n) {
	          q = b + 916 | 0;if (!(Ld(T(g[q >> 2]), d) | 0)) {
	            w = 21;break;
	          }if (!(Ld(T(g[b + 920 >> 2]), e) | 0)) {
	            w = 21;break;
	          }if ((c[b + 924 >> 2] | 0) != (i | 0)) {
	            w = 21;break;
	          }q = (c[b + 928 >> 2] | 0) == (j | 0) ? q : 0;w = 22;break;
	        }s = c[b + 520 >> 2] | 0;if (!s) w = 21;else {
	          r = 0;while (1) {
	            q = b + 524 + (r * 24 | 0) | 0;if (((Ld(T(g[q >> 2]), d) | 0 ? Ld(T(g[b + 524 + (r * 24 | 0) + 4 >> 2]), e) | 0 : 0) ? (c[b + 524 + (r * 24 | 0) + 8 >> 2] | 0) == (i | 0) : 0) ? (c[b + 524 + (r * 24 | 0) + 12 >> 2] | 0) == (j | 0) : 0) {
	              w = 22;break a;
	            }r = r + 1 | 0;if (r >>> 0 >= s >>> 0) {
	              w = 21;break;
	            }
	          }
	        }
	      } else {
	        u = T(Ud(b, 2, k));v = T(Ud(b, 0, k));q = b + 916 | 0;J = T(g[q >> 2]);I = T(g[b + 920 >> 2]);H = T(g[b + 932 >> 2]);if (!(Pd(i, d, j, e, c[b + 924 >> 2] | 0, J, c[b + 928 >> 2] | 0, I, H, T(g[b + 936 >> 2]), u, v, p) | 0)) {
	          s = c[b + 520 >> 2] | 0;if (!s) w = 21;else {
	            r = 0;while (1) {
	              q = b + 524 + (r * 24 | 0) | 0;H = T(g[q >> 2]);I = T(g[b + 524 + (r * 24 | 0) + 4 >> 2]);J = T(g[b + 524 + (r * 24 | 0) + 16 >> 2]);if (Pd(i, d, j, e, c[b + 524 + (r * 24 | 0) + 8 >> 2] | 0, H, c[b + 524 + (r * 24 | 0) + 12 >> 2] | 0, I, J, T(g[b + 524 + (r * 24 | 0) + 20 >> 2]), u, v, p) | 0) {
	                w = 22;break a;
	              }r = r + 1 | 0;if (r >>> 0 >= s >>> 0) {
	                w = 21;break;
	              }
	            }
	          }
	        } else w = 22;
	      } while (0);do if ((w | 0) == 21) {
	        if (!(a[11697] | 0)) {
	          q = 0;w = 31;
	        } else {
	          q = 0;w = 28;
	        }
	      } else if ((w | 0) == 22) {
	        r = (a[11697] | 0) != 0;if (!((q | 0) != 0 & (F ^ 1))) if (r) {
	          w = 28;break;
	        } else {
	          w = 31;break;
	        }t = q + 16 | 0;c[b + 908 >> 2] = c[t >> 2];s = q + 20 | 0;c[b + 912 >> 2] = c[s >> 2];if (!((a[11698] | 0) == 0 | r ^ 1)) {
	          c[x >> 2] = Wd(z) | 0;c[x + 4 >> 2] = z;Vd(b, 4, 2972, x);r = c[b + 972 >> 2] | 0;if (r | 0) nb[r & 127](b);i = Xd(i, n) | 0;j = Xd(j, n) | 0;L = +T(g[t >> 2]);K = +T(g[s >> 2]);c[A >> 2] = i;c[A + 4 >> 2] = j;h[A + 8 >> 3] = +d;h[A + 16 >> 3] = +e;h[A + 24 >> 3] = L;h[A + 32 >> 3] = K;c[A + 40 >> 2] = o;Vd(b, 4, 2989, A);
	        }
	      } while (0);if ((w | 0) == 28) {
	        r = Wd(z) | 0;c[t >> 2] = r;c[t + 4 >> 2] = z;c[t + 8 >> 2] = F ? 3047 : 11699;Vd(b, 4, 3038, t);r = c[b + 972 >> 2] | 0;if (r | 0) nb[r & 127](b);A = Xd(i, n) | 0;w = Xd(j, n) | 0;c[y >> 2] = A;c[y + 4 >> 2] = w;h[y + 8 >> 3] = +d;h[y + 16 >> 3] = +e;c[y + 24 >> 2] = o;Vd(b, 4, 3049, y);w = 31;
	      }if ((w | 0) == 31) {
	        Yd(b, d, e, f, i, j, k, m, n, p);if (a[11697] | 0) {
	          r = c[2279] | 0;A = Wd(r) | 0;c[B >> 2] = A;c[B + 4 >> 2] = r;c[B + 8 >> 2] = F ? 3047 : 11699;Vd(b, 4, 3083, B);r = c[b + 972 >> 2] | 0;if (r | 0) nb[r & 127](b);A = Xd(i, n) | 0;B = Xd(j, n) | 0;K = +T(g[b + 908 >> 2]);L = +T(g[b + 912 >> 2]);c[C >> 2] = A;c[C + 4 >> 2] = B;h[C + 8 >> 3] = K;h[C + 16 >> 3] = L;c[C + 24 >> 2] = o;Vd(b, 4, 3092, C);
	        }c[b + 516 >> 2] = f;if (!q) {
	          r = b + 520 | 0;q = c[r >> 2] | 0;if ((q | 0) == 16) {
	            if (a[11697] | 0) Vd(b, 4, 3124, D);c[r >> 2] = 0;q = 0;
	          }if (n) q = b + 916 | 0;else {
	            c[r >> 2] = q + 1;q = b + 524 + (q * 24 | 0) | 0;
	          }g[q >> 2] = d;g[q + 4 >> 2] = e;c[q + 8 >> 2] = i;c[q + 12 >> 2] = j;c[q + 16 >> 2] = c[b + 908 >> 2];c[q + 20 >> 2] = c[b + 912 >> 2];q = 0;
	        }
	      }if (n) {
	        c[b + 416 >> 2] = c[b + 908 >> 2];c[b + 420 >> 2] = c[b + 912 >> 2];a[b + 985 >> 0] = 1;a[E >> 0] = 0;
	      }c[2279] = (c[2279] | 0) + -1;c[b + 512 >> 2] = c[2278];l = G;return F | (q | 0) == 0 | 0;
	    }function Ud(a, b, c) {
	      a = a | 0;b = b | 0;c = T(c);var d = ib;d = T(me(a, b, c));return T(d + T(ne(a, b, c)));
	    }function Vd(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g;c[f >> 2] = e;if (!a) e = 0;else e = c[a + 976 >> 2] | 0;ge(e, a, b, d, f);l = g;return;
	    }function Wd(a) {
	      a = a | 0;return (a >>> 0 > 60 ? 3201 : 3201 + (60 - a) | 0) | 0;
	    }function Xd(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0;f = l;l = l + 32 | 0;d = f + 12 | 0;e = f;c[d >> 2] = c[254];c[d + 4 >> 2] = c[255];c[d + 8 >> 2] = c[256];c[e >> 2] = c[257];c[e + 4 >> 2] = c[258];c[e + 8 >> 2] = c[259];if ((a | 0) > 2) a = 11699;else a = c[(b ? e : d) + (a << 2) >> 2] | 0;l = f;return a | 0;
	    }function Yd(b, e, f, h, i, k, m, n, o, p) {
	      b = b | 0;e = T(e);f = T(f);h = h | 0;i = i | 0;k = k | 0;m = T(m);n = T(n);o = o | 0;p = p | 0;var q = 0,
	          r = 0,
	          s = 0,
	          t = 0,
	          u = ib,
	          v = ib,
	          w = ib,
	          x = ib,
	          y = ib,
	          z = ib,
	          A = ib,
	          B = 0,
	          C = 0,
	          D = 0,
	          E = ib,
	          F = ib,
	          G = 0,
	          H = ib,
	          I = 0,
	          J = 0,
	          K = 0,
	          L = 0,
	          M = 0,
	          N = 0,
	          O = 0,
	          P = 0,
	          Q = 0,
	          R = 0,
	          S = 0,
	          U = 0,
	          V = 0,
	          W = 0,
	          X = 0,
	          Y = 0,
	          Z = 0,
	          _ = 0,
	          $ = ib,
	          aa = ib,
	          ba = ib,
	          ca = ib,
	          da = ib,
	          ea = 0,
	          fa = 0,
	          ga = 0,
	          ha = 0,
	          ia = 0,
	          ja = ib,
	          ka = ib,
	          la = ib,
	          ma = ib,
	          na = ib,
	          oa = ib,
	          pa = 0,
	          qa = ib,
	          ra = ib,
	          sa = ib,
	          ta = ib,
	          ua = ib,
	          va = ib,
	          wa = 0,
	          xa = 0,
	          ya = ib,
	          za = ib,
	          Aa = 0,
	          Ba = 0,
	          Ca = 0,
	          Da = 0,
	          Ea = ib,
	          Fa = 0,
	          Ga = 0,
	          Ha = 0,
	          Ia = 0,
	          Ja = 0,
	          Ka = 0,
	          La = 0,
	          Ma = ib,
	          Na = 0,
	          Oa = 0;La = l;l = l + 16 | 0;ea = La + 12 | 0;fa = La + 8 | 0;ga = La + 4 | 0;ha = La;ec(b, (i | 0) == 0 | (Sb(e) | 0) ^ 1, 3326);ec(b, (k | 0) == 0 | (Sb(f) | 0) ^ 1, 3406);Ga = qe(b, h) | 0;c[b + 496 >> 2] = Ga;Ja = re(2, Ga) | 0;Ka = re(0, Ga) | 0;g[b + 440 >> 2] = T(me(b, Ja, m));g[b + 444 >> 2] = T(ne(b, Ja, m));g[b + 428 >> 2] = T(me(b, Ka, m));g[b + 436 >> 2] = T(ne(b, Ka, m));g[b + 464 >> 2] = T(se(b, Ja));g[b + 468 >> 2] = T(te(b, Ja));g[b + 452 >> 2] = T(se(b, Ka));g[b + 460 >> 2] = T(te(b, Ka));g[b + 488 >> 2] = T(ue(b, Ja, m));g[b + 492 >> 2] = T(ve(b, Ja, m));g[b + 476 >> 2] = T(ue(b, Ka, m));g[b + 484 >> 2] = T(ve(b, Ka, m));do if (!(c[b + 964 >> 2] | 0)) {
	        Ha = b + 948 | 0;Ia = (c[b + 952 >> 2] | 0) - (c[Ha >> 2] | 0) >> 2;if (!Ia) {
	          xe(b, e, f, i, k, m, n);break;
	        }if (!o ? ye(b, e, f, i, k, m, n) | 0 : 0) break;lc(b);Y = b + 508 | 0;a[Y >> 0] = 0;Ja = re(c[b + 4 >> 2] | 0, Ga) | 0;Ka = ze(Ja, Ga) | 0;Fa = oe(Ja) | 0;Z = c[b + 8 >> 2] | 0;Ba = b + 28 | 0;_ = (c[Ba >> 2] | 0) != 0;ua = Fa ? m : n;ya = Fa ? n : m;$ = T(Ae(b, Ja, m));aa = T(Be(b, Ja, m));u = T(Ae(b, Ka, m));va = T(Ce(b, Ja, m));za = T(Ce(b, Ka, m));D = Fa ? i : k;Aa = Fa ? k : i;Ea = Fa ? va : za;y = Fa ? za : va;ta = T(Ud(b, 2, m));x = T(Ud(b, 0, m));v = T(T(be(b + 364 | 0, m)) - Ea);w = T(T(be(b + 380 | 0, m)) - Ea);z = T(T(be(b + 372 | 0, n)) - y);A = T(T(be(b + 388 | 0, n)) - y);ba = Fa ? v : z;ca = Fa ? w : A;ta = T(e - ta);e = T(ta - Ea);if (Sb(e) | 0) Ea = e;else Ea = T(cC(T(eC(e, w)), v));ra = T(f - x);e = T(ra - y);if (Sb(e) | 0) sa = e;else sa = T(cC(T(eC(e, A)), z));v = Fa ? Ea : sa;qa = Fa ? sa : Ea;a: do if ((D | 0) == 1) {
	          h = 0;r = 0;while (1) {
	            q = ac(b, r) | 0;if (!h) {
	              if (T(Ee(q)) > T(0.0) ? T(Fe(q)) > T(0.0) : 0) h = q;else h = 0;
	            } else if (De(q) | 0) {
	              t = 0;break a;
	            }r = r + 1 | 0;if (r >>> 0 >= Ia >>> 0) {
	              t = h;break;
	            }
	          }
	        } else t = 0; while (0);B = t + 500 | 0;C = t + 504 | 0;h = 0;q = 0;e = T(0.0);s = 0;do {
	          r = c[(c[Ha >> 2] | 0) + (s << 2) >> 2] | 0;if ((c[r + 36 >> 2] | 0) == 1) {
	            Ge(r);a[r + 985 >> 0] = 1;a[r + 984 >> 0] = 0;
	          } else {
	            $d(r);if (o) ce(r, qe(r, Ga) | 0, v, qa, Ea);do if ((c[r + 24 >> 2] | 0) != 1) {
	              if ((r | 0) == (t | 0)) {
	                c[B >> 2] = c[2278];g[C >> 2] = T(0.0);break;
	              } else {
	                He(b, r, Ea, i, sa, Ea, sa, k, Ga, p);break;
	              }
	            } else {
	              if (q | 0) c[q + 960 >> 2] = r;c[r + 960 >> 2] = 0;q = r;h = (h | 0) == 0 ? r : h;
	            } while (0);oa = T(g[r + 504 >> 2]);e = T(e + T(oa + T(Ud(r, Ja, Ea))));
	          }s = s + 1 | 0;
	        } while ((s | 0) != (Ia | 0));K = e > v;pa = _ & ((D | 0) == 2 & K) ? 1 : D;I = (Aa | 0) == 1;M = I & (o ^ 1);N = (pa | 0) == 1;O = (pa | 0) == 2;P = 976 + (Ja << 2) | 0;Q = (Aa | 2 | 0) == 2;W = I & (_ ^ 1);R = 1040 + (Ka << 2) | 0;S = 1040 + (Ja << 2) | 0;U = 976 + (Ka << 2) | 0;V = (Aa | 0) != 1;K = _ & ((D | 0) != 0 & K);J = b + 976 | 0;I = I ^ 1;e = v;G = 0;L = 0;oa = T(0.0);da = T(0.0);while (1) {
	          b: do if (G >>> 0 < Ia >>> 0) {
	            C = c[Ha >> 2] | 0;s = 0;A = T(0.0);z = T(0.0);w = T(0.0);v = T(0.0);r = 0;q = 0;t = G;while (1) {
	              B = c[C + (t << 2) >> 2] | 0;if ((c[B + 36 >> 2] | 0) != 1 ? (c[B + 940 >> 2] = L, (c[B + 24 >> 2] | 0) != 1) : 0) {
	                x = T(Ud(B, Ja, Ea));X = c[P >> 2] | 0;f = T(be(B + 380 + (X << 3) | 0, ua));y = T(g[B + 504 >> 2]);f = T(eC(f, y));f = T(cC(T(be(B + 364 + (X << 3) | 0, ua)), f));if (_ & (s | 0) != 0 & T(x + T(z + f)) > e) {
	                  k = s;x = A;D = t;break b;
	                }x = T(x + f);f = T(z + x);x = T(A + x);if (De(B) | 0) {
	                  w = T(w + T(Ee(B)));v = T(v - T(y * T(Fe(B))));
	                }if (q | 0) c[q + 960 >> 2] = B;c[B + 960 >> 2] = 0;s = s + 1 | 0;q = B;r = (r | 0) == 0 ? B : r;
	              } else {
	                x = A;f = z;
	              }t = t + 1 | 0;if (t >>> 0 < Ia >>> 0) {
	                A = x;z = f;
	              } else {
	                k = s;D = t;break;
	              }
	            }
	          } else {
	            k = 0;x = T(0.0);w = T(0.0);v = T(0.0);r = 0;D = G;
	          } while (0);X = w > T(0.0) & w < T(1.0);E = X ? T(1.0) : w;X = v > T(0.0) & v < T(1.0);A = X ? T(1.0) : v;do if (!N) {
	            if (!(x < ba & ((Sb(ba) | 0) ^ 1))) {
	              if (!(x > ca & ((Sb(ca) | 0) ^ 1))) {
	                if (!(a[(c[J >> 2] | 0) + 3 >> 0] | 0)) {
	                  if (!(E == T(0.0)) ? !(T(Ee(b)) == T(0.0)) : 0) {
	                    X = 53;break;
	                  }e = x;X = 53;
	                } else X = 51;
	              } else {
	                e = ca;X = 51;
	              }
	            } else {
	              e = ba;X = 51;
	            }
	          } else X = 51; while (0);if ((X | 0) == 51) {
	            X = 0;if (Sb(e) | 0) X = 53;else {
	              F = T(e - x);H = e;
	            }
	          }if ((X | 0) == 53) {
	            X = 0;if (x < T(0.0)) {
	              F = T(-x);H = e;
	            } else {
	              F = T(0.0);H = e;
	            }
	          }if (!M ? (ia = (r | 0) == 0, !ia) : 0) {
	            s = c[P >> 2] | 0;t = F < T(0.0);y = T(F / A);B = F > T(0.0);z = T(F / E);w = T(0.0);x = T(0.0);e = T(0.0);q = r;do {
	              f = T(be(q + 380 + (s << 3) | 0, ua));v = T(be(q + 364 + (s << 3) | 0, ua));v = T(eC(f, T(cC(v, T(g[q + 504 >> 2])))));if (t) {
	                f = T(v * T(Fe(q)));if (f != T(-0.0) ? (Ma = T(v - T(y * f)), ja = T(Ie(q, Ja, Ma, H, Ea)), Ma != ja) : 0) {
	                  w = T(w - T(ja - v));e = T(e + f);
	                }
	              } else if ((B ? (ka = T(Ee(q)), ka != T(0.0)) : 0) ? (Ma = T(v + T(z * ka)), la = T(Ie(q, Ja, Ma, H, Ea)), Ma != la) : 0) {
	                w = T(w - T(la - v));x = T(x - ka);
	              }q = c[q + 960 >> 2] | 0;
	            } while ((q | 0) != 0);e = T(A + e);v = T(F + w);if (!ia) {
	              y = T(E + x);t = c[P >> 2] | 0;B = v < T(0.0);C = e == T(0.0);z = T(v / e);s = v > T(0.0);y = T(v / y);e = T(0.0);do {
	                Ma = T(be(r + 380 + (t << 3) | 0, ua));w = T(be(r + 364 + (t << 3) | 0, ua));w = T(eC(Ma, T(cC(w, T(g[r + 504 >> 2])))));if (B) {
	                  Ma = T(w * T(Fe(r)));v = T(-Ma);if (Ma != T(-0.0)) {
	                    Ma = T(z * v);v = T(Ie(r, Ja, T(w + (C ? v : Ma)), H, Ea));
	                  } else v = w;
	                } else if (s ? (ma = T(Ee(r)), ma != T(0.0)) : 0) v = T(Ie(r, Ja, T(w + T(y * ma)), H, Ea));else v = w;e = T(e - T(v - w));x = T(Ud(r, Ja, Ea));f = T(Ud(r, Ka, Ea));v = T(v + x);g[fa >> 2] = v;c[ha >> 2] = 1;w = T(g[r + 396 >> 2]);c: do if (Sb(w) | 0) {
	                  q = Sb(qa) | 0;do if (!q) {
	                    if (K | (ae(r, Ka, qa) | 0 | I)) break;if ((Je(b, r) | 0) != 4) break;if ((c[(Ke(r, Ka) | 0) + 4 >> 2] | 0) == 3) break;if ((c[(Le(r, Ka) | 0) + 4 >> 2] | 0) == 3) break;g[ea >> 2] = qa;c[ga >> 2] = 1;break c;
	                  } while (0);if (ae(r, Ka, qa) | 0) {
	                    q = c[r + 992 + (c[U >> 2] << 2) >> 2] | 0;Ma = T(f + T(be(q, qa)));g[ea >> 2] = Ma;q = V & (c[q + 4 >> 2] | 0) == 2;c[ga >> 2] = ((Sb(Ma) | 0 | q) ^ 1) & 1;break;
	                  } else {
	                    g[ea >> 2] = qa;c[ga >> 2] = q ? 0 : 2;break;
	                  }
	                } else {
	                  Ma = T(v - x);E = T(Ma / w);Ma = T(w * Ma);c[ga >> 2] = 1;g[ea >> 2] = T(f + (Fa ? E : Ma));
	                } while (0);Me(r, Ja, H, Ea, ha, fa);Me(r, Ka, qa, Ea, ga, ea);do if (!(ae(r, Ka, qa) | 0) ? (Je(b, r) | 0) == 4 : 0) {
	                  if ((c[(Ke(r, Ka) | 0) + 4 >> 2] | 0) == 3) {
	                    q = 0;break;
	                  }q = (c[(Le(r, Ka) | 0) + 4 >> 2] | 0) != 3;
	                } else q = 0; while (0);Ma = T(g[fa >> 2]);E = T(g[ea >> 2]);Na = c[ha >> 2] | 0;Oa = c[ga >> 2] | 0;Td(r, Fa ? Ma : E, Fa ? E : Ma, Ga, Fa ? Na : Oa, Fa ? Oa : Na, Ea, sa, o & (q ^ 1), 3488, p) | 0;a[Y >> 0] = a[Y >> 0] | a[r + 508 >> 0];r = c[r + 960 >> 2] | 0;
	              } while ((r | 0) != 0);
	            } else e = T(0.0);
	          } else e = T(0.0);e = T(F + e);Oa = e < T(0.0) & 1;a[Y >> 0] = Oa | d[Y >> 0];if (O & e > T(0.0)) {
	            q = c[P >> 2] | 0;if ((c[b + 364 + (q << 3) + 4 >> 2] | 0) != 0 ? (na = T(be(b + 364 + (q << 3) | 0, ua)), na >= T(0.0)) : 0) v = T(cC(T(0.0), T(na - T(H - e))));else v = T(0.0);
	          } else v = e;B = G >>> 0 < D >>> 0;if (B) {
	            t = c[Ha >> 2] | 0;s = G;q = 0;do {
	              r = c[t + (s << 2) >> 2] | 0;if (!(c[r + 24 >> 2] | 0)) {
	                q = ((c[(Ke(r, Ja) | 0) + 4 >> 2] | 0) == 3 & 1) + q | 0;q = q + ((c[(Le(r, Ja) | 0) + 4 >> 2] | 0) == 3 & 1) | 0;
	              }s = s + 1 | 0;
	            } while ((s | 0) != (D | 0));if (q) {
	              x = T(0.0);f = T(0.0);
	            } else X = 101;
	          } else X = 101;d: do if ((X | 0) == 101) {
	            X = 0;switch (Z | 0) {case 1:
	                {
	                  q = 0;x = T(v * T(.5));f = T(0.0);break d;
	                }case 2:
	                {
	                  q = 0;x = v;f = T(0.0);break d;
	                }case 3:
	                {
	                  if (k >>> 0 <= 1) {
	                    q = 0;x = T(0.0);f = T(0.0);break d;
	                  }f = T((k + -1 | 0) >>> 0);q = 0;x = T(0.0);f = T(T(cC(v, T(0.0))) / f);break d;
	                }case 5:
	                {
	                  f = T(v / T((k + 1 | 0) >>> 0));q = 0;x = f;break d;
	                }case 4:
	                {
	                  f = T(v / T(k >>> 0));q = 0;x = T(f * T(.5));break d;
	                }default:
	                {
	                  q = 0;x = T(0.0);f = T(0.0);break d;
	                }}
	          } while (0);e = T($ + x);if (B) {
	            w = T(v / T(q | 0));s = c[Ha >> 2] | 0;r = G;v = T(0.0);do {
	              q = c[s + (r << 2) >> 2] | 0;e: do if ((c[q + 36 >> 2] | 0) != 1) {
	                switch (c[q + 24 >> 2] | 0) {case 1:
	                    {
	                      if (Ne(q, Ja) | 0) {
	                        if (!o) break e;Ma = T(Oe(q, Ja, H));Ma = T(Ma + T(se(b, Ja)));Ma = T(Ma + T(me(q, Ja, Ea)));g[q + 400 + (c[S >> 2] << 2) >> 2] = Ma;break e;
	                      }break;
	                    }case 0:
	                    {
	                      Oa = (c[(Ke(q, Ja) | 0) + 4 >> 2] | 0) == 3;Ma = T(w + e);e = Oa ? Ma : e;if (o) {
	                        Oa = q + 400 + (c[S >> 2] << 2) | 0;g[Oa >> 2] = T(e + T(g[Oa >> 2]));
	                      }Oa = (c[(Le(q, Ja) | 0) + 4 >> 2] | 0) == 3;Ma = T(w + e);e = Oa ? Ma : e;if (M) {
	                        Ma = T(f + T(Ud(q, Ja, Ea)));v = qa;e = T(e + T(Ma + T(g[q + 504 >> 2])));break e;
	                      } else {
	                        e = T(e + T(f + T(Pe(q, Ja, Ea))));v = T(cC(v, T(Pe(q, Ka, Ea))));break e;
	                      }
	                    }default:
	                    {}}if (o) {
	                  Ma = T(x + T(se(b, Ja)));Oa = q + 400 + (c[S >> 2] << 2) | 0;g[Oa >> 2] = T(Ma + T(g[Oa >> 2]));
	                }
	              } while (0);r = r + 1 | 0;
	            } while ((r | 0) != (D | 0));
	          } else v = T(0.0);f = T(aa + e);if (Q) x = T(T(Ie(b, Ka, T(za + v), ya, m)) - za);else x = qa;w = T(T(Ie(b, Ka, T(za + (W ? qa : v)), ya, m)) - za);if (B & o) {
	            r = G;do {
	              s = c[(c[Ha >> 2] | 0) + (r << 2) >> 2] | 0;do if ((c[s + 36 >> 2] | 0) != 1) {
	                if ((c[s + 24 >> 2] | 0) == 1) {
	                  if (Ne(s, Ka) | 0) {
	                    Ma = T(Oe(s, Ka, qa));Ma = T(Ma + T(se(b, Ka)));Ma = T(Ma + T(me(s, Ka, Ea)));q = c[R >> 2] | 0;g[s + 400 + (q << 2) >> 2] = Ma;if (!(Sb(Ma) | 0)) break;
	                  } else q = c[R >> 2] | 0;Ma = T(se(b, Ka));g[s + 400 + (q << 2) >> 2] = T(Ma + T(me(s, Ka, Ea)));break;
	                }q = Je(b, s) | 0;do if ((q | 0) == 4) {
	                  if ((c[(Ke(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
	                    X = 139;break;
	                  }if ((c[(Le(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
	                    X = 139;break;
	                  }if (ae(s, Ka, qa) | 0) {
	                    e = u;break;
	                  }Na = c[s + 908 + (c[P >> 2] << 2) >> 2] | 0;c[ea >> 2] = Na;e = T(g[s + 396 >> 2]);Oa = Sb(e) | 0;v = (c[j >> 2] = Na, T(g[j >> 2]));if (Oa) e = w;else {
	                    F = T(Ud(s, Ka, Ea));Ma = T(v / e);e = T(e * v);e = T(F + (Fa ? Ma : e));
	                  }g[fa >> 2] = e;g[ea >> 2] = T(T(Ud(s, Ja, Ea)) + v);c[ga >> 2] = 1;c[ha >> 2] = 1;Me(s, Ja, H, Ea, ga, ea);Me(s, Ka, qa, Ea, ha, fa);e = T(g[ea >> 2]);F = T(g[fa >> 2]);Ma = Fa ? e : F;e = Fa ? F : e;Oa = ((Sb(Ma) | 0) ^ 1) & 1;Td(s, Ma, e, Ga, Oa, ((Sb(e) | 0) ^ 1) & 1, Ea, sa, 1, 3493, p) | 0;e = u;
	                } else X = 139; while (0);f: do if ((X | 0) == 139) {
	                  X = 0;e = T(x - T(Pe(s, Ka, Ea)));do if ((c[(Ke(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
	                    if ((c[(Le(s, Ka) | 0) + 4 >> 2] | 0) != 3) break;e = T(u + T(cC(T(0.0), T(e * T(.5)))));break f;
	                  } while (0);if ((c[(Le(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
	                    e = u;break;
	                  }if ((c[(Ke(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
	                    e = T(u + T(cC(T(0.0), e)));break;
	                  }switch (q | 0) {case 1:
	                      {
	                        e = u;break f;
	                      }case 2:
	                      {
	                        e = T(u + T(e * T(.5)));break f;
	                      }default:
	                      {
	                        e = T(u + e);break f;
	                      }}
	                } while (0);Ma = T(oa + e);Oa = s + 400 + (c[R >> 2] << 2) | 0;g[Oa >> 2] = T(Ma + T(g[Oa >> 2]));
	              } while (0);r = r + 1 | 0;
	            } while ((r | 0) != (D | 0));
	          }oa = T(oa + w);da = T(cC(da, f));k = L + 1 | 0;if (D >>> 0 >= Ia >>> 0) break;else {
	            e = H;G = D;L = k;
	          }
	        }do if (o) {
	          q = k >>> 0 > 1;if (!q ? !(Qe(b) | 0) : 0) break;if (!(Sb(qa) | 0)) {
	            e = T(qa - oa);g: do switch (c[b + 12 >> 2] | 0) {case 3:
	                {
	                  u = T(u + e);z = T(0.0);break;
	                }case 2:
	                {
	                  u = T(u + T(e * T(.5)));z = T(0.0);break;
	                }case 4:
	                {
	                  if (qa > oa) z = T(e / T(k >>> 0));else z = T(0.0);break;
	                }case 7:
	                if (qa > oa) {
	                  u = T(u + T(e / T(k << 1 >>> 0)));z = T(e / T(k >>> 0));z = q ? z : T(0.0);break g;
	                } else {
	                  u = T(u + T(e * T(.5)));z = T(0.0);break g;
	                }case 6:
	                {
	                  z = T(e / T(L >>> 0));z = qa > oa & q ? z : T(0.0);break;
	                }default:
	                z = T(0.0);} while (0);if (k | 0) {
	              B = 1040 + (Ka << 2) | 0;C = 976 + (Ka << 2) | 0;t = 0;r = 0;while (1) {
	                h: do if (r >>> 0 < Ia >>> 0) {
	                  v = T(0.0);w = T(0.0);e = T(0.0);s = r;while (1) {
	                    q = c[(c[Ha >> 2] | 0) + (s << 2) >> 2] | 0;do if ((c[q + 36 >> 2] | 0) != 1 ? (c[q + 24 >> 2] | 0) == 0 : 0) {
	                      if ((c[q + 940 >> 2] | 0) != (t | 0)) break h;if (Re(q, Ka) | 0) {
	                        Ma = T(g[q + 908 + (c[C >> 2] << 2) >> 2]);e = T(cC(e, T(Ma + T(Ud(q, Ka, Ea)))));
	                      }if ((Je(b, q) | 0) != 5) break;na = T(Se(q));na = T(na + T(me(q, 0, Ea)));Ma = T(g[q + 912 >> 2]);Ma = T(T(Ma + T(Ud(q, 0, Ea))) - na);na = T(cC(w, na));Ma = T(cC(v, Ma));v = Ma;w = na;e = T(cC(e, T(na + Ma)));
	                    } while (0);q = s + 1 | 0;if (q >>> 0 < Ia >>> 0) s = q;else {
	                      s = q;break;
	                    }
	                  }
	                } else {
	                  w = T(0.0);e = T(0.0);s = r;
	                } while (0);y = T(z + e);f = u;u = T(u + y);if (r >>> 0 < s >>> 0) {
	                  x = T(f + w);q = r;do {
	                    r = c[(c[Ha >> 2] | 0) + (q << 2) >> 2] | 0;i: do if ((c[r + 36 >> 2] | 0) != 1 ? (c[r + 24 >> 2] | 0) == 0 : 0) switch (Je(b, r) | 0) {case 1:
	                        {
	                          Ma = T(f + T(me(r, Ka, Ea)));g[r + 400 + (c[B >> 2] << 2) >> 2] = Ma;break i;
	                        }case 3:
	                        {
	                          Ma = T(T(u - T(ne(r, Ka, Ea))) - T(g[r + 908 + (c[C >> 2] << 2) >> 2]));g[r + 400 + (c[B >> 2] << 2) >> 2] = Ma;break i;
	                        }case 2:
	                        {
	                          Ma = T(f + T(T(y - T(g[r + 908 + (c[C >> 2] << 2) >> 2])) * T(.5)));g[r + 400 + (c[B >> 2] << 2) >> 2] = Ma;break i;
	                        }case 4:
	                        {
	                          Ma = T(f + T(me(r, Ka, Ea)));g[r + 400 + (c[B >> 2] << 2) >> 2] = Ma;if (ae(r, Ka, qa) | 0) break i;if (Fa) {
	                            v = T(g[r + 908 >> 2]);e = T(v + T(Ud(r, Ja, Ea)));w = y;
	                          } else {
	                            w = T(g[r + 912 >> 2]);w = T(w + T(Ud(r, Ka, Ea)));e = y;v = T(g[r + 908 >> 2]);
	                          }if (Ld(e, v) | 0 ? Ld(w, T(g[r + 912 >> 2])) | 0 : 0) break i;Td(r, e, w, Ga, 1, 1, Ea, sa, 1, 3501, p) | 0;break i;
	                        }case 5:
	                        {
	                          g[r + 404 >> 2] = T(T(x - T(Se(r))) + T(Oe(r, 0, qa)));break i;
	                        }default:
	                        break i;} while (0);q = q + 1 | 0;
	                  } while ((q | 0) != (s | 0));
	                }t = t + 1 | 0;if ((t | 0) == (k | 0)) break;else r = s;
	              }
	            }
	          }
	        } while (0);g[b + 908 >> 2] = T(Ie(b, 2, ta, m, m));g[b + 912 >> 2] = T(Ie(b, 0, ra, n, m));if ((pa | 0) != 0 ? (wa = c[b + 32 >> 2] | 0, xa = (pa | 0) == 2, !(xa & (wa | 0) != 2)) : 0) {
	          if (xa & (wa | 0) == 2) {
	            e = T(va + H);e = T(cC(T(eC(e, T(Te(b, Ja, da, ua)))), va));X = 198;
	          }
	        } else {
	          e = T(Ie(b, Ja, da, ua, m));X = 198;
	        }if ((X | 0) == 198) g[b + 908 + (c[976 + (Ja << 2) >> 2] << 2) >> 2] = e;if ((Aa | 0) != 0 ? (Ca = c[b + 32 >> 2] | 0, Da = (Aa | 0) == 2, !(Da & (Ca | 0) != 2)) : 0) {
	          if (Da & (Ca | 0) == 2) {
	            e = T(za + qa);e = T(cC(T(eC(e, T(Te(b, Ka, T(za + oa), ya)))), za));X = 204;
	          }
	        } else {
	          e = T(Ie(b, Ka, T(za + oa), ya, m));X = 204;
	        }if ((X | 0) == 204) g[b + 908 + (c[976 + (Ka << 2) >> 2] << 2) >> 2] = e;if (o) {
	          if ((c[Ba >> 2] | 0) == 2) {
	            r = 976 + (Ka << 2) | 0;s = 1040 + (Ka << 2) | 0;q = 0;do {
	              t = ac(b, q) | 0;if (!(c[t + 24 >> 2] | 0)) {
	                Na = c[r >> 2] | 0;Ma = T(g[b + 908 + (Na << 2) >> 2]);Oa = t + 400 + (c[s >> 2] << 2) | 0;Ma = T(Ma - T(g[Oa >> 2]));g[Oa >> 2] = T(Ma - T(g[t + 908 + (Na << 2) >> 2]));
	              }q = q + 1 | 0;
	            } while ((q | 0) != (Ia | 0));
	          }if (h | 0) {
	            q = Fa ? pa : i;do {
	              Ue(b, h, Ea, q, sa, Ga, p);h = c[h + 960 >> 2] | 0;
	            } while ((h | 0) != 0);
	          }q = (Ja | 2 | 0) == 3;r = (Ka | 2 | 0) == 3;if (q | r) {
	            h = 0;do {
	              s = c[(c[Ha >> 2] | 0) + (h << 2) >> 2] | 0;if ((c[s + 36 >> 2] | 0) != 1) {
	                if (q) Ve(b, s, Ja);if (r) Ve(b, s, Ka);
	              }h = h + 1 | 0;
	            } while ((h | 0) != (Ia | 0));
	          }
	        }
	      } else we(b, e, f, i, k, m, n); while (0);l = La;return;
	    }function Zd(a, b) {
	      a = a | 0;b = T(b);var c = 0;Vb(a, b >= T(0.0), 3147);c = b == T(0.0);g[a + 4 >> 2] = c ? T(0.0) : b;return;
	    }function _d(b, d, e, f) {
	      b = b | 0;d = T(d);e = T(e);f = f | 0;var h = ib,
	          i = ib,
	          j = 0,
	          k = 0,
	          l = 0;c[2278] = (c[2278] | 0) + 1;$d(b);if (!(ae(b, 2, d) | 0)) {
	        h = T(be(b + 380 | 0, d));if (!(h >= T(0.0))) {
	          l = ((Sb(d) | 0) ^ 1) & 1;h = d;
	        } else l = 2;
	      } else {
	        h = T(be(c[b + 992 >> 2] | 0, d));l = 1;h = T(h + T(Ud(b, 2, d)));
	      }if (!(ae(b, 0, e) | 0)) {
	        i = T(be(b + 388 | 0, e));if (!(i >= T(0.0))) {
	          k = ((Sb(e) | 0) ^ 1) & 1;i = e;
	        } else k = 2;
	      } else {
	        i = T(be(c[b + 996 >> 2] | 0, e));k = 1;i = T(i + T(Ud(b, 0, d)));
	      }j = b + 976 | 0;if (Td(b, h, i, f, l, k, d, e, 1, 3189, c[j >> 2] | 0) | 0 ? (ce(b, c[b + 496 >> 2] | 0, d, e, d), de(b, T(g[(c[j >> 2] | 0) + 4 >> 2]), T(0.0), T(0.0)), a[11696] | 0) : 0) Md(b, 7);return;
	    }function $d(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;h = i + 24 | 0;g = i + 16 | 0;e = i + 8 | 0;f = i;d = 0;do {
	        b = a + 380 + (d << 3) | 0;if (!((c[a + 380 + (d << 3) + 4 >> 2] | 0) != 0 ? (j = b, k = c[j + 4 >> 2] | 0, m = e, c[m >> 2] = c[j >> 2], c[m + 4 >> 2] = k, m = a + 364 + (d << 3) | 0, k = c[m + 4 >> 2] | 0, j = f, c[j >> 2] = c[m >> 2], c[j + 4 >> 2] = k, c[g >> 2] = c[e >> 2], c[g + 4 >> 2] = c[e + 4 >> 2], c[h >> 2] = c[f >> 2], c[h + 4 >> 2] = c[f + 4 >> 2], Kd(g, h) | 0) : 0)) b = a + 348 + (d << 3) | 0;c[a + 992 + (d << 2) >> 2] = b;d = d + 1 | 0;
	      } while ((d | 0) != 2);l = i;return;
	    }function ae(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0;a = c[a + 992 + (c[976 + (b << 2) >> 2] << 2) >> 2] | 0;switch (c[a + 4 >> 2] | 0) {case 0:case 3:
	          {
	            a = 0;break;
	          }case 1:
	          {
	            if (T(g[a >> 2]) < T(0.0)) a = 0;else e = 5;break;
	          }case 2:
	          {
	            if (T(g[a >> 2]) < T(0.0)) a = 0;else a = (Sb(d) | 0) ^ 1;break;
	          }default:
	          e = 5;}if ((e | 0) == 5) a = 1;return a | 0;
	    }function be(a, b) {
	      a = a | 0;b = T(b);switch (c[a + 4 >> 2] | 0) {case 2:
	          {
	            b = T(T(T(g[a >> 2]) * b) / T(100.0));break;
	          }case 1:
	          {
	            b = T(g[a >> 2]);break;
	          }default:
	          b = T(t);}return T(b);
	    }function ce(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = T(d);e = T(e);f = T(f);var h = 0,
	          i = ib;b = c[a + 944 >> 2] | 0 ? b : 1;h = re(c[a + 4 >> 2] | 0, b) | 0;b = ze(h, b) | 0;d = T($e(a, h, d));e = T($e(a, b, e));i = T(d + T(me(a, h, f)));g[a + 400 + (c[1040 + (h << 2) >> 2] << 2) >> 2] = i;d = T(d + T(ne(a, h, f)));g[a + 400 + (c[1e3 + (h << 2) >> 2] << 2) >> 2] = d;d = T(e + T(me(a, b, f)));g[a + 400 + (c[1040 + (b << 2) >> 2] << 2) >> 2] = d;f = T(e + T(ne(a, b, f)));g[a + 400 + (c[1e3 + (b << 2) >> 2] << 2) >> 2] = f;return;
	    }function de(a, b, d, e) {
	      a = a | 0;b = T(b);d = T(d);e = T(e);var f = 0,
	          h = 0,
	          i = ib,
	          j = ib,
	          k = 0,
	          l = 0,
	          m = ib,
	          n = 0,
	          o = ib,
	          p = ib,
	          q = ib,
	          r = ib;if (!(b == T(0.0))) {
	        f = a + 400 | 0;r = T(g[f >> 2]);h = a + 404 | 0;q = T(g[h >> 2]);n = a + 416 | 0;p = T(g[n >> 2]);l = a + 420 | 0;i = T(g[l >> 2]);o = T(r + d);m = T(q + e);e = T(o + p);j = T(m + i);k = (c[a + 988 >> 2] | 0) == 1;g[f >> 2] = T(Od(r, b, 0, k));g[h >> 2] = T(Od(q, b, 0, k));d = T(gC(T(p * b), T(1.0)));if (Ld(d, T(0.0)) | 0) h = 0;else h = (Ld(d, T(1.0)) | 0) ^ 1;d = T(gC(T(i * b), T(1.0)));if (Ld(d, T(0.0)) | 0) f = 0;else f = (Ld(d, T(1.0)) | 0) ^ 1;r = T(Od(e, b, k & h, k & (h ^ 1)));g[n >> 2] = T(r - T(Od(o, b, 0, k)));r = T(Od(j, b, k & f, k & (f ^ 1)));g[l >> 2] = T(r - T(Od(m, b, 0, k)));h = (c[a + 952 >> 2] | 0) - (c[a + 948 >> 2] | 0) >> 2;if (h | 0) {
	          f = 0;do {
	            de(ac(a, f) | 0, b, o, m);f = f + 1 | 0;
	          } while ((f | 0) != (h | 0));
	        }
	      }return;
	    }function ee(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;switch (d | 0) {case 5:case 0:
	          {
	            a = CB(c[489] | 0, e, f) | 0;break;
	          }default:
	          a = iC(e, f) | 0;}return a | 0;
	    }function fe(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;f = l;l = l + 16 | 0;g = f;c[g >> 2] = e;ge(a, 0, b, d, g);l = f;return;
	    }function ge(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;a = a | 0 ? a : 956;Bb[c[a + 8 >> 2] & 1](a, b, d, e, f) | 0;if ((d | 0) == 5) Ta();else return;
	    }function he(b, c, d) {
	      b = b | 0;c = c | 0;d = d | 0;a[b + c >> 0] = d & 1;return;
	    }function ie(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;c[a >> 2] = 0;c[a + 4 >> 2] = 0;c[a + 8 >> 2] = 0;d = b + 4 | 0;e = (c[d >> 2] | 0) - (c[b >> 2] | 0) >> 2;if (e | 0) {
	        je(a, e);ke(a, c[b >> 2] | 0, c[d >> 2] | 0, e);
	      }return;
	    }function je(a, b) {
	      a = a | 0;b = b | 0;var d = 0;if ((le(a) | 0) >>> 0 < b >>> 0) jC(a);if (b >>> 0 > 1073741823) Ta();else {
	        d = qC(b << 2) | 0;c[a + 4 >> 2] = d;c[a >> 2] = d;c[a + 8 >> 2] = d + (b << 2);return;
	      }
	    }function ke(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;e = a + 4 | 0;a = d - b | 0;if ((a | 0) > 0) {
	        BC(c[e >> 2] | 0, b | 0, a | 0) | 0;c[e >> 2] = (c[e >> 2] | 0) + (a >>> 2 << 2);
	      }return;
	    }function le(a) {
	      a = a | 0;return 1073741823;
	    }function me(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);if (oe(b) | 0 ? (c[a + 96 >> 2] | 0) != 0 : 0) a = a + 92 | 0;else a = Tb(a + 60 | 0, c[1040 + (b << 2) >> 2] | 0, 992) | 0;return T(pe(a, d));
	    }function ne(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);if (oe(b) | 0 ? (c[a + 104 >> 2] | 0) != 0 : 0) a = a + 100 | 0;else a = Tb(a + 60 | 0, c[1e3 + (b << 2) >> 2] | 0, 992) | 0;return T(pe(a, d));
	    }function oe(a) {
	      a = a | 0;return (a | 1 | 0) == 3 | 0;
	    }function pe(a, b) {
	      a = a | 0;b = T(b);if ((c[a + 4 >> 2] | 0) == 3) b = T(0.0);else b = T(be(a, b));return T(b);
	    }function qe(a, b) {
	      a = a | 0;b = b | 0;a = c[a >> 2] | 0;return ((a | 0) == 0 ? (b | 0) > 1 ? b : 1 : a) | 0;
	    }function re(a, b) {
	      a = a | 0;b = b | 0;var c = 0;a: do if ((b | 0) == 2) {
	        switch (a | 0) {case 2:
	            {
	              a = 3;break a;
	            }case 3:
	            break;default:
	            {
	              c = 4;break a;
	            }}a = 2;
	      } else c = 4; while (0);return a | 0;
	    }function se(a, b) {
	      a = a | 0;b = b | 0;var d = ib;if (!((oe(b) | 0 ? (c[a + 312 >> 2] | 0) != 0 : 0) ? (d = T(g[a + 308 >> 2]), d >= T(0.0)) : 0)) d = T(cC(T(g[(Tb(a + 276 | 0, c[1040 + (b << 2) >> 2] | 0, 992) | 0) >> 2]), T(0.0)));return T(d);
	    }function te(a, b) {
	      a = a | 0;b = b | 0;var d = ib;if (!((oe(b) | 0 ? (c[a + 320 >> 2] | 0) != 0 : 0) ? (d = T(g[a + 316 >> 2]), d >= T(0.0)) : 0)) d = T(cC(T(g[(Tb(a + 276 | 0, c[1e3 + (b << 2) >> 2] | 0, 992) | 0) >> 2]), T(0.0)));return T(d);
	    }function ue(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = ib;if (!((oe(b) | 0 ? (c[a + 240 >> 2] | 0) != 0 : 0) ? (e = T(be(a + 236 | 0, d)), e >= T(0.0)) : 0)) e = T(cC(T(be(Tb(a + 204 | 0, c[1040 + (b << 2) >> 2] | 0, 992) | 0, d)), T(0.0)));return T(e);
	    }function ve(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = ib;if (!((oe(b) | 0 ? (c[a + 248 >> 2] | 0) != 0 : 0) ? (e = T(be(a + 244 | 0, d)), e >= T(0.0)) : 0)) e = T(cC(T(be(Tb(a + 204 | 0, c[1e3 + (b << 2) >> 2] | 0, 992) | 0, d)), T(0.0)));return T(e);
	    }function we(a, b, d, e, f, h, i) {
	      a = a | 0;b = T(b);d = T(d);e = e | 0;f = f | 0;h = T(h);i = T(i);var j = ib,
	          k = ib,
	          m = ib,
	          n = ib,
	          o = ib,
	          p = ib,
	          q = 0,
	          r = 0,
	          s = 0;s = l;l = l + 16 | 0;q = s;r = a + 964 | 0;ec(a, (c[r >> 2] | 0) != 0, 3519);j = T(Ce(a, 2, b));k = T(Ce(a, 0, b));m = T(Ud(a, 2, b));n = T(Ud(a, 0, b));if (Sb(b) | 0) o = b;else o = T(cC(T(0.0), T(T(b - m) - j)));if (Sb(d) | 0) p = d;else p = T(cC(T(0.0), T(T(d - n) - k)));if ((e | 0) == 1 & (f | 0) == 1) {
	        g[a + 908 >> 2] = T(Ie(a, 2, T(b - m), h, h));b = T(Ie(a, 0, T(d - n), i, h));
	      } else {
	        Db[c[r >> 2] & 1](q, a, o, e, p, f);o = T(j + T(g[q >> 2]));p = T(b - m);g[a + 908 >> 2] = T(Ie(a, 2, (e | 2 | 0) == 2 ? o : p, h, h));p = T(k + T(g[q + 4 >> 2]));b = T(d - n);b = T(Ie(a, 0, (f | 2 | 0) == 2 ? p : b, i, h));
	      }g[a + 912 >> 2] = b;l = s;return;
	    }function xe(a, b, c, d, e, f, h) {
	      a = a | 0;b = T(b);c = T(c);d = d | 0;e = e | 0;f = T(f);h = T(h);var i = ib,
	          j = ib,
	          k = ib,
	          l = ib;k = T(Ce(a, 2, f));i = T(Ce(a, 0, f));l = T(Ud(a, 2, f));j = T(Ud(a, 0, f));b = T(b - l);g[a + 908 >> 2] = T(Ie(a, 2, (d | 2 | 0) == 2 ? k : b, f, f));c = T(c - j);g[a + 912 >> 2] = T(Ie(a, 0, (e | 2 | 0) == 2 ? i : c, h, f));return;
	    }function ye(a, b, c, d, e, f, h) {
	      a = a | 0;b = T(b);c = T(c);d = d | 0;e = e | 0;f = T(f);h = T(h);var i = 0,
	          j = ib,
	          k = ib;i = (d | 0) == 2;if ((!(b <= T(0.0) & i) ? !(c <= T(0.0) & (e | 0) == 2) : 0) ? !((d | 0) == 1 & (e | 0) == 1) : 0) a = 0;else {
	        j = T(Ud(a, 0, f));k = T(Ud(a, 2, f));i = b < T(0.0) & i | (Sb(b) | 0);b = T(b - k);g[a + 908 >> 2] = T(Ie(a, 2, i ? T(0.0) : b, f, f));b = T(c - j);i = c < T(0.0) & (e | 0) == 2 | (Sb(c) | 0);g[a + 912 >> 2] = T(Ie(a, 0, i ? T(0.0) : b, h, f));a = 1;
	      }return a | 0;
	    }function ze(a, b) {
	      a = a | 0;b = b | 0;if (We(a) | 0) a = re(2, b) | 0;else a = 0;return a | 0;
	    }function Ae(a, b, c) {
	      a = a | 0;b = b | 0;c = T(c);c = T(ue(a, b, c));return T(c + T(se(a, b)));
	    }function Be(a, b, c) {
	      a = a | 0;b = b | 0;c = T(c);c = T(ve(a, b, c));return T(c + T(te(a, b)));
	    }function Ce(a, b, c) {
	      a = a | 0;b = b | 0;c = T(c);var d = ib;d = T(Ae(a, b, c));return T(d + T(Be(a, b, c)));
	    }function De(a) {
	      a = a | 0;if (!(c[a + 24 >> 2] | 0)) {
	        if (T(Ee(a)) != T(0.0)) a = 1;else a = T(Fe(a)) != T(0.0);
	      } else a = 0;return a | 0;
	    }function Ee(a) {
	      a = a | 0;var b = ib;if (c[a + 944 >> 2] | 0) {
	        b = T(g[a + 44 >> 2]);if (Sb(b) | 0) {
	          b = T(g[a + 40 >> 2]);a = b > T(0.0) & ((Sb(b) | 0) ^ 1);return T(a ? b : T(0.0));
	        }
	      } else b = T(0.0);return T(b);
	    }function Fe(b) {
	      b = b | 0;var d = ib,
	          e = 0,
	          f = ib;do if (c[b + 944 >> 2] | 0) {
	        d = T(g[b + 48 >> 2]);if (Sb(d) | 0) {
	          e = a[(c[b + 976 >> 2] | 0) + 2 >> 0] | 0;if (e << 24 >> 24 == 0 ? (f = T(g[b + 40 >> 2]), f < T(0.0) & ((Sb(f) | 0) ^ 1)) : 0) {
	            d = T(-f);break;
	          }d = e << 24 >> 24 ? T(1.0) : T(0.0);
	        }
	      } else d = T(0.0); while (0);return T(d);
	    }function Ge(b) {
	      b = b | 0;var d = 0,
	          e = 0;yC(b + 400 | 0, 0, 540) | 0;a[b + 985 >> 0] = 1;lc(b);e = $b(b) | 0;if (e | 0) {
	        d = b + 948 | 0;b = 0;do {
	          Ge(c[(c[d >> 2] | 0) + (b << 2) >> 2] | 0);b = b + 1 | 0;
	        } while ((b | 0) != (e | 0));
	      }return;
	    }function He(a, b, d, e, f, h, i, j, k, m) {
	      a = a | 0;b = b | 0;d = T(d);e = e | 0;f = T(f);h = T(h);i = T(i);j = j | 0;k = k | 0;m = m | 0;var n = 0,
	          o = ib,
	          p = 0,
	          q = 0,
	          r = ib,
	          s = ib,
	          u = 0,
	          v = ib,
	          w = 0,
	          x = ib,
	          y = 0,
	          z = 0,
	          A = 0,
	          B = 0,
	          C = 0,
	          D = 0,
	          E = 0,
	          F = 0,
	          G = 0,
	          H = 0;G = l;l = l + 16 | 0;A = G + 12 | 0;B = G + 8 | 0;C = G + 4 | 0;D = G;F = re(c[a + 4 >> 2] | 0, k) | 0;y = oe(F) | 0;o = T(be(Xe(b) | 0, y ? h : i));z = ae(b, 2, h) | 0;E = ae(b, 0, i) | 0;do if (!(Sb(o) | 0) ? !(Sb(y ? d : f) | 0) : 0) {
	        n = b + 504 | 0;if (!(Sb(T(g[n >> 2])) | 0)) {
	          if (!(Ye(c[b + 976 >> 2] | 0, 0) | 0)) break;if ((c[b + 500 >> 2] | 0) == (c[2278] | 0)) break;
	        }g[n >> 2] = T(cC(o, T(Ce(b, F, h))));
	      } else p = 7; while (0);do if ((p | 0) == 7) {
	        w = y ^ 1;if (!(w | z ^ 1)) {
	          i = T(be(c[b + 992 >> 2] | 0, h));g[b + 504 >> 2] = T(cC(i, T(Ce(b, 2, h))));break;
	        }if (!(y | E ^ 1)) {
	          i = T(be(c[b + 996 >> 2] | 0, i));g[b + 504 >> 2] = T(cC(i, T(Ce(b, 0, h))));break;
	        }g[A >> 2] = T(t);g[B >> 2] = T(t);c[C >> 2] = 0;c[D >> 2] = 0;v = T(Ud(b, 2, h));x = T(Ud(b, 0, h));if (z) {
	          r = T(v + T(be(c[b + 992 >> 2] | 0, h)));g[A >> 2] = r;c[C >> 2] = 1;q = 1;
	        } else {
	          q = 0;r = T(t);
	        }if (E) {
	          o = T(x + T(be(c[b + 996 >> 2] | 0, i)));g[B >> 2] = o;c[D >> 2] = 1;n = 1;
	        } else {
	          n = 0;o = T(t);
	        }p = c[a + 32 >> 2] | 0;if (!(y & (p | 0) == 2)) {
	          if (Sb(r) | 0 ? !(Sb(d) | 0) : 0) {
	            g[A >> 2] = d;c[C >> 2] = 2;q = 2;r = d;
	          }
	        } else p = 2;if ((!((p | 0) == 2 & w) ? Sb(o) | 0 : 0) ? !(Sb(f) | 0) : 0) {
	          g[B >> 2] = f;c[D >> 2] = 2;n = 2;o = f;
	        }s = T(g[b + 396 >> 2]);u = Sb(s) | 0;do if (!u) {
	          if ((q | 0) == 1 & w) {
	            g[B >> 2] = T(T(r - v) / s);c[D >> 2] = 1;n = 1;p = 1;break;
	          }if (y & (n | 0) == 1) {
	            g[A >> 2] = T(s * T(o - x));c[C >> 2] = 1;n = 1;p = 1;
	          } else p = q;
	        } else p = q; while (0);H = Sb(d) | 0;q = (Je(a, b) | 0) != 4;if (!(y | z | ((e | 0) != 1 | H) | (q | (p | 0) == 1)) ? (g[A >> 2] = d, c[C >> 2] = 1, !u) : 0) {
	          g[B >> 2] = T(T(d - v) / s);c[D >> 2] = 1;n = 1;
	        }if (!(E | w | ((j | 0) != 1 | (Sb(f) | 0)) | (q | (n | 0) == 1)) ? (g[B >> 2] = f, c[D >> 2] = 1, !u) : 0) {
	          g[A >> 2] = T(s * T(f - x));c[C >> 2] = 1;
	        }Me(b, 2, h, h, C, A);Me(b, 0, i, h, D, B);d = T(g[A >> 2]);f = T(g[B >> 2]);Td(b, d, f, k, c[C >> 2] | 0, c[D >> 2] | 0, h, i, 0, 3565, m) | 0;i = T(g[b + 908 + (c[976 + (F << 2) >> 2] << 2) >> 2]);g[b + 504 >> 2] = T(cC(i, T(Ce(b, F, h))));
	      } while (0);c[b + 500 >> 2] = c[2278];l = G;return;
	    }function Ie(a, b, c, d, e) {
	      a = a | 0;b = b | 0;c = T(c);d = T(d);e = T(e);d = T(Te(a, b, c, d));return T(cC(d, T(Ce(a, b, e))));
	    }function Je(a, b) {
	      a = a | 0;b = b | 0;b = b + 20 | 0;b = c[((c[b >> 2] | 0) == 0 ? a + 16 | 0 : b) >> 2] | 0;if ((b | 0) == 5 ? We(c[a + 4 >> 2] | 0) | 0 : 0) b = 1;return b | 0;
	    }function Ke(a, b) {
	      a = a | 0;b = b | 0;if (oe(b) | 0 ? (c[a + 96 >> 2] | 0) != 0 : 0) b = 4;else b = c[1040 + (b << 2) >> 2] | 0;return a + 60 + (b << 3) | 0;
	    }function Le(a, b) {
	      a = a | 0;b = b | 0;if (oe(b) | 0 ? (c[a + 104 >> 2] | 0) != 0 : 0) b = 5;else b = c[1e3 + (b << 2) >> 2] | 0;return a + 60 + (b << 3) | 0;
	    }function Me(a, b, d, e, f, h) {
	      a = a | 0;b = b | 0;d = T(d);e = T(e);f = f | 0;h = h | 0;d = T(be(a + 380 + (c[976 + (b << 2) >> 2] << 3) | 0, d));d = T(d + T(Ud(a, b, e)));switch (c[f >> 2] | 0) {case 2:case 1:
	          {
	            f = Sb(d) | 0;e = T(g[h >> 2]);g[h >> 2] = f | e < d ? e : d;break;
	          }case 0:
	          {
	            if (!(Sb(d) | 0)) {
	              c[f >> 2] = 2;g[h >> 2] = d;
	            }break;
	          }default:
	          {}}return;
	    }function Ne(a, b) {
	      a = a | 0;b = b | 0;a = a + 132 | 0;if (oe(b) | 0 ? (c[(Tb(a, 4, 948) | 0) + 4 >> 2] | 0) != 0 : 0) a = 1;else a = (c[(Tb(a, c[1040 + (b << 2) >> 2] | 0, 948) | 0) + 4 >> 2] | 0) != 0;return a | 0;
	    }function Oe(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0;a = a + 132 | 0;if (oe(b) | 0 ? (e = Tb(a, 4, 948) | 0, (c[e + 4 >> 2] | 0) != 0) : 0) f = 4;else {
	        e = Tb(a, c[1040 + (b << 2) >> 2] | 0, 948) | 0;if (!(c[e + 4 >> 2] | 0)) d = T(0.0);else f = 4;
	      }if ((f | 0) == 4) d = T(be(e, d));return T(d);
	    }function Pe(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = ib;e = T(g[a + 908 + (c[976 + (b << 2) >> 2] << 2) >> 2]);e = T(e + T(me(a, b, d)));return T(e + T(ne(a, b, d)));
	    }function Qe(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;a: do if (!(We(c[a + 4 >> 2] | 0) | 0)) {
	        if ((c[a + 16 >> 2] | 0) != 5) {
	          d = $b(a) | 0;if (!d) b = 0;else {
	            b = 0;while (1) {
	              e = ac(a, b) | 0;if ((c[e + 24 >> 2] | 0) == 0 ? (c[e + 20 >> 2] | 0) == 5 : 0) {
	                b = 1;break a;
	              }b = b + 1 | 0;if (b >>> 0 >= d >>> 0) {
	                b = 0;break;
	              }
	            }
	          }
	        } else b = 1;
	      } else b = 0; while (0);return b | 0;
	    }function Re(a, b) {
	      a = a | 0;b = b | 0;var d = ib;d = T(g[a + 908 + (c[976 + (b << 2) >> 2] << 2) >> 2]);return d >= T(0.0) & ((Sb(d) | 0) ^ 1) | 0;
	    }function Se(a) {
	      a = a | 0;var b = ib,
	          d = 0,
	          e = 0,
	          f = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = ib;d = c[a + 968 >> 2] | 0;if (!d) {
	        h = $b(a) | 0;do if (h | 0) {
	          d = 0;f = 0;while (1) {
	            e = ac(a, f) | 0;if (c[e + 940 >> 2] | 0) {
	              i = 8;break;
	            }if ((c[e + 24 >> 2] | 0) != 1) {
	              j = (Je(a, e) | 0) == 5;if (j) {
	                d = e;break;
	              } else d = (d | 0) == 0 ? e : d;
	            }f = f + 1 | 0;if (f >>> 0 >= h >>> 0) {
	              i = 8;break;
	            }
	          }if ((i | 0) == 8) if (!d) break;b = T(Se(d));return T(b + T(g[d + 404 >> 2]));
	        } while (0);b = T(g[a + 912 >> 2]);
	      } else {
	        k = T(g[a + 908 >> 2]);b = T(g[a + 912 >> 2]);b = T(mb[d & 0](a, k, b));ec(a, (Sb(b) | 0) ^ 1, 3573);
	      }return T(b);
	    }function Te(a, b, c, d) {
	      a = a | 0;b = b | 0;c = T(c);d = T(d);var e = ib,
	          f = 0;if (!(We(b) | 0)) {
	        if (oe(b) | 0) {
	          b = 0;f = 3;
	        } else {
	          d = T(t);e = T(t);
	        }
	      } else {
	        b = 1;f = 3;
	      }if ((f | 0) == 3) {
	        e = T(be(a + 364 + (b << 3) | 0, d));d = T(be(a + 380 + (b << 3) | 0, d));
	      }f = d < c & (d >= T(0.0) & ((Sb(d) | 0) ^ 1));c = f ? d : c;f = e >= T(0.0) & ((Sb(e) | 0) ^ 1) & c < e;return T(f ? e : c);
	    }function Ue(a, b, d, e, f, h, i) {
	      a = a | 0;b = b | 0;d = T(d);e = e | 0;f = T(f);h = h | 0;i = i | 0;var j = ib,
	          k = ib,
	          l = 0,
	          m = 0,
	          n = ib,
	          o = ib,
	          p = ib,
	          q = 0,
	          r = 0,
	          s = 0,
	          u = 0,
	          v = ib,
	          w = 0;s = re(c[a + 4 >> 2] | 0, h) | 0;q = ze(s, h) | 0;r = oe(s) | 0;n = T(Ud(b, 2, d));o = T(Ud(b, 0, d));if (!(ae(b, 2, d) | 0)) {
	        if (Ne(b, 2) | 0 ? Ze(b, 2) | 0 : 0) {
	          j = T(g[a + 908 >> 2]);k = T(se(a, 2));k = T(j - T(k + T(te(a, 2))));j = T(Oe(b, 2, d));j = T(Ie(b, 2, T(k - T(j + T(_e(b, 2, d)))), d, d));
	        } else j = T(t);
	      } else j = T(n + T(be(c[b + 992 >> 2] | 0, d)));if (!(ae(b, 0, f) | 0)) {
	        if (Ne(b, 0) | 0 ? Ze(b, 0) | 0 : 0) {
	          k = T(g[a + 912 >> 2]);v = T(se(a, 0));v = T(k - T(v + T(te(a, 0))));k = T(Oe(b, 0, f));k = T(Ie(b, 0, T(v - T(k + T(_e(b, 0, f)))), f, d));
	        } else k = T(t);
	      } else k = T(o + T(be(c[b + 996 >> 2] | 0, f)));l = Sb(j) | 0;m = Sb(k) | 0;do if (l ^ m ? (p = T(g[b + 396 >> 2]), !(Sb(p) | 0)) : 0) if (l) {
	        j = T(n + T(T(k - o) * p));break;
	      } else {
	        v = T(o + T(T(j - n) / p));k = m ? v : k;break;
	      } while (0);m = Sb(j) | 0;l = Sb(k) | 0;if (m | l) {
	        w = (m ^ 1) & 1;e = d > T(0.0) & ((e | 0) != 0 & m);j = r ? j : e ? d : j;Td(b, j, k, h, r ? w : e ? 2 : w, m & (l ^ 1) & 1, j, k, 0, 3623, i) | 0;j = T(g[b + 908 >> 2]);j = T(j + T(Ud(b, 2, d)));k = T(g[b + 912 >> 2]);k = T(k + T(Ud(b, 0, d)));
	      }Td(b, j, k, h, 1, 1, j, k, 1, 3635, i) | 0;if (Ze(b, s) | 0 ? !(Ne(b, s) | 0) : 0) {
	        w = c[976 + (s << 2) >> 2] | 0;v = T(g[a + 908 + (w << 2) >> 2]);v = T(v - T(g[b + 908 + (w << 2) >> 2]));v = T(v - T(te(a, s)));v = T(v - T(ne(b, s, d)));v = T(v - T(_e(b, s, r ? d : f)));g[b + 400 + (c[1040 + (s << 2) >> 2] << 2) >> 2] = v;
	      } else u = 21;do if ((u | 0) == 21) {
	        if (!(Ne(b, s) | 0) ? (c[a + 8 >> 2] | 0) == 1 : 0) {
	          w = c[976 + (s << 2) >> 2] | 0;v = T(g[a + 908 + (w << 2) >> 2]);v = T(T(v - T(g[b + 908 + (w << 2) >> 2])) * T(.5));g[b + 400 + (c[1040 + (s << 2) >> 2] << 2) >> 2] = v;break;
	        }if (!(Ne(b, s) | 0) ? (c[a + 8 >> 2] | 0) == 2 : 0) {
	          w = c[976 + (s << 2) >> 2] | 0;v = T(g[a + 908 + (w << 2) >> 2]);v = T(v - T(g[b + 908 + (w << 2) >> 2]));g[b + 400 + (c[1040 + (s << 2) >> 2] << 2) >> 2] = v;
	        }
	      } while (0);if (Ze(b, q) | 0 ? !(Ne(b, q) | 0) : 0) {
	        w = c[976 + (q << 2) >> 2] | 0;v = T(g[a + 908 + (w << 2) >> 2]);v = T(v - T(g[b + 908 + (w << 2) >> 2]));v = T(v - T(te(a, q)));v = T(v - T(ne(b, q, d)));v = T(v - T(_e(b, q, r ? f : d)));g[b + 400 + (c[1040 + (q << 2) >> 2] << 2) >> 2] = v;
	      } else u = 30;do if ((u | 0) == 30 ? !(Ne(b, q) | 0) : 0) {
	        if ((Je(a, b) | 0) == 2) {
	          w = c[976 + (q << 2) >> 2] | 0;v = T(g[a + 908 + (w << 2) >> 2]);v = T(T(v - T(g[b + 908 + (w << 2) >> 2])) * T(.5));g[b + 400 + (c[1040 + (q << 2) >> 2] << 2) >> 2] = v;break;
	        }w = (Je(a, b) | 0) == 3;if (w ^ (c[a + 28 >> 2] | 0) == 2) {
	          w = c[976 + (q << 2) >> 2] | 0;v = T(g[a + 908 + (w << 2) >> 2]);v = T(v - T(g[b + 908 + (w << 2) >> 2]));g[b + 400 + (c[1040 + (q << 2) >> 2] << 2) >> 2] = v;
	        }
	      } while (0);return;
	    }function Ve(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = ib,
	          f = 0;f = c[976 + (d << 2) >> 2] | 0;e = T(g[b + 908 + (f << 2) >> 2]);e = T(T(g[a + 908 + (f << 2) >> 2]) - e);e = T(e - T(g[b + 400 + (c[1040 + (d << 2) >> 2] << 2) >> 2]));g[b + 400 + (c[1e3 + (d << 2) >> 2] << 2) >> 2] = e;return;
	    }function We(a) {
	      a = a | 0;return (a | 1 | 0) == 1 | 0;
	    }function Xe(b) {
	      b = b | 0;var d = ib;switch (c[b + 56 >> 2] | 0) {case 0:case 3:
	          {
	            d = T(g[b + 40 >> 2]);if (d > T(0.0) & ((Sb(d) | 0) ^ 1)) b = a[(c[b + 976 >> 2] | 0) + 2 >> 0] | 0 ? 1056 : 992;else b = 1056;break;
	          }default:
	          b = b + 52 | 0;}return b | 0;
	    }function Ye(b, c) {
	      b = b | 0;c = c | 0;return (a[b + c >> 0] | 0) != 0 | 0;
	    }function Ze(a, b) {
	      a = a | 0;b = b | 0;a = a + 132 | 0;if (oe(b) | 0 ? (c[(Tb(a, 5, 948) | 0) + 4 >> 2] | 0) != 0 : 0) a = 1;else a = (c[(Tb(a, c[1e3 + (b << 2) >> 2] | 0, 948) | 0) + 4 >> 2] | 0) != 0;return a | 0;
	    }function _e(a, b, d) {
	      a = a | 0;b = b | 0;d = T(d);var e = 0,
	          f = 0;a = a + 132 | 0;if (oe(b) | 0 ? (e = Tb(a, 5, 948) | 0, (c[e + 4 >> 2] | 0) != 0) : 0) f = 4;else {
	        e = Tb(a, c[1e3 + (b << 2) >> 2] | 0, 948) | 0;if (!(c[e + 4 >> 2] | 0)) d = T(0.0);else f = 4;
	      }if ((f | 0) == 4) d = T(be(e, d));return T(d);
	    }function $e(a, b, c) {
	      a = a | 0;b = b | 0;c = T(c);if (Ne(a, b) | 0) c = T(Oe(a, b, c));else c = T(-T(_e(a, b, c)));return T(c);
	    }function af(a) {
	      a = T(a);return (g[j >> 2] = a, c[j >> 2] | 0) | 0;
	    }function bf(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 1073741823) Ta();else {
	          f = qC(b << 2) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 2) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 2);return;
	    }function cf(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 2) << 2) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function df(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -4 - b | 0) >>> 2) << 2);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function ef(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;h = a + 4 | 0;i = c[h >> 2] | 0;f = i - e | 0;g = f >> 2;a = b + (g << 2) | 0;if (a >>> 0 < d >>> 0) {
	        e = i;do {
	          c[e >> 2] = c[a >> 2];a = a + 4 | 0;e = (c[h >> 2] | 0) + 4 | 0;c[h >> 2] = e;
	        } while (a >>> 0 < d >>> 0);
	      }if (g | 0) GC(i + (0 - g << 2) | 0, b | 0, f | 0) | 0;return;
	    }function ff(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = b + 4 | 0;j = c[i >> 2] | 0;f = c[a >> 2] | 0;h = d;g = h - f | 0;e = j + (0 - (g >> 2) << 2) | 0;c[i >> 2] = e;if ((g | 0) > 0) BC(e | 0, f | 0, g | 0) | 0;f = a + 4 | 0;g = b + 8 | 0;e = (c[f >> 2] | 0) - h | 0;if ((e | 0) > 0) {
	        BC(c[g >> 2] | 0, d | 0, e | 0) | 0;c[g >> 2] = (c[g >> 2] | 0) + (e >>> 2 << 2);
	      }h = c[a >> 2] | 0;c[a >> 2] = c[i >> 2];c[i >> 2] = h;h = c[f >> 2] | 0;c[f >> 2] = c[g >> 2];c[g >> 2] = h;h = a + 8 | 0;d = b + 12 | 0;a = c[h >> 2] | 0;c[h >> 2] = c[d >> 2];c[d >> 2] = a;c[b >> 2] = c[i >> 2];return j | 0;
	    }function gf(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;h = c[b >> 2] | 0;g = c[d >> 2] | 0;if ((h | 0) != (g | 0)) {
	        f = a + 8 | 0;d = ((g + -4 - h | 0) >>> 2) + 1 | 0;a = h;e = c[f >> 2] | 0;do {
	          c[e >> 2] = c[a >> 2];e = (c[f >> 2] | 0) + 4 | 0;c[f >> 2] = e;a = a + 4 | 0;
	        } while ((a | 0) != (g | 0));c[b >> 2] = h + (d << 2);
	      }return;
	    }function hf() {
	      Qb();return;
	    }function jf() {
	      var a = 0;a = qC(4) | 0;kf(a);return a | 0;
	    }function kf(a) {
	      a = a | 0;c[a >> 2] = gc() | 0;return;
	    }function lf(a) {
	      a = a | 0;if (a | 0) {
	        mf(a);sC(a);
	      }return;
	    }function mf(a) {
	      a = a | 0;ic(c[a >> 2] | 0);return;
	    }function nf(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;he(c[a >> 2] | 0, b, d);return;
	    }function of(a, b) {
	      a = a | 0;b = T(b);Zd(c[a >> 2] | 0, b);return;
	    }function pf(a, b) {
	      a = a | 0;b = b | 0;return Ye(c[a >> 2] | 0, b) | 0;
	    }function qf() {
	      var a = 0;a = qC(8) | 0;rf(a, 0);return a | 0;
	    }function rf(a, b) {
	      a = a | 0;b = b | 0;if (!b) b = Wb() | 0;else b = Ub(c[b >> 2] | 0) | 0;c[a >> 2] = b;c[a + 4 >> 2] = 0;vc(b, a);return;
	    }function sf(a) {
	      a = a | 0;var b = 0;b = qC(8) | 0;rf(b, a);return b | 0;
	    }function tf(a) {
	      a = a | 0;if (a | 0) {
	        uf(a);sC(a);
	      }return;
	    }function uf(a) {
	      a = a | 0;var b = 0;Zb(c[a >> 2] | 0);b = a + 4 | 0;a = c[b >> 2] | 0;c[b >> 2] = 0;if (a | 0) {
	        vf(a);sC(a);
	      }return;
	    }function vf(a) {
	      a = a | 0;wf(a);return;
	    }function wf(a) {
	      a = a | 0;a = c[a >> 2] | 0;if (a | 0) ab(a | 0);return;
	    }function xf(a) {
	      a = a | 0;return wc(a) | 0;
	    }function yf(a) {
	      a = a | 0;var b = 0,
	          d = 0;d = a + 4 | 0;b = c[d >> 2] | 0;c[d >> 2] = 0;if (b | 0) {
	        vf(b);sC(b);
	      }dc(c[a >> 2] | 0);return;
	    }function zf(a, b) {
	      a = a | 0;b = b | 0;sc(c[a >> 2] | 0, c[b >> 2] | 0);return;
	    }function Af(a, b) {
	      a = a | 0;b = b | 0;Hc(c[a >> 2] | 0, b);return;
	    }function Bf(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;Vc(c[a >> 2] | 0, b, T(d));return;
	    }function Cf(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;Wc(c[a >> 2] | 0, b, T(d));return;
	    }function Df(a, b) {
	      a = a | 0;b = b | 0;Bc(c[a >> 2] | 0, b);return;
	    }function Ef(a, b) {
	      a = a | 0;b = b | 0;Dc(c[a >> 2] | 0, b);return;
	    }function Ff(a, b) {
	      a = a | 0;b = b | 0;Fc(c[a >> 2] | 0, b);return;
	    }function Gf(a, b) {
	      a = a | 0;b = b | 0;xc(c[a >> 2] | 0, b);return;
	    }function Hf(a, b) {
	      a = a | 0;b = b | 0;Jc(c[a >> 2] | 0, b);return;
	    }function If(a, b) {
	      a = a | 0;b = b | 0;zc(c[a >> 2] | 0, b);return;
	    }function Jf(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;Yc(c[a >> 2] | 0, b, T(d));return;
	    }function Kf(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;Zc(c[a >> 2] | 0, b, T(d));return;
	    }function Lf(a, b) {
	      a = a | 0;b = b | 0;$c(c[a >> 2] | 0, b);return;
	    }function Mf(a, b) {
	      a = a | 0;b = b | 0;Lc(c[a >> 2] | 0, b);return;
	    }function Nf(a, b) {
	      a = a | 0;b = b | 0;Nc(c[a >> 2] | 0, b);return;
	    }function Of(a, b) {
	      a = a | 0;b = +b;Pc(c[a >> 2] | 0, T(b));return;
	    }function Pf(a, b) {
	      a = a | 0;b = +b;Sc(c[a >> 2] | 0, T(b));return;
	    }function Qf(a, b) {
	      a = a | 0;b = +b;Tc(c[a >> 2] | 0, T(b));return;
	    }function Rf(a, b) {
	      a = a | 0;b = +b;Qc(c[a >> 2] | 0, T(b));return;
	    }function Sf(a, b) {
	      a = a | 0;b = +b;Rc(c[a >> 2] | 0, T(b));return;
	    }function Tf(a, b) {
	      a = a | 0;b = +b;fd(c[a >> 2] | 0, T(b));return;
	    }function Uf(a, b) {
	      a = a | 0;b = +b;gd(c[a >> 2] | 0, T(b));return;
	    }function Vf(a) {
	      a = a | 0;hd(c[a >> 2] | 0);return;
	    }function Wf(a, b) {
	      a = a | 0;b = +b;jd(c[a >> 2] | 0, T(b));return;
	    }function Xf(a, b) {
	      a = a | 0;b = +b;kd(c[a >> 2] | 0, T(b));return;
	    }function Yf(a) {
	      a = a | 0;ld(c[a >> 2] | 0);return;
	    }function Zf(a, b) {
	      a = a | 0;b = +b;nd(c[a >> 2] | 0, T(b));return;
	    }function _f(a, b) {
	      a = a | 0;b = +b;od(c[a >> 2] | 0, T(b));return;
	    }function $f(a, b) {
	      a = a | 0;b = +b;qd(c[a >> 2] | 0, T(b));return;
	    }function ag(a, b) {
	      a = a | 0;b = +b;rd(c[a >> 2] | 0, T(b));return;
	    }function bg(a, b) {
	      a = a | 0;b = +b;td(c[a >> 2] | 0, T(b));return;
	    }function cg(a, b) {
	      a = a | 0;b = +b;ud(c[a >> 2] | 0, T(b));return;
	    }function dg(a, b) {
	      a = a | 0;b = +b;wd(c[a >> 2] | 0, T(b));return;
	    }function eg(a, b) {
	      a = a | 0;b = +b;xd(c[a >> 2] | 0, T(b));return;
	    }function fg(a, b) {
	      a = a | 0;b = +b;zd(c[a >> 2] | 0, T(b));return;
	    }function gg(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;dd(c[a >> 2] | 0, b, T(d));return;
	    }function hg(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;ad(c[a >> 2] | 0, b, T(d));return;
	    }function ig(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;bd(c[a >> 2] | 0, b, T(d));return;
	    }function jg(a) {
	      a = a | 0;return Ic(c[a >> 2] | 0) | 0;
	    }function kg(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0;e = l;l = l + 16 | 0;f = e;Xc(f, c[b >> 2] | 0, d);lg(a, f);l = e;return;
	    }function lg(a, b) {
	      a = a | 0;b = b | 0;mg(a, c[b + 4 >> 2] | 0, +T(g[b >> 2]));return;
	    }function mg(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;c[a >> 2] = b;h[a + 8 >> 3] = d;return;
	    }function ng(a) {
	      a = a | 0;return Cc(c[a >> 2] | 0) | 0;
	    }function og(a) {
	      a = a | 0;return Ec(c[a >> 2] | 0) | 0;
	    }function pg(a) {
	      a = a | 0;return Gc(c[a >> 2] | 0) | 0;
	    }function qg(a) {
	      a = a | 0;return yc(c[a >> 2] | 0) | 0;
	    }function rg(a) {
	      a = a | 0;return Kc(c[a >> 2] | 0) | 0;
	    }function sg(a) {
	      a = a | 0;return Ac(c[a >> 2] | 0) | 0;
	    }function tg(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0;e = l;l = l + 16 | 0;f = e;_c(f, c[b >> 2] | 0, d);lg(a, f);l = e;return;
	    }function ug(a) {
	      a = a | 0;return Mc(c[a >> 2] | 0) | 0;
	    }function vg(a) {
	      a = a | 0;return Oc(c[a >> 2] | 0) | 0;
	    }function wg(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;Uc(e, c[b >> 2] | 0);lg(a, e);l = d;return;
	    }function xg(a) {
	      a = a | 0;return + +T(tc(c[a >> 2] | 0));
	    }function yg(a) {
	      a = a | 0;return + +T(uc(c[a >> 2] | 0));
	    }function zg(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;id(e, c[b >> 2] | 0);lg(a, e);l = d;return;
	    }function Ag(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;md(e, c[b >> 2] | 0);lg(a, e);l = d;return;
	    }function Bg(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;pd(e, c[b >> 2] | 0);lg(a, e);l = d;return;
	    }function Cg(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;sd(e, c[b >> 2] | 0);lg(a, e);l = d;return;
	    }function Dg(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;vd(e, c[b >> 2] | 0);lg(a, e);l = d;return;
	    }function Eg(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;yd(e, c[b >> 2] | 0);lg(a, e);l = d;return;
	    }function Fg(a) {
	      a = a | 0;return + +T(Ad(c[a >> 2] | 0));
	    }function Gg(a, b) {
	      a = a | 0;b = b | 0;return + +T(ed(c[a >> 2] | 0, b));
	    }function Hg(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0;e = l;l = l + 16 | 0;f = e;cd(f, c[b >> 2] | 0, d);lg(a, f);l = e;return;
	    }function Ig(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;kc(c[a >> 2] | 0, c[b >> 2] | 0, d);return;
	    }function Jg(a, b) {
	      a = a | 0;b = b | 0;cc(c[a >> 2] | 0, c[b >> 2] | 0);return;
	    }function Kg(a) {
	      a = a | 0;return $b(c[a >> 2] | 0) | 0;
	    }function Lg(a) {
	      a = a | 0;a = pc(c[a >> 2] | 0) | 0;if (!a) a = 0;else a = xf(a) | 0;return a | 0;
	    }function Mg(a, b) {
	      a = a | 0;b = b | 0;a = ac(c[a >> 2] | 0, b) | 0;if (!a) a = 0;else a = xf(a) | 0;return a | 0;
	    }function Ng(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;e = qC(4) | 0;Og(e, b);d = a + 4 | 0;b = c[d >> 2] | 0;c[d >> 2] = e;if (b | 0) {
	        vf(b);sC(b);
	      }jc(c[a >> 2] | 0, 1);return;
	    }function Og(a, b) {
	      a = a | 0;b = b | 0;gh(a, b);return;
	    }function Pg(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = T(c);d = d | 0;e = T(e);f = f | 0;var i = 0,
	          j = 0;i = l;l = l + 16 | 0;j = i;Qg(j, wc(b) | 0, +c, d, +e, f);g[a >> 2] = T(+h[j >> 3]);g[a + 4 >> 2] = T(+h[j + 8 >> 3]);l = i;return;
	    }function Qg(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = +d;e = e | 0;f = +f;g = g | 0;var i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;i = l;l = l + 32 | 0;n = i + 8 | 0;m = i + 20 | 0;k = i;j = i + 16 | 0;h[n >> 3] = d;c[m >> 2] = e;h[k >> 3] = f;c[j >> 2] = g;Rg(a, c[b + 4 >> 2] | 0, n, m, k, j);l = i;return;
	    }function Rg(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;var i = 0,
	          j = 0;i = l;l = l + 16 | 0;j = i;UA(j);b = Sg(b) | 0;Tg(a, b, +h[d >> 3], c[e >> 2] | 0, +h[f >> 3], c[g >> 2] | 0);WA(j);l = i;return;
	    }function Sg(a) {
	      a = a | 0;return c[a >> 2] | 0;
	    }function Tg(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = +c;d = d | 0;e = +e;f = f | 0;var g = 0;g = Vg(Ug() | 0) | 0;c = +Wg(c);d = Xg(d) | 0;e = +Wg(e);Yg(a, cb(0, g | 0, b | 0, +c, d | 0, +e, Xg(f) | 0) | 0);return;
	    }function Ug() {
	      var b = 0;if (!(a[7608] | 0)) {
	        dh(9120);b = 7608;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 9120;
	    }function Vg(a) {
	      a = a | 0;return c[a + 8 >> 2] | 0;
	    }function Wg(a) {
	      a = +a;return + +ch(a);
	    }function Xg(a) {
	      a = a | 0;return bh(a) | 0;
	    }function Yg(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0;f = l;l = l + 32 | 0;d = f;e = b;if (!(e & 1)) {
	        c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = c[b + 4 >> 2];c[a + 8 >> 2] = c[b + 8 >> 2];c[a + 12 >> 2] = c[b + 12 >> 2];
	      } else {
	        Zg(d, 0);Ja(e | 0, d | 0) | 0;_g(a, d);$g(d);
	      }l = f;return;
	    }function Zg(b, d) {
	      b = b | 0;d = d | 0;ah(b, d);c[b + 8 >> 2] = 0;a[b + 24 >> 0] = 0;return;
	    }function _g(a, b) {
	      a = a | 0;b = b | 0;b = b + 8 | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = c[b + 4 >> 2];c[a + 8 >> 2] = c[b + 8 >> 2];c[a + 12 >> 2] = c[b + 12 >> 2];return;
	    }function $g(b) {
	      b = b | 0;a[b + 24 >> 0] = 0;return;
	    }function ah(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = b;return;
	    }function bh(a) {
	      a = a | 0;return a | 0;
	    }function ch(a) {
	      a = +a;return +a;
	    }function dh(a) {
	      a = a | 0;fh(a, eh() | 0, 4);return;
	    }function eh() {
	      return 1064;
	    }function fh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;c[a + 8 >> 2] = _a(b | 0, d + 1 | 0) | 0;return;
	    }function gh(a, b) {
	      a = a | 0;b = b | 0;b = c[b >> 2] | 0;c[a >> 2] = b;Aa(b | 0);return;
	    }function hh(a) {
	      a = a | 0;var b = 0,
	          d = 0;d = a + 4 | 0;b = c[d >> 2] | 0;c[d >> 2] = 0;if (b | 0) {
	        vf(b);sC(b);
	      }jc(c[a >> 2] | 0, 0);return;
	    }function ih(a) {
	      a = a | 0;qc(c[a >> 2] | 0);return;
	    }function jh(a) {
	      a = a | 0;return rc(c[a >> 2] | 0) | 0;
	    }function kh(a, b, d, e) {
	      a = a | 0;b = +b;d = +d;e = e | 0;_d(c[a >> 2] | 0, T(b), T(d), e);return;
	    }function lh(a) {
	      a = a | 0;return + +T(Bd(c[a >> 2] | 0));
	    }function mh(a) {
	      a = a | 0;return + +T(Dd(c[a >> 2] | 0));
	    }function nh(a) {
	      a = a | 0;return + +T(Cd(c[a >> 2] | 0));
	    }function oh(a) {
	      a = a | 0;return + +T(Ed(c[a >> 2] | 0));
	    }function ph(a) {
	      a = a | 0;return + +T(Fd(c[a >> 2] | 0));
	    }function qh(a) {
	      a = a | 0;return + +T(Gd(c[a >> 2] | 0));
	    }function rh(a, b) {
	      a = a | 0;b = b | 0;h[a >> 3] = +T(Bd(c[b >> 2] | 0));h[a + 8 >> 3] = +T(Dd(c[b >> 2] | 0));h[a + 16 >> 3] = +T(Cd(c[b >> 2] | 0));h[a + 24 >> 3] = +T(Ed(c[b >> 2] | 0));h[a + 32 >> 3] = +T(Fd(c[b >> 2] | 0));h[a + 40 >> 3] = +T(Gd(c[b >> 2] | 0));return;
	    }function sh(a, b) {
	      a = a | 0;b = b | 0;return + +T(Hd(c[a >> 2] | 0, b));
	    }function th(a, b) {
	      a = a | 0;b = b | 0;return + +T(Id(c[a >> 2] | 0, b));
	    }function uh(a, b) {
	      a = a | 0;b = b | 0;return + +T(Jd(c[a >> 2] | 0, b));
	    }function vh() {
	      return fc() | 0;
	    }function wh() {
	      xh();yh();zh();Ah();Bh();Ch();return;
	    }function xh() {
	      kv(11713, 4938, 1);return;
	    }function yh() {
	      yu(10448);return;
	    }function zh() {
	      eu(10408);return;
	    }function Ah() {
	      vt(10324);return;
	    }function Bh() {
	      or(10096);return;
	    }function Ch() {
	      Dh(9132);return;
	    }function Dh(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0,
	          s = 0,
	          t = 0,
	          u = 0,
	          v = 0,
	          w = 0,
	          x = 0,
	          y = 0,
	          z = 0,
	          A = 0,
	          B = 0,
	          C = 0,
	          D = 0,
	          E = 0,
	          F = 0,
	          G = 0,
	          H = 0,
	          I = 0,
	          J = 0,
	          K = 0,
	          L = 0,
	          M = 0,
	          N = 0,
	          O = 0,
	          P = 0,
	          Q = 0,
	          R = 0,
	          S = 0,
	          T = 0,
	          U = 0,
	          V = 0,
	          W = 0,
	          X = 0,
	          Y = 0,
	          Z = 0,
	          _ = 0,
	          $ = 0,
	          aa = 0,
	          ba = 0,
	          ca = 0,
	          da = 0,
	          ea = 0,
	          fa = 0,
	          ga = 0,
	          ha = 0,
	          ia = 0,
	          ja = 0,
	          ka = 0,
	          la = 0,
	          ma = 0,
	          na = 0,
	          oa = 0,
	          pa = 0,
	          qa = 0,
	          ra = 0,
	          sa = 0,
	          ta = 0,
	          ua = 0,
	          va = 0,
	          wa = 0,
	          xa = 0,
	          ya = 0,
	          za = 0,
	          Aa = 0,
	          Ba = 0,
	          Ca = 0,
	          Da = 0,
	          Ea = 0,
	          Fa = 0,
	          Ga = 0;b = l;l = l + 672 | 0;d = b + 656 | 0;Ga = b + 648 | 0;Fa = b + 640 | 0;Ea = b + 632 | 0;Da = b + 624 | 0;Ca = b + 616 | 0;Ba = b + 608 | 0;Aa = b + 600 | 0;za = b + 592 | 0;ya = b + 584 | 0;xa = b + 576 | 0;wa = b + 568 | 0;va = b + 560 | 0;ua = b + 552 | 0;ta = b + 544 | 0;sa = b + 536 | 0;ra = b + 528 | 0;qa = b + 520 | 0;pa = b + 512 | 0;oa = b + 504 | 0;na = b + 496 | 0;ma = b + 488 | 0;la = b + 480 | 0;ka = b + 472 | 0;ja = b + 464 | 0;ia = b + 456 | 0;ha = b + 448 | 0;ga = b + 440 | 0;fa = b + 432 | 0;ea = b + 424 | 0;da = b + 416 | 0;ca = b + 408 | 0;ba = b + 400 | 0;aa = b + 392 | 0;$ = b + 384 | 0;_ = b + 376 | 0;Z = b + 368 | 0;Y = b + 360 | 0;X = b + 352 | 0;W = b + 344 | 0;V = b + 336 | 0;U = b + 328 | 0;T = b + 320 | 0;S = b + 312 | 0;R = b + 304 | 0;Q = b + 296 | 0;P = b + 288 | 0;O = b + 280 | 0;N = b + 272 | 0;M = b + 264 | 0;L = b + 256 | 0;K = b + 248 | 0;J = b + 240 | 0;I = b + 232 | 0;H = b + 224 | 0;G = b + 216 | 0;F = b + 208 | 0;E = b + 200 | 0;D = b + 192 | 0;C = b + 184 | 0;B = b + 176 | 0;A = b + 168 | 0;z = b + 160 | 0;y = b + 152 | 0;x = b + 144 | 0;w = b + 136 | 0;v = b + 128 | 0;u = b + 120 | 0;t = b + 112 | 0;s = b + 104 | 0;r = b + 96 | 0;q = b + 88 | 0;p = b + 80 | 0;o = b + 72 | 0;n = b + 64 | 0;m = b + 56 | 0;k = b + 48 | 0;j = b + 40 | 0;i = b + 32 | 0;h = b + 24 | 0;g = b + 16 | 0;f = b + 8 | 0;e = b;Eh(a, 3646);Fh(a, 3651, 2) | 0;Gh(a, 3665, 2) | 0;Hh(a, 3682, 18) | 0;c[Ga >> 2] = 19;c[Ga + 4 >> 2] = 0;c[d >> 2] = c[Ga >> 2];c[d + 4 >> 2] = c[Ga + 4 >> 2];Ih(a, 3690, d) | 0;c[Fa >> 2] = 1;c[Fa + 4 >> 2] = 0;c[d >> 2] = c[Fa >> 2];c[d + 4 >> 2] = c[Fa + 4 >> 2];Jh(a, 3696, d) | 0;c[Ea >> 2] = 2;c[Ea + 4 >> 2] = 0;c[d >> 2] = c[Ea >> 2];c[d + 4 >> 2] = c[Ea + 4 >> 2];Kh(a, 3706, d) | 0;c[Da >> 2] = 1;c[Da + 4 >> 2] = 0;c[d >> 2] = c[Da >> 2];c[d + 4 >> 2] = c[Da + 4 >> 2];Lh(a, 3722, d) | 0;c[Ca >> 2] = 2;c[Ca + 4 >> 2] = 0;c[d >> 2] = c[Ca >> 2];c[d + 4 >> 2] = c[Ca + 4 >> 2];Lh(a, 3734, d) | 0;c[Ba >> 2] = 3;c[Ba + 4 >> 2] = 0;c[d >> 2] = c[Ba >> 2];c[d + 4 >> 2] = c[Ba + 4 >> 2];Kh(a, 3753, d) | 0;c[Aa >> 2] = 4;c[Aa + 4 >> 2] = 0;c[d >> 2] = c[Aa >> 2];c[d + 4 >> 2] = c[Aa + 4 >> 2];Kh(a, 3769, d) | 0;c[za >> 2] = 5;c[za + 4 >> 2] = 0;c[d >> 2] = c[za >> 2];c[d + 4 >> 2] = c[za + 4 >> 2];Kh(a, 3783, d) | 0;c[ya >> 2] = 6;c[ya + 4 >> 2] = 0;c[d >> 2] = c[ya >> 2];c[d + 4 >> 2] = c[ya + 4 >> 2];Kh(a, 3796, d) | 0;c[xa >> 2] = 7;c[xa + 4 >> 2] = 0;c[d >> 2] = c[xa >> 2];c[d + 4 >> 2] = c[xa + 4 >> 2];Kh(a, 3813, d) | 0;c[wa >> 2] = 8;c[wa + 4 >> 2] = 0;c[d >> 2] = c[wa >> 2];c[d + 4 >> 2] = c[wa + 4 >> 2];Kh(a, 3825, d) | 0;c[va >> 2] = 3;c[va + 4 >> 2] = 0;c[d >> 2] = c[va >> 2];c[d + 4 >> 2] = c[va + 4 >> 2];Lh(a, 3843, d) | 0;c[ua >> 2] = 4;c[ua + 4 >> 2] = 0;c[d >> 2] = c[ua >> 2];c[d + 4 >> 2] = c[ua + 4 >> 2];Lh(a, 3853, d) | 0;c[ta >> 2] = 9;c[ta + 4 >> 2] = 0;c[d >> 2] = c[ta >> 2];c[d + 4 >> 2] = c[ta + 4 >> 2];Kh(a, 3870, d) | 0;c[sa >> 2] = 10;c[sa + 4 >> 2] = 0;c[d >> 2] = c[sa >> 2];c[d + 4 >> 2] = c[sa + 4 >> 2];Kh(a, 3884, d) | 0;c[ra >> 2] = 11;c[ra + 4 >> 2] = 0;c[d >> 2] = c[ra >> 2];c[d + 4 >> 2] = c[ra + 4 >> 2];Kh(a, 3896, d) | 0;c[qa >> 2] = 1;c[qa + 4 >> 2] = 0;c[d >> 2] = c[qa >> 2];c[d + 4 >> 2] = c[qa + 4 >> 2];Mh(a, 3907, d) | 0;c[pa >> 2] = 2;c[pa + 4 >> 2] = 0;c[d >> 2] = c[pa >> 2];c[d + 4 >> 2] = c[pa + 4 >> 2];Mh(a, 3915, d) | 0;c[oa >> 2] = 3;c[oa + 4 >> 2] = 0;c[d >> 2] = c[oa >> 2];c[d + 4 >> 2] = c[oa + 4 >> 2];Mh(a, 3928, d) | 0;c[na >> 2] = 4;c[na + 4 >> 2] = 0;c[d >> 2] = c[na >> 2];c[d + 4 >> 2] = c[na + 4 >> 2];Mh(a, 3948, d) | 0;c[ma >> 2] = 5;c[ma + 4 >> 2] = 0;c[d >> 2] = c[ma >> 2];c[d + 4 >> 2] = c[ma + 4 >> 2];Mh(a, 3960, d) | 0;c[la >> 2] = 6;c[la + 4 >> 2] = 0;c[d >> 2] = c[la >> 2];c[d + 4 >> 2] = c[la + 4 >> 2];Mh(a, 3974, d) | 0;c[ka >> 2] = 7;c[ka + 4 >> 2] = 0;c[d >> 2] = c[ka >> 2];c[d + 4 >> 2] = c[ka + 4 >> 2];Mh(a, 3983, d) | 0;c[ja >> 2] = 20;c[ja + 4 >> 2] = 0;c[d >> 2] = c[ja >> 2];c[d + 4 >> 2] = c[ja + 4 >> 2];Ih(a, 3999, d) | 0;c[ia >> 2] = 8;c[ia + 4 >> 2] = 0;c[d >> 2] = c[ia >> 2];c[d + 4 >> 2] = c[ia + 4 >> 2];Mh(a, 4012, d) | 0;c[ha >> 2] = 9;c[ha + 4 >> 2] = 0;c[d >> 2] = c[ha >> 2];c[d + 4 >> 2] = c[ha + 4 >> 2];Mh(a, 4022, d) | 0;c[ga >> 2] = 21;c[ga + 4 >> 2] = 0;c[d >> 2] = c[ga >> 2];c[d + 4 >> 2] = c[ga + 4 >> 2];Ih(a, 4039, d) | 0;c[fa >> 2] = 10;c[fa + 4 >> 2] = 0;c[d >> 2] = c[fa >> 2];c[d + 4 >> 2] = c[fa + 4 >> 2];Mh(a, 4053, d) | 0;c[ea >> 2] = 11;c[ea + 4 >> 2] = 0;c[d >> 2] = c[ea >> 2];c[d + 4 >> 2] = c[ea + 4 >> 2];Mh(a, 4065, d) | 0;c[da >> 2] = 12;c[da + 4 >> 2] = 0;c[d >> 2] = c[da >> 2];c[d + 4 >> 2] = c[da + 4 >> 2];Mh(a, 4084, d) | 0;c[ca >> 2] = 13;c[ca + 4 >> 2] = 0;c[d >> 2] = c[ca >> 2];c[d + 4 >> 2] = c[ca + 4 >> 2];Mh(a, 4097, d) | 0;c[ba >> 2] = 14;c[ba + 4 >> 2] = 0;c[d >> 2] = c[ba >> 2];c[d + 4 >> 2] = c[ba + 4 >> 2];Mh(a, 4117, d) | 0;c[aa >> 2] = 15;c[aa + 4 >> 2] = 0;c[d >> 2] = c[aa >> 2];c[d + 4 >> 2] = c[aa + 4 >> 2];Mh(a, 4129, d) | 0;c[$ >> 2] = 16;c[$ + 4 >> 2] = 0;c[d >> 2] = c[$ >> 2];c[d + 4 >> 2] = c[$ + 4 >> 2];Mh(a, 4148, d) | 0;c[_ >> 2] = 17;c[_ + 4 >> 2] = 0;c[d >> 2] = c[_ >> 2];c[d + 4 >> 2] = c[_ + 4 >> 2];Mh(a, 4161, d) | 0;c[Z >> 2] = 18;c[Z + 4 >> 2] = 0;c[d >> 2] = c[Z >> 2];c[d + 4 >> 2] = c[Z + 4 >> 2];Mh(a, 4181, d) | 0;c[Y >> 2] = 5;c[Y + 4 >> 2] = 0;c[d >> 2] = c[Y >> 2];c[d + 4 >> 2] = c[Y + 4 >> 2];Lh(a, 4196, d) | 0;c[X >> 2] = 6;c[X + 4 >> 2] = 0;c[d >> 2] = c[X >> 2];c[d + 4 >> 2] = c[X + 4 >> 2];Lh(a, 4206, d) | 0;c[W >> 2] = 7;c[W + 4 >> 2] = 0;c[d >> 2] = c[W >> 2];c[d + 4 >> 2] = c[W + 4 >> 2];Lh(a, 4217, d) | 0;c[V >> 2] = 3;c[V + 4 >> 2] = 0;c[d >> 2] = c[V >> 2];c[d + 4 >> 2] = c[V + 4 >> 2];Nh(a, 4235, d) | 0;c[U >> 2] = 1;c[U + 4 >> 2] = 0;c[d >> 2] = c[U >> 2];c[d + 4 >> 2] = c[U + 4 >> 2];Oh(a, 4251, d) | 0;c[T >> 2] = 4;c[T + 4 >> 2] = 0;c[d >> 2] = c[T >> 2];c[d + 4 >> 2] = c[T + 4 >> 2];Nh(a, 4263, d) | 0;c[S >> 2] = 5;c[S + 4 >> 2] = 0;c[d >> 2] = c[S >> 2];c[d + 4 >> 2] = c[S + 4 >> 2];Nh(a, 4279, d) | 0;c[R >> 2] = 6;c[R + 4 >> 2] = 0;c[d >> 2] = c[R >> 2];c[d + 4 >> 2] = c[R + 4 >> 2];Nh(a, 4293, d) | 0;c[Q >> 2] = 7;c[Q + 4 >> 2] = 0;c[d >> 2] = c[Q >> 2];c[d + 4 >> 2] = c[Q + 4 >> 2];Nh(a, 4306, d) | 0;c[P >> 2] = 8;c[P + 4 >> 2] = 0;c[d >> 2] = c[P >> 2];c[d + 4 >> 2] = c[P + 4 >> 2];Nh(a, 4323, d) | 0;c[O >> 2] = 9;c[O + 4 >> 2] = 0;c[d >> 2] = c[O >> 2];c[d + 4 >> 2] = c[O + 4 >> 2];Nh(a, 4335, d) | 0;c[N >> 2] = 2;c[N + 4 >> 2] = 0;c[d >> 2] = c[N >> 2];c[d + 4 >> 2] = c[N + 4 >> 2];Oh(a, 4353, d) | 0;c[M >> 2] = 12;c[M + 4 >> 2] = 0;c[d >> 2] = c[M >> 2];c[d + 4 >> 2] = c[M + 4 >> 2];Ph(a, 4363, d) | 0;c[L >> 2] = 1;c[L + 4 >> 2] = 0;c[d >> 2] = c[L >> 2];c[d + 4 >> 2] = c[L + 4 >> 2];Qh(a, 4376, d) | 0;c[K >> 2] = 2;c[K + 4 >> 2] = 0;c[d >> 2] = c[K >> 2];c[d + 4 >> 2] = c[K + 4 >> 2];Qh(a, 4388, d) | 0;c[J >> 2] = 13;c[J + 4 >> 2] = 0;c[d >> 2] = c[J >> 2];c[d + 4 >> 2] = c[J + 4 >> 2];Ph(a, 4402, d) | 0;c[I >> 2] = 14;c[I + 4 >> 2] = 0;c[d >> 2] = c[I >> 2];c[d + 4 >> 2] = c[I + 4 >> 2];Ph(a, 4411, d) | 0;c[H >> 2] = 15;c[H + 4 >> 2] = 0;c[d >> 2] = c[H >> 2];c[d + 4 >> 2] = c[H + 4 >> 2];Ph(a, 4421, d) | 0;c[G >> 2] = 16;c[G + 4 >> 2] = 0;c[d >> 2] = c[G >> 2];c[d + 4 >> 2] = c[G + 4 >> 2];Ph(a, 4433, d) | 0;c[F >> 2] = 17;c[F + 4 >> 2] = 0;c[d >> 2] = c[F >> 2];c[d + 4 >> 2] = c[F + 4 >> 2];Ph(a, 4446, d) | 0;c[E >> 2] = 18;c[E + 4 >> 2] = 0;c[d >> 2] = c[E >> 2];c[d + 4 >> 2] = c[E + 4 >> 2];Ph(a, 4458, d) | 0;c[D >> 2] = 3;c[D + 4 >> 2] = 0;c[d >> 2] = c[D >> 2];c[d + 4 >> 2] = c[D + 4 >> 2];Qh(a, 4471, d) | 0;c[C >> 2] = 1;c[C + 4 >> 2] = 0;c[d >> 2] = c[C >> 2];c[d + 4 >> 2] = c[C + 4 >> 2];Rh(a, 4486, d) | 0;c[B >> 2] = 10;c[B + 4 >> 2] = 0;c[d >> 2] = c[B >> 2];c[d + 4 >> 2] = c[B + 4 >> 2];Nh(a, 4496, d) | 0;c[A >> 2] = 11;c[A + 4 >> 2] = 0;c[d >> 2] = c[A >> 2];c[d + 4 >> 2] = c[A + 4 >> 2];Nh(a, 4508, d) | 0;c[z >> 2] = 3;c[z + 4 >> 2] = 0;c[d >> 2] = c[z >> 2];c[d + 4 >> 2] = c[z + 4 >> 2];Oh(a, 4519, d) | 0;c[y >> 2] = 4;c[y + 4 >> 2] = 0;c[d >> 2] = c[y >> 2];c[d + 4 >> 2] = c[y + 4 >> 2];Sh(a, 4530, d) | 0;c[x >> 2] = 19;c[x + 4 >> 2] = 0;c[d >> 2] = c[x >> 2];c[d + 4 >> 2] = c[x + 4 >> 2];Th(a, 4542, d) | 0;c[w >> 2] = 12;c[w + 4 >> 2] = 0;c[d >> 2] = c[w >> 2];c[d + 4 >> 2] = c[w + 4 >> 2];Uh(a, 4554, d) | 0;c[v >> 2] = 13;c[v + 4 >> 2] = 0;c[d >> 2] = c[v >> 2];c[d + 4 >> 2] = c[v + 4 >> 2];Vh(a, 4568, d) | 0;c[u >> 2] = 2;c[u + 4 >> 2] = 0;c[d >> 2] = c[u >> 2];c[d + 4 >> 2] = c[u + 4 >> 2];Wh(a, 4578, d) | 0;c[t >> 2] = 20;c[t + 4 >> 2] = 0;c[d >> 2] = c[t >> 2];c[d + 4 >> 2] = c[t + 4 >> 2];Xh(a, 4587, d) | 0;c[s >> 2] = 22;c[s + 4 >> 2] = 0;c[d >> 2] = c[s >> 2];c[d + 4 >> 2] = c[s + 4 >> 2];Ih(a, 4602, d) | 0;c[r >> 2] = 23;c[r + 4 >> 2] = 0;c[d >> 2] = c[r >> 2];c[d + 4 >> 2] = c[r + 4 >> 2];Ih(a, 4619, d) | 0;c[q >> 2] = 14;c[q + 4 >> 2] = 0;c[d >> 2] = c[q >> 2];c[d + 4 >> 2] = c[q + 4 >> 2];Yh(a, 4629, d) | 0;c[p >> 2] = 1;c[p + 4 >> 2] = 0;c[d >> 2] = c[p >> 2];c[d + 4 >> 2] = c[p + 4 >> 2];Zh(a, 4637, d) | 0;c[o >> 2] = 4;c[o + 4 >> 2] = 0;c[d >> 2] = c[o >> 2];c[d + 4 >> 2] = c[o + 4 >> 2];Qh(a, 4653, d) | 0;c[n >> 2] = 5;c[n + 4 >> 2] = 0;c[d >> 2] = c[n >> 2];c[d + 4 >> 2] = c[n + 4 >> 2];Qh(a, 4669, d) | 0;c[m >> 2] = 6;c[m + 4 >> 2] = 0;c[d >> 2] = c[m >> 2];c[d + 4 >> 2] = c[m + 4 >> 2];Qh(a, 4686, d) | 0;c[k >> 2] = 7;c[k + 4 >> 2] = 0;c[d >> 2] = c[k >> 2];c[d + 4 >> 2] = c[k + 4 >> 2];Qh(a, 4701, d) | 0;c[j >> 2] = 8;c[j + 4 >> 2] = 0;c[d >> 2] = c[j >> 2];c[d + 4 >> 2] = c[j + 4 >> 2];Qh(a, 4719, d) | 0;c[i >> 2] = 9;c[i + 4 >> 2] = 0;c[d >> 2] = c[i >> 2];c[d + 4 >> 2] = c[i + 4 >> 2];Qh(a, 4736, d) | 0;c[h >> 2] = 21;c[h + 4 >> 2] = 0;c[d >> 2] = c[h >> 2];c[d + 4 >> 2] = c[h + 4 >> 2];_h(a, 4754, d) | 0;c[g >> 2] = 2;c[g + 4 >> 2] = 0;c[d >> 2] = c[g >> 2];c[d + 4 >> 2] = c[g + 4 >> 2];Rh(a, 4772, d) | 0;c[f >> 2] = 3;c[f + 4 >> 2] = 0;c[d >> 2] = c[f >> 2];c[d + 4 >> 2] = c[f + 4 >> 2];Rh(a, 4790, d) | 0;c[e >> 2] = 4;c[e + 4 >> 2] = 0;c[d >> 2] = c[e >> 2];c[d + 4 >> 2] = c[e + 4 >> 2];Rh(a, 4808, d) | 0;l = b;return;
	    }function Eh(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = dr() | 0;c[a >> 2] = d;er(d, b);Hv(c[a >> 2] | 0);return;
	    }function Fh(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;Oq(a, ai(b) | 0, c, 0);return a | 0;
	    }function Gh(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;tq(a, ai(b) | 0, c, 0);return a | 0;
	    }function Hh(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;cq(a, ai(b) | 0, c, 0);return a | 0;
	    }function Ih(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Lp(a, b, f);l = e;return a | 0;
	    }function Jh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];pp(a, b, f);l = e;return a | 0;
	    }function Kh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Yo(a, b, f);l = e;return a | 0;
	    }function Lh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Fo(a, b, f);l = e;return a | 0;
	    }function Mh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];mo(a, b, f);l = e;return a | 0;
	    }function Nh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Un(a, b, f);l = e;return a | 0;
	    }function Oh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Bn(a, b, f);l = e;return a | 0;
	    }function Ph(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Um(a, b, f);l = e;return a | 0;
	    }function Qh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Bm(a, b, f);l = e;return a | 0;
	    }function Rh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];im(a, b, f);l = e;return a | 0;
	    }function Sh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Rl(a, b, f);l = e;return a | 0;
	    }function Th(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];vl(a, b, f);l = e;return a | 0;
	    }function Uh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];bl(a, b, f);l = e;return a | 0;
	    }function Vh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Kk(a, b, f);l = e;return a | 0;
	    }function Wh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];nk(a, b, f);l = e;return a | 0;
	    }function Xh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Rj(a, b, f);l = e;return a | 0;
	    }function Yh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];xj(a, b, f);l = e;return a | 0;
	    }function Zh(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];_i(a, b, f);l = e;return a | 0;
	    }function _h(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];$h(a, b, f);l = e;return a | 0;
	    }function $h(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];bi(a, d, f, 1);l = e;return;
	    }function ai(a) {
	      a = a | 0;return a | 0;
	    }function bi(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = ci() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = di(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, ei(g, e) | 0, e);l = f;return;
	    }function ci() {
	      var b = 0,
	          d = 0;if (!(a[7616] | 0)) {
	        qi(9136);Ha(24, 9136, o | 0) | 0;d = 7616;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9136) | 0)) {
	        b = 9136;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));qi(9136);
	      }return 9136;
	    }function di(a) {
	      a = a | 0;return 0;
	    }function ei(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = ci() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];ki(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        li(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function fi(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;var h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0;h = l;l = l + 32 | 0;o = h + 24 | 0;n = h + 20 | 0;j = h + 16 | 0;m = h + 12 | 0;k = h + 8 | 0;i = h + 4 | 0;p = h;c[n >> 2] = b;c[j >> 2] = d;c[m >> 2] = e;c[k >> 2] = f;c[i >> 2] = g;g = a + 28 | 0;c[p >> 2] = c[g >> 2];c[o >> 2] = c[p >> 2];gi(a + 24 | 0, o, n, m, k, j, i) | 0;c[g >> 2] = c[c[g >> 2] >> 2];l = h;return;
	    }function gi(a, b, d, e, f, g, h) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;h = h | 0;a = hi(b) | 0;b = qC(24) | 0;ii(b + 4 | 0, c[d >> 2] | 0, c[e >> 2] | 0, c[f >> 2] | 0, c[g >> 2] | 0, c[h >> 2] | 0);c[b >> 2] = c[a >> 2];c[a >> 2] = b;return b | 0;
	    }function hi(a) {
	      a = a | 0;return c[a >> 2] | 0;
	    }function ii(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;c[a + 8 >> 2] = e;c[a + 12 >> 2] = f;c[a + 16 >> 2] = g;return;
	    }function ji(a, b) {
	      a = a | 0;b = b | 0;return b | a | 0;
	    }function ki(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function li(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = mi(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;ni(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];ki(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;oi(a, i);pi(i);l = k;return;
	      }
	    }function mi(a) {
	      a = a | 0;return 357913941;
	    }function ni(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function oi(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function pi(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function qi(a) {
	      a = a | 0;ui(a);return;
	    }function ri(a) {
	      a = a | 0;ti(a + 24 | 0);return;
	    }function si(a) {
	      a = a | 0;return c[a >> 2] | 0;
	    }function ti(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function ui(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 3, b, wi() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function vi() {
	      return 9228;
	    }function wi() {
	      return 1140;
	    }function xi(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0;d = l;l = l + 16 | 0;e = d + 8 | 0;f = d;g = zi(a) | 0;a = c[g + 4 >> 2] | 0;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = a;c[e >> 2] = c[f >> 2];c[e + 4 >> 2] = c[f + 4 >> 2];b = Ai(b, e) | 0;l = d;return b | 0;
	    }function yi(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;c[a + 8 >> 2] = e;c[a + 12 >> 2] = f;c[a + 16 >> 2] = g;return;
	    }function zi(a) {
	      a = a | 0;return (c[(ci() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Ai(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0;f = l;l = l + 48 | 0;e = f;d = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;ob[d & 31](e, a);e = Bi(e) | 0;l = f;return e | 0;
	    }function Bi(a) {
	      a = a | 0;var b = 0,
	          c = 0,
	          d = 0,
	          e = 0;e = l;l = l + 32 | 0;b = e + 12 | 0;c = e;d = Di(Ci() | 0) | 0;if (!d) a = Ii(a) | 0;else {
	        Ei(b, d);Fi(c, b);Gi(a, c);a = Hi(b) | 0;
	      }l = e;return a | 0;
	    }function Ci() {
	      var b = 0;if (!(a[7632] | 0)) {
	        Ti(9184);Ha(25, 9184, o | 0) | 0;b = 7632;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 9184;
	    }function Di(a) {
	      a = a | 0;return c[a + 36 >> 2] | 0;
	    }function Ei(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = b;c[a + 4 >> 2] = a;c[a + 8 >> 2] = 0;return;
	    }function Fi(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = c[b + 4 >> 2];c[a + 8 >> 2] = 0;return;
	    }function Gi(a, b) {
	      a = a | 0;b = b | 0;Ni(b, a, a + 8 | 0, a + 16 | 0, a + 24 | 0, a + 32 | 0, a + 40 | 0) | 0;return;
	    }function Hi(a) {
	      a = a | 0;return c[(c[a + 4 >> 2] | 0) + 8 >> 2] | 0;
	    }function Ii(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;j = l;l = l + 16 | 0;d = j + 4 | 0;e = j;f = jy(8) | 0;g = f;h = qC(48) | 0;i = h;b = i + 48 | 0;do {
	        c[i >> 2] = c[a >> 2];i = i + 4 | 0;a = a + 4 | 0;
	      } while ((i | 0) < (b | 0));b = g + 4 | 0;c[b >> 2] = h;i = qC(8) | 0;h = c[b >> 2] | 0;c[e >> 2] = 0;c[d >> 2] = c[e >> 2];Ji(i, h, d);c[f >> 2] = i;l = j;return g | 0;
	    }function Ji(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;d = qC(16) | 0;c[d + 4 >> 2] = 0;c[d + 8 >> 2] = 0;c[d >> 2] = 1092;c[d + 12 >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function Ki(a) {
	      a = a | 0;kC(a);sC(a);return;
	    }function Li(a) {
	      a = a | 0;a = c[a + 12 >> 2] | 0;if (a | 0) sC(a);return;
	    }function Mi(a) {
	      a = a | 0;sC(a);return;
	    }function Ni(a, b, d, e, f, g, h) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;h = h | 0;g = Oi(c[a >> 2] | 0, b, d, e, f, g, h) | 0;h = a + 4 | 0;c[(c[h >> 2] | 0) + 8 >> 2] = g;return c[(c[h >> 2] | 0) + 8 >> 2] | 0;
	    }function Oi(a, b, c, d, e, f, g) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;var i = 0,
	          j = 0;i = l;l = l + 16 | 0;j = i;UA(j);a = Sg(a) | 0;g = Pi(a, +h[b >> 3], +h[c >> 3], +h[d >> 3], +h[e >> 3], +h[f >> 3], +h[g >> 3]) | 0;WA(j);l = i;return g | 0;
	    }function Pi(a, b, c, d, e, f, g) {
	      a = a | 0;b = +b;c = +c;d = +d;e = +e;f = +f;g = +g;var h = 0;h = Vg(Qi() | 0) | 0;b = +Wg(b);c = +Wg(c);d = +Wg(d);e = +Wg(e);f = +Wg(f);return ya(0, h | 0, a | 0, +b, +c, +d, +e, +f, + +Wg(g)) | 0;
	    }function Qi() {
	      var b = 0;if (!(a[7624] | 0)) {
	        Ri(9172);b = 7624;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 9172;
	    }function Ri(a) {
	      a = a | 0;fh(a, Si() | 0, 6);return;
	    }function Si() {
	      return 1112;
	    }function Ti(a) {
	      a = a | 0;Zi(a);return;
	    }function Ui(a) {
	      a = a | 0;Vi(a + 24 | 0);Wi(a + 16 | 0);return;
	    }function Vi(a) {
	      a = a | 0;Yi(a);return;
	    }function Wi(a) {
	      a = a | 0;Xi(a);return;
	    }function Xi(a) {
	      a = a | 0;var b = 0,
	          d = 0;b = c[a >> 2] | 0;if (b | 0) do {
	        d = b;b = c[b >> 2] | 0;sC(d);
	      } while ((b | 0) != 0);c[a >> 2] = 0;return;
	    }function Yi(a) {
	      a = a | 0;var b = 0,
	          d = 0;b = c[a >> 2] | 0;if (b | 0) do {
	        d = b;b = c[b >> 2] | 0;sC(d);
	      } while ((b | 0) != 0);c[a >> 2] = 0;return;
	    }function Zi(b) {
	      b = b | 0;var d = 0;c[b + 16 >> 2] = 0;c[b + 20 >> 2] = 0;d = b + 24 | 0;c[d >> 2] = 0;c[b + 28 >> 2] = d;c[b + 36 >> 2] = 0;a[b + 40 >> 0] = 0;a[b + 41 >> 0] = 0;return;
	    }function _i(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];$i(a, d, f, 0);l = e;return;
	    }function $i(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = aj() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = bj(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, cj(g, e) | 0, e);l = f;return;
	    }function aj() {
	      var b = 0,
	          d = 0;if (!(a[7640] | 0)) {
	        jj(9232);Ha(26, 9232, o | 0) | 0;d = 7640;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9232) | 0)) {
	        b = 9232;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));jj(9232);
	      }return 9232;
	    }function bj(a) {
	      a = a | 0;return 0;
	    }function cj(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = aj() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];dj(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        ej(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function dj(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function ej(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = fj(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;gj(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];dj(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;hj(a, i);ij(i);l = k;return;
	      }
	    }function fj(a) {
	      a = a | 0;return 357913941;
	    }function gj(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function hj(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function ij(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function jj(a) {
	      a = a | 0;mj(a);return;
	    }function kj(a) {
	      a = a | 0;lj(a + 24 | 0);return;
	    }function lj(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function mj(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 1, b, nj() | 0, 3);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function nj() {
	      return 1144;
	    }function oj(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = +d;e = +e;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0;g = l;l = l + 16 | 0;h = g + 8 | 0;i = g;j = pj(a) | 0;a = c[j + 4 >> 2] | 0;c[i >> 2] = c[j >> 2];c[i + 4 >> 2] = a;c[h >> 2] = c[i >> 2];c[h + 4 >> 2] = c[i + 4 >> 2];qj(b, h, d, e, f);l = g;return;
	    }function pj(a) {
	      a = a | 0;return (c[(aj() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function qj(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = +d;e = +e;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0;k = l;l = l + 16 | 0;h = k + 2 | 0;i = k + 1 | 0;j = k;g = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) g = c[(c[a >> 2] | 0) + g >> 2] | 0;rj(h, d);d = +sj(h, d);rj(i, e);e = +sj(i, e);tj(j, f);j = uj(j, f) | 0;qb[g & 1](a, d, e, j);l = k;return;
	    }function rj(a, b) {
	      a = a | 0;b = +b;return;
	    }function sj(a, b) {
	      a = a | 0;b = +b;return + +wj(b);
	    }function tj(a, b) {
	      a = a | 0;b = b | 0;return;
	    }function uj(a, b) {
	      a = a | 0;b = b | 0;return vj(b) | 0;
	    }function vj(a) {
	      a = a | 0;return a | 0;
	    }function wj(a) {
	      a = +a;return +a;
	    }function xj(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];yj(a, d, f, 1);l = e;return;
	    }function yj(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = zj() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Aj(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Bj(g, e) | 0, e);l = f;return;
	    }function zj() {
	      var b = 0,
	          d = 0;if (!(a[7648] | 0)) {
	        Ij(9268);Ha(27, 9268, o | 0) | 0;d = 7648;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9268) | 0)) {
	        b = 9268;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Ij(9268);
	      }return 9268;
	    }function Aj(a) {
	      a = a | 0;return 0;
	    }function Bj(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = zj() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Cj(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Dj(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Cj(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Dj(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Ej(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Fj(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Cj(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;Gj(a, i);Hj(i);l = k;return;
	      }
	    }function Ej(a) {
	      a = a | 0;return 357913941;
	    }function Fj(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function Gj(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Hj(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Ij(a) {
	      a = a | 0;Lj(a);return;
	    }function Jj(a) {
	      a = a | 0;Kj(a + 24 | 0);return;
	    }function Kj(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Lj(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 4, b, Mj() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Mj() {
	      return 1160;
	    }function Nj(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0;d = l;l = l + 16 | 0;e = d + 8 | 0;f = d;g = Oj(a) | 0;a = c[g + 4 >> 2] | 0;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = a;c[e >> 2] = c[f >> 2];c[e + 4 >> 2] = c[f + 4 >> 2];b = Pj(b, e) | 0;l = d;return b | 0;
	    }function Oj(a) {
	      a = a | 0;return (c[(zj() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Pj(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;return Qj(pb[d & 31](a) | 0) | 0;
	    }function Qj(a) {
	      a = a | 0;return a & 1 | 0;
	    }function Rj(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Sj(a, d, f, 0);l = e;return;
	    }function Sj(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Tj() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Uj(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Vj(g, e) | 0, e);l = f;return;
	    }function Tj() {
	      var b = 0,
	          d = 0;if (!(a[7656] | 0)) {
	        ak(9304);Ha(28, 9304, o | 0) | 0;d = 7656;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9304) | 0)) {
	        b = 9304;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));ak(9304);
	      }return 9304;
	    }function Uj(a) {
	      a = a | 0;return 0;
	    }function Vj(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Tj() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Wj(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Xj(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Wj(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Xj(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Yj(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Zj(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Wj(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;_j(a, i);$j(i);l = k;return;
	      }
	    }function Yj(a) {
	      a = a | 0;return 357913941;
	    }function Zj(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function _j(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function $j(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function ak(a) {
	      a = a | 0;dk(a);return;
	    }function bk(a) {
	      a = a | 0;ck(a + 24 | 0);return;
	    }function ck(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function dk(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 5, b, ek() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function ek() {
	      return 1164;
	    }function fk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = gk(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];hk(b, f, d);l = e;return;
	    }function gk(a) {
	      a = a | 0;return (c[(Tj() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function hk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;ik(f, d);d = jk(f, d) | 0;ob[e & 31](a, d);kk(f);l = g;return;
	    }function ik(a, b) {
	      a = a | 0;b = b | 0;lk(a, b);return;
	    }function jk(a, b) {
	      a = a | 0;b = b | 0;return a | 0;
	    }function kk(a) {
	      a = a | 0;vf(a);return;
	    }function lk(a, b) {
	      a = a | 0;b = b | 0;mk(a, b);return;
	    }function mk(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = b;return;
	    }function nk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];ok(a, d, f, 0);l = e;return;
	    }function ok(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = pk() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = qk(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, rk(g, e) | 0, e);l = f;return;
	    }function pk() {
	      var b = 0,
	          d = 0;if (!(a[7664] | 0)) {
	        yk(9340);Ha(29, 9340, o | 0) | 0;d = 7664;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9340) | 0)) {
	        b = 9340;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));yk(9340);
	      }return 9340;
	    }function qk(a) {
	      a = a | 0;return 0;
	    }function rk(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = pk() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];sk(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        tk(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function sk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function tk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = uk(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;vk(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];sk(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;wk(a, i);xk(i);l = k;return;
	      }
	    }function uk(a) {
	      a = a | 0;return 357913941;
	    }function vk(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function wk(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function xk(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function yk(a) {
	      a = a | 0;Bk(a);return;
	    }function zk(a) {
	      a = a | 0;Ak(a + 24 | 0);return;
	    }function Ak(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Bk(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 4, b, Ck() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Ck() {
	      return 1180;
	    }function Dk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = Ek(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];d = Fk(b, f, d) | 0;l = e;return d | 0;
	    }function Ek(a) {
	      a = a | 0;return (c[(pk() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Fk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;Gk(f, d);f = Hk(f, d) | 0;f = Ik(wb[e & 15](a, f) | 0) | 0;l = g;return f | 0;
	    }function Gk(a, b) {
	      a = a | 0;b = b | 0;return;
	    }function Hk(a, b) {
	      a = a | 0;b = b | 0;return Jk(b) | 0;
	    }function Ik(a) {
	      a = a | 0;return a | 0;
	    }function Jk(a) {
	      a = a | 0;return a | 0;
	    }function Kk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Lk(a, d, f, 0);l = e;return;
	    }function Lk(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Mk() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Nk(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Ok(g, e) | 0, e);l = f;return;
	    }function Mk() {
	      var b = 0,
	          d = 0;if (!(a[7672] | 0)) {
	        Vk(9376);Ha(30, 9376, o | 0) | 0;d = 7672;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9376) | 0)) {
	        b = 9376;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Vk(9376);
	      }return 9376;
	    }function Nk(a) {
	      a = a | 0;return 0;
	    }function Ok(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Mk() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Pk(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Qk(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Pk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Qk(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Rk(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Sk(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Pk(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;Tk(a, i);Uk(i);l = k;return;
	      }
	    }function Rk(a) {
	      a = a | 0;return 357913941;
	    }function Sk(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function Tk(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Uk(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Vk(a) {
	      a = a | 0;Yk(a);return;
	    }function Wk(a) {
	      a = a | 0;Xk(a + 24 | 0);return;
	    }function Xk(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Yk(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 5, b, Zk() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Zk() {
	      return 1196;
	    }function _k(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0;d = l;l = l + 16 | 0;e = d + 8 | 0;f = d;g = $k(a) | 0;a = c[g + 4 >> 2] | 0;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = a;c[e >> 2] = c[f >> 2];c[e + 4 >> 2] = c[f + 4 >> 2];b = al(b, e) | 0;l = d;return b | 0;
	    }function $k(a) {
	      a = a | 0;return (c[(Mk() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function al(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;return Ik(pb[d & 31](a) | 0) | 0;
	    }function bl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];cl(a, d, f, 1);l = e;return;
	    }function cl(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = dl() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = el(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, fl(g, e) | 0, e);l = f;return;
	    }function dl() {
	      var b = 0,
	          d = 0;if (!(a[7680] | 0)) {
	        ml(9412);Ha(31, 9412, o | 0) | 0;d = 7680;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9412) | 0)) {
	        b = 9412;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));ml(9412);
	      }return 9412;
	    }function el(a) {
	      a = a | 0;return 0;
	    }function fl(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = dl() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];gl(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        hl(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function gl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function hl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = il(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;jl(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];gl(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;kl(a, i);ll(i);l = k;return;
	      }
	    }function il(a) {
	      a = a | 0;return 357913941;
	    }function jl(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function kl(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function ll(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function ml(a) {
	      a = a | 0;pl(a);return;
	    }function nl(a) {
	      a = a | 0;ol(a + 24 | 0);return;
	    }function ol(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function pl(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 6, b, ql() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function ql() {
	      return 1200;
	    }function rl(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0;d = l;l = l + 16 | 0;e = d + 8 | 0;f = d;g = sl(a) | 0;a = c[g + 4 >> 2] | 0;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = a;c[e >> 2] = c[f >> 2];c[e + 4 >> 2] = c[f + 4 >> 2];b = tl(b, e) | 0;l = d;return b | 0;
	    }function sl(a) {
	      a = a | 0;return (c[(dl() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function tl(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;return ul(pb[d & 31](a) | 0) | 0;
	    }function ul(a) {
	      a = a | 0;return a | 0;
	    }function vl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];wl(a, d, f, 0);l = e;return;
	    }function wl(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = xl() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = yl(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, zl(g, e) | 0, e);l = f;return;
	    }function xl() {
	      var b = 0,
	          d = 0;if (!(a[7688] | 0)) {
	        Gl(9448);Ha(32, 9448, o | 0) | 0;d = 7688;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9448) | 0)) {
	        b = 9448;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Gl(9448);
	      }return 9448;
	    }function yl(a) {
	      a = a | 0;return 0;
	    }function zl(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = xl() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Al(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Bl(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Al(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Bl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Cl(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Dl(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Al(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;El(a, i);Fl(i);l = k;return;
	      }
	    }function Cl(a) {
	      a = a | 0;return 357913941;
	    }function Dl(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function El(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Fl(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Gl(a) {
	      a = a | 0;Jl(a);return;
	    }function Hl(a) {
	      a = a | 0;Il(a + 24 | 0);return;
	    }function Il(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Jl(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 6, b, Kl() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Kl() {
	      return 1204;
	    }function Ll(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = Ml(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Nl(b, f, d);l = e;return;
	    }function Ml(a) {
	      a = a | 0;return (c[(xl() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Nl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;Ol(f, d);f = Pl(f, d) | 0;ob[e & 31](a, f);l = g;return;
	    }function Ol(a, b) {
	      a = a | 0;b = b | 0;return;
	    }function Pl(a, b) {
	      a = a | 0;b = b | 0;return Ql(b) | 0;
	    }function Ql(a) {
	      a = a | 0;return a | 0;
	    }function Rl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Sl(a, d, f, 0);l = e;return;
	    }function Sl(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Tl() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Ul(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Vl(g, e) | 0, e);l = f;return;
	    }function Tl() {
	      var b = 0,
	          d = 0;if (!(a[7696] | 0)) {
	        am(9484);Ha(33, 9484, o | 0) | 0;d = 7696;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9484) | 0)) {
	        b = 9484;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));am(9484);
	      }return 9484;
	    }function Ul(a) {
	      a = a | 0;return 0;
	    }function Vl(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Tl() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Wl(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Xl(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Wl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Xl(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Yl(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Zl(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Wl(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;_l(a, i);$l(i);l = k;return;
	      }
	    }function Yl(a) {
	      a = a | 0;return 357913941;
	    }function Zl(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function _l(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function $l(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function am(a) {
	      a = a | 0;dm(a);return;
	    }function bm(a) {
	      a = a | 0;cm(a + 24 | 0);return;
	    }function cm(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function dm(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 1, b, em() | 0, 2);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function em() {
	      return 1212;
	    }function fm(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;f = l;l = l + 16 | 0;g = f + 8 | 0;h = f;i = gm(a) | 0;a = c[i + 4 >> 2] | 0;c[h >> 2] = c[i >> 2];c[h + 4 >> 2] = a;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = c[h + 4 >> 2];hm(b, g, d, e);l = f;return;
	    }function gm(a) {
	      a = a | 0;return (c[(Tl() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function hm(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;i = l;l = l + 16 | 0;g = i + 1 | 0;h = i;f = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) f = c[(c[a >> 2] | 0) + f >> 2] | 0;Ol(g, d);g = Pl(g, d) | 0;Gk(h, e);h = Hk(h, e) | 0;Eb[f & 15](a, g, h);l = i;return;
	    }function im(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];jm(a, d, f, 1);l = e;return;
	    }function jm(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = km() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = lm(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, mm(g, e) | 0, e);l = f;return;
	    }function km() {
	      var b = 0,
	          d = 0;if (!(a[7704] | 0)) {
	        tm(9520);Ha(34, 9520, o | 0) | 0;d = 7704;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9520) | 0)) {
	        b = 9520;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));tm(9520);
	      }return 9520;
	    }function lm(a) {
	      a = a | 0;return 0;
	    }function mm(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = km() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];nm(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        om(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function nm(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function om(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = pm(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;qm(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];nm(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;rm(a, i);sm(i);l = k;return;
	      }
	    }function pm(a) {
	      a = a | 0;return 357913941;
	    }function qm(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function rm(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function sm(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function tm(a) {
	      a = a | 0;wm(a);return;
	    }function um(a) {
	      a = a | 0;vm(a + 24 | 0);return;
	    }function vm(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function wm(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 1, b, xm() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function xm() {
	      return 1224;
	    }function ym(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0.0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;f = l;l = l + 16 | 0;g = f + 8 | 0;h = f;i = zm(a) | 0;a = c[i + 4 >> 2] | 0;c[h >> 2] = c[i >> 2];c[h + 4 >> 2] = a;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = c[h + 4 >> 2];e = +Am(b, g, d);l = f;return +e;
	    }function zm(a) {
	      a = a | 0;return (c[(km() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Am(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0.0;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;tj(f, d);f = uj(f, d) | 0;h = +ch(+zb[e & 7](a, f));l = g;return +h;
	    }function Bm(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Cm(a, d, f, 1);l = e;return;
	    }function Cm(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Dm() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Em(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Fm(g, e) | 0, e);l = f;return;
	    }function Dm() {
	      var b = 0,
	          d = 0;if (!(a[7712] | 0)) {
	        Mm(9556);Ha(35, 9556, o | 0) | 0;d = 7712;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9556) | 0)) {
	        b = 9556;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Mm(9556);
	      }return 9556;
	    }function Em(a) {
	      a = a | 0;return 0;
	    }function Fm(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Dm() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Gm(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Hm(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Gm(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Hm(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Im(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Jm(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Gm(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;Km(a, i);Lm(i);l = k;return;
	      }
	    }function Im(a) {
	      a = a | 0;return 357913941;
	    }function Jm(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function Km(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Lm(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Mm(a) {
	      a = a | 0;Pm(a);return;
	    }function Nm(a) {
	      a = a | 0;Om(a + 24 | 0);return;
	    }function Om(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Pm(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 5, b, Qm() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Qm() {
	      return 1232;
	    }function Rm(a, b) {
	      a = a | 0;b = b | 0;var d = 0.0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = Sm(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];d = +Tm(b, f);l = e;return +d;
	    }function Sm(a) {
	      a = a | 0;return (c[(Dm() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Tm(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;return + +ch(+ub[d & 15](a));
	    }function Um(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Vm(a, d, f, 1);l = e;return;
	    }function Vm(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Wm() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Xm(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Ym(g, e) | 0, e);l = f;return;
	    }function Wm() {
	      var b = 0,
	          d = 0;if (!(a[7720] | 0)) {
	        dn(9592);Ha(36, 9592, o | 0) | 0;d = 7720;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9592) | 0)) {
	        b = 9592;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));dn(9592);
	      }return 9592;
	    }function Xm(a) {
	      a = a | 0;return 0;
	    }function Ym(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Wm() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Zm(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        _m(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Zm(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function _m(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = $m(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;an(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Zm(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;bn(a, i);cn(i);l = k;return;
	      }
	    }function $m(a) {
	      a = a | 0;return 357913941;
	    }function an(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function bn(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function cn(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function dn(a) {
	      a = a | 0;gn(a);return;
	    }function en(a) {
	      a = a | 0;fn(a + 24 | 0);return;
	    }function fn(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function gn(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 7, b, hn() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function hn() {
	      return 1276;
	    }function jn(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0;d = l;l = l + 16 | 0;e = d + 8 | 0;f = d;g = kn(a) | 0;a = c[g + 4 >> 2] | 0;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = a;c[e >> 2] = c[f >> 2];c[e + 4 >> 2] = c[f + 4 >> 2];b = ln(b, e) | 0;l = d;return b | 0;
	    }function kn(a) {
	      a = a | 0;return (c[(Wm() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function ln(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0;f = l;l = l + 16 | 0;e = f;d = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;ob[d & 31](e, a);e = mn(e) | 0;l = f;return e | 0;
	    }function mn(a) {
	      a = a | 0;var b = 0,
	          c = 0,
	          d = 0,
	          e = 0;e = l;l = l + 32 | 0;b = e + 12 | 0;c = e;d = Di(nn() | 0) | 0;if (!d) a = pn(a) | 0;else {
	        Ei(b, d);Fi(c, b);on(a, c);a = Hi(b) | 0;
	      }l = e;return a | 0;
	    }function nn() {
	      var b = 0;if (!(a[7736] | 0)) {
	        An(9640);Ha(25, 9640, o | 0) | 0;b = 7736;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 9640;
	    }function on(a, b) {
	      a = a | 0;b = b | 0;un(b, a, a + 8 | 0) | 0;return;
	    }
	    function pn(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;d = l;l = l + 16 | 0;f = d + 4 | 0;h = d;e = jy(8) | 0;b = e;i = qC(16) | 0;c[i >> 2] = c[a >> 2];c[i + 4 >> 2] = c[a + 4 >> 2];c[i + 8 >> 2] = c[a + 8 >> 2];c[i + 12 >> 2] = c[a + 12 >> 2];g = b + 4 | 0;c[g >> 2] = i;a = qC(8) | 0;g = c[g >> 2] | 0;c[h >> 2] = 0;c[f >> 2] = c[h >> 2];qn(a, g, f);c[e >> 2] = a;l = d;return b | 0;
	    }function qn(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;d = qC(16) | 0;c[d + 4 >> 2] = 0;c[d + 8 >> 2] = 0;c[d >> 2] = 1244;c[d + 12 >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function rn(a) {
	      a = a | 0;kC(a);sC(a);return;
	    }function sn(a) {
	      a = a | 0;a = c[a + 12 >> 2] | 0;if (a | 0) sC(a);return;
	    }function tn(a) {
	      a = a | 0;sC(a);return;
	    }function un(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;b = vn(c[a >> 2] | 0, b, d) | 0;d = a + 4 | 0;c[(c[d >> 2] | 0) + 8 >> 2] = b;return c[(c[d >> 2] | 0) + 8 >> 2] | 0;
	    }function vn(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0;e = l;l = l + 16 | 0;f = e;UA(f);a = Sg(a) | 0;d = wn(a, c[b >> 2] | 0, +h[d >> 3]) | 0;WA(f);l = e;return d | 0;
	    }function wn(a, b, c) {
	      a = a | 0;b = b | 0;c = +c;var d = 0;d = Vg(xn() | 0) | 0;b = Xg(b) | 0;return za(0, d | 0, a | 0, b | 0, + +Wg(c)) | 0;
	    }function xn() {
	      var b = 0;if (!(a[7728] | 0)) {
	        yn(9628);b = 7728;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 9628;
	    }function yn(a) {
	      a = a | 0;fh(a, zn() | 0, 2);return;
	    }function zn() {
	      return 1264;
	    }function An(a) {
	      a = a | 0;Zi(a);return;
	    }function Bn(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Cn(a, d, f, 1);l = e;return;
	    }function Cn(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Dn() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = En(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Fn(g, e) | 0, e);l = f;return;
	    }function Dn() {
	      var b = 0,
	          d = 0;if (!(a[7744] | 0)) {
	        Mn(9684);Ha(37, 9684, o | 0) | 0;d = 7744;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9684) | 0)) {
	        b = 9684;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Mn(9684);
	      }return 9684;
	    }function En(a) {
	      a = a | 0;return 0;
	    }function Fn(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Dn() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Gn(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Hn(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Gn(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Hn(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = In(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Jn(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Gn(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;Kn(a, i);Ln(i);l = k;return;
	      }
	    }function In(a) {
	      a = a | 0;return 357913941;
	    }function Jn(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function Kn(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Ln(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Mn(a) {
	      a = a | 0;Pn(a);return;
	    }function Nn(a) {
	      a = a | 0;On(a + 24 | 0);return;
	    }function On(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Pn(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 5, b, Qn() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Qn() {
	      return 1280;
	    }function Rn(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = Sn(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];d = Tn(b, f, d) | 0;l = e;return d | 0;
	    }function Sn(a) {
	      a = a | 0;return (c[(Dn() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Tn(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;h = l;l = l + 32 | 0;f = h;g = h + 16 | 0;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;tj(g, d);g = uj(g, d) | 0;Eb[e & 15](f, a, g);g = mn(f) | 0;l = h;return g | 0;
	    }function Un(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Vn(a, d, f, 1);l = e;return;
	    }function Vn(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Wn() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Xn(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Yn(g, e) | 0, e);l = f;return;
	    }function Wn() {
	      var b = 0,
	          d = 0;if (!(a[7752] | 0)) {
	        eo(9720);Ha(38, 9720, o | 0) | 0;d = 7752;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9720) | 0)) {
	        b = 9720;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));eo(9720);
	      }return 9720;
	    }function Xn(a) {
	      a = a | 0;return 0;
	    }function Yn(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Wn() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Zn(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        _n(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Zn(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function _n(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = $n(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;ao(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Zn(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;bo(a, i);co(i);l = k;return;
	      }
	    }function $n(a) {
	      a = a | 0;return 357913941;
	    }function ao(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function bo(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function co(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function eo(a) {
	      a = a | 0;ho(a);return;
	    }function fo(a) {
	      a = a | 0;go(a + 24 | 0);return;
	    }function go(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function ho(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 8, b, io() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function io() {
	      return 1288;
	    }function jo(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0;d = l;l = l + 16 | 0;e = d + 8 | 0;f = d;g = ko(a) | 0;a = c[g + 4 >> 2] | 0;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = a;c[e >> 2] = c[f >> 2];c[e + 4 >> 2] = c[f + 4 >> 2];b = lo(b, e) | 0;l = d;return b | 0;
	    }function ko(a) {
	      a = a | 0;return (c[(Wn() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function lo(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;return bh(pb[d & 31](a) | 0) | 0;
	    }function mo(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];no(a, d, f, 0);l = e;return;
	    }function no(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = oo() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = po(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, qo(g, e) | 0, e);l = f;return;
	    }function oo() {
	      var b = 0,
	          d = 0;if (!(a[7760] | 0)) {
	        xo(9756);Ha(39, 9756, o | 0) | 0;d = 7760;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9756) | 0)) {
	        b = 9756;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));xo(9756);
	      }return 9756;
	    }function po(a) {
	      a = a | 0;return 0;
	    }function qo(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = oo() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];ro(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        so(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function ro(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function so(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = to(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;uo(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];ro(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;vo(a, i);wo(i);l = k;return;
	      }
	    }function to(a) {
	      a = a | 0;return 357913941;
	    }function uo(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function vo(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function wo(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function xo(a) {
	      a = a | 0;Ao(a);return;
	    }function yo(a) {
	      a = a | 0;zo(a + 24 | 0);return;
	    }function zo(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Ao(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 8, b, Bo() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Bo() {
	      return 1292;
	    }function Co(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = Do(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Eo(b, f, d);l = e;return;
	    }function Do(a) {
	      a = a | 0;return (c[(oo() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Eo(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;var e = 0,
	          f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;rj(f, d);d = +sj(f, d);lb[e & 31](a, d);l = g;return;
	    }function Fo(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Go(a, d, f, 0);l = e;return;
	    }function Go(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Ho() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Io(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Jo(g, e) | 0, e);l = f;return;
	    }function Ho() {
	      var b = 0,
	          d = 0;if (!(a[7768] | 0)) {
	        Qo(9792);Ha(40, 9792, o | 0) | 0;d = 7768;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9792) | 0)) {
	        b = 9792;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Qo(9792);
	      }return 9792;
	    }function Io(a) {
	      a = a | 0;return 0;
	    }function Jo(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Ho() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Ko(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Lo(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Ko(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Lo(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Mo(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;No(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Ko(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;Oo(a, i);Po(i);l = k;return;
	      }
	    }function Mo(a) {
	      a = a | 0;return 357913941;
	    }function No(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function Oo(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Po(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Qo(a) {
	      a = a | 0;To(a);return;
	    }function Ro(a) {
	      a = a | 0;So(a + 24 | 0);return;
	    }function So(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function To(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 1, b, Uo() | 0, 2);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Uo() {
	      return 1300;
	    }function Vo(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = +e;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;f = l;l = l + 16 | 0;g = f + 8 | 0;h = f;i = Wo(a) | 0;a = c[i + 4 >> 2] | 0;c[h >> 2] = c[i >> 2];c[h + 4 >> 2] = a;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = c[h + 4 >> 2];Xo(b, g, d, e);l = f;return;
	    }function Wo(a) {
	      a = a | 0;return (c[(Ho() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Xo(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = +e;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;i = l;l = l + 16 | 0;g = i + 1 | 0;h = i;f = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) f = c[(c[a >> 2] | 0) + f >> 2] | 0;tj(g, d);g = uj(g, d) | 0;rj(h, e);e = +sj(h, e);Gb[f & 15](a, g, e);l = i;return;
	    }function Yo(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Zo(a, d, f, 0);l = e;return;
	    }function Zo(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = _o() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = $o(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, ap(g, e) | 0, e);l = f;return;
	    }function _o() {
	      var b = 0,
	          d = 0;if (!(a[7776] | 0)) {
	        hp(9828);Ha(41, 9828, o | 0) | 0;d = 7776;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9828) | 0)) {
	        b = 9828;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));hp(9828);
	      }return 9828;
	    }function $o(a) {
	      a = a | 0;return 0;
	    }function ap(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = _o() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];bp(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        cp(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function bp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function cp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = dp(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;ep(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];bp(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;fp(a, i);gp(i);l = k;return;
	      }
	    }function dp(a) {
	      a = a | 0;return 357913941;
	    }function ep(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function fp(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function gp(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function hp(a) {
	      a = a | 0;kp(a);return;
	    }function ip(a) {
	      a = a | 0;jp(a + 24 | 0);return;
	    }function jp(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function kp(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 7, b, lp() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function lp() {
	      return 1312;
	    }function mp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = np(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];op(b, f, d);l = e;return;
	    }function np(a) {
	      a = a | 0;return (c[(_o() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function op(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;tj(f, d);f = uj(f, d) | 0;ob[e & 31](a, f);l = g;return;
	    }function pp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];qp(a, d, f, 0);l = e;return;
	    }function qp(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = rp() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = sp(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, tp(g, e) | 0, e);l = f;return;
	    }function rp() {
	      var b = 0,
	          d = 0;if (!(a[7784] | 0)) {
	        Ap(9864);Ha(42, 9864, o | 0) | 0;d = 7784;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9864) | 0)) {
	        b = 9864;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Ap(9864);
	      }return 9864;
	    }function sp(a) {
	      a = a | 0;return 0;
	    }function tp(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = rp() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];up(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        vp(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function up(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function vp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = wp(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;xp(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];up(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;yp(a, i);zp(i);l = k;return;
	      }
	    }function wp(a) {
	      a = a | 0;return 357913941;
	    }function xp(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function yp(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function zp(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Ap(a) {
	      a = a | 0;Dp(a);return;
	    }function Bp(a) {
	      a = a | 0;Cp(a + 24 | 0);return;
	    }function Cp(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Dp(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 8, b, Ep() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Ep() {
	      return 1320;
	    }function Fp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = Gp(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Hp(b, f, d);l = e;return;
	    }function Gp(a) {
	      a = a | 0;return (c[(rp() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Hp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;Ip(f, d);f = Jp(f, d) | 0;ob[e & 31](a, f);l = g;return;
	    }function Ip(a, b) {
	      a = a | 0;b = b | 0;return;
	    }function Jp(a, b) {
	      a = a | 0;b = b | 0;return Kp(b) | 0;
	    }function Kp(a) {
	      a = a | 0;return a | 0;
	    }function Lp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Mp(a, d, f, 0);l = e;return;
	    }function Mp(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Np() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Op(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Pp(g, e) | 0, e);l = f;return;
	    }function Np() {
	      var b = 0,
	          d = 0;if (!(a[7792] | 0)) {
	        Wp(9900);Ha(43, 9900, o | 0) | 0;d = 7792;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9900) | 0)) {
	        b = 9900;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Wp(9900);
	      }return 9900;
	    }function Op(a) {
	      a = a | 0;return 0;
	    }function Pp(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Np() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Qp(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Rp(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Qp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Rp(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Sp(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Tp(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Qp(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;Up(a, i);Vp(i);l = k;return;
	      }
	    }function Sp(a) {
	      a = a | 0;return 357913941;
	    }function Tp(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function Up(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Vp(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Wp(a) {
	      a = a | 0;Zp(a);return;
	    }function Xp(a) {
	      a = a | 0;Yp(a + 24 | 0);return;
	    }function Yp(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Zp(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 22, b, _p() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function _p() {
	      return 1344;
	    }function $p(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0;d = l;l = l + 16 | 0;e = d + 8 | 0;f = d;g = aq(a) | 0;a = c[g + 4 >> 2] | 0;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = a;c[e >> 2] = c[f >> 2];c[e + 4 >> 2] = c[f + 4 >> 2];bq(b, e);l = d;return;
	    }function aq(a) {
	      a = a | 0;return (c[(Np() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function bq(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;nb[d & 127](a);return;
	    }function cq(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = dq() | 0;a = eq(d) | 0;fi(g, b, f, a, fq(d, e) | 0, e);return;
	    }function dq() {
	      var b = 0,
	          d = 0;if (!(a[7800] | 0)) {
	        mq(9936);Ha(44, 9936, o | 0) | 0;d = 7800;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9936) | 0)) {
	        b = 9936;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));mq(9936);
	      }return 9936;
	    }function eq(a) {
	      a = a | 0;return a | 0;
	    }function fq(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = dq() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        gq(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        hq(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function gq(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function hq(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = iq(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;jq(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;gq(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;kq(a, f);lq(f);l = i;return;
	      }
	    }function iq(a) {
	      a = a | 0;return 536870911;
	    }function jq(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function kq(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function lq(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function mq(a) {
	      a = a | 0;pq(a);return;
	    }function nq(a) {
	      a = a | 0;oq(a + 24 | 0);return;
	    }function oq(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function pq(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 23, b, Kl() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function qq(a, b) {
	      a = a | 0;b = b | 0;sq(c[(rq(a) | 0) >> 2] | 0, b);return;
	    }function rq(a) {
	      a = a | 0;return (c[(dq() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function sq(a, b) {
	      a = a | 0;b = b | 0;var c = 0,
	          d = 0;c = l;l = l + 16 | 0;d = c;Ol(d, b);b = Pl(d, b) | 0;nb[a & 127](b);l = c;return;
	    }function tq(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = uq() | 0;a = vq(d) | 0;fi(g, b, f, a, wq(d, e) | 0, e);return;
	    }function uq() {
	      var b = 0,
	          d = 0;if (!(a[7808] | 0)) {
	        Dq(9972);Ha(45, 9972, o | 0) | 0;d = 7808;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(9972) | 0)) {
	        b = 9972;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Dq(9972);
	      }return 9972;
	    }function vq(a) {
	      a = a | 0;return a | 0;
	    }function wq(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = uq() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        xq(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        yq(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function xq(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function yq(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = zq(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;Aq(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;xq(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;Bq(a, f);Cq(f);l = i;return;
	      }
	    }function zq(a) {
	      a = a | 0;return 536870911;
	    }function Aq(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function Bq(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Cq(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Dq(a) {
	      a = a | 0;Gq(a);return;
	    }function Eq(a) {
	      a = a | 0;Fq(a + 24 | 0);return;
	    }function Fq(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function Gq(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 9, b, Hq() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Hq() {
	      return 1348;
	    }function Iq(a, b) {
	      a = a | 0;b = b | 0;return Kq(c[(Jq(a) | 0) >> 2] | 0, b) | 0;
	    }function Jq(a) {
	      a = a | 0;return (c[(uq() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function Kq(a, b) {
	      a = a | 0;b = b | 0;var c = 0,
	          d = 0;c = l;l = l + 16 | 0;d = c;Lq(d, b);b = Mq(d, b) | 0;b = Ik(pb[a & 31](b) | 0) | 0;l = c;return b | 0;
	    }function Lq(a, b) {
	      a = a | 0;b = b | 0;return;
	    }function Mq(a, b) {
	      a = a | 0;b = b | 0;return Nq(b) | 0;
	    }function Nq(a) {
	      a = a | 0;return a | 0;
	    }function Oq(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = Pq() | 0;a = Qq(d) | 0;fi(g, b, f, a, Rq(d, e) | 0, e);return;
	    }function Pq() {
	      var b = 0,
	          d = 0;if (!(a[7816] | 0)) {
	        Yq(10008);Ha(46, 10008, o | 0) | 0;d = 7816;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10008) | 0)) {
	        b = 10008;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Yq(10008);
	      }return 10008;
	    }function Qq(a) {
	      a = a | 0;return a | 0;
	    }function Rq(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = Pq() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        Sq(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        Tq(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function Sq(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function Tq(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = Uq(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;Vq(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;Sq(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;Wq(a, f);Xq(f);l = i;return;
	      }
	    }function Uq(a) {
	      a = a | 0;return 536870911;
	    }function Vq(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function Wq(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Xq(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Yq(a) {
	      a = a | 0;$q(a);return;
	    }function Zq(a) {
	      a = a | 0;_q(a + 24 | 0);return;
	    }function _q(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function $q(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 15, b, Zk() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function ar(a) {
	      a = a | 0;return cr(c[(br(a) | 0) >> 2] | 0) | 0;
	    }function br(a) {
	      a = a | 0;return (c[(Pq() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function cr(a) {
	      a = a | 0;return Ik(Ab[a & 7]() | 0) | 0;
	    }function dr() {
	      var b = 0;if (!(a[7832] | 0)) {
	        nr(10052);Ha(25, 10052, o | 0) | 0;b = 7832;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10052;
	    }function er(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = fr() | 0;c[a + 4 >> 2] = gr() | 0;c[a + 12 >> 2] = b;c[a + 8 >> 2] = hr() | 0;c[a + 32 >> 2] = 2;return;
	    }function fr() {
	      return 11709;
	    }function gr() {
	      return 1188;
	    }function hr() {
	      return lr() | 0;
	    }function ir(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;if ((jr(d, 896) | 0) == 512) {
	        if (c | 0) {
	          kr(c);sC(c);
	        }
	      } else if (b | 0) {
	        uf(b);sC(b);
	      }return;
	    }function jr(a, b) {
	      a = a | 0;b = b | 0;return b & a | 0;
	    }function kr(a) {
	      a = a | 0;a = c[a + 4 >> 2] | 0;if (a | 0) oC(a);return;
	    }function lr() {
	      var b = 0;if (!(a[7824] | 0)) {
	        c[2511] = mr() | 0;c[2512] = 0;b = 7824;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10044;
	    }function mr() {
	      return 0;
	    }function nr(a) {
	      a = a | 0;Zi(a);return;
	    }function or(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0;b = l;l = l + 32 | 0;d = b + 24 | 0;g = b + 16 | 0;f = b + 8 | 0;e = b;pr(a, 4827);qr(a, 4834, 3) | 0;rr(a, 3682, 47) | 0;c[g >> 2] = 9;c[g + 4 >> 2] = 0;c[d >> 2] = c[g >> 2];c[d + 4 >> 2] = c[g + 4 >> 2];sr(a, 4841, d) | 0;c[f >> 2] = 1;c[f + 4 >> 2] = 0;c[d >> 2] = c[f >> 2];c[d + 4 >> 2] = c[f + 4 >> 2];tr(a, 4871, d) | 0;c[e >> 2] = 10;c[e + 4 >> 2] = 0;c[d >> 2] = c[e >> 2];c[d + 4 >> 2] = c[e + 4 >> 2];ur(a, 4891, d) | 0;l = b;return;
	    }function pr(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = nt() | 0;c[a >> 2] = d;ot(d, b);Hv(c[a >> 2] | 0);return;
	    }function qr(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;Ws(a, ai(b) | 0, c, 0);return a | 0;
	    }function rr(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;Es(a, ai(b) | 0, c, 0);return a | 0;
	    }function sr(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];is(a, b, f);l = e;return a | 0;
	    }function tr(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Or(a, b, f);l = e;return a | 0;
	    }function ur(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = c[d + 4 >> 2] | 0;c[g >> 2] = c[d >> 2];c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];vr(a, b, f);l = e;return a | 0;
	    }function vr(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];wr(a, d, f, 1);l = e;return;
	    }function wr(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = xr() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = yr(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, zr(g, e) | 0, e);l = f;return;
	    }function xr() {
	      var b = 0,
	          d = 0;if (!(a[7840] | 0)) {
	        Gr(10100);Ha(48, 10100, o | 0) | 0;d = 7840;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10100) | 0)) {
	        b = 10100;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Gr(10100);
	      }return 10100;
	    }function yr(a) {
	      a = a | 0;return 0;
	    }function zr(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = xr() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Ar(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Br(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Ar(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Br(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Cr(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Dr(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Ar(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;Er(a, i);Fr(i);l = k;return;
	      }
	    }function Cr(a) {
	      a = a | 0;return 357913941;
	    }function Dr(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function Er(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Fr(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Gr(a) {
	      a = a | 0;Jr(a);return;
	    }function Hr(a) {
	      a = a | 0;Ir(a + 24 | 0);return;
	    }function Ir(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function Jr(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 6, b, Kr() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Kr() {
	      return 1364;
	    }function Lr(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = Mr(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];d = Nr(b, f, d) | 0;l = e;return d | 0;
	    }function Mr(a) {
	      a = a | 0;return (c[(xr() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function Nr(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;tj(f, d);f = uj(f, d) | 0;f = Qj(wb[e & 15](a, f) | 0) | 0;l = g;return f | 0;
	    }function Or(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];Pr(a, d, f, 0);l = e;return;
	    }function Pr(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = Qr() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = Rr(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, Sr(g, e) | 0, e);l = f;return;
	    }function Qr() {
	      var b = 0,
	          d = 0;if (!(a[7848] | 0)) {
	        Zr(10136);Ha(49, 10136, o | 0) | 0;d = 7848;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10136) | 0)) {
	        b = 10136;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Zr(10136);
	      }return 10136;
	    }function Rr(a) {
	      a = a | 0;return 0;
	    }function Sr(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = Qr() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];Tr(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        Ur(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function Tr(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function Ur(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = Vr(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;Wr(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];Tr(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;Xr(a, i);Yr(i);l = k;return;
	      }
	    }function Vr(a) {
	      a = a | 0;return 357913941;
	    }function Wr(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function Xr(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Yr(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Zr(a) {
	      a = a | 0;as(a);return;
	    }function _r(a) {
	      a = a | 0;$r(a + 24 | 0);return;
	    }function $r(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function as(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 9, b, bs() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function bs() {
	      return 1372;
	    }function cs(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;h = ds(a) | 0;a = c[h + 4 >> 2] | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = a;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];es(b, f, d);l = e;return;
	    }function ds(a) {
	      a = a | 0;return (c[(Qr() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function es(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;var e = 0,
	          f = 0,
	          g = 0,
	          h = ib;g = l;l = l + 16 | 0;f = g;e = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;fs(f, d);h = T(gs(f, d));kb[e & 1](a, h);l = g;return;
	    }function fs(a, b) {
	      a = a | 0;b = +b;return;
	    }function gs(a, b) {
	      a = a | 0;b = +b;return T(hs(b));
	    }function hs(a) {
	      a = +a;return T(a);
	    }function is(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 16 | 0;f = e + 8 | 0;g = e;i = c[d >> 2] | 0;h = c[d + 4 >> 2] | 0;d = ai(b) | 0;c[g >> 2] = i;c[g + 4 >> 2] = h;c[f >> 2] = c[g >> 2];c[f + 4 >> 2] = c[g + 4 >> 2];js(a, d, f, 0);l = e;return;
	    }function js(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;f = l;l = l + 32 | 0;g = f + 16 | 0;m = f + 8 | 0;i = f;k = c[d >> 2] | 0;j = c[d + 4 >> 2] | 0;h = c[a >> 2] | 0;a = ks() | 0;c[m >> 2] = k;c[m + 4 >> 2] = j;c[g >> 2] = c[m >> 2];c[g + 4 >> 2] = c[m + 4 >> 2];d = ls(g) | 0;c[i >> 2] = k;c[i + 4 >> 2] = j;c[g >> 2] = c[i >> 2];c[g + 4 >> 2] = c[i + 4 >> 2];fi(h, b, a, d, ms(g, e) | 0, e);l = f;return;
	    }function ks() {
	      var b = 0,
	          d = 0;if (!(a[7856] | 0)) {
	        ts(10172);Ha(50, 10172, o | 0) | 0;d = 7856;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10172) | 0)) {
	        b = 10172;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));ts(10172);
	      }return 10172;
	    }function ls(a) {
	      a = a | 0;return 0;
	    }function ms(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;m = l;l = l + 32 | 0;f = m + 24 | 0;h = m + 16 | 0;i = m;j = m + 8 | 0;g = c[a >> 2] | 0;e = c[a + 4 >> 2] | 0;c[i >> 2] = g;c[i + 4 >> 2] = e;n = ks() | 0;k = n + 24 | 0;a = ji(b, 4) | 0;c[j >> 2] = a;b = n + 28 | 0;d = c[b >> 2] | 0;if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
	        c[h >> 2] = g;c[h + 4 >> 2] = e;c[f >> 2] = c[h >> 2];c[f + 4 >> 2] = c[h + 4 >> 2];ns(d, f, a);a = (c[b >> 2] | 0) + 12 | 0;c[b >> 2] = a;
	      } else {
	        os(k, i, j);a = c[b >> 2] | 0;
	      }l = m;return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
	    }function ns(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0;e = c[b + 4 >> 2] | 0;c[a >> 2] = c[b >> 2];c[a + 4 >> 2] = e;c[a + 8 >> 2] = d;return;
	    }function os(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0;k = l;l = l + 48 | 0;e = k + 32 | 0;h = k + 24 | 0;i = k;j = a + 4 | 0;f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;g = ps(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        m = c[a >> 2] | 0;o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;n = o << 1;qs(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);j = i + 8 | 0;g = c[j >> 2] | 0;f = c[b + 4 >> 2] | 0;d = c[d >> 2] | 0;c[h >> 2] = c[b >> 2];c[h + 4 >> 2] = f;c[e >> 2] = c[h >> 2];c[e + 4 >> 2] = c[h + 4 >> 2];ns(g, e, d);c[j >> 2] = (c[j >> 2] | 0) + 12;rs(a, i);ss(i);l = k;return;
	      }
	    }function ps(a) {
	      a = a | 0;return 357913941;
	    }function qs(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 357913941) Ta();else {
	          f = qC(b * 12 | 0) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d * 12 | 0) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b * 12 | 0);return;
	    }function rs(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function ss(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function ts(a) {
	      a = a | 0;ws(a);return;
	    }function us(a) {
	      a = a | 0;vs(a + 24 | 0);return;
	    }function vs(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);sC(d);
	      }return;
	    }function ws(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 2, 3, b, xs() | 0, 2);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function xs() {
	      return 1380;
	    }function ys(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;f = l;l = l + 16 | 0;g = f + 8 | 0;h = f;i = zs(a) | 0;a = c[i + 4 >> 2] | 0;c[h >> 2] = c[i >> 2];c[h + 4 >> 2] = a;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = c[h + 4 >> 2];As(b, g, d, e);l = f;return;
	    }function zs(a) {
	      a = a | 0;return (c[(ks() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
	    }function As(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;i = l;l = l + 16 | 0;g = i + 1 | 0;h = i;f = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;a = a + (b >> 1) | 0;if (b & 1) f = c[(c[a >> 2] | 0) + f >> 2] | 0;tj(g, d);g = uj(g, d) | 0;Bs(h, e);h = Cs(h, e) | 0;Eb[f & 15](a, g, h);l = i;return;
	    }function Bs(a, b) {
	      a = a | 0;b = b | 0;return;
	    }function Cs(a, b) {
	      a = a | 0;b = b | 0;return Ds(b) | 0;
	    }function Ds(a) {
	      a = a | 0;return (a | 0) != 0 | 0;
	    }function Es(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = Fs() | 0;a = Gs(d) | 0;fi(g, b, f, a, Hs(d, e) | 0, e);return;
	    }function Fs() {
	      var b = 0,
	          d = 0;if (!(a[7864] | 0)) {
	        Os(10208);Ha(51, 10208, o | 0) | 0;d = 7864;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10208) | 0)) {
	        b = 10208;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Os(10208);
	      }return 10208;
	    }function Gs(a) {
	      a = a | 0;return a | 0;
	    }function Hs(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = Fs() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        Is(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        Js(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function Is(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function Js(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = Ks(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;Ls(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;Is(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;Ms(a, f);Ns(f);l = i;return;
	      }
	    }function Ks(a) {
	      a = a | 0;return 536870911;
	    }function Ls(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function Ms(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Ns(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Os(a) {
	      a = a | 0;Rs(a);return;
	    }function Ps(a) {
	      a = a | 0;Qs(a + 24 | 0);return;
	    }function Qs(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function Rs(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 24, b, Ss() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Ss() {
	      return 1392;
	    }function Ts(a, b) {
	      a = a | 0;b = b | 0;Vs(c[(Us(a) | 0) >> 2] | 0, b);return;
	    }function Us(a) {
	      a = a | 0;return (c[(Fs() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function Vs(a, b) {
	      a = a | 0;b = b | 0;var c = 0,
	          d = 0;c = l;l = l + 16 | 0;d = c;Lq(d, b);b = Mq(d, b) | 0;nb[a & 127](b);l = c;return;
	    }function Ws(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = Xs() | 0;a = Ys(d) | 0;fi(g, b, f, a, Zs(d, e) | 0, e);return;
	    }function Xs() {
	      var b = 0,
	          d = 0;if (!(a[7872] | 0)) {
	        et(10244);Ha(52, 10244, o | 0) | 0;d = 7872;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10244) | 0)) {
	        b = 10244;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));et(10244);
	      }return 10244;
	    }function Ys(a) {
	      a = a | 0;return a | 0;
	    }function Zs(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = Xs() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        _s(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        $s(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function _s(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function $s(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = at(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;bt(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;_s(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;ct(a, f);dt(f);l = i;return;
	      }
	    }function at(a) {
	      a = a | 0;return 536870911;
	    }function bt(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function ct(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function dt(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function et(a) {
	      a = a | 0;ht(a);return;
	    }function ft(a) {
	      a = a | 0;gt(a + 24 | 0);return;
	    }function gt(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function ht(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 16, b, it() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function it() {
	      return 1400;
	    }function jt(a) {
	      a = a | 0;return lt(c[(kt(a) | 0) >> 2] | 0) | 0;
	    }function kt(a) {
	      a = a | 0;return (c[(Xs() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function lt(a) {
	      a = a | 0;return mt(Ab[a & 7]() | 0) | 0;
	    }function mt(a) {
	      a = a | 0;return a | 0;
	    }function nt() {
	      var b = 0;if (!(a[7880] | 0)) {
	        ut(10280);Ha(25, 10280, o | 0) | 0;b = 7880;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10280;
	    }function ot(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = pt() | 0;c[a + 4 >> 2] = qt() | 0;c[a + 12 >> 2] = b;c[a + 8 >> 2] = rt() | 0;c[a + 32 >> 2] = 4;return;
	    }function pt() {
	      return 11711;
	    }function qt() {
	      return 1356;
	    }function rt() {
	      return lr() | 0;
	    }function st(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;if ((jr(d, 896) | 0) == 512) {
	        if (c | 0) {
	          tt(c);sC(c);
	        }
	      } else if (b | 0) {
	        mf(b);sC(b);
	      }return;
	    }function tt(a) {
	      a = a | 0;a = c[a + 4 >> 2] | 0;if (a | 0) oC(a);return;
	    }function ut(a) {
	      a = a | 0;Zi(a);return;
	    }function vt(a) {
	      a = a | 0;wt(a, 4920);xt(a) | 0;yt(a) | 0;return;
	    }function wt(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = nn() | 0;c[a >> 2] = d;Yt(d, b);Hv(c[a >> 2] | 0);return;
	    }function xt(a) {
	      a = a | 0;var b = 0;b = c[a >> 2] | 0;At(b, Mt() | 0);return a | 0;
	    }function yt(a) {
	      a = a | 0;var b = 0;b = c[a >> 2] | 0;At(b, zt() | 0);return a | 0;
	    }function zt() {
	      var b = 0;if (!(a[7888] | 0)) {
	        Bt(10328);Ha(53, 10328, o | 0) | 0;b = 7888;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }if (!(si(10328) | 0)) Bt(10328);return 10328;
	    }function At(a, b) {
	      a = a | 0;b = b | 0;fi(a, 0, b, 0, 0, 0);return;
	    }function Bt(a) {
	      a = a | 0;Et(a);Gt(a, 10);return;
	    }function Ct(a) {
	      a = a | 0;Dt(a + 24 | 0);return;
	    }function Dt(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function Et(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 5, 1, b, Jt() | 0, 2);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Ft(a, b, c) {
	      a = a | 0;b = b | 0;c = +c;Ht(a, b, c);return;
	    }function Gt(a, b) {
	      a = a | 0;b = b | 0;c[a + 20 >> 2] = b;return;
	    }function Ht(a, b, d) {
	      a = a | 0;b = b | 0;d = +d;var e = 0,
	          f = 0,
	          g = 0,
	          i = 0,
	          j = 0;e = l;l = l + 16 | 0;g = e + 8 | 0;j = e + 13 | 0;f = e;i = e + 12 | 0;tj(j, b);c[g >> 2] = uj(j, b) | 0;rj(i, d);h[f >> 3] = +sj(i, d);It(a, g, f);l = e;return;
	    }function It(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;mg(b + 8 | 0, c[d >> 2] | 0, +h[e >> 3]);a[b + 24 >> 0] = 1;return;
	    }function Jt() {
	      return 1404;
	    }function Kt(a, b) {
	      a = a | 0;b = +b;return Lt(a, b) | 0;
	    }function Lt(a, b) {
	      a = a | 0;b = +b;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;e = l;l = l + 16 | 0;g = e + 4 | 0;h = e + 8 | 0;i = e;f = jy(8) | 0;d = f;j = qC(16) | 0;tj(g, a);a = uj(g, a) | 0;rj(h, b);mg(j, a, +sj(h, b));h = d + 4 | 0;c[h >> 2] = j;a = qC(8) | 0;h = c[h >> 2] | 0;c[i >> 2] = 0;c[g >> 2] = c[i >> 2];qn(a, h, g);c[f >> 2] = a;l = e;return d | 0;
	    }function Mt() {
	      var b = 0;if (!(a[7896] | 0)) {
	        Nt(10364);Ha(54, 10364, o | 0) | 0;b = 7896;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }if (!(si(10364) | 0)) Nt(10364);return 10364;
	    }function Nt(a) {
	      a = a | 0;Qt(a);Gt(a, 55);return;
	    }function Ot(a) {
	      a = a | 0;Pt(a + 24 | 0);return;
	    }function Pt(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function Qt(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 5, 4, b, Vt() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Rt(a) {
	      a = a | 0;St(a);return;
	    }function St(a) {
	      a = a | 0;Tt(a);return;
	    }function Tt(b) {
	      b = b | 0;Ut(b + 8 | 0);a[b + 24 >> 0] = 1;return;
	    }function Ut(a) {
	      a = a | 0;c[a >> 2] = 0;h[a + 8 >> 3] = 0.0;return;
	    }function Vt() {
	      return 1424;
	    }function Wt() {
	      return Xt() | 0;
	    }function Xt() {
	      var a = 0,
	          b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;b = l;l = l + 16 | 0;f = b + 4 | 0;h = b;d = jy(8) | 0;a = d;e = qC(16) | 0;Ut(e);g = a + 4 | 0;c[g >> 2] = e;e = qC(8) | 0;g = c[g >> 2] | 0;c[h >> 2] = 0;c[f >> 2] = c[h >> 2];qn(e, g, f);c[d >> 2] = e;l = b;return a | 0;
	    }function Yt(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = Zt() | 0;c[a + 4 >> 2] = _t() | 0;c[a + 12 >> 2] = b;c[a + 8 >> 2] = $t() | 0;c[a + 32 >> 2] = 5;return;
	    }function Zt() {
	      return 11710;
	    }function _t() {
	      return 1416;
	    }function $t() {
	      return cu() | 0;
	    }function au(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;if ((jr(d, 896) | 0) == 512) {
	        if (c | 0) {
	          bu(c);sC(c);
	        }
	      } else if (b | 0) sC(b);return;
	    }function bu(a) {
	      a = a | 0;a = c[a + 4 >> 2] | 0;if (a | 0) oC(a);return;
	    }function cu() {
	      var b = 0;if (!(a[7904] | 0)) {
	        c[2600] = du() | 0;c[2601] = 0;b = 7904;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10400;
	    }function du() {
	      return c[357] | 0;
	    }function eu(a) {
	      a = a | 0;fu(a, 4926);gu(a) | 0;return;
	    }function fu(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = Ci() | 0;c[a >> 2] = d;su(d, b);Hv(c[a >> 2] | 0);return;
	    }function gu(a) {
	      a = a | 0;var b = 0;b = c[a >> 2] | 0;At(b, hu() | 0);return a | 0;
	    }function hu() {
	      var b = 0;if (!(a[7912] | 0)) {
	        iu(10412);Ha(56, 10412, o | 0) | 0;b = 7912;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }if (!(si(10412) | 0)) iu(10412);return 10412;
	    }function iu(a) {
	      a = a | 0;lu(a);Gt(a, 57);return;
	    }function ju(a) {
	      a = a | 0;ku(a + 24 | 0);return;
	    }function ku(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function lu(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 5, 5, b, pu() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function mu(a) {
	      a = a | 0;nu(a);return;
	    }function nu(a) {
	      a = a | 0;ou(a);return;
	    }function ou(b) {
	      b = b | 0;var d = 0,
	          e = 0;d = b + 8 | 0;e = d + 48 | 0;do {
	        c[d >> 2] = 0;d = d + 4 | 0;
	      } while ((d | 0) < (e | 0));a[b + 56 >> 0] = 1;return;
	    }function pu() {
	      return 1432;
	    }function qu() {
	      return ru() | 0;
	    }function ru() {
	      var a = 0,
	          b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;h = l;l = l + 16 | 0;a = h + 4 | 0;b = h;d = jy(8) | 0;e = d;f = qC(48) | 0;g = f;i = g + 48 | 0;do {
	        c[g >> 2] = 0;g = g + 4 | 0;
	      } while ((g | 0) < (i | 0));g = e + 4 | 0;c[g >> 2] = f;i = qC(8) | 0;g = c[g >> 2] | 0;c[b >> 2] = 0;c[a >> 2] = c[b >> 2];Ji(i, g, a);c[d >> 2] = i;l = h;return e | 0;
	    }function su(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = tu() | 0;c[a + 4 >> 2] = uu() | 0;c[a + 12 >> 2] = b;c[a + 8 >> 2] = vu() | 0;c[a + 32 >> 2] = 6;return;
	    }function tu() {
	      return 11704;
	    }function uu() {
	      return 1436;
	    }function vu() {
	      return cu() | 0;
	    }function wu(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;if ((jr(d, 896) | 0) == 512) {
	        if (c | 0) {
	          xu(c);sC(c);
	        }
	      } else if (b | 0) sC(b);return;
	    }function xu(a) {
	      a = a | 0;a = c[a + 4 >> 2] | 0;if (a | 0) oC(a);return;
	    }function yu(a) {
	      a = a | 0;zu(a, 4933);Au(a) | 0;Bu(a) | 0;return;
	    }function zu(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = cv() | 0;c[a >> 2] = d;dv(d, b);Hv(c[a >> 2] | 0);return;
	    }function Au(a) {
	      a = a | 0;var b = 0;b = c[a >> 2] | 0;At(b, Su() | 0);return a | 0;
	    }function Bu(a) {
	      a = a | 0;var b = 0;b = c[a >> 2] | 0;At(b, Cu() | 0);return a | 0;
	    }function Cu() {
	      var b = 0;if (!(a[7920] | 0)) {
	        Du(10452);Ha(58, 10452, o | 0) | 0;b = 7920;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }if (!(si(10452) | 0)) Du(10452);return 10452;
	    }function Du(a) {
	      a = a | 0;Gu(a);Gt(a, 1);return;
	    }function Eu(a) {
	      a = a | 0;Fu(a + 24 | 0);return;
	    }function Fu(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function Gu(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 5, 1, b, Lu() | 0, 2);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Hu(a, b, c) {
	      a = a | 0;b = +b;c = +c;Iu(a, b, c);return;
	    }function Iu(a, b, c) {
	      a = a | 0;b = +b;c = +c;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          i = 0;d = l;l = l + 32 | 0;f = d + 8 | 0;i = d + 17 | 0;e = d;g = d + 16 | 0;rj(i, b);h[f >> 3] = +sj(i, b);rj(g, c);h[e >> 3] = +sj(g, c);Ju(a, f, e);l = d;return;
	    }function Ju(b, c, d) {
	      b = b | 0;c = c | 0;d = d | 0;Ku(b + 8 | 0, +h[c >> 3], +h[d >> 3]);a[b + 24 >> 0] = 1;return;
	    }function Ku(a, b, c) {
	      a = a | 0;b = +b;c = +c;h[a >> 3] = b;h[a + 8 >> 3] = c;return;
	    }function Lu() {
	      return 1472;
	    }function Mu(a, b) {
	      a = +a;b = +b;return Nu(a, b) | 0;
	    }function Nu(a, b) {
	      a = +a;b = +b;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;e = l;l = l + 16 | 0;h = e + 4 | 0;i = e + 8 | 0;j = e;f = jy(8) | 0;d = f;g = qC(16) | 0;rj(h, a);a = +sj(h, a);rj(i, b);Ku(g, a, +sj(i, b));i = d + 4 | 0;c[i >> 2] = g;g = qC(8) | 0;i = c[i >> 2] | 0;c[j >> 2] = 0;c[h >> 2] = c[j >> 2];Ou(g, i, h);c[f >> 2] = g;l = e;return d | 0;
	    }function Ou(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;d = qC(16) | 0;c[d + 4 >> 2] = 0;c[d + 8 >> 2] = 0;c[d >> 2] = 1452;c[d + 12 >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function Pu(a) {
	      a = a | 0;kC(a);sC(a);return;
	    }function Qu(a) {
	      a = a | 0;a = c[a + 12 >> 2] | 0;if (a | 0) sC(a);return;
	    }function Ru(a) {
	      a = a | 0;sC(a);return;
	    }function Su() {
	      var b = 0;if (!(a[7928] | 0)) {
	        Tu(10488);Ha(59, 10488, o | 0) | 0;b = 7928;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }if (!(si(10488) | 0)) Tu(10488);return 10488;
	    }function Tu(a) {
	      a = a | 0;Wu(a);Gt(a, 60);return;
	    }function Uu(a) {
	      a = a | 0;Vu(a + 24 | 0);return;
	    }function Vu(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function Wu(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 5, 6, b, $u() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Xu(a) {
	      a = a | 0;Yu(a);return;
	    }function Yu(a) {
	      a = a | 0;Zu(a);return;
	    }function Zu(b) {
	      b = b | 0;_u(b + 8 | 0);a[b + 24 >> 0] = 1;return;
	    }function _u(a) {
	      a = a | 0;c[a >> 2] = 0;c[a + 4 >> 2] = 0;c[a + 8 >> 2] = 0;c[a + 12 >> 2] = 0;return;
	    }function $u() {
	      return 1492;
	    }function av() {
	      return bv() | 0;
	    }function bv() {
	      var a = 0,
	          b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;b = l;l = l + 16 | 0;f = b + 4 | 0;h = b;d = jy(8) | 0;a = d;e = qC(16) | 0;_u(e);g = a + 4 | 0;c[g >> 2] = e;e = qC(8) | 0;g = c[g >> 2] | 0;c[h >> 2] = 0;c[f >> 2] = c[h >> 2];Ou(e, g, f);c[d >> 2] = e;l = b;return a | 0;
	    }function cv() {
	      var b = 0;if (!(a[7936] | 0)) {
	        jv(10524);Ha(25, 10524, o | 0) | 0;b = 7936;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10524;
	    }function dv(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = ev() | 0;c[a + 4 >> 2] = fv() | 0;c[a + 12 >> 2] = b;c[a + 8 >> 2] = gv() | 0;c[a + 32 >> 2] = 7;return;
	    }function ev() {
	      return 11700;
	    }function fv() {
	      return 1484;
	    }function gv() {
	      return cu() | 0;
	    }function hv(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;if ((jr(d, 896) | 0) == 512) {
	        if (c | 0) {
	          iv(c);sC(c);
	        }
	      } else if (b | 0) sC(b);return;
	    }function iv(a) {
	      a = a | 0;a = c[a + 4 >> 2] | 0;if (a | 0) oC(a);return;
	    }function jv(a) {
	      a = a | 0;Zi(a);return;
	    }function kv(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;a = ai(b) | 0;b = lv(c) | 0;c = mv(c, 0) | 0;Zv(a, b, c, nv() | 0, 0);return;
	    }function lv(a) {
	      a = a | 0;return a | 0;
	    }function mv(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = nv() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        vv(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        wv(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function nv() {
	      var b = 0,
	          d = 0;if (!(a[7944] | 0)) {
	        ov(10568);Ha(61, 10568, o | 0) | 0;d = 7944;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10568) | 0)) {
	        b = 10568;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));ov(10568);
	      }return 10568;
	    }function ov(a) {
	      a = a | 0;rv(a);return;
	    }function pv(a) {
	      a = a | 0;qv(a + 24 | 0);return;
	    }function qv(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function rv(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 17, b, ql() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function sv(a) {
	      a = a | 0;return uv(c[(tv(a) | 0) >> 2] | 0) | 0;
	    }function tv(a) {
	      a = a | 0;return (c[(nv() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function uv(a) {
	      a = a | 0;return ul(Ab[a & 7]() | 0) | 0;
	    }function vv(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function wv(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = xv(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;yv(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;vv(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;zv(a, f);Av(f);l = i;return;
	      }
	    }function xv(a) {
	      a = a | 0;return 536870911;
	    }function yv(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function zv(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Av(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Bv() {
	      Cv();return;
	    }function Cv() {
	      Dv(10604);return;
	    }function Dv(a) {
	      a = a | 0;Ev(a, 4955);return;
	    }function Ev(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = Fv() | 0;c[a >> 2] = d;Gv(d, b);Hv(c[a >> 2] | 0);return;
	    }function Fv() {
	      var b = 0;if (!(a[7952] | 0)) {
	        Rv(10612);Ha(25, 10612, o | 0) | 0;b = 7952;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10612;
	    }function Gv(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = Mv() | 0;c[a + 4 >> 2] = Nv() | 0;c[a + 12 >> 2] = b;c[a + 8 >> 2] = Ov() | 0;c[a + 32 >> 2] = 8;return;
	    }function Hv(a) {
	      a = a | 0;var b = 0,
	          d = 0;b = l;l = l + 16 | 0;d = b;Iv() | 0;c[d >> 2] = a;Jv(10608, d);l = b;return;
	    }function Iv() {
	      if (!(a[11714] | 0)) {
	        c[2652] = 0;Ha(62, 10608, o | 0) | 0;a[11714] = 1;
	      }return 10608;
	    }function Jv(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = qC(8) | 0;c[d + 4 >> 2] = c[b >> 2];c[d >> 2] = c[a >> 2];c[a >> 2] = d;return;
	    }function Kv(a) {
	      a = a | 0;Lv(a);return;
	    }function Lv(a) {
	      a = a | 0;var b = 0,
	          d = 0;b = c[a >> 2] | 0;if (b | 0) do {
	        d = b;b = c[b >> 2] | 0;sC(d);
	      } while ((b | 0) != 0);c[a >> 2] = 0;return;
	    }function Mv() {
	      return 11715;
	    }function Nv() {
	      return 1496;
	    }function Ov() {
	      return lr() | 0;
	    }function Pv(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;if ((jr(d, 896) | 0) == 512) {
	        if (c | 0) {
	          Qv(c);sC(c);
	        }
	      } else if (b | 0) sC(b);return;
	    }function Qv(a) {
	      a = a | 0;a = c[a + 4 >> 2] | 0;if (a | 0) oC(a);return;
	    }function Rv(a) {
	      a = a | 0;Zi(a);return;
	    }function Sv(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;Iv() | 0;d = c[2652] | 0;a: do if (d | 0) {
	        while (1) {
	          e = c[d + 4 >> 2] | 0;if (e | 0 ? (AB(Tv(e) | 0, a) | 0) == 0 : 0) break;d = c[d >> 2] | 0;if (!d) break a;
	        }Uv(e, b);
	      } while (0);return;
	    }function Tv(a) {
	      a = a | 0;return c[a + 12 >> 2] | 0;
	    }function Uv(a, b) {
	      a = a | 0;b = b | 0;var d = 0;a = a + 36 | 0;d = c[a >> 2] | 0;if (d | 0) {
	        vf(d);sC(d);
	      }d = qC(4) | 0;Og(d, b);c[a >> 2] = d;return;
	    }function Vv() {
	      if (!(a[11716] | 0)) {
	        c[2664] = 0;Ha(63, 10656, o | 0) | 0;a[11716] = 1;
	      }return 10656;
	    }function Wv() {
	      var b = 0;if (!(a[11717] | 0)) {
	        Xv();c[2665] = 1504;a[11717] = 1;b = 1504;
	      } else b = c[2665] | 0;return b | 0;
	    }function Xv() {
	      if (!(a[11740] | 0)) {
	        a[11718] = ji(ji(8, 0) | 0, 0) | 0;a[11719] = ji(ji(0, 0) | 0, 0) | 0;a[11720] = ji(ji(0, 16) | 0, 0) | 0;a[11721] = ji(ji(8, 0) | 0, 0) | 0;a[11722] = ji(ji(0, 0) | 0, 0) | 0;a[11723] = ji(ji(8, 0) | 0, 0) | 0;a[11724] = ji(ji(0, 0) | 0, 0) | 0;a[11725] = ji(ji(8, 0) | 0, 0) | 0;a[11726] = ji(ji(0, 0) | 0, 0) | 0;a[11727] = ji(ji(8, 0) | 0, 0) | 0;a[11728] = ji(ji(0, 0) | 0, 0) | 0;a[11729] = ji(ji(0, 0) | 0, 32) | 0;a[11730] = ji(ji(0, 0) | 0, 32) | 0;a[11740] = 1;
	      }return;
	    }function Yv() {
	      return 1572;
	    }function Zv(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;g = l;l = l + 32 | 0;m = g + 16 | 0;k = g + 12 | 0;j = g + 8 | 0;i = g + 4 | 0;h = g;c[m >> 2] = a;c[k >> 2] = b;c[j >> 2] = d;c[i >> 2] = e;c[h >> 2] = f;Vv() | 0;_v(10656, m, k, j, i, h);l = g;return;
	    }function _v(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;var h = 0;h = qC(24) | 0;ii(h + 4 | 0, c[b >> 2] | 0, c[d >> 2] | 0, c[e >> 2] | 0, c[f >> 2] | 0, c[g >> 2] | 0);c[h >> 2] = c[a >> 2];c[a >> 2] = h;return;
	    }function $v(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0,
	          s = 0,
	          t = 0,
	          u = 0;u = l;l = l + 32 | 0;q = u + 20 | 0;r = u + 8 | 0;s = u + 4 | 0;t = u;b = c[b >> 2] | 0;if (b | 0) {
	        p = q + 4 | 0;j = q + 8 | 0;k = r + 4 | 0;m = r + 8 | 0;n = r + 8 | 0;o = q + 8 | 0;do {
	          h = b + 4 | 0;i = aw(h) | 0;if (i | 0) {
	            f = bw(i) | 0;c[q >> 2] = 0;c[p >> 2] = 0;c[j >> 2] = 0;e = (cw(i) | 0) + 1 | 0;dw(q, e);if (e | 0) while (1) {
	              e = e + -1 | 0;OA(r, c[f >> 2] | 0);g = c[p >> 2] | 0;if (g >>> 0 < (c[o >> 2] | 0) >>> 0) {
	                c[g >> 2] = c[r >> 2];c[p >> 2] = (c[p >> 2] | 0) + 4;
	              } else ew(q, r);if (!e) break;else f = f + 4 | 0;
	            }e = fw(i) | 0;c[r >> 2] = 0;c[k >> 2] = 0;c[m >> 2] = 0;a: do if (c[e >> 2] | 0) {
	              f = 0;g = 0;while (1) {
	                if ((f | 0) == (g | 0)) gw(r, e);else {
	                  c[f >> 2] = c[e >> 2];c[k >> 2] = (c[k >> 2] | 0) + 4;
	                }e = e + 4 | 0;if (!(c[e >> 2] | 0)) break a;f = c[k >> 2] | 0;g = c[n >> 2] | 0;
	              }
	            } while (0);c[s >> 2] = hw(h) | 0;c[t >> 2] = si(i) | 0;iw(d, a, s, t, q, r);jw(r);kw(q);
	          }b = c[b >> 2] | 0;
	        } while ((b | 0) != 0);
	      }l = u;return;
	    }function aw(a) {
	      a = a | 0;return c[a + 12 >> 2] | 0;
	    }function bw(a) {
	      a = a | 0;return c[a + 12 >> 2] | 0;
	    }function cw(a) {
	      a = a | 0;return c[a + 16 >> 2] | 0;
	    }function dw(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0;f = l;l = l + 32 | 0;d = f;e = c[a >> 2] | 0;if ((c[a + 8 >> 2] | 0) - e >> 2 >>> 0 < b >>> 0) {
	        Rw(d, b, (c[a + 4 >> 2] | 0) - e >> 2, a + 8 | 0);Sw(a, d);Tw(d);
	      }l = f;return;
	    }function ew(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0;h = l;l = l + 32 | 0;d = h;e = a + 4 | 0;f = ((c[e >> 2] | 0) - (c[a >> 2] | 0) >> 2) + 1 | 0;g = Nw(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        i = c[a >> 2] | 0;k = (c[a + 8 >> 2] | 0) - i | 0;j = k >> 1;Rw(d, k >> 2 >>> 0 < g >>> 1 >>> 0 ? j >>> 0 < f >>> 0 ? f : j : g, (c[e >> 2] | 0) - i >> 2, a + 8 | 0);g = d + 8 | 0;c[c[g >> 2] >> 2] = c[b >> 2];c[g >> 2] = (c[g >> 2] | 0) + 4;Sw(a, d);Tw(d);l = h;return;
	      }
	    }function fw(a) {
	      a = a | 0;return c[a + 8 >> 2] | 0;
	    }function gw(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0;h = l;l = l + 32 | 0;d = h;e = a + 4 | 0;f = ((c[e >> 2] | 0) - (c[a >> 2] | 0) >> 2) + 1 | 0;g = Kw(a) | 0;if (g >>> 0 < f >>> 0) jC(a);else {
	        i = c[a >> 2] | 0;k = (c[a + 8 >> 2] | 0) - i | 0;j = k >> 1;Ow(d, k >> 2 >>> 0 < g >>> 1 >>> 0 ? j >>> 0 < f >>> 0 ? f : j : g, (c[e >> 2] | 0) - i >> 2, a + 8 | 0);g = d + 8 | 0;c[c[g >> 2] >> 2] = c[b >> 2];c[g >> 2] = (c[g >> 2] | 0) + 4;Pw(a, d);Qw(d);l = h;return;
	      }
	    }function hw(a) {
	      a = a | 0;return c[a >> 2] | 0;
	    }function iw(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;f = f | 0;lw(a, b, c, d, e, f);return;
	    }function jw(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -4 - e | 0) >>> 2) << 2);sC(d);
	      }return;
	    }function kw(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -4 - e | 0) >>> 2) << 2);sC(d);
	      }return;
	    }function lw(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;var h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;h = l;l = l + 48 | 0;m = h + 40 | 0;i = h + 32 | 0;n = h + 24 | 0;j = h + 12 | 0;k = h;UA(i);a = Sg(a) | 0;c[n >> 2] = c[b >> 2];d = c[d >> 2] | 0;e = c[e >> 2] | 0;mw(j, f);nw(k, g);c[m >> 2] = c[n >> 2];ow(a, m, d, e, j, k);jw(k);kw(j);WA(i);l = h;return;
	    }function mw(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;c[a >> 2] = 0;c[a + 4 >> 2] = 0;c[a + 8 >> 2] = 0;d = b + 4 | 0;e = (c[d >> 2] | 0) - (c[b >> 2] | 0) >> 2;if (e | 0) {
	        Lw(a, e);Mw(a, c[b >> 2] | 0, c[d >> 2] | 0, e);
	      }return;
	    }function nw(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;c[a >> 2] = 0;c[a + 4 >> 2] = 0;c[a + 8 >> 2] = 0;d = b + 4 | 0;e = (c[d >> 2] | 0) - (c[b >> 2] | 0) >> 2;if (e | 0) {
	        Iw(a, e);Jw(a, c[b >> 2] | 0, c[d >> 2] | 0, e);
	      }return;
	    }function ow(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;var h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0;h = l;l = l + 32 | 0;m = h + 28 | 0;n = h + 24 | 0;i = h + 12 | 0;j = h;k = Vg(pw() | 0) | 0;c[n >> 2] = c[b >> 2];c[m >> 2] = c[n >> 2];b = qw(m) | 0;d = rw(d) | 0;e = sw(e) | 0;c[i >> 2] = c[f >> 2];m = f + 4 | 0;c[i + 4 >> 2] = c[m >> 2];n = f + 8 | 0;c[i + 8 >> 2] = c[n >> 2];c[n >> 2] = 0;c[m >> 2] = 0;c[f >> 2] = 0;f = tw(i) | 0;c[j >> 2] = c[g >> 2];m = g + 4 | 0;c[j + 4 >> 2] = c[m >> 2];n = g + 8 | 0;c[j + 8 >> 2] = c[n >> 2];c[n >> 2] = 0;c[m >> 2] = 0;c[g >> 2] = 0;Ba(0, k | 0, a | 0, b | 0, d | 0, e | 0, f | 0, uw(j) | 0) | 0;jw(j);kw(i);l = h;return;
	    }function pw() {
	      var b = 0;if (!(a[7968] | 0)) {
	        Gw(10708);b = 7968;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10708;
	    }function qw(a) {
	      a = a | 0;return yw(a) | 0;
	    }function rw(a) {
	      a = a | 0;return ww(a) | 0;
	    }function sw(a) {
	      a = a | 0;return ul(a) | 0;
	    }function tw(a) {
	      a = a | 0;return xw(a) | 0;
	    }function uw(a) {
	      a = a | 0;return vw(a) | 0;
	    }function vw(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;e = (c[a + 4 >> 2] | 0) - (c[a >> 2] | 0) | 0;d = e >> 2;e = jy(e + 4 | 0) | 0;c[e >> 2] = d;if (d | 0) {
	        b = 0;do {
	          c[e + 4 + (b << 2) >> 2] = ww(c[(c[a >> 2] | 0) + (b << 2) >> 2] | 0) | 0;b = b + 1 | 0;
	        } while ((b | 0) != (d | 0));
	      }return e | 0;
	    }function ww(a) {
	      a = a | 0;return a | 0;
	    }function xw(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;e = (c[a + 4 >> 2] | 0) - (c[a >> 2] | 0) | 0;d = e >> 2;e = jy(e + 4 | 0) | 0;c[e >> 2] = d;if (d | 0) {
	        b = 0;do {
	          c[e + 4 + (b << 2) >> 2] = yw((c[a >> 2] | 0) + (b << 2) | 0) | 0;b = b + 1 | 0;
	        } while ((b | 0) != (d | 0));
	      }return e | 0;
	    }function yw(a) {
	      a = a | 0;var b = 0,
	          c = 0,
	          d = 0,
	          e = 0;e = l;l = l + 32 | 0;b = e + 12 | 0;c = e;d = Di(zw() | 0) | 0;if (!d) a = Aw(a) | 0;else {
	        Ei(b, d);Fi(c, b);RA(a, c);a = Hi(b) | 0;
	      }l = e;return a | 0;
	    }function zw() {
	      var b = 0;if (!(a[7960] | 0)) {
	        Fw(10664);Ha(25, 10664, o | 0) | 0;b = 7960;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10664;
	    }function Aw(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;d = l;l = l + 16 | 0;f = d + 4 | 0;h = d;e = jy(8) | 0;b = e;i = qC(4) | 0;c[i >> 2] = c[a >> 2];g = b + 4 | 0;c[g >> 2] = i;a = qC(8) | 0;g = c[g >> 2] | 0;c[h >> 2] = 0;c[f >> 2] = c[h >> 2];Bw(a, g, f);c[e >> 2] = a;l = d;return b | 0;
	    }function Bw(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;d = qC(16) | 0;c[d + 4 >> 2] = 0;c[d + 8 >> 2] = 0;c[d >> 2] = 1656;c[d + 12 >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function Cw(a) {
	      a = a | 0;kC(a);sC(a);return;
	    }function Dw(a) {
	      a = a | 0;a = c[a + 12 >> 2] | 0;if (a | 0) sC(a);return;
	    }function Ew(a) {
	      a = a | 0;sC(a);return;
	    }function Fw(a) {
	      a = a | 0;Zi(a);return;
	    }function Gw(a) {
	      a = a | 0;fh(a, Hw() | 0, 5);return;
	    }function Hw() {
	      return 1676;
	    }function Iw(a, b) {
	      a = a | 0;b = b | 0;var d = 0;if ((Kw(a) | 0) >>> 0 < b >>> 0) jC(a);if (b >>> 0 > 1073741823) Ta();else {
	        d = qC(b << 2) | 0;c[a + 4 >> 2] = d;c[a >> 2] = d;c[a + 8 >> 2] = d + (b << 2);return;
	      }
	    }function Jw(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;e = a + 4 | 0;a = d - b | 0;if ((a | 0) > 0) {
	        BC(c[e >> 2] | 0, b | 0, a | 0) | 0;c[e >> 2] = (c[e >> 2] | 0) + (a >>> 2 << 2);
	      }return;
	    }function Kw(a) {
	      a = a | 0;return 1073741823;
	    }function Lw(a, b) {
	      a = a | 0;b = b | 0;var d = 0;if ((Nw(a) | 0) >>> 0 < b >>> 0) jC(a);if (b >>> 0 > 1073741823) Ta();else {
	        d = qC(b << 2) | 0;c[a + 4 >> 2] = d;c[a >> 2] = d;c[a + 8 >> 2] = d + (b << 2);return;
	      }
	    }function Mw(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;e = a + 4 | 0;a = d - b | 0;if ((a | 0) > 0) {
	        BC(c[e >> 2] | 0, b | 0, a | 0) | 0;c[e >> 2] = (c[e >> 2] | 0) + (a >>> 2 << 2);
	      }return;
	    }function Nw(a) {
	      a = a | 0;return 1073741823;
	    }function Ow(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 1073741823) Ta();else {
	          f = qC(b << 2) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 2) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 2);return;
	    }function Pw(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 2) << 2) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Qw(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -4 - b | 0) >>> 2) << 2);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Rw(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 1073741823) Ta();else {
	          f = qC(b << 2) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 2) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 2);return;
	    }function Sw(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 2) << 2) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Tw(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -4 - b | 0) >>> 2) << 2);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Uw(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0;r = l;l = l + 32 | 0;m = r + 20 | 0;n = r + 12 | 0;k = r + 16 | 0;o = r + 4 | 0;p = r;q = r + 8 | 0;i = Wv() | 0;g = c[i >> 2] | 0;h = c[g >> 2] | 0;if (h | 0) {
	        j = c[i + 8 >> 2] | 0;i = c[i + 4 >> 2] | 0;while (1) {
	          OA(m, h);Vw(a, m, i, j);g = g + 4 | 0;h = c[g >> 2] | 0;if (!h) break;else {
	            j = j + 1 | 0;i = i + 1 | 0;
	          }
	        }
	      }g = Yv() | 0;h = c[g >> 2] | 0;if (h | 0) do {
	        OA(m, h);c[n >> 2] = c[g + 4 >> 2];Ww(b, m, n);g = g + 8 | 0;h = c[g >> 2] | 0;
	      } while ((h | 0) != 0);g = c[(Iv() | 0) >> 2] | 0;if (g | 0) do {
	        b = c[g + 4 >> 2] | 0;OA(m, c[(Xw(b) | 0) >> 2] | 0);c[n >> 2] = Tv(b) | 0;Yw(d, m, n);g = c[g >> 2] | 0;
	      } while ((g | 0) != 0);OA(k, 0);g = Vv() | 0;c[m >> 2] = c[k >> 2];$v(m, g, f);g = c[(Iv() | 0) >> 2] | 0;if (g | 0) {
	        a = m + 4 | 0;b = m + 8 | 0;d = m + 8 | 0;do {
	          j = c[g + 4 >> 2] | 0;OA(n, c[(Xw(j) | 0) >> 2] | 0);_w(o, Zw(j) | 0);h = c[o >> 2] | 0;if (h | 0) {
	            c[m >> 2] = 0;c[a >> 2] = 0;c[b >> 2] = 0;do {
	              OA(p, c[(Xw(c[h + 4 >> 2] | 0) | 0) >> 2] | 0);i = c[a >> 2] | 0;if (i >>> 0 < (c[d >> 2] | 0) >>> 0) {
	                c[i >> 2] = c[p >> 2];c[a >> 2] = (c[a >> 2] | 0) + 4;
	              } else ew(m, p);h = c[h >> 2] | 0;
	            } while ((h | 0) != 0);$w(e, n, m);kw(m);
	          }c[q >> 2] = c[n >> 2];k = ax(j) | 0;c[m >> 2] = c[q >> 2];$v(m, k, f);Wi(o);g = c[g >> 2] | 0;
	        } while ((g | 0) != 0);
	      }l = r;return;
	    }function Vw(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;ox(a, b, c, d);return;
	    }function Ww(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;nx(a, b, c);return;
	    }function Xw(a) {
	      a = a | 0;return a | 0;
	    }function Yw(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;ix(a, b, c);return;
	    }function Zw(a) {
	      a = a | 0;return a + 16 | 0;
	    }function _w(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;g = l;l = l + 16 | 0;f = g + 8 | 0;d = g;c[a >> 2] = 0;e = c[b >> 2] | 0;c[f >> 2] = e;c[d >> 2] = a;d = gx(d) | 0;if (e | 0) {
	        e = qC(12) | 0;h = (hx(f) | 0) + 4 | 0;a = c[h + 4 >> 2] | 0;b = e + 4 | 0;c[b >> 2] = c[h >> 2];c[b + 4 >> 2] = a;b = c[c[f >> 2] >> 2] | 0;c[f >> 2] = b;if (!b) a = e;else {
	          b = e;while (1) {
	            a = qC(12) | 0;j = (hx(f) | 0) + 4 | 0;i = c[j + 4 >> 2] | 0;h = a + 4 | 0;c[h >> 2] = c[j >> 2];c[h + 4 >> 2] = i;c[b >> 2] = a;h = c[c[f >> 2] >> 2] | 0;c[f >> 2] = h;if (!h) break;else b = a;
	          }
	        }c[a >> 2] = c[d >> 2];c[d >> 2] = e;
	      }l = g;return;
	    }function $w(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;bx(a, b, c);return;
	    }function ax(a) {
	      a = a | 0;return a + 24 | 0;
	    }function bx(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 32 | 0;h = e + 24 | 0;f = e + 16 | 0;i = e + 12 | 0;g = e;UA(f);a = Sg(a) | 0;c[i >> 2] = c[b >> 2];mw(g, d);c[h >> 2] = c[i >> 2];cx(a, h, g);kw(g);WA(f);l = e;return;
	    }function cx(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;e = l;l = l + 32 | 0;h = e + 16 | 0;i = e + 12 | 0;f = e;g = Vg(dx() | 0) | 0;c[i >> 2] = c[b >> 2];c[h >> 2] = c[i >> 2];b = qw(h) | 0;c[f >> 2] = c[d >> 2];h = d + 4 | 0;c[f + 4 >> 2] = c[h >> 2];i = d + 8 | 0;c[f + 8 >> 2] = c[i >> 2];c[i >> 2] = 0;c[h >> 2] = 0;c[d >> 2] = 0;xa(0, g | 0, a | 0, b | 0, tw(f) | 0) | 0;kw(f);l = e;return;
	    }function dx() {
	      var b = 0;if (!(a[7976] | 0)) {
	        ex(10720);b = 7976;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10720;
	    }function ex(a) {
	      a = a | 0;fh(a, fx() | 0, 2);return;
	    }function fx() {
	      return 1732;
	    }function gx(a) {
	      a = a | 0;return c[a >> 2] | 0;
	    }function hx(a) {
	      a = a | 0;return c[a >> 2] | 0;
	    }function ix(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 32 | 0;g = e + 16 | 0;f = e + 8 | 0;h = e;UA(f);a = Sg(a) | 0;c[h >> 2] = c[b >> 2];d = c[d >> 2] | 0;c[g >> 2] = c[h >> 2];jx(a, g, d);WA(f);l = e;return;
	    }function jx(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 16 | 0;g = e + 4 | 0;h = e;f = Vg(kx() | 0) | 0;c[h >> 2] = c[b >> 2];c[g >> 2] = c[h >> 2];b = qw(g) | 0;xa(0, f | 0, a | 0, b | 0, rw(d) | 0) | 0;l = e;return;
	    }function kx() {
	      var b = 0;if (!(a[7984] | 0)) {
	        lx(10732);b = 7984;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10732;
	    }function lx(a) {
	      a = a | 0;fh(a, mx() | 0, 2);return;
	    }function mx() {
	      return 1744;
	    }function nx(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = l;l = l + 32 | 0;g = e + 16 | 0;f = e + 8 | 0;h = e;UA(f);a = Sg(a) | 0;c[h >> 2] = c[b >> 2];d = c[d >> 2] | 0;c[g >> 2] = c[h >> 2];jx(a, g, d);WA(f);l = e;return;
	    }function ox(b, d, e, f) {
	      b = b | 0;d = d | 0;e = e | 0;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0;g = l;l = l + 32 | 0;i = g + 16 | 0;h = g + 8 | 0;j = g;UA(h);b = Sg(b) | 0;c[j >> 2] = c[d >> 2];e = a[e >> 0] | 0;f = a[f >> 0] | 0;c[i >> 2] = c[j >> 2];px(b, i, e, f);WA(h);l = g;return;
	    }function px(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;f = l;l = l + 16 | 0;h = f + 4 | 0;i = f;g = Vg(qx() | 0) | 0;c[i >> 2] = c[b >> 2];c[h >> 2] = c[i >> 2];b = qw(h) | 0;d = rx(d) | 0;$a(0, g | 0, a | 0, b | 0, d | 0, rx(e) | 0) | 0;l = f;return;
	    }function qx() {
	      var b = 0;if (!(a[7992] | 0)) {
	        tx(10744);b = 7992;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10744;
	    }function rx(a) {
	      a = a | 0;return sx(a) | 0;
	    }function sx(a) {
	      a = a | 0;return a & 255 | 0;
	    }function tx(a) {
	      a = a | 0;fh(a, ux() | 0, 3);return;
	    }function ux() {
	      return 1756;
	    }function vx(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0;p = l;l = l + 32 | 0;j = p + 8 | 0;k = p + 4 | 0;m = p + 20 | 0;n = p;mk(b, 0);f = QA(d) | 0;c[j >> 2] = 0;o = j + 4 | 0;c[o >> 2] = 0;c[j + 8 >> 2] = 0;switch (f << 24 >> 24) {case 0:
	          {
	            a[m >> 0] = 0;wx(k, e, m);xx(b, k) | 0;wf(k);break;
	          }case 8:
	          {
	            o = PA(d) | 0;a[m >> 0] = 8;OA(n, c[o + 4 >> 2] | 0);yx(k, e, m, n, o + 8 | 0);xx(b, k) | 0;wf(k);break;
	          }case 9:
	          {
	            h = PA(d) | 0;d = c[h + 4 >> 2] | 0;if (d | 0) {
	              i = j + 8 | 0;g = h + 12 | 0;while (1) {
	                d = d + -1 | 0;OA(k, c[g >> 2] | 0);f = c[o >> 2] | 0;if (f >>> 0 < (c[i >> 2] | 0) >>> 0) {
	                  c[f >> 2] = c[k >> 2];c[o >> 2] = (c[o >> 2] | 0) + 4;
	                } else ew(j, k);if (!d) break;else g = g + 4 | 0;
	              }
	            }a[m >> 0] = 9;OA(n, c[h + 8 >> 2] | 0);zx(k, e, m, n, j);xx(b, k) | 0;wf(k);break;
	          }default:
	          {
	            o = PA(d) | 0;a[m >> 0] = f;OA(n, c[o + 4 >> 2] | 0);Ax(k, e, m, n);xx(b, k) | 0;wf(k);
	          }}kw(j);l = p;return;
	    }function wx(b, c, d) {
	      b = b | 0;c = c | 0;d = d | 0;var e = 0,
	          f = 0;e = l;l = l + 16 | 0;f = e;UA(f);c = Sg(c) | 0;Ox(b, c, a[d >> 0] | 0);WA(f);l = e;return;
	    }function xx(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = c[a >> 2] | 0;if (d | 0) ab(d | 0);c[a >> 2] = c[b >> 2];c[b >> 2] = 0;return a | 0;
	    }function yx(b, d, e, f, g) {
	      b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;var h = 0,
	          i = 0,
	          j = 0,
	          k = 0;h = l;l = l + 32 | 0;j = h + 16 | 0;i = h + 8 | 0;k = h;UA(i);d = Sg(d) | 0;e = a[e >> 0] | 0;c[k >> 2] = c[f >> 2];g = c[g >> 2] | 0;c[j >> 2] = c[k >> 2];Kx(b, d, e, j, g);WA(i);l = h;return;
	    }function zx(b, d, e, f, g) {
	      b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;var h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;h = l;l = l + 32 | 0;k = h + 24 | 0;i = h + 16 | 0;m = h + 12 | 0;j = h;UA(i);d = Sg(d) | 0;e = a[e >> 0] | 0;c[m >> 2] = c[f >> 2];mw(j, g);c[k >> 2] = c[m >> 2];Gx(b, d, e, k, j);kw(j);WA(i);l = h;return;
	    }function Ax(b, d, e, f) {
	      b = b | 0;d = d | 0;e = e | 0;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0;g = l;l = l + 32 | 0;i = g + 16 | 0;h = g + 8 | 0;j = g;UA(h);d = Sg(d) | 0;e = a[e >> 0] | 0;c[j >> 2] = c[f >> 2];c[i >> 2] = c[j >> 2];Bx(b, d, e, i);WA(h);l = g;return;
	    }function Bx(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;f = l;l = l + 16 | 0;g = f + 4 | 0;i = f;h = Vg(Cx() | 0) | 0;d = rx(d) | 0;c[i >> 2] = c[e >> 2];c[g >> 2] = c[i >> 2];Dx(a, xa(0, h | 0, b | 0, d | 0, qw(g) | 0) | 0);l = f;return;
	    }function Cx() {
	      var b = 0;if (!(a[8e3] | 0)) {
	        Ex(10756);b = 8e3;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10756;
	    }function Dx(a, b) {
	      a = a | 0;b = b | 0;mk(a, b);return;
	    }function Ex(a) {
	      a = a | 0;fh(a, Fx() | 0, 2);return;
	    }function Fx() {
	      return 1772;
	    }function Gx(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0;g = l;l = l + 32 | 0;j = g + 16 | 0;k = g + 12 | 0;h = g;i = Vg(Hx() | 0) | 0;d = rx(d) | 0;c[k >> 2] = c[e >> 2];c[j >> 2] = c[k >> 2];e = qw(j) | 0;c[h >> 2] = c[f >> 2];j = f + 4 | 0;c[h + 4 >> 2] = c[j >> 2];k = f + 8 | 0;c[h + 8 >> 2] = c[k >> 2];c[k >> 2] = 0;c[j >> 2] = 0;c[f >> 2] = 0;Dx(a, $a(0, i | 0, b | 0, d | 0, e | 0, tw(h) | 0) | 0);kw(h);l = g;return;
	    }function Hx() {
	      var b = 0;if (!(a[8008] | 0)) {
	        Ix(10768);b = 8008;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10768;
	    }function Ix(a) {
	      a = a | 0;fh(a, Jx() | 0, 3);return;
	    }function Jx() {
	      return 1784;
	    }function Kx(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0;g = l;l = l + 16 | 0;i = g + 4 | 0;j = g;h = Vg(Lx() | 0) | 0;d = rx(d) | 0;c[j >> 2] = c[e >> 2];c[i >> 2] = c[j >> 2];e = qw(i) | 0;Dx(a, $a(0, h | 0, b | 0, d | 0, e | 0, sw(f) | 0) | 0);l = g;return;
	    }function Lx() {
	      var b = 0;if (!(a[8016] | 0)) {
	        Mx(10780);b = 8016;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10780;
	    }function Mx(a) {
	      a = a | 0;fh(a, Nx() | 0, 3);return;
	    }function Nx() {
	      return 1800;
	    }function Ox(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;var d = 0;d = Vg(Px() | 0) | 0;Dx(a, bb(0, d | 0, b | 0, rx(c) | 0) | 0);return;
	    }function Px() {
	      var b = 0;if (!(a[8024] | 0)) {
	        Qx(10792);b = 8024;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 10792;
	    }function Qx(a) {
	      a = a | 0;fh(a, Rx() | 0, 1);return;
	    }function Rx() {
	      return 1816;
	    }function Sx() {
	      Tx();Ux();Vx();return;
	    }function Tx() {
	      c[2702] = rC(65536) | 0;return;
	    }function Ux() {
	      qy(10856);return;
	    }function Vx() {
	      Wx(10816);return;
	    }function Wx(a) {
	      a = a | 0;Xx(a, 5044);Yx(a) | 0;return;
	    }function Xx(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = zw() | 0;c[a >> 2] = d;ky(d, b);Hv(c[a >> 2] | 0);return;
	    }function Yx(a) {
	      a = a | 0;var b = 0;b = c[a >> 2] | 0;At(b, Zx() | 0);return a | 0;
	    }function Zx() {
	      var b = 0;if (!(a[8032] | 0)) {
	        _x(10820);Ha(64, 10820, o | 0) | 0;b = 8032;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }if (!(si(10820) | 0)) _x(10820);return 10820;
	    }function _x(a) {
	      a = a | 0;by(a);Gt(a, 25);return;
	    }function $x(a) {
	      a = a | 0;ay(a + 24 | 0);return;
	    }function ay(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function by(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 5, 18, b, gy() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function cy(a, b) {
	      a = a | 0;b = b | 0;dy(a, b);return;
	    }function dy(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0;d = l;l = l + 16 | 0;e = d;f = d + 4 | 0;Gk(f, b);c[e >> 2] = Hk(f, b) | 0;ey(a, e);l = d;return;
	    }function ey(b, d) {
	      b = b | 0;d = d | 0;fy(b + 4 | 0, c[d >> 2] | 0);a[b + 8 >> 0] = 1;return;
	    }function fy(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = b;return;
	    }function gy() {
	      return 1824;
	    }function hy(a) {
	      a = a | 0;return iy(a) | 0;
	    }function iy(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0;d = l;l = l + 16 | 0;f = d + 4 | 0;h = d;e = jy(8) | 0;b = e;i = qC(4) | 0;Gk(f, a);fy(i, Hk(f, a) | 0);g = b + 4 | 0;c[g >> 2] = i;a = qC(8) | 0;g = c[g >> 2] | 0;c[h >> 2] = 0;c[f >> 2] = c[h >> 2];Bw(a, g, f);c[e >> 2] = a;l = d;return b | 0;
	    }function jy(a) {
	      a = a | 0;var b = 0,
	          d = 0;a = a + 7 & -8;if (a >>> 0 <= 32768 ? (b = c[2701] | 0, a >>> 0 <= (65536 - b | 0) >>> 0) : 0) {
	        d = (c[2702] | 0) + b | 0;c[2701] = b + a;a = d;
	      } else {
	        a = rC(a + 8 | 0) | 0;c[a >> 2] = c[2703];c[2703] = a;a = a + 8 | 0;
	      }return a | 0;
	    }function ky(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = ly() | 0;c[a + 4 >> 2] = my() | 0;c[a + 12 >> 2] = b;c[a + 8 >> 2] = ny() | 0;c[a + 32 >> 2] = 9;return;
	    }function ly() {
	      return 11744;
	    }function my() {
	      return 1832;
	    }function ny() {
	      return cu() | 0;
	    }function oy(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;if ((jr(d, 896) | 0) == 512) {
	        if (c | 0) {
	          py(c);sC(c);
	        }
	      } else if (b | 0) sC(b);return;
	    }function py(a) {
	      a = a | 0;a = c[a + 4 >> 2] | 0;if (a | 0) oC(a);return;
	    }function qy(a) {
	      a = a | 0;ry(a, 5052);sy(a) | 0;ty(a, 5058, 26) | 0;uy(a, 5069, 1) | 0;vy(a, 5077, 10) | 0;wy(a, 5087, 19) | 0;yy(a, 5094, 27) | 0;return;
	    }function ry(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = GA() | 0;c[a >> 2] = d;HA(d, b);Hv(c[a >> 2] | 0);return;
	    }function sy(a) {
	      a = a | 0;var b = 0;b = c[a >> 2] | 0;At(b, rA() | 0);return a | 0;
	    }function ty(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;Yz(a, ai(b) | 0, c, 0);return a | 0;
	    }function uy(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;Gz(a, ai(b) | 0, c, 0);return a | 0;
	    }function vy(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;hz(a, ai(b) | 0, c, 0);return a | 0;
	    }function wy(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;Ry(a, ai(b) | 0, c, 0);return a | 0;
	    }function xy(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;a: while (1) {
	        d = c[2703] | 0;while (1) {
	          if ((d | 0) == (b | 0)) break a;e = c[d >> 2] | 0;c[2703] = e;if (!d) d = e;else break;
	        }sC(d);
	      }c[2701] = a;return;
	    }function yy(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;zy(a, ai(b) | 0, c, 0);return a | 0;
	    }function zy(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = Ay() | 0;a = By(d) | 0;fi(g, b, f, a, Cy(d, e) | 0, e);return;
	    }function Ay() {
	      var b = 0,
	          d = 0;if (!(a[8040] | 0)) {
	        Jy(10860);Ha(65, 10860, o | 0) | 0;d = 8040;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10860) | 0)) {
	        b = 10860;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Jy(10860);
	      }return 10860;
	    }function By(a) {
	      a = a | 0;return a | 0;
	    }function Cy(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = Ay() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        Dy(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        Ey(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function Dy(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function Ey(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = Fy(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;Gy(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;Dy(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;Hy(a, f);Iy(f);l = i;return;
	      }
	    }function Fy(a) {
	      a = a | 0;return 536870911;
	    }function Gy(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function Hy(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Iy(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Jy(a) {
	      a = a | 0;My(a);return;
	    }function Ky(a) {
	      a = a | 0;Ly(a + 24 | 0);return;
	    }function Ly(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function My(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 11, b, Ny() | 0, 2);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Ny() {
	      return 1840;
	    }function Oy(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;Qy(c[(Py(a) | 0) >> 2] | 0, b, d);return;
	    }function Py(a) {
	      a = a | 0;return (c[(Ay() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function Qy(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;var d = 0,
	          e = 0,
	          f = 0;d = l;l = l + 16 | 0;f = d + 1 | 0;e = d;Gk(f, b);b = Hk(f, b) | 0;Gk(e, c);c = Hk(e, c) | 0;ob[a & 31](b, c);l = d;return;
	    }function Ry(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = Sy() | 0;a = Ty(d) | 0;fi(g, b, f, a, Uy(d, e) | 0, e);return;
	    }function Sy() {
	      var b = 0,
	          d = 0;if (!(a[8048] | 0)) {
	        $y(10896);Ha(66, 10896, o | 0) | 0;d = 8048;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10896) | 0)) {
	        b = 10896;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));$y(10896);
	      }return 10896;
	    }function Ty(a) {
	      a = a | 0;return a | 0;
	    }function Uy(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = Sy() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        Vy(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        Wy(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function Vy(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function Wy(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = Xy(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;Yy(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;Vy(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;Zy(a, f);_y(f);l = i;return;
	      }
	    }function Xy(a) {
	      a = a | 0;return 536870911;
	    }function Yy(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function Zy(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function _y(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function $y(a) {
	      a = a | 0;cz(a);return;
	    }function az(a) {
	      a = a | 0;bz(a + 24 | 0);return;
	    }function bz(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function cz(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 11, b, dz() | 0, 1);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function dz() {
	      return 1852;
	    }function ez(a, b) {
	      a = a | 0;b = b | 0;return gz(c[(fz(a) | 0) >> 2] | 0, b) | 0;
	    }function fz(a) {
	      a = a | 0;return (c[(Sy() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function gz(a, b) {
	      a = a | 0;b = b | 0;var c = 0,
	          d = 0;c = l;l = l + 16 | 0;d = c;Gk(d, b);b = Hk(d, b) | 0;b = ul(pb[a & 31](b) | 0) | 0;l = c;return b | 0;
	    }function hz(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = iz() | 0;a = jz(d) | 0;fi(g, b, f, a, kz(d, e) | 0, e);return;
	    }function iz() {
	      var b = 0,
	          d = 0;if (!(a[8056] | 0)) {
	        rz(10932);Ha(67, 10932, o | 0) | 0;d = 8056;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10932) | 0)) {
	        b = 10932;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));rz(10932);
	      }return 10932;
	    }function jz(a) {
	      a = a | 0;return a | 0;
	    }function kz(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = iz() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        lz(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        mz(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function lz(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function mz(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = nz(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;oz(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;lz(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;pz(a, f);qz(f);l = i;return;
	      }
	    }function nz(a) {
	      a = a | 0;return 536870911;
	    }function oz(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function pz(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function qz(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function rz(a) {
	      a = a | 0;uz(a);return;
	    }function sz(a) {
	      a = a | 0;tz(a + 24 | 0);return;
	    }function tz(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function uz(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 7, b, vz() | 0, 2);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function vz() {
	      return 1860;
	    }function wz(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;return yz(c[(xz(a) | 0) >> 2] | 0, b, d) | 0;
	    }function xz(a) {
	      a = a | 0;return (c[(iz() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function yz(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;e = l;l = l + 32 | 0;h = e + 12 | 0;g = e + 8 | 0;i = e;j = e + 16 | 0;f = e + 4 | 0;zz(j, b);Az(i, j, b);ik(f, d);d = jk(f, d) | 0;c[h >> 2] = c[i >> 2];Eb[a & 15](g, h, d);d = Bz(g) | 0;wf(g);kk(f);l = e;return d | 0;
	    }function zz(a, b) {
	      a = a | 0;b = b | 0;return;
	    }function Az(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;Cz(a, c);return;
	    }function Bz(a) {
	      a = a | 0;return Sg(a) | 0;
	    }function Cz(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0;f = l;l = l + 16 | 0;d = f;e = b;if (!(e & 1)) c[a >> 2] = c[b >> 2];else {
	        Dz(d, 0);Ja(e | 0, d | 0) | 0;Ez(a, d);Fz(d);
	      }l = f;return;
	    }function Dz(b, d) {
	      b = b | 0;d = d | 0;ah(b, d);c[b + 4 >> 2] = 0;a[b + 8 >> 0] = 0;return;
	    }function Ez(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = c[b + 4 >> 2];return;
	    }function Fz(b) {
	      b = b | 0;a[b + 8 >> 0] = 0;return;
	    }function Gz(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = Hz() | 0;a = Iz(d) | 0;fi(g, b, f, a, Jz(d, e) | 0, e);return;
	    }function Hz() {
	      var b = 0,
	          d = 0;if (!(a[8064] | 0)) {
	        Qz(10968);Ha(68, 10968, o | 0) | 0;d = 8064;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(10968) | 0)) {
	        b = 10968;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));Qz(10968);
	      }return 10968;
	    }function Iz(a) {
	      a = a | 0;return a | 0;
	    }function Jz(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = Hz() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        Kz(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        Lz(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function Kz(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function Lz(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = Mz(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;Nz(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;Kz(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;Oz(a, f);Pz(f);l = i;return;
	      }
	    }function Mz(a) {
	      a = a | 0;return 536870911;
	    }function Nz(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function Oz(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function Pz(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function Qz(a) {
	      a = a | 0;Tz(a);return;
	    }function Rz(a) {
	      a = a | 0;Sz(a + 24 | 0);return;
	    }function Sz(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function Tz(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 1, b, Uz() | 0, 5);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function Uz() {
	      return 1872;
	    }function Vz(a, b, d, e, f, g) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;Xz(c[(Wz(a) | 0) >> 2] | 0, b, d, e, f, g);return;
	    }function Wz(a) {
	      a = a | 0;return (c[(Hz() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function Xz(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;g = l;l = l + 32 | 0;h = g + 16 | 0;i = g + 12 | 0;j = g + 8 | 0;k = g + 4 | 0;m = g;ik(h, b);b = jk(h, b) | 0;ik(i, c);c = jk(i, c) | 0;ik(j, d);d = jk(j, d) | 0;ik(k, e);e = jk(k, e) | 0;ik(m, f);f = jk(m, f) | 0;jb[a & 1](b, c, d, e, f);kk(m);kk(k);kk(j);kk(i);kk(h);l = g;return;
	    }function Yz(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = c[a >> 2] | 0;f = Zz() | 0;a = _z(d) | 0;fi(g, b, f, a, $z(d, e) | 0, e);return;
	    }function Zz() {
	      var b = 0,
	          d = 0;if (!(a[8072] | 0)) {
	        gA(11004);Ha(69, 11004, o | 0) | 0;d = 8072;c[d >> 2] = 1;c[d + 4 >> 2] = 0;
	      }if (!(si(11004) | 0)) {
	        b = 11004;d = b + 36 | 0;do {
	          c[b >> 2] = 0;b = b + 4 | 0;
	        } while ((b | 0) < (d | 0));gA(11004);
	      }return 11004;
	    }function _z(a) {
	      a = a | 0;return a | 0;
	    }function $z(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;i = l;l = l + 16 | 0;f = i;g = i + 4 | 0;c[f >> 2] = a;j = Zz() | 0;h = j + 24 | 0;b = ji(b, 4) | 0;c[g >> 2] = b;d = j + 28 | 0;e = c[d >> 2] | 0;if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
	        aA(e, a, b);b = (c[d >> 2] | 0) + 8 | 0;c[d >> 2] = b;
	      } else {
	        bA(h, f, g);b = c[d >> 2] | 0;
	      }l = i;return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
	    }function aA(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function bA(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0;i = l;l = l + 32 | 0;f = i;g = a + 4 | 0;h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;e = cA(a) | 0;if (e >>> 0 < h >>> 0) jC(a);else {
	        j = c[a >> 2] | 0;m = (c[a + 8 >> 2] | 0) - j | 0;k = m >> 2;dA(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);h = f + 8 | 0;aA(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);c[h >> 2] = (c[h >> 2] | 0) + 8;eA(a, f);fA(f);l = i;return;
	      }
	    }function cA(a) {
	      a = a | 0;return 536870911;
	    }function dA(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0;c[a + 12 >> 2] = 0;c[a + 16 >> 2] = e;do if (b) {
	        if (b >>> 0 > 536870911) Ta();else {
	          f = qC(b << 3) | 0;break;
	        }
	      } else f = 0; while (0);c[a >> 2] = f;e = f + (d << 3) | 0;c[a + 8 >> 2] = e;c[a + 4 >> 2] = e;c[a + 12 >> 2] = f + (b << 3);return;
	    }function eA(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;e = c[a >> 2] | 0;h = a + 4 | 0;g = b + 4 | 0;f = (c[h >> 2] | 0) - e | 0;d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;c[g >> 2] = d;if ((f | 0) > 0) {
	        BC(d | 0, e | 0, f | 0) | 0;e = g;d = c[g >> 2] | 0;
	      } else e = g;g = c[a >> 2] | 0;c[a >> 2] = d;c[e >> 2] = g;g = b + 8 | 0;f = c[h >> 2] | 0;c[h >> 2] = c[g >> 2];c[g >> 2] = f;g = a + 8 | 0;h = b + 12 | 0;a = c[g >> 2] | 0;c[g >> 2] = c[h >> 2];c[h >> 2] = a;c[b >> 2] = c[e >> 2];return;
	    }function fA(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;b = c[a + 4 >> 2] | 0;d = a + 8 | 0;e = c[d >> 2] | 0;if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);a = c[a >> 2] | 0;if (a | 0) sC(a);return;
	    }function gA(a) {
	      a = a | 0;jA(a);return;
	    }function hA(a) {
	      a = a | 0;iA(a + 24 | 0);return;
	    }function iA(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function jA(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 1, 12, b, kA() | 0, 2);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function kA() {
	      return 1896;
	    }function lA(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;nA(c[(mA(a) | 0) >> 2] | 0, b, d);return;
	    }function mA(a) {
	      a = a | 0;return (c[(Zz() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
	    }function nA(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;var d = 0,
	          e = 0,
	          f = 0;d = l;l = l + 16 | 0;f = d + 4 | 0;e = d;oA(f, b);b = pA(f, b) | 0;ik(e, c);c = jk(e, c) | 0;ob[a & 31](b, c);kk(e);l = d;return;
	    }function oA(a, b) {
	      a = a | 0;b = b | 0;return;
	    }function pA(a, b) {
	      a = a | 0;b = b | 0;return qA(b) | 0;
	    }function qA(a) {
	      a = a | 0;return a | 0;
	    }function rA() {
	      var b = 0;if (!(a[8080] | 0)) {
	        sA(11040);Ha(70, 11040, o | 0) | 0;b = 8080;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }if (!(si(11040) | 0)) sA(11040);return 11040;
	    }function sA(a) {
	      a = a | 0;vA(a);Gt(a, 71);return;
	    }function tA(a) {
	      a = a | 0;uA(a + 24 | 0);return;
	    }function uA(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0;d = c[a >> 2] | 0;e = d;if (d | 0) {
	        a = a + 4 | 0;b = c[a >> 2] | 0;if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);sC(d);
	      }return;
	    }function vA(a) {
	      a = a | 0;var b = 0;b = vi() | 0;yi(a, 5, 7, b, zA() | 0, 0);c[a + 24 >> 2] = 0;c[a + 28 >> 2] = 0;c[a + 32 >> 2] = 0;return;
	    }function wA(a) {
	      a = a | 0;xA(a);return;
	    }function xA(a) {
	      a = a | 0;yA(a);return;
	    }function yA(b) {
	      b = b | 0;a[b + 8 >> 0] = 1;return;
	    }function zA() {
	      return 1936;
	    }function AA() {
	      return BA() | 0;
	    }function BA() {
	      var a = 0,
	          b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0;b = l;l = l + 16 | 0;f = b + 4 | 0;h = b;d = jy(8) | 0;a = d;g = a + 4 | 0;c[g >> 2] = qC(1) | 0;e = qC(8) | 0;g = c[g >> 2] | 0;c[h >> 2] = 0;c[f >> 2] = c[h >> 2];CA(e, g, f);c[d >> 2] = e;l = b;return a | 0;
	    }function CA(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;c[a >> 2] = b;d = qC(16) | 0;c[d + 4 >> 2] = 0;c[d + 8 >> 2] = 0;c[d >> 2] = 1916;c[d + 12 >> 2] = b;c[a + 4 >> 2] = d;return;
	    }function DA(a) {
	      a = a | 0;kC(a);sC(a);return;
	    }function EA(a) {
	      a = a | 0;a = c[a + 12 >> 2] | 0;if (a | 0) sC(a);return;
	    }function FA(a) {
	      a = a | 0;sC(a);return;
	    }function GA() {
	      var b = 0;if (!(a[8088] | 0)) {
	        NA(11076);Ha(25, 11076, o | 0) | 0;b = 8088;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 11076;
	    }function HA(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = IA() | 0;c[a + 4 >> 2] = JA() | 0;c[a + 12 >> 2] = b;c[a + 8 >> 2] = KA() | 0;c[a + 32 >> 2] = 10;return;
	    }function IA() {
	      return 11745;
	    }function JA() {
	      return 1940;
	    }function KA() {
	      return lr() | 0;
	    }function LA(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;if ((jr(d, 896) | 0) == 512) {
	        if (c | 0) {
	          MA(c);sC(c);
	        }
	      } else if (b | 0) sC(b);return;
	    }function MA(a) {
	      a = a | 0;a = c[a + 4 >> 2] | 0;if (a | 0) oC(a);return;
	    }function NA(a) {
	      a = a | 0;Zi(a);return;
	    }function OA(a, b) {
	      a = a | 0;b = b | 0;c[a >> 2] = b;return;
	    }function PA(a) {
	      a = a | 0;return c[a >> 2] | 0;
	    }function QA(b) {
	      b = b | 0;return a[c[b >> 2] >> 0] | 0;
	    }function RA(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;c[e >> 2] = c[a >> 2];SA(b, e) | 0;l = d;return;
	    }function SA(a, b) {
	      a = a | 0;b = b | 0;var d = 0;d = TA(c[a >> 2] | 0, b) | 0;b = a + 4 | 0;c[(c[b >> 2] | 0) + 8 >> 2] = d;return c[(c[b >> 2] | 0) + 8 >> 2] | 0;
	    }function TA(a, b) {
	      a = a | 0;b = b | 0;var d = 0,
	          e = 0;d = l;l = l + 16 | 0;e = d;UA(e);a = Sg(a) | 0;b = VA(a, c[b >> 2] | 0) | 0;WA(e);l = d;return b | 0;
	    }function UA(a) {
	      a = a | 0;c[a >> 2] = c[2701];c[a + 4 >> 2] = c[2703];return;
	    }function VA(a, b) {
	      a = a | 0;b = b | 0;var c = 0;c = Vg(XA() | 0) | 0;return bb(0, c | 0, a | 0, sw(b) | 0) | 0;
	    }function WA(a) {
	      a = a | 0;xy(c[a >> 2] | 0, c[a + 4 >> 2] | 0);return;
	    }function XA() {
	      var b = 0;if (!(a[8096] | 0)) {
	        YA(11120);b = 8096;c[b >> 2] = 1;c[b + 4 >> 2] = 0;
	      }return 11120;
	    }function YA(a) {
	      a = a | 0;fh(a, ZA() | 0, 1);return;
	    }function ZA() {
	      return 1948;
	    }function _A() {
	      $A();return;
	    }function $A() {
	      var b = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0,
	          s = 0,
	          t = 0;s = l;l = l + 16 | 0;o = s + 4 | 0;p = s;Ea(65536, 10804, c[2702] | 0, 10812);f = Wv() | 0;e = c[f >> 2] | 0;b = c[e >> 2] | 0;if (b | 0) {
	        g = c[f + 8 >> 2] | 0;f = c[f + 4 >> 2] | 0;while (1) {
	          Ma(b | 0, d[f >> 0] | 0 | 0, a[g >> 0] | 0);e = e + 4 | 0;b = c[e >> 2] | 0;if (!b) break;else {
	            g = g + 1 | 0;f = f + 1 | 0;
	          }
	        }
	      }b = Yv() | 0;e = c[b >> 2] | 0;if (e | 0) do {
	        Na(e | 0, c[b + 4 >> 2] | 0);b = b + 8 | 0;e = c[b >> 2] | 0;
	      } while ((e | 0) != 0);Na(aB() | 0, 5167);n = Iv() | 0;b = c[n >> 2] | 0;a: do if (b | 0) {
	        do {
	          bB(c[b + 4 >> 2] | 0);b = c[b >> 2] | 0;
	        } while ((b | 0) != 0);b = c[n >> 2] | 0;if (b | 0) {
	          m = n;do {
	            while (1) {
	              h = b;b = c[b >> 2] | 0;h = c[h + 4 >> 2] | 0;if (!(cB(h) | 0)) break;c[p >> 2] = m;c[o >> 2] = c[p >> 2];dB(n, o) | 0;if (!b) break a;
	            }eB(h);m = c[m >> 2] | 0;e = fB(h) | 0;i = Va() | 0;j = l;l = l + ((1 * (e << 2) | 0) + 15 & -16) | 0;k = l;l = l + ((1 * (e << 2) | 0) + 15 & -16) | 0;e = c[(Zw(h) | 0) >> 2] | 0;if (e | 0) {
	              f = j;g = k;while (1) {
	                c[f >> 2] = c[(Xw(c[e + 4 >> 2] | 0) | 0) >> 2];c[g >> 2] = c[e + 8 >> 2];e = c[e >> 2] | 0;if (!e) break;else {
	                  f = f + 4 | 0;g = g + 4 | 0;
	                }
	              }
	            }t = Xw(h) | 0;e = gB(h) | 0;f = fB(h) | 0;g = hB(h) | 0;Ra(t | 0, e | 0, j | 0, k | 0, f | 0, g | 0, Tv(h) | 0);Ga(i | 0);
	          } while ((b | 0) != 0);
	        }
	      } while (0);b = c[(Vv() | 0) >> 2] | 0;if (b | 0) do {
	        t = b + 4 | 0;n = aw(t) | 0;h = fw(n) | 0;i = bw(n) | 0;j = (cw(n) | 0) + 1 | 0;k = iB(n) | 0;m = jB(t) | 0;n = si(n) | 0;o = hw(t) | 0;p = kB(t) | 0;Pa(0, h | 0, i | 0, j | 0, k | 0, m | 0, n | 0, o | 0, p | 0, lB(t) | 0);b = c[b >> 2] | 0;
	      } while ((b | 0) != 0);b = c[(Iv() | 0) >> 2] | 0;b: do if (b | 0) {
	        c: while (1) {
	          e = c[b + 4 >> 2] | 0;if (e | 0 ? (q = c[(Xw(e) | 0) >> 2] | 0, r = c[(ax(e) | 0) >> 2] | 0, r | 0) : 0) {
	            f = r;do {
	              e = f + 4 | 0;g = aw(e) | 0;d: do if (g | 0) switch (si(g) | 0) {case 0:
	                  break c;case 4:case 3:case 2:
	                  {
	                    k = fw(g) | 0;m = bw(g) | 0;n = (cw(g) | 0) + 1 | 0;o = iB(g) | 0;p = si(g) | 0;t = hw(e) | 0;Pa(q | 0, k | 0, m | 0, n | 0, o | 0, 0, p | 0, t | 0, kB(e) | 0, lB(e) | 0);break d;
	                  }case 1:
	                  {
	                    j = fw(g) | 0;k = bw(g) | 0;m = (cw(g) | 0) + 1 | 0;n = iB(g) | 0;o = jB(e) | 0;p = si(g) | 0;t = hw(e) | 0;Pa(q | 0, j | 0, k | 0, m | 0, n | 0, o | 0, p | 0, t | 0, kB(e) | 0, lB(e) | 0);break d;
	                  }case 5:
	                  {
	                    n = fw(g) | 0;o = bw(g) | 0;p = (cw(g) | 0) + 1 | 0;t = iB(g) | 0;Pa(q | 0, n | 0, o | 0, p | 0, t | 0, mB(g) | 0, si(g) | 0, 0, 0, 0);break d;
	                  }default:
	                  break d;} while (0);f = c[f >> 2] | 0;
	            } while ((f | 0) != 0);
	          }b = c[b >> 2] | 0;if (!b) break b;
	        }Ta();
	      } while (0);Sa();l = s;return;
	    }function aB() {
	      return 11703;
	    }function bB(b) {
	      b = b | 0;a[b + 40 >> 0] = 0;return;
	    }function cB(b) {
	      b = b | 0;return (a[b + 40 >> 0] | 0) != 0 | 0;
	    }function dB(a, b) {
	      a = a | 0;b = b | 0;b = nB(b) | 0;a = c[b >> 2] | 0;c[b >> 2] = c[a >> 2];sC(a);return c[b >> 2] | 0;
	    }function eB(b) {
	      b = b | 0;a[b + 40 >> 0] = 1;return;
	    }function fB(a) {
	      a = a | 0;return c[a + 20 >> 2] | 0;
	    }function gB(a) {
	      a = a | 0;return c[a + 8 >> 2] | 0;
	    }function hB(a) {
	      a = a | 0;return c[a + 32 >> 2] | 0;
	    }function iB(a) {
	      a = a | 0;return c[a + 4 >> 2] | 0;
	    }function jB(a) {
	      a = a | 0;return c[a + 4 >> 2] | 0;
	    }function kB(a) {
	      a = a | 0;return c[a + 8 >> 2] | 0;
	    }function lB(a) {
	      a = a | 0;return c[a + 16 >> 2] | 0;
	    }function mB(a) {
	      a = a | 0;return c[a + 20 >> 2] | 0;
	    }function nB(a) {
	      a = a | 0;return c[a >> 2] | 0;
	    }
	    function oB(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0,
	          s = 0,
	          t = 0,
	          u = 0,
	          v = 0,
	          w = 0,
	          x = 0;x = l;l = l + 16 | 0;o = x;do if (a >>> 0 < 245) {
	        k = a >>> 0 < 11 ? 16 : a + 11 & -8;a = k >>> 3;n = c[2783] | 0;d = n >>> a;if (d & 3 | 0) {
	          b = (d & 1 ^ 1) + a | 0;a = 11172 + (b << 1 << 2) | 0;d = a + 8 | 0;e = c[d >> 2] | 0;f = e + 8 | 0;g = c[f >> 2] | 0;if ((a | 0) == (g | 0)) c[2783] = n & ~(1 << b);else {
	            c[g + 12 >> 2] = a;c[d >> 2] = g;
	          }w = b << 3;c[e + 4 >> 2] = w | 3;w = e + w + 4 | 0;c[w >> 2] = c[w >> 2] | 1;w = f;l = x;return w | 0;
	        }m = c[2785] | 0;if (k >>> 0 > m >>> 0) {
	          if (d | 0) {
	            b = 2 << a;b = d << a & (b | 0 - b);b = (b & 0 - b) + -1 | 0;h = b >>> 12 & 16;b = b >>> h;d = b >>> 5 & 8;b = b >>> d;f = b >>> 2 & 4;b = b >>> f;a = b >>> 1 & 2;b = b >>> a;e = b >>> 1 & 1;e = (d | h | f | a | e) + (b >>> e) | 0;b = 11172 + (e << 1 << 2) | 0;a = b + 8 | 0;f = c[a >> 2] | 0;h = f + 8 | 0;d = c[h >> 2] | 0;if ((b | 0) == (d | 0)) {
	              a = n & ~(1 << e);c[2783] = a;
	            } else {
	              c[d + 12 >> 2] = b;c[a >> 2] = d;a = n;
	            }g = (e << 3) - k | 0;c[f + 4 >> 2] = k | 3;e = f + k | 0;c[e + 4 >> 2] = g | 1;c[e + g >> 2] = g;if (m | 0) {
	              f = c[2788] | 0;b = m >>> 3;d = 11172 + (b << 1 << 2) | 0;b = 1 << b;if (!(a & b)) {
	                c[2783] = a | b;b = d;a = d + 8 | 0;
	              } else {
	                a = d + 8 | 0;b = c[a >> 2] | 0;
	              }c[a >> 2] = f;c[b + 12 >> 2] = f;c[f + 8 >> 2] = b;c[f + 12 >> 2] = d;
	            }c[2785] = g;c[2788] = e;w = h;l = x;return w | 0;
	          }i = c[2784] | 0;if (i) {
	            d = (i & 0 - i) + -1 | 0;h = d >>> 12 & 16;d = d >>> h;g = d >>> 5 & 8;d = d >>> g;j = d >>> 2 & 4;d = d >>> j;e = d >>> 1 & 2;d = d >>> e;a = d >>> 1 & 1;a = c[11436 + ((g | h | j | e | a) + (d >>> a) << 2) >> 2] | 0;d = (c[a + 4 >> 2] & -8) - k | 0;e = c[a + 16 + (((c[a + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;if (!e) {
	              j = a;g = d;
	            } else {
	              do {
	                h = (c[e + 4 >> 2] & -8) - k | 0;j = h >>> 0 < d >>> 0;d = j ? h : d;a = j ? e : a;e = c[e + 16 + (((c[e + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;
	              } while ((e | 0) != 0);j = a;g = d;
	            }h = j + k | 0;if (j >>> 0 < h >>> 0) {
	              f = c[j + 24 >> 2] | 0;b = c[j + 12 >> 2] | 0;do if ((b | 0) == (j | 0)) {
	                a = j + 20 | 0;b = c[a >> 2] | 0;if (!b) {
	                  a = j + 16 | 0;b = c[a >> 2] | 0;if (!b) {
	                    d = 0;break;
	                  }
	                }while (1) {
	                  d = b + 20 | 0;e = c[d >> 2] | 0;if (e | 0) {
	                    b = e;a = d;continue;
	                  }d = b + 16 | 0;e = c[d >> 2] | 0;if (!e) break;else {
	                    b = e;a = d;
	                  }
	                }c[a >> 2] = 0;d = b;
	              } else {
	                d = c[j + 8 >> 2] | 0;c[d + 12 >> 2] = b;c[b + 8 >> 2] = d;d = b;
	              } while (0);do if (f | 0) {
	                b = c[j + 28 >> 2] | 0;a = 11436 + (b << 2) | 0;if ((j | 0) == (c[a >> 2] | 0)) {
	                  c[a >> 2] = d;if (!d) {
	                    c[2784] = i & ~(1 << b);break;
	                  }
	                } else {
	                  c[f + 16 + (((c[f + 16 >> 2] | 0) != (j | 0) & 1) << 2) >> 2] = d;if (!d) break;
	                }c[d + 24 >> 2] = f;b = c[j + 16 >> 2] | 0;if (b | 0) {
	                  c[d + 16 >> 2] = b;c[b + 24 >> 2] = d;
	                }b = c[j + 20 >> 2] | 0;if (b | 0) {
	                  c[d + 20 >> 2] = b;c[b + 24 >> 2] = d;
	                }
	              } while (0);if (g >>> 0 < 16) {
	                w = g + k | 0;c[j + 4 >> 2] = w | 3;w = j + w + 4 | 0;c[w >> 2] = c[w >> 2] | 1;
	              } else {
	                c[j + 4 >> 2] = k | 3;c[h + 4 >> 2] = g | 1;c[h + g >> 2] = g;if (m | 0) {
	                  e = c[2788] | 0;b = m >>> 3;d = 11172 + (b << 1 << 2) | 0;b = 1 << b;if (!(n & b)) {
	                    c[2783] = n | b;b = d;a = d + 8 | 0;
	                  } else {
	                    a = d + 8 | 0;b = c[a >> 2] | 0;
	                  }c[a >> 2] = e;c[b + 12 >> 2] = e;c[e + 8 >> 2] = b;c[e + 12 >> 2] = d;
	                }c[2785] = g;c[2788] = h;
	              }w = j + 8 | 0;l = x;return w | 0;
	            } else n = k;
	          } else n = k;
	        } else n = k;
	      } else if (a >>> 0 <= 4294967231) {
	        a = a + 11 | 0;k = a & -8;j = c[2784] | 0;if (j) {
	          e = 0 - k | 0;a = a >>> 8;if (a) {
	            if (k >>> 0 > 16777215) i = 31;else {
	              n = (a + 1048320 | 0) >>> 16 & 8;v = a << n;m = (v + 520192 | 0) >>> 16 & 4;v = v << m;i = (v + 245760 | 0) >>> 16 & 2;i = 14 - (m | n | i) + (v << i >>> 15) | 0;i = k >>> (i + 7 | 0) & 1 | i << 1;
	            }
	          } else i = 0;d = c[11436 + (i << 2) >> 2] | 0;a: do if (!d) {
	            d = 0;a = 0;v = 57;
	          } else {
	            a = 0;h = k << ((i | 0) == 31 ? 0 : 25 - (i >>> 1) | 0);g = 0;while (1) {
	              f = (c[d + 4 >> 2] & -8) - k | 0;if (f >>> 0 < e >>> 0) if (!f) {
	                a = d;e = 0;f = d;v = 61;break a;
	              } else {
	                a = d;e = f;
	              }f = c[d + 20 >> 2] | 0;d = c[d + 16 + (h >>> 31 << 2) >> 2] | 0;g = (f | 0) == 0 | (f | 0) == (d | 0) ? g : f;f = (d | 0) == 0;if (f) {
	                d = g;v = 57;break;
	              } else h = h << ((f ^ 1) & 1);
	            }
	          } while (0);if ((v | 0) == 57) {
	            if ((d | 0) == 0 & (a | 0) == 0) {
	              a = 2 << i;a = j & (a | 0 - a);if (!a) {
	                n = k;break;
	              }n = (a & 0 - a) + -1 | 0;h = n >>> 12 & 16;n = n >>> h;g = n >>> 5 & 8;n = n >>> g;i = n >>> 2 & 4;n = n >>> i;m = n >>> 1 & 2;n = n >>> m;d = n >>> 1 & 1;a = 0;d = c[11436 + ((g | h | i | m | d) + (n >>> d) << 2) >> 2] | 0;
	            }if (!d) {
	              i = a;h = e;
	            } else {
	              f = d;v = 61;
	            }
	          }if ((v | 0) == 61) while (1) {
	            v = 0;d = (c[f + 4 >> 2] & -8) - k | 0;n = d >>> 0 < e >>> 0;d = n ? d : e;a = n ? f : a;f = c[f + 16 + (((c[f + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;if (!f) {
	              i = a;h = d;break;
	            } else {
	              e = d;v = 61;
	            }
	          }if ((i | 0) != 0 ? h >>> 0 < ((c[2785] | 0) - k | 0) >>> 0 : 0) {
	            g = i + k | 0;if (i >>> 0 >= g >>> 0) {
	              w = 0;l = x;return w | 0;
	            }f = c[i + 24 >> 2] | 0;b = c[i + 12 >> 2] | 0;do if ((b | 0) == (i | 0)) {
	              a = i + 20 | 0;b = c[a >> 2] | 0;if (!b) {
	                a = i + 16 | 0;b = c[a >> 2] | 0;if (!b) {
	                  b = 0;break;
	                }
	              }while (1) {
	                d = b + 20 | 0;e = c[d >> 2] | 0;if (e | 0) {
	                  b = e;a = d;continue;
	                }d = b + 16 | 0;e = c[d >> 2] | 0;if (!e) break;else {
	                  b = e;a = d;
	                }
	              }c[a >> 2] = 0;
	            } else {
	              w = c[i + 8 >> 2] | 0;c[w + 12 >> 2] = b;c[b + 8 >> 2] = w;
	            } while (0);do if (f) {
	              a = c[i + 28 >> 2] | 0;d = 11436 + (a << 2) | 0;if ((i | 0) == (c[d >> 2] | 0)) {
	                c[d >> 2] = b;if (!b) {
	                  e = j & ~(1 << a);c[2784] = e;break;
	                }
	              } else {
	                c[f + 16 + (((c[f + 16 >> 2] | 0) != (i | 0) & 1) << 2) >> 2] = b;if (!b) {
	                  e = j;break;
	                }
	              }c[b + 24 >> 2] = f;a = c[i + 16 >> 2] | 0;if (a | 0) {
	                c[b + 16 >> 2] = a;c[a + 24 >> 2] = b;
	              }a = c[i + 20 >> 2] | 0;if (a) {
	                c[b + 20 >> 2] = a;c[a + 24 >> 2] = b;e = j;
	              } else e = j;
	            } else e = j; while (0);do if (h >>> 0 >= 16) {
	              c[i + 4 >> 2] = k | 3;c[g + 4 >> 2] = h | 1;c[g + h >> 2] = h;b = h >>> 3;if (h >>> 0 < 256) {
	                d = 11172 + (b << 1 << 2) | 0;a = c[2783] | 0;b = 1 << b;if (!(a & b)) {
	                  c[2783] = a | b;b = d;a = d + 8 | 0;
	                } else {
	                  a = d + 8 | 0;b = c[a >> 2] | 0;
	                }c[a >> 2] = g;c[b + 12 >> 2] = g;c[g + 8 >> 2] = b;c[g + 12 >> 2] = d;break;
	              }b = h >>> 8;if (b) {
	                if (h >>> 0 > 16777215) b = 31;else {
	                  v = (b + 1048320 | 0) >>> 16 & 8;w = b << v;u = (w + 520192 | 0) >>> 16 & 4;w = w << u;b = (w + 245760 | 0) >>> 16 & 2;b = 14 - (u | v | b) + (w << b >>> 15) | 0;b = h >>> (b + 7 | 0) & 1 | b << 1;
	                }
	              } else b = 0;d = 11436 + (b << 2) | 0;c[g + 28 >> 2] = b;a = g + 16 | 0;c[a + 4 >> 2] = 0;c[a >> 2] = 0;a = 1 << b;if (!(e & a)) {
	                c[2784] = e | a;c[d >> 2] = g;c[g + 24 >> 2] = d;c[g + 12 >> 2] = g;c[g + 8 >> 2] = g;break;
	              }a = h << ((b | 0) == 31 ? 0 : 25 - (b >>> 1) | 0);d = c[d >> 2] | 0;while (1) {
	                if ((c[d + 4 >> 2] & -8 | 0) == (h | 0)) {
	                  v = 97;break;
	                }e = d + 16 + (a >>> 31 << 2) | 0;b = c[e >> 2] | 0;if (!b) {
	                  v = 96;break;
	                } else {
	                  a = a << 1;d = b;
	                }
	              }if ((v | 0) == 96) {
	                c[e >> 2] = g;c[g + 24 >> 2] = d;c[g + 12 >> 2] = g;c[g + 8 >> 2] = g;break;
	              } else if ((v | 0) == 97) {
	                v = d + 8 | 0;w = c[v >> 2] | 0;c[w + 12 >> 2] = g;c[v >> 2] = g;c[g + 8 >> 2] = w;c[g + 12 >> 2] = d;c[g + 24 >> 2] = 0;break;
	              }
	            } else {
	              w = h + k | 0;c[i + 4 >> 2] = w | 3;w = i + w + 4 | 0;c[w >> 2] = c[w >> 2] | 1;
	            } while (0);w = i + 8 | 0;l = x;return w | 0;
	          } else n = k;
	        } else n = k;
	      } else n = -1; while (0);d = c[2785] | 0;if (d >>> 0 >= n >>> 0) {
	        b = d - n | 0;a = c[2788] | 0;if (b >>> 0 > 15) {
	          w = a + n | 0;c[2788] = w;c[2785] = b;c[w + 4 >> 2] = b | 1;c[w + b >> 2] = b;c[a + 4 >> 2] = n | 3;
	        } else {
	          c[2785] = 0;c[2788] = 0;c[a + 4 >> 2] = d | 3;w = a + d + 4 | 0;c[w >> 2] = c[w >> 2] | 1;
	        }w = a + 8 | 0;l = x;return w | 0;
	      }h = c[2786] | 0;if (h >>> 0 > n >>> 0) {
	        u = h - n | 0;c[2786] = u;w = c[2789] | 0;v = w + n | 0;c[2789] = v;c[v + 4 >> 2] = u | 1;c[w + 4 >> 2] = n | 3;w = w + 8 | 0;l = x;return w | 0;
	      }if (!(c[2901] | 0)) {
	        c[2903] = 4096;c[2902] = 4096;c[2904] = -1;c[2905] = -1;c[2906] = 0;c[2894] = 0;a = o & -16 ^ 1431655768;c[o >> 2] = a;c[2901] = a;a = 4096;
	      } else a = c[2903] | 0;i = n + 48 | 0;j = n + 47 | 0;g = a + j | 0;f = 0 - a | 0;k = g & f;if (k >>> 0 <= n >>> 0) {
	        w = 0;l = x;return w | 0;
	      }a = c[2893] | 0;if (a | 0 ? (m = c[2891] | 0, o = m + k | 0, o >>> 0 <= m >>> 0 | o >>> 0 > a >>> 0) : 0) {
	        w = 0;l = x;return w | 0;
	      }b: do if (!(c[2894] & 4)) {
	        d = c[2789] | 0;c: do if (d) {
	          e = 11580;while (1) {
	            a = c[e >> 2] | 0;if (a >>> 0 <= d >>> 0 ? (r = e + 4 | 0, (a + (c[r >> 2] | 0) | 0) >>> 0 > d >>> 0) : 0) break;a = c[e + 8 >> 2] | 0;if (!a) {
	              v = 118;break c;
	            } else e = a;
	          }b = g - h & f;if (b >>> 0 < 2147483647) {
	            a = FC(b | 0) | 0;if ((a | 0) == ((c[e >> 2] | 0) + (c[r >> 2] | 0) | 0)) {
	              if ((a | 0) != (-1 | 0)) {
	                h = b;g = a;v = 135;break b;
	              }
	            } else {
	              e = a;v = 126;
	            }
	          } else b = 0;
	        } else v = 118; while (0);do if ((v | 0) == 118) {
	          d = FC(0) | 0;if ((d | 0) != (-1 | 0) ? (b = d, p = c[2902] | 0, q = p + -1 | 0, b = ((q & b | 0) == 0 ? 0 : (q + b & 0 - p) - b | 0) + k | 0, p = c[2891] | 0, q = b + p | 0, b >>> 0 > n >>> 0 & b >>> 0 < 2147483647) : 0) {
	            r = c[2893] | 0;if (r | 0 ? q >>> 0 <= p >>> 0 | q >>> 0 > r >>> 0 : 0) {
	              b = 0;break;
	            }a = FC(b | 0) | 0;if ((a | 0) == (d | 0)) {
	              h = b;g = d;v = 135;break b;
	            } else {
	              e = a;v = 126;
	            }
	          } else b = 0;
	        } while (0);do if ((v | 0) == 126) {
	          d = 0 - b | 0;if (!(i >>> 0 > b >>> 0 & (b >>> 0 < 2147483647 & (e | 0) != (-1 | 0)))) if ((e | 0) == (-1 | 0)) {
	            b = 0;break;
	          } else {
	            h = b;g = e;v = 135;break b;
	          }a = c[2903] | 0;a = j - b + a & 0 - a;if (a >>> 0 >= 2147483647) {
	            h = b;g = e;v = 135;break b;
	          }if ((FC(a | 0) | 0) == (-1 | 0)) {
	            FC(d | 0) | 0;b = 0;break;
	          } else {
	            h = a + b | 0;g = e;v = 135;break b;
	          }
	        } while (0);c[2894] = c[2894] | 4;v = 133;
	      } else {
	        b = 0;v = 133;
	      } while (0);if (((v | 0) == 133 ? k >>> 0 < 2147483647 : 0) ? (u = FC(k | 0) | 0, r = FC(0) | 0, s = r - u | 0, t = s >>> 0 > (n + 40 | 0) >>> 0, !((u | 0) == (-1 | 0) | t ^ 1 | u >>> 0 < r >>> 0 & ((u | 0) != (-1 | 0) & (r | 0) != (-1 | 0)) ^ 1)) : 0) {
	        h = t ? s : b;g = u;v = 135;
	      }if ((v | 0) == 135) {
	        b = (c[2891] | 0) + h | 0;c[2891] = b;if (b >>> 0 > (c[2892] | 0) >>> 0) c[2892] = b;j = c[2789] | 0;do if (j) {
	          b = 11580;while (1) {
	            a = c[b >> 2] | 0;d = b + 4 | 0;e = c[d >> 2] | 0;if ((g | 0) == (a + e | 0)) {
	              v = 145;break;
	            }f = c[b + 8 >> 2] | 0;if (!f) break;else b = f;
	          }if (((v | 0) == 145 ? (c[b + 12 >> 2] & 8 | 0) == 0 : 0) ? j >>> 0 < g >>> 0 & j >>> 0 >= a >>> 0 : 0) {
	            c[d >> 2] = e + h;w = j + 8 | 0;w = (w & 7 | 0) == 0 ? 0 : 0 - w & 7;v = j + w | 0;w = (c[2786] | 0) + (h - w) | 0;c[2789] = v;c[2786] = w;c[v + 4 >> 2] = w | 1;c[v + w + 4 >> 2] = 40;c[2790] = c[2905];break;
	          }if (g >>> 0 < (c[2787] | 0) >>> 0) c[2787] = g;d = g + h | 0;b = 11580;while (1) {
	            if ((c[b >> 2] | 0) == (d | 0)) {
	              v = 153;break;
	            }a = c[b + 8 >> 2] | 0;if (!a) break;else b = a;
	          }if ((v | 0) == 153 ? (c[b + 12 >> 2] & 8 | 0) == 0 : 0) {
	            c[b >> 2] = g;m = b + 4 | 0;c[m >> 2] = (c[m >> 2] | 0) + h;m = g + 8 | 0;m = g + ((m & 7 | 0) == 0 ? 0 : 0 - m & 7) | 0;b = d + 8 | 0;b = d + ((b & 7 | 0) == 0 ? 0 : 0 - b & 7) | 0;k = m + n | 0;i = b - m - n | 0;c[m + 4 >> 2] = n | 3;do if ((b | 0) != (j | 0)) {
	              if ((b | 0) == (c[2788] | 0)) {
	                w = (c[2785] | 0) + i | 0;c[2785] = w;c[2788] = k;c[k + 4 >> 2] = w | 1;c[k + w >> 2] = w;break;
	              }a = c[b + 4 >> 2] | 0;if ((a & 3 | 0) == 1) {
	                h = a & -8;e = a >>> 3;d: do if (a >>> 0 < 256) {
	                  a = c[b + 8 >> 2] | 0;d = c[b + 12 >> 2] | 0;if ((d | 0) == (a | 0)) {
	                    c[2783] = c[2783] & ~(1 << e);break;
	                  } else {
	                    c[a + 12 >> 2] = d;c[d + 8 >> 2] = a;break;
	                  }
	                } else {
	                  g = c[b + 24 >> 2] | 0;a = c[b + 12 >> 2] | 0;do if ((a | 0) == (b | 0)) {
	                    e = b + 16 | 0;d = e + 4 | 0;a = c[d >> 2] | 0;if (!a) {
	                      a = c[e >> 2] | 0;if (!a) {
	                        a = 0;break;
	                      } else d = e;
	                    }while (1) {
	                      e = a + 20 | 0;f = c[e >> 2] | 0;if (f | 0) {
	                        a = f;d = e;continue;
	                      }e = a + 16 | 0;f = c[e >> 2] | 0;if (!f) break;else {
	                        a = f;d = e;
	                      }
	                    }c[d >> 2] = 0;
	                  } else {
	                    w = c[b + 8 >> 2] | 0;c[w + 12 >> 2] = a;c[a + 8 >> 2] = w;
	                  } while (0);if (!g) break;d = c[b + 28 >> 2] | 0;e = 11436 + (d << 2) | 0;do if ((b | 0) != (c[e >> 2] | 0)) {
	                    c[g + 16 + (((c[g + 16 >> 2] | 0) != (b | 0) & 1) << 2) >> 2] = a;if (!a) break d;
	                  } else {
	                    c[e >> 2] = a;if (a | 0) break;c[2784] = c[2784] & ~(1 << d);break d;
	                  } while (0);c[a + 24 >> 2] = g;d = b + 16 | 0;e = c[d >> 2] | 0;if (e | 0) {
	                    c[a + 16 >> 2] = e;c[e + 24 >> 2] = a;
	                  }d = c[d + 4 >> 2] | 0;if (!d) break;c[a + 20 >> 2] = d;c[d + 24 >> 2] = a;
	                } while (0);b = b + h | 0;f = h + i | 0;
	              } else f = i;b = b + 4 | 0;c[b >> 2] = c[b >> 2] & -2;c[k + 4 >> 2] = f | 1;c[k + f >> 2] = f;b = f >>> 3;if (f >>> 0 < 256) {
	                d = 11172 + (b << 1 << 2) | 0;a = c[2783] | 0;b = 1 << b;if (!(a & b)) {
	                  c[2783] = a | b;b = d;a = d + 8 | 0;
	                } else {
	                  a = d + 8 | 0;b = c[a >> 2] | 0;
	                }c[a >> 2] = k;c[b + 12 >> 2] = k;c[k + 8 >> 2] = b;c[k + 12 >> 2] = d;break;
	              }b = f >>> 8;do if (!b) b = 0;else {
	                if (f >>> 0 > 16777215) {
	                  b = 31;break;
	                }v = (b + 1048320 | 0) >>> 16 & 8;w = b << v;u = (w + 520192 | 0) >>> 16 & 4;w = w << u;b = (w + 245760 | 0) >>> 16 & 2;b = 14 - (u | v | b) + (w << b >>> 15) | 0;b = f >>> (b + 7 | 0) & 1 | b << 1;
	              } while (0);e = 11436 + (b << 2) | 0;c[k + 28 >> 2] = b;a = k + 16 | 0;c[a + 4 >> 2] = 0;c[a >> 2] = 0;a = c[2784] | 0;d = 1 << b;if (!(a & d)) {
	                c[2784] = a | d;c[e >> 2] = k;c[k + 24 >> 2] = e;c[k + 12 >> 2] = k;c[k + 8 >> 2] = k;break;
	              }a = f << ((b | 0) == 31 ? 0 : 25 - (b >>> 1) | 0);d = c[e >> 2] | 0;while (1) {
	                if ((c[d + 4 >> 2] & -8 | 0) == (f | 0)) {
	                  v = 194;break;
	                }e = d + 16 + (a >>> 31 << 2) | 0;b = c[e >> 2] | 0;if (!b) {
	                  v = 193;break;
	                } else {
	                  a = a << 1;d = b;
	                }
	              }if ((v | 0) == 193) {
	                c[e >> 2] = k;c[k + 24 >> 2] = d;c[k + 12 >> 2] = k;c[k + 8 >> 2] = k;break;
	              } else if ((v | 0) == 194) {
	                v = d + 8 | 0;w = c[v >> 2] | 0;c[w + 12 >> 2] = k;c[v >> 2] = k;c[k + 8 >> 2] = w;c[k + 12 >> 2] = d;c[k + 24 >> 2] = 0;break;
	              }
	            } else {
	              w = (c[2786] | 0) + i | 0;c[2786] = w;c[2789] = k;c[k + 4 >> 2] = w | 1;
	            } while (0);w = m + 8 | 0;l = x;return w | 0;
	          }b = 11580;while (1) {
	            a = c[b >> 2] | 0;if (a >>> 0 <= j >>> 0 ? (w = a + (c[b + 4 >> 2] | 0) | 0, w >>> 0 > j >>> 0) : 0) break;b = c[b + 8 >> 2] | 0;
	          }f = w + -47 | 0;a = f + 8 | 0;a = f + ((a & 7 | 0) == 0 ? 0 : 0 - a & 7) | 0;f = j + 16 | 0;a = a >>> 0 < f >>> 0 ? j : a;b = a + 8 | 0;d = g + 8 | 0;d = (d & 7 | 0) == 0 ? 0 : 0 - d & 7;v = g + d | 0;d = h + -40 - d | 0;c[2789] = v;c[2786] = d;c[v + 4 >> 2] = d | 1;c[v + d + 4 >> 2] = 40;c[2790] = c[2905];d = a + 4 | 0;c[d >> 2] = 27;c[b >> 2] = c[2895];c[b + 4 >> 2] = c[2896];c[b + 8 >> 2] = c[2897];c[b + 12 >> 2] = c[2898];c[2895] = g;c[2896] = h;c[2898] = 0;c[2897] = b;b = a + 24 | 0;do {
	            v = b;b = b + 4 | 0;c[b >> 2] = 7;
	          } while ((v + 8 | 0) >>> 0 < w >>> 0);if ((a | 0) != (j | 0)) {
	            g = a - j | 0;c[d >> 2] = c[d >> 2] & -2;c[j + 4 >> 2] = g | 1;c[a >> 2] = g;b = g >>> 3;if (g >>> 0 < 256) {
	              d = 11172 + (b << 1 << 2) | 0;a = c[2783] | 0;b = 1 << b;if (!(a & b)) {
	                c[2783] = a | b;b = d;a = d + 8 | 0;
	              } else {
	                a = d + 8 | 0;b = c[a >> 2] | 0;
	              }c[a >> 2] = j;c[b + 12 >> 2] = j;c[j + 8 >> 2] = b;c[j + 12 >> 2] = d;break;
	            }b = g >>> 8;if (b) {
	              if (g >>> 0 > 16777215) d = 31;else {
	                v = (b + 1048320 | 0) >>> 16 & 8;w = b << v;u = (w + 520192 | 0) >>> 16 & 4;w = w << u;d = (w + 245760 | 0) >>> 16 & 2;d = 14 - (u | v | d) + (w << d >>> 15) | 0;d = g >>> (d + 7 | 0) & 1 | d << 1;
	              }
	            } else d = 0;e = 11436 + (d << 2) | 0;c[j + 28 >> 2] = d;c[j + 20 >> 2] = 0;c[f >> 2] = 0;b = c[2784] | 0;a = 1 << d;if (!(b & a)) {
	              c[2784] = b | a;c[e >> 2] = j;c[j + 24 >> 2] = e;c[j + 12 >> 2] = j;c[j + 8 >> 2] = j;break;
	            }a = g << ((d | 0) == 31 ? 0 : 25 - (d >>> 1) | 0);d = c[e >> 2] | 0;while (1) {
	              if ((c[d + 4 >> 2] & -8 | 0) == (g | 0)) {
	                v = 216;break;
	              }e = d + 16 + (a >>> 31 << 2) | 0;b = c[e >> 2] | 0;if (!b) {
	                v = 215;break;
	              } else {
	                a = a << 1;d = b;
	              }
	            }if ((v | 0) == 215) {
	              c[e >> 2] = j;c[j + 24 >> 2] = d;c[j + 12 >> 2] = j;c[j + 8 >> 2] = j;break;
	            } else if ((v | 0) == 216) {
	              v = d + 8 | 0;w = c[v >> 2] | 0;c[w + 12 >> 2] = j;c[v >> 2] = j;c[j + 8 >> 2] = w;c[j + 12 >> 2] = d;c[j + 24 >> 2] = 0;break;
	            }
	          }
	        } else {
	          w = c[2787] | 0;if ((w | 0) == 0 | g >>> 0 < w >>> 0) c[2787] = g;c[2895] = g;c[2896] = h;c[2898] = 0;c[2792] = c[2901];c[2791] = -1;b = 0;do {
	            w = 11172 + (b << 1 << 2) | 0;c[w + 12 >> 2] = w;c[w + 8 >> 2] = w;b = b + 1 | 0;
	          } while ((b | 0) != 32);w = g + 8 | 0;w = (w & 7 | 0) == 0 ? 0 : 0 - w & 7;v = g + w | 0;w = h + -40 - w | 0;c[2789] = v;c[2786] = w;c[v + 4 >> 2] = w | 1;c[v + w + 4 >> 2] = 40;c[2790] = c[2905];
	        } while (0);b = c[2786] | 0;if (b >>> 0 > n >>> 0) {
	          u = b - n | 0;c[2786] = u;w = c[2789] | 0;v = w + n | 0;c[2789] = v;c[v + 4 >> 2] = u | 1;c[w + 4 >> 2] = n | 3;w = w + 8 | 0;l = x;return w | 0;
	        }
	      }c[(vB() | 0) >> 2] = 12;w = 0;l = x;return w | 0;
	    }function pB(a) {
	      a = a | 0;var b = 0,
	          d = 0,
	          e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;if (!a) return;d = a + -8 | 0;f = c[2787] | 0;a = c[a + -4 >> 2] | 0;b = a & -8;j = d + b | 0;do if (!(a & 1)) {
	        e = c[d >> 2] | 0;if (!(a & 3)) return;h = d + (0 - e) | 0;g = e + b | 0;if (h >>> 0 < f >>> 0) return;if ((h | 0) == (c[2788] | 0)) {
	          a = j + 4 | 0;b = c[a >> 2] | 0;if ((b & 3 | 0) != 3) {
	            i = h;b = g;break;
	          }c[2785] = g;c[a >> 2] = b & -2;c[h + 4 >> 2] = g | 1;c[h + g >> 2] = g;return;
	        }d = e >>> 3;if (e >>> 0 < 256) {
	          a = c[h + 8 >> 2] | 0;b = c[h + 12 >> 2] | 0;if ((b | 0) == (a | 0)) {
	            c[2783] = c[2783] & ~(1 << d);i = h;b = g;break;
	          } else {
	            c[a + 12 >> 2] = b;c[b + 8 >> 2] = a;i = h;b = g;break;
	          }
	        }f = c[h + 24 >> 2] | 0;a = c[h + 12 >> 2] | 0;do if ((a | 0) == (h | 0)) {
	          d = h + 16 | 0;b = d + 4 | 0;a = c[b >> 2] | 0;if (!a) {
	            a = c[d >> 2] | 0;if (!a) {
	              a = 0;break;
	            } else b = d;
	          }while (1) {
	            d = a + 20 | 0;e = c[d >> 2] | 0;if (e | 0) {
	              a = e;b = d;continue;
	            }d = a + 16 | 0;e = c[d >> 2] | 0;if (!e) break;else {
	              a = e;b = d;
	            }
	          }c[b >> 2] = 0;
	        } else {
	          i = c[h + 8 >> 2] | 0;c[i + 12 >> 2] = a;c[a + 8 >> 2] = i;
	        } while (0);if (f) {
	          b = c[h + 28 >> 2] | 0;d = 11436 + (b << 2) | 0;if ((h | 0) == (c[d >> 2] | 0)) {
	            c[d >> 2] = a;if (!a) {
	              c[2784] = c[2784] & ~(1 << b);i = h;b = g;break;
	            }
	          } else {
	            c[f + 16 + (((c[f + 16 >> 2] | 0) != (h | 0) & 1) << 2) >> 2] = a;if (!a) {
	              i = h;b = g;break;
	            }
	          }c[a + 24 >> 2] = f;b = h + 16 | 0;d = c[b >> 2] | 0;if (d | 0) {
	            c[a + 16 >> 2] = d;c[d + 24 >> 2] = a;
	          }b = c[b + 4 >> 2] | 0;if (b) {
	            c[a + 20 >> 2] = b;c[b + 24 >> 2] = a;i = h;b = g;
	          } else {
	            i = h;b = g;
	          }
	        } else {
	          i = h;b = g;
	        }
	      } else {
	        i = d;h = d;
	      } while (0);if (h >>> 0 >= j >>> 0) return;a = j + 4 | 0;e = c[a >> 2] | 0;if (!(e & 1)) return;if (!(e & 2)) {
	        a = c[2788] | 0;if ((j | 0) == (c[2789] | 0)) {
	          j = (c[2786] | 0) + b | 0;c[2786] = j;c[2789] = i;c[i + 4 >> 2] = j | 1;if ((i | 0) != (a | 0)) return;c[2788] = 0;c[2785] = 0;return;
	        }if ((j | 0) == (a | 0)) {
	          j = (c[2785] | 0) + b | 0;c[2785] = j;c[2788] = h;c[i + 4 >> 2] = j | 1;c[h + j >> 2] = j;return;
	        }f = (e & -8) + b | 0;d = e >>> 3;do if (e >>> 0 < 256) {
	          b = c[j + 8 >> 2] | 0;a = c[j + 12 >> 2] | 0;if ((a | 0) == (b | 0)) {
	            c[2783] = c[2783] & ~(1 << d);break;
	          } else {
	            c[b + 12 >> 2] = a;c[a + 8 >> 2] = b;break;
	          }
	        } else {
	          g = c[j + 24 >> 2] | 0;a = c[j + 12 >> 2] | 0;do if ((a | 0) == (j | 0)) {
	            d = j + 16 | 0;b = d + 4 | 0;a = c[b >> 2] | 0;if (!a) {
	              a = c[d >> 2] | 0;if (!a) {
	                d = 0;break;
	              } else b = d;
	            }while (1) {
	              d = a + 20 | 0;e = c[d >> 2] | 0;if (e | 0) {
	                a = e;b = d;continue;
	              }d = a + 16 | 0;e = c[d >> 2] | 0;if (!e) break;else {
	                a = e;b = d;
	              }
	            }c[b >> 2] = 0;d = a;
	          } else {
	            d = c[j + 8 >> 2] | 0;c[d + 12 >> 2] = a;c[a + 8 >> 2] = d;d = a;
	          } while (0);if (g | 0) {
	            a = c[j + 28 >> 2] | 0;b = 11436 + (a << 2) | 0;if ((j | 0) == (c[b >> 2] | 0)) {
	              c[b >> 2] = d;if (!d) {
	                c[2784] = c[2784] & ~(1 << a);break;
	              }
	            } else {
	              c[g + 16 + (((c[g + 16 >> 2] | 0) != (j | 0) & 1) << 2) >> 2] = d;if (!d) break;
	            }c[d + 24 >> 2] = g;a = j + 16 | 0;b = c[a >> 2] | 0;if (b | 0) {
	              c[d + 16 >> 2] = b;c[b + 24 >> 2] = d;
	            }a = c[a + 4 >> 2] | 0;if (a | 0) {
	              c[d + 20 >> 2] = a;c[a + 24 >> 2] = d;
	            }
	          }
	        } while (0);c[i + 4 >> 2] = f | 1;c[h + f >> 2] = f;if ((i | 0) == (c[2788] | 0)) {
	          c[2785] = f;return;
	        }
	      } else {
	        c[a >> 2] = e & -2;c[i + 4 >> 2] = b | 1;c[h + b >> 2] = b;f = b;
	      }a = f >>> 3;if (f >>> 0 < 256) {
	        d = 11172 + (a << 1 << 2) | 0;b = c[2783] | 0;a = 1 << a;if (!(b & a)) {
	          c[2783] = b | a;a = d;b = d + 8 | 0;
	        } else {
	          b = d + 8 | 0;a = c[b >> 2] | 0;
	        }c[b >> 2] = i;c[a + 12 >> 2] = i;c[i + 8 >> 2] = a;c[i + 12 >> 2] = d;return;
	      }a = f >>> 8;if (a) {
	        if (f >>> 0 > 16777215) a = 31;else {
	          h = (a + 1048320 | 0) >>> 16 & 8;j = a << h;g = (j + 520192 | 0) >>> 16 & 4;j = j << g;a = (j + 245760 | 0) >>> 16 & 2;a = 14 - (g | h | a) + (j << a >>> 15) | 0;a = f >>> (a + 7 | 0) & 1 | a << 1;
	        }
	      } else a = 0;e = 11436 + (a << 2) | 0;c[i + 28 >> 2] = a;c[i + 20 >> 2] = 0;c[i + 16 >> 2] = 0;b = c[2784] | 0;d = 1 << a;do if (b & d) {
	        b = f << ((a | 0) == 31 ? 0 : 25 - (a >>> 1) | 0);d = c[e >> 2] | 0;while (1) {
	          if ((c[d + 4 >> 2] & -8 | 0) == (f | 0)) {
	            a = 73;break;
	          }e = d + 16 + (b >>> 31 << 2) | 0;a = c[e >> 2] | 0;if (!a) {
	            a = 72;break;
	          } else {
	            b = b << 1;d = a;
	          }
	        }if ((a | 0) == 72) {
	          c[e >> 2] = i;c[i + 24 >> 2] = d;c[i + 12 >> 2] = i;c[i + 8 >> 2] = i;break;
	        } else if ((a | 0) == 73) {
	          h = d + 8 | 0;j = c[h >> 2] | 0;c[j + 12 >> 2] = i;c[h >> 2] = i;c[i + 8 >> 2] = j;c[i + 12 >> 2] = d;c[i + 24 >> 2] = 0;break;
	        }
	      } else {
	        c[2784] = b | d;c[e >> 2] = i;c[i + 24 >> 2] = e;c[i + 12 >> 2] = i;c[i + 8 >> 2] = i;
	      } while (0);j = (c[2791] | 0) + -1 | 0;c[2791] = j;if (!j) a = 11588;else return;while (1) {
	        a = c[a >> 2] | 0;if (!a) break;else a = a + 8 | 0;
	      }c[2791] = -1;return;
	    }function qB() {
	      return 11628;
	    }function rB(a) {
	      a = a | 0;var b = 0,
	          d = 0;b = l;l = l + 16 | 0;d = b;c[d >> 2] = yB(c[a + 60 >> 2] | 0) | 0;a = uB(db(6, d | 0) | 0) | 0;l = b;return a | 0;
	    }function sB(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0;n = l;l = l + 48 | 0;k = n + 16 | 0;g = n;f = n + 32 | 0;i = a + 28 | 0;e = c[i >> 2] | 0;c[f >> 2] = e;j = a + 20 | 0;e = (c[j >> 2] | 0) - e | 0;c[f + 4 >> 2] = e;c[f + 8 >> 2] = b;c[f + 12 >> 2] = d;e = e + d | 0;h = a + 60 | 0;c[g >> 2] = c[h >> 2];c[g + 4 >> 2] = f;c[g + 8 >> 2] = 2;g = uB(gb(146, g | 0) | 0) | 0;a: do if ((e | 0) != (g | 0)) {
	        b = 2;while (1) {
	          if ((g | 0) < 0) break;e = e - g | 0;p = c[f + 4 >> 2] | 0;o = g >>> 0 > p >>> 0;f = o ? f + 8 | 0 : f;b = (o << 31 >> 31) + b | 0;p = g - (o ? p : 0) | 0;c[f >> 2] = (c[f >> 2] | 0) + p;o = f + 4 | 0;c[o >> 2] = (c[o >> 2] | 0) - p;c[k >> 2] = c[h >> 2];c[k + 4 >> 2] = f;c[k + 8 >> 2] = b;g = uB(gb(146, k | 0) | 0) | 0;if ((e | 0) == (g | 0)) {
	            m = 3;break a;
	          }
	        }c[a + 16 >> 2] = 0;c[i >> 2] = 0;c[j >> 2] = 0;c[a >> 2] = c[a >> 2] | 32;if ((b | 0) == 2) d = 0;else d = d - (c[f + 4 >> 2] | 0) | 0;
	      } else m = 3; while (0);if ((m | 0) == 3) {
	        p = c[a + 44 >> 2] | 0;c[a + 16 >> 2] = p + (c[a + 48 >> 2] | 0);c[i >> 2] = p;c[j >> 2] = p;
	      }l = n;return d | 0;
	    }function tB(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0;f = l;l = l + 32 | 0;g = f;e = f + 20 | 0;c[g >> 2] = c[a + 60 >> 2];c[g + 4 >> 2] = 0;c[g + 8 >> 2] = b;c[g + 12 >> 2] = e;c[g + 16 >> 2] = d;if ((uB(fb(140, g | 0) | 0) | 0) < 0) {
	        c[e >> 2] = -1;a = -1;
	      } else a = c[e >> 2] | 0;l = f;return a | 0;
	    }function uB(a) {
	      a = a | 0;if (a >>> 0 > 4294963200) {
	        c[(vB() | 0) >> 2] = 0 - a;a = -1;
	      }return a | 0;
	    }function vB() {
	      return (wB() | 0) + 64 | 0;
	    }function wB() {
	      return xB() | 0;
	    }function xB() {
	      return 2084;
	    }function yB(a) {
	      a = a | 0;return a | 0;
	    }function zB(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = l;l = l + 32 | 0;f = g;c[b + 36 >> 2] = 1;if ((c[b >> 2] & 64 | 0) == 0 ? (c[f >> 2] = c[b + 60 >> 2], c[f + 4 >> 2] = 21523, c[f + 8 >> 2] = g + 16, Wa(54, f | 0) | 0) : 0) a[b + 75 >> 0] = -1;f = sB(b, d, e) | 0;l = g;return f | 0;
	    }function AB(b, c) {
	      b = b | 0;c = c | 0;var d = 0,
	          e = 0;d = a[b >> 0] | 0;e = a[c >> 0] | 0;if (d << 24 >> 24 == 0 ? 1 : d << 24 >> 24 != e << 24 >> 24) b = e;else {
	        do {
	          b = b + 1 | 0;c = c + 1 | 0;d = a[b >> 0] | 0;e = a[c >> 0] | 0;
	        } while (!(d << 24 >> 24 == 0 ? 1 : d << 24 >> 24 != e << 24 >> 24));b = e;
	      }return (d & 255) - (b & 255) | 0;
	    }function BB(b, c, d) {
	      b = b | 0;c = c | 0;d = d | 0;var e = 0,
	          f = 0;a: do if (!d) b = 0;else {
	        while (1) {
	          e = a[b >> 0] | 0;f = a[c >> 0] | 0;if (e << 24 >> 24 != f << 24 >> 24) break;d = d + -1 | 0;if (!d) {
	            b = 0;break a;
	          } else {
	            b = b + 1 | 0;c = c + 1 | 0;
	          }
	        }b = (e & 255) - (f & 255) | 0;
	      } while (0);return b | 0;
	    }function CB(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0,
	          s = 0;s = l;l = l + 224 | 0;n = s + 120 | 0;o = s + 80 | 0;q = s;r = s + 136 | 0;f = o;g = f + 40 | 0;do {
	        c[f >> 2] = 0;f = f + 4 | 0;
	      } while ((f | 0) < (g | 0));c[n >> 2] = c[e >> 2];if ((DB(0, d, n, q, o) | 0) < 0) e = -1;else {
	        if ((c[b + 76 >> 2] | 0) > -1) p = EB(b) | 0;else p = 0;e = c[b >> 2] | 0;m = e & 32;if ((a[b + 74 >> 0] | 0) < 1) c[b >> 2] = e & -33;f = b + 48 | 0;if (!(c[f >> 2] | 0)) {
	          g = b + 44 | 0;h = c[g >> 2] | 0;c[g >> 2] = r;i = b + 28 | 0;c[i >> 2] = r;j = b + 20 | 0;c[j >> 2] = r;c[f >> 2] = 80;k = b + 16 | 0;c[k >> 2] = r + 80;e = DB(b, d, n, q, o) | 0;if (h) {
	            sb[c[b + 36 >> 2] & 7](b, 0, 0) | 0;e = (c[j >> 2] | 0) == 0 ? -1 : e;c[g >> 2] = h;c[f >> 2] = 0;c[k >> 2] = 0;c[i >> 2] = 0;c[j >> 2] = 0;
	          }
	        } else e = DB(b, d, n, q, o) | 0;f = c[b >> 2] | 0;c[b >> 2] = f | m;if (p | 0) FB(b);e = (f & 32 | 0) == 0 ? e : -1;
	      }l = s;return e | 0;
	    }function DB(d, e, f, g, i) {
	      d = d | 0;e = e | 0;f = f | 0;g = g | 0;i = i | 0;var j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0,
	          s = 0,
	          t = 0,
	          u = 0,
	          v = 0,
	          w = 0,
	          x = 0,
	          y = 0,
	          z = 0,
	          B = 0,
	          C = 0,
	          D = 0,
	          E = 0,
	          F = 0,
	          G = 0,
	          H = 0;H = l;l = l + 64 | 0;D = H + 16 | 0;E = H;B = H + 24 | 0;F = H + 8 | 0;G = H + 20 | 0;c[D >> 2] = e;x = (d | 0) != 0;y = B + 40 | 0;z = y;B = B + 39 | 0;C = F + 4 | 0;k = 0;j = 0;p = 0;a: while (1) {
	        do if ((j | 0) > -1) if ((k | 0) > (2147483647 - j | 0)) {
	          c[(vB() | 0) >> 2] = 75;j = -1;break;
	        } else {
	          j = k + j | 0;break;
	        } while (0);k = a[e >> 0] | 0;if (!(k << 24 >> 24)) {
	          w = 87;break;
	        } else m = e;b: while (1) {
	          switch (k << 24 >> 24) {case 37:
	              {
	                k = m;w = 9;break b;
	              }case 0:
	              {
	                k = m;break b;
	              }default:
	              {}}v = m + 1 | 0;c[D >> 2] = v;k = a[v >> 0] | 0;m = v;
	        }c: do if ((w | 0) == 9) while (1) {
	          w = 0;if ((a[m + 1 >> 0] | 0) != 37) break c;k = k + 1 | 0;m = m + 2 | 0;c[D >> 2] = m;if ((a[m >> 0] | 0) == 37) w = 9;else break;
	        } while (0);k = k - e | 0;if (x) GB(d, e, k);if (k | 0) {
	          e = m;continue;
	        }n = m + 1 | 0;k = (a[n >> 0] | 0) + -48 | 0;if (k >>> 0 < 10) {
	          v = (a[m + 2 >> 0] | 0) == 36;u = v ? k : -1;p = v ? 1 : p;n = v ? m + 3 | 0 : n;
	        } else u = -1;c[D >> 2] = n;k = a[n >> 0] | 0;m = (k << 24 >> 24) + -32 | 0;d: do if (m >>> 0 < 32) {
	          o = 0;q = k;while (1) {
	            k = 1 << m;if (!(k & 75913)) {
	              k = q;break d;
	            }o = k | o;n = n + 1 | 0;c[D >> 2] = n;k = a[n >> 0] | 0;m = (k << 24 >> 24) + -32 | 0;if (m >>> 0 >= 32) break;else q = k;
	          }
	        } else o = 0; while (0);if (k << 24 >> 24 == 42) {
	          m = n + 1 | 0;k = (a[m >> 0] | 0) + -48 | 0;if (k >>> 0 < 10 ? (a[n + 2 >> 0] | 0) == 36 : 0) {
	            c[i + (k << 2) >> 2] = 10;k = c[g + ((a[m >> 0] | 0) + -48 << 3) >> 2] | 0;p = 1;n = n + 3 | 0;
	          } else {
	            if (p | 0) {
	              j = -1;break;
	            }if (x) {
	              p = (c[f >> 2] | 0) + (4 - 1) & ~(4 - 1);k = c[p >> 2] | 0;c[f >> 2] = p + 4;p = 0;n = m;
	            } else {
	              k = 0;p = 0;n = m;
	            }
	          }c[D >> 2] = n;v = (k | 0) < 0;k = v ? 0 - k | 0 : k;o = v ? o | 8192 : o;
	        } else {
	          k = HB(D) | 0;if ((k | 0) < 0) {
	            j = -1;break;
	          }n = c[D >> 2] | 0;
	        }do if ((a[n >> 0] | 0) == 46) {
	          if ((a[n + 1 >> 0] | 0) != 42) {
	            c[D >> 2] = n + 1;m = HB(D) | 0;n = c[D >> 2] | 0;break;
	          }q = n + 2 | 0;m = (a[q >> 0] | 0) + -48 | 0;if (m >>> 0 < 10 ? (a[n + 3 >> 0] | 0) == 36 : 0) {
	            c[i + (m << 2) >> 2] = 10;m = c[g + ((a[q >> 0] | 0) + -48 << 3) >> 2] | 0;n = n + 4 | 0;c[D >> 2] = n;break;
	          }if (p | 0) {
	            j = -1;break a;
	          }if (x) {
	            v = (c[f >> 2] | 0) + (4 - 1) & ~(4 - 1);m = c[v >> 2] | 0;c[f >> 2] = v + 4;
	          } else m = 0;c[D >> 2] = q;n = q;
	        } else m = -1; while (0);t = 0;while (1) {
	          if (((a[n >> 0] | 0) + -65 | 0) >>> 0 > 57) {
	            j = -1;break a;
	          }v = n + 1 | 0;c[D >> 2] = v;q = a[(a[n >> 0] | 0) + -65 + (5178 + (t * 58 | 0)) >> 0] | 0;r = q & 255;if ((r + -1 | 0) >>> 0 < 8) {
	            t = r;n = v;
	          } else break;
	        }if (!(q << 24 >> 24)) {
	          j = -1;break;
	        }s = (u | 0) > -1;do if (q << 24 >> 24 == 19) {
	          if (s) {
	            j = -1;break a;
	          } else w = 49;
	        } else {
	          if (s) {
	            c[i + (u << 2) >> 2] = r;s = g + (u << 3) | 0;u = c[s + 4 >> 2] | 0;w = E;c[w >> 2] = c[s >> 2];c[w + 4 >> 2] = u;w = 49;break;
	          }if (!x) {
	            j = 0;break a;
	          }IB(E, r, f);
	        } while (0);if ((w | 0) == 49 ? (w = 0, !x) : 0) {
	          k = 0;e = v;continue;
	        }n = a[n >> 0] | 0;n = (t | 0) != 0 & (n & 15 | 0) == 3 ? n & -33 : n;s = o & -65537;u = (o & 8192 | 0) == 0 ? o : s;e: do switch (n | 0) {case 110:
	            switch ((t & 255) << 24 >> 24) {case 0:
	                {
	                  c[c[E >> 2] >> 2] = j;k = 0;e = v;continue a;
	                }case 1:
	                {
	                  c[c[E >> 2] >> 2] = j;k = 0;e = v;continue a;
	                }case 2:
	                {
	                  k = c[E >> 2] | 0;c[k >> 2] = j;c[k + 4 >> 2] = ((j | 0) < 0) << 31 >> 31;k = 0;e = v;continue a;
	                }case 3:
	                {
	                  b[c[E >> 2] >> 1] = j;k = 0;e = v;continue a;
	                }case 4:
	                {
	                  a[c[E >> 2] >> 0] = j;k = 0;e = v;continue a;
	                }case 6:
	                {
	                  c[c[E >> 2] >> 2] = j;k = 0;e = v;continue a;
	                }case 7:
	                {
	                  k = c[E >> 2] | 0;c[k >> 2] = j;c[k + 4 >> 2] = ((j | 0) < 0) << 31 >> 31;k = 0;e = v;continue a;
	                }default:
	                {
	                  k = 0;e = v;continue a;
	                }}case 112:
	            {
	              n = 120;m = m >>> 0 > 8 ? m : 8;e = u | 8;w = 61;break;
	            }case 88:case 120:
	            {
	              e = u;w = 61;break;
	            }case 111:
	            {
	              n = E;e = c[n >> 2] | 0;n = c[n + 4 >> 2] | 0;r = KB(e, n, y) | 0;s = z - r | 0;o = 0;q = 5642;m = (u & 8 | 0) == 0 | (m | 0) > (s | 0) ? m : s + 1 | 0;s = u;w = 67;break;
	            }case 105:case 100:
	            {
	              n = E;e = c[n >> 2] | 0;n = c[n + 4 >> 2] | 0;if ((n | 0) < 0) {
	                e = wC(0, 0, e | 0, n | 0) | 0;n = A;o = E;c[o >> 2] = e;c[o + 4 >> 2] = n;o = 1;q = 5642;w = 66;break e;
	              } else {
	                o = (u & 2049 | 0) != 0 & 1;q = (u & 2048 | 0) == 0 ? (u & 1 | 0) == 0 ? 5642 : 5644 : 5643;w = 66;break e;
	              }
	            }case 117:
	            {
	              n = E;o = 0;q = 5642;e = c[n >> 2] | 0;n = c[n + 4 >> 2] | 0;w = 66;break;
	            }case 99:
	            {
	              a[B >> 0] = c[E >> 2];e = B;o = 0;q = 5642;r = y;n = 1;m = s;break;
	            }case 109:
	            {
	              n = MB(c[(vB() | 0) >> 2] | 0) | 0;w = 71;break;
	            }case 115:
	            {
	              n = c[E >> 2] | 0;n = n | 0 ? n : 5652;w = 71;break;
	            }case 67:
	            {
	              c[F >> 2] = c[E >> 2];c[C >> 2] = 0;c[E >> 2] = F;r = -1;n = F;w = 75;break;
	            }case 83:
	            {
	              e = c[E >> 2] | 0;if (!m) {
	                OB(d, 32, k, 0, u);e = 0;w = 84;
	              } else {
	                r = m;n = e;w = 75;
	              }break;
	            }case 65:case 71:case 70:case 69:case 97:case 103:case 102:case 101:
	            {
	              k = QB(d, +h[E >> 3], k, m, u, n) | 0;e = v;continue a;
	            }default:
	            {
	              o = 0;q = 5642;r = y;n = m;m = u;
	            }} while (0);f: do if ((w | 0) == 61) {
	          u = E;t = c[u >> 2] | 0;u = c[u + 4 >> 2] | 0;r = JB(t, u, y, n & 32) | 0;q = (e & 8 | 0) == 0 | (t | 0) == 0 & (u | 0) == 0;o = q ? 0 : 2;q = q ? 5642 : 5642 + (n >> 4) | 0;s = e;e = t;n = u;w = 67;
	        } else if ((w | 0) == 66) {
	          r = LB(e, n, y) | 0;s = u;w = 67;
	        } else if ((w | 0) == 71) {
	          w = 0;u = NB(n, 0, m) | 0;t = (u | 0) == 0;e = n;o = 0;q = 5642;r = t ? n + m | 0 : u;n = t ? m : u - n | 0;m = s;
	        } else if ((w | 0) == 75) {
	          w = 0;q = n;e = 0;m = 0;while (1) {
	            o = c[q >> 2] | 0;if (!o) break;m = PB(G, o) | 0;if ((m | 0) < 0 | m >>> 0 > (r - e | 0) >>> 0) break;e = m + e | 0;if (r >>> 0 > e >>> 0) q = q + 4 | 0;else break;
	          }if ((m | 0) < 0) {
	            j = -1;break a;
	          }OB(d, 32, k, e, u);if (!e) {
	            e = 0;w = 84;
	          } else {
	            o = 0;while (1) {
	              m = c[n >> 2] | 0;if (!m) {
	                w = 84;break f;
	              }m = PB(G, m) | 0;o = m + o | 0;if ((o | 0) > (e | 0)) {
	                w = 84;break f;
	              }GB(d, G, m);if (o >>> 0 >= e >>> 0) {
	                w = 84;break;
	              } else n = n + 4 | 0;
	            }
	          }
	        } while (0);if ((w | 0) == 67) {
	          w = 0;n = (e | 0) != 0 | (n | 0) != 0;u = (m | 0) != 0 | n;n = ((n ^ 1) & 1) + (z - r) | 0;e = u ? r : y;r = y;n = u ? (m | 0) > (n | 0) ? m : n : m;m = (m | 0) > -1 ? s & -65537 : s;
	        } else if ((w | 0) == 84) {
	          w = 0;OB(d, 32, k, e, u ^ 8192);k = (k | 0) > (e | 0) ? k : e;e = v;continue;
	        }t = r - e | 0;s = (n | 0) < (t | 0) ? t : n;u = s + o | 0;k = (k | 0) < (u | 0) ? u : k;OB(d, 32, k, u, m);GB(d, q, o);OB(d, 48, k, u, m ^ 65536);OB(d, 48, s, t, 0);GB(d, e, t);OB(d, 32, k, u, m ^ 8192);e = v;
	      }g: do if ((w | 0) == 87) if (!d) if (!p) j = 0;else {
	        j = 1;while (1) {
	          e = c[i + (j << 2) >> 2] | 0;if (!e) break;IB(g + (j << 3) | 0, e, f);j = j + 1 | 0;if ((j | 0) >= 10) {
	            j = 1;break g;
	          }
	        }while (1) {
	          if (c[i + (j << 2) >> 2] | 0) {
	            j = -1;break g;
	          }j = j + 1 | 0;if ((j | 0) >= 10) {
	            j = 1;break;
	          }
	        }
	      } while (0);l = H;return j | 0;
	    }function EB(a) {
	      a = a | 0;return 0;
	    }function FB(a) {
	      a = a | 0;return;
	    }function GB(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;if (!(c[a >> 2] & 32)) aC(b, d, a) | 0;return;
	    }function HB(b) {
	      b = b | 0;var d = 0,
	          e = 0,
	          f = 0;e = c[b >> 2] | 0;f = (a[e >> 0] | 0) + -48 | 0;if (f >>> 0 < 10) {
	        d = 0;do {
	          d = f + (d * 10 | 0) | 0;e = e + 1 | 0;c[b >> 2] = e;f = (a[e >> 0] | 0) + -48 | 0;
	        } while (f >>> 0 < 10);
	      } else d = 0;return d | 0;
	    }function IB(a, b, d) {
	      a = a | 0;b = b | 0;d = d | 0;var e = 0,
	          f = 0,
	          g = 0.0;a: do if (b >>> 0 <= 20) do switch (b | 0) {case 9:
	          {
	            e = (c[d >> 2] | 0) + (4 - 1) & ~(4 - 1);b = c[e >> 2] | 0;c[d >> 2] = e + 4;c[a >> 2] = b;break a;
	          }case 10:
	          {
	            e = (c[d >> 2] | 0) + (4 - 1) & ~(4 - 1);b = c[e >> 2] | 0;c[d >> 2] = e + 4;e = a;c[e >> 2] = b;c[e + 4 >> 2] = ((b | 0) < 0) << 31 >> 31;break a;
	          }case 11:
	          {
	            e = (c[d >> 2] | 0) + (4 - 1) & ~(4 - 1);b = c[e >> 2] | 0;c[d >> 2] = e + 4;e = a;c[e >> 2] = b;c[e + 4 >> 2] = 0;break a;
	          }case 12:
	          {
	            e = (c[d >> 2] | 0) + (8 - 1) & ~(8 - 1);b = e;f = c[b >> 2] | 0;b = c[b + 4 >> 2] | 0;c[d >> 2] = e + 8;e = a;c[e >> 2] = f;c[e + 4 >> 2] = b;break a;
	          }case 13:
	          {
	            f = (c[d >> 2] | 0) + (4 - 1) & ~(4 - 1);e = c[f >> 2] | 0;c[d >> 2] = f + 4;e = (e & 65535) << 16 >> 16;f = a;c[f >> 2] = e;c[f + 4 >> 2] = ((e | 0) < 0) << 31 >> 31;break a;
	          }case 14:
	          {
	            f = (c[d >> 2] | 0) + (4 - 1) & ~(4 - 1);e = c[f >> 2] | 0;c[d >> 2] = f + 4;f = a;c[f >> 2] = e & 65535;c[f + 4 >> 2] = 0;break a;
	          }case 15:
	          {
	            f = (c[d >> 2] | 0) + (4 - 1) & ~(4 - 1);e = c[f >> 2] | 0;c[d >> 2] = f + 4;e = (e & 255) << 24 >> 24;f = a;c[f >> 2] = e;c[f + 4 >> 2] = ((e | 0) < 0) << 31 >> 31;break a;
	          }case 16:
	          {
	            f = (c[d >> 2] | 0) + (4 - 1) & ~(4 - 1);e = c[f >> 2] | 0;c[d >> 2] = f + 4;f = a;c[f >> 2] = e & 255;c[f + 4 >> 2] = 0;break a;
	          }case 17:
	          {
	            f = (c[d >> 2] | 0) + (8 - 1) & ~(8 - 1);g = +h[f >> 3];c[d >> 2] = f + 8;h[a >> 3] = g;break a;
	          }case 18:
	          {
	            f = (c[d >> 2] | 0) + (8 - 1) & ~(8 - 1);g = +h[f >> 3];c[d >> 2] = f + 8;h[a >> 3] = g;break a;
	          }default:
	          break a;} while (0); while (0);return;
	    }function JB(b, c, e, f) {
	      b = b | 0;c = c | 0;e = e | 0;f = f | 0;if (!((b | 0) == 0 & (c | 0) == 0)) do {
	        e = e + -1 | 0;a[e >> 0] = d[5694 + (b & 15) >> 0] | 0 | f;b = AC(b | 0, c | 0, 4) | 0;c = A;
	      } while (!((b | 0) == 0 & (c | 0) == 0));return e | 0;
	    }function KB(b, c, d) {
	      b = b | 0;c = c | 0;d = d | 0;if (!((b | 0) == 0 & (c | 0) == 0)) do {
	        d = d + -1 | 0;a[d >> 0] = b & 7 | 48;b = AC(b | 0, c | 0, 3) | 0;c = A;
	      } while (!((b | 0) == 0 & (c | 0) == 0));return d | 0;
	    }function LB(b, c, d) {
	      b = b | 0;c = c | 0;d = d | 0;var e = 0;if (c >>> 0 > 0 | (c | 0) == 0 & b >>> 0 > 4294967295) {
	        while (1) {
	          e = HC(b | 0, c | 0, 10, 0) | 0;d = d + -1 | 0;a[d >> 0] = e & 255 | 48;e = b;b = EC(b | 0, c | 0, 10, 0) | 0;if (!(c >>> 0 > 9 | (c | 0) == 9 & e >>> 0 > 4294967295)) break;else c = A;
	        }c = b;
	      } else c = b;if (c) while (1) {
	        d = d + -1 | 0;a[d >> 0] = (c >>> 0) % 10 | 0 | 48;if (c >>> 0 < 10) break;else c = (c >>> 0) / 10 | 0;
	      }return d | 0;
	    }function MB(a) {
	      a = a | 0;return XB(a, c[(WB() | 0) + 188 >> 2] | 0) | 0;
	    }function NB(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;h = d & 255;f = (e | 0) != 0;a: do if (f & (b & 3 | 0) != 0) {
	        g = d & 255;while (1) {
	          if ((a[b >> 0] | 0) == g << 24 >> 24) {
	            i = 6;break a;
	          }b = b + 1 | 0;e = e + -1 | 0;f = (e | 0) != 0;if (!(f & (b & 3 | 0) != 0)) {
	            i = 5;break;
	          }
	        }
	      } else i = 5; while (0);if ((i | 0) == 5) if (f) i = 6;else e = 0;b: do if ((i | 0) == 6) {
	        g = d & 255;if ((a[b >> 0] | 0) != g << 24 >> 24) {
	          f = P(h, 16843009) | 0;c: do if (e >>> 0 > 3) while (1) {
	            h = c[b >> 2] ^ f;if ((h & -2139062144 ^ -2139062144) & h + -16843009 | 0) break;b = b + 4 | 0;e = e + -4 | 0;if (e >>> 0 <= 3) {
	              i = 11;break c;
	            }
	          } else i = 11; while (0);if ((i | 0) == 11) if (!e) {
	            e = 0;break;
	          }while (1) {
	            if ((a[b >> 0] | 0) == g << 24 >> 24) break b;b = b + 1 | 0;e = e + -1 | 0;if (!e) {
	              e = 0;break;
	            }
	          }
	        }
	      } while (0);return (e | 0 ? b : 0) | 0;
	    }function OB(a, b, c, d, e) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = l;l = l + 256 | 0;f = g;if ((c | 0) > (d | 0) & (e & 73728 | 0) == 0) {
	        e = c - d | 0;yC(f | 0, b | 0, (e >>> 0 < 256 ? e : 256) | 0) | 0;if (e >>> 0 > 255) {
	          b = c - d | 0;do {
	            GB(a, f, 256);e = e + -256 | 0;
	          } while (e >>> 0 > 255);e = b & 255;
	        }GB(a, f, e);
	      }l = g;return;
	    }function PB(a, b) {
	      a = a | 0;b = b | 0;if (!a) a = 0;else a = UB(a, b, 0) | 0;return a | 0;
	    }function QB(b, e, f, g, h, i) {
	      b = b | 0;e = +e;f = f | 0;g = g | 0;h = h | 0;i = i | 0;var j = 0,
	          k = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0,
	          q = 0,
	          r = 0.0,
	          s = 0,
	          t = 0,
	          u = 0,
	          v = 0,
	          w = 0,
	          x = 0,
	          y = 0,
	          z = 0,
	          B = 0,
	          C = 0,
	          D = 0,
	          E = 0,
	          F = 0,
	          G = 0,
	          H = 0;H = l;l = l + 560 | 0;m = H + 8 | 0;u = H;G = H + 524 | 0;F = G;n = H + 512 | 0;c[u >> 2] = 0;E = n + 12 | 0;RB(e) | 0;if ((A | 0) < 0) {
	        e = -e;C = 1;B = 5659;
	      } else {
	        C = (h & 2049 | 0) != 0 & 1;B = (h & 2048 | 0) == 0 ? (h & 1 | 0) == 0 ? 5660 : 5665 : 5662;
	      }RB(e) | 0;D = A & 2146435072;do if (D >>> 0 < 2146435072 | (D | 0) == 2146435072 & 0 < 0) {
	        r = +SB(e, u) * 2.0;j = r != 0.0;if (j) c[u >> 2] = (c[u >> 2] | 0) + -1;w = i | 32;if ((w | 0) == 97) {
	          s = i & 32;q = (s | 0) == 0 ? B : B + 9 | 0;p = C | 2;j = 12 - g | 0;do if (!(g >>> 0 > 11 | (j | 0) == 0)) {
	            e = 8.0;do {
	              j = j + -1 | 0;e = e * 16.0;
	            } while ((j | 0) != 0);if ((a[q >> 0] | 0) == 45) {
	              e = -(e + (-r - e));break;
	            } else {
	              e = r + e - e;break;
	            }
	          } else e = r; while (0);k = c[u >> 2] | 0;j = (k | 0) < 0 ? 0 - k | 0 : k;j = LB(j, ((j | 0) < 0) << 31 >> 31, E) | 0;if ((j | 0) == (E | 0)) {
	            j = n + 11 | 0;a[j >> 0] = 48;
	          }a[j + -1 >> 0] = (k >> 31 & 2) + 43;o = j + -2 | 0;a[o >> 0] = i + 15;n = (g | 0) < 1;m = (h & 8 | 0) == 0;j = G;do {
	            D = ~~e;k = j + 1 | 0;a[j >> 0] = d[5694 + D >> 0] | s;e = (e - +(D | 0)) * 16.0;if ((k - F | 0) == 1 ? !(m & (n & e == 0.0)) : 0) {
	              a[k >> 0] = 46;j = j + 2 | 0;
	            } else j = k;
	          } while (e != 0.0);D = j - F | 0;F = E - o | 0;E = (g | 0) != 0 & (D + -2 | 0) < (g | 0) ? g + 2 | 0 : D;j = F + p + E | 0;OB(b, 32, f, j, h);GB(b, q, p);OB(b, 48, f, j, h ^ 65536);GB(b, G, D);OB(b, 48, E - D | 0, 0, 0);GB(b, o, F);OB(b, 32, f, j, h ^ 8192);break;
	        }k = (g | 0) < 0 ? 6 : g;if (j) {
	          j = (c[u >> 2] | 0) + -28 | 0;c[u >> 2] = j;e = r * 268435456.0;
	        } else {
	          e = r;j = c[u >> 2] | 0;
	        }D = (j | 0) < 0 ? m : m + 288 | 0;m = D;do {
	          y = ~~e >>> 0;c[m >> 2] = y;m = m + 4 | 0;e = (e - +(y >>> 0)) * 1.0e9;
	        } while (e != 0.0);if ((j | 0) > 0) {
	          n = D;p = m;while (1) {
	            o = (j | 0) < 29 ? j : 29;j = p + -4 | 0;if (j >>> 0 >= n >>> 0) {
	              m = 0;do {
	                x = zC(c[j >> 2] | 0, 0, o | 0) | 0;x = xC(x | 0, A | 0, m | 0, 0) | 0;y = A;v = HC(x | 0, y | 0, 1e9, 0) | 0;c[j >> 2] = v;m = EC(x | 0, y | 0, 1e9, 0) | 0;j = j + -4 | 0;
	              } while (j >>> 0 >= n >>> 0);if (m) {
	                n = n + -4 | 0;c[n >> 2] = m;
	              }
	            }m = p;while (1) {
	              if (m >>> 0 <= n >>> 0) break;j = m + -4 | 0;if (!(c[j >> 2] | 0)) m = j;else break;
	            }j = (c[u >> 2] | 0) - o | 0;c[u >> 2] = j;if ((j | 0) > 0) p = m;else break;
	          }
	        } else n = D;if ((j | 0) < 0) {
	          g = ((k + 25 | 0) / 9 | 0) + 1 | 0;t = (w | 0) == 102;do {
	            s = 0 - j | 0;s = (s | 0) < 9 ? s : 9;if (n >>> 0 < m >>> 0) {
	              o = (1 << s) + -1 | 0;p = 1e9 >>> s;q = 0;j = n;do {
	                y = c[j >> 2] | 0;c[j >> 2] = (y >>> s) + q;q = P(y & o, p) | 0;j = j + 4 | 0;
	              } while (j >>> 0 < m >>> 0);j = (c[n >> 2] | 0) == 0 ? n + 4 | 0 : n;if (!q) {
	                n = j;j = m;
	              } else {
	                c[m >> 2] = q;n = j;j = m + 4 | 0;
	              }
	            } else {
	              n = (c[n >> 2] | 0) == 0 ? n + 4 | 0 : n;j = m;
	            }m = t ? D : n;m = (j - m >> 2 | 0) > (g | 0) ? m + (g << 2) | 0 : j;j = (c[u >> 2] | 0) + s | 0;c[u >> 2] = j;
	          } while ((j | 0) < 0);j = n;g = m;
	        } else {
	          j = n;g = m;
	        }y = D;if (j >>> 0 < g >>> 0) {
	          m = (y - j >> 2) * 9 | 0;o = c[j >> 2] | 0;if (o >>> 0 >= 10) {
	            n = 10;do {
	              n = n * 10 | 0;m = m + 1 | 0;
	            } while (o >>> 0 >= n >>> 0);
	          }
	        } else m = 0;t = (w | 0) == 103;v = (k | 0) != 0;n = k - ((w | 0) != 102 ? m : 0) + ((v & t) << 31 >> 31) | 0;if ((n | 0) < (((g - y >> 2) * 9 | 0) + -9 | 0)) {
	          n = n + 9216 | 0;s = D + 4 + (((n | 0) / 9 | 0) + -1024 << 2) | 0;n = ((n | 0) % 9 | 0) + 1 | 0;if ((n | 0) < 9) {
	            o = 10;do {
	              o = o * 10 | 0;n = n + 1 | 0;
	            } while ((n | 0) != 9);
	          } else o = 10;p = c[s >> 2] | 0;q = (p >>> 0) % (o >>> 0) | 0;n = (s + 4 | 0) == (g | 0);if (!(n & (q | 0) == 0)) {
	            r = (((p >>> 0) / (o >>> 0) | 0) & 1 | 0) == 0 ? 9007199254740992.0 : 9007199254740994.0;x = (o | 0) / 2 | 0;e = q >>> 0 < x >>> 0 ? .5 : n & (q | 0) == (x | 0) ? 1.0 : 1.5;if (C) {
	              x = (a[B >> 0] | 0) == 45;e = x ? -e : e;r = x ? -r : r;
	            }n = p - q | 0;c[s >> 2] = n;if (r + e != r) {
	              x = n + o | 0;c[s >> 2] = x;if (x >>> 0 > 999999999) {
	                m = s;while (1) {
	                  n = m + -4 | 0;c[m >> 2] = 0;if (n >>> 0 < j >>> 0) {
	                    j = j + -4 | 0;c[j >> 2] = 0;
	                  }x = (c[n >> 2] | 0) + 1 | 0;c[n >> 2] = x;if (x >>> 0 > 999999999) m = n;else break;
	                }
	              } else n = s;m = (y - j >> 2) * 9 | 0;p = c[j >> 2] | 0;if (p >>> 0 >= 10) {
	                o = 10;do {
	                  o = o * 10 | 0;m = m + 1 | 0;
	                } while (p >>> 0 >= o >>> 0);
	              }
	            } else n = s;
	          } else n = s;n = n + 4 | 0;n = g >>> 0 > n >>> 0 ? n : g;x = j;
	        } else {
	          n = g;x = j;
	        }w = n;while (1) {
	          if (w >>> 0 <= x >>> 0) {
	            u = 0;break;
	          }j = w + -4 | 0;if (!(c[j >> 2] | 0)) w = j;else {
	            u = 1;break;
	          }
	        }g = 0 - m | 0;do if (t) {
	          j = ((v ^ 1) & 1) + k | 0;if ((j | 0) > (m | 0) & (m | 0) > -5) {
	            o = i + -1 | 0;k = j + -1 - m | 0;
	          } else {
	            o = i + -2 | 0;k = j + -1 | 0;
	          }j = h & 8;if (!j) {
	            if (u ? (z = c[w + -4 >> 2] | 0, (z | 0) != 0) : 0) {
	              if (!((z >>> 0) % 10 | 0)) {
	                n = 0;j = 10;do {
	                  j = j * 10 | 0;n = n + 1 | 0;
	                } while (!((z >>> 0) % (j >>> 0) | 0 | 0));
	              } else n = 0;
	            } else n = 9;j = ((w - y >> 2) * 9 | 0) + -9 | 0;if ((o | 32 | 0) == 102) {
	              s = j - n | 0;s = (s | 0) > 0 ? s : 0;k = (k | 0) < (s | 0) ? k : s;s = 0;break;
	            } else {
	              s = j + m - n | 0;s = (s | 0) > 0 ? s : 0;k = (k | 0) < (s | 0) ? k : s;s = 0;break;
	            }
	          } else s = j;
	        } else {
	          o = i;s = h & 8;
	        } while (0);t = k | s;p = (t | 0) != 0 & 1;q = (o | 32 | 0) == 102;if (q) {
	          v = 0;j = (m | 0) > 0 ? m : 0;
	        } else {
	          j = (m | 0) < 0 ? g : m;j = LB(j, ((j | 0) < 0) << 31 >> 31, E) | 0;n = E;if ((n - j | 0) < 2) do {
	            j = j + -1 | 0;a[j >> 0] = 48;
	          } while ((n - j | 0) < 2);a[j + -1 >> 0] = (m >> 31 & 2) + 43;j = j + -2 | 0;a[j >> 0] = o;v = j;j = n - j | 0;
	        }j = C + 1 + k + p + j | 0;OB(b, 32, f, j, h);GB(b, B, C);OB(b, 48, f, j, h ^ 65536);if (q) {
	          o = x >>> 0 > D >>> 0 ? D : x;s = G + 9 | 0;p = s;q = G + 8 | 0;n = o;do {
	            m = LB(c[n >> 2] | 0, 0, s) | 0;if ((n | 0) == (o | 0)) {
	              if ((m | 0) == (s | 0)) {
	                a[q >> 0] = 48;m = q;
	              }
	            } else if (m >>> 0 > G >>> 0) {
	              yC(G | 0, 48, m - F | 0) | 0;do m = m + -1 | 0; while (m >>> 0 > G >>> 0);
	            }GB(b, m, p - m | 0);n = n + 4 | 0;
	          } while (n >>> 0 <= D >>> 0);if (t | 0) GB(b, 5710, 1);if (n >>> 0 < w >>> 0 & (k | 0) > 0) while (1) {
	            m = LB(c[n >> 2] | 0, 0, s) | 0;if (m >>> 0 > G >>> 0) {
	              yC(G | 0, 48, m - F | 0) | 0;do m = m + -1 | 0; while (m >>> 0 > G >>> 0);
	            }GB(b, m, (k | 0) < 9 ? k : 9);n = n + 4 | 0;m = k + -9 | 0;if (!(n >>> 0 < w >>> 0 & (k | 0) > 9)) {
	              k = m;break;
	            } else k = m;
	          }OB(b, 48, k + 9 | 0, 9, 0);
	        } else {
	          t = u ? w : x + 4 | 0;if ((k | 0) > -1) {
	            u = G + 9 | 0;s = (s | 0) == 0;g = u;p = 0 - F | 0;q = G + 8 | 0;o = x;do {
	              m = LB(c[o >> 2] | 0, 0, u) | 0;if ((m | 0) == (u | 0)) {
	                a[q >> 0] = 48;m = q;
	              }do if ((o | 0) == (x | 0)) {
	                n = m + 1 | 0;GB(b, m, 1);if (s & (k | 0) < 1) {
	                  m = n;break;
	                }GB(b, 5710, 1);m = n;
	              } else {
	                if (m >>> 0 <= G >>> 0) break;yC(G | 0, 48, m + p | 0) | 0;do m = m + -1 | 0; while (m >>> 0 > G >>> 0);
	              } while (0);F = g - m | 0;GB(b, m, (k | 0) > (F | 0) ? F : k);k = k - F | 0;o = o + 4 | 0;
	            } while (o >>> 0 < t >>> 0 & (k | 0) > -1);
	          }OB(b, 48, k + 18 | 0, 18, 0);GB(b, v, E - v | 0);
	        }OB(b, 32, f, j, h ^ 8192);
	      } else {
	        G = (i & 32 | 0) != 0;j = C + 3 | 0;OB(b, 32, f, j, h & -65537);GB(b, B, C);GB(b, e != e | 0.0 != 0.0 ? G ? 5686 : 5690 : G ? 5678 : 5682, 3);OB(b, 32, f, j, h ^ 8192);
	      } while (0);l = H;return ((j | 0) < (f | 0) ? f : j) | 0;
	    }function RB(a) {
	      a = +a;var b = 0;h[j >> 3] = a;b = c[j >> 2] | 0;A = c[j + 4 >> 2] | 0;return b | 0;
	    }function SB(a, b) {
	      a = +a;b = b | 0;return + +TB(a, b);
	    }function TB(a, b) {
	      a = +a;b = b | 0;var d = 0,
	          e = 0,
	          f = 0;h[j >> 3] = a;d = c[j >> 2] | 0;e = c[j + 4 >> 2] | 0;f = AC(d | 0, e | 0, 52) | 0;switch (f & 2047) {case 0:
	          {
	            if (a != 0.0) {
	              a = +TB(a * 18446744073709551616.0, b);d = (c[b >> 2] | 0) + -64 | 0;
	            } else d = 0;c[b >> 2] = d;break;
	          }case 2047:
	          break;default:
	          {
	            c[b >> 2] = (f & 2047) + -1022;c[j >> 2] = d;c[j + 4 >> 2] = e & -2146435073 | 1071644672;a = +h[j >> 3];
	          }}return +a;
	    }function UB(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;do if (b) {
	        if (d >>> 0 < 128) {
	          a[b >> 0] = d;b = 1;break;
	        }if (!(c[c[(VB() | 0) + 188 >> 2] >> 2] | 0)) if ((d & -128 | 0) == 57216) {
	          a[b >> 0] = d;b = 1;break;
	        } else {
	          c[(vB() | 0) >> 2] = 84;b = -1;break;
	        }if (d >>> 0 < 2048) {
	          a[b >> 0] = d >>> 6 | 192;a[b + 1 >> 0] = d & 63 | 128;b = 2;break;
	        }if (d >>> 0 < 55296 | (d & -8192 | 0) == 57344) {
	          a[b >> 0] = d >>> 12 | 224;a[b + 1 >> 0] = d >>> 6 & 63 | 128;a[b + 2 >> 0] = d & 63 | 128;b = 3;break;
	        }if ((d + -65536 | 0) >>> 0 < 1048576) {
	          a[b >> 0] = d >>> 18 | 240;a[b + 1 >> 0] = d >>> 12 & 63 | 128;a[b + 2 >> 0] = d >>> 6 & 63 | 128;a[b + 3 >> 0] = d & 63 | 128;b = 4;break;
	        } else {
	          c[(vB() | 0) >> 2] = 84;b = -1;break;
	        }
	      } else b = 1; while (0);return b | 0;
	    }function VB() {
	      return xB() | 0;
	    }function WB() {
	      return xB() | 0;
	    }function XB(b, e) {
	      b = b | 0;e = e | 0;var f = 0,
	          g = 0;g = 0;while (1) {
	        if ((d[5712 + g >> 0] | 0) == (b | 0)) {
	          b = 2;break;
	        }f = g + 1 | 0;if ((f | 0) == 87) {
	          f = 5800;g = 87;b = 5;break;
	        } else g = f;
	      }if ((b | 0) == 2) if (!g) f = 5800;else {
	        f = 5800;b = 5;
	      }if ((b | 0) == 5) while (1) {
	        do {
	          b = f;f = f + 1 | 0;
	        } while ((a[b >> 0] | 0) != 0);g = g + -1 | 0;if (!g) break;else b = 5;
	      }return YB(f, c[e + 20 >> 2] | 0) | 0;
	    }function YB(a, b) {
	      a = a | 0;b = b | 0;return ZB(a, b) | 0;
	    }function ZB(a, b) {
	      a = a | 0;b = b | 0;if (!b) b = 0;else b = _B(c[b >> 2] | 0, c[b + 4 >> 2] | 0, a) | 0;return (b | 0 ? b : a) | 0;
	    }function _B(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          l = 0,
	          m = 0,
	          n = 0,
	          o = 0;o = (c[b >> 2] | 0) + 1794895138 | 0;h = $B(c[b + 8 >> 2] | 0, o) | 0;f = $B(c[b + 12 >> 2] | 0, o) | 0;g = $B(c[b + 16 >> 2] | 0, o) | 0;a: do if ((h >>> 0 < d >>> 2 >>> 0 ? (n = d - (h << 2) | 0, f >>> 0 < n >>> 0 & g >>> 0 < n >>> 0) : 0) ? ((g | f) & 3 | 0) == 0 : 0) {
	        n = f >>> 2;m = g >>> 2;l = 0;while (1) {
	          j = h >>> 1;k = l + j | 0;i = k << 1;g = i + n | 0;f = $B(c[b + (g << 2) >> 2] | 0, o) | 0;g = $B(c[b + (g + 1 << 2) >> 2] | 0, o) | 0;if (!(g >>> 0 < d >>> 0 & f >>> 0 < (d - g | 0) >>> 0)) {
	            f = 0;break a;
	          }if (a[b + (g + f) >> 0] | 0) {
	            f = 0;break a;
	          }f = AB(e, b + g | 0) | 0;if (!f) break;f = (f | 0) < 0;if ((h | 0) == 1) {
	            f = 0;break a;
	          } else {
	            l = f ? l : k;h = f ? j : h - j | 0;
	          }
	        }f = i + m | 0;g = $B(c[b + (f << 2) >> 2] | 0, o) | 0;f = $B(c[b + (f + 1 << 2) >> 2] | 0, o) | 0;if (f >>> 0 < d >>> 0 & g >>> 0 < (d - f | 0) >>> 0) f = (a[b + (f + g) >> 0] | 0) == 0 ? b + f | 0 : 0;else f = 0;
	      } else f = 0; while (0);return f | 0;
	    }function $B(a, b) {
	      a = a | 0;b = b | 0;var c = 0;c = IC(a | 0) | 0;return ((b | 0) == 0 ? a : c) | 0;
	    }function aC(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0,
	          j = 0;f = e + 16 | 0;g = c[f >> 2] | 0;if (!g) {
	        if (!(bC(e) | 0)) {
	          g = c[f >> 2] | 0;h = 5;
	        } else f = 0;
	      } else h = 5;a: do if ((h | 0) == 5) {
	        j = e + 20 | 0;i = c[j >> 2] | 0;f = i;if ((g - i | 0) >>> 0 < d >>> 0) {
	          f = sb[c[e + 36 >> 2] & 7](e, b, d) | 0;break;
	        }b: do if ((a[e + 75 >> 0] | 0) > -1) {
	          i = d;while (1) {
	            if (!i) {
	              h = 0;g = b;break b;
	            }g = i + -1 | 0;if ((a[b + g >> 0] | 0) == 10) break;else i = g;
	          }f = sb[c[e + 36 >> 2] & 7](e, b, i) | 0;if (f >>> 0 < i >>> 0) break a;h = i;g = b + i | 0;d = d - i | 0;f = c[j >> 2] | 0;
	        } else {
	          h = 0;g = b;
	        } while (0);BC(f | 0, g | 0, d | 0) | 0;c[j >> 2] = (c[j >> 2] | 0) + d;f = h + d | 0;
	      } while (0);return f | 0;
	    }function bC(b) {
	      b = b | 0;var d = 0,
	          e = 0;d = b + 74 | 0;e = a[d >> 0] | 0;a[d >> 0] = e + 255 | e;d = c[b >> 2] | 0;if (!(d & 8)) {
	        c[b + 8 >> 2] = 0;c[b + 4 >> 2] = 0;e = c[b + 44 >> 2] | 0;c[b + 28 >> 2] = e;c[b + 20 >> 2] = e;c[b + 16 >> 2] = e + (c[b + 48 >> 2] | 0);b = 0;
	      } else {
	        c[b >> 2] = d | 32;b = -1;
	      }return b | 0;
	    }function cC(a, b) {
	      a = T(a);b = T(b);var c = 0,
	          d = 0;c = dC(a) | 0;do if ((c & 2147483647) >>> 0 <= 2139095040) {
	        d = dC(b) | 0;if ((d & 2147483647) >>> 0 <= 2139095040) if ((d ^ c | 0) < 0) {
	          a = (c | 0) < 0 ? b : a;break;
	        } else {
	          a = a < b ? b : a;break;
	        }
	      } else a = b; while (0);return T(a);
	    }function dC(a) {
	      a = T(a);return (g[j >> 2] = a, c[j >> 2] | 0) | 0;
	    }function eC(a, b) {
	      a = T(a);b = T(b);var c = 0,
	          d = 0;c = fC(a) | 0;do if ((c & 2147483647) >>> 0 <= 2139095040) {
	        d = fC(b) | 0;if ((d & 2147483647) >>> 0 <= 2139095040) if ((d ^ c | 0) < 0) {
	          a = (c | 0) < 0 ? a : b;break;
	        } else {
	          a = a < b ? a : b;break;
	        }
	      } else a = b; while (0);return T(a);
	    }function fC(a) {
	      a = T(a);return (g[j >> 2] = a, c[j >> 2] | 0) | 0;
	    }function gC(a, b) {
	      a = T(a);b = T(b);var d = 0,
	          e = 0,
	          f = 0,
	          h = 0,
	          i = 0,
	          k = 0,
	          l = 0,
	          m = 0;h = (g[j >> 2] = a, c[j >> 2] | 0);k = (g[j >> 2] = b, c[j >> 2] | 0);d = h >>> 23 & 255;i = k >>> 23 & 255;l = h & -2147483648;f = k << 1;a: do if ((f | 0) != 0 ? !((d | 0) == 255 | ((hC(b) | 0) & 2147483647) >>> 0 > 2139095040) : 0) {
	        e = h << 1;if (e >>> 0 <= f >>> 0) {
	          b = T(a * T(0.0));return T((e | 0) == (f | 0) ? b : a);
	        }if (!d) {
	          d = h << 9;if ((d | 0) > -1) {
	            e = d;d = 0;do {
	              d = d + -1 | 0;e = e << 1;
	            } while ((e | 0) > -1);
	          } else d = 0;e = h << 1 - d;
	        } else e = h & 8388607 | 8388608;if (!i) {
	          h = k << 9;if ((h | 0) > -1) {
	            f = 0;do {
	              f = f + -1 | 0;h = h << 1;
	            } while ((h | 0) > -1);
	          } else f = 0;i = f;k = k << 1 - f;
	        } else k = k & 8388607 | 8388608;f = e - k | 0;h = (f | 0) > -1;b: do if ((d | 0) > (i | 0)) {
	          while (1) {
	            if (h) if (!f) break;else e = f;e = e << 1;d = d + -1 | 0;f = e - k | 0;h = (f | 0) > -1;if ((d | 0) <= (i | 0)) break b;
	          }b = T(a * T(0.0));break a;
	        } while (0);if (h) if (!f) {
	          b = T(a * T(0.0));break;
	        } else e = f;if (e >>> 0 < 8388608) do {
	          e = e << 1;d = d + -1 | 0;
	        } while (e >>> 0 < 8388608);if ((d | 0) > 0) d = e + -8388608 | d << 23;else d = e >>> (1 - d | 0);b = (c[j >> 2] = d | l, T(g[j >> 2]));
	      } else m = 3; while (0);if ((m | 0) == 3) {
	        b = T(a * b);b = T(b / b);
	      }return T(b);
	    }function hC(a) {
	      a = T(a);return (g[j >> 2] = a, c[j >> 2] | 0) | 0;
	    }function iC(a, b) {
	      a = a | 0;b = b | 0;return CB(c[582] | 0, a, b) | 0;
	    }function jC(a) {
	      a = a | 0;Ta();
	    }function kC(a) {
	      a = a | 0;return;
	    }function lC(a, b) {
	      a = a | 0;b = b | 0;return 0;
	    }function mC(a) {
	      a = a | 0;if ((nC(a + 4 | 0) | 0) == -1) {
	        nb[c[(c[a >> 2] | 0) + 8 >> 2] & 127](a);a = 1;
	      } else a = 0;return a | 0;
	    }function nC(a) {
	      a = a | 0;var b = 0;b = c[a >> 2] | 0;c[a >> 2] = b + -1;return b + -1 | 0;
	    }function oC(a) {
	      a = a | 0;if (mC(a) | 0) pC(a);return;
	    }function pC(a) {
	      a = a | 0;var b = 0;b = a + 8 | 0;if (!((c[b >> 2] | 0) != 0 ? (nC(b) | 0) != -1 : 0)) nb[c[(c[a >> 2] | 0) + 16 >> 2] & 127](a);return;
	    }function qC(a) {
	      a = a | 0;var b = 0;b = (a | 0) == 0 ? 1 : a;while (1) {
	        a = oB(b) | 0;if (a | 0) break;a = uC() | 0;if (!a) {
	          a = 0;break;
	        }Fb[a & 0]();
	      }return a | 0;
	    }function rC(a) {
	      a = a | 0;return qC(a) | 0;
	    }function sC(a) {
	      a = a | 0;pB(a);return;
	    }function tC(b) {
	      b = b | 0;if ((a[b + 11 >> 0] | 0) < 0) sC(c[b >> 2] | 0);return;
	    }function uC() {
	      var a = 0;a = c[2923] | 0;c[2923] = a + 0;return a | 0;
	    }function vC() {}function wC(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;d = b - d - (c >>> 0 > a >>> 0 | 0) >>> 0;return (A = d, a - c >>> 0 | 0) | 0;
	    }function xC(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;c = a + c >>> 0;return (A = b + d + (c >>> 0 < a >>> 0 | 0) >>> 0, c | 0) | 0;
	    }function yC(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0,
	          i = 0;h = b + e | 0;d = d & 255;if ((e | 0) >= 67) {
	        while (b & 3) {
	          a[b >> 0] = d;b = b + 1 | 0;
	        }f = h & -4 | 0;g = f - 64 | 0;i = d | d << 8 | d << 16 | d << 24;while ((b | 0) <= (g | 0)) {
	          c[b >> 2] = i;c[b + 4 >> 2] = i;c[b + 8 >> 2] = i;c[b + 12 >> 2] = i;c[b + 16 >> 2] = i;c[b + 20 >> 2] = i;c[b + 24 >> 2] = i;c[b + 28 >> 2] = i;c[b + 32 >> 2] = i;c[b + 36 >> 2] = i;c[b + 40 >> 2] = i;c[b + 44 >> 2] = i;c[b + 48 >> 2] = i;c[b + 52 >> 2] = i;c[b + 56 >> 2] = i;c[b + 60 >> 2] = i;b = b + 64 | 0;
	        }while ((b | 0) < (f | 0)) {
	          c[b >> 2] = i;b = b + 4 | 0;
	        }
	      }while ((b | 0) < (h | 0)) {
	        a[b >> 0] = d;b = b + 1 | 0;
	      }return h - e | 0;
	    }function zC(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;if ((c | 0) < 32) {
	        A = b << c | (a & (1 << c) - 1 << 32 - c) >>> 32 - c;return a << c;
	      }A = a << c - 32;return 0;
	    }function AC(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;if ((c | 0) < 32) {
	        A = b >>> c;return a >>> c | (b & (1 << c) - 1) << 32 - c;
	      }A = 0;return b >>> c - 32 | 0;
	    }function BC(b, d, e) {
	      b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0,
	          h = 0;if ((e | 0) >= 8192) return Oa(b | 0, d | 0, e | 0) | 0;h = b | 0;g = b + e | 0;if ((b & 3) == (d & 3)) {
	        while (b & 3) {
	          if (!e) return h | 0;a[b >> 0] = a[d >> 0] | 0;b = b + 1 | 0;d = d + 1 | 0;e = e - 1 | 0;
	        }e = g & -4 | 0;f = e - 64 | 0;while ((b | 0) <= (f | 0)) {
	          c[b >> 2] = c[d >> 2];c[b + 4 >> 2] = c[d + 4 >> 2];c[b + 8 >> 2] = c[d + 8 >> 2];c[b + 12 >> 2] = c[d + 12 >> 2];c[b + 16 >> 2] = c[d + 16 >> 2];c[b + 20 >> 2] = c[d + 20 >> 2];c[b + 24 >> 2] = c[d + 24 >> 2];c[b + 28 >> 2] = c[d + 28 >> 2];c[b + 32 >> 2] = c[d + 32 >> 2];c[b + 36 >> 2] = c[d + 36 >> 2];c[b + 40 >> 2] = c[d + 40 >> 2];c[b + 44 >> 2] = c[d + 44 >> 2];c[b + 48 >> 2] = c[d + 48 >> 2];c[b + 52 >> 2] = c[d + 52 >> 2];c[b + 56 >> 2] = c[d + 56 >> 2];c[b + 60 >> 2] = c[d + 60 >> 2];b = b + 64 | 0;d = d + 64 | 0;
	        }while ((b | 0) < (e | 0)) {
	          c[b >> 2] = c[d >> 2];b = b + 4 | 0;d = d + 4 | 0;
	        }
	      } else {
	        e = g - 4 | 0;while ((b | 0) < (e | 0)) {
	          a[b >> 0] = a[d >> 0] | 0;a[b + 1 >> 0] = a[d + 1 >> 0] | 0;a[b + 2 >> 0] = a[d + 2 >> 0] | 0;a[b + 3 >> 0] = a[d + 3 >> 0] | 0;b = b + 4 | 0;d = d + 4 | 0;
	        }
	      }while ((b | 0) < (g | 0)) {
	        a[b >> 0] = a[d >> 0] | 0;b = b + 1 | 0;d = d + 1 | 0;
	      }return h | 0;
	    }function CC(b) {
	      b = b | 0;var c = 0;c = a[n + (b & 255) >> 0] | 0;if ((c | 0) < 8) return c | 0;c = a[n + (b >> 8 & 255) >> 0] | 0;if ((c | 0) < 8) return c + 8 | 0;c = a[n + (b >> 16 & 255) >> 0] | 0;if ((c | 0) < 8) return c + 16 | 0;return (a[n + (b >>> 24) >> 0] | 0) + 24 | 0;
	    }function DC(a, b, d, e, f) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;f = f | 0;var g = 0,
	          h = 0,
	          i = 0,
	          j = 0,
	          k = 0,
	          l = 0,
	          m = 0,
	          n = 0,
	          o = 0,
	          p = 0;l = a;j = b;k = j;h = d;n = e;i = n;if (!k) {
	        g = (f | 0) != 0;if (!i) {
	          if (g) {
	            c[f >> 2] = (l >>> 0) % (h >>> 0);c[f + 4 >> 2] = 0;
	          }n = 0;f = (l >>> 0) / (h >>> 0) >>> 0;return (A = n, f) | 0;
	        } else {
	          if (!g) {
	            n = 0;f = 0;return (A = n, f) | 0;
	          }c[f >> 2] = a | 0;c[f + 4 >> 2] = b & 0;n = 0;f = 0;return (A = n, f) | 0;
	        }
	      }g = (i | 0) == 0;do if (h) {
	        if (!g) {
	          g = (S(i | 0) | 0) - (S(k | 0) | 0) | 0;if (g >>> 0 <= 31) {
	            m = g + 1 | 0;i = 31 - g | 0;b = g - 31 >> 31;h = m;a = l >>> (m >>> 0) & b | k << i;b = k >>> (m >>> 0) & b;g = 0;i = l << i;break;
	          }if (!f) {
	            n = 0;f = 0;return (A = n, f) | 0;
	          }c[f >> 2] = a | 0;c[f + 4 >> 2] = j | b & 0;n = 0;f = 0;return (A = n, f) | 0;
	        }g = h - 1 | 0;if (g & h | 0) {
	          i = (S(h | 0) | 0) + 33 - (S(k | 0) | 0) | 0;p = 64 - i | 0;m = 32 - i | 0;j = m >> 31;o = i - 32 | 0;b = o >> 31;h = i;a = m - 1 >> 31 & k >>> (o >>> 0) | (k << m | l >>> (i >>> 0)) & b;b = b & k >>> (i >>> 0);g = l << p & j;i = (k << p | l >>> (o >>> 0)) & j | l << m & i - 33 >> 31;break;
	        }if (f | 0) {
	          c[f >> 2] = g & l;c[f + 4 >> 2] = 0;
	        }if ((h | 0) == 1) {
	          o = j | b & 0;p = a | 0 | 0;return (A = o, p) | 0;
	        } else {
	          p = CC(h | 0) | 0;o = k >>> (p >>> 0) | 0;p = k << 32 - p | l >>> (p >>> 0) | 0;return (A = o, p) | 0;
	        }
	      } else {
	        if (g) {
	          if (f | 0) {
	            c[f >> 2] = (k >>> 0) % (h >>> 0);c[f + 4 >> 2] = 0;
	          }o = 0;p = (k >>> 0) / (h >>> 0) >>> 0;return (A = o, p) | 0;
	        }if (!l) {
	          if (f | 0) {
	            c[f >> 2] = 0;c[f + 4 >> 2] = (k >>> 0) % (i >>> 0);
	          }o = 0;p = (k >>> 0) / (i >>> 0) >>> 0;return (A = o, p) | 0;
	        }g = i - 1 | 0;if (!(g & i)) {
	          if (f | 0) {
	            c[f >> 2] = a | 0;c[f + 4 >> 2] = g & k | b & 0;
	          }o = 0;p = k >>> ((CC(i | 0) | 0) >>> 0);return (A = o, p) | 0;
	        }g = (S(i | 0) | 0) - (S(k | 0) | 0) | 0;if (g >>> 0 <= 30) {
	          b = g + 1 | 0;i = 31 - g | 0;h = b;a = k << i | l >>> (b >>> 0);b = k >>> (b >>> 0);g = 0;i = l << i;break;
	        }if (!f) {
	          o = 0;p = 0;return (A = o, p) | 0;
	        }c[f >> 2] = a | 0;c[f + 4 >> 2] = j | b & 0;o = 0;p = 0;return (A = o, p) | 0;
	      } while (0);if (!h) {
	        k = i;j = 0;i = 0;
	      } else {
	        m = d | 0 | 0;l = n | e & 0;k = xC(m | 0, l | 0, -1, -1) | 0;d = A;j = i;i = 0;do {
	          e = j;j = g >>> 31 | j << 1;g = i | g << 1;e = a << 1 | e >>> 31 | 0;n = a >>> 31 | b << 1 | 0;wC(k | 0, d | 0, e | 0, n | 0) | 0;p = A;o = p >> 31 | ((p | 0) < 0 ? -1 : 0) << 1;i = o & 1;a = wC(e | 0, n | 0, o & m | 0, (((p | 0) < 0 ? -1 : 0) >> 31 | ((p | 0) < 0 ? -1 : 0) << 1) & l | 0) | 0;b = A;h = h - 1 | 0;
	        } while ((h | 0) != 0);k = j;j = 0;
	      }h = 0;if (f | 0) {
	        c[f >> 2] = a;c[f + 4 >> 2] = b;
	      }o = (g | 0) >>> 31 | (k | h) << 1 | (h << 1 | g >>> 31) & 0 | j;p = (g << 1 | 0 >>> 31) & -2 | i;return (A = o, p) | 0;
	    }function EC(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;return DC(a, b, c, d, 0) | 0;
	    }function FC(a) {
	      a = a | 0;var b = 0,
	          d = 0;d = a + 15 & -16 | 0;b = c[i >> 2] | 0;a = b + d | 0;if ((d | 0) > 0 & (a | 0) < (b | 0) | (a | 0) < 0) {
	        Y() | 0;Qa(12);return -1;
	      }c[i >> 2] = a;if ((a | 0) > (X() | 0) ? (W() | 0) == 0 : 0) {
	        c[i >> 2] = b;Qa(12);return -1;
	      }return b | 0;
	    }function GC(b, c, d) {
	      b = b | 0;c = c | 0;d = d | 0;var e = 0;if ((c | 0) < (b | 0) & (b | 0) < (c + d | 0)) {
	        e = b;c = c + d | 0;b = b + d | 0;while ((d | 0) > 0) {
	          b = b - 1 | 0;c = c - 1 | 0;d = d - 1 | 0;a[b >> 0] = a[c >> 0] | 0;
	        }b = e;
	      } else BC(b, c, d) | 0;return b | 0;
	    }function HC(a, b, d, e) {
	      a = a | 0;b = b | 0;d = d | 0;e = e | 0;var f = 0,
	          g = 0;g = l;l = l + 16 | 0;f = g | 0;DC(a, b, d, e, f) | 0;l = g;return (A = c[f + 4 >> 2] | 0, c[f >> 2] | 0) | 0;
	    }function IC(a) {
	      a = a | 0;return (a & 255) << 24 | (a >> 8 & 255) << 16 | (a >> 16 & 255) << 8 | a >>> 24 | 0;
	    }function JC(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;f = f | 0;jb[a & 1](b | 0, c | 0, d | 0, e | 0, f | 0);
	    }function KC(a, b, c) {
	      a = a | 0;b = b | 0;c = T(c);kb[a & 1](b | 0, T(c));
	    }function LC(a, b, c) {
	      a = a | 0;b = b | 0;c = +c;lb[a & 31](b | 0, +c);
	    }function MC(a, b, c, d) {
	      a = a | 0;b = b | 0;c = T(c);d = T(d);return T(mb[a & 0](b | 0, T(c), T(d)));
	    }function NC(a, b) {
	      a = a | 0;b = b | 0;nb[a & 127](b | 0);
	    }function OC(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;ob[a & 31](b | 0, c | 0);
	    }function PC(a, b) {
	      a = a | 0;b = b | 0;return pb[a & 31](b | 0) | 0;
	    }function QC(a, b, c, d, e) {
	      a = a | 0;b = b | 0;c = +c;d = +d;e = e | 0;qb[a & 1](b | 0, +c, +d, e | 0);
	    }function RC(a, b, c, d) {
	      a = a | 0;b = b | 0;c = +c;d = +d;rb[a & 1](b | 0, +c, +d);
	    }function SC(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;return sb[a & 7](b | 0, c | 0, d | 0) | 0;
	    }function TC(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;return +tb[a & 1](b | 0, c | 0, d | 0);
	    }function UC(a, b) {
	      a = a | 0;b = b | 0;return +ub[a & 15](b | 0);
	    }function VC(a, b, c) {
	      a = a | 0;b = b | 0;c = +c;return vb[a & 1](b | 0, +c) | 0;
	    }function WC(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;return wb[a & 15](b | 0, c | 0) | 0;
	    }function XC(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = c | 0;d = +d;e = +e;f = f | 0;xb[a & 1](b | 0, c | 0, +d, +e, f | 0);
	    }function YC(a, b, c, d, e, f, g) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;f = f | 0;g = g | 0;yb[a & 1](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0);
	    }function ZC(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;return +zb[a & 7](b | 0, c | 0);
	    }function _C(a) {
	      a = a | 0;return Ab[a & 7]() | 0;
	    }function $C(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;f = f | 0;return Bb[a & 1](b | 0, c | 0, d | 0, e | 0, f | 0) | 0;
	    }function aD(a, b, c, d, e) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = +e;Cb[a & 1](b | 0, c | 0, d | 0, +e);
	    }function bD(a, b, c, d, e, f, g) {
	      a = a | 0;b = b | 0;c = c | 0;d = T(d);e = e | 0;f = T(f);g = g | 0;Db[a & 1](b | 0, c | 0, T(d), e | 0, T(f), g | 0);
	    }function cD(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;Eb[a & 15](b | 0, c | 0, d | 0);
	    }function dD(a) {
	      a = a | 0;Fb[a & 0]();
	    }function eD(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = +d;Gb[a & 15](b | 0, c | 0, +d);
	    }function fD(a, b, c) {
	      a = a | 0;b = +b;c = +c;return Hb[a & 1](+b, +c) | 0;
	    }function gD(a, b, c, d, e) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;Ib[a & 15](b | 0, c | 0, d | 0, e | 0);
	    }function hD(a, b, c, d, e) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;U(0);
	    }function iD(a, b) {
	      a = a | 0;b = T(b);U(1);
	    }function jD(a, b) {
	      a = a | 0;b = +b;U(2);
	    }function kD(a, b, c) {
	      a = a | 0;b = T(b);c = T(c);U(3);return ib;
	    }function lD(a) {
	      a = a | 0;U(4);
	    }function mD(a, b) {
	      a = a | 0;b = b | 0;U(5);
	    }function nD(a) {
	      a = a | 0;U(6);return 0;
	    }function oD(a, b, c, d) {
	      a = a | 0;b = +b;c = +c;d = d | 0;U(7);
	    }function pD(a, b, c) {
	      a = a | 0;b = +b;c = +c;U(8);
	    }function qD(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;U(9);return 0;
	    }function rD(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;U(10);return 0.0;
	    }function sD(a) {
	      a = a | 0;U(11);return 0.0;
	    }function tD(a, b) {
	      a = a | 0;b = +b;U(12);return 0;
	    }function uD(a, b) {
	      a = a | 0;b = b | 0;U(13);return 0;
	    }function vD(a, b, c, d, e) {
	      a = a | 0;b = b | 0;c = +c;d = +d;e = e | 0;U(14);
	    }function wD(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;f = f | 0;U(15);
	    }function xD(a, b) {
	      a = a | 0;b = b | 0;U(16);return 0.0;
	    }function yD() {
	      U(17);return 0;
	    }function zD(a, b, c, d, e) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;e = e | 0;U(18);return 0;
	    }function AD(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = +d;U(19);
	    }function BD(a, b, c, d, e, f) {
	      a = a | 0;b = b | 0;c = T(c);d = d | 0;e = T(e);f = f | 0;U(20);
	    }function CD(a, b, c) {
	      a = a | 0;b = b | 0;c = c | 0;U(21);
	    }function DD() {
	      U(22);
	    }function ED(a, b, c) {
	      a = a | 0;b = b | 0;c = +c;U(23);
	    }function FD(a, b) {
	      a = +a;b = +b;U(24);return 0;
	    }function GD(a, b, c, d) {
	      a = a | 0;b = b | 0;c = c | 0;d = d | 0;U(25);
	    }
	
	    // EMSCRIPTEN_END_FUNCS
	    var jb = [hD, Uw];var kb = [iD, of];var lb = [jD, Of, Pf, Qf, Rf, Sf, Tf, Uf, Wf, Xf, Zf, _f, $f, ag, bg, cg, dg, eg, fg, jD, jD, jD, jD, jD, jD, jD, jD, jD, jD, jD, jD, jD];var mb = [kD];var nb = [lD, kC, Ki, Li, Mi, rn, sn, tn, Pu, Qu, Ru, Cw, Dw, Ew, DA, EA, FA, Rb, tf, yf, Vf, Yf, hh, ih, ri, Ui, kj, Jj, bk, zk, Wk, nl, Hl, bm, um, Nm, en, Nn, fo, yo, Ro, ip, Bp, Xp, nq, Eq, Zq, lf, Hr, _r, us, Ps, ft, Ct, Ot, Rt, ju, mu, Eu, Uu, Xu, pv, Kv, Vi, $x, Ky, az, sz, Rz, hA, tA, wA, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD, lD];var ob = [mD, zf, Af, Df, Ef, Ff, Gf, Hf, If, Lf, Mf, Nf, wg, zg, Ag, Bg, Cg, Dg, Eg, Jg, Ng, rh, $p, qq, Ts, cy, Sv, xy, mD, mD, mD, mD];var pb = [nD, rB, sf, jg, ng, og, pg, qg, rg, sg, ug, vg, Kg, Lg, jh, ar, jt, sv, hy, jy, nD, nD, nD, nD, nD, nD, nD, nD, nD, nD, nD, nD];var qb = [oD, kh];var rb = [pD, Hu];var sb = [qD, sB, tB, zB, Dk, Rn, Lr, wz];var tb = [rD, ym];var ub = [sD, xg, yg, Fg, lh, mh, nh, oh, ph, qh, sD, sD, sD, sD, sD, sD];var vb = [tD, Kt];var wb = [uD, lC, Mg, xi, Nj, _k, rl, jn, jo, Iq, pf, ez, uD, uD, uD, uD];var xb = [vD, oj];var yb = [wD, Vz];var zb = [xD, Gg, sh, th, uh, Rm, xD, xD];var Ab = [yD, vh, qf, jf, Wt, qu, av, AA];var Bb = [zD, ee];var Cb = [AD, Vo];var Db = [BD, Pg];var Eb = [CD, kg, tg, Hg, Ig, fk, Ll, mp, Fp, nf, vx, Oy, lA, CD, CD, CD];var Fb = [DD];var Gb = [ED, Bf, Cf, Jf, Kf, gg, hg, ig, Co, cs, Ft, ED, ED, ED, ED, ED];var Hb = [FD, Mu];var Ib = [GD, fm, ir, ys, st, au, wu, hv, Pv, oy, LA, GD, GD, GD, GD, GD];return { _llvm_bswap_i32: IC, dynCall_idd: fD, dynCall_i: _C, _i64Subtract: wC, ___udivdi3: EC, dynCall_vif: KC, setThrew: Nb, dynCall_viii: cD, _bitshift64Lshr: AC, _bitshift64Shl: zC, dynCall_vi: NC, dynCall_viiddi: XC, dynCall_diii: TC, dynCall_iii: WC, _memset: yC, _sbrk: FC, _memcpy: BC, __GLOBAL__sub_I_Yoga_cpp: hf, dynCall_vii: OC, ___uremdi3: HC, dynCall_vid: LC, stackAlloc: Jb, _nbind_init: _A, getTempRet0: Pb, dynCall_di: UC, dynCall_iid: VC, setTempRet0: Ob, _i64Add: xC, dynCall_fiff: MC, dynCall_iiii: SC, _emscripten_get_global_libc: qB, dynCall_viid: eD, dynCall_viiid: aD, dynCall_viififi: bD, dynCall_ii: PC, __GLOBAL__sub_I_Binding_cc: Sx, dynCall_viiii: gD, dynCall_iiiiii: $C, stackSave: Kb, dynCall_viiiii: JC, __GLOBAL__sub_I_nbind_cc: wh, dynCall_vidd: RC, _free: pB, runPostSets: vC, dynCall_viiiiii: YC, establishStackSpace: Mb, _memmove: GC, stackRestore: Lb, _malloc: oB, __GLOBAL__sub_I_common_cc: Bv, dynCall_viddi: QC, dynCall_dii: ZC, dynCall_v: dD };
	  }(
	
	  // EMSCRIPTEN_END_ASM
	  Module.asmGlobalArg, Module.asmLibraryArg, buffer);var _llvm_bswap_i32 = Module["_llvm_bswap_i32"] = asm["_llvm_bswap_i32"];var getTempRet0 = Module["getTempRet0"] = asm["getTempRet0"];var ___udivdi3 = Module["___udivdi3"] = asm["___udivdi3"];var setThrew = Module["setThrew"] = asm["setThrew"];var _bitshift64Lshr = Module["_bitshift64Lshr"] = asm["_bitshift64Lshr"];var _bitshift64Shl = Module["_bitshift64Shl"] = asm["_bitshift64Shl"];var _memset = Module["_memset"] = asm["_memset"];var _sbrk = Module["_sbrk"] = asm["_sbrk"];var _memcpy = Module["_memcpy"] = asm["_memcpy"];var stackAlloc = Module["stackAlloc"] = asm["stackAlloc"];var ___uremdi3 = Module["___uremdi3"] = asm["___uremdi3"];var _nbind_init = Module["_nbind_init"] = asm["_nbind_init"];var _i64Subtract = Module["_i64Subtract"] = asm["_i64Subtract"];var setTempRet0 = Module["setTempRet0"] = asm["setTempRet0"];var _i64Add = Module["_i64Add"] = asm["_i64Add"];var _emscripten_get_global_libc = Module["_emscripten_get_global_libc"] = asm["_emscripten_get_global_libc"];var __GLOBAL__sub_I_Yoga_cpp = Module["__GLOBAL__sub_I_Yoga_cpp"] = asm["__GLOBAL__sub_I_Yoga_cpp"];var __GLOBAL__sub_I_Binding_cc = Module["__GLOBAL__sub_I_Binding_cc"] = asm["__GLOBAL__sub_I_Binding_cc"];var stackSave = Module["stackSave"] = asm["stackSave"];var __GLOBAL__sub_I_nbind_cc = Module["__GLOBAL__sub_I_nbind_cc"] = asm["__GLOBAL__sub_I_nbind_cc"];var _free = Module["_free"] = asm["_free"];var runPostSets = Module["runPostSets"] = asm["runPostSets"];var establishStackSpace = Module["establishStackSpace"] = asm["establishStackSpace"];var _memmove = Module["_memmove"] = asm["_memmove"];var stackRestore = Module["stackRestore"] = asm["stackRestore"];var _malloc = Module["_malloc"] = asm["_malloc"];var __GLOBAL__sub_I_common_cc = Module["__GLOBAL__sub_I_common_cc"] = asm["__GLOBAL__sub_I_common_cc"];var dynCall_viiiii = Module["dynCall_viiiii"] = asm["dynCall_viiiii"];var dynCall_vif = Module["dynCall_vif"] = asm["dynCall_vif"];var dynCall_vid = Module["dynCall_vid"] = asm["dynCall_vid"];var dynCall_fiff = Module["dynCall_fiff"] = asm["dynCall_fiff"];var dynCall_vi = Module["dynCall_vi"] = asm["dynCall_vi"];var dynCall_vii = Module["dynCall_vii"] = asm["dynCall_vii"];var dynCall_ii = Module["dynCall_ii"] = asm["dynCall_ii"];var dynCall_viddi = Module["dynCall_viddi"] = asm["dynCall_viddi"];var dynCall_vidd = Module["dynCall_vidd"] = asm["dynCall_vidd"];var dynCall_iiii = Module["dynCall_iiii"] = asm["dynCall_iiii"];var dynCall_diii = Module["dynCall_diii"] = asm["dynCall_diii"];var dynCall_di = Module["dynCall_di"] = asm["dynCall_di"];var dynCall_iid = Module["dynCall_iid"] = asm["dynCall_iid"];var dynCall_iii = Module["dynCall_iii"] = asm["dynCall_iii"];var dynCall_viiddi = Module["dynCall_viiddi"] = asm["dynCall_viiddi"];var dynCall_viiiiii = Module["dynCall_viiiiii"] = asm["dynCall_viiiiii"];var dynCall_dii = Module["dynCall_dii"] = asm["dynCall_dii"];var dynCall_i = Module["dynCall_i"] = asm["dynCall_i"];var dynCall_iiiiii = Module["dynCall_iiiiii"] = asm["dynCall_iiiiii"];var dynCall_viiid = Module["dynCall_viiid"] = asm["dynCall_viiid"];var dynCall_viififi = Module["dynCall_viififi"] = asm["dynCall_viififi"];var dynCall_viii = Module["dynCall_viii"] = asm["dynCall_viii"];var dynCall_v = Module["dynCall_v"] = asm["dynCall_v"];var dynCall_viid = Module["dynCall_viid"] = asm["dynCall_viid"];var dynCall_idd = Module["dynCall_idd"] = asm["dynCall_idd"];var dynCall_viiii = Module["dynCall_viiii"] = asm["dynCall_viiii"];Runtime.stackAlloc = Module["stackAlloc"];Runtime.stackSave = Module["stackSave"];Runtime.stackRestore = Module["stackRestore"];Runtime.establishStackSpace = Module["establishStackSpace"];Runtime.setTempRet0 = Module["setTempRet0"];Runtime.getTempRet0 = Module["getTempRet0"];Module["asm"] = asm;function ExitStatus(status) {
	    this.name = "ExitStatus";this.message = "Program terminated with exit(" + status + ")";this.status = status;
	  }ExitStatus.prototype = new Error();ExitStatus.prototype.constructor = ExitStatus;var initialStackTop;var preloadStartTime = null;var calledMain = false;dependenciesFulfilled = function runCaller() {
	    if (!Module["calledRun"]) run();if (!Module["calledRun"]) dependenciesFulfilled = runCaller;
	  };Module["callMain"] = Module.callMain = function callMain(args) {
	    args = args || [];ensureInitRuntime();var argc = args.length + 1;function pad() {
	      for (var i = 0; i < 4 - 1; i++) {
	        argv.push(0);
	      }
	    }var argv = [allocate(intArrayFromString(Module["thisProgram"]), "i8", ALLOC_NORMAL)];pad();for (var i = 0; i < argc - 1; i = i + 1) {
	      argv.push(allocate(intArrayFromString(args[i]), "i8", ALLOC_NORMAL));pad();
	    }argv.push(0);argv = allocate(argv, "i32", ALLOC_NORMAL);try {
	      var ret = Module["_main"](argc, argv, 0);exit(ret, true);
	    } catch (e) {
	      if (e instanceof ExitStatus) {
	        return;
	      } else if (e == "SimulateInfiniteLoop") {
	        Module["noExitRuntime"] = true;return;
	      } else {
	        var toLog = e;if (e && typeof e === "object" && e.stack) {
	          toLog = [e, e.stack];
	        }Module.printErr("exception thrown: " + toLog);Module["quit"](1, e);
	      }
	    } finally {
	      calledMain = true;
	    }
	  };function run(args) {
	    args = args || Module["arguments"];if (preloadStartTime === null) preloadStartTime = Date.now();if (runDependencies > 0) {
	      return;
	    }preRun();if (runDependencies > 0) return;if (Module["calledRun"]) return;function doRun() {
	      if (Module["calledRun"]) return;Module["calledRun"] = true;if (ABORT) return;ensureInitRuntime();preMain();if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();if (Module["_main"] && shouldRunNow) Module["callMain"](args);postRun();
	    }if (Module["setStatus"]) {
	      Module["setStatus"]("Running...");setTimeout(function () {
	        setTimeout(function () {
	          Module["setStatus"]("");
	        }, 1);doRun();
	      }, 1);
	    } else {
	      doRun();
	    }
	  }Module["run"] = Module.run = run;function exit(status, implicit) {
	    if (implicit && Module["noExitRuntime"]) {
	      return;
	    }if (Module["noExitRuntime"]) {} else {
	      ABORT = true;EXITSTATUS = status;STACKTOP = initialStackTop;exitRuntime();if (Module["onExit"]) Module["onExit"](status);
	    }if (ENVIRONMENT_IS_NODE) {
	      process["exit"](status);
	    }Module["quit"](status, new ExitStatus(status));
	  }Module["exit"] = Module.exit = exit;var abortDecorators = [];function abort(what) {
	    if (Module["onAbort"]) {
	      Module["onAbort"](what);
	    }if (what !== undefined) {
	      Module.print(what);Module.printErr(what);what = JSON.stringify(what);
	    } else {
	      what = "";
	    }ABORT = true;EXITSTATUS = 1;var extra = "\nIf this abort() is unexpected, build with -s ASSERTIONS=1 which can give more information.";var output = "abort(" + what + ") at " + stackTrace() + extra;if (abortDecorators) {
	      abortDecorators.forEach(function (decorator) {
	        output = decorator(output, what);
	      });
	    }throw output;
	  }Module["abort"] = Module.abort = abort;if (Module["preInit"]) {
	    if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];while (Module["preInit"].length > 0) {
	      Module["preInit"].pop()();
	    }
	  }var shouldRunNow = true;if (Module["noInitialRun"]) {
	    shouldRunNow = false;
	  }run();
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84), __webpack_require__(305)(module), __webpack_require__(59).Buffer))

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @format
	 */
	
	var CONSTANTS = {
	  ALIGN_COUNT: 8,
	  ALIGN_AUTO: 0,
	  ALIGN_FLEX_START: 1,
	  ALIGN_CENTER: 2,
	  ALIGN_FLEX_END: 3,
	  ALIGN_STRETCH: 4,
	  ALIGN_BASELINE: 5,
	  ALIGN_SPACE_BETWEEN: 6,
	  ALIGN_SPACE_AROUND: 7,
	
	  DIMENSION_COUNT: 2,
	  DIMENSION_WIDTH: 0,
	  DIMENSION_HEIGHT: 1,
	
	  DIRECTION_COUNT: 3,
	  DIRECTION_INHERIT: 0,
	  DIRECTION_LTR: 1,
	  DIRECTION_RTL: 2,
	
	  DISPLAY_COUNT: 2,
	  DISPLAY_FLEX: 0,
	  DISPLAY_NONE: 1,
	
	  EDGE_COUNT: 9,
	  EDGE_LEFT: 0,
	  EDGE_TOP: 1,
	  EDGE_RIGHT: 2,
	  EDGE_BOTTOM: 3,
	  EDGE_START: 4,
	  EDGE_END: 5,
	  EDGE_HORIZONTAL: 6,
	  EDGE_VERTICAL: 7,
	  EDGE_ALL: 8,
	
	  EXPERIMENTAL_FEATURE_COUNT: 1,
	  EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS: 0,
	
	  FLEX_DIRECTION_COUNT: 4,
	  FLEX_DIRECTION_COLUMN: 0,
	  FLEX_DIRECTION_COLUMN_REVERSE: 1,
	  FLEX_DIRECTION_ROW: 2,
	  FLEX_DIRECTION_ROW_REVERSE: 3,
	
	  JUSTIFY_COUNT: 6,
	  JUSTIFY_FLEX_START: 0,
	  JUSTIFY_CENTER: 1,
	  JUSTIFY_FLEX_END: 2,
	  JUSTIFY_SPACE_BETWEEN: 3,
	  JUSTIFY_SPACE_AROUND: 4,
	  JUSTIFY_SPACE_EVENLY: 5,
	
	  LOG_LEVEL_COUNT: 6,
	  LOG_LEVEL_ERROR: 0,
	  LOG_LEVEL_WARN: 1,
	  LOG_LEVEL_INFO: 2,
	  LOG_LEVEL_DEBUG: 3,
	  LOG_LEVEL_VERBOSE: 4,
	  LOG_LEVEL_FATAL: 5,
	
	  MEASURE_MODE_COUNT: 3,
	  MEASURE_MODE_UNDEFINED: 0,
	  MEASURE_MODE_EXACTLY: 1,
	  MEASURE_MODE_AT_MOST: 2,
	
	  NODE_TYPE_COUNT: 2,
	  NODE_TYPE_DEFAULT: 0,
	  NODE_TYPE_TEXT: 1,
	
	  OVERFLOW_COUNT: 3,
	  OVERFLOW_VISIBLE: 0,
	  OVERFLOW_HIDDEN: 1,
	  OVERFLOW_SCROLL: 2,
	
	  POSITION_TYPE_COUNT: 2,
	  POSITION_TYPE_RELATIVE: 0,
	  POSITION_TYPE_ABSOLUTE: 1,
	
	  PRINT_OPTIONS_COUNT: 3,
	  PRINT_OPTIONS_LAYOUT: 1,
	  PRINT_OPTIONS_STYLE: 2,
	  PRINT_OPTIONS_CHILDREN: 4,
	
	  UNIT_COUNT: 4,
	  UNIT_UNDEFINED: 0,
	  UNIT_POINT: 1,
	  UNIT_PERCENT: 2,
	  UNIT_AUTO: 3,
	
	  WRAP_COUNT: 3,
	  WRAP_NO_WRAP: 0,
	  WRAP_WRAP: 1,
	  WRAP_WRAP_REVERSE: 2
	};
	
	module.exports = CONSTANTS;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @format
	 */
	
	var CONSTANTS = __webpack_require__(308);
	
	var Layout = function () {
	  function Layout(left, right, top, bottom, width, height) {
	    _classCallCheck(this, Layout);
	
	    this.left = left;
	    this.right = right;
	    this.top = top;
	    this.bottom = bottom;
	    this.width = width;
	    this.height = height;
	  }
	
	  _createClass(Layout, [{
	    key: 'fromJS',
	    value: function fromJS(expose) {
	      expose(this.left, this.right, this.top, this.bottom, this.width, this.height);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<Layout#' + this.left + ':' + this.right + ';' + this.top + ':' + this.bottom + ';' + this.width + ':' + this.height + '>';
	    }
	  }]);
	
	  return Layout;
	}();
	
	var Size = function () {
	  _createClass(Size, null, [{
	    key: 'fromJS',
	    value: function fromJS(_ref) {
	      var width = _ref.width,
	          height = _ref.height;
	
	      return new Size(width, height);
	    }
	  }]);
	
	  function Size(width, height) {
	    _classCallCheck(this, Size);
	
	    this.width = width;
	    this.height = height;
	  }
	
	  _createClass(Size, [{
	    key: 'fromJS',
	    value: function fromJS(expose) {
	      expose(this.width, this.height);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<Size#' + this.width + 'x' + this.height + '>';
	    }
	  }]);
	
	  return Size;
	}();
	
	var Value = function () {
	  function Value(unit, value) {
	    _classCallCheck(this, Value);
	
	    this.unit = unit;
	    this.value = value;
	  }
	
	  _createClass(Value, [{
	    key: 'fromJS',
	    value: function fromJS(expose) {
	      expose(this.unit, this.value);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      switch (this.unit) {
	        case CONSTANTS.UNIT_POINT:
	          return String(this.value);
	        case CONSTANTS.UNIT_PERCENT:
	          return this.value + '%';
	        case CONSTANTS.UNIT_AUTO:
	          return 'auto';
	        default:
	          {
	            return this.value + '?';
	          }
	      }
	    }
	  }, {
	    key: 'valueOf',
	    value: function valueOf() {
	      return this.value;
	    }
	  }]);
	
	  return Value;
	}();
	
	module.exports = function (bind, lib) {
	  function patch(prototype, name, fn) {
	    var original = prototype[name];
	
	    prototype[name] = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return fn.call.apply(fn, [this, original].concat(args));
	    };
	  }
	
	  var _arr = ['setPosition', 'setMargin', 'setFlexBasis', 'setWidth', 'setHeight', 'setMinWidth', 'setMinHeight', 'setMaxWidth', 'setMaxHeight', 'setPadding'];
	
	  var _loop = function _loop() {
	    var _methods;
	
	    var fnName = _arr[_i];
	    var methods = (_methods = {}, _defineProperty(_methods, CONSTANTS.UNIT_POINT, lib.Node.prototype[fnName]), _defineProperty(_methods, CONSTANTS.UNIT_PERCENT, lib.Node.prototype[fnName + 'Percent']), _defineProperty(_methods, CONSTANTS.UNIT_AUTO, lib.Node.prototype[fnName + 'Auto']), _methods);
	
	    patch(lib.Node.prototype, fnName, function (original) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      // We patch all these functions to add support for the following calls:
	      // .setWidth(100) / .setWidth("100%") / .setWidth(.getWidth()) / .setWidth("auto")
	
	      var value = args.pop();
	      var unit = void 0,
	          asNumber = void 0;
	
	      if (value === 'auto') {
	        unit = CONSTANTS.UNIT_AUTO;
	        asNumber = undefined;
	      } else if (value instanceof Value) {
	        unit = value.unit;
	        asNumber = value.valueOf();
	      } else {
	        unit = typeof value === 'string' && value.endsWith('%') ? CONSTANTS.UNIT_PERCENT : CONSTANTS.UNIT_POINT;
	        asNumber = parseFloat(value);
	        if (!Number.isNaN(value) && Number.isNaN(asNumber)) {
	          throw new Error('Invalid value ' + value + ' for ' + fnName);
	        }
	      }
	
	      if (!methods[unit]) throw new Error('Failed to execute "' + fnName + '": Unsupported unit \'' + value + '\'');
	
	      if (asNumber !== undefined) {
	        var _methods$unit;
	
	        return (_methods$unit = methods[unit]).call.apply(_methods$unit, [this].concat(args, [asNumber]));
	      } else {
	        var _methods$unit2;
	
	        return (_methods$unit2 = methods[unit]).call.apply(_methods$unit2, [this].concat(args));
	      }
	    });
	  };
	
	  for (var _i = 0; _i < _arr.length; _i++) {
	    _loop();
	  }
	
	  patch(lib.Config.prototype, 'free', function () {
	    // Since we handle the memory allocation ourselves (via lib.Config.create),
	    // we also need to handle the deallocation
	    lib.Config.destroy(this);
	  });
	
	  patch(lib.Node, 'create', function (_, config) {
	    // We decide the constructor we want to call depending on the parameters
	    return config ? lib.Node.createWithConfig(config) : lib.Node.createDefault();
	  });
	
	  patch(lib.Node.prototype, 'free', function () {
	    // Since we handle the memory allocation ourselves (via lib.Node.create),
	    // we also need to handle the deallocation
	    lib.Node.destroy(this);
	  });
	
	  patch(lib.Node.prototype, 'freeRecursive', function () {
	    for (var t = 0, T = this.getChildCount(); t < T; ++t) {
	      this.getChild(0).freeRecursive();
	    }
	    this.free();
	  });
	
	  patch(lib.Node.prototype, 'setMeasureFunc', function (original, measureFunc) {
	    // This patch is just a convenience patch, since it helps write more
	    // idiomatic source code (such as .setMeasureFunc(null))
	    // We also automatically convert the return value of the measureFunc
	    // to a Size object, so that we can return anything that has .width and
	    // .height properties
	    if (measureFunc) {
	      return original.call(this, function () {
	        return Size.fromJS(measureFunc.apply(undefined, arguments));
	      });
	    } else {
	      return this.unsetMeasureFunc();
	    }
	  });
	
	  patch(lib.Node.prototype, 'calculateLayout', function (original) {
	    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
	    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NaN;
	    var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : CONSTANTS.DIRECTION_LTR;
	
	    // Just a small patch to add support for the function default parameters
	    return original.call(this, width, height, direction);
	  });
	
	  return _extends({
	    Config: lib.Config,
	    Node: lib.Node,
	    Layout: bind('Layout', Layout),
	    Size: bind('Size', Size),
	    Value: bind('Value', Value),
	    getInstanceCount: function getInstanceCount() {
	      return lib.getInstanceCount.apply(lib, arguments);
	    }
	  }, CONSTANTS);
	};

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, module) {(function (w) {
	  "use strict";
	
	  function findBest(atobNative) {
	    // normal window
	    if ('function' === typeof atobNative) { return atobNative; }
	
	
	    // browserify (web worker)
	    if ('function' === typeof Buffer) {
	      return function atobBrowserify(a) {
	        //!! Deliberately using an API that's deprecated in node.js because
	        //!! this file is for browsers and we expect them to cope with it.
	        //!! Discussion: github.com/node-browser-compat/atob/pull/9
	        return new Buffer(a, 'base64').toString('binary');
	      };
	    }
	
	    // ios web worker with base64js
	    if ('object' === typeof w.base64js) {
	      // bufferToBinaryString
	      // https://git.coolaj86.com/coolaj86/unibabel.js/blob/master/index.js#L50
	      return function atobWebWorker_iOS(a) {
	        var buf = w.base64js.b64ToByteArray(a);
	        return Array.prototype.map.call(buf, function (ch) {
	          return String.fromCharCode(ch);
	        }).join('');
	      };
	    }
	
			return function () {
				// ios web worker without base64js
				throw new Error("You're probably in an old browser or an iOS webworker." +
					" It might help to include beatgammit's base64-js.");
	    };
	  }
	
	  var atobBest = findBest(w.atob);
	  w.atob = atobBest;
	
	  if ((typeof module === 'object') && module && module.exports) {
	    module.exports = atobBest;
	  }
	}(window));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59).Buffer, __webpack_require__(305)(module)))

/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(9);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _EditValue = __webpack_require__(100);
	
	var _EditValue2 = _interopRequireDefault(_EditValue);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var TAG_PATTERN = /<controls prop="([A-Za-z]+)"><\/controls>/gi;
	
	var DocsSidebar = function (_Component) {
	  _inherits(DocsSidebar, _Component);
	
	  function DocsSidebar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DocsSidebar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderControls = function (props) {
	      var match = void 0;
	
	      var _loop = function _loop() {
	        var prop = match[1];
	        var element = window.document.querySelector('controls[prop="' + match[1] + '"]');
	
	        if (element) {
	          if (element.childNodes.length !== 0) {
	            console.warn('The element <controls type="' + prop + '"> is not empty. It\'s content will be replaced by the react-component mounted in this element.');
	          }
	          _reactDom2.default.render(_react2.default.createElement(_EditValue2.default, {
	            property: prop,
	            value: props.layout[prop],
	            onChange: function onChange(property, value) {
	              if (window.ga) {
	                window.ga('send', {
	                  hitType: 'event',
	                  eventCategory: 'DocsSidebar',
	                  eventAction: 'valueChanged',
	                  eventLabel: prop
	                });
	              }
	              props.onChange(property, value);
	            }
	          }), element);
	        }
	      };
	
	      while (match = TAG_PATTERN.exec(props.markdown)) {
	        _loop();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DocsSidebar.prototype.componentDidMount = function componentDidMount() {
	    this.renderControls(this.props);
	  };
	
	  DocsSidebar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.renderControls(nextProps);
	  };
	
	  DocsSidebar.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocsSidebar' },
	      _react2.default.createElement('div', {
	        className: 'markdown',
	        dangerouslySetInnerHTML: { __html: this.props.markdown }
	      }),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/docs', className: 'overview' },
	        'BACK TO OVERVIEW'
	      )
	    );
	  };
	
	  return DocsSidebar;
	}(_react.Component);
	
	exports.default = DocsSidebar;
	module.exports = exports['default'];

/***/ }),
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(151);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _src = __webpack_require__(164);
	
	var _src2 = _interopRequireDefault(_src);
	
	var _DocsSidebar = __webpack_require__(422);
	
	var _DocsSidebar2 = _interopRequireDefault(_DocsSidebar);
	
	var _EditValue = __webpack_require__(100);
	
	var _EditValue2 = _interopRequireDefault(_EditValue);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(350);
	
	var _atob = __webpack_require__(415);
	
	var _atob2 = _interopRequireDefault(_atob);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) Meta Platforms, Inc. and affiliates.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var REGEX = /<controls prop="([A-Za-z]+)"\s?\/>/gi;
	
	var withPlayground = function (_Component) {
	  _inherits(withPlayground, _Component);
	
	  function withPlayground() {
	    _classCallCheck(this, withPlayground);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  withPlayground.prototype.render = function render() {
	    var _this2 = this;
	
	    var layoutDefinition = void 0;
	    if (this.props.pathContext.frontmatter.initialPlayground) {
	      layoutDefinition = JSON.parse((0, _atob2.default)(this.props.pathContext.frontmatter.initialPlayground));
	    }
	    return _react2.default.createElement(
	      _Page2.default,
	      {
	        className: 'doc-block playground',
	        title: this.props.pathContext.frontmatter.title },
	      _react2.default.createElement(_src2.default, {
	        layoutDefinition: layoutDefinition,
	        selectedNodePath: [],
	        showGuides: false,
	        renderSidebar: function renderSidebar(layout, onChange) {
	          return _react2.default.createElement(_DocsSidebar2.default, {
	            layout: layout,
	            onChange: onChange,
	            markdown: _this2.props.pathContext.html
	          });
	        }
	      })
	    );
	  };
	
	  return withPlayground;
	}(_react.Component);
	
	exports.default = withPlayground;
	module.exports = exports['default'];

/***/ }),
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
]);


// WEBPACK FOOTER //
// component---src-templates-with-playground-js-d7edf521ccc2c7915705.js